"use strict";

/**
 * First file loaded of the application.
 */
(function (angular) {
  'use strict';
  /**
   * @ngdoc module
   * @name app
   * @type {angular.Module}
   * @description Main module
   */

  var app = angular.module('app', ['ngMessages', 'ngResource', 'ngSanitize', 'ngAnimate', 'ngCookies', 'angular-jwt', 'ngStorage', 'cgBusy', 'ngLodash', 'ui.bootstrap', 'ui.router', 'ui.mask', 'ui.validate', 'pascalprecht.translate', 'smart-table', 'ncy-angular-breadcrumb', 'validation.match', 'angularMoment', 'mwl.confirm', 'ngFileUpload', 'ngImgCrop', 'dcbImgFallback', 'angularPromiseButtons', '720kb.datepicker', 'angularRipple', 'ngFileSaver', 'datetime', 'ngCsv', 'orbaAuth', 'orbaUtils', 'ngOrbaCsvImport', 'ngOrbaXmlImport', 'app.config']);
})(angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgPagination
   * @description
   * Component for display pagination controls.
   */

  module.component('sgPagination', {
    templateUrl: 'app/global/components/pagination/sgPagination.html',
    controller: sgPagination,
    controllerAs: 'vm',
    bindings: {
      paginator: '='
    }
  });
  /*@ngInject*/

  function sgPagination() {
    var vm = this;
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgNameEditor
   * @description
   * Component to edit the name of a model resource object.
   */

  sgNameEditor.$inject = ["$scope"];
  module.component('sgNameEditor', {
    templateUrl: 'app/global/components/editor/sgNameEditor.html',
    controller: sgNameEditor,
    controllerAs: 'vm',
    bindings: {
      /**
       * Resource model.
       * @type $resource
       */
      model: '<',

      /**
       * When the user request update the name of the model.
       */
      onRequestChange: '&',

      /**
       * Label of the field.
       * @type string
       */
      label: '@',

      /**
       * Placeholder of the input field.
       * @type string
       */
      placeholder: '@'
    }
  });
  /*@ngInject*/

  function sgNameEditor($scope) {
    var vm = this;

    vm.$onInit = function () {
      vm.label = angular.isUndefined(vm.label) ? 'Name' : vm.label;
      vm.placeholder = angular.isUndefined(vm.placeholder) ? 'Name' : vm.placeholder;
      /*
       * Sets the name of the model in the input box.
       * Also, if the name of the model changes and the name in the input wasn't changed, update it
       * accordingly.
       */

      if (!angular.isObject(vm.model)) {
        throw 'A model object was expected';
      }

      vm.newName = angular.isString(vm.model.name) ? vm.model.name : vm.model.name = '';
      $scope.$watch('vm.model.name', function (newName, oldName) {
        if (vm.newName === oldName) {
          vm.newName = newName;
        }
      });
    };
    /**
     * @ngdoc method
     * @name isSaveAllowed
     * @description Allows to know if there any change available pending to apply to the real model.
     * @returns {boolean}
     */


    vm.isSaveAllowed = function () {
      return vm.isEditable() && vm.newName !== vm.model.name && angular.isString(vm.newName) && vm.newName.length > 0;
    };
    /**
     * @ngdoc method
     * @name isEditable
     * @description Check if the name of the current model is editable.
     * @returns {boolean} This method also returns FALSE if the model is not defined
     */


    vm.isEditable = function () {
      return angular.isObject(vm.model);
    };
    /**
     * @ngdoc method
     * @name save
     * @description
     * Execute the external "onRequestChange" function.
     */


    vm.save = function () {
      if (vm.isSaveAllowed()) {
        //Informing the parent scope that the user want to change the model's name
        vm.onRequestChange({
          name: vm.newName
        });
      }
    };
  }
})(angular.module('app'));
"use strict";

/**
 * @ngdoc object
 * @module orbaUtils
 * @overview
 * Module with utils services.
 *
 * @author  daniel.zegarra@orba.co
 */
(function (angular) {
  'use strict'; //Registering the module

  angular.module('orbaUtils', ['duScroll']);
})(angular);
"use strict";

(function (module) {
  /**
   * @ngdoc service
   * @name orbaUtils.jsUtils
   * @description
   * Service with useful and common methods for js.
   * @author daniel.zegarra@orba.co
   */

  /*@ngInject*/
  module.factory('jsUtils', ["lodash", function (lodash) {
    /**
     * Return the boolean value of the value given.
     * Parameters recognized as TRUE are: "true", "1" and, of course TRUE. The rest will be considered as FALSE.
     * @param {*} val
     * @return {Boolean}
     */
    var getBoolValue = function getBoolValue(val) {
      return ['true', '1', 1, true].indexOf(val) !== -1;
    };
    /**
     * Creates a light copy of the object given. All the functions and object properties are strip.
     * NOTE: This functions returns a new object. Doesn't change in any way the object given.
     * @param {object} obj Object to copy
     * @return {Object} Light version of the object given
     */


    var getLightObject = function getLightObject(obj) {
      return lodash.omitBy(obj, function (val) {
        return angular.isFunction(val) || angular.isObject(val);
      });
    };

    return {
      getBoolValue: getBoolValue,
      getLightObject: getLightObject
    };
  }]);
})(angular.module('orbaUtils'));
"use strict";

(function (module) {
  /**
   * @ngdoc service
   * @name orbaUtils.domUtils
   * @description
   * Service with useful methods to work with the DOM.
   * @author daniel.zegarra@orba.co
   */

  /*@ngInject*/
  module.factory('domUtils', ["$window", "$document", function ($window, $document) {
    'use strict';
    /**
     * Execute getBoundingClientRect() over the first element passed and returns the result.
     * @param {Element[]} itemEl
     * @return {ClientRect}
     */

    var getCmpDomProperties = function getCmpDomProperties(itemEl) {
      return itemEl[0].getBoundingClientRect();
    };
    /**
     * Check if the element given is complete visible in the screen.
     * @param {Element[]} itemEl
     * @param {number} [offset=0]
     * @return {boolean}
     */


    var itemIsVisible = function itemIsVisible(itemEl, offset) {
      var item = getCmpDomProperties(itemEl);
      offset = isFinite(offset) ? offset : 0;
      return item.top > 0 && item.bottom + offset < $window.innerHeight;
    };
    /**
     * Scroll vertically the content to completely show the element given.
     * @param {Element[]} itemEl
     * @param {number} [offset=0]
     * @param {number} [duration=500]
     */


    var scrollToItem = function scrollToItem(itemEl, offset, duration) {
      offset = isFinite(offset) ? offset : 0;
      duration = isFinite(duration) ? duration : 500;
      var itemProps = getCmpDomProperties(itemEl);
      /**
       * Position (in px) of the item row in reference to the document
       * @type {number}
       */

      var yItemPos = $window.pageYOffset + itemProps.top - $window.innerHeight;
      $document.scrollTopAnimated(yItemPos + itemProps.height + offset, duration);
    };
    /**
     * Scroll the page to the bottom.
     * @param {number} duration
     */


    var scrollToBottom = function scrollToBottom(duration) {
      var doc_h = $document.height();
      var screen_h = $window.innerHeight;
      duration = isFinite(duration) ? duration : 500;

      if (doc_h > screen_h) {
        $document.scrollTopAnimated(doc_h - screen_h, duration);
      }
    };

    return {
      getCmpDomProperties: getCmpDomProperties,
      itemIsVisible: itemIsVisible,
      scrollToItem: scrollToItem,
      scrollToBottom: scrollToBottom
    };
  }]);
})(angular.module('orbaUtils'));
"use strict";

/**
 * @ngdoc object
 * @name sgCurrentPath
 * @module app
 * @description
 * This little factory allows us to save the current path (relative url path) to be restored later.
 *
 * @author  daniel.zegarra@orba.co
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('orbaCurrentPath', ["$state", function ($state) {
    var savedState;

    var clearSaved = function clearSaved() {
      savedState = null;
    };

    var save = function save(toState, toParams) {
      savedState = {
        state: toState,
        params: toParams
      };
    };
    /**
     * Restore the previous saved path it there is one
     * @returns {string}
     */


    var restore = function restore() {
      if (savedState !== null) {
        $state.go(savedState.state, savedState.params);
      }

      clearSaved();
    };

    clearSaved();
    return {
      save: save,
      restore: restore
    };
  }]);
})(angular.module('orbaUtils'));
"use strict";

(function (module) {
  /**
   * @ngdoc service
   * @name orbaUtils.collectionUtils
   * @description
   * Service with useful method to wotk with collections of objects.
   * @author daniel.zegarra@orba.co
   */

  /*@ngInject*/
  module.factory('collectionUtils', ["lodash", function (lodash) {
    /**
     * @description
     * Synchronize the properties of two arrays of objects without create a new array.
     *
     * In angular the arrays and object are linked by reference. Any update of objects or arrays
     *
     * @ngdoc method
     * @name orbaUtils.collectionUtils:updateCollection
     * @methodOf orbaUtils.collectionUtils
     * @param {object[]} src Source array
     * @param {object[]} dest Destination array
     * @param {string} id Name of the id key of each object
     * @param {boolean} [soft=false] Update only the properties of src found in dest and don't remove the not found properties of src
     */
    var updateCollection = function updateCollection(src, dest, id, soft) {
      var strip = function strip(item) {
        var pk = {};
        pk[id] = item[id];
        return pk;
      }; //First: Loop the source and update the items found in the destination


      angular.forEach(src, function (srcItem) {
        var destItem = lodash.find(dest, strip(srcItem));
        if (destItem) updateObject(srcItem, destItem, soft);
      }); //Second: Add the items in the source not found in the destination

      angular.forEach(src, function (srcItem) {
        if (!lodash.find(dest, strip(srcItem))) {
          dest.push(srcItem);
        }
      }); //Third: Remove the items of the destination not found in the source

      lodash.remove(dest, function (destItem) {
        return !lodash.find(src, strip(destItem));
      });
    };
    /**
     * @description Update an object
     * @ngdoc method
     * @name orbaUtils.collectionUtils:updateObject
     * @methodOf orbaUtils.collectionUtils
     * @param {*} src
     * @param {*} dest
     * @param {boolean} [soft=false] Update only the properties of src found in dest and don't remove the not found properties of src
     * @returns {*}
     */


    var updateObject = function updateObject(src, dest, soft) {
      return soft === true ? angular.merge(dest, src) : angular.copy(src, dest);
    };

    return {
      updateCollection: updateCollection,
      updateObject: updateObject
    };
  }]);
})(angular.module('orbaUtils'));
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc service
   * @name settlementsResource
   * @description
   * This service use the backend API to manage settlements.
   *
   * It use response transformations to rectify the data returned by the server.
   * Check the {@link https://docs.angularjs.org/api/ngResource/service/$resource $resource docs} for
   * more information.
   */

  settlementsResource.$inject = ["$resource", "$http", "$q", "moment", "settleConfig", "resourceQueryPaginator", "$rootScope", "$httpParamSerializer"];
  module.factory('settlementsResource', settlementsResource);
  /*@ngInject*/

  function settlementsResource($resource, $http, $q, moment, settleConfig, resourceQueryPaginator, $rootScope, $httpParamSerializer) {
    var resource,
        paginator = resourceQueryPaginator();
    /**
     * Stacks of transform functions to parse the server responses.
     *
     * @see https://docs.angularjs.org/api/ng/service/$http#default-transformations
     * @type {{forMulti: function[], forSingle: function[]}}
     */

    var transformStack = {
      forMulti: $http.defaults.transformResponse.concat(transformMulti),
      forSingle: $http.defaults.transformResponse.concat(transformSingle)
    };
    /**
     * Returns an object with the type properties of the model corrected.
     * @param {object} srcItem
     * @returns {object} Returns an object with the properties types corrected
     */

    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.amount = parseFloat(item.amount);
      item.amount_settle = parseFloat(item.amount_settle);
      item.attachment_date = item.attachment_date === null ? '' : moment(item.attachment_date).toDate();
      item.due_date = moment(item.due_date).toDate();
      return item;
    };
    /**
     * Transform the response of a single element.
     * @param {object} data
     * @returns {object}
     */


    function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.settlement_items || data) : data;
    }
    /**
     * Transform the response of a array of several elements.
     * @param {object} data
     * @returns {object}
     */


    function transformMulti(data) {
      $rootScope.settleData = data.settlement_data;
      return angular.isObject(data) ? (data.settlement_items || data).map(transformItem) : data;
    }
    /**
     * Resource for settlement management.
     * Note: This instance will be returned by this service.
     */


    resource = $resource(settleConfig.restful.settlements, {}, {
      //List of invoices
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo(transformStack.forMulti)
      }
    });

    resource.prototype.getCSV = function (filters) {
      var url = settleConfig.restful.csv;

      if (filters) {
        url += '?' + $httpParamSerializer(filters);
      }

      return $http.get(url, {
        responseType: 'blob'
      }).then(function (response) {
        return response.data;
      }, function (response) {
        return $q.reject(response.statusText);
      });
    }; //Applying the pagination support to the "query" method


    paginator.applyToResource(resource, 'query');
    return resource;
  }
})(angular.module('app'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgSettleListHeader
   * @module app
   * @description
   * Header with account information for the settlements section.
   */

  sgSettleListHeader.$inject = ["orbaSession", "blocksResource"];
  module.component('sgSettleListHeader', {
    templateUrl: 'app/settlements/components/sgSettleListHeader.html',
    controller: sgSettleListHeader,
    controllerAs: 'vm'
  });
  /*@ngInject*/

  function sgSettleListHeader(orbaSession, blocksResource) {
    var vm = this;
    vm.info = orbaSession.info;
    vm.conatctInfo = blocksResource.query({
      id: 'settlement_info'
    });
  }
})(angular.module('app'));
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc controller
   * @name sgSettleListFilters
   * @description
   * Input filters for settlements list.
   */

  sgSettleListFilters.$inject = ["$scope", "lodash"];
  module.component('sgSettleListFilters', {
    templateUrl: 'app/settlements/components/sgSettleListFilters.html',
    controller: sgSettleListFilters,
    controllerAs: 'vm',
    bindings: {
      originalFilters: '=filters'
    }
  });
  /*@ngInject*/

  function sgSettleListFilters($scope, lodash) {
    var vm = this;

    vm.$onInit = function () {
      vm.filters = {}; //If the real filters change, update the working filters

      $scope.$watch('vm.originalFilters', function (originalFilters) {
        vm.filters = angular.copy(originalFilters || {});
      });
    };
    /**
     * Apply the changes on the inputs over the real filters.
     */


    vm.applyChanges = function () {
      vm.originalFilters = getFilters();
    };
    /**
     * Checks if are pending changes in the filters to apply.
     * @returns {boolean}
     */


    vm.pendingChanges = function () {
      return !angular.equals(getFilters(), vm.originalFilters || {});
    };
    /**
     * Clear all the active filters.
     */


    vm.clearFilters = function () {
      vm.originalFilters = {};
    };
    /**
     * Check if there any filter currently active.
     * @return {boolean}
     */


    vm.filtersAreClear = function () {
      return angular.equals(getFilters() || {}, {});
    };
    /**
     * Return the filters.
     * @return {Object}
     */


    function getFilters() {
      return lodash.pickBy(vm.filters, function (value) {
        return angular.isString(value) ? !!value : true;
      });
    }
  }
})(angular.module('app'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgSettleList
   * @module app
   * @description
   * Show a list of settlements with a button to download the results as CSV.
   */

  sgSettleList.$inject = ["$scope", "$translate", "paginationManager", "settlementsResource", "settleConfig", "dateFilter", "$rootScope", "FileSaver"];
  module.component('sgSettleList', {
    templateUrl: 'app/settlements/components/sgSettleList.html',
    controllerAs: 'vm',
    controller: sgSettleList,
    bindings: {
      filters: '<?'
    }
  });
  /*@ngInject*/

  function sgSettleList($scope, $translate, paginationManager, settlementsResource, settleConfig, dateFilter, $rootScope, FileSaver) {
    var vm = this;
    /**
     * Get CSV file with data from api. Include user filters in request query.
     */

    vm.getCSV = function () {
      return settlementsResource.prototype.getCSV($scope.paginator.filters).then(function (blobData) {
        FileSaver.saveAs(blobData, $translate.instant('SETTLE.TITLE') + '.csv');
      });
    };

    vm.$onInit = function () {
      vm.errorMsg = ''; //Obtaining the list of payments

      $scope.limitValues = [5, 10, 15, 20, 50, 100, 200];
      $scope.paginator = paginationManager($scope, 'settlement_items', settlementsResource.query, clearErrorMsg, showErrorMsg);
      $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : settleConfig.list.pageSize;
      $scope.paginator.page = 1; //Maintaining the filters in sync

      $scope.$watchCollection('vm.filters', function (filters) {
        $scope.paginator.filters = filters;
      });
    };
    /**
     * Clear the error message.
     */


    function clearErrorMsg() {
      vm.errorMsg = '';
    }
    /**
     * Show an error.
     * @param {string} [err='GLOBAL.LIST_NOT_AVAILABLE']
     */


    function showErrorMsg(err) {
      vm.errorMsg = err || 'GLOBAL.LIST_NOT_AVAILABLE';
    }
  }
})(angular.module('app'));
"use strict";

/**
 * @ngdoc object
 * @module orbaAuth
 * @requires angular-jwt
 * @overview
 * Module to manage the authentication process.
 *
 * @author  daniel.zegarra@orba.co
 */
(function (angular) {
  'use strict'; //Registering the module

  angular.module('orbaAuth', ['ui.router', 'angular-jwt', 'ngStorage', 'orbaUtils']);
})(angular);
"use strict";

/**
 * @ngdoc serviceProvider
 * @name orbaSessionKeeper
 * @module orbaAuth
 * @requires ngStorage
 * @description
 * This service allow to save the session information in a temporal or permanent way in the browser
 * and in this way, continue working even if the user close the application.
 *
 * Note: If the "token" argument is found in the URL this service wont try to recovery the saved session from
 * browser storage.
 *
 * This service works listening the "onLogin" and "onLogout" events dispatched in {@link $rootScope} by
 * {@link orbaSession}.
 *
 * Configurable options in {@link orbaSessionKeeper orbaSessionKeeperProvider}:
 *  - {@link enable}
 *  - {@link useLocalStorage}
 *
 *  Events dispatched in {@link $rootScope}:
 *   - onSessionSave
 *   - onSessionClear
 *
 * @author  daniel.zegarra@orba.co
 */
(function (module) {
  'use strict';

  module.provider('orbaSessionKeeper', function orbaSessionKeeperProvider() {
    /**
     * Status of the keeper.
     * @type {boolean}
     */
    var enabled = false;
    /**
     * This variable decide if the keeper will user session or local storage.
     * @type {boolean}
     */

    var localStorage = false;
    /**
     * Enable or disable this feature.
     * @param {boolean} val
     */

    this.enable = function (val) {
      enabled = val;
    };
    /**
     * Decide if allow the session be remembered even if the browser is close.
     * @param {boolean} enable
     */


    this.useLocalStorage = function (enable) {
      localStorage = enable;
    };
    /**
     * This function returns the real thing.
     * @constructor
     * @param $sessionStorage
     * @param $localStorage
     * @param $rootScope
     * @param orbaSession
     * @returns {{enable: enable}}
     */

    /*@ngInject*/


    this.$get = ["$sessionStorage", "$localStorage", "$rootScope", "orbaSession", "$timeout", function orbaSessionKeeper($sessionStorage, $localStorage, $rootScope, orbaSession, $timeout) {
      var sessionListeners = {};
      /**
       * Enable or disable this feature at runtime.
       * @param {boolean} val
       */

      var enable = function enable() {
        if (!enabled) {
          enabled = true;
          installListeners(); //Save current session

          save();
        }
      };
      /**
       * Disable the session store.
       * @param {boolean} [clearData=true] Clear the current data stored
       */


      var disable = function disable(clearData) {
        if (enabled) {
          sessionListeners.login();
          sessionListeners.logout();

          if (clearData !== false) {
            clear();
          }

          enabled = false;
        }
      };
      /**
       * Return the instance of type of storage configured to use.
       * @returns {$sessionStorage|$localStorage}
       */


      var getStorage = function getStorage() {
        return localStorage ? $localStorage : $sessionStorage;
      };
      /**
       * Store the information of the current session.
       */


      var save = function save() {
        var token = orbaSession.getToken(),
            data = orbaSession.getTokenPayload(),
            storage = getStorage();
        storage.token = token;
        storage.data = data;
        $timeout(function () {
          $rootScope.$emit('onSessionSave', token);
        });
        return token;
      };
      /**
       * Read and returns the session information save in storage.
       * @returns {{token:string, data:*}}
       */


      var read = function read() {
        return getStorage().$default({
          token: '',
          data: {}
        });
      };
      /**
       * Delete the session information from the storage.
       *
       * @param {boolean} [noFireEvent=FALSE]
       */


      var clear = function clear(noFireEvent) {
        getStorage().$reset({
          token: '',
          data: {}
        });
        if (!noFireEvent) $rootScope.$emit('onSessionClear');
      };
      /**
       * Install the listeners of the session events.
       */


      var installListeners = function installListeners() {
        sessionListeners.login = $rootScope.$on('onLogin', function () {
          save();
        });
        sessionListeners.logout = $rootScope.$on('onLogout', function () {
          clear();
        });
      };
      /**
       * Read and return the session data stored.
       * The session is storage is only recovered if there is no a currently session active.
       * @return {object}
       */


      var restore = function restore() {
        var session = read();

        if (session.token && !orbaSession.isLoggedIn()) {
          orbaSession.install(session.token, session.data);
        }
      };

      if (enabled) {
        installListeners();
      }

      return {
        enable: enable,
        disable: disable,
        restore: restore
      };
    }];
    this.$get.$inject = ["$sessionStorage", "$localStorage", "$rootScope", "orbaSession", "$timeout"];
  });
})(angular.module('orbaAuth'));
"use strict";

/**
 * @ngdoc serviceProvider
 * @name orbaSession
 * @module orbaAuth
 * @description
 * Encapsulate the logic to authenticate the user against the server and retrieve a temporal token for future requests.
 * In a few words, allows you to login to the server.
 *
 * This service use one authentication plugin which is who really talk with the server. By default the plugin
 * {@link authJwtPlugin} is used but this can be changes calling the {@link #setAuthPlugin} function during the
 * configuration phase.
 *
 * Configurable options in {@link orbaSessionKeeper orbaSessionKeeperProvider}:
 *  - {@link #setAuthPlugin} "authJwtPlugin" by default
 *  - {@link #setAuthHost} If its not defined, use the same host this app is located
 *  - {@link #requireTokenExpiration} Disable by default
 *
 * Events:
 *  - onLogin({raw:string, payload:object})
 *
 * @author  daniel.zegarra@orba.co
 */
(function (module, angular) {
  'use strict';
  /**
   * Service to manage the session and authentication process.
   */

  module.provider('orbaSession', function orbaSessionProvider() {
    /**
     * URL of the auth server
     * @type {string}
     */
    var hostUrl = '';
    /**
     * ID of the client.
     * @type {string}
     */

    var clientId = '';
    var timestamp;
    /**
     * Name of the plugin for authentications.
     * @type {string}
     */

    var plugin = 'authJwtPlugin';
    /**
     * Close the session immediately if the client is unable to obtain the basic information of the user after
     * obtain a valid token.
     * @type {boolean}
     */

    var logoutIfUserHasNoInfo = true;
    /**
     * Request for the user information just after a valid session token is installed.
     * @type {boolean}
     */

    var obtainUserInfoAfterLogin = false;
    /**
     * Defines the client ID.
     * @param {number} id
     */

    this.setClientId = function (id) {
      clientId = id;
    };
    /**
     * Defines the plugin to use for the authentication process.
     * @param {string} name
     */


    this.setAuthPlugin = function (name) {
      plugin = name;
    };
    /**
     * Define the Host URL of the authentication server.
     * @param {string} url
     */


    this.setAuthHost = function (url) {
      hostUrl = url;
    };
    /**
     * Download user information automatically after login.
     * @param {boolean} enable
     */


    this.obtainUserInfoAfterLogin = function (enable) {
      obtainUserInfoAfterLogin = enable;
    };
    /**
     * This function returns the real thing.
     * @constructor
     * @param $injector
     * @param $rootScope
     * @param $http
     * @param $timeout
     * @param $q
     * @returns {{login: login, isLoggedIn: isLoggedIn, logout: logout, info: Object, checkAccountConfirmationTokenValidity: checkAccountConfirmationTokenValidity, setPasswordAndThenLoginWithResponse: setPasswordAndThenLoginWithResponse, loginSettingPasswordWithToken: loginSettingPasswordWithToken, install: install, isThisPluginUsed: isThisPluginUsed, loadUserInfo: loadUserInfo, getToken: getToken, getTokenPayload: getSessionInfo, getClientId: getClientId, getAuthHost: getAuthHost, getPluginInstance: getPluginInstance}}
     */

    /*@ngInject*/


    this.$get = ["$injector", "$rootScope", "$http", "$timeout", "$q", function ($injector, $rootScope, $http, $timeout, $q) {
      /**
       * This variable store information of the session and user.
       * @type {{session: {}, user: {}}}
       */
      var info = {
        /**
         * Store information about the current session.
         * @type {object}
         */
        session: {},

        /**
         * Store the user information obtain from the server.
         * @type {object}
         */
        user: {}
      };
      var userDataResolved = $q.defer();
      /**
       * The value of the current token.
       * @type {string}
       */

      var token = '';
      /**
       * Class of the auth plugin.
       */

      var authPluginClass = $injector.get(plugin);
      /**
       * Instance of the auth plugin.
       */

      var authPluginObj = authPluginClass(hostUrl, clientId);
      /**
       * Try to create a session using the credentials given.
       * @param {string} username
       * @param {string} password
       * @returns {$q}
       */

      var login = function login(username, password) {
        var onSuccess = function onSuccess(token) {
          try {
            install(token.raw, token.payload);
            return info.session; //This is returned by the Promise
          } catch (exception) {
            return $q.reject(String(exception));
          }
        };

        return authPluginObj.requestToken(username, password).then(onSuccess);
      };
      /**
       * Try to create a session using the token from url
       * @param {string} token raw token
       * @returns {$q}
       */


      var loginByToken = function loginByToken(token) {
        var parsedToken = authPluginObj.parseToken(token);

        try {
          install(parsedToken.raw, parsedToken.payload);
          return info.session; //This is returned by the Promise
        } catch (exception) {
          return $q.reject(String(exception));
        }
      };
      /**
       * Close the current session.
       */


      var logout = function logout() {
        if (!isLoggedIn()) return;
        token = '';
        info.session = {};
        info.user = {};
        authPluginObj.cancelToken();
        $rootScope.$emit('onLogout');
      };
      /**
       * Request to the server the setting of a password using an "account confirmation token".
       *
       * If the request is accepted by the server this will return a login token (the same used for the login
       * requests) that will immediately be installed as a valid session.
       *
       * FIXME The resource URL is hardcoded
       * @param {string} token
       * @param {object} model
       * @returns {$q}
       */


      var loginSettingPasswordWithToken = function loginSettingPasswordWithToken(token, model) {
        return $q(function (resolve, reject) {
          var payload = {
            client_id: clientId,
            code: token,
            agreement_rules: model.hasOwnProperty('agreement_rules') ? model.agreement_rules : false,
            agreement_notifications: model.hasOwnProperty('agreement_notifications') ? model.agreement_notifications : false
          };

          if (model.hasOwnProperty('password')) {
            payload.password = model.password;
          }

          var onSuccess = function onSuccess(token) {
            try {
              install(token.raw, token.payload);
              resolve(info.session); //This is returned by the Promise
            } catch (exception) {
              return reject(String(exception));
            }
          };

          var onFailure = function onFailure(errorMsg) {
            reject(errorMsg);
          }; //TODO The url suffix is hardcoded


          return authPluginObj.requestTokenWithCustomPayload(hostUrl + '/index/confirm', angular.toJson(payload)).then(onSuccess, onFailure);
        });
      };
      /**
       * Using a temporal token send a New-Password request to the server with the new password as a payload.
       * In case of success the server respond with a valid session token, the same returned when a user login.
       * This function use this token to automatically start a new user session.
       *
       * I'm aware that the name of this function is a bit to long, but is the best I got to describe correctly
       * all of this function do.
       *
       * FIXME The resource URL is hardcoded
       * @param token
       * @param password
       * @returns {*}
       */


      var setPasswordAndThenLoginWithResponse = function setPasswordAndThenLoginWithResponse(token, password) {
        return $q(function (resolve, reject) {
          var payload = {
            client_id: clientId,
            code: token,
            password: password
          };

          var onSuccess = function onSuccess(token) {
            try {
              install(token.raw, token.payload);
              resolve(info.session); //This is returned by the Promise
            } catch (exception) {
              return reject(String(exception));
            }
          };

          var onFailure = function onFailure(errorMsg) {
            reject(errorMsg);
          }; //TODO The url suffix is hardcoded


          return authPluginObj.requestTokenWithCustomPayload(hostUrl + '/users/recoveryPassword', angular.toJson(payload)).then(onSuccess, onFailure);
        });
      };
      /**
       * Ask to the server if the given code is valid and obtain user information as a plus.
       *
       * FIXME The resource URL is hardcoded
       * @param {string} token
       * @returns {$q}
       */


      var checkAccountConfirmationTokenValidity = function checkAccountConfirmationTokenValidity(token) {
        return $q(function (resolve, reject) {
          var payload = {
            client_id: clientId,
            code: token
          };
          $http.post(hostUrl + '/users/welcome', angular.toJson(payload)).then(function (response) {
            if (angular.isObject(response.data) && response.data.user) {
              resolve(response.data.user);
            } else {
              reject('The response doesn\'t have the format expected');
            }
          }, function (response) {
            reject(response.data.message);
          });
        });
      };
      /**
       * Take a token and session data and install it.
       *
       * @param {string} _token
       * @param {object} [sessionInfo]
       * @returns {boolean} Returns TRUE if the token is valid and was installed
       */


      var install = function install(_token, sessionInfo) {
        if (authPluginObj.isValidToken(_token)) {
          token = _token;
          info.session = sessionInfo;
          $rootScope.$emit('onLogin', {
            raw: token,
            payload: info.session
          });

          if (obtainUserInfoAfterLogin === true) {
            loadUserInfo();
          }

          return true;
        }

        return false;
      };
      /**
       * Check if the plugin name given is the current auth plugin used.
       *
       * @param {string} name
       * @returns {boolean}
       */


      var isThisPluginUsed = function isThisPluginUsed(name) {
        return plugin === name;
      };
      /**
       * Returns session information initially delivered by the server.
       *
       * @return {object}
       */


      var getSessionInfo = function getSessionInfo() {
        return angular.copy(info.session);
      };
      /**
       * Returns the ID of the user owner of the current session.
       * @returns {number|null}
       */


      var getUserId = function getUserId() {
        if (isLoggedIn()) {
          return info.session.sgid;
        }

        return null;
      };
      /**
       * Return the current token.
       * @returns {string}
       */


      var getToken = function getToken() {
        return token;
      };
      /**
       * Return TRUE if the there's a session active.
       *
       * @return {boolean}
       */


      var isLoggedIn = function isLoggedIn() {
        return !!token;
      };
      /**
       * Return TRUE if account is active and logged in
       *
       * @return {boolean}
       */


      var isActiveAccount = function isActiveAccount() {
        var active = false;

        try {
          active = !!token && this.info.user.user.agreement_rules;
        } catch (err) {}

        return active;
      };
      /**
       * Returns the ID of this client application.
       * @returns {string}
       */


      var getClientId = function getClientId() {
        return clientId;
      };
      /**
       * Returns the URL of the host used to authenticate.
       * @returns {string}
       */


      var getAuthHost = function getAuthHost() {
        return hostUrl;
      };
      /**
       * Returns the instance of the auth plugin used.
       * The name of the plugin is defined during the conf phase using {@link #setAuthPlugin}.
       * @returns {Object}
       */


      var getPluginInstance = function getPluginInstance() {
        return authPluginObj;
      };
      /**
       * Retrieve the current user information from the server.
       * This function should be called just after a valid session token is installed.
       *
       * Once a valid token is obtain the client (me) needs to know who is the user.
       * The server returns basic data and this information is save locally.
       * The user can access this data using the {@link #info.user} public property of this class.
       *
       * Note: The HTTP request made bu this function relies that the token will be added automatically to the
       * HTTP header. So, no additional data is included in the call.
       *
       * FIXME The resource URL is hardcoded
       * @returns {$q} Return the HTTP Promise
       */


      var loadUserInfo = function loadUserInfo() {
        // prevent reading user data resource multiple times within one second
        var currentTime = new Date();

        if (timestamp && new Date(timestamp.getTime() + 1000) > currentTime) {
          return $q.resolve();
        }

        timestamp = currentTime;
        return $http.get(hostUrl + '/users/me').then(function (response) {
          info.user = Object.assign({}, response.data);
          $rootScope.$emit('onUserInfo', info.user);
          userDataResolved.resolve();
        }, function (response) {
          if (logoutIfUserHasNoInfo === true) {
            logout();
          }
        });
      };

      return {
        //Common methods
        login: login,
        loginByToken: loginByToken,
        isLoggedIn: isLoggedIn,
        isActiveAccount: isActiveAccount,
        logout: logout,
        //Public params
        info: info,
        userDataResolved: userDataResolved.promise,
        //Methods used usually just one time in the account's life
        checkAccountConfirmationTokenValidity: checkAccountConfirmationTokenValidity,
        setPasswordAndThenLoginWithResponse: setPasswordAndThenLoginWithResponse,
        loginSettingPasswordWithToken: loginSettingPasswordWithToken,
        //Very internal methods
        install: install,
        isThisPluginUsed: isThisPluginUsed,
        loadUserInfo: loadUserInfo,
        //Get methods
        getUserId: getUserId,
        getToken: getToken,
        getTokenPayload: getSessionInfo,
        getClientId: getClientId,
        getAuthHost: getAuthHost,
        getPluginInstance: getPluginInstance
      };
    }];
    this.$get.$inject = ["$injector", "$rootScope", "$http", "$timeout", "$q"];
  });
})(angular.module('orbaAuth'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name loginGhostMode
   * @module orbaAuth
   * @description
   * Look at the URL parameters to find the "token" parameter. If it found it, use its value to install a user
   * session.
   */

  loginGhostMode.$inject = ["$location", "orbaSession", "orbaSessionKeeper", "ghostModeConfig"];
  module.service('loginGhostMode', loginGhostMode);
  /*@ngInject*/

  function loginGhostMode($location, orbaSession, orbaSessionKeeper, ghostModeConfig) {
    var tokenFound,
        remember = ghostModeConfig.rememberSessions;
    return {
      rememberSession: rememberSession,
      iAmGhost: iAmGhost,
      run: run
    };
    /**
     * Returns the token from the URL.
     * @return {string|null}
     */

    function getToken() {
      var urlParams = $location.search();
      var token = urlParams.hasOwnProperty('token') ? urlParams.token : null;
      return angular.isString(token) && token.length > 0 ? token : null;
    }
    /**
     * Remove the token from the URL.
     */


    function cleanUrl() {
      $location.search('token', null);
    }
    /**
     * Check if the current session is a ghost session.
     * @return {boolean}
     */


    function iAmGhost() {
      return orbaSession.getToken() == tokenFound;
    }
    /**
     * Check if the session should be remember in the browser if no value is passed as an argument.
     *
     * If an argument is passed the "remember" option is updated.
     *
     * @param {boolean} [enable=undefined]
     * @return {boolean}
     */


    function rememberSession(enable) {
      if (angular.isDefined(enable)) {
        remember = !!enable;
      }

      return remember;
    }
    /**
     * Try to find a session token in the URL and installed if it found one.
     */


    function run() {
      tokenFound = getToken();

      if (tokenFound) {
        //Don't remember this ghost session
        if (!rememberSession()) {
          orbaSessionKeeper.disable(false);
        }

        if (orbaSession.isLoggedIn()) {
          orbaSession.logout();
        }

        orbaSession.loginByToken(tokenFound);
        cleanUrl();
      }
    }
  }
})(angular.module('orbaAuth'));
"use strict";

/**
 * @ngdoc service
 * @name orbaLoginEnforceHttpInterceptor
 * @module orbaAuth
 * @description
 * Interceptor used to Enforcing login when the server rejects the current token.
 *
 * This service is used by {@link orbaLoginEnforce}.
 *
 * @author daniel.zegarra@orba.co
 */
(function (module) {
  /*@ngInject*/
  module.factory('orbaLoginEnforceHttpInterceptor', ["$q", "$injector", "$location", function ($q, $injector, $location) {
    var REQUIRE_AGREEMENTS_PUSHACTION = "requireAgreements";
    var REQUIRE_AGREEMENTS_REDIRECT = "/auth/setAgreements";
    /**
     * Function executed when the response of a HTTP request is an error.
     * Redirect to the auth form if the server respond with a 401 state.
     * @param  {object}  response Response returned by the server
     * @return {Promise}
     */

    function responseError(response) {
      var orbaSession = $injector.get('orbaSession');

      if (response.status == 401 && orbaSession.isLoggedIn()) {
        orbaSession.logout();
        $injector.get('orbaLoginEnforce').showLoginForm();
      }

      if (response.status == 403 && orbaSession.isLoggedIn()) {
        // Api informs us that we need to redirect inactive user
        var pushAction = response.headers('X-Frontend-Action');

        if (pushAction === REQUIRE_AGREEMENTS_PUSHACTION) {
          $location.path(REQUIRE_AGREEMENTS_REDIRECT);
        }
      }

      return $q.reject(response);
    }

    return {
      responseError: responseError
    };
  }]);
})(angular.module('orbaAuth'));
"use strict";

/**
 * @ngdoc serviceProvider
 * @name orbaLoginEnforce
 * @module orbaAuth
 * @description
 * Just loading this script you're doing a couple of things to ensure the user will be force to use his credentials
 * before interacting with this app.
 *
 * First, the {@link orbaLoginEnforceHttpInterceptor} service is registered as a HTTP interceptor which show the
 * login form to the user if the server returns a "401 Unauthorized" error to any HTTP request.
 *
 * And second, if the user is not login the login form will be the only screen he could see.
 *
 * @author daniel.zegarra@orba.co
 */
(function (module, angular) {
  module.provider('orbaLoginEnforce', function orbaLoginEnforceProvider() {
    var loginViewState = 'login',
        excludedViewStates = [];
    /**
     * Set the name of the state view which shown the login form screen.
     * @param {string} stateName
     */

    this.loginFormViewState = function (stateName) {
      loginViewState = stateName;
    };
    /**
     * Set the list of view states which the enforced won't be applied.
     * @param {RegExp[]} states
     */


    this.excludedViewStates = function (states) {
      excludedViewStates = states;
    };
    /**
     * This function returns the real thing.
     * @constructor
     * @param $state
     * @param $rootScope
     * @param orbaCurrentPath
     * @returns {{isThisStateExcluded: isThisStateExcluded, showLoginForm: showLoginForm}}
     */

    /*@ngInject*/


    this.$get = ["$state", "$rootScope", "orbaCurrentPath", function ($state, $rootScope, orbaCurrentPath) {
      var waitingLogin = false;
      /**
       * Just in case you don't make out, this function show the login form.
       */

      var showLoginForm = function showLoginForm() {
        $state.go(loginViewState);
      };
      /**
       * show login form with restore path
       */


      var showLoginFormRestore = function showLoginFormRestore(toState, toParams) {
        orbaCurrentPath.save(toState, toParams);
        $state.go(loginViewState);
        restorePathAfterLogin();
      };
      /**
       * It will wait until the user gain a valid session and then it will redirect to the initial url.
       */


      var restorePathAfterLogin = function restorePathAfterLogin() {
        waitingLogin = true;
      };
      /**
       * Check is the view state name given is in the excluded list.
       * @param {string} stateName
       * @return {boolean}
       */


      var isThisStateExcluded = function isThisStateExcluded(stateName) {
        var excluded = false;
        angular.forEach(excludedViewStates, function (value) {
          if (!!stateName.match(value)) {
            excluded = true;
          }
        });
        return excluded;
      };

      var installListeners = function installListeners() {
        $rootScope.$on('onSessionSave', function () {
          if (waitingLogin) {
            orbaCurrentPath.restore();
            waitingLogin = false;
          }
        });
      };

      installListeners();
      return {
        isThisStateExcluded: isThisStateExcluded,
        showLoginForm: showLoginForm,
        showLoginFormRestore: showLoginFormRestore
      };
    }];
    this.$get.$inject = ["$state", "$rootScope", "orbaCurrentPath"];
  });
  /*
   * HTTP REQUEST EAR-DROPPING
   * Enforcing login when the server rejects the current token.
   */

  /*@ngInject*/

  module.config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push('orbaLoginEnforceHttpInterceptor');
  }]);
  /*
   * VIEW STATE POLICEMEN
   * Enforcing login when no session is found and the new view state is restricted.
   */
  //Don't allow to a unauthenticated user to access other states rather than the login screen

  module.run(["$rootScope", "orbaSession", "orbaLoginEnforce", function ($rootScope, orbaSession, orbaLoginEnforce) {
    //This event is fired just before the state change
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
      if (!orbaSession.isLoggedIn() && !orbaLoginEnforce.isThisStateExcluded(toState.name)) {
        event.preventDefault(); //You shall not pass!

        orbaLoginEnforce.showLoginFormRestore(toState, toParams);
      }
    });
  }]);
})(angular.module('orbaAuth'), angular);
"use strict";

/**
 * @ngdoc service
 * @name authJwtPluginInterceptor
 * @module orbaAuth
 * @description
 * This is the HTTP interceptor for the authentication plugin "authJwtPlugin".
 * An HTTP interceptor add the session token to each HTTP request make by the client.
 *
 * This interceptor is installed during the Angular configuration phase but the requests are ONLY altered
 * if the "authJwtPlugin" is been used.
 * This plugin can be selected with the next line:
 * orbaSessionProvider.setAuthPlugin('authJwtPlugin');
 *
 * @author  daniel.zegarra@orba.co
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('authJwtPluginInterceptor', ["$injector", function ($injector) {
    /**
     * Function executed each time a HTTP request is made.
     * Its job is to add the session token to the headers if the current user is already authenticated.
     * @param  {object} config Configuration object of the $http request
     * @return {object}        The updated configuration
     */
    function request(config) {
      var sessionManager = $injector.get('orbaSession');

      if (sessionManager.isThisPluginUsed('authJwtPlugin') && sessionManager.isLoggedIn()) {
        config.headers.Authorization = 'Bearer ' + sessionManager.getToken();
      }

      return config;
    }

    return {
      request: request
    };
  }]); //The interceptor is registered in config phase because $httpProvider is available only during this time

  /*@ngInject*/

  module.config(["$httpProvider", function ($httpProvider) {
    $httpProvider.interceptors.push('authJwtPluginInterceptor');
  }]);
})(angular.module('orbaAuth'));
"use strict";

/**
 * @ngdoc service
 * @name authJwtPlugin
 * @module orbaAuth
 * @description
 * Authentication plugin that can be use by the service {@link orbaSession} to request a temporal token to a server.
 * This plugin allows using the json web token standard to authenticate against the server.
 *
 * @author  daniel.zegarra@orba.co
 */
(function (module, angular) {
  'use strict';
  /*@ngInject*/

  module.service('authJwtPlugin', ["$http", "$q", "jwtHelper", function authJwtPlugin($http, $q, jwtHelper) {
    return function (hostUrl, clientId) {
      /**
       * Function used to construct the "request token" payload.
       * @param {string} username
       * @param {string} password
       * @return {object}
       */
      var loginPayloadBuilder = function loginPayloadBuilder(username, password) {
        return {
          username: username,
          password: password,
          grant_type: 'password',
          //TODO This string should be harcoded?
          client_id: clientId
        };
      };
      /**
       * Default configuration to the new token HTTP request.
       * Follow {@link https://docs.angularjs.org/api/ng/service/$http|this link} to see the complete list.
       * @type {object}
       */


      var config = {
        /*headers: {
         'Content-Type': 'application/x-www-form-urlencoded'
         }*/
      };
      /**
       * Decode the data asociated to the token and return the result.
       * @param {string} rawToken
       * @returns {object|null}
       */

      var readTokenData = function readTokenData(rawToken) {
        try {
          return jwtHelper.decodeToken(rawToken);
        } catch (err) {
          return null;
        }
      };
      /**
       * See if given token is valid and decode it
       * @param {string} rawToken
       * @returns {object|false}
       */


      var parseToken = function parseToken(rawToken) {
        var tokenDecodedData;

        if (isValidToken(rawToken)) {
          tokenDecodedData = readTokenData(rawToken);
          return {
            raw: rawToken,
            payload: tokenDecodedData
          };
        }

        return false;
      };
      /**
       * Check if the given token is a valid one.
       *
       * Take notice that only the payload of the token is validated. The header and the signature
       * is not take in account in the validation process used by this function.
       *
       * @param {string} rawToken
       * @returns {boolean}
       */


      var isValidToken = function isValidToken(rawToken) {
        //The library can throw an error if the token is invalid
        try {
          var decodedToken = jwtHelper.decodeToken(rawToken);
        } catch (err) {
          return false;
        }

        if (!angular.isObject(decodedToken)) {
          return false;
        } //The token has to contain expiration date


        if (jwtHelper.getTokenExpirationDate(rawToken) === null) {
          return false;
        }

        return !jwtHelper.isTokenExpired(rawToken);
      };
      /**
       * Request a valid token using the custom data given and url given.
       *
       * @param  {string} url URL of the server
       * @param  {string} payload Data to send for obtain a valid token
       * @return {$q}     Angular promise
       */


      var requestToken = function requestToken(url, payload) {
        return $q(function (resolve, reject) {
          /**
           * Function executed when the credentials of the user were accepted by the server and this
           * returned a temporal token.
           * Its function is to make a last locally validation of the token the response and resolve
           * the promise.
           * @param  {object} response Response of the server
           */
          var onSuccess = function onSuccess(response) {
            var rawToken, tokenDecodedData;

            if (angular.isObject(response.data) && response.data.token) {
              rawToken = response.data.token;

              if (isValidToken(rawToken)) {
                tokenDecodedData = readTokenData(rawToken);
                resolve({
                  raw: rawToken,
                  payload: tokenDecodedData
                });
              } else {
                reject('The token received is not valid');
              }
            } else {
              reject('The response doesn\'t have a valid format');
            }
          };
          /**
           * Function executed when the server responded with an error.
           * @param  {object} response Response of the server
           */


          var onFailure = function onFailure(response) {
            if (angular.isObject(response.data) && response.data.message) {
              reject(response.data.message);
            } else if (angular.isString(response.data) && response.data == 'The account has been blocked. Please contact your commercial Counsellor.') {
              // Ugly hack because of Daniel's pointless filter that strips useful error code from response
              reject('ACCOUNT.ERROR_BANNED');
            } else {
              reject(null);
            }
          }; //Making the request


          $http.post(url, payload, config).then(onSuccess, onFailure);
        });
      };
      /**
       * Request a valid token using the credentials given.
       *
       * For use this function the server host have to be already defined.
       *
       * @param  {string} username Username
       * @param  {string} password Password associated to the username
       * @return {$q}              Angular promise
       */


      var requestTokenWithUsernameAndPassword = function requestTokenWithUsernameAndPassword(username, password) {
        var payload = loginPayloadBuilder(username, password);
        return requestToken(hostUrl + '/index', angular.toJson(payload));
      };
      /**
       * Order to the server to discard a valid token.
       * @param {string} rawToken
       */


      function cancelToken(rawToken) {//TODO For now this function do nothing
      }

      return {
        requestToken: requestTokenWithUsernameAndPassword,
        requestTokenWithCustomPayload: requestToken,
        cancelToken: cancelToken,
        isValidToken: isValidToken,
        renovateToken: null,
        readTokenData: readTokenData,
        parseToken: parseToken
      };
    };
  }]);
})(angular.module('orbaAuth'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name productInfoModalLauncher
   * @module app
   * @description
   * Service to show a modal window with information of a product.
   */

  productInfoModalLauncher.$inject = ["$uibModal", "$rootScope"];
  module.service('productInfoModalLauncher', productInfoModalLauncher);
  /*@ngInject*/

  function productInfoModalLauncher($uibModal, $rootScope) {
    /**
     * @name show
     * @description
     * Show information of a product.
     * @param {object} model product information model
     * @param {boolean} allowAddToCart product information model
     */
    var show = function show(model, allowAddToCart) {
      var scope = $rootScope.$new(true);
      scope.model = model;
      scope.allowAddToCart = allowAddToCart === true;
      $uibModal.open({
        size: 'lg',
        windowClass: 'center-modal-child',
        //Template to encapsulate the product summary component
        template: '<div class="modal-body no-padding">' + '<div class="product-module no-padding">' + '<product-info-summary model="model" allow-add-to-cart="allowAddToCart" on-go-to-cart-list="$close()"></product-info-summary>' + '<div class="close-button">' + '<button type="button" class="close" ng-click="$close()" ng-attr-title="{{\'GLOBAL.CLOSE\'|translate}}" ng-attr-aria-label="{{\'GLOBAL.CLOSE\'|translate}}">' + '</button>' + '</div>' + '</div>' + '</div>',
        scope: scope
      });
    };

    return {
      show: show
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:productCatalog
   * @description
   * @author tomasz.sledziewski@orba.co
   * Service to handle category from api
   */

  module.service('productCategory', ['$q', 'websocket', function ($q, websocket) {
    /**
     * Category list object (flat)
     */
    var _category;
    /**
     * Get category (flat) from Node
     *
     * @return {*}
     */


    function getCategoryFromNode() {
      return $q(function (resolve, reject) {
        websocket.emit('category.structure', null, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });
    }
    /**
     * have category ?
     *
     * @return {boolean}
     */


    function haveContent() {
      return _category !== undefined;
    }
    /**
     * Get category
     *
     * @return {*}
     */


    function getCategory() {
      return $q(function (resolve, reject) {
        if (!haveContent()) {
          getCategoryFromNode().then(function (response) {
            _category = response;
            resolve(_category);
          });
        } else {
          resolve(_category);
        }
      });
    }
    /**
     * Get category by ID
     *
     * @param id
     * @return {*}
     */


    function getCategoryByIndex(id) {
      return getCategory().then(function (category) {
        for (var i = 0; i < category.length; i++) {
          if (category[i].id === id) {
            return category[i];
          }
        }
      });
    }

    return {
      haveContent: haveContent,
      getCategory: getCategory,
      getCategoryByIndex: getCategoryByIndex
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:productCatalog
   * @description
   * Service to connect the different components of the Product module across the app.
   * @author daniel.zegarra@orba.co
   */

  module.service('productCatalog', function () {
    return {
      keywords: ''
    };
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:cardFileService
   * @description Service for downloading PDF product cards
   * @author oskar.laska@orba.co
   */

  /*@ngInject*/

  module.service('cardFileService', ['productConfig', '$http', 'FileSaver', function (productConfig, $http, FileSaver) {
    /**
     * Helper function. Extracts file name from
     * Content-Disposition header of response.
     *
     * @param response
     * @return {null|string} File name or null
     */
    function getFileName(response) {
      var contentDisposition = response.headers('Content-Disposition');

      if (contentDisposition && contentDisposition.length) {
        var filenameRegex = /filename=\"(.+?)\"/;
        var matches = filenameRegex.exec(contentDisposition);
        return matches[1];
      }

      return null;
    }
    /**
     * Helper function. Sends PDF to client basing on
     * response data returned from Magento.
     *
     * @param response
     */


    function downloadPdf(response) {
      var filename = getFileName(response) || 'card.pdf';
      FileSaver.saveAs(response.data, filename);
    }
    /**
     * Download single card PDF file by sku.
     *
     * @param {string} sku
     */


    function downloadSingleCard(sku) {
      var url = productConfig.cardUrls.single.replace(':sku', sku);
      return $http({
        url: url,
        method: 'GET',
        responseType: 'blob'
      }).then(downloadPdf);
    }
    /**
     * Download cart's card PDF file by cartId and SKUs.
     *
     * @param {array} skus
     * @param {string} cartId
     */


    function downloadCartCard(cartId, skus) {
      var url = productConfig.cardUrls.cart;
      var payload = {
        cart_id: cartId,
        sku: skus
      };
      return $http({
        url: url,
        method: 'POST',
        responseType: 'blob',
        data: payload
      }).then(downloadPdf);
    }
    /**
     * Download offers's card PDF file by offerId and SKUs.
     *
     * @param {array} skus
     * @param {string} offerId
     */


    function downloadOfferCard(offerId, skus) {
      var url = productConfig.cardUrls.offer;
      var payload = {
        offer_id: offerId,
        sku: skus
      };
      return $http({
        url: url,
        method: 'POST',
        responseType: 'blob',
        data: payload
      }).then(downloadPdf);
    }

    return {
      downloadSingleCard: downloadSingleCard,
      downloadCartCard: downloadCartCard,
      downloadOfferCard: downloadOfferCard
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:attributesService
   * @description
   * Service to handle attributes from api
   */

  /*@ngInject*/

  module.service('attributesService', ["productAttributesResource", function (productAttributesResource) {
    /**
     * object to store attributes
     * @type {null}
     */
    var attr = null;
    /**
     * Read attributes from api
     */

    function readAttributes() {
      attr = productAttributesResource.query();
    }

    return {
      get: function get() {
        if (attr === null) {
          readAttributes();
        }

        return attr;
      }
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:productsResource
   * @description
   * Encapsulate the logic to make products search requests to the server.
   * @author daniel.zegarra@orba.co
   */

  module.factory('productsResource', ['$q', 'websocket', '$resource', 'productConfig', function ($q, websocket, $resource, productConfig) {
    /**
     * Prepare the payload for request a search of products.
     * @param {string}   [keywords='']          Keywords filter
     * @param {object}   [products={include:[], exclude:[], checkOnly:boolean}]          List of SKUs for include or exclude
     * @param {string[]} [products.include=[]]  List of SKUs to limit the search
     * @param {string[]} [products.exclude=[]]  List of SKUs to exclude
     * @param {number}   [page=1]               Page number
     * @param {number}   [rowsPerPage=10]       Size of the page of results
     * @param {String}   [sort=NULL]            Sort order
     * @param {string[]} [fields]               List of columns to retrieve
     * @param {number}   [category]
     * @returns {{q: string, products: {include: Array, exclude: Array}, sort: string, start: number, rows: string, expectFields: Array}}
     */
    var buildPayload = function buildPayload(keywords, products, page, rowsPerPage, sort, fields, category) {
      if (!angular.isString(keywords)) {
        keywords = '';
      }

      if (!angular.isObject(products)) {
        products = {};
      }

      var result = {
        q: keywords,
        products: {
          include: products.hasOwnProperty('include') ? angular.isArray(products.include) ? products.include : [products.include] : [],
          exclude: products.hasOwnProperty('exclude') ? angular.isArray(products.exclude) ? products.exclude : [products.exclude] : []
        },
        filterCatalogPrice: products.hasOwnProperty('filterCatalogPrice') ? products.filterCatalogPrice : false,
        sort: sort,
        start: (isFinite(rowsPerPage) ? rowsPerPage : 10) * ((isFinite(page) ? page : 1) - 1),
        rows: rowsPerPage,
        expectFields: fields || []
      };

      if (products.hasOwnProperty('checkOnly')) {
        result.checkOnly = products.checkOnly;
        delete products.checkOnly;
      }

      if (category !== null) {
        result.cid = category;
      }

      if (products !== null) {
        delete products.include;
        delete products.exclude;
        result.filter = products;
      }

      return result;
    };

    return {
      /**
       * @ngdoc method
       * @name query
       * @methodOf app.service:productsResource
       * @description
       * Start a search request.
       * @param {string} keywords
       * @param {object} filters
       * @param {number} page
       * @param {number} rowsPerPage
       * @param {string} sort
       * @param {number} category
       * @returns {$q}
       */
      query: function query(keywords, filters, page, rowsPerPage, sort, category) {
        return $q(function (resolve, reject) {
          var startTime = new Date(),
              payload = buildPayload(keywords, filters, page, rowsPerPage, sort, null, category);
          /**
           * Receive the response.
           * @param {object} response
           */

          var processResponse = function processResponse(response) {
            if (response.hasOwnProperty('error')) {
              reject(response.error);
            } else {
              response.time = new Date() - startTime;
              resolve(response);
            }
          };

          websocket.emit('product.search', payload, processResponse);
        });
      },

      /**
       * Request the information of a single product.
       * @param {string} sku
       * @return {Promise}
       */
      get: function get(sku) {
        return $q(function (resolve, reject) {
          websocket.emit('product.get', sku, function (response) {
            if (!angular.isObject(response)) {
              response = {};
            }

            if (response.hasOwnProperty('error')) {
              reject(response.error);
            } else {
              resolve(response);
            }
          });
        });
      },

      /**
       * Send api request to update stocks
       * @return {boolean}
       */
      requestStockUpdate: function requestStockUpdate(sku) {
        $resource(productConfig.restful.stocks, {
          sku: '@sku'
        }).get({
          sku: sku
        });
        return $q(function (resolve, reject) {
          websocket.emit('product.listenForUpdates', {
            sku: sku
          });
          websocket.once('product.updated', function (sku) {
            resolve(sku);
          });
        });
      }
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('productAttributesResource', ["$resource", "$http", "lodash", "productConfig", function ($resource, $http, lodash, productConfig) {
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @param {string} code_short
     * @returns {object} Returns the item formatted
     */
    var transformItem = function transformItem(srcItem, code_short) {
      return {
        code: srcItem.solr_field,
        label: srcItem.frontend_label,
        type: srcItem.backend_type,
        position: parseInt(srcItem.position, 10)
      };
    };

    return $resource(productConfig.restful.productAttributes, {}, {
      'query': {
        method: 'GET',

        /**
         * I make any transformation necessary to use this data in the app.
         * @param {object|object[]|string} data
         * @returns {object[]|string}
         */
        transformResponse: $http.defaults.transformResponse.concat(function (data) {
          return angular.isObject(data) ? lodash.keyBy(lodash.map(data.attributes || data, transformItem), 'code') : data;
        })
      }
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.filter('translateProductAttrName', ["attributesService", function (attributesService) {
    var catalog = attributesService.get();
    /**
     * Receive a role ID and returns its name.
     * @param {string} code
     * @returns {string}
     */

    var resolve = function resolve(code) {
      var name = code;

      if (catalog.hasOwnProperty(code)) {
        name = catalog[code].label;
      }

      return name;
    };
    /**
     * Filter per se.
     * @param {string} code
     * @returns {string}
     */


    var filter = function filter(code) {
      if (catalog.$resolved) {
        return resolve(code);
      } else {
        return '-';
      }
    };

    filter.$stateful = true;
    return filter;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc filter
   * @name sortProductAttributes
   * @description
   * Sort an array of custom product attributes using the position defined for each attribute in the custom
   * attributes catalog.
   * This filter retrieve asynchronously the catalog of product attributes.
   * @param {boolean} [reverse=false] Sort in reverse
   */

  /*@ngInject*/

  module.filter('sortProductAttributes', ["orderByFilter", "lodash", "attributesService", function (orderByFilter, lodash, attributesService) {
    var catalog = attributesService.get();
    /**
     * Returns the index's position of the given product custom attribute.
     * @param {object} attrFromProduct
     * @return {number}
     */

    var getPositionOfProductAttr = function getPositionOfProductAttr(attrFromProduct) {
      var catItem = lodash.find(catalog, {
        code: attrFromProduct.code
      });
      return catItem ? catItem.position : 0;
    };
    /**
     * Sorter function.
     * @param {array} attrsFromProduct Array of attributes from a product
     * @param {boolean} [reverse=false]
     * @returns {array} Sorted attributes
     */


    var sort = function sort(attrsFromProduct, reverse) {
      if (catalog.$resolved === true) {
        return orderByFilter(attrsFromProduct, getPositionOfProductAttr, reverse);
      }

      return attrsFromProduct;
    };

    sort.$stateful = true;
    return sort;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @module app
   * @name quickInfoCtrl
   * @description Controller for product quick info view.
   */

  quickInfoCtrl.$inject = ["$scope", "orbaSession"];
  module.controller('quickInfoCtrl', quickInfoCtrl);
  /*@ngInject*/

  function quickInfoCtrl($scope, orbaSession) {
    var vm = this;
    vm.model = {}; //TODO userLimited value should be retrieved here without knowing role id here

    $scope.userLimited = parseInt(orbaSession.getTokenPayload().sgrol, 10) === 2;
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name app.controller:productCatalogCtrl
   * @description
   * Controller for the catalog of products.
   * @author daniel.zegarra@orba.co
   */

  function productCatalogCtrl($scope, productsResource, productCatalog, orbaSession, $state, attributesService, $filter, $localStorage) {
    /*const*/
    var FILTER_PRICE_CODE = 'price_decimal';
    $scope.rows = [];
    $scope.numberOfRows = 0;
    $scope.currentPage = parseInt($state.params.p, 10) || 1;
    $scope.rowsPerPage = 10;
    $scope.totalResults = $state.params.p ? parseInt($state.params.p, 10) * $scope.rowsPerPage : 0;
    $scope.filters = JSON.parse($state.params.filter);
    $scope.cid = $state.params.cid ? $state.params.cid : null;
    $scope.category = {
      isRoot: true
    };
    $scope.facet = [];
    $scope.showFilter = false;
    $scope.showCategory = false;
    $scope.limitValues = [5, 10, 15, 20, 50, 100];
    var resName = 'products';
    var stored = $localStorage.paginatorData || {};
    $scope.rowsPerPage = stored[resName] && stored[resName].rowsPerPage ? stored[resName].rowsPerPage : 10;

    if ($state.params.hasOwnProperty('s')) {
      productCatalog.keywords = $state.params.s;
    }

    $scope.sortCatalog = [{
      code: 'scoreDESC',
      label: 'GLOBAL.SORT.scoreDESC'
    }, {
      code: 'nameASC',
      label: 'GLOBAL.SORT.nameASC'
    }, {
      code: 'nameDESC',
      label: 'GLOBAL.SORT.nameDESC'
    }, {
      code: 'priceASC',
      label: 'GLOBAL.SORT.priceASC'
    }, {
      code: 'priceDESC',
      label: 'GLOBAL.SORT.priceDESC'
    }, {
      code: 'skuASC',
      label: 'GLOBAL.SORT.skuASC'
    }, {
      code: 'skuDESC',
      label: 'GLOBAL.SORT.skuDESC'
    }];
    $scope.keywords = $state.params.s || '';
    var sortFromUrl = false;

    if ($state.params.sort) {
      angular.forEach($scope.sortCatalog, function (item) {
        if (item.code === $state.params.sort) {
          sortFromUrl = true;
        }
      });
    }

    $scope.sort = sortFromUrl ? $state.params.sort : 'scoreDESC';
    $scope.paginatorLimitSize = 5;
    $scope.time = null;
    $scope.lastErrorMsg = '';
    $scope.dismissError = dismissError;
    $scope.updateResults = updateResults; //TODO userLimited value should be retrieved here without knowing role id here

    $scope.userLimited = parseInt(orbaSession.getTokenPayload().sgrol, 10) === 2;

    function updateLimit() {
      var stored = $localStorage.paginatorData || {};
      stored[resName] = {
        rowsPerPage: $scope.rowsPerPage
      };
      $localStorage.paginatorData = stored;
    }
    /**
     * @ngdoc method
     * @name updateResults
     * @methodOf app.controller:productCatalogCtrl
     * @description
     * Request new results from the server.
     */


    function updateResults() {
      dismissError();
      updateLimit();
      $state.go($state.current, {
        s: $scope.keywords,
        p: $scope.currentPage,
        sort: $scope.sort,
        filter: JSON.stringify($scope.filters),
        cid: $scope.cid
      }, {
        notify: false
      });
      $scope.searchProductsPromise = productsResource.query($scope.keywords, $scope.filters, $scope.currentPage, $scope.rowsPerPage, $scope.sort, $scope.cid).then(function (results) {
        $scope.totalResults = results.total;
        $scope.time = results.time;
        $scope.rows = results.rows;
        $scope.numberOfRows = results.total;
        $scope.category = results.category;
        prepareFacet(results.facet);
        showHideFilterAndCategory();
      }, showError);
    }
    /**
     * Show or hide filter and category
     */


    function showHideFilterAndCategory() {
      if ($scope.cid !== null && $scope.cid !== undefined) {
        $scope.showCategory = true;
        $scope.showFilter = true;
      } else {
        $scope.showCategory = true;
        $scope.showFilter = false;
      }

      if ($scope.keywords !== null && $scope.keywords !== undefined && $scope.keywords !== '') {
        $scope.showCategory = false;
        $scope.showFilter = true;
      }
    }
    /**
     * Show an error message.
     * @param {string} msg
     */


    function showError(msg) {
      msg = msg ? msg : 'An unknown error has just happened';
      $scope.lastErrorMsg = msg;
      $scope.rows = [];
    }
    /**
     * @ngdoc method
     * @name dismissError
     * @methodOf app.controller:productCatalogCtrl
     * @description
     * Clear the previous error message.
     */


    function dismissError() {
      $scope.lastErrorMsg = '';
    }
    /**
     * Update the results when the filters change.
     */


    $scope.$watchGroup(['keywords', 'filters', 'sort', 'rowsPerPage', 'currentPage', 'filters', 'cid'], $scope.updateResults);
    /**
     * Prepare Facet
     * Translate code to label and add information witch field is selected
     *
     * @param {[]} facet
     * @return {[]}
     */

    function prepareFacet(facet) {
      if (facet !== undefined) {
        if (facet.length > 0) {
          return attributesService.get().$promise.then(function (attr) {
            var result = facet.filter(function (_facet) {
              if (attr.hasOwnProperty(_facet.code)) {
                _facet.label = $filter('translateProductAttrName')(_facet.code);
                _facet.type = attr[_facet.code].type;
              } else if (_facet.code === FILTER_PRICE_CODE) {
                _facet.label = $filter('translate')('GLOBAL.CATALOG-PRICE');
                _facet.type = 'decimal';
              }

              if (_facet.label !== undefined) {
                switch (_facet.code) {
                  case FILTER_PRICE_CODE:
                    preparePriceFilter(_facet);
                    break;

                  default:
                    prepareListFilter(_facet);
                }

                return true;
              }

              return false;
            }); // sort an filter of alphabetically by label

            result.sort(function (a, b) {
              // filter for price must be first
              if (a.code === FILTER_PRICE_CODE) {
                return -1;
              }

              if (b.code === FILTER_PRICE_CODE) {
                return 1;
              }

              return a.label.localeCompare(b.label);
            });
            $scope.facet = result;
          });
        }
      } else {
        $scope.facet = [];
      }
    }
    /**
     * Prepare price for filter
     * @param filter
     */


    function preparePriceFilter(filter) {
      var filterItems = getFilterItemsFromState(filter.code);
      filter.open = true;

      if (filterItems) {
        if (filterItems[0] !== null) {
          filter.values[0] = filterItems[0];
          filter.selected = true;
        }

        if (filterItems[1] !== null) {
          filter.values[1] = filterItems[1];
          filter.selected = true;
        }

        filter.originSelected = filter.selected;
      }
    }
    /**
     * Prepare list varchar for filter
     * @param filter
     */


    function prepareListFilter(filter) {
      var filterItems = getFilterItemsFromState(filter.code);
      filter.selected = filterItems.length > 0;
      filter.originSelected = filter.selected;
      filter.values.forEach(function (item) {
        if (filter.type === 'boolean') {
          item.label = item.name === 'true' ? $filter('translate')('GLOBAL.YES') : $filter('translate')('GLOBAL.NO');
        } else {
          item.label = item.name;
        }

        if (filterItems) {
          item.selected = filterItems.indexOf(item.name) >= 0;
          item.originSelected = item.selected;

          if (item.selected) {
            filter.open = true;
          }
        }
      });
    }
    /**
     * Get filter from state(url)
     *
     * @param {string} filterName
     * @return {[]|boolean}
     */


    function getFilterItemsFromState(filterName) {
      var filters = $scope.filters;

      if (filters !== null && filters !== undefined) {
        if (filters.hasOwnProperty(filterName)) {
          return filters[filterName];
        }
      }

      return false;
    }
    /**
     * Show filters?
     * Filters when show root category mast by hidden
     *
     * @return {boolean}
     */


    $scope.showFilters = function () {
      return !($state.params.cid === null || $state.params.cid === undefined);
    };
    /**
     * Shared method for update filter
     * @param arg
     */


    $scope.updateFilter = function (arg) {
      $scope.filters = arg;
      $scope.currentPage = 1;
    };
    /**
     * Shared method for update category
     * @param arg
     */


    $scope.updateCategory = function (arg) {
      $scope.cid = arg;
      $scope.currentPage = 1;
      $scope.filters = {};
    };
  }

  module.controller('productCatalogCtrl', ['$scope', 'productsResource', 'productCatalog', 'orbaSession', '$state', 'attributesService', '$filter', '$localStorage', productCatalogCtrl]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgProductSearchBox
   * @description
   * Search box of products.
   * @author daniel.zegarra@orba.co
   */

  sgProductSearchBox.$inject = ["$scope", "$state", "productCatalog"];
  module.component('sgProductSearchBox', {
    templateUrl: 'app/product/components/productSearchBox.html',
    controllerAs: 'vm',
    bindToController: true,
    controller: sgProductSearchBox,
    bindings: {
      keywords: '=?'
    }
  });
  /*@ngInject*/

  function sgProductSearchBox($scope, $state, productCatalog) {
    var vm = this;
    vm.catalogSvc = productCatalog;
    /**
     * Redirect the user to the catalog and update the keywords filter to update the results.
     */

    vm.search = function () {
      vm.catalogSvc.keywords = vm.keywords; //TODO State view name is hardcoded

      $state.go('product.catalog', {
        p: 1,
        s: vm.keywords,
        sort: 'scoreDESC',
        cid: null,
        filter: null
      });
    }; //Main updated the keywords input field with the current filter in of the catalog service


    $scope.$watch('vm.catalogSvc.keywords', function (newValue) {
      vm.keywords = newValue;
    });
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name productRelatedModal
   * @module app
   * @description
   * Service to show a modal window with information about related products
   */

  productRelatedModal.$inject = ["$uibModal", "$rootScope"];
  module.service('productRelatedModal', productRelatedModal);
  /*@ngInject*/

  function productRelatedModal($uibModal, $rootScope) {
    /**
     * @name show
     * @description
     * Show information of a product.
     * @param {object} model product information model
     * @param userLimited
     */
    var show = function show(model, userLimited) {
      var scope = $rootScope.$new(true);
      scope.model = model;
      scope.userLimited = userLimited;
      $uibModal.open({
        size: 'lg',
        windowClass: 'center-modal-child',
        //Template to encapsulate the product summary component
        templateUrl: 'app/product/components/productRelatedModal.html',
        scope: scope
      });
    };

    return {
      show: show
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productRelatedItem
   * @description
   * Show the information of a product as a row in a table - products related
   */

  productRelatedItem.$inject = ["lodash", "productConfig", "toaster"];
  module.directive('productRelatedItem', function () {
    return {
      restrict: 'AE',
      templateUrl: 'app/product/components/productRelatedItem.html',
      controller: productRelatedItem,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        row: '<data',
        userLimited: '=',
        allowAddToCart: '='
      }
    };
  });
  /*@ngInject*/

  function productRelatedItem(lodash, productConfig, toaster) {
    var vm = this;
    /**
     * Return the name of the Line of this product.
     * @returns {string}
     */

    vm.getLineName = function () {
      var customAttrNameForLine = productConfig.customAttributes.line;

      if (vm.row && vm.row.customFields) {
        var productAttr = lodash.find(vm.row.customFields, {
          code: customAttrNameForLine
        });

        if (productAttr) {
          return productAttr.value;
        }
      }

      return '';
    };
    /**
     * Check if the current product has a Line name.
     * @returns {boolean}
     */


    vm.hasLine = function () {
      return vm.getLineName().length > 0;
    };
    /**
     * Called when this product is added to the active cart.
     */


    vm.onProductAddToCart = function () {
      toaster.success('CART.UPDATE_SUCCESS_MSG');
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productRelatedButtonLauncher
   * @description
   * Show a button to show related products
   */

  productRelatedButtonLauncherController.$inject = ["productRelatedModal", "productsResource", "$q", "toaster", "lodash", "productConfig"];
  module.component('productRelatedButtonLauncher', {
    restrict: 'AE',
    templateUrl: 'app/product/components/productRelatedButtonLauncher.html',
    controller: productRelatedButtonLauncherController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      userLimited: '<'
    }
  });
  /*@ngInclude*/

  function productRelatedButtonLauncherController(productRelatedModal, productsResource, $q, toaster, lodash, productConfig) {
    var vm = this;
    /**
     * @ngdoc
     * @name open
     * @description
     * Show the modal window with related products
     */

    vm.showModal = function () {
      if (vm.hasModel() && vm.model.related !== false) {
        if (vm.hasEnoughData() === false) {
          vm.fetchProductDataFromBackend();
        }

        vm.fetchDataFromBackend(vm.model.related).then(function (rel) {
          var related = {};
          angular.copy(rel, related);
          related.sku = vm.model.sku;
          related.name = vm.model.name;
          /**
           * Return the name of the Brand of this product.
           * @returns {string}
           */

          related.getBrandName = function () {
            if (vm.model && vm.model.customFields) {
              var customAttrNameForBrand = productConfig.customAttributes.brand;
              var productAttr = lodash.find(vm.model.customFields, {
                code: customAttrNameForBrand
              });

              if (productAttr) {
                return productAttr.value;
              }
            }

            return '';
          };
          /**
           * Check if the current product has a Brand name.
           * @returns {boolean}
           */


          related.hasBrand = function () {
            return related.getBrandName().length > 0;
          };
          /**
           * Return the name of the Line of this product.
           * @returns {string}
           */


          related.getLineName = function () {
            var customAttrNameForLine = productConfig.customAttributes.line;

            if (vm.model && vm.model.customFields) {
              var productAttr = lodash.find(vm.model.customFields, {
                code: customAttrNameForLine
              });

              if (productAttr) {
                return productAttr.value;
              }
            }

            return '';
          };
          /**
           * Check if the current product has a Line name.
           * @returns {boolean}
           */


          related.hasLine = function () {
            return related.getLineName().length > 0;
          };

          productRelatedModal.show(related, vm.userLimited);
        });
      }
    };
    /**
     * Request information of the current product to the server
     */


    vm.fetchDataFromBackend = function (relatedProducts) {
      var related = {};
      angular.copy(relatedProducts, related);
      return $q(function (resolve, reject) {
        var products = {
          include: []
        }; // Podobny
        // switch in cart, hide popup. not implemented

        if (related.related.length > 0) {
          products.include = products.include.concat(related.related);
        } //uzupełniający
        // add to cart, not hiding popup


        if (related.upsell.length > 0) {
          products.include = products.include.concat(related.upsell);
        } //alternatywny
        // to discuss with stalgast


        if (related.crossell.length > 0) {
          products.include = products.include.concat(related.crossell);
        }

        productsResource.query(null, products, 1, products.include.length).then(function (results) {
          lodash.forEach(related, function (value, key) {
            if (value !== false) {
              related[key] = value.map(function (item) {
                var productObject = lodash.find(results.rows, function (o) {
                  return o.code === item;
                });

                if (productObject) {
                  return productObject;
                }
              }).filter(function (item) {
                return typeof item !== 'undefined';
              });

              if (!related[key].length) {
                related[key] = false;
              }
            }
          });
          resolve(related);
        }, function (errMsg) {
          toaster.error(errMsg);
          reject();
        });
      });
    };
    /**
     * @ngdoc
     * @name hasModel
     * @description
     * Check if the product information is available.
     * @returns {Boolean}
     */


    vm.hasModel = function () {
      return angular.isDefined(vm.model) && angular.isObject(vm.model);
    };
    /**
     * Check if the current information available for this product is enough for this component.
     * @return {boolean|null} Be aware that if the model is not defined yet it will return NULL, so be sure to
     * do a strict comparison of its result
     */


    vm.hasEnoughData = function () {
      if (angular.isObject(vm.model)) {
        return angular.isDefined(vm.model.customFields);
      }

      return null;
    };
    /**
     * Request information of the current product to the server and install the new properties when the updated
     * data is received.
     */


    vm.fetchProductDataFromBackend = function () {
      return $q(function (resolve, reject) {
        productsResource.get(vm.model.sku).then(function (model) {
          vm.model = model;
          resolve();
        }, function (errMsg) {
          toaster.error(errMsg);
          reject();
        });
      });
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgProductQuickInfoItems
   * @description Show product quick info items.
   */

  /*@ngInject*/

  module.directive('sgProductQuickInfoItems', function () {
    return {
      templateUrl: 'app/product/components/productQuickInfoItems.html',
      controller: sgProductQuickInfoItems,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        model: '<',
        userLimited: '<',
        isItemChosen: '&',
        setOrUpdateChosenItem: '<',
        getChosenItem: '&',
        removeChosenItem: '&',
        updateChosenItemQty: '<'
      }
    };
  });
  /*@ngInject*/

  function sgProductQuickInfoItems() {
    var vm = this;
  }
})(angular.module('app'));
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgProductQuickInfoItem
   * @description Row to represent a product quick info.
   *
   * This is a directive instead of a component because it is used in a TR tag (inside an HTML table).
   */

  /*@ngInject*/

  sgProductQuickInfoItem.$inject = ["$scope", "$timeout", "$translate", "lodash", "productsResource", "domUtils", "collectionUtils", "cartActive", "toaster"];
  module.directive('sgProductQuickInfoItem', ["$timeout", function ($timeout) {
    return {
      templateUrl: 'app/product/components/productQuickInfoItem.html',
      controller: sgProductQuickInfoItem,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        model: '<',
        userLimited: '<',
        isItemChosen: '&',
        setOrUpdateChosenItem: '<',
        getChosenItem: '&?',
        removeChosenItem: '&?',
        updateChosenItemQty: '<?',
        isProduct: '<?',
        position: '<?'
      },
      link: function link(scope, element) {
        /**
         * Focus a specific input field.
         * @param {string} name Name of the field (input param "name")
         * @param {number} [delay] Delay (in ms) the focusing
         */
        scope.vm.focusField = function (name, delay) {
          if (isFinite(delay) && delay > 0) {
            $timeout(function () {
              scope.vm.focusField(name);
            }, delay);
          }
          /* NOTE: This css selector is too complex to be handled by the jqlite of Angular 1.5.
           * This will continue to work only if jQuery library is also used in this project.
           */


          element.find('input[name=' + name + ']:not([readonly])').focus().select();
        }; // Making the element node available to the controller


        scope.vm.element = element;
      }
    };
  }]);
  /*@ngInject*/

  function sgProductQuickInfoItem($scope, $timeout, $translate, lodash, productsResource, domUtils, collectionUtils, cartActive, toaster) {
    var vm = this;
    vm.workCopy = {};
    vm.qtyValid = true;
    vm.qtyIncValid = true;
    /**
     * Scope variable used to check if list of searched products is shown.
     * For more details about this variable see the doc of the function {@link findProduct()}.
     * @type {Promise}
     */

    vm.typeaheadPromise = null;
    /**
     * Translated labels used by the template.
     * This approach is used to reduce the number of scope watchers in the template because this translations
     * are used several times in the same template.
     * @type {object}
     */

    vm.labels = $translate.instant(['CART.NOT_AVAILABLE_HELPTEXT']);
    /**
     * Pixels reserved under the "sku" input field to display the list of found products.
     * @type {number}
     */

    vm.suggestionPxHeightReserved = 140;
    /**
     * @ngdoc method
     * @name setOrUpdateChosenProduct
     * @description This function is called when the user finish to edit the model.
     * It call the external function callback ordering to apply the changes on the real model.
     */

    vm.setOrUpdateChosenProduct = function () {
      if (!vm.qtyValid || !vm.qtyIncValid || !vm.workCopy.sku) {
        return;
      }
      /**
       * Item model object without the custom properties added at runtime by this component.
       * @type {object}
       */


      var preparedItem = lodash.omit(vm.workCopy, ['available', 'stock', 'stockVisible']);
      vm.setOrUpdateChosenItem(preparedItem);
      vm.resetWorkingCopy();

      if (!vm.isProduct) {
        vm.focusField('sku');

        if (vm.typeaheadPromise !== null && typeof vm.typeaheadPromise.$$state.value !== 'undefined' && vm.typeaheadPromise.$$state.value.length > 0) {
          vm.typeaheadPromise = null;
        }
      }
    };
    /**
     * @ngdoc method
     * @name updateDefaultQty
     * @description When sku is selected set default qty, based on qtyIncrements
     */


    vm.updateDefaultQty = function (item) {
      vm.workCopy.qty = item.qtyIncrements;
      vm.workCopy.qtyIncrements = item.qtyIncrements;
    };
    /**
     * @ngdoc method
     * @name resetWorkingCopy
     * @description Synchronize the properties of the working copy model and the real model.
     */


    vm.resetWorkingCopy = function () {
      if (!lodash.isEqual(vm.workCopy, vm.model)) {
        collectionUtils.updateObject(vm.model, vm.workCopy, true);
      }
    };
    /**
     * @ngdoc method
     * @name increaseQty
     * @description Increase qty by qtyIncrements value
     */


    vm.increaseQty = function () {
      if (vm.qtyIncValid) {
        vm.workCopy.qty += vm.workCopy.qtyIncrements;

        if (!vm.isProduct || !vm.isItemChosen()) {
          return;
        }

        vm.updateChosenItemQty(vm.workCopy.qty);
      }
    };
    /**
     * @ngdoc method
     * @name decreaseQty
     * @description Decrease qty by qtyIncrements value
     */


    vm.decreaseQty = function () {
      if (vm.workCopy.qty > vm.workCopy.qtyIncrements && vm.qtyIncValid) {
        vm.workCopy.qty -= vm.workCopy.qtyIncrements;

        if (!vm.isProduct || !vm.isItemChosen()) {
          return;
        }

        vm.updateChosenItemQty(vm.workCopy.qty);
      }
    };
    /**
     * @ngdoc method
     * @name increaseAvaliable
     * @description Check if increase is available
     */


    vm.increaseAvaliable = function () {
      return vm.qtyIncValid;
    };
    /**
     * @ngdoc method
     * @name decreaseAvaliable
     * @description Check if decrease is available
     */


    vm.decreaseAvaliable = function () {
      if (angular.isUndefined(vm.workCopy.qtyIncrements)) {
        return true;
      }

      return vm.qtyIncValid && vm.workCopy.qty > vm.workCopy.qtyIncrements;
    };
    /**
     * @ngdoc method
     * @name itemIsInSale
     * @description Ask if the current item is in sale.
     * @returns {boolean}  TRUE/FALSE
     */


    vm.itemIsInSale = function () {
      if (angular.isNumber(vm.workCopy.promotion_price) && vm.workCopy.promotion_price > 0) {
        return vm.workCopy.promotion_price !== vm.workCopy.price;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name itemExists
     * @description Ask if the item belong to the offer (has already an ID).
     * @returns {boolean} TRUE/FALSE
     */


    vm.itemExists = function () {
      return vm.workCopy.hasOwnProperty('sku') && vm.workCopy.sku !== '';
    };
    /**
     * @ngdoc method
     * @name findProduct
     * @description Make a product search and returns the first 5 products matched.
     * @returns {Promise} Future
     */


    vm.findProduct = function (val) {
      //List of products to include and exclude
      var products = {
        include: [val + '*'],
        //Using Apache Lucene wildcards
        exclude: vm.isItemChosen() ? [vm.getChosenItem().sku] : [],
        filterCatalogPrice: true,
        checkOnly: true
      };
      vm.typeaheadPromise = productsResource.query(null, products, 1, 5).then(function (results) {
        return (results.rows || []).map(function (item) {
          return {
            sku: item.sku,
            label: item.sku + ' - ' + item.name,
            qtyIncrements: item.qtyIncrements
          };
        });
      });
      return vm.typeaheadPromise;
    };
    /**
     * Return the stock quantity that should be visible to the user.
     * @return {number|null} It will return NULL if there's no enough data to calculate a value
     */


    vm.calculateVisibleStock = function () {
      if (angular.isObject(vm.workCopy) && vm.workCopy.hasOwnProperty('sku') && vm.workCopy.hasOwnProperty('stock') && vm.workCopy.qty !== null) {
        return lodash.min([vm.workCopy.qty, vm.workCopy.stock]);
      }

      return 0;
    };
    /**
     * Update the value of the "stockVisible" property of the item.
     */


    vm.updateVisibleStock = function () {
      if (angular.isObject(vm.workCopy)) {
        vm.workCopy.stockVisible = vm.calculateVisibleStock();
      }
    };
    /**
     * Check if the quantity requested of this product is less or equal than the available stock.
     * Note: This function returns FALSE is no stock or quantity value is available.
     * @return {boolean}
     */


    vm.isQtyLessThanStock = function () {
      var stock = vm.workCopy.stockVisible;

      if (isFinite(stock) && isFinite(vm.workCopy.qty)) {
        return stock >= vm.workCopy.qty;
      }

      return false;
    };
    /**
     * Function executed when the row gain focus.
     * It tries to create enough space under the item to show all the product suggestions.
     */


    vm.onFocus = function () {
      if (!domUtils.itemIsVisible(vm.element, vm.suggestionPxHeightReserved)) {
        domUtils.scrollToItem(vm.element, vm.suggestionPxHeightReserved);
      }
    };
    /**
     * Validate qty increments
     * @param qty
     * @param qtyIncrements
     * @return {boolean}
     */


    function validateQtyIncrements(qty, qtyIncrements) {
      return qty % qtyIncrements === 0;
    }
    /**
     * validate qty
     * @param qty
     * @return {boolean}
     */


    function validateQty(qty) {
      return !isNaN(parseInt(qty));
    } // Update working copy each time the model changed


    $scope.$watchCollection('vm.model', vm.resetWorkingCopy); // check if given qty is valid

    $scope.$watch('vm.workCopy.qtyIncrements', function () {
      if (angular.isUndefined(vm.workCopy.qtyIncrements)) {
        vm.qtyIncValid = true;
      } else {
        vm.qtyIncValid = validateQtyIncrements(vm.workCopy.qty, vm.workCopy.qtyIncrements); //Updating the qty increment error

        vm.incrementErrorMsg = $translate.instant('CART.QTY_INCREMENT_ERROR', vm.workCopy);
      }
    }); // check if given qty is valid

    $scope.$watch('vm.workCopy.qty', function () {
      vm.qtyValid = validateQty(vm.workCopy.qty);

      if (!angular.isUndefined(vm.workCopy.qtyIncrements)) {
        vm.qtyIncValid = validateQtyIncrements(vm.workCopy.qty, vm.workCopy.qtyIncrements);
      }
    }); // Recalculate the visible stock every time the qty or stock of the item change

    $scope.$watchGroup(['vm.workCopy.qty', 'vm.workCopy.stock'], vm.updateVisibleStock); // If the directive is created without a model, use an empty object

    if (angular.isUndefined(vm.model)) {
      vm.model = {
        sku: '',
        qty: 1,
        qtyIncrements: 1,
        discount: 0,
        reseller_price: 0
      };
    }
  }
})(angular.module('app'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgProductQuickInfoEditor
   * @module app
   * @description This component shows the product quick info view.
   */

  sgProductQuickInfoEditor.$inject = ["$scope", "lodash", "productsResource", "toaster"];
  module.component('sgProductQuickInfoEditor', {
    templateUrl: 'app/product/components/productQuickInfoEditor.html',
    controller: sgProductQuickInfoEditor,
    controllerAs: 'vm',
    bindings: {
      model: '<',
      userLimited: '<'
    }
  });
  /*@ngInject*/

  function sgProductQuickInfoEditor($scope, lodash, productsResource, toaster) {
    var vm = this;
    /**
     * @ngdoc method
     * @name updateStocks
     * @description Update stock in product quick info
     */

    vm.updateStocks = function () {
      if (vm.isItemChosen()) {
        return productsResource.requestStockUpdate(vm.model.sku).then(function () {
          /**
           * Item model object without the custom properties added at runtime by this component.
           * @type {object}
           */
          var currentItem = {
            sku: vm.model.sku,
            qty: vm.model.qty
          };
          vm.setOrUpdateChosenItem(currentItem);
          toaster.success('CART.STOCKS_UPDATED');
        });
      } else {
        toaster.error('PRODUCT.SELECT_PRODUCT_FIRST_MSG');
      }
    };
    /**
     * @ngdoc method
     * @name setOrUpdateChosenItem
     * @description Set or update chosen product.
     * @param {object} item
     */


    vm.setOrUpdateChosenItem = function (item) {
      productsResource.get(item.sku).then(function (model) {
        if (lodash.isEmpty(model)) {
          toaster.error('PRODUCT.PRODUCT_DOESNT_EXIST_MSG');
        } else {
          vm.model = model;

          if (item.hasOwnProperty('qty')) {
            vm.model.qty = item.qty;
          }
        }
      }, function (errMsg) {
        toaster.error(errMsg);
      });
    };
    /**
     * @ngdoc method
     * @name getChosenItem
     * @description Return chosen product.
     * @returns {object}
     */


    vm.getChosenItem = function () {
      return vm.model;
    };
    /**
     * @ngdoc method
     * @name isItemChosen
     * @description Return if a product is chosen.
     * @returns {boolean}
     */


    vm.isItemChosen = function () {
      return vm.model.hasOwnProperty('id') && vm.model.id !== '';
    };
    /**
     * @ngdoc method
     * @name removeChosenItem
     * @description Remove chosen product from the view.
     * @returns {boolean}
     */


    vm.removeChosenItem = function () {
      vm.model = {};
    };
    /**
     * @ngdoc method
     * @name updateChosenItemQty
     * @description Update quantity of chosen product.
     */


    vm.updateChosenItemQty = function (qty) {
      if (vm.isItemChosen()) {
        vm.model.qty = qty;
      }
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productQuickInfoButtonLauncher
   * @description Show a button to access product quick info view.
   */

  productQuickInfoButtonLauncherController.$inject = ["$scope", "$state", "$translate"];
  module.component('productQuickInfoButtonLauncher', {
    templateUrl: 'app/product/components/productQuickInfoButtonLauncher.html',
    controller: productQuickInfoButtonLauncherController,
    controllerAs: 'vm'
  });
  /*@ngInclude*/

  function productQuickInfoButtonLauncherController($scope, $state, $translate) {
    var vm = this;
    vm.labelKey = 'PRODUCT.QUICK_INFO';
    /**
     * Initiate the component.
     */

    vm.$onInit = function () {
      $translate(vm.labelKey).then(function (label) {
        vm.label = label;
      });
    };
    /**
     * Function executed after the user presses over the component.
     */


    vm.onPress = function () {
      $state.go('product.quickInfo');
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productPageRelatedItem
   * @description
   * Show the information of a product as a row in a table - products related
   */

  productPageRelatedItem.$inject = ["lodash", "productConfig", "toaster", "$q", "productsResource"];
  module.directive('productPageRelatedItem', function () {
    return {
      restrict: 'AE',
      templateUrl: 'app/product/components/productRelatedItem.html',
      controller: productPageRelatedItem,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        row: '<data',
        allowAddToCart: '='
      }
    };
  });
  /*@ngInject*/

  function productPageRelatedItem(lodash, productConfig, toaster, $q, productsResource) {
    var vm = this;

    vm.fetchDataFromBackend = function () {
      return $q(function (resolve, reject) {
        productsResource.get(vm.row).then(function (model) {
          console.log(model);
          vm.row = model;
          resolve();
        }, function (errMsg) {
          toaster.error(errMsg);
          reject();
        });
      });
    };

    vm.fetchDataFromBackend();
    /**
     * Return the name of the Line of this product.
     * @returns {string}
     */

    vm.getLineName = function () {
      var customAttrNameForLine = productConfig.customAttributes.line;

      if (vm.row && vm.row.customFields) {
        var productAttr = lodash.find(vm.row.customFields, {
          code: customAttrNameForLine
        });

        if (productAttr) {
          return productAttr.value;
        }
      }

      return '';
    };
    /**
     * Check if the current product has a Line name.
     * @returns {boolean}
     */


    vm.hasLine = function () {
      return vm.getLineName().length > 0;
    };
    /**
     * Called when this product is added to the active cart.
     */


    vm.onProductAddToCart = function () {
      toaster.success('CART.UPDATE_SUCCESS_MSG');
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productItem
   * @description
   * Show the information of a product as a row in a table.
   * @author daniel.zegarra@orba.co
   */

  productItem.$inject = ["lodash", "productConfig", "toaster"];
  module.directive('productItem', function () {
    return {
      restrict: 'AE',
      templateUrl: 'app/product/components/productItem.html',
      controller: productItem,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        row: '<data',
        userLimited: '='
      }
    };
  });
  /*@ngInject*/

  function productItem(lodash, productConfig, toaster) {
    var vm = this;
    var LOYALTY_ICON_URL = '/img/stalgast_profit.svg';
    var LOYALTY_ATTRIBUTE_CODE = 'loyalty_program_varchar';
    /**
     * Return the name of the Line of this product.
     * @returns {string}
     */

    vm.getLineName = function () {
      var customAttrNameForLine = productConfig.customAttributes.line;

      if (vm.row && vm.row.customFields) {
        var productAttr = lodash.find(vm.row.customFields, {
          code: customAttrNameForLine
        });

        if (productAttr) {
          return productAttr.value;
        }
      }

      return '';
    };
    /**
     * Check if the current product has a Line name.
     * @returns {boolean}
     */


    vm.hasLine = function () {
      return vm.getLineName().length > 0;
    };

    vm.getLoyaltyIconUrl = function () {
      return LOYALTY_ICON_URL;
    };
    /**
     * @returns {boolean}
     */


    vm.loyaltyProgramEnabled = function () {
      if (vm.row && vm.row.customFields) {
        var productAttr = lodash.find(vm.row.customFields, {
          code: LOYALTY_ATTRIBUTE_CODE
        });

        if (productAttr !== undefined) {
          switch (productAttr.value) {
            case 'Tak':
              return true;

            case 'Nie':
            default:
              return false;
          }
        }
      }

      return false;
    };
    /**
     * Called when this product is added to the active cart.
     */


    vm.onProductAddToCart = function () {
      toaster.success('CART.UPDATE_SUCCESS_MSG');
    };
    /**
     * Return the name of the Brand of this product.
     * @returns {string}
     */


    vm.getBrandName = function () {
      if (vm.row && vm.row.customFields) {
        var customAttrNameForBrand = productConfig.customAttributes.brand;
        var productAttr = lodash.find(vm.row.customFields, {
          code: customAttrNameForBrand
        });

        if (productAttr) {
          return productAttr.value;
        }
      }

      return '';
    };
    /**
     * Check if the current product has a Brand name.
     * @returns {boolean}
     */


    vm.hasBrand = function () {
      return vm.getBrandName().length > 0;
    };
  }
})(angular.module('app'));
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productInfoSummary
   * @description
   * Show a
   * @author daniel.zegarra@orba.co
   */

  productInfoSummary.$inject = ["toaster", "productConfig", "lodash", "attributesService", "$filter", "cardFileService", "$q", "productsResource", "$scope"];
  module.component('productInfoSummary', {
    restrict: 'AE',
    templateUrl: 'app/product/components/productInfoSummary.html',
    controller: productInfoSummary,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',

      /**
       * Allow user add this product to the active cart.
       * FALSE by default.
       * @type {boolean}
       */
      allowAddToCart: '<?',
      onGoToCartList: '&'
    }
  });
  /*@ngInclude*/

  function productInfoSummary(toaster, productConfig, lodash, attributesService, $filter, cardFileService, $q, productsResource, $scope) {
    var vm = this;
    vm.customAttrNameForLine = productConfig.customAttributes.line;
    attributesService.get().$promise.then(function (attr) {
      vm.model.customFields = lodash.filter(vm.model.customFields, function (item) {
        if (attr.hasOwnProperty(item.code)) {
          item.label = $filter('translateProductAttrName')(item.code);

          if (attr[item.code].type === 'boolean') {
            item.value = item.value ? $filter('translate')('GLOBAL.YES') : $filter('translate')('GLOBAL.NO');
          }

          return item;
        }
      });
    });
    /*
    * LEGEND
    * - price_catalog Price of list
    * - price_special Price if the product is in sale
    * - price_reseller Price for an specific reseller
    * - price_discount Discount of the reseller price against the catalog price of the special price (if exist)
    */

    /**
     * Check if the current product has at least one attribute to show.
     * @return {boolean}
     */

    vm.hasAttributes = function () {
      if (angular.isObject(vm.model)) {
        if (vm.hasLine()) {
          return angular.isArray(vm.model.customFields) && vm.model.customFields.length > 1;
        } else {
          return angular.isArray(vm.model.customFields) && vm.model.customFields.length;
        }
      }

      return false;
    };
    /**
     * Check if the current product is in sale.
     * @return {boolean}
     */


    vm.hasPromoPrice = function () {
      if (angular.isObject(vm.model)) {
        return vm.model.price_special > 0 && vm.model.price_catalog !== vm.model.price_special;
      }

      return false;
    };
    /**
     * Returns the discount percentage of the promotion price against the list price.
     * @return {number} Value between 0-100
     */


    vm.getPromoDiscount = function () {
      if (vm.hasPromoPrice()) {
        return Math.round((vm.model.price_catalog - vm.model.price_special) / vm.model.price_catalog * 100);
      }

      return 0;
    };
    /**
     * Check if the price for this reseller has a discount.
     * @return {boolean}
     */


    vm.hasResellerDiscount = function () {
      if (angular.isObject(vm.model)) {
        return vm.model.price_discount > 0;
      }

      return false;
    };
    /**
     * Check if the current product has stock available.
     * @return {boolean}
     */


    vm.isAvailable = function () {
      if (angular.isObject(vm.model)) {
        return vm.model.stock > 0;
      }

      return false;
    };
    /**
     * Return the name of the Line of this product.
     * @returns {string}
     */


    vm.getLineName = function () {
      if (vm.model && vm.model.customFields) {
        var productAttr = lodash.find(vm.model.customFields, {
          code: vm.customAttrNameForLine
        });

        if (productAttr) {
          return productAttr.value;
        }
      }

      return '';
    };
    /**
     * Check if the current product has a Line name.
     * @returns {boolean}
     */


    vm.hasLine = function () {
      return vm.getLineName().length > 0;
    };
    /**
     * Called when this product is added to the active cart.
     */


    vm.onProductAddToCart = function () {
      toaster.success('CART.UPDATE_SUCCESS_MSG');
    };

    vm.getProduct = function (sku) {
      return $q(function (resolve, reject) {
        productsResource.get(sku).then(function (model) {
          resolve(model.name != null);
        }, function (errMsg) {
          reject();
        });
      });
    };

    vm.getUpsellProducts = function () {
      var _this = this;

      if (!$scope.itemsProcessed) {
        $scope.itemsProcessed = true;

        var temporaryArray = _toConsumableArray(this.model.related.upsell);

        var i = 0;
        temporaryArray.forEach(function (item, currentIndex) {
          _this.getProduct(item).then(function (result) {
            if (result === false) {
              _this.model.related.upsell.splice(currentIndex - i, 1);

              i++;
            }
          }).then(function () {
            if (currentIndex === _this.model.related.upsell.length) {
              return _this.model.related.upsell;
            }
          });
        });
      } else {
        return this.model.related.upsell;
      }
    };
    /**
     * Initiate the component.
     * Automatically during the component's initiation process.
     */


    vm.$onInit = function () {
      vm.allowAddToCart = angular.isDefined(vm.allowAddToCart) ? vm.allowAddToCart : false;
      $scope.items = [];
      $scope.itemsProcessed = false;
      $scope.currentIndex = 0;

      $scope.changeImage = function (delta) {
        $scope.currentIndex += delta;

        if ($scope.currentIndex < 0) {
          $scope.currentIndex = vm.model.productPicturesUrls.length - 1;
        } else if ($scope.currentIndex >= vm.model.productPicturesUrls.length) {
          $scope.currentIndex = 0;
        }
      };
    };
    /**
     * Download product's card.
     */


    vm.downloadCard = function () {
      cardFileService.downloadSingleCard(vm.model.sku);
    };
    /**
     * Return the name of the Brand of this product.
     * @returns {string}
     */


    vm.getBrandName = function () {
      if (vm.model && vm.model.customFields) {
        var customAttrNameForBrand = productConfig.customAttributes.brand;
        var productAttr = lodash.find(vm.model.customFields, {
          code: customAttrNameForBrand
        });

        if (productAttr) {
          return productAttr.value;
        }
      }

      return '';
    };
    /**
     * Check if the current product has a Brand name.
     * @returns {boolean}
     */


    vm.hasBrand = function () {
      return vm.getBrandName().length > 0;
    };

    vm.fetchDataFromBackend = function (sku) {
      var check = false;
      var promise = this.getProduct(sku);
      promise.then(function (result) {
        return result;
      }, function () {
        return false;
      }, function () {
        return false;
      });
    };

    vm.checkImage = function (tab) {
      if (tab === 'related') {
        $('.product-picture').hide();
        $('.product-info').removeClass('col-xs-8').addClass('col-xs-12');
      } else {
        $('.product-picture').show();
        $('.product-info').removeClass('col-xs-12').addClass('col-xs-8');
      }
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productInfoDelivery
   * @description
   * Show delivery information if need
   * @author tomasz.sledziewski@orba.co
   */

  productInfoDelivery.$inject = ["$translate"];
  module.component('productInfoDelivery', {
    restrict: 'AE',
    templateUrl: 'app/product/components/productInfoDelivery.html',
    controller: productInfoDelivery,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<'
    }
  });
  /*@ngInclude*/

  function productInfoDelivery($translate) {
    var vm = this;

    vm.label = function () {
      if (vm.model.salesLogistics === "magazynowany") {
        var data = new Date(vm.model.dataTime);
        return $translate.instant('CART.DELIVERY_DATE') + ' ' + data.toLocaleDateString();
      } else {
        var daysTrans = vm.model.leadTime === 1 ? $translate.instant('GLOBAL.DAY') : $translate.instant('GLOBAL.DAYS');
        return $translate.instant('CART.DELIVERY_ORDER') + ' ' + vm.model.leadTime + " " + daysTrans + ".";
      }
    };
    /**
     * Have date
     */


    vm.haveModel = function () {
      return angular.isObject(vm.model);
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productInfoButtonLauncher
   * @description
   * Show a button to show the product information when the user press on it.
   * @author daniel.zegarra@orba.co
   */

  productInfoButtonLauncherController.$inject = ["$translate", "productInfoModalLauncher", "productsResource", "$q"];
  module.component('productInfoButtonLauncher', {
    restrict: 'AE',
    templateUrl: 'app/product/components/productInfoButtonLauncher.html',
    controller: productInfoButtonLauncherController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      tooltipDelay: '<?',
      tooltipPos: '<?',

      /**
       * Allow user add this product to the active cart.
       * FALSE by default.
       * @type {boolean}
       */
      allowAddToCart: '<?'
    }
  });
  /*@ngInclude*/

  function productInfoButtonLauncherController($translate, productInfoModalLauncher, productsResource, $q) {
    var vm = this;
    vm.labelKey = 'PRODUCT.VIEW_INFO_TOOLTIP';
    vm.tooltipDelay = vm.tooltipDelay || 1000;
    vm.tooltipPos = vm.tooltipPos || 'bottom';
    /**
     * @ngdoc
     * @name open
     * @description
     * Show the modal window with information of the product.
     */

    vm.showModal = function () {
      if (vm.haveModel()) {
        if (vm.hasEnoughData() === false) {
          vm.fetchingDataPromise = vm.fetchDataFromBackend();
        } else {
          vm.fetchingDataPromise = $q.resolve();
        }

        vm.fetchingDataPromise.then(function () {
          productInfoModalLauncher.show(vm.model, vm.allowAddToCart);
        });
      }
    };
    /**
     * Request information of the current product to the server and install the new properties when the updated
     * data is received.
     */


    vm.fetchDataFromBackend = function () {
      return $q(function (resolve, reject) {
        productsResource.get(vm.model.sku).then(function (model) {
          vm.model = model;
          resolve();
        }, function (errMsg) {
          toaster.error(errMsg);
          reject();
        });
      });
    };
    /**
     * Check if the current information available for this product is enough for this component.
     * @return {boolean|null} Be aware that if the model is not defined yet it will return NULL, so be sure to
     * do a strict comparison of its result
     */


    vm.hasEnoughData = function () {
      if (angular.isObject(vm.model)) {
        return angular.isDefined(vm.model.customFields);
      }

      return null;
    };
    /**
     * @ngdoc
     * @name haveModel
     * @description
     * Check if the product information is available.
     * @returns {Boolean}
     */


    vm.haveModel = function () {
      return angular.isDefined(vm.model) && angular.isObject(vm.model);
    };
    /**
     * Initiate the component.
     */


    vm.$onInit = function () {
      vm.allowAddToCart = angular.isDefined(vm.allowAddToCart) ? vm.allowAddToCart : false;
      $translate(vm.labelKey).then(function (label) {
        vm.label = label;
      });
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productFilterPrice
   * @description
   * Show filter for price
   */

  productFilterPriceController.$inject = ["$scope"];
  module.component('productFilterPrice', {
    restrict: 'E',
    templateUrl: 'app/product/components/productFilterPrice.html',
    controller: productFilterPriceController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      filters: '&'
    }
  });
  /*@ngInclude*/

  function productFilterPriceController($scope) {
    var vm = this;
    vm.valueFrom = 0;
    vm.valueTo = 0;
    vm.validFrom = true;
    vm.validTo = true;
    vm.validNumberFrom = true;
    vm.validNumberTo = true;
    vm.valid = true;

    this.$onChanges = function () {
      setValuesFromScope();
    };
    /**
     * set value from model to local variable
     */


    function setValuesFromScope() {
      vm.valueFrom = vm.model.values[0];
      vm.valueTo = vm.model.values[1];
    }
    /**
     * clear values
     * */


    function clearValuesInScope() {
      vm.model.values[0] = null;
      vm.model.values[1] = null;
    }
    /**
     *  Clear filter
     */


    vm.clearFilter = function () {
      clearValuesInScope();
      vm.filters({});
    };
    /**
     * Apply filter
     */


    vm.applyFilter = function () {
      if (vm.valid) {
        vm.filters({});
      }
    };
    /**
     * watch change in price from/to
     */


    $scope.$watchGroup(['vm.valueFrom', 'vm.valueTo'], function () {
      var valueFrom = null;
      var valueTo = null;
      vm.validNumberFrom = true;
      vm.validNumberTo = true;

      if (!angular.isUndefined(vm.valueFrom) && vm.valueFrom !== null) {
        valueFrom = convertTuNumber(vm.valueFrom);

        if (valueFrom !== null) {
          vm.validNumberFrom = isFinite(valueFrom) && valueFrom >= 0;
        }
      }

      if (!angular.isUndefined(vm.valueTo) && vm.valueTo !== null) {
        valueTo = convertTuNumber(vm.valueTo);

        if (valueTo !== null) {
          vm.validNumberTo = isFinite(valueTo) && valueTo >= 0;
        }
      }

      if (angular.isNumber(valueFrom) && angular.isNumber(valueTo) && vm.validNumberFrom && vm.validNumberTo) {
        vm.validTo = valueFrom <= valueTo;
      } else {
        vm.validTo = true;
      }

      vm.valid = vm.validFrom && vm.validTo && vm.validNumberFrom && vm.validNumberTo;

      if (vm.valid) {
        vm.model.values[0] = valueFrom;
        vm.model.values[1] = valueTo;
      } else {
        clearValuesInScope();
      }
    });
    /**
     * Convert string to number
     *
     * @param {string|number} value
     * @return {*}
     */

    function convertTuNumber(value) {
      if (value === "") {
        return null;
      } else if (angular.isNumber(value)) {
        return value;
      } else {
        return Number(value.replace(",", "."));
      }
    }
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productFilterCategory
   * @description
   * Show a button to show related products
   */

  productFilterDefaultController.$inject = ["lodash"];
  module.component('productFilterDefault', {
    restrict: 'E',
    templateUrl: 'app/product/components/productFilterDefault.html',
    controller: productFilterDefaultController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      filters: '&'
    }
  });
  /*@ngInclude*/

  function productFilterDefaultController(lodash) {
    var vm = this;
    /**
     * How many of items to show
     *
     * @type {number}
     */

    var showMoreItems = 5;
    vm.showAllItems = false;
    vm.haveMoreItems = haveMoreItems();
    vm.limitTo = showMoreItems;
    /**
     * How many items matches
     *
     * @return {*}
     */

    function countMatchesItems() {
      return lodash.reduce(vm.model.values, function (result, value) {
        if (value !== null && value !== undefined) {
          if (value.matches) result++;
        }

        return result;
      }, 0);
    }
    /**
     * Have more items?
     *
     * @return {boolean}
     */


    function haveMoreItems() {
      return countMatchesItems() > showMoreItems;
    }
    /**
     * Toggle more items
     */


    vm.clickMoreItems = function () {
      vm.limitTo = 5000;
      vm.showAllItems = true;
    };
    /**
     * Toggle more items
     */


    vm.clickLessItems = function () {
      vm.limitTo = showMoreItems;
      vm.showAllItems = false;
    };
    /**
     *  Clear filter
     */


    vm.clearFilter = function () {
      vm.model.values.forEach(function (item) {
        item.selected = false;
      });
      vm.filters({});
    };
    /**
     * Apply filter
     */


    vm.applyFilter = function () {
      vm.filters({});
    };

    vm.removeItem = function (item) {
      item.selected = false;
      vm.filters({});
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productFilterCategory
   * @description
   * Container for filters and control when show filters
   */

  productFilterContainerController.$inject = ["$scope", "lodash", "$state", "filterConfig"];
  module.component('productFilterContainer', {
    restrict: 'E',
    templateUrl: 'app/product/components/productFilterContainer.html',
    controller: productFilterContainerController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      filters: '&',
      rowsInResult: '<'
    }
  });
  /*@ngInclude*/

  function productFilterContainerController($scope, lodash, $state, filterConfig) {
    var vm = this;
    vm.selectedFilters = [];
    vm.countActiveFilter = 0;
    /**
     * Run after initialization
     */

    vm.$onInit = function () {
      vm.countActiveFilter = _countActiveFilter();
    };
    /**
     * If something changes
     */


    $scope.$watch('vm.model', function () {
      vm.countActiveFilter = _countActiveFilter();
    });
    /**
     * Show filters when one is active or there are products to show
     *
     * @return {boolean}
     */

    vm.showFilters = function () {
      return vm.rowsInResult.length > 0 || vm.countActiveFilter > 0;
    };
    /**
     * Count active filter
     *
     * @return {number}
     * @private
     */


    function _countActiveFilter() {
      return lodash.reduce(vm.model, function (sum, filter) {
        if (filter.originSelected) {
          sum++;
        }

        return sum;
      }, 0);
    }
    /**
     * Get active filter
     */


    vm.getActiveFilter = function () {
      var selectedFilters = {}; // vm.model is array

      vm.model.forEach(function (filter) {
        var result;

        switch (filter.code) {
          case 'price_decimal':
            result = vm._preparePriceFilter(filter);
            break;

          default:
            result = vm._prepareListFilter(filter);
        }

        if (result !== false) {
          selectedFilters[filter.code] = result;
        }
      });
      return selectedFilters;
    };
    /**
     * Prepare filters typ list for request
     *
     * @param filter
     * @return {*}
     * @private
     */


    vm._prepareListFilter = function (filter) {
      var _filterItems = lodash.filter(filter.values, function (item) {
        return item.selected;
      });

      _filterItems = lodash.map(_filterItems, function (item) {
        return item.name;
      });

      if (_filterItems.length > 0) {
        return _filterItems;
      } else {
        return false;
      }
    };
    /**
     * Prepare filters typ price for request
     *
     * @param filter
     * @return {[*,*]}
     * @private
     */


    vm._preparePriceFilter = function (filter) {
      return [filter.values[0], filter.values[1]];
    };
    /**
     * Handle for event button Remove all filters
     */


    vm.removeAllFilter = function () {
      vm.filters({
        arg: {}
      });
    };
    /**
     * Apply filter
     */


    vm.applyFilter = function () {
      vm.filters({
        arg: vm.getActiveFilter()
      });
    };
    /**
     * Need show buttons
     */


    vm.filterButtons = function () {
      var show = false;

      if (filterConfig.showButtonsAfterAllFilters) {
        var filters = JSON.parse($state.params.filter);

        if (filters !== null && !angular.equals({}, filters)) {
          show = true;
        }
      }

      return show;
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productFilterCategory
   * @description
   * Show a button to show related products
   */

  module.component('productFilterCategory', {
    restrict: 'E',
    templateUrl: 'app/product/components/productFilterCategory.html',
    controller: productFilterCategoryController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '=',
      category: '&'
    }
  });
  /*@ngInclude*/

  function productFilterCategoryController() {
    var vm = this;

    vm.goTo = function (category_id) {
      vm.category({
        arg: category_id
      });
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:productFilterCategory
   * @description
   * Component shows active filters
   * It can show active filters as a tag cloud or a list of active filters
   */

  productFilterActiveController.$inject = ["filterConfig"];
  module.component('productFilterActive', {
    restrict: 'E',
    templateUrl: 'app/product/components/productFilterActive.html',
    controller: productFilterActiveController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      filters: '&',
      parentApplyFilter: '&'
    }
  });

  function productFilterActiveController(filterConfig) {
    /*const*/
    var FILTER_PRICE_CODE = 'price_decimal';
    var vm = this;
    vm._activeFilter = [];
    vm._activeItemsFilters = [];

    this.$onChanges = function () {
      prepareData();
    };
    /**
     * Show tags or list filter?
     *
     * @return {boolean}
     */


    vm.showTags = function () {
      return filterConfig.activeFilter.showTags;
    };
    /**
     * Selected any filter ?
     *
     * @return {boolean}
     */


    vm.selectedAnyFilter = function () {
      return vm._activeFilter.length > 0;
    };
    /**
     * Prepare data
     * Search and save active filters and their active items
     */


    function prepareData() {
      vm._activeFilter = [];
      vm._activeItemsFilters = [];
      vm.model.forEach(function (filter) {
        if (filter.originSelected || filter.selected) {
          vm._activeFilter.push(filter);
        }

        switch (filter.code) {
          case FILTER_PRICE_CODE:
            prepareDataFromPriceFilter(filter);
            break;

          default:
            prepareDataFromDefaultFilter(filter);
        }
      });
    }
    /**
     * Prepare data from price filter
     *
     * @param {Object} filter
     */


    function prepareDataFromPriceFilter(filter) {
      filter.values.every(function (value) {
        if (value !== null && value !== undefined && value !== "null") {
          vm._activeItemsFilters.push(filter);

          return false;
        }

        return true;
      });
    }
    /**
     * Prepare data from default filter
     *
     * @param {Object} filter
     */


    function prepareDataFromDefaultFilter(filter) {
      filter.values.forEach(function (item) {
        if (item.selected) {
          /** for tooltip */
          item.filterName = angular.copy(filter.label);

          vm._activeItemsFilters.push(item);
        }
      });
    }
    /**
     * Remove tags
     *
     * The method deselects the value of the filter and forces the reload product list
     *
     * @param {Object} tag
     */


    vm.removeTags = function (tag) {
      if (tag.code === FILTER_PRICE_CODE) {
        tag.values = [null, null];
      }

      tag.selected = false;
      vm.parentApplyFilter({});
    };
    /**
     * Clear all filters
     */


    vm.clearFilter = function () {
      vm.filters({
        arg: {}
      });
    };
    /**
     * When we have list mode (not tags)
     * Update filters (previously the user has to uncheck which they do not want) and their items
     * Next send information to parent component, to needed update filters and product list
     */


    vm.applyFilter = function () {
      vm.model.forEach(function (filter) {
        if (filter.selected === false) {
          switch (filter.code) {
            case FILTER_PRICE_CODE:
              filter.values = [null, null];
              break;

            default:
              filter.values.forEach(function (item) {
                item.selected = false;
              });
          }
        }
      });
      vm.parentApplyFilter({});
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name productInfoButtonLauncher
   * @description
   * Show a button to show the product information when the user press on it.
   * @author daniel.zegarra@orba.co
   */

  module.component('productAvailabilityIcon', {
    templateUrl: 'app/product/components/productAvailabilityIcon.html',
    controller: productAvailabilityIconController,
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      showLabel: '<?',
      showTooltip: '<?',
      tooltipPos: '@?'
    }
  });
  /*@ngInclude*/

  function productAvailabilityIconController() {
    var vm = this;
    vm.tooltipPos = vm.tooltipPos || 'top'; //By default the label is shown

    if (angular.isUndefined(vm.showLabel)) {
      vm.showLabel = true;
    } //By default the tooltip is no used


    if (angular.isUndefined(vm.showTooltip)) {
      vm.showTooltip = false;
    }
    /**
     * @ngdoc method
     * @name getStatus
     * @description
     * Returns "available", "onorder", "unavailable" or "disabled" depending of the availability of the product.
     * @returns {string} available|onorder|unavailable|disabled
     */


    vm.getStatus = function () {
      if (angular.isDefined(vm.model) && angular.isObject(vm.model)) {
        if (vm.model.available == 'available') {
          return 'available';
        }

        if (vm.model.available == 'unavailable') {
          return 'unavailable';
        }

        if (vm.model.available == 'onorder') {
          return 'onorder';
        }

        return 'unavailable';
      }

      return 'disabled';
    };
  }
})(angular.module('app'));
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc service
   * @name paymentsResource
   * @description
   * This service use the backend API to manage payments.
   *
   * It use response transformations to rectify the data returned by the server.
   * Check the {@link https://docs.angularjs.org/api/ngResource/service/$resource $resource docs} for
   * more information.
   */

  paymentsResource.$inject = ["$resource", "$http", "$q", "moment", "paymentConfig", "resourceQueryPaginator"];
  module.factory('paymentsResource', paymentsResource);
  /*@ngInject*/

  function paymentsResource($resource, $http, $q, moment, paymentConfig, resourceQueryPaginator) {
    var resource,
        paginator = resourceQueryPaginator(),
        idField = 'payment_number';
    /**
     * Stacks of transform functions to parse the server responses.
     *
     * @see https://docs.angularjs.org/api/ng/service/$http#default-transformations
     * @type {{forMulti: function[], forSingle: function[]}}
     */

    var transformStack = {
      forMulti: $http.defaults.transformResponse.concat(transformMulti),
      forSingle: $http.defaults.transformResponse.concat(transformSingle)
    };
    /**
     * Returns an object with the type properties of the model corrected.
     * @param {object} srcItem
     * @returns {object} Returns an object with the properties types corrected
     */

    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.amount = parseFloat(item.amount);
      item.payment_date = moment(item.payment_date).toDate();
      return item;
    };
    /**
     * Transform the response of a single element.
     * @param {object} data
     * @returns {object}
     */


    function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.payment || data) : data;
    }
    /**
     * Transform the response of a array of several elements.
     * @param {object} data
     * @returns {object}
     */


    function transformMulti(data) {
      return angular.isObject(data) ? (data.payments || data).map(transformItem) : data;
    }
    /**
     * Resource for payment management.
     * Note: This instance will be returned by this service.
     */


    resource = $resource(paymentConfig.restful.payments, {
      id: '@' + idField
    }, {
      //List of invoices
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo(transformStack.forMulti)
      }
    }); //Applying the pagination support to the "query" method

    paginator.applyToResource(resource, 'query');
    /**
     * Returns the ID of the current model.
     * @return {number}
     */

    resource.prototype.getId = function () {
      return this[idField];
    };
    /**
     * @ngdoc method
     * @name isPhantom
     * @description
     * Returns TRUE if the element doesn't have an ID.
     * @returns {boolean}
     */


    resource.prototype.isPhantom = function () {
      return !(this.hasOwnProperty(idField) || this[idField] === null);
    };

    return resource;
  }
})(angular.module('app'), angular);
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc controller
   * @name sgPaymentsListFilters
   * @description
   * Input filters for payments list.
   */

  sgPaymentsListFilters.$inject = ["$scope", "lodash"];
  module.component('sgPaymentsListFilters', {
    templateUrl: 'app/payment/components/sgPaymentsListFilters.html',
    controller: sgPaymentsListFilters,
    controllerAs: 'vm',
    bindings: {
      originalFilters: '=filters'
    }
  });
  /*@ngInject*/

  function sgPaymentsListFilters($scope, lodash) {
    var vm = this;

    vm.$onInit = function () {
      vm.filters = {}; //If the real filters change, update the working filters

      $scope.$watch('vm.originalFilters', function (originalFilters) {
        vm.filters = angular.copy(originalFilters || {});
      });
    };
    /**
     * Apply the changes on the inputs over the real filters.
     */


    vm.applyChanges = function () {
      vm.originalFilters = getFilters();
    };
    /**
     * Checks if are pending changes in the filters to apply.
     * @returns {boolean}
     */


    vm.pendingChanges = function () {
      return !angular.equals(getFilters(), vm.originalFilters || {});
    };
    /**
     * Clear all the active filters.
     */


    vm.clearFilters = function () {
      vm.originalFilters = {};
    };
    /**
     * Check if there any filter currently active.
     * @return {boolean}
     */


    vm.filtersAreClear = function () {
      return angular.equals(getFilters() || {}, {});
    };
    /**
     * Return the filters.
     * @return {Object}
     */


    function getFilters() {
      return lodash.pickBy(vm.filters, function (value) {
        return angular.isString(value) ? !!value : true;
      });
    }
  }
})(angular.module('app'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgPaymentsList
   * @module app
   * @description
   * Show a list of payments with a button to download the results as CSV.
   */

  sgPaymentsList.$inject = ["$scope", "$translate", "paginationManager", "paymentsResource", "paymentConfig", "dateFilter"];
  module.component('sgPaymentsList', {
    templateUrl: 'app/payment/components/sgPaymentsList.html',
    controllerAs: 'vm',
    controller: sgPaymentsList,
    bindings: {
      filters: '<?'
    }
  });
  /*@ngInject*/

  function sgPaymentsList($scope, $translate, paginationManager, paymentsResource, paymentConfig, dateFilter) {
    var vm = this;
    /**
     * Configuration for the CSV export library.
     * @type {{filename: string, fields: string[], headers: string[]}}
     */

    vm.csvConfig = {
      filename: $translate.instant('PAYMENT.PAYMENTS') + '.csv',
      fields: ['attachment', 'name', 'amount', 'currency', 'payment_date'],
      headers: [$translate.instant('PAYMENT.ATTACHMENT'), $translate.instant('PAYMENT.NAME'), $translate.instant('PAYMENT.AMOUNT'), $translate.instant('GLOBAL.CURRENCY'), $translate.instant('PAYMENT.PAYMENT_DATE')],

      /**
       * Convert the search results in a collection with values more easy to print as CSV.
       * @return {function}
       */
      getData: function getData() {
        return $scope.paginator.rows.map(function (payment) {
          return {
            attachment: payment.attachment,
            name: payment.name,
            amount: payment.amount,
            currency: payment.currency,
            payment_date: dateFilter(payment.payment_date)
          };
        });
      }
    };

    vm.$onInit = function () {
      vm.errorMsg = ''; //Obtaining the list of payments

      $scope.limitValues = [5, 10, 15, 20, 50, 100, 200];
      $scope.paginator = paginationManager($scope, 'payment', paymentsResource.query, clearErrorMsg, showErrorMsg);
      $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : paymentConfig.list.pageSize;
      $scope.paginator.page = 1; //Maintaining the filters in sync

      $scope.$watchCollection('vm.filters', function (filters) {
        $scope.paginator.filters = filters;
      });
    };
    /**
     * Clear the error message.
     */


    function clearErrorMsg() {
      vm.errorMsg = '';
    }
    /**
     * Show an error.
     * @param {string} [err='GLOBAL.LIST_NOT_AVAILABLE']
     */


    function showErrorMsg(err) {
      vm.errorMsg = err || 'GLOBAL.LIST_NOT_AVAILABLE';
    }
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgPaymentListHeader
   * @module app
   * @description
   * Header with account information for the payments section.
   */

  sgPaymentListHeader.$inject = ["orbaSession"];
  module.component('sgPaymentListHeader', {
    templateUrl: 'app/payment/components/sgPaymentListHeader.html',
    controller: sgPaymentListHeader,
    controllerAs: 'vm'
  });
  /*@ngInject*/

  function sgPaymentListHeader(orbaSession) {
    var vm = this;
    vm.info = orbaSession.info;
  }
})(angular.module('app'));
"use strict";

(function (module) {
  /**
   * @ngdoc service
   * @name currentOrder
   * @module app
   * @description
   * Store information about the current order so this way can be shared by several controllers during the
   * order process.
   */

  /*@ngInject*/
  module.factory('currentOrder', ["$rootScope", "lodash", function ($rootScope, lodash) {
    'use strict';

    var quote,
        cart,
        order,
        catalogs = {
      shippingMethods: [],
      shippingMethodsConfig: []
    };
    /**
     * Returns the quote model.
     * @return {object}
     */

    var getQuote = function getQuote() {
      return quote;
    };
    /**
     * Returns the quote ID stored.
     * @return {string}
     */


    var getQuoteId = function getQuoteId() {
      return hasQuote() ? quote.sg_id : null;
    };
    /**
     * Check if a quote model is defined.
     * @return {boolean}
     */


    var hasQuote = function hasQuote() {
      return angular.isObject(quote);
    };
    /**
     * Store a quote model.
     * @param {object} data
     */


    var setQuote = function setQuote(data) {
      quote = data;
    };
    /**
     * Read, parse and store the catalog required to update the quote model.
     * @param {object} methods
     * @param {object} methods.shipping
     */


    var setCatalogs = function setCatalogs(methods) {
      //Reading catalogs
      catalogs.shippingMethods = [];
      angular.forEach(methods.shipping, function (value, key) {
        this.push({
          code: key,
          label: value
        });
      }, catalogs.shippingMethods); //Pre-selecting the first of each catalog

      if (quote.sg_delivery_method === null && catalogs.shippingMethods.length > 0) {
        quote.sg_delivery_method = catalogs.shippingMethods[0].code;
      }

      catalogs.shippingMethodsConfig = methods.shipping_config;
    };
    /**
     * Store the quote model and the catalogs at the same time.
     * @param {object} data
     */


    var setQuoteAndCatalogs = function setQuoteAndCatalogs(data) {
      setQuote(data.quote);
      setCatalogs(data.methods);
    };
    /**
     * Returns the shipping method's catalog.
     * @return {Array}
     */


    var getShippingMethods = function getShippingMethods() {
      return catalogs.shippingMethods;
    };
    /**
     * Returns the shipping methods configuration.
     * @return {Array}
     */


    var getShippingMethodsConfig = function getShippingMethodsConfig() {
      return catalogs.shippingMethodsConfig;
    };
    /**
     *
     * @param items
     */


    var setQuoteItems = function setQuoteItems(items) {
      quote.items = items;
      return quote;
    };
    /**
     * Save the cart model.
     * @param {object} cartModel Cart model
     */


    var saveCart = function saveCart(cartModel) {
      cart = cartModel;
    };
    /**
     * Save items returned from quote.
     * @param {object} items qoute items
     */


    var saveQuoteItems = function saveQuoteItems(items) {
      cart.items = items;
    };
    /**
     * Return the cart model previously saved.
     * @return {object} Cart model
     */


    var getCart = function getCart() {
      return cart;
    };
    /**
     * Save the order model.
     * @param {object} orderModel Order model
     */


    var saveOrder = function saveOrder(orderModel) {
      order = orderModel;
      $rootScope.$emit('onOrderPlaced', {
        order: getOrder(),
        cart: getCart()
      });
    };
    /**
     * Return the order model previously saved.
     * @return {object} Order model
     */


    var getOrder = function getOrder() {
      return order;
    };
    /**
     * Update the stocks of the currently stored cart items data.
     * @param {object[]} stocksData
     * @return {object[]} Cart items with its stocks updated
     */


    var updateCartStocks = function updateCartStocks(stocksData) {
      if (!angular.isArray(cart.items)) {
        cart.items = [];
      }

      cart.items.forEach(function (item) {
        var stockItem = lodash.find(stocksData, {
          sku: item.sku
        });

        if (stockItem) {
          item.stock = stockItem.stock;
          item.warehouse = stockItem.warehouse;
          item.dlvDate = stockItem.dlvDate;
        }
      });
      return cart.items;
    };

    return {
      catalogs: catalogs,
      hasQuote: hasQuote,
      getQuoteId: getQuoteId,
      getQuote: getQuote,
      setQuote: setQuote,
      setQuoteItems: setQuoteItems,
      setCatalogs: setCatalogs,
      setQuoteAndCatalogs: setQuoteAndCatalogs,
      getShippingMethods: getShippingMethods,
      getShippingMethodsConfig: getShippingMethodsConfig,
      saveCart: saveCart,
      getCart: getCart,
      saveOrder: saveOrder,
      saveQuoteItems: saveQuoteItems,
      getOrder: getOrder,
      updateCartStocks: updateCartStocks
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  /**
   * @ngdoc service
   * @name ordersResource
   * @module app
   * @description
   * Service to use the order's API of the backend.
   */

  /*@ngInject*/
  module.service('ordersResource', ["$http", "$q", "$timeout", "moment", "websocket", "orderConfig", "$resource", "resourceQueryPaginator", "invoicesResource", "orbaSession", "cartItemModel", function ($http, $q, $timeout, moment, websocket, orderConfig, $resource, resourceQueryPaginator, invoicesResource, orbaSession, cartItemModel) {
    'use strict';

    var paginator = resourceQueryPaginator();
    /**
     * Request create a quote based in cart ID given.
     * @param  {number} cartId ID of the shopping cart
     * @return {$q}
     */

    var createQuoteFromCart = function createQuoteFromCart(cartId) {
      return $q(function (resolve, reject) {
        $http.post(orderConfig.restful.quotes, {
          cartId: cartId
        }).then(function (response) {
          if (angular.isObject(response.data)) {
            resolve(transformQuoteItem(response.data));
          } else {
            reject('GLOBAL.SUCCESS_RESPONSE_IN_UNEXPECTED_FORMAT');
          }
        }, function (response) {
          reject(response.data);
        });
      });
    };

    var formatPayload = function formatPayload(quote) {
      if (quote.hasOwnProperty('sg_shipping_date') && angular.isDate(quote.sg_shipping_date)) {
        quote.sg_shipping_date = new Date();
        quote.sg_shipping_date = moment(quote.sg_shipping_date).format('YYYY-MM-DD');
      }

      return quote;
    };
    /**
     * Send a request to update a quote.
     * @param  {object} quote Properties of the quote to update
     * @return {$q}           Promise
     */


    var updateQuote = function updateQuote(quote) {
      return $q(function (resolve, reject) {
        $http.put(orderConfig.restful.quotes, formatPayload(quote)).then(function (response) {
          if (angular.isObject(response.data) && response.data.hasOwnProperty('quote')) {
            resolve(response.data.quote);
          } else {
            reject('GLOBAL.SUCCESS_RESPONSE_IN_UNEXPECTED_FORMAT');
          }
        }, function (response) {
          reject(response.data);
        });
      });
    };
    /**
     * This function returns a Promise with is resolve when the quote items finally have its stocks updated.
     * @param {string} quoteId
     * @return {$q}
     */


    var whenQuoteIsReady = function whenQuoteIsReady(quoteId) {
      return $q(function (resolve, reject) {
        var timeout = parseInt(orbaSession.info.user.reseller.checkout_stock_timeout, 10) * 1000;
        websocket.emit('quote.listenForUpdates', {
          quoteId: quoteId,
          timeout: timeout
        });
        websocket.once('quote.updated', function (quoteId) {
          resolve(quoteId);
        });
      });
    };
    /**
     * Confirm the creation of an order passing the id of the quote.
     * @param {string} quoteId
     */


    var createOrderFromQuote = function createOrderFromQuote(quoteId) {
      var createOrderEndpoint = orderConfig.restful.orders.replace('/:id', '');
      return $q(function (resolve, reject) {
        $http.post(createOrderEndpoint, {
          sg_id: quoteId
        }).then(function (response) {
          if (angular.isObject(response.data) && response.data.hasOwnProperty('order')) {
            resolve(response.data.order);
          } else {
            reject('GLOBAL.SUCCESS_RESPONSE_IN_UNEXPECTED_FORMAT');
          }
        }, function (response) {
          reject(response.data);
        });
      });
    };
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */


    var transformQuoteItem = function transformQuoteItem(srcItem) {
      var item = angular.copy(srcItem);
      item.quote.sg_shipping_date = srcItem.quote.sg_shipping_date !== null ? moment(srcItem.quote.sg_shipping_date).toDate() : moment().startOf('day').toDate();
      item.quote.sg_cod_amount = parseFloat(srcItem.quote.sg_cod_amount);

      if (item.quote.hasOwnProperty('items') && angular.isArray(item.quote.items)) {
        item.quote.items = item.quote.items.map(function (subitem) {
          return new cartItemModel(subitem);
        });
      }

      return item;
    };
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */


    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.sg_order_date = moment(srcItem.sg_order_date).toDate();

      if (item.hasOwnProperty('items') && angular.isArray(item.items)) {
        angular.forEach(item.items, function (subitem) {
          subitem.qty_ordered = parseInt(subitem.qty_ordered, 10);
          subitem.qty_shipped = parseInt(subitem.qty_shipped, 10);
          subitem.sg_quantity_reserved = parseInt(subitem.sg_quantity_reserved, 10);
          subitem.sg_discount = parseFloat(subitem.sg_discount);
          subitem.sg_price = parseFloat(subitem.sg_price);
          subitem.row_total = parseFloat(subitem.row_total);
          subitem.sg_delivered_data = moment(subitem.sg_delivered_data).toDate();
          if (isNaN(subitem.sg_discount)) subitem.sg_discount = 0;
          if (isNaN(subitem.qty_ordered)) subitem.qty_ordered = 0;
          if (isNaN(subitem.qty_shipped)) subitem.qty_shipped = 0;
          if (isNaN(subitem.sg_quantity_reserved)) subitem.sg_quantity_reserved = 0;
        });
      }

      if (item.hasOwnProperty('invoices') && angular.isArray(item.invoices)) {
        if (item.invoices.length > 0) {
          item.invoices = item.invoices.map(function (subitem) {
            subitem.net_total = parseFloat(subitem.net_total);
            subitem.tax_total = parseFloat(subitem.tax_total);
            subitem.grand_total = parseFloat(subitem.grand_total);
            subitem.invoice_date = moment(subitem.invoice_date).toDate();
            subitem.due_date = moment(subitem.due_date).toDate();
            return new invoicesResource(subitem);
          });
        } else {
          item.invoices = null;
        }
      }

      if (item.hasOwnProperty('shipments') && angular.isArray(item.shipments)) {
        if (item.shipments.length > 0) {
          angular.forEach(item.shipments, function (subitem) {
            subitem.cash_on_delivery = parseFloat(subitem.cash_on_delivery);

            if (subitem.cash_on_delivery === 0) {
              subitem.cash_on_delivery = null;
            }
          });
        } else {
          item.shipments = null;
        }
      }

      return item;
    };
    /**
     * Send api request to update stocks
     * @return {Promise}
     */


    var requestUpdateStocks = function requestUpdateStocks() {
      var timeout = parseInt(orbaSession.info.user.reseller.checkout_stock_timeout, 10);

      if (timeout > 0) {
        return $resource(orderConfig.restful.stocks).save();
      }

      return $q.resolve();
    };
    /**
     * Process a response for a request of a single row.
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformSingle = function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.order || data) : data;
    };
    /**
     * Process a response for a request of multiple rows.
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformMultiple = function transformMultiple(data) {
      return angular.isObject(data) ? (data.orders || data).map(transformItem) : data;
    };
    /**
     * Orders api
     */


    var rest = $resource(orderConfig.restful.orders, {
      id: '@entity_id'
    }, {
      //Collection of items
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo($http.defaults.transformResponse.concat(transformMultiple))
      },
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: paginator.addTransformTo($http.defaults.transformResponse.concat(transformSingle))
      }
    }); // Apply pagination to resource query

    paginator.applyToResource(rest, 'query');
    return {
      rest: rest,
      createQuoteFromCart: createQuoteFromCart,
      updateQuote: updateQuote,
      whenQuoteIsReady: whenQuoteIsReady,
      requestUpdateStocks: requestUpdateStocks,
      createOrderFromQuote: createOrderFromQuote
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('orderStep3Ctrl', ["$stateParams", "currentOrder", function quoteStep3Ctrl($stateParams, currentOrder) {
    var vm = this;
    vm.model = currentOrder.getOrder();
    vm.orderCode = $stateParams.code;
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for update a new cart.
 */
(function (module) {
  'use strict';

  orderStep2Ctrl.$inject = ["$state", "$stateParams", "$translate", "toaster", "ordersResource", "currentOrder", "cartsResource", "offersResource", "cartActive", "sessionAccess", "convertToModal", "$rootScope"];
  module.controller('orderStep2Ctrl', orderStep2Ctrl);
  /*@ngInject*/

  function orderStep2Ctrl($state, $stateParams, $translate, toaster, ordersResource, currentOrder, cartsResource, offersResource, cartActive, sessionAccess, convertToModal, $rootScope) {
    var vm = this;
    vm.quote = currentOrder.getQuote();
    vm.cart = currentOrder.getCart();

    if ($stateParams.hasOwnProperty('cartId')) {
      vm.model = cartsResource.get({
        id: $stateParams.cartId
      });
      vm.model.$promise["catch"](function () {
        toaster.error('CART.CART_NOT_AVAILABLE');

        if (cartActive.get() && cartActive.get().getId() === $stateParams.cartId) {
          cartActive.set(null);
        }

        vm.goBack();
      });
    } else {} // vm.model = new cartsResource();
    //ACCESS KEYS


    vm.access = sessionAccess.areActionsAllowed([]);
    /**
     * Returns to the list.
     */

    vm.goBack = function () {
      $state.go('cart.list');
    };
    /**
     * Mark the given cart as active.
     * @param {object} cartModel
     */


    vm.activateCart = function (cartModel) {
      if (cartActive.set(cartModel)) {
        toaster.info('CART.ACTIVATION_NOTIF', {
          name: cartModel.name
        });
      }
    };
    /**
     * Redirect the user to the first step of creating a order process passing it the entire quote data.
     * @param {object} quote
     */


    vm.startOrderProcess = function (quote) {
      currentOrder.saveCart(vm.model);
      currentOrder.saveQuoteItems(quote.quote.items);
      currentOrder.setQuoteAndCatalogs(quote);
      $state.go('order.step1', {
        cartId: vm.model.uniqid
      });
    };
    /**
     * When a new cart is created this function update the current router state to the "Update cart" mode without
     * really exit the "Create cart" mode.
     * @param {object} cartModel
     */


    vm.changeToUpdateMode = function (cartModel) {
      $state.go('cart.update', {
        id: cartModel.uniqid
      }, {
        notify: false
      });
    };
    /**
     * Request the conversion of the current cart to an offer.
     */


    vm.convertToOffer = function () {
      if (vm.model.canConvertToOffer()) {
        convertToModal.show(vm.model.name, false, 'CART').then(function (data) {
          offersResource.createFromCart({
            id: vm.model.uniqid,
            newName: data.name
          }).then(function (offerModel) {
            if (offerModel.hasOwnProperty('items_failed') && offerModel.items_failed.length > 0) {
              convertToModal.failedItems = offerModel.items_failed;
              toaster.warning('CART.PARTIALLY_CONVERTED_TO_OFFER');
            }

            if (data.remove === true) {
              vm.model.$remove();
            }

            vm.openOffer(offerModel);
          }, toaster.error);
        });
      }
    };
    /**
     * Open de offer editor with the offer given.
     * @param {object} offerModel
     */


    vm.openOffer = function (offerModel) {
      $state.go('offer.update', {
        id: offerModel.uniqid
      });
    };
    /**
     * Returns a hint to show when the user cannot convert the the current cart into a offer.
     * @return {string}
     */


    vm.getConvertToOfferHint = function () {
      return vm.model && vm.model.canConvertToOffer() ? '' : $translate.instant('CART.CANT_BE_CONVERTED_TO_OFFER');
    };
    /**
     * This variable will change when the items with stocks were available.
     * @type {boolean}
     */


    vm.stocksUpdated = false;
    /**
     * Initialize the controller.
     */

    var init = function init() {
      if (!$stateParams.cartId) {
        throw 'No cart ID is passed in the URL';
      } //If the quote data is not found the user is redirect to the cart to create a new quote


      if (!currentOrder.hasQuote()) {
        vm.showError('ORDER.NO_QUOTE_WAS_FOUND');
        vm.goToCart();
        return;
      } //Wait until the items stocks are updated


      ordersResource.whenQuoteIsReady(currentOrder.getQuoteId()).then(function (quoteItems) {
        currentOrder.updateCartStocks(quoteItems);
        vm.stocksUpdated = true;
      });
    };
    /**
     * Redirect the user to the cart view.
     */


    vm.goToCart = function () {
      $state.go('cart.update', {
        id: $stateParams.cartId
      });
    };
    /**
     * Redirect the user to the next step of the process.
     */


    vm.goToNextStep = function () {
      $state.go('order.step3', {
        code: currentOrder.getOrder().increment_id
      });
    };
    /**
     * Show a error notification.
     * @param {string} msg
     */


    vm.showError = function (msg) {
      toaster.error(msg || 'GLOBAL.UNKNOWN_ERROR');
    };
    /**
     * Confirm the creation of the order based in the current quote.
     * @return {Promise}
     */


    vm.confirmOrder = function () {
      vm.confirmOrderPromise = ordersResource.createOrderFromQuote(currentOrder.getQuoteId()).then(function (orderModel) {
        currentOrder.saveOrder(orderModel);
        vm.goToNextStep();
      }, vm.showError);
      return vm.confirmOrderPromise;
    };

    init();
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';

  quoteStep1Ctrl.$inject = ["$state", "$stateParams", "$document", "$timeout", "moment", "toaster", "lodash", "domUtils", "ordersResource", "addressesResource", "currentOrder", "orbaSession", "websocket", "$q", "$scope", "$filter"];
  module.controller('orderStep1Ctrl', quoteStep1Ctrl);
  /*@ngInject*/

  function quoteStep1Ctrl($state, $stateParams, $document, $timeout, moment, toaster, lodash, domUtils, ordersResource, addressesResource, currentOrder, orbaSession, websocket, $q, $scope, $filter) {
    var vm = this;
    vm.addressSelectionTableVisible = false;
    vm.saveAddress = false;
    vm.saveAddressAvailable = false;
    vm.shippingMethods = currentOrder.getShippingMethods();
    vm.shippingMethodsConfig = currentOrder.getShippingMethodsConfig();
    vm.model = currentOrder.getQuote();
    vm.cart = currentOrder.getCart();
    vm.today = moment().startOf('day').toDate();
    vm.session = orbaSession;
    /**
     * Array of calid postcodes
     * @type {Array}
     */

    vm.validCodes = [];
    /**
     * Variable to flag if custom form errors should be shown
     * @type {boolean}
     */

    vm.showErrors = false;
    /**
     * Focus a specific input field of the view.
     * @param {string} name Name of the field (input param "name")
     */

    vm.focusField = function (name) {
      $document.find('input[name=' + name + ']:not([readonly])').focus();
    };
    /**
     * Initialize the controller.
     */


    var init = function init() {
      if (!$stateParams.cartId) {
        throw 'No cart ID is passed in the URL';
      } //If the quote data is not found the user is redirect to the cart to create a new quote


      if (!currentOrder.hasQuote()) {
        vm.showError('ORDER.NO_QUOTE_WAS_FOUND');
        vm.goToCart();
      } else {
        if (vm.cart.hasOwnProperty('company') && vm.cart.company !== null) {
          vm.setShipmentAddress(vm.cart);
        } else {
          vm.defaultAddress = addressesResource.getdefault();
          vm.defaultAddress.$promise.then(function () {
            vm.defaultAddress.fullname = vm.session.info.user.user.firstname + ' ' + vm.session.info.user.user.lastname;
            vm.defaultAddress.telephone = vm.session.info.user.user.phone;
            vm.setShipmentAddress(vm.defaultAddress);
          });
        }

        vm.setServiceRequest();
      }
    };

    vm.setServiceRequest = function () {
      vm.model.sg_service_request = vm.model.sg_service_request || vm.model.sg_order_name;

      if (vm.model.sg_service_request.length > 30) {
        vm.model.sg_service_request = vm.model.sg_service_request.substr(0, 30);
      }
    };
    /**
     * Submit the quote.
     * @return {Promise}
     */


    vm.submitQuote = function () {
      vm.model._request_stock = false;
      vm.updateQuoteRequestPromise = ordersResource.updateQuote(vm.model).then(function (quote) {
        ordersResource.requestUpdateStocks();
        currentOrder.setQuote(quote);
        vm.goToNextStep();
      }, vm.showError);
      return vm.updateQuoteRequestPromise;
    };
    /**
     * Save quote data
     * @return {Promise}
     */


    vm.saveQuote = function () {
      vm.showErrors = true;

      if (vm.quoteForm.$invalid) {
        return $q.reject();
      }

      vm.model._request_stock = false;
      vm.updateQuoteRequestPromise = ordersResource.updateQuote(vm.model).then(function () {
        toaster.success('ORDER.DATA_SAVED');
      }, vm.showError);
      return vm.updateQuoteRequestPromise;
    };
    /**
     * Return valid postcodes starting from given params
     * @param {string} code
     * @return {*[]}
     */


    vm.findPostCodes = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            vm.validCodes = response;
            resolve(response);
          }
        });
      });
    };
    /**
     * Checks if currently given postcode is valid
     * @param {string} postcode
     * @return {*}
     */


    vm.validatePostcode = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (Array.isArray(response) && response.indexOf(postcode) < 0) {
            reject(false);
          } else {
            resolve(true);
          }
        });
      });
    };
    /**
     * Return valid cities based on postcode, starting from given param
     * @param {string} city
     * @return {*[]}
     */


    vm.findCities = function (city) {
      return $q(function (resolve, reject) {
        if (!vm.model.postcode) {
          reject([]);
        }

        websocket.emit('account.getValidCities', {
          postcode: vm.model.postcode,
          city: city
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject([]);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Return valid streets based on postcode and city, starting from given param
     * @param {string} street
     * @return {*[]}
     */


    vm.findStreets = function (street) {
      return $q(function (resolve, reject) {
        if (!vm.model.postcode || !vm.model.city) {
          reject([]);
        }

        websocket.emit('account.getValidStreets', {
          postcode: vm.model.postcode,
          city: vm.model.city,
          street: street
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Validate if given date is not from past
     * @param date
     * @return {boolean}
     */


    vm.validateShippingDate = function (date) {
      return !moment(date).isBefore(vm.today);
    };
    /**
     * This function should be called from the view when all the required fields are completed and the form data
     * is ready to be send to the backend.
     * @return {Promise}
     */


    vm.submitAll = function () {
      vm.showErrors = true;

      if (vm.quoteForm.$invalid) {
        return $q.reject();
      }

      if (vm.saveAddress && vm.saveAddressAvailable) {
        vm.saveNewAddress().then(function () {
          toaster.success('ORDER.ADDRESS_CREATION_SUCCESS');
          vm.saveAddress = false;
        })["catch"](function () {
          toaster.error('ORDER.ADDRESS_CREATION_FAILURE');
        });
      }

      return vm.submitQuote();
    };
    /**
     * Create a new address with the address properties of the current quote.
     * @return {Promise}
     */


    vm.saveNewAddress = function () {
      var addressData = lodash.pick(vm.model, ['firstname', 'lastname', 'fullname', 'label', 'company', 'street', 'building', 'city', 'postcode', 'telephone']);
      return addressesResource.save(addressData).$promise;
    };
    /**
     * Redirect the user to the cart view.
     */


    vm.goToCart = function () {
      $state.go('cart.update', {
        id: $stateParams.cartId
      });
    };
    /**
     * Redirect the user to the next step of the process to create an order.
     */


    vm.goToNextStep = function () {
      $state.go('order.step2', {
        cartId: $stateParams.cartId
      });
    };
    /**
     * Show a error notification.
     * @param {string} msg
     */


    vm.showError = function (msg) {
      toaster.error(msg || 'GLOBAL.UNKNOWN_ERROR');
    };
    /**
     * Set the shipment address properties of the quote from a address model.
     * @param {addressesResource} addressModel
     */


    vm.setShipmentAddress = function (addressModel) {
      var address = lodash.pick(addressModel, ['firstname', 'lastname', 'fullname', 'label', 'company', 'street', 'building', 'city', 'postcode', 'telephone']);
      addressesResource.fillDefaultLabel(address);
      Object.assign(vm.model, address);
      vm.addressSelectionTableVisible = false;
      $timeout(function () {
        vm.saveAddressAvailable = false;
      });
    };
    /**
     * Set the shipment address properties of the quote from a default address entity.
     */


    vm.setDefaultAddress = function () {
      vm.defaultAddress = addressesResource.getdefault();
      vm.defaultAddress.$promise.then(function () {
        vm.setShipmentAddress(vm.defaultAddress);
      });
    };
    /**
     * Clear all the shipment address information from the quote model.
     */


    vm.clearShipmentAddress = function () {
      Object.assign(vm.model, {
        firstname: '',
        lastname: '',
        fullname: '',
        label: '',
        company: '',
        street: '',
        building: '',
        city: '',
        postcode: '',
        telephone: ''
      });
      vm.addressSelectionTableVisible = false;
      vm.saveAddressAvailable = true;
    };
    /**
     * Show the table for select a existing address.
     */


    vm.selectShipmentAddress = function () {
      vm.addressSelectionTableVisible = true;
    };
    /**
     * Scroll the page to the bottom of the screen.
     */


    vm.scrollToBottom = function () {
      $timeout(function () {
        domUtils.scrollToBottom();
      }, 0);
    };
    /**
     * Format currency according to current locale.
     *
     * @param {float} value
     * @returns {string}
     */


    vm.formatCurrency = function (value) {
      return $filter('currency')(value);
    };
    /**
     * Get value for minimal cod amount validation.
     *
     * @returns {float|string}
     */


    vm.getCodMinCoditionValue = function () {
      if (vm.quoteForm.sg_delivery_method.$modelValue == 'courier_cod') {
        return vm.shippingMethodsConfig.courier_cod.cod_min_amount;
      }

      return '';
    };
    /**
     * Get value for maximal cod amount validation.
     *
     * @returns {float|string}
     */


    vm.getCodMaxCoditionValue = function () {
      if (vm.quoteForm.sg_delivery_method.$modelValue == 'courier_cod') {
        return vm.shippingMethodsConfig.courier_cod.cod_max_amount;
      }

      return '';
    };
    /**
     * Show save address checbox on each address field change
     */


    $scope.$watchGroup(['vm.model.firstname', 'vm.model.lastname', 'vm.model.fullname', 'vm.model.label', 'vm.model.company', 'vm.model.street', 'vm.model.building', 'vm.model.city', 'vm.model.postcode', 'vm.model.telephone'], function () {
      vm.saveAddressAvailable = true;
    });
    init();
  }
})(angular.module('app'));
"use strict";

/**
 * Controller for Orders list
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('orderListCtrl', ["$scope", "ordersResource", "paginationManager", "orderConfig", function accountAddressesListCtrl($scope, ordersResource, paginationManager, orderConfig) {
    init();
    /**
     * Initialize the controller.
     */

    function init() {
      /**
       * Retrieve orders from api
       */
      $scope.paginator = paginationManager($scope, 'order', ordersResource.rest.query);
      $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : orderConfig.list.pageSize;
      $scope.paginator.page = 1;
      $scope.paginator.autoRefresh(true);
    }
    /**
     * Available order statuses
     * TODO: this should be retrieved from api, but there's no such method for now
     * @type {Object}
     */


    $scope.orderStatuses = {
      'created': 'ORDER.STATUSES.CREATED',
      'delete': 'ORDER.STATUSES.DELETE',
      'cancel': 'ORDER.STATUSES.CANCEL',
      'in_progress': 'ORDER.STATUSES.IN_PROGRESS',
      'completed': 'ORDER.STATUSES.COMPLETED',
      'invalid': 'ORDER.STATUSES.INVALID',
      'error': 'ORDER.STATUSES.ERROR',
      'invoiced': 'ORDER.STATUSES.INVOICED'
    };
    /**
     * Set filters payload
     * @return {{}}
     */

    var setFilterPayload = function setFilterPayload() {
      var filterPayload = {};
      angular.forEach($scope.filter, function (value, key) {
        if (value) {
          filterPayload[key] = value;
        }
      });
      return filterPayload;
    };
    /**
     * Reload orders with given filters
     */


    $scope.filterOrders = function () {
      $scope.paginator.filters = setFilterPayload();
    };
    /**
     * Clear filters and refresh list
     */


    $scope.clearFilters = function () {
      $scope.filter = {};
      $scope.filterOrders();
    };
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for order details
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('orderItemCtrl', ["$scope", "$state", "$stateParams", "toaster", "ordersResource", "FileSaver", function orderItemCtrl($scope, $state, $stateParams, toaster, ordersResource, FileSaver) {
    /**
     * Available order statuses
     * TODO: this should be retrieved from api, but there's no such method for now
     * @type {Object}
     */
    $scope.orderStatuses = {
      'created': 'ORDER.STATUSES.CREATED',
      'delete': 'ORDER.STATUSES.DELETE',
      'cancel': 'ORDER.STATUSES.CANCEL',
      'in_progress': 'ORDER.STATUSES.IN_PROGRESS',
      'completed': 'ORDER.STATUSES.COMPLETED',
      'invalid': 'ORDER.STATUSES.INVALID',
      'error': 'ORDER.STATUSES.ERROR',
      'invoiced': 'ORDER.STATUSES.INVOICED'
    };
    /**
     * Error message by default if the server returns an error and don't detail the cause.
     * @type {string}
     */

    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * Returns to the orders list router state.
     */

    $scope.goBack = function () {
      $state.go('orders.list');
    };
    /**
     * Download the PDF document of the invoice given as argument.
     * @param {string} invoice
     */


    $scope.downloadPdf = function (invoice) {
      invoice.getPdfDocument().then(function (blobData) {
        FileSaver.saveAs(blobData, invoice.getId() + '.pdf');
      })["catch"](function (errorMsg) {
        toaster.error(errorMsg);
      });
    };
    /*
     * Retrieve order info
     */


    if ($stateParams.id) {
      $scope.order = ordersResource.rest.get({
        id: $stateParams.id
      });
      $scope.order.$promise["catch"](function (response) {
        toaster.error(response.data || $scope.defaultErrorMsg);
        $scope.goBack();
      });
    } else {
      $scope.goBack();
    }
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgQuoteDetails
   * @module app
   * @description
   * Show a table with information about a quote.
   */

  module.component('sgQuoteDetails', {
    templateUrl: 'app/order/components/sgQuoteDetails.html',
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      /**
       * Quote information.
       * @type {object}
       */
      model: '<model'
    }
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgOrderSummary
   * @description
   * Summary of the order.
   */

  module.component('sgOrderSummary', {
    templateUrl: 'app/order/components/sgOrderSummary.html',
    controllerAs: 'vm',
    bindings: {
      /**
       * Order model.
       */
      model: '<'
    }
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:issueAttachmentModal
   * @description Show a modal component with attachments.
   */

  issueAttachmentsModal.$inject = ["$uibModal", "toaster", "$translate"];
  module.factory('issueAttachmentsModal', issueAttachmentsModal);
  /*@ngInject*/

  function issueAttachmentsModal($uibModal, toaster, $translate) {
    var show = function show(_attachments) {
      if (!_attachments) _attachments = [];

      if (_attachments.length == 0) {
        toaster.error($translate.instant('ISSUE.NO_ATTACHMENTS'));
      } else {
        $uibModal.open({
          controller: 'issueAttachmentsModal',
          templateUrl: 'app/issues/partials/issueAttachmentsModal.html',
          resolve: {
            attachments: function attachments() {
              return _attachments;
            }
          }
        });
      }
    };

    return {
      show: show
    };
  }

  ;
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:issueAttachmentDownload
   * @author oskar.laska@orba.co
   * @description Trigger download for an issue attachment.
   */

  module.service('issueAttachmentDownload', ['$http', 'FileSaver', 'issuesConfig', function ($http, FileSaver, issuesConfig) {
    /**
     * @ngdoc method
     * @name app.service:issueAttachmentDownload#getFileNameFromResponse
     * @methodOf app.service:issueAttachmentDownload
     * @description Gets file name returned in Content-Disposition header of response.
     * @param [response] Response fetched from magento
     * @returns {string} The file name
     */
    function getFileNameFromResponse(response) {
      var contentDisposition = response.headers('Content-Disposition');

      if (contentDisposition && contentDisposition.length) {
        var filenameRegex = /filename=\"(.+?)\"/;
        var matches = filenameRegex.exec(contentDisposition);
        return matches[1];
      }

      return null;
    }

    ;
    /**
     * @ngdoc method
     * @name app.service:issueAttachmentDownload#downloadFile
     * @methodOf app.service:issueAttachmentDownload
     * @description Downloads file basing on response from API.
     * @param [response] Response fetched from magento
     * @returns {undefined}
     */

    function downloadFile(response) {
      FileSaver.saveAs(response.data, getFileNameFromResponse(response));
    }

    ;

    function downloadAttachment(attach_id) {
      $http({
        method: 'GET',
        url: issuesConfig.restful.downloadAttachment.replace(':attach_id', attach_id),
        responseType: 'blob'
      }).then(downloadFile);
    }

    ;
    return {
      downloadAttachment: downloadAttachment
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('issuesResource', ["$resource", "$http", "issuesConfig", "moment", "resourceQueryPaginator", "$rootScope", "$filter", function ($resource, $http, issuesConfig, moment, resourceQueryPaginator, $rootScope, $filter) {
    var paginator = resourceQueryPaginator();
    /**
     * Available issues types
     * @type {Object}
     */

    $rootScope.issueTypes = {
      'PaidRepair': 'COMPLAINT.PAIDREPAIR',
      'Complaint': 'COMPLAINT.COMPLAINT',
      'Service': 'COMPLAINT.SERVICE',
      'BackSent': 'COMPLAINT.BACKSENT'
    };
    /**
     * Available issues request, Created by createRequestMapping function
     * @type {Object}
     */

    $rootScope.issueRequests = {};
    /**
     * Available issues request
     * @type {Object}
     */

    $rootScope.issueTasks = {
      'Canceled': 'ISSUE.CANCELED',
      'Completed': 'ISSUE.COMPLETED',
      'Error': 'ISSUE.ERROR',
      'InProgress': 'ISSUE.IN_PROGRESS',
      'New': 'ISSUE.NEW',
      'OK': 'ISSUE.OK',
      'Received': 'ISSUE.RECEIVED'
    };

    var createRequestMapping = function createRequestMapping(typeMap) {
      for (var key in typeMap) {
        if (typeMap.hasOwnProperty(key)) {
          typeMap[key].forEach(function (value) {
            $rootScope.issueRequests[value] = 'ISSUE.' + value.toUpperCase();
          });
        }
      }
    };
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */


    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);

      if (item.items) {
        item.items.forEach(function (product) {
          if (product.attachments) {
            product.attachments = product.attachments.map(function (attachment) {
              return {
                attach_id: attachment.attach_id || '<no attach_id>',
                name: attachment.file_name || '<no name>',
                uniqid: attachment.uniqid || '<no uniqid>',
                size: attachment.size || '<no size>'
              };
            });
          }
        });
      }

      return item;
    };
    /**
     * Process a response for a request of a single row.
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformSingle = function transformSingle(data) {
      if (angular.isObject(data) && data.dictionary) {
        $rootScope.dictionary = data.dictionary;
        createRequestMapping(data.dictionary.typeMap);
      }

      if (angular.isObject(data) && angular.isObject(data.issue) && Array.isArray(data.issue.items)) {
        data.issue.items.forEach(function (item) {
          if (!Array.isArray(item.attachments)) {
            return;
          }

          item.attachments.forEach(function (attachment) {
            if (angular.isObject(data.filesize)) {
              var contains = attachment.attach_id in data.filesize;
              attachment.size = contains ? data.filesize[attachment.attach_id] : null;
            }
          });
        });
      }

      return angular.isObject(data) ? transformItem(data.issue || data) : data;
    };
    /**
     * Process a response for a request of multiple rows.
     * Sorting dictionary arrays from response.
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformMultiple = function transformMultiple(data) {
      if (data.dictionary) {
        data.dictionary.current_task.sort(function (value1, value2) {
          var value;

          if (value1 === value2) {
            value = 0;
          } else {
            value = value1 > value2 ? 1 : -1;
          }

          return value;
        });
        $rootScope.dictionary = data.dictionary;
        createRequestMapping(data.dictionary.typeMap);
      }

      return angular.isObject(data) ? (data.issues || data).map(transformItem) : data;
    };
    /**
     * Transform attachment (after create request).
     */


    var transformAttachment = function transformAttachment(data) {
      if (data.attachments) {
        return {
          attach_id: data.attachments.attach_id || '<no attach_id>',
          name: data.attachments.file_name || '<no name>',
          uniqid: data.attachments.uniqid || '<no uniqid>',
          size: data.attachments.size
        };
      }

      return data;
    };

    var resource = $resource(issuesConfig.restful.issues, {
      id: '@id'
    }, {
      //Collection of items
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo($http.defaults.transformResponse.concat(transformMultiple))
      },
      //Single item
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Save new issue
      'save': {
        method: 'POST',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Check new issue and products inside
      'check': {
        method: 'POST',
        url: issuesConfig.restful.issuesCheck,
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      'getItemAttachments': {
        method: 'GET',
        url: issuesConfig.restful.issueItemAttachments,
        isArray: true
      },
      //Delete issue
      'delete': {
        method: 'DELETE',
        isArray: false
      },
      //Update issue
      'put': {
        method: 'PUT',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Post issue to AX
      'postAX': {
        method: 'POST',
        url: issuesConfig.restful.issuesAX,
        isArray: false
      },
      // Create a new attachment
      'createAttachment': {
        method: 'POST',
        url: issuesConfig.restful.itemAttachment,
        transformRequest: [],
        transformResponse: $http.defaults.transformResponse.concat(transformAttachment),
        headers: {
          'Content-Type': undefined
        }
      }
    }); // Apply pagination to resource query

    paginator.applyToResource(resource, 'query');
    return resource;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('issueProductAttachmentsResource', ["$resource", "$http", "issuesConfig", "moment", "resourceQueryPaginator", "$rootScope", "$filter", function ($resource, $http, issuesConfig, moment, resourceQueryPaginator, $rootScope, $filter) {
    var resource = $resource(issuesConfig.restful.attachments, {
      id: '@id'
    }, {
      //Delete attachment
      'delete': {
        method: 'DELETE',
        url: issuesConfig.restful.attachments
      }
    });
    return resource;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @module app
   * @name issuesListCtrl
   * @description
   * Controller displaying, deleting and filtering issues.
   */

  module.controller('issuesListCtrl', ["$scope", "issuesResource", "paginationManager", "issuesConfig", "toaster", "lodash", function issuesListCtrl($scope, issuesResource, paginationManager, issuesConfig, toaster, lodash) {
    init();
    /**
     * Messages dictionary, which are used for display them to a user
     */

    var messages = {
      deleteSuccess: 'ISSUE.DELETE_SUCCESS_MSG',
      deleteError: 'ISSUE.DELETE_FAILURE_MSG',
      issueLocked: 'ISSUE.ISSUE_IS_LOCKED'
    };
    /**
     * Initialize the controller.
     */

    function init() {
      /**
       * Retrieve issues from api
       */
      $scope.paginator = paginationManager($scope, 'issues', issuesResource.query);
      $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : issuesConfig.list.pageSize;
      $scope.paginator.page = 1;
      $scope.paginator.autoRefresh(true);
    }
    /**
     * Set filters payload
     * @return {{}}
     */


    var setFilterPayload = function setFilterPayload() {
      var filterPayload = {};
      angular.forEach($scope.filter, function (value, key) {
        if (value) {
          filterPayload[key] = value;
        }
      });
      return filterPayload;
    };
    /**
     * Reload issues with given filters
     */


    $scope.filterIssues = function () {
      $scope.paginator.filters = setFilterPayload();
    };
    /**
     * Clear issues filter and refresh list
     */


    $scope.clearFilters = function () {
      $scope.filter = {};
      $scope.filterIssues();
    };
    /**
     * Delete one issue from list
     */


    $scope.deleteIssue = function (id) {
      issuesResource["delete"](id).$promise.then(function () {
        init();
        toaster.success(messages.deleteSuccess);
      })["catch"](function (err) {
        var errorMessage = messages.deleteError;

        if (err.status === 409) {
          errorMessage = err.data;
        }

        toaster.error(errorMessage);
      });
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @module app
   * @name issuesNewCtrl
   * @description
   * Controller for create new issue.
   */

  module.controller('issuesNewCtrl', ["$scope", "addressesResource", "lodash", "issuesResource", "issueAttachmentsModal", "websocket", "$q", "orbaSession", "toaster", "$state", "$translate", "$rootScope", function issuesNewCtrl($scope, addressesResource, lodash, issuesResource, issueAttachmentsModal, websocket, $q, orbaSession, toaster, $state, $translate, $rootScope) {
    $scope.errors = null;
    $scope.currentPreset = '';
    $scope.addressData = {};
    $scope.addNew = false;
    $scope.validCodes = '';
    $scope.fileSizeLimit = 70 * 1024 * 1024; //70 MB
    // Below are  two variables to assign promises from api communication,
    // then in html template they are responsible for displaying loading spinner

    $scope.issuePromise = '';
    $scope.productPromise = ''; // Flag for check in view if user editing issue or adding a new one

    $scope.editIssue = false; // Model of issue data we assign from user inputs and then sending to api

    $scope.formData = {
      issue_name: '',
      account_number: '',
      delivery_name: '',
      delivery_street: '',
      delivery_building: '',
      delivery_city: '',
      delivery_postcode: '',
      contact_person: '',
      contact_phone: '',
      contact_email: '',
      contact_notification: '',
      items: []
    };
    $scope.addresses = addressesResource.query(); // If state param - then user want to edit existing issue
    // We must get data of this issue and fill form with it

    if ($state.params.id) {
      $scope.editIssue = true;
      $scope.formData = issuesResource.get({
        id: $state.params.id
      });
      $scope.issuePromise = $scope.formData;
      $scope.formData.$promise.then(function (data) {
        if (data.issue_id) {
          toaster.success('ISSUE.ISSUE_IS_LOCKED');
          $state.go('issues.item', {
            id: $state.params.id
          });
        }
      });
    } else {
      $scope.addresses.$promise.then(function (data) {
        var defaultAddress = lodash.find(data, function (addr) {
          return addr.is_default_shipping === true;
        });

        if (!defaultAddress) {
          defaultAddress = data[0];
        } // Set default value of address field to user data


        $scope.currentPreset = defaultAddress;
        $scope.usePreset(defaultAddress, false);
        init();
      });
    }
    /**
     * Messages dictionary, which are used for display them to a user
     */


    var messages = {
      issueSuccess: 'ISSUE.ISSUE_ADD_SUCCESS',
      issueError: 'ISSUE.ISSUE_ADD_FAILURE',
      formError: 'ISSUE.FILL_FORM',
      noItemsError: 'ISSUE.FILL_ITEMS',
      productSuccess: 'ISSUE.PRODUCT_ADD_SUCCESS',
      productError: 'ISSUE.PRODUCT_ADD_FAILURE',
      productDeleteSuccess: 'ISSUE.PRODUCT_DELETE_SUCCESS',
      productDeleteError: 'ISSUE.PRODUCT_DELETE_FAILURE',
      issueCheckSuccess: 'ISSUE.CHECK_SUCCESS',
      issueCreateSuccess: 'ISSUE.CREATE_SUCCESS',
      filesError: 'ISSUE.FILE_UPLOAD_ERROR'
    };
    /**
     * Initialize the controller.
     */

    function init() {
      orbaSession.userDataResolved.then(function () {
        if ($scope.formData.contact_person === '') {
          $scope.formData.contact_person = orbaSession.info.user.user.firstname + ' ' + orbaSession.info.user.user.lastname;
        }

        if ($scope.formData.contact_phone === '') {
          $scope.formData.contact_phone = orbaSession.info.user.user.phone;
        }

        if ($scope.formData.contact_email === '') {
          $scope.formData.contact_email = orbaSession.info.user.user.email;
        }

        $scope.formData.account_number = orbaSession.info.session.sgRAxId;

        if ($scope.formData.contact_notification === '') {
          $scope.formData.contact_notification = 'Email';
        }
      }).then(function () {
        return issuesResource.save($scope.formData).$promise;
      }).then(function (data) {
        $scope.formData.uniqid = data.uniqid;
        $state.go('issues.edit', {
          id: data.uniqid
        }, {
          location: 'replace'
        });
        toaster.success(messages.issueCreateSuccess);
      })["catch"](function (err) {
        toaster.error(err && err.data || 'GLOBAL.UNKNOWN_ERROR');
      });
    }

    ;
    /**
     * Actually change visibility -- used internally, not w/ event
     */

    $scope.addNewVisibility = function (bool, item, rowNode) {
      $scope.errors = null;

      if (item) {
        $scope.itemRowNode = rowNode;
        rowNode.classList.add('item-editing');
        $scope.itemEdit = item;
      } else if (!bool) {
        if ($scope.itemRowNode) {
          $scope.itemRowNode.classList.remove('item-editing');
        }

        $scope.itemEdit = null;
      }

      $scope.addNew = bool;
    };
    /**
     * Change visibility of add new product form -- from event
     */


    $scope.addNewVisibilityEvent = function (bool, item, $event) {
      var rowNode = null;

      if (item) {
        rowNode = $event.currentTarget.parentNode.parentNode;
      }

      $scope.addNewVisibility(bool, item, rowNode);
    };
    /**
     * Apply a address preset to the current issue.
     * @param {addressesResource} address
     * @param {setPhonePerson} should it set phone & person or leave the default values
     */


    $scope.usePreset = function (address, setPhonePerson) {
      if (address instanceof addressesResource) {
        // Picked wanted data from addressesResource and return object
        var picked = lodash.pick(address, ['company', 'street', 'building', 'postcode', 'city', 'telephone', 'fullname']); // Create new object with wanted keys, values come from object created by lodash above

        var object = {
          'delivery_name': picked.company,
          'delivery_street': picked.street,
          'delivery_building': picked.building,
          'delivery_postcode': picked.postcode,
          'delivery_city': picked.city,
          'contact_phone': picked.telephone,
          'contact_person': picked.fullname
        };

        if (!setPhonePerson) {
          delete object.contact_person;
          delete object.contact_phone;
        } // Assign created object to current form data


        Object.assign($scope.formData, object);
      } else {
        Object.assign($scope.formData, {
          delivery_name: '',
          delivery_street: '',
          delivery_building: '',
          delivery_postcode: '',
          delivery_city: ''
        });
      }
    };
    /**
     * Return valid postcodes starting from given params
     * @param {string} code
     * @return {*[]}
     */


    $scope.findPostCodes = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            $scope.validCodes = response;
            resolve(response);
          }
        });
      });
    };
    /**
     * Checks if currently given postcode is valid
     * @param {string} postcode
     * @return {*}
     */


    $scope.validatePostcode = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (Array.isArray(response) && response.indexOf(postcode) < 0) {
            reject(false);
          } else {
            resolve(true);
          }
        });
      });
    };
    /**
     * Return valid cities based on postcode, starting from given param
     * @param {string} city
     * @return {*[]}
     */


    $scope.findCities = function (city) {
      return $q(function (resolve, reject) {
        var postcode = $scope.formData.delivery_postcode;

        if (!postcode) {
          reject([]);
        }

        websocket.emit('account.getValidCities', {
          postcode: postcode,
          city: city
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject([]);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Return valid streets based on postcode and city, starting from given param
     * @param {string} city
     * @return {*[]}
     */


    $scope.findStreets = function (street) {
      return $q(function (resolve, reject) {
        var postcode = $scope.formData.delivery_postcode;
        var city = $scope.formData.delivery_city;

        if (!postcode || !city) {
          reject([]);
        }

        websocket.emit('account.getValidStreets', {
          postcode: postcode,
          city: city,
          street: street
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * @return {Array}
     */


    $scope.preSubmitErrors = function () {
      var errors = [];

      if ($scope.issueForm.$invalid) {
        // I'm deeply ashamed of what i have done here
        jQuery('form[name=\'issueForm\'] .form-control').triggerHandler('blur');
        errors.push($translate.instant(messages.formError));
      }

      if (!$scope.formData.items.length) {
        errors.push($translate.instant(messages.noItemsError));
      }

      return errors;
    };

    $scope.checkFilesSize = function (beforeSend) {
      var fileSize = 0;
      $scope.formData.items.forEach(function (item) {
        item.attachments.forEach(function (attachment) {
          fileSize += attachment.size;
        });
      });
      var isTooBig = fileSize >= $scope.fileSizeLimit;

      if (isTooBig) {
        toaster.error(beforeSend === true ? 'ISSUE.FILES_ERROR_TOO_BIG' : 'ISSUE.FILES_ERROR_TOO_BIG_WARNING');
      }

      return isTooBig;
    };
    /**
     * Submit and send issue data to AX
     */


    $scope.submitIssue = function () {
      var localErrors = $scope.preSubmitErrors();

      if (localErrors.length) {
        toaster.error(localErrors.join('\n'));
        return $q.reject();
      }

      if ($scope.checkFilesSize(true)) {
        return;
      }

      var formData = $scope.formData;
      $scope.issuePromise = issuesResource.postAX({
        id: formData.uniqid
      }, formData).$promise.then(function () {
        toaster.success(messages.issueSuccess);
        $state.go('issues.list');
      })["catch"](function (err) {
        toaster.error(err && err.data || 'GLOBAL.UNKNOWN_ERROR');
      });
      return $scope.issuePromise;
    };
    /**
     * Utility function to create FormData from a file.
     *
     * @param {File} file - File to be wrapped.
     *
     * @returns {FormData} - Form data with file kept in `file` key.
     */


    $scope.fileToFormData = function (file) {
      var formData = new FormData();
      formData.append("file", file);
      return formData;
    };
    /**
     * Add product to current issue
     */


    $scope.addProductToIssue = function (product) {
      var itemsCopy;

      if ($scope.itemEdit) {
        itemsCopy = $scope.formData.items.map(function (item) {
          if (item === $scope.itemEdit) {
            return product;
          }

          return item;
        });
      } else {
        itemsCopy = [].concat($scope.formData.items).concat(product);
      }

      return Object.assign({}, $scope.formData, {
        items: itemsCopy
      });
    };
    /**
     * Remove files from database.
     *
     * @param {Array} fileIds
     * @returns {Promise}
     */


    $scope.removeFilesFromDb = function (fileIds) {
      if (!fileIds) fileIds = [];
      var promises = [];
      fileIds.forEach(function (fid) {
        var promise = issuesResource.deleteAttachment({
          id: fid
        }).$promise;
        promises.push(promise);
      });
      return $q.all(promises);
    };
    /**
     * Add files to database.
     *
     * @param {Array} files
     * @returns {Promise}
     */


    $scope.addFilesToDb = function (productId, files) {
      if (!files) files = [];
      var promises = []; // Send new files

      files.forEach(function (file) {
        file.success = false;
        file.error = false;
        file.uploading = true;
        var formData = $scope.fileToFormData(file);
        var promise = issuesResource.createAttachment({
          item_id: productId
        }, formData).$promise; // Handle responses

        promise.then(function (resp) {
          file.uploading = false;
          file.success = true;
          file.uniqid = resp.uniqid; // Get edited item from formData

          var formItemEdit = $scope.formData.items.filter(function (i) {
            return i.uniqid == productId;
          })[0];
          if (!formItemEdit.attachments) formItemEdit.attachments = [];
          var newAttachments = formItemEdit.attachments.filter(function (a) {
            return a.uniqid != resp.uniqid;
          });
          newAttachments.push(resp);
          formItemEdit.attachments = newAttachments;
        })["catch"](function (err) {
          file.uploading = false;
          file.error = err.status;
        }); // Push to summary promise

        promises.push(promise);
      });
      return $q.all(promises);
    };
    /**
     * Set errors using data from http request.
     *
     * Useful when `catch`ing from a promise.
     *
     * @param {object} response - Response from a http request.
     */


    $scope.setErrors = function (response) {
      $scope.errors = response.data;
    };
    /**
     * Add new product to current issue and save issue to api
     * @param product
     */


    $scope.addNewProduct = function (product) {
      return $q(function (resolve, reject) {
        // Add product to current issue
        var sendData = $scope.addProductToIssue(product); // Null attachments to send them separately later

        var attachmentsToSend = product.attachments.filter(function (a) {
          return !a.uniqid;
        });
        sendData.attachments = undefined; // Send current issue to API

        return $scope.productPromise = issuesResource.put({
          id: $scope.formData.uniqid
        }, sendData).$promise.then(function (resp) {
          // If issue saved, save received data...
          $scope.formData = resp; // ...extract the new product _or_ get edited product...

          product = resp.items.filter(function (i) {
            return i.is_new;
          })[0];
          if (product) $scope.itemEdit = product; // ...and send new files to API.

          return $scope.addFilesToDb($scope.itemEdit.uniqid, attachmentsToSend).then(function () {
            resolve();
          })["catch"](function (err) {
            setTimeout(function () {
              $scope.addNewVisibility(true, $scope.itemEdit, document.getElementById($scope.itemEdit.uniqid));
            }, 10);
            reject("f");
          });
        })["catch"](function (err) {
          reject("p");
        });
      }).then(function () {
        $scope.addNewVisibility(false);
        toaster.success(messages.productSuccess);
        $scope.checkFilesSize(false);
      })["catch"](function (err) {
        // Error for (f)ile or (p)roduct
        if (err == "f") {
          toaster.error(messages.filesError);
        } else if (err == "p") {
          toaster.error(messages.productError);
        }
      });
    };
    /**
     * Validate product attributes (e.g. warranty_end_date)
     * @param product
     */


    $scope.validateProduct = function (product) {
      var itemsCopy = [].concat($scope.formData.items).concat(product);
      var sendData = Object.assign({}, $scope.formData, {
        items: itemsCopy
      });
      $scope.productPromise = issuesResource.check({
        id: $scope.formData.uniqid
      }, sendData).$promise;
      return $scope.productPromise;
    };
    /**
     * Helper function. Sets warranty attributes for product
     * with given uniqid.
     *
     * @param {string} uniqid           Unique ID
     * @param {string} warrantyEndDate  `warranty_end_date`
     * @param {string} warrantyTerms    `warranty_terms`
     */


    $scope.setWarrantyByUniqid = function (uniqid, warrantyEndDate, warrantyTerms) {
      var products = this.formData.items.filter(function (i) {
        return i.uniqid == uniqid;
      });

      if (products.length) {
        products[0].warranty_end_date = warrantyEndDate;
        products[0].warranty_terms = warrantyTerms;
      }
    };
    /**
     * Validate issue
     */


    $scope.validateIssue = function () {
      if ($scope.checkFilesSize(false)) {
        return;
      }

      $scope.errors = null;
      var localErrors = $scope.preSubmitErrors();

      if (localErrors.length) {
        $scope.errors = localErrors.join('<br>');
        return $q.reject();
      }

      $scope.issuePromise = issuesResource.check({
        id: $scope.formData.uniqid
      }, $scope.formData).$promise.then(function (issue) {
        // Update warranty with fetched data
        if (issue && issue.items.length) {
          issue.items.forEach(function (i) {
            $scope.setWarrantyByUniqid(i.uniqid, i.warranty_end_date, i.warranty_terms);
          });
        }

        return issuesResource.put({
          id: $scope.formData.uniqid
        }, $scope.formData).$promise;
      }).then(function () {
        toaster.success(messages.issueCheckSuccess);
      })["catch"](function (err) {
        toaster.error(err && err.data || 'GLOBAL.UNKNOWN_ERROR');
      });
      return $scope.issuePromise;
    };
    /**
     * Remove product from current issue, reload issue
     * @param product
     */


    $scope.removeProduct = function (product) {
      var newItems = $scope.formData.items.filter(function (elem) {
        return elem !== product;
      });
      var sendData = Object.assign($scope.formData, {
        items: newItems
      }); // Send current issue to API

      return $scope.productPromise = issuesResource.put({
        id: $scope.formData.uniqid
      }, sendData).$promise.then(function () {
        $scope.formData = sendData;
        toaster.success(messages.productDeleteSuccess);
      })["catch"](function () {
        toaster.success(messages.productDeleteError);
      });
    };
    /**
     * Show attachments for specified product.
     */


    $scope.showAttachmentsModal = function (product) {
      issueAttachmentsModal.show(product.attachments);
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @module app
   * @name issuesItemCtrl
   * @description
   * Controller displaying issue.
   */

  module.controller('issuesItemCtrl', ["$scope", "toaster", "issuesResource", "$state", "$stateParams", "$rootScope", "issueAttachmentsModal", function issuesItemCtrl($scope, toaster, issuesResource, $state, $stateParams, $rootScope, issueAttachmentsModal) {
    /**
     * Error message by default if the server returns an error and don't detail the cause.
     * @type {string}
     */
    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * Returns to the issues list router state.
     */

    $scope.goBack = function () {
      $state.go('issues.list');
    };
    /**
     * Show attachments for specified product id.
     */


    $scope.showAttachmentsModal = function (product) {
      issueAttachmentsModal.show(product.attachments);
    };
    /**
     * Retrieve issue info
     */


    if ($stateParams.id) {
      $scope.issue = issuesResource.get({
        id: $stateParams.id
      });
      $scope.issue.$promise["catch"](function (response) {
        toaster.error(response.data || $scope.defaultErrorMsg);
        $scope.goBack();
      });
    } else {
      $scope.goBack();
    }
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';

  module.controller('issueAttachmentsModal', ["$scope", "$rootScope", "issueAttachmentsModal", "attachments", "issueAttachmentDownload", function issueAttachmentsModal($scope, $rootScope, issueAttachmentsModal, attachments, issueAttachmentDownload) {
    $scope.attachments = attachments || [];

    $scope.downloadAttachment = function (attachment) {
      issueAttachmentDownload.downloadAttachment(attachment.attach_id);
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgNewReportProduct
   * @module app
   */

  sgIssuesNewProduct.$inject = ["productsResource", "issueProductAttachmentsResource", "$scope", "$rootScope", "$element", "toaster"];
  module.component('sgIssuesNewProduct', {
    templateUrl: 'app/issues/components/sgIssuesNewProduct.html',
    controller: sgIssuesNewProduct,
    controllerAs: 'vm',
    bindings: {
      submit: '<',
      validate: '<',
      visibility: '<',
      itemEdit: '<'
    }
  });
  /*@ngInject*/

  function sgIssuesNewProduct(productsResource, issueProductAttachmentsResource, $scope, $rootScope, $element, toaster) {
    var vm = this; // If product is in catalog (sku is in database) than value below is equal to that product, else empty

    vm.definedProduct = ''; // Track required empty fields. Update after field validation

    vm.required = {
      invoice_id: false
    }; // Track if there are any error in product form

    vm.hasErrorFields = false; // If vm.definedProduct exist - than fill name filed automatically and disable this field

    $scope.nameDisabled = false; // Currently added product model

    vm.item = {
      type: '',
      sku: '',
      ext_item_code: '',
      product_name: '',
      count: '',
      invoice_id: '',
      warranty_terms: '',
      warranty_end_date: '',
      serial_id: '',
      request: '',
      description: '',
      attachments: []
    };
    /**
     * Available issues types
     * @type {Object}
     */

    vm.issueTypes = $rootScope.issueTypes;
    /**
     * Available issues request
     * @type {Object}
     */

    vm.issueRequests = $rootScope.issueRequests;
    /**
     * Types mapping to requests
     * @type {Object}
     */

    vm.typesToRequests = $rootScope.dictionary.typeMap;
    /**
     * On component init we checking if component is in viewport, if not - scroll
     */

    function init() {
      var bounding = $element[0].getBoundingClientRect();

      if (bounding.top >= 0 && bounding.bottom >= (window.innerHeight || document.documentElement.clientHeight)) {
        window.scroll({
          top: bounding.top,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
    /**
     * Iterate through new product form fields and validate them
     */


    vm.checkFields = function () {
      if (!vm.item.type) {
        addErrorClass('type');
      }

      if (!vm.item.sku) {
        addErrorClass('sku');
      }

      if (!vm.item.product_name) {
        addErrorClass('product_name');
      }

      if (!vm.item.count) {
        addErrorClass('count');
      }

      if (!vm.item.invoice_id && (vm.item.type === 'Complaint' || vm.item.type === 'BackSent')) {
        addErrorClass('invoice_id');
      }

      if (!vm.item.request) {
        addErrorClass('request');
      }

      if (!vm.item.description) {
        addErrorClass('description');
      }

      if (vm.hasErrorFields) {
        return true;
      }

      return false;
    };
    /**
     * Get i18n key of specified upload error.
     */


    vm.getUploadErrorString = function (error) {
      switch (error) {
        case 413:
          return 'ISSUE.FILE_ERROR_TOO_BIG';

        case 400:
          return 'ISSUE.FILE_ERROR_TYPE';

        default:
          return 'ISSUE.FILE_ERROR_UNKNOWN';
      }
    };
    /**
     * Add product to current issue after validate all fields
     * @param item
     */


    vm.addItem = function (item) {
      var hasErrors = vm.checkFields();

      if (hasErrors) {
        return;
      }

      vm.submit(shouldAssignDefinedProduct(item));
    };
    /**
     * Remove specified file from product.
     * @param file
     */


    vm.deleteFile = function (file) {
      if (file.uniqid) {
        issueProductAttachmentsResource["delete"]({
          id: file.uniqid
        }).$promise.then(function () {
          vm.item.attachments = vm.item.attachments.filter(function (f) {
            return f != file;
          });
        })["catch"](function (err) {
          toaster.error(err && err.data || 'GLOBAL.UNKNOWN_ERROR');
        });
      } else {
        vm.item.attachments = vm.item.attachments.filter(function (f) {
          return f != file;
        });
      }
    };
    /**
     * Add error class and change value to true of in required object for given name of filed
     * Error flag is equal true
     * @param fieldName
     */


    function addErrorClass(fieldName) {
      vm.hasErrorFields = true;
      angular.element('[ng-model="' + 'vm.item.' + fieldName + '"]').addClass('error-field');
      vm.required[fieldName] = true;
    }
    /**
     * Remove error class and change value to false of in required object for given name of filed
     * If all needed fields has values - error flag is false, else true
     * @param fieldName
     */


    function removeErrorClass(fieldName) {
      for (var key in vm.required) {
        if (vm.required[key] === true) {
          break;
        } else {
          vm.hasErrorFields = false;
        }
      }

      angular.element('[ng-model="vm.item.' + fieldName + '"]').removeClass('error-field');
      vm.required[fieldName] = false;
    }
    /**
     * @ngdoc method
     * @name findProduct
     * @description Make a product search and returns the first 5 products matched.
     * @returns {Promise} Future
     */


    vm.findProduct = function (val) {
      //List of products to include and exclude
      var products = {
        include: [val + '*'],
        //Using Apache Lucene wildcards
        exclude: [],
        filterCatalogPrice: false,
        checkOnly: true
      };
      vm.typeaheadPromise = productsResource.query(null, products, 1, 5).then(function (results) {
        return (results.rows || []).map(function (item) {
          return {
            sku: item.sku,
            label: item.sku + ' - ' + item.name,
            product_name: item.name,
            qtyIncrements: item.qtyIncrements
          };
        });
      });
      return vm.typeaheadPromise;
    };
    /**
     * Set product for 'vm' object, check if product is currently in stalgast catalog
     * If so - product_name field is disabled and filled automatically, else - user type product_name field by himself.
     * @param item
     */


    vm.setDefinedProduct = function (item) {
      if (item && item.label) {
        vm.definedProduct = item;
        vm.item.product_name = item.product_name;
        removeErrorClass('product_name');
        $scope.nameDisabled = true;
      } else {
        vm.definedProduct = '';
        $scope.nameDisabled = false;
      }
    };
    /**
     * Prepare object to send to API, if sku of product exist than return argument,
     * else set sku as 'ext_item_code' and set sku to empty value
     * @param object
     * @returns object
     */


    function shouldAssignDefinedProduct(object) {
      var returnedObject = object; // If current item with given sku doesn't exist - send sku as ext_item_code

      if (!vm.definedProduct) {
        returnedObject = Object.assign({}, object, {
          ext_item_code: vm.item.sku,
          sku: ''
        });
      } else {
        returnedObject = Object.assign({}, object, {
          ext_item_code: '',
          sku: vm.item.sku
        });
      }

      return returnedObject;
    }

    ;
    /**
     * Check validity of field by elementKey param.
     * @param elementKey
     */

    vm.validateField = function (elementKey) {
      if ((elementKey === 'invoice_id' || elementKey === 'type') && vm.item.type !== 'Complaint' && vm.item.type !== 'BackSent') {
        vm.required.invoice_id = false;
        removeErrorClass('invoice_id'); // If invoice_id is empty byt not required (depend on vm.item.type) - return

        if (elementKey === 'invoice_id') {
          return;
        }
      }

      vm.required[elementKey] = vm.item[elementKey] ? false : true;

      if (vm.item[elementKey]) {
        removeErrorClass(elementKey);
      } else {
        addErrorClass(elementKey);
      }
    };
    /**
     * Change quantity of product
     * @param qty
     */


    vm.changeCount = function (qty) {
      if (vm.item.count) {
        vm.item.count += qty;
      } else {
        vm.item.count = 1;
      }

      vm.validateField('count');
    };

    $scope.$watch('vm.item.type', function (newValue) {
      vm.filteredRequests = vm.typesToRequests[newValue];
    });
    init(); // If item to edit is passed to component - user want to edit issue, not adding a new one

    if (vm.itemEdit) {
      // Parse item count to number because in count input only numbers are valid
      vm.itemEdit.count = parseInt(vm.itemEdit.count); // Assign editing item to item model in component

      vm.item = Object.assign({}, vm.itemEdit);
      vm.findProduct(vm.itemEdit.sku).then(function (result) {
        vm.itemEdit.label = result[0] && result[0].label;
        vm.setDefinedProduct(vm.itemEdit);
      }); // If item has ext_item_code instead of sku - assign it to sku model to display in component

      if (!vm.itemEdit.sku) {
        vm.item.sku = vm.itemEdit.ext_item_code;
      }
    }
  }
})(angular.module('app'));
"use strict";

(function (module, angular, Big) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:offersResource
   * @description
   * This service use the backend API to manage offers and its items.
   *
   * The offer items actions were implemented here because all the offer items HTTP requests returns a complete
   * snapshot of the offer (an its items). Managing the items in the same service ensure the update of the complete
   * offer properties every time a item of the offer change.
   *
   * It use response transformations to rectify the data returned by the server.
   * Check the {@link https://docs.angularjs.org/api/ngResource/service/$resource $resource docs} for
   * more information.
   */

  offersResource.$inject = ["$resource", "$http", "$q", "moment", "lodash", "websocket", "jsUtils", "offerConfig", "cartConfig", "collectionUtils", "resourceQueryPaginator", "offerItemModel"];
  module.factory('offersResource', offersResource);
  /*@ngInject*/

  function offersResource($resource, $http, $q, moment, lodash, websocket, jsUtils, offerConfig, cartConfig, collectionUtils, resourceQueryPaginator, offerItemModel) {
    var resource,
        paginator = resourceQueryPaginator(),
        idField = 'entity_id';
    /**
     * Stacks of transform functions to parse the server responses.
     *
     * @see https://docs.angularjs.org/api/ng/service/$http#default-transformations
     * @type {{forMulti: function[], forSingle: function[]}}
     */

    var transformStack = {
      forMulti: $http.defaults.transformResponse.concat(transformMulti),
      forSingle: $http.defaults.transformResponse.concat(transformSingle)
    };
    /**
     * Returns an object with the type properties of the model corrected.
     * @param {object} srcItem
     * @returns {object} Returns an object with the properties types corrected
     */

    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.entity_id = parseInt(item.entity_id, 10);
      item.items_count = parseInt(item.items_count, 10);
      item.items_qty = parseInt(item.items_qty, 10);
      item.subtotal = parseFloat(item.subtotal);
      item.grand_total = parseFloat(item.grand_total);
      item.customer_id = parseInt(item.customer_id, 10);
      item.created_at = moment(item.created_at).toDate();
      item.updated_at = moment(item.updated_at).toDate();
      item.sg_shipping_date = item.sg_shipping_date ? moment(item.sg_shipping_date).toDate() : null;
      item.add_prices = jsUtils.getBoolValue(item.add_prices);
      item.add_discounts = jsUtils.getBoolValue(item.add_discounts);
      item.add_images = jsUtils.getBoolValue(item.add_images);
      item.add_descriptions = jsUtils.getBoolValue(item.add_descriptions);
      item.hide_stalgast_items = jsUtils.getBoolValue(item.hide_stalgast_items);
      item.add_customer_logo = jsUtils.getBoolValue(item.add_customer_logo);
      item.add_stalgast_logo = jsUtils.getBoolValue(item.add_stalgast_logo);
      item.ignore_promo_price = jsUtils.getBoolValue(item.ignore_promo_price);
      item.item_id = item.item_id || 1;
      item.is_extended = item.is_extended ? true : false;

      if (item.hasOwnProperty('items') && angular.isArray(item.items)) {
        item.items = item.items.map(function (subitem) {
          return new offerItemModel(subitem);
        });
      }

      if (item.hasOwnProperty('items_extended') && angular.isArray(item.items_extended)) {
        item.items_extended = item.items_extended.map(function (subitem) {
          subitem.is_extended = true;
          return new offerItemModel(subitem);
        });
      }

      return item;
    };
    /**
     * Transform the response of a single element.
     * @param {object} data
     * @returns {object}
     */


    function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.offer || data) : data;
    }
    /**
     * Transform the response of a array of several elements.
     * @param {object} data
     * @returns {object}
     */


    function transformMulti(data) {
      return angular.isObject(data) ? (data.offers || data).map(transformItem) : data;
    }
    /**
     * Update, stealthily, the properties and items of the model.
     * This function should be called inside the execution context of the resource instance.
     * @param {object} response HTTP response with the entire cart data
     */


    function updateModel(response) {
      var updatedModel = response.data,
          oldModel = this; //We need to separate the updates

      var updatedHeader = lodash.omit(updatedModel, 'items', 'items_extended'),
          updatedItems = lodash.pick(updatedModel, 'items'),
          updatedItemsExtended = lodash.pick(updatedModel, 'items_extended'); //Updating header

      collectionUtils.updateObject(updatedHeader, oldModel, true); //Updating items

      if (!oldModel.hasOwnProperty('items') || !angular.isArray(oldModel.items)) {
        oldModel.items = [];
      } //Updating items_extended


      if (!oldModel.hasOwnProperty('items_extended') || !angular.isArray(oldModel.items_extended)) {
        oldModel.items_extended = [];
      }

      collectionUtils.updateCollection(updatedItems.items, oldModel.items, 'item_id', true);
      collectionUtils.updateCollection(updatedItemsExtended.items_extended, oldModel.items_extended, 'item_id', true);
      return oldModel;
    }
    /**
     * Resource for offer management.
     * Note: This instance will be returned by this service.
     */


    resource = $resource(offerConfig.restful.offers, {
      id: '@' + idField
    }, {
      //List of offers
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo(transformStack.forMulti)
      },
      //Offer creation (empty, without items)
      'save': {
        method: 'POST',
        isArray: false,
        transformResponse: transformStack.forSingle
      },
      //Offer extended creation (empty, without items)
      'saveExtended': {
        method: 'POST',
        url: offerConfig.restful.offerItemsExtended,
        isArray: false,
        transformResponse: transformStack.forSingle
      },
      //Offer update (just offer, no items)
      'update': {
        method: 'PUT',
        isArray: false,
        transformResponse: transformStack.forSingle
      },
      //Obtain offer (with items)
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: transformStack.forSingle
      }
    }); //Applying the pagination support to the "query" method

    paginator.applyToResource(resource, 'query');
    /**
     * @ngdoc method
     * @name createFromCart
     * @description
     * Order the backend to create a new offer based on a specific cart.
     * @param {number} cartId ID of the cart
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */

    resource.createFromCart = function (cart, success, failure) {
      var url = cartConfig.restful.carts.replace('/:id', '/toOffer'),
          payload = {
        cartId: cart.id
      };

      if (typeof cart.newName !== 'undefined') {
        payload.name = cart.newName;
      }

      return $http.post(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(function (response) {
        return new resource(response.data);
      }).then(success, failure);
    };
    /*
    * ADDING ACTIONS FOR MANAGE OFFER ITEMS
    */

    /**
     * @ngdoc method
     * @name $addItem
     * @description
     * Add a new item to the offer.
     * The properties of the cart are updated automatically if the backend respond for this call is successful
     * @param {object} item
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.prototype.$addItem = function (item, success, failure) {
      var me = this,
          url,
          payload;

      if (item.price) {
        url = offerConfig.restful.offerItemsExtended.replace('/:id', '');
        payload = {
          offer_id: me[idField],
          items_extended: [{
            sku: item.sku,
            name: item.name,
            brand: item.brand,
            qty: item.qty,
            price: parseFloat(item.price.replace(',', '.')),
            discount: angular.isNumber(item.discount) ? item.discount : 0
          }]
        };
      } else {
        url = offerConfig.restful.offerItems.replace('/:id', '');
        payload = {
          offer_id: me[idField],
          items: [{
            sku: item.sku,
            qty: item.qty,
            discount: angular.isNumber(item.discount) ? item.discount : 0
          }]
        };
      }

      return $http.post(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateModel)).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name $updateItem
     * @description
     * Update one or more items of the offer.
     * The properties of the cart are updated automatically if the backend respond for this call is successful
     * @param {object|object[]} item_or_items
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.prototype.$updateItem = function (item_or_items, success, failure) {
      var me = this,
          url = offerConfig.restful.editOffer.replace(':id', me[idField]),
          items = !angular.isArray(item_or_items) ? [item_or_items] : item_or_items,
          payload,
          payloadItems = {},
          payloadExtended = {};
      var item = items.filter(function (item) {
        return !item.is_extended;
      });
      var item_extended = items.filter(function (item) {
        return item.is_extended;
      });

      if (item.length > 0) {
        payloadItems = {
          items: item.map(function (item) {
            return {
              sku: item.sku,
              qty: item.qty,
              discount: angular.isNumber(item.discount) ? item.discount : 0
            };
          })
        };
      }

      if (item_extended.length > 0) {
        payloadExtended = {
          items_extended: item_extended.map(function (item) {
            return {
              item_id: item.item_id,
              sku: item.sku,
              name: item.name,
              brand: item.brand,
              qty: item.qty,
              price: parseFloat(item.price.toString().replace(',', '.')),
              discount: angular.isNumber(item.discount) ? item.discount : 0
            };
          })
        };
      }

      payload = Object.assign({}, payloadItems, payloadExtended);
      return $http.put(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateModel)).then(success, failure);
    };
    /**
     * Request backend to generate offer file and send it by email.
     *
     * @param {string} fileType
     * @returns {Promise}
     */


    resource.prototype.mailMe = function (fileType) {
      var me = this;
      return $resource(offerConfig.restful.mail, {
        id: '@id'
      }).save({
        id: me[idField],
        fileType: fileType
      }).$promise;
    };
    /**
     * @ngdoc method
     * @name $removeItem
     * @description
     * Remove an item from the offer.
     * The properties of the offer are updated automatically if the backend respond for this call is successful
     * @param {object|object[]} item_or_items
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.prototype.$removeItem = function (item_or_items, success, failure) {
      var me = this,
          url = offerConfig.restful.editOffer.replace(':id', me[idField]),
          items = !angular.isArray(item_or_items) ? [item_or_items] : item_or_items,
          payloadItem = {};
      var item = items.filter(function (item) {
        return !item.is_extended;
      });
      var item_extended = items.filter(function (item) {
        return item.is_extended;
      });

      if (item.length > 0) {
        payloadItem.items = {
          sku: item.map(function (item) {
            return item.sku;
          })
        };
      }

      if (item_extended.length > 0) {
        payloadItem.items_extended = item_extended.map(function (item) {
          return {
            item_id: item.item_id
          };
        });
      }

      return $http["delete"](url, {
        data: payloadItem,
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateModel)).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name isPhantom
     * @description
     * Returns TRUE if the offer doesn't have an ID yet.
     * @returns {boolean}
     */


    resource.prototype.isPhantom = function () {
      return !(this.hasOwnProperty(idField) && angular.isNumber(this[idField]) && this[idField] > 0);
    };
    /**
     * Check if the current offer can be converted into a cart.
     * @return {boolean}
     */


    resource.prototype.hasItems = function () {
      if (this && !this.isPhantom()) {
        if (angular.isArray(this.items) && this.items.length > 0) {
          return true;
        }
      }

      return false;
    };
    /**
     * Obtain the availability status of a bunch of products and quantities (cart items).
     * @param {object[]} cartItems
     * @returns {$q}
     */


    resource.getAvailability = function (cartItems) {
      return $q(function (resolve, reject) {
        websocket.emit('cart.getAvailabilityOfItems', cartItems, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Obtain and update the availability status of the current cart's items.
     * @returns {$q} Promise returning the same current model instance
     */


    resource.prototype.refreshAvailability = function () {
      var model = this,
          items = (model.items || []).map(function (item) {
        return {
          sku: item.sku,
          qty: item.qty
        };
      });

      if (items.length) {
        return resource.getAvailability(items).then(function (availabilityReport) {
          var report = availabilityReport.map(function (item) {
            return {
              sku: item.sku,
              available: item.available,
              qtyIncrements: item.qtyIncrements,
              stock: item.stock,
              dlvDate: item.dlvDate
            };
          });
          collectionUtils.updateCollection(report, model.items, 'sku', true);
          return model;
        });
      } else {
        return $q.resolve(model);
      }
    };
    /**
     * Returns the ID of the current model.
     * @return {number}
     */


    resource.prototype.getId = function () {
      return this[idField];
    };
    /**
     * Returns the net amount of the all available products.
     * @return {number}
     */


    resource.prototype.calAvailableNetAmount = function () {
      var sumRegular = lodash.reduce(this.items, function (prevValue, item) {
        return prevValue.plus(item.calAvailableNetAmount());
      }, new Big(0));
      var sumAll = lodash.reduce(this.items_extended, function (prevValue, item) {
        return prevValue.plus(item.row_total_excl_tax);
      }, sumRegular);
      return parseFloat(sumAll.toFixed(2));
    };
    /**
     * Returns the gross amount of the all available products.
     * @return {number}
     */


    resource.prototype.calAvailableGrossAmount = function () {
      var netAmout = this.calAvailableNetAmount();
      return parseFloat(netAmout.toFixed(2)) + parseFloat(netAmout.toFixed(2)) * 0.23;
    };
    /**
     * Returns the file content of the offer as a Blob object.
     * Note: This file is created by the backend.
     *
     * @param {string} fileType
     * @return {Promise} The promise resolve a single Blob object and in case of error rejects an error string.
     */


    resource.prototype.getFileDocument = function (fileType) {
      if (this.isPhantom()) {
        return $q.reject('Offer does not have an ID');
      }

      var offerId = encodeURIComponent(this[idField]),
          url = offerConfig.documentUrl.replace(':id', offerId),
          payload = {
        fileType: fileType
      };
      return $http.post(url, payload, {
        responseType: 'blob'
      }).then(function (response) {
        return response;
      }, function (response) {
        return $q.reject(response.statusText);
      });
    };
    /**
     * Returns the list of available file formats an offer can be exported to.
     *
     * @return {Promise}
     */


    resource.prototype.getFileExportTypes = function () {
      return $http.get(offerConfig.restful.fileExportType).then(function (response) {
        return response.data;
      }, function (response) {
        return $q.reject(response.statusText);
      });
    };

    return resource;
  }
})(angular.module('app'), angular, Big);
"use strict";

(function (module) {
  'use strict';

  module.factory('offerItemModel', ["moment", "lodash", "offerConfig", function (moment, lodash, offerConfig) {
    return function (initialData) {
      var me = this,

      /**
       * Decimal precision to use when calculate the net and gross amounts of available products.
       * @type {number}
       */
      amountsPrecision = offerConfig.decimalPrecision || 4;

      if (initialData) {
        initialData.item_id = parseInt(initialData.item_id, 10);
        initialData.is_extended = initialData.is_extended ? true : false;
        initialData.brand = initialData.brand ? initialData.brand : '';
        initialData.offer_id = parseInt(initialData.offer_id, 10);
        initialData.qty = parseInt(initialData.qty, 10);
        initialData.price = parseFloat(initialData.price);
        initialData.discount = parseFloat(initialData.discount);
        if (isNaN(initialData.discount)) initialData.discount = 0;
        initialData.promotion_price = parseFloat(initialData.promotion_price);
        initialData.reseller_price = parseFloat(initialData.reseller_price);
        initialData.row_total_excl_tax = parseFloat(initialData.row_total_excl_tax);
        initialData.row_total_incl_tax = parseFloat(initialData.row_total_incl_tax);
        initialData.product_id = parseInt(initialData.product_id, 10);
        initialData.created_at = moment(initialData.created_at).toDate();
        initialData.updated_at = moment(initialData.updated_at).toDate();
        Object.assign(me, initialData);
      }
      /**
       * Calculate and returns the net amount of one product.
       * @returns {number}
       */


      me.calUnitNetAmount = function () {
        if (me.itemExists() && me.qty >= 0) {
          return parseFloat(new Big(me.row_total_excl_tax || 0).div(me.qty).toFixed(amountsPrecision));
        }

        return 0;
      };
      /**
       * Calculate and returns the gross amount of one product.
       * @returns {number}
       */


      me.calUnitGrossAmount = function () {
        if (me.itemExists() && me.qty >= 0) {
          return parseFloat(new Big(me.row_total_incl_tax || 0).div(me.qty).toFixed(amountsPrecision));
        }

        return 0;
      };
      /**
       * Calculate and returns the net amount of the quantity of available units.
       * @returns {number}
       */


      me.calAvailableNetAmount = function () {
        var unitAmount = me.calUnitNetAmount();
        var stockVisible = me.calculateVisibleStock();
        console.log('calAvailableNetAmount');
        console.log(unitAmount);
        console.log(stockVisible);

        if (stockVisible && stockVisible > 0) {
          return parseFloat(new Big(unitAmount).times(stockVisible).toFixed(amountsPrecision));
        }

        return 0;
      };
      /**
       * Calculate and returns the gross amount of the quantity of available units.
       * @returns {number}
       */


      me.calAvailableGrossAmount = function () {
        var unitAmount = me.calUnitGrossAmount();
        var stockVisible = me.calculateVisibleStock();
        console.log('calAvailableGrossAmount');
        console.log(unitAmount);
        console.log(stockVisible);

        if (stockVisible && stockVisible > 0) {
          return parseFloat(new Big(unitAmount).times(stockVisible).toFixed(amountsPrecision));
        }

        return 0;
      };
      /**
       * Return the stock quantity that should be visible to the user.
       * @returns {number|null} It will return NULL if there's no enough data to calculate a value
       */


      me.calculateVisibleStock = function () {
        if (me.hasOwnProperty('sku') && me.hasOwnProperty('stock')) {
          //If the stock is infinity always return the value of the quantity requested
          if (me.stock === -1) {
            return me.qty;
          }

          return lodash.min([me.qty, me.stock]);
        }

        return null;
      };
      /**
       * Ask if the item belong to the cart (has already an ID).
       * @returns {boolean}
       */


      me.itemExists = function () {
        return me.hasOwnProperty('item_id') && me.item_id > 0;
      };
      /**
       * Ask if the current item is in sale.
       * @returns {boolean}
       */


      me.itemIsInSale = function () {
        if (angular.isNumber(me.promotion_price) && me.promotion_price > 0) {
          return me.promotion_price !== me.price;
        }

        return false;
      }; //Never copy this functions to another object. This functions are just mine!


      Object.defineProperties(me, {
        "calUnitNetAmount": {
          enumerable: false
        },
        "calAvailableNetAmount": {
          enumerable: false
        },
        "calUnitGrossAmount": {
          enumerable: false
        },
        "calAvailableGrossAmount": {
          enumerable: false
        },
        "calculateVisibleStock": {
          enumerable: false
        },
        "itemExists": {
          enumerable: false
        },
        "itemIsInSale": {
          enumerable: false
        }
      });
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name offerListCtrl
   * @description
   * Controller for show the list of offers available for the current user.
   */

  cartListCtrl.$inject = ["$state", "$scope", "$translate", "offersResource", "paginationManager", "offerConfig"];
  module.controller('offerListCtrl', cartListCtrl);
  /*@ngInject*/

  function cartListCtrl($state, $scope, $translate, offersResource, paginationManager, offerConfig) {
    var vm = this;
    vm.waitMsg = $translate.instant('GLOBAL.LOADING_DATA');
    vm.errorMsg = ''; //Obtaining the list of offers

    $scope.paginator = paginationManager($scope, 'offer', offersResource.query, clearErrorMsg, showErrorMsg);
    $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : offerConfig.list.pageSize;
    $scope.paginator.page = 1;
    /**
     * Clear the error message.
     */

    function clearErrorMsg() {
      vm.errorMsg = '';
    }
    /**
     * Show an error.
     * @param {string} [err='GLOBAL.LIST_NOT_AVAILABLE']
     */


    function showErrorMsg(err) {
      vm.errorMsg = err || 'GLOBAL.LIST_NOT_AVAILABLE';
    }
    /**
     * Move to the router state for create a new offer.
     */


    vm.startNewOffer = function () {
      $state.go('offer.new');
    };
    /**
     * Active the offer given and show its content to the user.
     * @param {object} offerModel
     */


    vm.openOffer = function (offerModel) {
      $state.go('offer.update', {
        id: offerModel.entity_id
      });
    };
    /**
     * Delete the offer given and update the list.
     * @param {object} offerModel
     */


    vm.deleteOffer = function (offerModel) {
      offerModel.$remove(function () {
        $scope.paginator.refresh();
      });
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @module app
   * @name offerEditorCtrl
   * @description
   * Controller for create or update a offer.
   */

  offerEditorCtrl.$inject = ["$state", "$stateParams", "$translate", "toaster", "offersResource", "cartsResource", "sessionAccess", "convertToModal"];
  module.controller('offerEditorCtrl', offerEditorCtrl);
  /*@ngInject*/

  function offerEditorCtrl($state, $stateParams, $translate, toaster, offersResource, cartsResource, sessionAccess, convertToModal) {
    var vm = this;

    if ($stateParams.hasOwnProperty('id')) {
      vm.model = offersResource.get({
        id: $stateParams.id
      });
    } else {
      vm.model = new offersResource();
    }
    /**
     * Read and clear failed items from last conversion
     */


    vm.itemsFailed = angular.copy(convertToModal.failedItems);
    convertToModal.failed = null; //ACCESS KEYS

    vm.access = sessionAccess.areActionsAllowed(['offers.edit', 'offerItems.add', 'offerItems.edit', 'offerItems.delete']);
    /**
     * Returns to the list.
     */

    vm.goBack = function () {
      $state.go('offer.list');
    };
    /**
     * When a new offer is created this function update the current router state to the "Update offer" mode without
     * really exit the "Create offer" mode.
     * @param {object} offerModel
     */


    vm.changeToUpdateMode = function (offerModel) {
      $state.go('offer.update', {
        id: offerModel.entity_id
      }, {
        notify: false
      });
    };
    /**
     * Request the conversion of the current offer to a cart.
     */


    vm.convertToCart = function () {
      convertToModal.show(vm.model.name, false, 'OFFER').then(function (data) {
        cartsResource.createFromOffer({
          id: vm.model.entity_id,
          newName: data.name
        }).then(function (cartModel) {
          if (data.remove === true) {
            vm.model.$remove();
          }

          vm.openCart(cartModel);
        }, toaster.error);
      });
    };
    /**
     * Open the cart editor with the cart given.
     * @param {object} cartModel
     */


    vm.openCart = function (cartModel) {
      $state.go('cart.update', {
        id: cartModel.entity_id
      });
    };
    /**
     * Returns a hint to show when the user cannot convert the current offer into a cart.
     * @return {string}
     */


    vm.getConvertToCartHint = function () {
      return vm.model.hasItems() ? '' : $translate.instant('OFFER.CANT_BE_CONVERTED_TO_CART');
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  "use strict";
  /**
   * @ngdoc component
   * @name sgOfferReferForm
   * @module app
   * @description
   * Show a form to edit the refer information of an offer.
   */

  module.component('sgOfferReferForm', {
    templateUrl: 'app/offer/components/offerReferForm.html',
    controllerAs: 'vm',
    bindings: {
      model: '=',
      editable: '<'
    }
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgOfferOptionsForm
   * @module app
   * @description
   * Show a form to edit the property options of an offer.
   */

  module.component('sgOfferOptionsForm', {
    templateUrl: 'app/offer/components/offerOptionsForm.html',
    controllerAs: 'vm',
    controller: sgOfferOptionsForm,
    bindings: {
      model: '=',
      editable: '<',
      exportFileTypes: '<',
      exportFileType: '='
    }
  });
  /*@ngInject*/

  function sgOfferOptionsForm() {
    var vm = this;
    /**
     * List of all the available offer options.
     * @type {string[]}
     */

    vm.opts = ['add_discounts', 'add_images', 'add_descriptions', 'hide_stalgast_items', 'add_customer_logo', 'add_stalgast_logo'];
    /**
     * Create and returns a object with all the available options with the value given as argument.
     * @param {*} defaultValue
     * @return {object}
     */

    function buildModificator(defaultValue) {
      var obj = {};
      vm.opts.forEach(function (opt) {
        obj[opt] = defaultValue;
      });
      return obj;
    }
    /**
     * Select all the options.
     */


    vm.selectAll = function () {
      Object.assign(vm.model, buildModificator(true));
    };
    /**
     * Deselect all the options.
     */


    vm.clearSelection = function () {
      Object.assign(vm.model, buildModificator(false));
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name sgOfferListFilters
   * @description
   * Input filters for offer list.
   */

  module.component('sgOfferListFilters', {
    templateUrl: 'app/offer/components/offerListFilters.html',
    controllerAs: 'vm',
    bindings: {
      originalFilters: '=filters'
    },
    controller: ["$scope", "lodash", function ($scope, lodash) {
      var vm = this;

      vm.$onInit = function () {
        vm.filters = {}; //A different store for dates is used because the local format is shown but the YYYY-MM-DD is sent
        //The datepicker lib take the viewValue as value source

        $scope.$watch('vm.filters[\'filter[created_at][from]\']', function (value) {
          setFilter('filter[created_at][to]', value);
        }); //If the real filters change, update the working filters model

        $scope.$watch('vm.originalFilters', function (originalFilters) {
          vm.filters = angular.copy(originalFilters || {});
          vm.filters['filter[created_at][to]'] = vm.filters['filter[created_at][from]'];
        });
      };
      /**
       * Apply the changes on the inputs over the real filters.
       */


      vm.applyChanges = function () {
        vm.originalFilters = getFilters();
      };
      /**
       * Set the value of one unique filter.
       * @param {string} name
       * @param {*} value
       */


      function setFilter(name, value) {
        if (angular.isDefined(value) && value !== null) {
          vm.filters[name] = value;
        } else {
          delete vm.filters[name];
        }
      }
      /**
       * Checks if are pending changes in the filters to apply.
       * @returns {boolean}
       */


      vm.pendingChanges = function () {
        return !angular.equals(getFilters(), vm.originalFilters || {});
      };
      /**
       * Clear all the active filters.
       */


      vm.clearFilters = function () {
        vm.originalFilters = {};
      };
      /**
       * Check if there any filter currently active.
       * @return {boolean}
       */


      vm.filtersAreClear = function () {
        return angular.equals(getFilters() || {}, {});
      };
      /**
       * Return the filters.
       * @return {Object}
       */


      function getFilters() {
        return lodash.pickBy(vm.filters, function (value) {
          return angular.isString(value) ? !!value : true;
        });
      }
    }]
  });
})(angular.module('app'));
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgOfferItems
   * @description
   * Show the items of a offer.
   */

  /*@ngInject*/

  sgOfferItems.$inject = ["$scope", "$timeout", "$translate", "lodash", "toaster", "domUtils", "$compile", "$window", "cardFileService"];
  module.directive('sgOfferItems', function () {
    return {
      templateUrl: 'app/offer/components/offerItems.html',
      controller: sgOfferItems,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        /**
         * Offer model.
         * @type {object}
         */
        model: '=',
        allowAddItems: '<',
        allowEditItems: '<',
        allowRemoveItems: '<',
        selectable: '<?',
        selection: '=?',
        onRequestAdd: '&?',
        onRequestUpdate: '&',
        onRequestRemove: '&',
        onRequestRemoveMulti: '&',
        promiseOfferChanged: '<',
        itemsWaiting: '<',
        formStep: '<?'
      },
      link: function link(scope, element) {
        scope.vm.getCreatorRow = function () {
          return element.find('tr.add-new-item');
        };
      }
    };
  });
  /*@ngInject*/

  function sgOfferItems($scope, $timeout, $translate, lodash, toaster, domUtils, $compile, $window, cardFileService) {
    var vm = this;
    /**
     * List of used SKUs in the current offer.
     * @type {String[]}
     */

    vm.usedSKUs = [];
    /**
     * List of selected SKUs for batch operations.
     * @type {String[]}
     */

    vm.selectedSKUs = [];
    /**
     * Translated labels for passed to the template.
     * The translations is made here to reduce the number of scope watchers.
     * @type {Object}
     */

    vm.labels = $translate.instant(['GLOBAL.REMOVE_SELECTION', 'GLOBAL.ARE_YOU_SURE', 'GLOBAL.YES', 'GLOBAL.NO', 'GLOBAL.REMOVE_SELECTION', 'GLOBAL.DOWNLOAD_CARD_FOR_SELECTED']);
    /**
     * Stack of all the offer items selected for batch operations.
     * @type {Object[]}
     */

    vm.selection = angular.isArray(vm.selection) ? vm.selection : [];
    vm.selectionExtended = angular.isArray(vm.selectionExtended) ? vm.selectionExtended : [];
    /**
     * Indicate if all the items are currently selected.
     * @type {boolean}
     */

    vm.areAllSelected = false;
    vm.areAllSelectedExtended = false;
    /**
     * Select or deselect all the items.
     * @param {boolean} select
     */

    vm.applyBatchSelection = function (select) {
      vm.model.items.forEach(function (item) {
        vm.updateSelection(item, select);
      });
    };

    vm.applyBatchSelectionExtended = function (select) {
      vm.model.items_extended.forEach(function (item) {
        vm.updateSelectionExtended(item, select);
      });
    };
    /**
     * @ngdoc method
     * @name isCartLoaded
     * @returns {boolean}
     */


    vm.isCartLoaded = function () {
      if (angular.isObject(vm.model)) {
        return !vm.model.isPhantom();
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name isProductInOffer
     * @param {string} sku
     * @returns {boolean}
     */


    vm.isProductInOffer = function (sku) {
      return lodash.findIndex(vm.model.items, {
        sku: sku
      }) >= 0 || lodash.findIndex(vm.itemsWaiting, {
        sku: sku
      }) >= 0;
    };
    /**
     * @ngdoc method
     * @name requestAdd
     * @description
     * This method order the creation of the new item only if the product isn't already in the current offer.
     * @param {object} item
     * @returns {boolean}
     */


    vm.requestAdd = function (item) {
      //Don't order creation if the product code is already in the list
      if (!vm.isProductInOffer(item.sku)) {
        vm.onRequestAdd({
          item: item
        });
        vm.usedSKUs.push(item.sku);
      } else {
        toaster.error('OFFER.PRODUCT_ALREADY_IN_OFFER');
      }
    };
    /**
     * @ngdoc method
     * @name updateSelection
     * @description
     * Update the array of selected items.
     * @returns {boolean}
     */


    vm.updateSelection = function (item, selected) {
      if (selected) {
        //Adding
        if (!vm.isSelected(item)) {
          vm.selection.push(item);
        }
      } else {
        //Removing
        lodash.remove(vm.selection, {
          sku: item.sku
        });
      }
    };
    /**
     * @ngdoc method
     * @name updateSelectionExtended
     * @description
     * Update the array of selected items_extended.
     * @returns {boolean}
     */


    vm.updateSelectionExtended = function (item, selected) {
      if (selected) {
        //Adding
        if (!vm.isSelectedExtended(item)) {
          vm.selectionExtended.push(item);
        }
      } else {
        //Removing
        lodash.remove(vm.selectionExtended, {
          item_id: item.item_id
        });
      }
    };
    /**
     * @ngdoc method
     * @name clearSelection
     * @description
     * Un-select all the selected items.
     * @returns {boolean}
     */


    vm.clearSelection = function () {
      vm.selection = [];
    };
    /**
     * @ngdoc method
     * @name removeAllSelected
     * @description
     * Send the order to remove all the selected items.
     * @returns {boolean}
     */


    vm.removeAllSelected = function () {
      var allSelected = [].concat(vm.selection).concat(vm.selectionExtended);
      vm.onRequestRemoveMulti({
        items: allSelected
      });
    };
    /**
     * @ngdoc method
     * @name isSelected
     * @description
     * Query if the given offer item is selected.
     * @returns {boolean}
     */


    vm.isSelected = function (item) {
      return vm.selectedSKUs.indexOf(item.sku) >= 0;
    };

    vm.isSelectedExtended = function (item) {
      var isSelect = vm.selectionExtended.filter(function (elem) {
        return elem.item_id === item.item_id;
      });

      if (isSelect.length === 1) {
        return true;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name pruneSelection
     * @description
     * Remove from the selection array all the items which no longer are part of the offer.
     * @returns {boolean}
     */


    vm.pruneSelection = function () {
      lodash.remove(vm.selection, function (item) {
        return lodash.findIndex(vm.model.items, {
          sku: item.sku
        }) === -1;
      });
    };
    /**
     * Apply a discount to the selected items.
     */


    vm.applyBatchDiscount = function () {
      var normalAndExtended;
      var discount = vm.batchDiscount || 0;

      if (vm.selection.length === 0 && vm.selectionExtended.length === 0) {
        return;
      }

      if (vm.selection.length > 0 && vm.selectionExtended.length > 0) {
        normalAndExtended = [].concat(vm.selection).concat(vm.selectionExtended);
        vm.onRequestUpdate({
          item: normalAndExtended.map(function (item) {
            return Object.assign(angular.copy(item), {
              discount: discount
            });
          })
        });
      } else if (vm.selection.length > 0) {
        vm.onRequestUpdate({
          item: vm.selection.map(function (item) {
            return Object.assign(angular.copy(item), {
              discount: discount
            });
          })
        });
      } else if (vm.selectionExtended.length > 0) {
        vm.onRequestUpdate({
          item: vm.selectionExtended.map(function (item) {
            return Object.assign(angular.copy(item), {
              discount: discount
            });
          })
        });
      }
    };
    /**
     * @ngdoc method
     * @name downloadCardForSelected
     * @methodOf app.directive:sgCartItems
     * @description Download PDF card for selected items
     * @returns {boolean}
     */


    vm.downloadCardForSelected = function () {
      var skus = getSelectedSKUs();
      cardFileService.downloadOfferCard(vm.model.entity_id, skus);
    };
    /**
     * @ngdoc method
     * @name getUsedSKUs
     * @description
     * Returns a list with all the SKUs used actually in the offer.
     * @returns {string[]}
     */


    function getUsedSKUs() {
      var itemsWaiting = vm.itemsWaiting || [];

      if (angular.isObject(vm.model) && vm.model.hasOwnProperty('items') && angular.isArray(vm.model.items)) {
        return vm.model.items.map(function (item) {
          return item.sku;
        }).concat(itemsWaiting.map(function (item) {
          return item.sku;
        }));
      }

      return [];
    }
    /**
     * @ngdoc method
     * @name getSelectedSKUs
     * @description
     * Returns a list with all the SKUs selected for batch operations.
     * @returns {string[]}
     */


    function getSelectedSKUs() {
      if (angular.isArray(vm.selection)) {
        return vm.selection.map(function (item) {
          return item.sku;
        });
      }

      return [];
    }
    /**
     * Function executed after a new item is detected.
     * It maintain visible the row to add new items always visible.
     */


    function afterAddNewItem() {
      if (vm.editable === true) {
        //$timeout used with delay 0 because this need to be executed in the next digest cycle
        $timeout(function () {
          var creatorItem = vm.getCreatorRow();

          if (!domUtils.itemIsVisible(creatorItem, 140)) {
            //FIXME WTF this arbitrary value is doing here!
            domUtils.scrollToItem(creatorItem, 140);
          }
        }, 0);
      }
    }

    vm.upDate = function () {
      lodash.remove(vm.selectionExtended, function (item) {
        return lodash.findIndex(vm.model.items_extended, {
          item_id: item.item_id
        }) === -1;
      });
    }; //Prune the selection array every time a change is detected in the items list


    $scope.$watchCollection('vm.model.items', vm.pruneSelection); //Prune the selection array every time a change is detected in the items_extended list

    $scope.$watchCollection('vm.model.items_extended', vm.upDate); //Maintain the selectedSKUs variable updated and the "areAllSelected" variable

    $scope.$watchCollection('vm.selection', function () {
      vm.selectedSKUs = getSelectedSKUs(); //Check if all the element are currently selected

      vm.areAllSelected = angular.isArray(vm.model.items) && vm.model.items.length ? vm.model.items.length === vm.selection.length : false;
    }); //Maintain the "usedSKUs" variable updated

    $scope.$watchCollection('vm.model.items', function (newItems, oldItems) {
      vm.usedSKUs = getUsedSKUs(); //Detect when new items are added to the table

      if (angular.isArray(newItems) && angular.isArray(oldItems) && newItems.length > oldItems.length) {
        afterAddNewItem();
      }
    });
    $scope.showExtended = vm.model.items_extended.length > 0;
  }
})(angular.module('app'), angular);
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgOfferItemExtended
   * @description Row to represent a item of an offer.
   *
   * This a directive instead of a component because is used in a TR tag (inside a HTML table).
   */

  /*@ngInject*/

  sgOfferItemExtended.$inject = ["$scope", "$timeout", "$translate", "lodash", "productsResource", "domUtils", "collectionUtils", "toaster"];
  module.directive('sgOfferItemExtended', ["$timeout", function ($timeout) {
    return {
      restrict: 'AE',
      templateUrl: 'app/offer/components/offerItemExtended.html',
      controller: sgOfferItemExtended,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        model: '<',
        editable: '<?',
        removable: '<?',

        /**
         * Position in the items offer's list.
         */
        position: '<',

        /**
         * Show a checkbox to select this item.
         */
        selectable: '<',
        isSelectedExtended: '<?',

        /**
         * Array with the SKUs that shouldn't be include in the product searches.
         */
        skuExcludeList: '<',
        onRequestCreate: '&?',
        onRequestUpdate: '&?',
        onRequestRemove: '&?',
        onSelectionChange: '&?',
        isProductInOffer: '<',
        formStep: '<?'
      },
      link: function link(scope, element) {
        /**
         * Focus a specific input field.
         * @param {string} name Name of the field (input param "name")
         * @param {number} [delay] Delay (in ms) the focusing
         */
        scope.vm.focusField = function (name, delay) {
          if (isFinite(delay) && delay > 0) {
            $timeout(function () {
              scope.vm.focusField(name);
            }, delay);
          }
          /* NOTE: This css selector is too complex to be handler by the jqlite of Angular 1.5.
           * This will continuing to work only if jQuery library is also used in this project.
           */


          element.find('input[name=' + name + ']:not([readonly])').focus().select();
        }; //Making the element node available to the controller


        scope.vm.element = element;
      }
    };
  }]);
  /*@ngInject*/

  function sgOfferItemExtended($scope, $timeout, $translate, lodash, productsResource, domUtils, collectionUtils, toaster) {
    var vm = this;
    vm.workCopy = {};
    vm.qtyValid = true;
    vm.qtyIncValid = true;
    vm.isSelected = false;
    /**
     * Scope variable used to check if list of searched products is shown.
     * For more details about this variable see the doc of the function {@link findProduct()}.
     * @type {Promise}
     */

    vm.typeaheadPromise = null;
    /**
     * Scope variable used by the template to create or destroy the button for remove confirmation.
     * For more details about this variable see the doc of the function {@link resetRemoveButton()}.
     * @type {boolean}
     */

    vm.removeButtonVisible = true;
    /**
     * Translated labels used by the template.
     * This approach is used to reduce the number of scope watchers in the template because this translations
     * are used several times in the same template.
     * @type {object}
     */

    vm.labels = $translate.instant(['GLOBAL.REMOVE', 'GLOBAL.ARE_YOU_SURE', 'GLOBAL.SURE?', 'GLOBAL.YES', 'GLOBAL.NO', 'CART.NOT_AVAILABLE_HELPTEXT']);
    /**
     * Pixels reserved under the "sku" input field to display the product's suggestions for adding a new
     * offer's item.
     * @type {number}
     */

    vm.suggestionPxHeightReserved = 140;
    /**
     * @ngdoc method
     * @name arePendingChanges
     * @description Check is the item has pending unsaved changes.
     * @returns {boolean} TRUE/FALSE
     */

    vm.arePendingChanges = function () {
      vm.isEmpty('name');
      vm.isEmpty('price');

      if (vm.model.sku !== vm.workCopy.sku || vm.workCopy.sku === "") {
        return true;
      }

      if (vm.model.qty !== vm.workCopy.qty) {
        return true;
      }

      if (vm.model.discount !== vm.workCopy.discount) {
        return true;
      }

      if (vm.model.name !== vm.workCopy.name) {
        return true;
      }

      if (vm.model.brand !== vm.workCopy.brand) {
        return true;
      }

      if (vm.model.price !== vm.workCopy.price) {
        return true;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name saveChanges
     * @description This function is called when the user finish to edit the model.
     * It call the external function callback ordering to apply the changes on the real model.
     */


    vm.saveChanges = function () {
      if (!vm.arePendingChanges()) {
        return;
      }

      if (!vm.qtyValid || !vm.qtyIncValid || !vm.workCopy.name || !vm.workCopy.price) {
        return;
      }
      /**
       * Offer's item model object without the custom properties added at runtime by this component.
       * @type {object}
       */


      var preparedItem = lodash.omit(vm.workCopy, ['available', 'stock', 'stockVisible']);

      if (vm.itemExists()) {
        vm.onRequestUpdate({
          item: preparedItem
        });
      } else {
        vm.onRequestCreate({
          item: preparedItem
        });
        vm.resetWorkingCopy();
        vm.focusField('sku');
        vm.typeaheadPromise = null;
        vm.resetInputs();
      }
    };
    /**
     * @ngdoc method
     * @name updateItemIfExist
     * @description
     * This function order the update of the offer's item only if this already exists.
     * If the item isn't exist yet this function will do nothing.
     *
     * This function is useful when is called by a Input blur event because the changes in the input values
     * should be saved immediately when the item already exist but if not, the creation order should be sent
     * just after the user explicitly express that (pressing the key ENTER for example).
     */


    vm.updateItemIfExist = function () {
      if (vm.itemExists()) {
        vm.saveChanges();
      }
    };
    /**
     * @ngdoc method
     * @name requestRemove
     * @description This method is called when the user request the removing of this item from the offer.
     */


    vm.requestRemove = function () {
      vm.resetRemoveButton();
      vm.onRequestRemove({
        item: vm.workCopy
      });
    };
    /**
     * @ngdoc method
     * @name updateDefaultQty
     * @description When sku selected set default qty, based on qtyIncrements
     */


    vm.updateDefaultQty = function (item) {
      vm.workCopy.qty = item.qtyIncrements;
      vm.workCopy.qtyIncrements = item.qtyIncrements;
    };
    /**
     * @ngdoc method
     * @name resetWorkingCopy
     * @description Synchronize the properties of the working copy model and the real model.
     */


    vm.resetWorkingCopy = function () {
      if (!lodash.isEqual(vm.workCopy, vm.model)) {
        collectionUtils.updateObject(vm.model, vm.workCopy, true);
      }
    };

    vm.resetInputs = function () {
      setTimeout(function () {
        vm.element.find('input').removeClass('ng-touched');
      }, 100);
    };
    /**
     * @ngdoc method
     * @name increaseQty
     * @description Increase qty by 1 value
     */


    vm.increaseQty = function () {
      vm.workCopy.qty += 1;

      if (typeof vm.timer !== 'undefined') {
        clearInterval(vm.timer);
      }

      vm.timer = setInterval(function () {
        vm.saveChanges();
        clearInterval(vm.timer);
      }, 300);
    };
    /**
     * @ngdoc method
     * @name decreaseQty
     * @description Decrease qty by qtyIncrements value
     */


    vm.decreaseQty = function () {
      vm.workCopy.qty -= 1;

      if (typeof vm.timer !== 'undefined') {
        clearInterval(vm.timer);
      }

      vm.timer = setInterval(function () {
        vm.saveChanges();
        clearInterval(vm.timer);
      }, 300);
    };
    /**
     * @ngdoc method
     * @name decreaseAvaliable
     * @description Check if decrease available
     */


    vm.decreaseAvaliable = function () {
      if (vm.workCopy.qty - 1 <= 0) {
        return false;
      }

      return true;
    };
    /**
     * @ngdoc method
     * @name itemIsInSale
     * @description Ask if the current item is in sale.
     * @returns {boolean}  TRUE/FALSE
     */


    vm.itemIsInSale = function () {
      if (angular.isNumber(vm.workCopy.promotion_price) && vm.workCopy.promotion_price > 0) {
        return vm.workCopy.promotion_price !== vm.workCopy.price;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name itemExists
     * @description Ask if the item belong to the offer (has already an ID).
     * @returns {boolean} TRUE/FALSE
     */


    vm.itemExists = function () {
      return vm.workCopy.hasOwnProperty('item_id') && vm.workCopy.item_id > 0;
    };
    /**
     * @ngdoc method
     * @name findProduct
     * @description Make a product search and returns the first 5 products matched.
     * @returns {Promise} Future
     */


    vm.findProduct = function (val) {
      //List of products to include and exclude
      var products = {
        include: [val + '*'],
        //Using Apache Lucene wildcards
        exclude: angular.isArray(vm.skuExcludeList) ? vm.skuExcludeList : [],
        filterCatalogPrice: true,
        checkOnly: true
      };
      vm.typeaheadPromise = productsResource.query(null, products, 1, 5).then(function (results) {
        return (results.rows || []).map(function (item) {
          return {
            sku: item.sku,
            label: item.sku + ' - ' + item.name,
            qtyIncrements: item.qtyIncrements
          };
        });
      });
      return vm.typeaheadPromise;
    };
    /**
     * Return the stock quantity that should be visible to the user.
     * @return {number|null} It will return NULL if there's no enough data to calculate a value
     */


    vm.calculateVisibleStock = function () {
      // if (angular.isObject(vm.workCopy) && vm.workCopy.hasOwnProperty('sku') && vm.workCopy.hasOwnProperty('stock') && vm.workCopy.qty !== null) {
      //     return lodash.min([vm.workCopy.qty, vm.workCopy.stock]);
      // }
      return vm.workCopy.qty + 2;
    };
    /**
     * Update the value of the "stockVisible" property of the offer's item.
     */


    vm.updateVisibleStock = function () {
      if (angular.isObject(vm.workCopy)) {
        vm.workCopy.stockVisible = vm.calculateVisibleStock();
      }
    };
    /**
     * Check if the quantity requested of this product is less or equal that the available stock.
     * Note: This function returns FALSE is no stock or quantity value is available.
     * @return {boolean}
     */


    vm.isQtyLessThanStock = function () {
      // var stock = vm.workCopy.stockVisible;
      // if (isFinite(stock) && isFinite(vm.workCopy.qty)) {
      //     return stock >= vm.workCopy.qty;
      // }
      // return false;
      return true;
    };
    /**
     * This function change the value of the scope variable "removeButtonVisible" used by the template for
     * create or destroy the html node element which contain the confirmation button.
     *
     * This hack is necessary because ngRepeat try reuse the rows when the data change (and that's a good thing)
     * but the component used to ask for inline confirmation before remove items, don't have support for reuse the
     * same instance.
     *
     * When this functions is call the button is destroyed and created again in the next digest cycle.
     */


    vm.resetRemoveButton = function () {
      vm.removeButtonVisible = false;
      $timeout(function () {
        vm.removeButtonVisible = true;
      }, 0);
    };
    /**
     * Function executed when the row gain focus.
     * It try to create enough space under the item to show all the product suggestions.
     */


    vm.onFocus = function () {
      if (!domUtils.itemIsVisible(vm.element, vm.suggestionPxHeightReserved)) {
        domUtils.scrollToItem(vm.element, vm.suggestionPxHeightReserved);
      }
    };

    vm.isEmpty = function (elemName) {
      var element = vm.element.find('input[name=' + elemName + ']');

      if (!vm.workCopy[elemName]) {
        element.addClass('required-empty');
        vm.element.find('span.required_' + elemName).addClass('required_show');
        element.parent().addClass('wrapper_' + elemName);
      } else {
        element.removeClass('required-empty');
        vm.element.find('span.required_' + elemName).removeClass('required_show');
        element.parent().removeClass('wrapper_' + elemName);
      }
    };
    /**
     * validate qty
     * @param qty
     * @param qtyIncrements
     * @return {boolean}
     */


    function validateQty(qty) {
      return !isNaN(parseInt(qty));
    } //Update working copy each time the model changed


    $scope.$watchCollection('vm.model', vm.resetWorkingCopy); // check if given qty is valid

    $scope.$watch('vm.workCopy.qty', function () {
      vm.qtyValid = validateQty(vm.workCopy.qty);
    }); //Invoke an external function When the selection change

    $scope.$watch('vm.isSelectedExtended', function (newVal, oldVal) {
      if (vm.onSelectionChange && newVal !== oldVal) {
        vm.onSelectionChange({
          item: vm.model,
          selected: newVal
        });
      }
    }); //If the directive is created without a model, I use a empty object

    if (angular.isUndefined(vm.model)) {
      vm.model = {
        sku: '',
        name: '',
        brand: '',
        price: '',
        qty: 1,
        qtyIncrements: 1,
        discount: 0,
        item_id: ''
      };
    }
  }
})(angular.module('app'), angular);
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgOfferItem
   * @description Row to represent a item of an offer.
   *
   * This a directive instead of a component because is used in a TR tag (inside a HTML table).
   */

  /*@ngInject*/

  sgOfferItem.$inject = ["$scope", "$timeout", "$translate", "lodash", "productsResource", "domUtils", "collectionUtils", "toaster"];
  module.directive('sgOfferItem', ["$timeout", function ($timeout) {
    return {
      restrict: 'AE',
      templateUrl: 'app/offer/components/offerItem.html',
      controller: sgOfferItem,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        model: '<',
        editable: '<?',
        removable: '<?',

        /**
         * Position in the items offer's list.
         */
        position: '<',

        /**
         * Show a checkbox to select this item.
         */
        selectable: '<',
        isSelected: '<?',

        /**
         * Array with the SKUs that shouldn't be include in the product searches.
         */
        skuExcludeList: '<',
        onRequestCreate: '&?',
        onRequestUpdate: '&?',
        onRequestRemove: '&?',
        onSelectionChange: '&?',
        isProductInOffer: '<'
      },
      link: function link(scope, element) {
        /**
         * Focus a specific input field.
         * @param {string} name Name of the field (input param "name")
         * @param {number} [delay] Delay (in ms) the focusing
         */
        scope.vm.focusField = function (name, delay) {
          if (isFinite(delay) && delay > 0) {
            $timeout(function () {
              scope.vm.focusField(name);
            }, delay);
          }
          /* NOTE: This css selector is too complex to be handler by the jqlite of Angular 1.5.
           * This will continuing to work only if jQuery library is also used in this project.
           */


          element.find('input[name=' + name + ']:not([readonly])').focus().select();
        }; //Making the element node available to the controller


        scope.vm.element = element;
      }
    };
  }]);
  /*@ngInject*/

  function sgOfferItem($scope, $timeout, $translate, lodash, productsResource, domUtils, collectionUtils, toaster) {
    var vm = this;
    vm.workCopy = {};
    vm.qtyValid = true;
    vm.qtyIncValid = true;
    vm.isSelected = false;
    /**
     * Scope variable used to check if list of searched products is shown.
     * For more details about this variable see the doc of the function {@link findProduct()}.
     * @type {Promise}
     */

    vm.typeaheadPromise = null;
    /**
     * Scope variable used by the template to create or destroy the button for remove confirmation.
     * For more details about this variable see the doc of the function {@link resetRemoveButton()}.
     * @type {boolean}
     */

    vm.removeButtonVisible = true;
    /**
     * Translated labels used by the template.
     * This approach is used to reduce the number of scope watchers in the template because this translations
     * are used several times in the same template.
     * @type {object}
     */

    vm.labels = $translate.instant(['GLOBAL.REMOVE', 'GLOBAL.ARE_YOU_SURE', 'GLOBAL.SURE?', 'GLOBAL.YES', 'GLOBAL.NO', 'CART.NOT_AVAILABLE_HELPTEXT']);
    /**
     * Pixels reserved under the "sku" input field to display the product's suggestions for adding a new
     * offer's item.
     * @type {number}
     */

    vm.suggestionPxHeightReserved = 140;
    /**
     * Show warning if promotional price is below price of purchase.
     * @type {boolean}
     */

    vm.warningPromoPrice = false;
    /**
     * @ngdoc method
     * @name arePendingChanges
     * @description Check is the item has pending unsaved changes.
     * @returns {boolean} TRUE/FALSE
     */

    vm.arePendingChanges = function () {
      if (vm.workCopy.sku === '' || vm.workCopy.qty < 1) {
        return false;
      }

      if (vm.model.sku !== vm.workCopy.sku) {
        return true;
      }

      if (vm.model.qty !== vm.workCopy.qty) {
        return true;
      }

      if (vm.model.discount !== vm.workCopy.discount) {
        return true;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name saveChanges
     * @description This function is called when the user finish to edit the model.
     * It call the external function callback ordering to apply the changes on the real model.
     */


    vm.saveChanges = function () {
      if (!vm.arePendingChanges()) {
        return;
      }

      if (!vm.qtyValid || !vm.qtyIncValid || !vm.workCopy.sku) {
        return;
      }
      /**
       * Offer's item model object without the custom properties added at runtime by this component.
       * @type {object}
       */


      var preparedItem = lodash.omit(vm.workCopy, ['available', 'stock', 'stockVisible']);

      if (vm.itemExists()) {
        vm.onRequestUpdate({
          item: preparedItem
        });
      } else {
        if (!vm.isProductInOffer(preparedItem.sku)) {
          // checking if list with products searched is shown
          if (vm.typeaheadPromise !== null && typeof vm.typeaheadPromise.$$state.value !== 'undefined' && vm.typeaheadPromise.$$state.value.length > 0) {
            vm.onRequestCreate({
              item: preparedItem
            });
            vm.resetWorkingCopy();
            vm.focusField('sku');
            vm.typeaheadPromise = null;
          }
        } else {
          toaster.error('OFFER.PRODUCT_ALREADY_IN_OFFER');
        }
      }
    };
    /**
     * @ngdoc method
     * @name updateItemIfExist
     * @description
     * This function order the update of the offer's item only if this already exists.
     * If the item isn't exist yet this function will do nothing.
     *
     * This function is useful when is called by a Input blur event because the changes in the input values
     * should be saved immediately when the item already exist but if not, the creation order should be sent
     * just after the user explicitly express that (pressing the key ENTER for example).
     */


    vm.updateItemIfExist = function () {
      if (vm.itemExists()) {
        vm.saveChanges();
      }
    };
    /**
     * @ngdoc method
     * @name requestRemove
     * @description This method is called when the user request the removing of this item from the offer.
     */


    vm.requestRemove = function () {
      vm.resetRemoveButton();
      vm.onRequestRemove({
        item: vm.workCopy
      });
    };
    /**
     * @ngdoc method
     * @name updateDefaultQty
     * @description When sku selected set default qty, based on qtyIncrements
     */


    vm.updateDefaultQty = function (item) {
      vm.workCopy.qty = item.qtyIncrements;
      vm.workCopy.qtyIncrements = item.qtyIncrements;
    };
    /**
     * @ngdoc method
     * @name resetWorkingCopy
     * @description Synchronize the properties of the working copy model and the real model.
     */


    vm.resetWorkingCopy = function () {
      if (!lodash.isEqual(vm.workCopy, vm.model)) {
        collectionUtils.updateObject(vm.model, vm.workCopy, true);
      }
    };
    /**
     * @ngdoc method
     * @name increaseQty
     * @description Increase qty by qtyIncrements value
     */


    vm.increaseQty = function () {
      if (vm.qtyIncValid) {
        vm.workCopy.qty += vm.workCopy.qtyIncrements;
      }

      if (!vm.itemExists()) {
        return;
      }

      if (typeof vm.timer !== 'undefined') {
        clearInterval(vm.timer);
      }

      vm.timer = setInterval(function () {
        vm.saveChanges();
        clearInterval(vm.timer);
      }, 300);
    };
    /**
     * @ngdoc method
     * @name decreaseQty
     * @description Decrease qty by qtyIncrements value
     */


    vm.decreaseQty = function () {
      if (vm.workCopy.qty > vm.workCopy.qtyIncrements && vm.qtyIncValid) {
        vm.workCopy.qty -= vm.workCopy.qtyIncrements;
      }

      if (!vm.itemExists()) {
        return;
      }

      if (typeof vm.timer !== 'undefined') {
        clearInterval(vm.timer);
      }

      vm.timer = setInterval(function () {
        vm.saveChanges();
        clearInterval(vm.timer);
      }, 300);
    };
    /**
     * @ngdoc method
     * @name increaseAvaliable
     * @description Check if increase available
     */


    vm.increaseAvaliable = function () {
      return vm.qtyIncValid;
    };
    /**
     * @ngdoc method
     * @name decreaseAvaliable
     * @description Check if decrease available
     */


    vm.decreaseAvaliable = function () {
      if (angular.isUndefined(vm.workCopy.qtyIncrements)) {
        return true;
      }

      return vm.qtyIncValid && vm.workCopy.qty > vm.workCopy.qtyIncrements;
    };
    /**
     * @ngdoc method
     * @name itemIsInSale
     * @description Ask if the current item is in sale.
     * @returns {boolean}  TRUE/FALSE
     */


    vm.itemIsInSale = function () {
      if (angular.isNumber(vm.workCopy.promotion_price) && vm.workCopy.promotion_price > 0) {
        return vm.workCopy.promotion_price !== vm.workCopy.price;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name itemExists
     * @description Ask if the item belong to the offer (has already an ID).
     * @returns {boolean} TRUE/FALSE
     */


    vm.itemExists = function () {
      return vm.workCopy.hasOwnProperty('item_id') && vm.workCopy.item_id > 0;
    };
    /**
     * @ngdoc method
     * @name findProduct
     * @description Make a product search and returns the first 5 products matched.
     * @returns {Promise} Future
     */


    vm.findProduct = function (val) {
      //List of products to include and exclude
      var products = {
        include: [val + '*'],
        //Using Apache Lucene wildcards
        exclude: angular.isArray(vm.skuExcludeList) ? vm.skuExcludeList : [],
        filterCatalogPrice: false,
        checkOnly: true
      };
      vm.typeaheadPromise = productsResource.query(null, products, 1, 5).then(function (results) {
        return (results.rows || []).map(function (item) {
          return {
            sku: item.sku,
            label: item.sku + ' - ' + item.name,
            qtyIncrements: item.qtyIncrements
          };
        });
      });
      return vm.typeaheadPromise;
    };
    /**
     * Return the stock quantity that should be visible to the user.
     * @return {number|null} It will return NULL if there's no enough data to calculate a value
     */


    vm.calculateVisibleStock = function () {
      if (angular.isObject(vm.workCopy) && vm.workCopy.hasOwnProperty('sku') && vm.workCopy.hasOwnProperty('stock') && vm.workCopy.qty !== null) {
        return lodash.min([vm.workCopy.qty, vm.workCopy.stock]);
      }

      return 0;
    };
    /**
     * Update the value of the "stockVisible" property of the offer's item.
     */


    vm.updateVisibleStock = function () {
      if (angular.isObject(vm.workCopy)) {
        vm.workCopy.stockVisible = vm.calculateVisibleStock();
      }
    };
    /**
     * Check if the quantity requested of this product is less or equal that the available stock.
     * Note: This function returns FALSE is no stock or quantity value is available.
     * @return {boolean}
     */


    vm.isQtyLessThanStock = function () {
      var stock = vm.workCopy.stockVisible;

      if (isFinite(stock) && isFinite(vm.workCopy.qty)) {
        return stock >= vm.workCopy.qty;
      }

      return false;
    };
    /**
     * This function change the value of the scope variable "removeButtonVisible" used by the template for
     * create or destroy the html node element which contain the confirmation button.
     *
     * This hack is necessary because ngRepeat try reuse the rows when the data change (and that's a good thing)
     * but the component used to ask for inline confirmation before remove items, don't have support for reuse the
     * same instance.
     *
     * When this functions is call the button is destroyed and created again in the next digest cycle.
     */


    vm.resetRemoveButton = function () {
      vm.removeButtonVisible = false;
      $timeout(function () {
        vm.removeButtonVisible = true;
      }, 0);
    };
    /**
     * Function executed when the row gain focus.
     * It try to create enough space under the item to show all the product suggestions.
     */


    vm.onFocus = function () {
      if (!domUtils.itemIsVisible(vm.element, vm.suggestionPxHeightReserved)) {
        domUtils.scrollToItem(vm.element, vm.suggestionPxHeightReserved);
      }
    };
    /**
     * Validate qty increments
     * @param qty
     * @param qtyIncrements
     * @return {boolean}
     */


    function validateQtyIncrements(qty, qtyIncrements) {
      return qty % qtyIncrements === 0;
    }
    /**
     * validate qty
     * @param qty
     * @param qtyIncrements
     * @return {boolean}
     */


    function validateQty(qty) {
      return !isNaN(parseInt(qty));
    } //Update working copy each time the model changed


    $scope.$watchCollection('vm.model', vm.resetWorkingCopy); // check if given qty is valid

    $scope.$watch('vm.workCopy.qtyIncrements', function () {
      if (angular.isUndefined(vm.workCopy.qtyIncrements)) {
        vm.qtyIncValid = true;
      } else {
        vm.qtyIncValid = validateQtyIncrements(vm.workCopy.qty, vm.workCopy.qtyIncrements); //Updating the qty increment error

        vm.incrementErrorMsg = $translate.instant('CART.QTY_INCREMENT_ERROR', vm.workCopy);
      }
    }); // check if given qty is valid

    $scope.$watch('vm.workCopy.qty', function () {
      vm.qtyValid = validateQty(vm.workCopy.qty);

      if (!angular.isUndefined(vm.workCopy.qtyIncrements)) {
        vm.qtyIncValid = validateQtyIncrements(vm.workCopy.qty, vm.workCopy.qtyIncrements);
      }
    }); //Recalculate the visible stock every time the qty or stock of the item change

    $scope.$watchGroup(['vm.workCopy.qty', 'vm.workCopy.stock'], vm.updateVisibleStock); //Invoke an external function When the selection change

    $scope.$watch('vm.isSelected', function (newVal, oldVal) {
      if (vm.onSelectionChange && newVal !== oldVal) {
        vm.onSelectionChange({
          item: vm.model,
          selected: newVal
        });
      }
    }); // Watch on discount price - if is below than price of purchase - show warning message

    $scope.$watch('vm.workCopy.row_total_excl_tax', function () {
      if (vm.workCopy.row_total_excl_tax < vm.workCopy.reseller_price) {
        vm.warningPromoPrice = true;
      } else if (vm.workCopy.row_total_excl_tax < vm.workCopy.reseller_price * vm.workCopy.qty) {
        vm.warningPromoPrice = true;
      } else {
        vm.warningPromoPrice = false;
      }
    }); //If the directive is created without a model, I use a empty object

    if (angular.isUndefined(vm.model)) {
      vm.model = {
        sku: '',
        qty: 1,
        qtyIncrements: 1,
        discount: 0,
        reseller_price: 0
      };
    }
  }
})(angular.module('app'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgOfferEditor
   * @module app
   * @description
   * This component show a complete editor of a offer.
   */

  sgOfferEditor.$inject = ["$q", "$document", "$timeout", "$translate", "toaster", "FileSaver", "jsUtils", "orbaSession", "offerConfig", "moment", "gtmDataLayer", "fileDownload"];
  module.component('sgOfferEditor', {
    templateUrl: 'app/offer/components/offerEditor.html',
    controller: sgOfferEditor,
    controllerAs: 'vm',
    bindings: {
      /**
       * @name model object
       * @type {offersResource} model
       */
      model: '=',
      step: '=',
      editable: '<',
      itemsFailed: '<',
      allowAddItems: '<',
      allowEditItems: '<',
      allowRemoveItems: '<',
      onLoad: '&?',
      onCreate: '&?',
      onUpdate: '&?'
    }
  });
  /*@ngInject*/

  function sgOfferEditor($q, $document, $timeout, $translate, toaster, FileSaver, jsUtils, orbaSession, offerConfig, moment, gtmDataLayer, fileDownload) {
    var vm = this;
    /**
     * Variable used to show loading while adding/removing products in cart
     */

    vm.promiseOfferChanged = $q.resolve(0); //automatically resolved promises

    /**
     * Buffor for promises
     */

    vm.itemsWaiting = [];
    /**
     * List of  SKUs added at current session.
     * @type {String[]}
     */

    vm.currentSessionSkus = [];
    /**
     * Default step
     * @type {number}
     */

    vm.step = 1;
    /**
     * List of all the available export file types.
     * @type {string[]}
     */

    vm.exportFileTypes = [];
    /**
     * Default / current export file type
     * @type {string}
     */

    vm.exportFileType = 'pdf';
    /**
     * Enable or disable generation tooltip notice
     * @return {boolean}
     */

    vm.generationTooltipEnabled = function () {
      if (vm.model.hasOwnProperty('items') && vm.model.items.length >= offerConfig.tooltipLimit) {
        return true;
      } else {
        return false;
      }
    };
    /**
     * Clear array of failed import sku's
     */


    vm.clearFailed = function () {
      delete vm.itemsFailed;
    };
    /**
     * Variable which contain the fatal error message received.
     * @type {string}
     */


    vm.fatalErrorMsg = '';
    /**
     * Messages catalog.
     * @name defaultMessages
     * @type {object}
     */

    vm.defaultMessages = {
      unknownError: 'GLOBAL.UNKNOWN_ERROR',
      creationSuccess: 'OFFER.CREATION_SUCCESS_MSG',
      creationError: 'OFFER.CREATION_FAILURE_MSG',
      updateSuccess: 'OFFER.UPDATE_SUCCESS_MSG',
      updateError: 'OFFER.UPDATE_FAILURE_MSG',
      deleteSuccess: 'OFFER.DELETE_SUCCESS_MSG',
      deleteError: 'OFFER.DELETE_FAILURE_MSG'
    };
    /**
     * Copy of the model used to detect not saved changes.
     * See the function {@link self::createBkpCopy()} for more details.
     * @type {offersResource}
     */

    vm.modelCopy = null;
    /**
     * Notifications catalog.
     * @name notifs
     * @type {object}
     */

    vm.notifs = {
      model: {
        creation: {
          success: function success() {
            toaster.success(vm.defaultMessages.creationSuccess);
            return {
              model: vm.model
            };
          },
          failure: function failure(response) {
            toaster.error(response.data || vm.defaultMessages.creationError);
            return $q.reject(response);
          }
        },
        update: {
          success: function success() {
            toaster.success(vm.defaultMessages.updateSuccess);
            return {
              model: vm.model
            };
          },
          failure: function failure(response) {
            toaster.error(response.data || vm.defaultMessages.updateError);
            return $q.reject(response);
          }
        }
      },
      items: {
        success: function success() {
          toaster.success(vm.defaultMessages.updateSuccess);
        },
        failure: function failure(response) {
          toaster.error(response.data || vm.defaultMessages.updateSuccess);
          return $q.reject(response);
        }
      }
    };
    /**
     * @internal
     */

    vm.$onInit = function () {
      if (angular.isObject(vm.model) && vm.model.hasOwnProperty('$promise')) {
        vm.createBkpCopy(); //Disable this component if the model encounter a fatal error

        vm.model.$promise["catch"](function (response) {
          vm.showFatalError(response);
        }); //Obtain the availability of the cart's items when the cart data is loaded

        if (vm.model.$resolved) {
          vm.onLoadModel();
        } else if (vm.model.$promise) {
          vm.model.$promise.then(vm.onLoadModel);
        }
      }
    };
    /**
     * Function called when the model data is available to work with.
     * @returns {object} model object
     */


    vm.onLoadModel = function () {
      vm.refreshItemsAvailability();
      vm.createBkpCopy();
      vm.setDefaultAuthor();
      vm.fetchExportFileTypes();
      if (vm.onLoad) vm.onLoad({
        model: vm.model
      });
      gtmDataLayer.push({
        'offerName': vm.model.name
      });
      return vm.model;
    };

    vm.setDefaultAuthor = function () {
      orbaSession.userDataResolved.then(function () {
        if (vm.model.author_email === null) {
          vm.model.author_email = orbaSession.info.user.user.email;
        }

        if (vm.model.author_firstname === null) {
          vm.model.author_firstname = orbaSession.info.user.user.firstname;
        }

        if (vm.model.author_lastname === null) {
          vm.model.author_lastname = orbaSession.info.user.user.lastname;
        }

        if (vm.model.author_telephone === null) {
          vm.model.author_telephone = orbaSession.info.user.user.phone;
        }

        if (vm.model.offerdate === null) {
          vm.model.offerdate = moment().format('YYYY-MM-DD');
        }
      });
    };
    /**
     * Fetch available exporters file types from the backend.
     */


    vm.fetchExportFileTypes = function () {
      if (!vm.exportFileTypes.length) {
        vm.model.getFileExportTypes().then(function (data) {
          vm.exportFileTypes = data.types;
        });
      }
    };
    /**
     * @ngdoc method
     * @name showFatalError
     * @description Show a serious error to the user.
     * @param {string} [msg=vm.defaultMessages.unknownError]
     */


    vm.showFatalError = function (msg) {
      vm.fatalErrorMsg = msg || vm.defaultMessages.unknownError;
    };
    /**
     * @ngdoc method
     * @name showError
     * @description Show an error as a notification.
     * @param {string} [msg=vm.defaultMessages.unknownError]
     */


    vm.showError = function (msg) {
      toaster.error(msg || vm.defaultMessages.unknownError);
    };
    /**
     * Change view to step
     * @param step
     */


    vm.goToStep = function (step) {
      vm.step = parseInt(step, 10);

      if (vm.step === 2) {
        vm.setDefaultAuthor();
      }
    };
    /**
     * @ngdoc method
     * @name save
     * @description
     * Send to the backend any change made to the model
     */


    vm.saveChanges = function () {
      if (vm.model.isPhantom()) {
        return vm.model.$save().then(vm.notifs.model.creation.success, vm.notifs.model.creation.failure).then(vm.onLoadModel).then(function (model) {
          vm.focusField('sku');
          return model;
        }).then(function (model) {
          vm.createBkpCopy();
          if (vm.onCreate) vm.onCreate({
            model: model
          });
        });
      } else {
        if (vm.offerForm.$invalid && vm.step !== 1) {
          var invalidElement = angular.element('input.ng-invalid')[0].name;

          if (invalidElement) {
            vm.focusField(invalidElement);
          }

          return $q.reject();
        }

        return vm.model.$update().then(vm.notifs.model.update.success, vm.notifs.model.update.failure).then(function (model) {
          vm.createBkpCopy();
          vm.refreshItemsAvailability();
          if (vm.onUpdate) vm.onUpdate({
            model: model
          });
        });
      }
    };
    /**
     * Apply a new name for the current offer.
     * @param {string} name
     */


    vm.changeName = function (name) {
      vm.model.name = name;
      return vm.saveChanges();
    };
    /**
     * Focus a specific DOM element in the next digest cycle.
     * @param {string} name Name of the input element.
     */


    vm.focusField = function (name) {
      $timeout(function () {
        $document.find('input[name=' + name + ']:not([readonly])').focus();
      }, 0);
    };
    /**
     * Update the availability of the current cart items.
     */


    vm.refreshItemsAvailability = function () {
      vm.model.refreshAvailability();
    };
    /**
     * @ngdoc method
     * @name addCartItem
     * @methodOf app.directive:sgCartEditor
     * @description Order the back to add a new item to the current cart
     * @param {object} item
     */


    vm.addItem = function (item) {
      vm.itemsWaiting.push(angular.copy(item)); //if status not pending

      if (vm.promiseOfferChanged.$$state.status !== 0) {
        vm.startResolvingPromise(vm.itemsWaiting[0]);
      }
    };
    /**
     * @ngdoc method
     * @name startResolvingPromise
     * @methodOf app.directive:offerEditor
     * @description adds item to the cart
     * @param {object} item
     */


    vm.startResolvingPromise = function (item) {
      vm.promiseOfferChanged = vm.model.$addItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability)["finally"](vm.refreshItemsWaiting);
    };
    /**
     * @ngdoc method
     * @name refreshItemsWaiting
     * @methodOf app.directive:offerEditor
     * @description resolving itemsWaiting list one by one
     * @param {object} item
     */


    vm.refreshItemsWaiting = function () {
      vm.itemsWaiting.shift(); // buffor must be used by usedSKU's as long as possible

      if (vm.itemsWaiting.length !== 0) {
        vm.startResolvingPromise(vm.itemsWaiting[0]);
      }
    };
    /**
     * @ngdoc method
     * @name updateCartItem
     * @methodOf app.directive:sgCartEditor
     * @description Request update an existing item of the cart.
     * @param {object} item
     */


    vm.updateItem = function (item) {
      vm.model.$updateItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability);
    };
    /**
     * @ngdoc method
     * @name removeCartItem
     * @methodOf app.directive:sgCartEditor
     * @description Request remove an item.
     * @param {object} item
     */


    vm.removeItem = function (item) {
      vm.promiseOfferChanged = vm.model.$removeItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability);
    };
    /**
     * Download generated document of the actual offer.
     */


    vm.downloadFile = function () {
      //This variable is the ctrl is needed by vm.allowDownloadFile()
      var savePromise = $q.defer();

      if (!vm.allowDownloadFile()) {
        savePromise = vm.saveChanges();
      } else {
        savePromise = $q.resolve();
      }

      savePromise.then(function () {
        vm.downloadFilePromise = vm.model.getFileDocument(vm.exportFileType).then(function (response) {
          fileDownload.downloadFile(response);
        })["catch"](function (errorMsg) {
          toaster.error(errorMsg);
        });
      });
      return vm.downloadFilePromise;
    };

    vm.sendByEmail = function () {
      var savePromise = $q.defer();

      if (!vm.allowDownloadFile()) {
        savePromise = vm.saveChanges();
      } else {
        savePromise = $q.resolve();
      }

      savePromise.then(function () {
        vm.model.mailMe(vm.exportFileType).then(function () {
          toaster.success('OFFER.MAIL_SENT');
        }, function () {
          toaster.error(errorMsg);
        });
      });
    };
    /**
     * Update the shadow copy of the offer model data used to detect when are changed pending to be send to the
     * backend.
     */


    vm.createBkpCopy = function () {
      vm.modelCopy = jsUtils.getLightObject(vm.model);
    };
    /**
     * Check if there're pending changes to be send to the backend.
     * @return {boolean}
     */


    vm.arePendingChanges = function () {
      return !angular.equals(jsUtils.getLightObject(vm.model), vm.modelCopy);
    };
    /**
     * Check if user should be allowed to generate a new file of this offer.
     * @return {boolean}
     */


    vm.allowDownloadFile = function () {
      if (vm.arePendingChanges()) {
        return false;
      }

      if (vm.offerForm.$invalid) {
        return false;
      }

      return !(vm.hasOwnProperty('downloadFilePromise') && !vm.downloadFilePromise.$$state.status);
    };

    vm.changePromoPrice = function () {
      vm.saveChanges();
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  "use strict";
  /**
   * @ngdoc component
   * @name sgOfferAttrsForm
   * @module app
   * @description
   * Show a form to edit the header properties of an offer.
   */

  module.component('sgOfferAttrsForm', {
    templateUrl: 'app/offer/components/offerAttrsForm.html',
    controllerAs: 'vm',
    bindings: {
      model: '=',
      editable: '<'
    }
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgOfferAddressForm
   * @module app
   * @description
   * Show a form to edit the address properties of an offer.
   */

  sgOfferAddressForm.$inject = ["$document", "$locale", "lodash", "addressesResource", "$q", "websocket"];
  module.component('sgOfferAddressForm', {
    templateUrl: 'app/offer/components/offerAddressForm.html',
    controllerAs: 'vm',
    controller: sgOfferAddressForm,
    bindings: {
      model: '=',
      editable: '<'
    }
  });
  /*@ngInject*/

  function sgOfferAddressForm($document, $locale, lodash, addressesResource, $q, websocket) {
    var vm = this;
    vm.addresses = addressesResource.query();
    vm.locale = $locale;
    vm.today = moment().startOf('day').toDate();
    /**
     * Apply a address preset to the current offer model.
     * @param {addressesResource} address
     */

    vm.usePreset = function (address) {
      if (address instanceof addressesResource) {
        Object.assign(vm.model, lodash.pick(address, ['company', 'fullname', 'firstname', 'lastname', 'street', 'building', 'postcode', 'city', 'telephone']));
      } else {
        Object.assign(vm.model, {
          company: '',
          fullname: '',
          firstname: '',
          lastname: '',
          street: '',
          building: '',
          postcode: '',
          city: '',
          telephone: ''
        });
      }
    };
    /**
     * Return valid postcodes starting from given params
     * @param {string} postcode
     * @return {*[]}
     */


    vm.findPostCodes = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            vm.validCodes = response;
            resolve(response);
          }
        });
      });
    };
    /**
     * Checks if currently given postcode is valid
     * @param {string} postcode
     * @return {*}
     */


    vm.validatePostcode = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (Array.isArray(response) && response.indexOf(postcode) < 0) {
            reject(false);
          } else {
            resolve(true);
          }
        });
      });
    };
    /**
     * Return valid cities based on postcode, starting from given param
     * @param {string} city
     * @return {*[]}
     */


    vm.findCities = function (city) {
      return $q(function (resolve, reject) {
        if (!vm.model.postcode) {
          reject([]);
        }

        websocket.emit('account.getValidCities', {
          postcode: vm.model.postcode,
          city: city
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject([]);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Return valid streets based on postcode and city, starting from given param
     * @param {string} street
     * @return {*[]}
     */


    vm.findStreets = function (street) {
      return $q(function (resolve, reject) {
        if (!vm.model.postcode || !vm.model.city) {
          reject([]);
        }

        websocket.emit('account.getValidStreets', {
          postcode: vm.model.postcode,
          city: vm.model.city,
          street: street
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Validate if given date is not from past
     * @param date
     * @return {boolean}
     */


    vm.validateShippingDate = function (date) {
      return !moment(date).isBefore(vm.today);
    };
    /**
     * Check if a preset is been used.
     * @return {boolean}
     */


    vm.isPresetUsed = function () {
      return !!vm.currentPreset;
    };
    /**
     * Focus a specific DOM element.
     * @param {string} id
     */


    vm.focusField = function (id) {
      $document.find('#' + id + ':not([readonly])').focus();
    };
  }
})(angular.module('app'));
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc service
   * @name invoicesResource
   * @description
   * This service use the backend API to manage invoices.
   *
   * It use response transformations to rectify the data returned by the server.
   * Check the {@link https://docs.angularjs.org/api/ngResource/service/$resource $resource docs} for
   * more information.
   */

  invoicesResource.$inject = ["$resource", "$http", "$q", "moment", "invoiceConfig", "resourceQueryPaginator"];
  module.factory('invoicesResource', invoicesResource);
  /*@ngInject*/

  function invoicesResource($resource, $http, $q, moment, invoiceConfig, resourceQueryPaginator) {
    var resource,
        paginator = resourceQueryPaginator(),
        idField = 'invoice_number';
    /**
     * Stacks of transform functions to parse the server responses.
     *
     * @see https://docs.angularjs.org/api/ng/service/$http#default-transformations
     * @type {{forMulti: function[], forSingle: function[]}}
     */

    var transformStack = {
      forMulti: $http.defaults.transformResponse.concat(transformMulti),
      forSingle: $http.defaults.transformResponse.concat(transformSingle)
    };
    /**
     * Returns an object with the type properties of the model corrected.
     * @param {object} srcItem
     * @returns {object} Returns an object with the properties types corrected
     */

    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.net_total = parseFloat(item.net_total);
      item.tax_total = parseFloat(item.tax_total);
      item.grand_total = parseFloat(item.grand_total);
      item.invoice_date = moment(item.invoice_date).toDate();
      item.due_date = moment(item.due_date).toDate();
      return item;
    };
    /**
     * Transform the response of a single element.
     * @param {object} data
     * @returns {object}
     */


    function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.invoice || data) : data;
    }
    /**
     * Transform the response of a array of several elements.
     * @param {object} data
     * @returns {object}
     */


    function transformMulti(data) {
      return angular.isObject(data) ? (data.invoices || data).map(transformItem) : data;
    }
    /**
     * Resource for invoice management.
     * Note: This instance will be returned by this service.
     */


    resource = $resource(invoiceConfig.restful.invoices, {
      id: '@' + idField
    }, {
      //List of invoices
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo(transformStack.forMulti)
      }
    }); //Applying the pagination support to the "query" method

    paginator.applyToResource(resource, 'query');
    /**
     * Returns the ID of the current model.
     * @return {number}
     */

    resource.prototype.getId = function () {
      return this[idField];
    };
    /**
     * @ngdoc method
     * @name isPhantom
     * @description
     * Returns TRUE if the element doesn't have an ID.
     * @returns {boolean}
     */


    resource.prototype.isPhantom = function () {
      return !(this.hasOwnProperty(idField) || this[idField] === null);
    };
    /**
     * Returns the PDF file of the invoice as a Blob object.
     * Note: This PDF file is created by the backend.
     *
     * @return {Promise} The promise resolve a single Blob object and in case of error rejects an error string.
     */


    resource.prototype.getPdfDocument = function () {
      if (this.isPhantom()) {
        return $q.reject('Invoice does not have an ID');
      }

      var invoiceId = encodeURIComponent(this[idField]),
          url = invoiceConfig.documentUrl.replace(':id', invoiceId);
      return $http.get(url, {
        responseType: 'blob'
      }).then(function (response) {
        return response.data;
      }, function (response) {
        return $q.reject(response.statusText);
      });
    };
    /**
     * Returns the file content of the offer as a Blob object.
     * Note: This file is created by the backend.
     *
     * @param {string} fileType
     * @return {Promise} The promise resolve a single Blob object and in case of error rejects an error string.
     */


    resource.prototype.getFileDocument = function (fileType) {
      if (this.isPhantom()) {
        return $q.reject('Invoice does not have an ID');
      }

      var invoiceId = encodeURIComponent(this[idField]),
          url = invoiceConfig.documentUrl.replace(':id', invoiceId),
          payload = {
        fileType: fileType
      };
      return $http.post(url, payload, {
        responseType: 'blob'
      }).then(function (response) {
        return response;
      }, function (response) {
        return $q.reject(response.statusText);
      });
    };

    return resource;
  }
})(angular.module('app'), angular);
"use strict";

(function (module) {
  'use strict';
  /**
   * Controller for the view for list and filter invoices.
   */

  module.controller('invoiceListCtrl', function () {});
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * Controller for downloading pdf file of invoice
   */

  /*@ngInject*/

  module.controller('invoiceDownloadCtrl', ["invoicesResource", "FileSaver", "$stateParams", "$state", function (invoicesResource, FileSaver, $stateParams, $state) {
    /**
     * Download the PDF document of the invoice given as argument.
     * @param {invoicesResource} invoice
     */
    var downloadPdf = function downloadPdf(invoiceId) {
      var invoice = new invoicesResource({
        invoice_number: invoiceId
      });
      invoice.getPdfDocument().then(function (blobData) {
        if (blobData instanceof Blob) {
          FileSaver.saveAs(blobData, invoice.getId() + '.pdf');
        }
      })["catch"](function (errorMsg) {
        toaster.error(errorMsg);
      });
    };

    if ($stateParams.id) {
      downloadPdf($stateParams.id);
    }

    $state.go('invoice.list');
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name sgInvoicesListFilters
   * @description
   * Input filters for offer list.
   */

  sgInvoicesListFilters.$inject = ["$scope", "lodash"];
  module.component('sgInvoicesListFilters', {
    templateUrl: 'app/invoice/components/sgInvoicesListFilters.html',
    controller: sgInvoicesListFilters,
    controllerAs: 'vm',
    bindings: {
      originalFilters: '=filters'
    }
  });
  /*@ngInject*/

  function sgInvoicesListFilters($scope, lodash) {
    var vm = this;

    vm.$onInit = function () {
      vm.filters = {}; //If the real filters change, update the working filters

      $scope.$watch('vm.originalFilters', function (originalFilters) {
        vm.filters = angular.copy(originalFilters || {});
      });
    };
    /**
     * Apply the changes on the inputs over the real filters.
     */


    vm.applyChanges = function () {
      vm.originalFilters = getFilters();
    };
    /**
     * Checks if are pending changes in the filters to apply.
     * @returns {boolean}
     */


    vm.pendingChanges = function () {
      return !angular.equals(getFilters(), vm.originalFilters || {});
    };
    /**
     * Clear all the active filters.
     */


    vm.clearFilters = function () {
      vm.originalFilters = {};
    };
    /**
     * Check if there any filter currently active.
     * @return {boolean}
     */


    vm.filtersAreClear = function () {
      return angular.equals(getFilters() || {}, {});
    };
    /**
     * Return the filters.
     * @return {Object}
     */


    function getFilters() {
      return lodash.pickBy(vm.filters, function (value) {
        return angular.isString(value) ? !!value : true;
      });
    }
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgInvoicesList
   * @module app
   * @description
   * Show a list of invoices.
   */

  sgInvoicesList.$inject = ["$scope", "$translate", "FileSaver", "toaster", "paginationManager", "invoicesResource", "invoiceConfig", "dateFilter", "$q", "jsUtils", "$http"];
  module.component('sgInvoicesList', {
    templateUrl: 'app/invoice/components/sgInvoicesList.html',
    controllerAs: 'vm',
    controller: sgInvoicesList,
    bindings: {
      filters: '<?',

      /**
       * @name model object
       * @type {invoicesResource} model
       */
      model: '='
    }
  });
  /*@ngInject*/

  function sgInvoicesList($scope, $translate, FileSaver, toaster, paginationManager, invoicesResource, invoiceConfig, dateFilter, $q, jsUtils, $http) {
    var vm = this;
    /**
     * Configuration for the CSV export library.
     * @type {{filename: string, fields: string[], headers: string[]}}
     */

    vm.csvConfig = {
      filename: $translate.instant('INVOICE.LIST') + '.csv',
      fields: ['invoice_number', 'order_numbers', 'distributor_id', 'net_total', 'tax_total', 'grand_total', 'invoice_date', 'due_date'],
      headers: [$translate.instant('INVOICE.INVOICE_NUMBER'), $translate.instant('INVOICE.ORDER'), $translate.instant('INVOICE.PAYER_ACCOUNT'), $translate.instant('INVOICE.NET_AMOUNT'), $translate.instant('INVOICE.TAX_AMOUNT'), $translate.instant('INVOICE.GROSS_AMOUNT'), $translate.instant('INVOICE.DUE_DATE'), $translate.instant('INVOICE.PAYMENT_DATE')],

      /**
       * Convert the search results in a collection with values more easy to print as CSV.
       * @return {function}
       */
      getData: function getData() {
        return $scope.paginator.rows.map(function (invoice) {
          return {
            invoice_number: invoice.invoice_number,
            order_numbers: invoice.order_numbers,
            distributor_id: invoice.distributor_id,
            net_total: invoice.net_total,
            tax_total: invoice.tax_total,
            grand_total: invoice.grand_total,
            invoice_date: dateFilter(invoice.invoice_date),
            due_date: dateFilter(invoice.due_date)
          };
        });
      }
    };
    vm.xlsConfig = {
      filename: $translate.instant('INVOICE.LIST') + '.xls',
      fields: ['invoice_number', 'order_numbers', 'distributor_id', 'net_total', 'tax_total', 'grand_total', 'invoice_date', 'due_date'],
      headers: [$translate.instant('INVOICE.INVOICE_NUMBER'), $translate.instant('INVOICE.ORDER'), $translate.instant('INVOICE.PAYER_ACCOUNT'), $translate.instant('INVOICE.NET_AMOUNT'), $translate.instant('INVOICE.TAX_AMOUNT'), $translate.instant('INVOICE.GROSS_AMOUNT'), $translate.instant('INVOICE.DUE_DATE'), $translate.instant('INVOICE.PAYMENT_DATE')],

      /**
       * Convert the search results in a collection with values more easy to print as CSV.
       * @return {function}
       */
      getData: function getData() {
        return $scope.paginator.rows.map(function (invoice) {
          return {
            invoice_number: invoice.invoice_number,
            order_numbers: invoice.order_numbers,
            distributor_id: invoice.distributor_id,
            net_total: invoice.net_total,
            tax_total: invoice.tax_total,
            grand_total: invoice.grand_total,
            invoice_date: dateFilter(invoice.invoice_date),
            due_date: dateFilter(invoice.due_date)
          };
        });
      }
    };

    vm.$onInit = function () {
      vm.waitMsg = $translate.instant('GLOBAL.LOADING_DATA');
      vm.errorMsg = ''; //Obtaining the list of invoices

      $scope.limitValues = [5, 10, 15, 20, 50, 100, 200];
      $scope.paginator = paginationManager($scope, 'invoice', invoicesResource.query, clearErrorMsg, showErrorMsg);
      $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : invoiceConfig.list.pageSize;
      $scope.paginator.page = 1; //Maintaining the filters in sync

      $scope.$watchCollection('vm.filters', function (filters) {
        $scope.paginator.filters = filters;
      });
    };
    /**
     * Clear the error message.
     */


    function clearErrorMsg() {
      vm.errorMsg = '';
    }
    /**
     * Show an error.
     * @param {string} [err='GLOBAL.LIST_NOT_AVAILABLE']
     */


    function showErrorMsg(err) {
      vm.errorMsg = err || 'GLOBAL.LIST_NOT_AVAILABLE';
    }
    /**
     * Download the PDF document of the invoice given as argument.
     * @param {invoicesResource} invoice
     */


    vm.downloadPdf = function (invoice) {
      invoice.getPdfDocument().then(function (blobData) {
        FileSaver.saveAs(blobData, invoice.getId() + '.pdf');
      })["catch"](function (errorMsg) {
        toaster.error(errorMsg);
      });
    };
    /**
     * Download generated document of the actual offer.
     */


    vm.downloadFile = function (type) {
      var numbers = [];
      $scope.paginator.rows.forEach(function (element) {
        numbers.push(element.invoice_number);
      });

      if (numbers.length === 0) {
        return;
      }

      $http({
        method: 'GET',
        url: invoiceConfig.downloadFile + "?numbers=" + numbers.toString() + "&type=".concat(type),
        headers: {
          'Content-type': 'application/json'
        },
        responseType: 'blob'
      }).success(function (data, status, headers, config) {
        var blob = type !== "pdf" ? new Blob([data], {
          type: 'application/octet-stream'
        }) : new Blob([data], {
          type: "application/pdf"
        });
        var objectUrl = URL.createObjectURL(blob);
        var anchor = document.createElement("a");
        anchor.download = "Lista-faktur.".concat(type);
        anchor.href = objectUrl;
        anchor.click();
      }).error(function (data, status, headers, config) {//upload failed
      });
    };
  }
})(angular.module('app'));
"use strict";

/**
 * Service to avoid execute $apply() after each remote event received.
 * Just inject "websocket" in a controller or service and that's it.
 *
 * @author daniel.zegarra@orba.co
 */
(function (module, io) {
  'use strict';

  module.provider('websocket', function () {
    var provider = this,
        socket;
    /**
     * URL of the websocket host server.
     * ws://DOMAIN/route/path
     * @type {string}
     */

    var hostUrl = null;
    /**
     * Route path to use to open the websocket connection.
     * ws://domain/ROUTE/PATH
     * @type {string}
     */

    var hostUrlRoute = null;
    /**
     * Set the url of the websocket server.
     * @param {string} url
     */

    provider.setHost = function (url) {
      hostUrl = url;
    };
    /**
     * Set the path of the url of the websocket server.
     * @param {string} path
     */


    provider.setUrlRoute = function (path) {
      hostUrlRoute = path;
    };
    /**
     * Return the url of the websocket server.
     * @returns {string}
     */


    provider.getHost = function () {
      return hostUrl;
    };
    /**
     * Return the route path currently used.
     * @returns {string}
     */


    provider.getUrlRoute = function () {
      return hostUrlRoute;
    };
    /**
     * This function returns the real thing.
     * @returns {{connect: connect, on: on, emit: emit}}
     */

    /*@ngInject*/


    provider.$get = function ($rootScope, $q) {
      if (!io) throw 'The JSlib socket.io is not loaded in the browser';
      /**
       * Start a connection with the server using token string.
       * @param {string} token
       * @return {$q}
       */

      var connect = function connect(token) {
        return $q(function (resolve, reject) {
          socket = io.connect(provider.getHost(), {
            //In case the websocket server is listening in a specific route
            path: provider.getUrlRoute()
          });

          var onSuccess = function onSuccess(response) {
            resolve(response);
          };

          var onFailure = function onFailure(err) {
            socket.disconnect();
            if (reject) reject(err.message);
          };

          socket.on('connect', function () {
            socket.emit('authenticate', {
              token: token
            });
            socket.on('authenticated', onSuccess);
            socket.on('unauthorized', onFailure);
          });
        });
      };
      /**
       * Listen for an event.
       * @param {string} eventName
       * @param {function} callback
       */


      var on = function on(eventName, callback) {
        if (!socket) return;
        socket.on(eventName, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            callback.apply(socket, args);
          });
        });
      };
      /**
       * Emit an event to the server.
       * @param {string} eventName
       * @param {*} data
       * @param {function} [callback]
       */


      var emit = function emit(eventName, data, callback) {
        if (!socket) return;
        socket.emit(eventName, data, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            if (callback) callback.apply(socket, args);
          });
        });
      };
      /**
       * Listen for an event and stop listening after the first dispatch.
       * @param {string} eventName
       * @param {function} callback
       */


      var once = function once(eventName, callback) {
        var listener = socket.on(eventName, function () {
          var args = arguments;
          $rootScope.$apply(function () {
            callback.apply(socket, args);
          }); //Stop listening
          //listener.destroy();
        });
      };

      return {
        connect: connect,
        on: on,
        once: once,
        emit: emit
      };
    };

    provider.$get.$inject = ["$rootScope", "$q"];
  });
})(angular.module('app'), io);
"use strict";

(function (module, humane) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:toaster
   * @description
   * Service to display discrete notifications in the screen.
   * It requires of the library humane.js.
   * @author  daniel.zegarra@orba.co
   */

  /*@ngInject*/

  module.factory('toaster', ["humane", function (humane) {
    var hideDelay = 3000,
        normalDelay = hideDelay,
        errorDelay = hideDelay * 1.5;
    return {
      success: humane.spawn({
        addnCls: 'humane-flatty-success',
        clickToClose: true,
        timeout: normalDelay
      }),
      error: humane.spawn({
        addnCls: 'humane-flatty-error',
        clickToClose: true,
        timeout: errorDelay
      }),
      warning: humane.spawn({
        addnCls: 'humane-flatty-warning',
        clickToClose: true,
        timeout: normalDelay
      }),
      info: humane.spawn({
        addnCls: 'humane-flatty-info',
        clickToClose: true,
        timeout: normalDelay
      })
    };
  }]);
  /**
   * @ngdoc service
   * @name humane
   * @description Registering the humane library as a angular value.
   */

  module.value('humane', humane);
})(angular.module('orbaUtils'), humane);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc factory
   * @name resourceQueryPaginator
   * @description
   * Read the pagination parameters returned in the header response of the GET HTTP requests and include this
   * parameters in the final collection deliver during the initial call.
   * The additional parameters are accessible as non enumerable properties of the returned collection.
   *
   * This service cover a deficiency of the $resource service which doesn't allow to change the final result
   * passed to the requester.
   *
   * This factory returns a function which should be called for each $resource you need to implement.
   * @author  daniel.zegarra@orba.co
   */

  /*@ngInject*/

  module.factory('resourceQueryPaginator', function () {
    return function () {
      /**
       * Values which will be copied to the next results.
       * @type {object}
       */
      var toApplyInNextResult = {};
      /**
       * HTTP transform function used to read and temporary store the pagination values
       * @param data
       * @param headerGetter
       * @param status
       * @return {*}
       */

      function readPaginationParams(data, headerGetter, status) {
        var limit = headerGetter('x-pagination-limit'),
            page = headerGetter('x-pagination-page'),
            pages = headerGetter('x-pagination-pages'),
            total = headerGetter('x-pagination-total');
        toApplyInNextResult = {
          limit: parseInt(limit, 10),
          page: parseInt(page, 10),
          pages: parseInt(pages, 10),
          total: parseInt(total, 10)
        };
        return data;
      }
      /**
       * Define the value of a no enumerable property in a object.
       * If the property is enumerable is changed to no enumerable.
       * @param {object} obj
       * @param {string} propName
       * @param {*} value
       */


      function setNoEnumerableValue(obj, propName, value) {
        if (obj.hasOwnProperty(propName)) {
          if (obj.propertyIsEnumerable(propName)) {
            Object.defineProperty(obj, propName, {
              enumerable: false
            });
          }

          obj[propName] = value;
        } else {
          Object.defineProperty(obj, propName, {
            enumerable: false,
            value: value
          });
        }
      }
      /**
       * Decorate a method of the resource given to apply the no enumerable properties to its results before
       * pass then to the requester.
       * @param {$resource} resource
       * @param {string} [methodName='query']
       */


      function applyToResource(resource, methodName) {
        methodName = angular.isString(methodName) ? methodName : 'query';
        var originalMethod = resource[methodName];

        resource[methodName] = function () {
          var queryResults = originalMethod.apply(this, arguments);
          queryResults.$promise.then(function (rows) {
            if (Object.keys(toApplyInNextResult).length) {
              setNoEnumerableValue(rows, 'limit', toApplyInNextResult.limit);
              setNoEnumerableValue(rows, 'page', toApplyInNextResult.page);
              setNoEnumerableValue(rows, 'pages', toApplyInNextResult.pages);
              setNoEnumerableValue(rows, 'total', toApplyInNextResult.total);
              toApplyInNextResult = {};
            }

            return rows;
          });
          return queryResults;
        };
      }
      /**
       * Add a custom transformation to capture the pagination parameters and return the new transforms stack.
       * The new transform function don't change the data received.
       * @param {function[]} transforms
       * @return {function[]}
       */


      function addTransformTo(transforms) {
        return transforms.concat(readPaginationParams);
      }

      return {
        applyToResource: applyToResource,
        addTransformTo: addTransformTo
      };
    };
  });
})(angular.module('orbaUtils'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc factory
   * @name resourceQueryPaginator
   * @description
   * Read the pagination parameters returned in the header response of the GET HTTP requests and include this
   * parameters in the final collection deliver during the initial call.
   * The additional parameters are accessible as non enumerable properties of the returned collection.
   *
   * This service cover a deficiency of the $resource service which doesn't allow to change the final result
   * passed to the requester.
   *
   * This factory returns a function which should be called for each $resource you need to implement.
   * @author  daniel.zegarra@orba.co
   */

  /*@ngInject*/

  module.factory('resourceQueryPaginator', function () {
    return function () {
      /**
       * Values which will be copied to the next results.
       * @type {object}
       */
      var toApplyInNextResult = {};
      /**
       * HTTP transform function used to read and temporary store the pagination values
       * @param data
       * @param headerGetter
       * @param status
       * @return {*}
       */

      function readPaginationParams(data, headerGetter, status) {
        var limit = headerGetter('x-pagination-limit'),
            page = headerGetter('x-pagination-page'),
            pages = headerGetter('x-pagination-pages'),
            total = headerGetter('x-pagination-total');
        toApplyInNextResult = {
          limit: parseInt(limit, 10),
          page: parseInt(page, 10),
          pages: parseInt(pages, 10),
          total: parseInt(total, 10)
        };
        return data;
      }
      /**
       * Define the value of a no enumerable property in a object.
       * If the property is enumerable is changed to no enumerable.
       * @param {object} obj
       * @param {string} propName
       * @param {*} value
       */


      function setNoEnumerableValue(obj, propName, value) {
        if (obj.hasOwnProperty(propName)) {
          if (obj.propertyIsEnumerable(propName)) {
            Object.defineProperty(obj, propName, {
              enumerable: false
            });
          }

          obj[propName] = value;
        } else {
          Object.defineProperty(obj, propName, {
            enumerable: false,
            value: value
          });
        }
      }
      /**
       * Decorate a method of the resource given to apply the no enumerable properties to its results before
       * pass then to the requester.
       * @param {$resource} resource
       * @param {string} [methodName='query']
       */


      function applyToResource(resource, methodName) {
        methodName = angular.isString(methodName) ? methodName : 'query';
        var originalMethod = resource[methodName];

        resource[methodName] = function () {
          var queryResults = originalMethod.apply(this, arguments);
          queryResults.$promise.then(function (rows) {
            if (Object.keys(toApplyInNextResult).length) {
              setNoEnumerableValue(rows, 'limit', toApplyInNextResult.limit);
              setNoEnumerableValue(rows, 'page', toApplyInNextResult.page);
              setNoEnumerableValue(rows, 'pages', toApplyInNextResult.pages);
              setNoEnumerableValue(rows, 'total', toApplyInNextResult.total);
              toApplyInNextResult = {};
            }

            return rows;
          });
          return queryResults;
        };
      }
      /**
       * Add a custom transformation to capture the pagination parameters and return the new transforms stack.
       * The new transform function don't change the data received.
       * @param {function[]} transforms
       * @return {function[]}
       */


      function addTransformTo(transforms) {
        return transforms.concat(readPaginationParams);
      }

      return {
        applyToResource: applyToResource,
        addTransformTo: addTransformTo
      };
    };
  });
})(angular.module('orbaUtils'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name paginationManager
   * @description
   * Receive a $resource query function and returns an object ready to publish in any angular scope.
   * If any of the parameters returned by the object of this function change, the results will be automatically
   * updated.
   *
   * For used in a controllers:
   *  1. Inject this service.
   *  2. Create a instance: $scope.paginator = paginationManager(offersResource.query, onSuccess, onFailure);
   *  3. Set the page and page size properties:
   *    $scope.paginator.limit = 10; //Page size
   *    $scope.paginator.page = 1; //Current page
   *
   * Then, the properties of the pagination instance can be binding to any other pagination component.
   */

  /*@ngInject*/

  module.factory('paginationManager', ["$rootScope", "$localStorage", "$q", "lodash", function ($rootScope, $localStorage, $q, lodash) {
    return function (_$scope, resName, queryFn, onSuccess, onFailure) {
      var me = {},
          lastQueryPayload,
          filtersWatcher;
      me.limitValues = [5, 10, 15, 20, 50, 100];
      me.$promise = null;
      me.rows = [];
      me.filters = {};
      me.limit = 0;
      me.filters = {};
      me.total = 0;
      me.page = 0;
      me.pages = 0;
      me.settleData = {};
      me.from = 0;
      me.to = 0;
      me.refresh = refresh;
      me.haveFilters = haveFilters;
      me.autoRefresh = autoRefresh;
      lastQueryPayload = buildQueryPayload(); //Watching the filters property waiting for changes to update the results

      autoRefresh(true);

      function scopeWatcher() {
        if (_$scope.paginator) {
          var stored = $localStorage.paginatorData || {};
          stored[resName] = {
            limit: _$scope.paginator.limit
          };
          $localStorage.paginatorData = stored;
        }
      }

      if (resName !== null) {
        var stored = $localStorage.paginatorData || {};
        me.limit = stored[resName] && stored[resName].limit ? stored[resName].limit : 10;
        me.page = 1;

        _$scope.$watch('paginator.limit', scopeWatcher); // To use custom limits list, set them in scope before invoke of paginationManager


        if (!_$scope.hasOwnProperty('limitValues')) {
          _$scope.limitValues = me.limitValues;
        }
      }
      /**
       * Return an object with the filters needed to send in the search request.
       * @return {{limit: number, offset: number}}
       */


      function buildQueryPayload() {
        var f = {
          limit: me.limit,
          offset: me.page
        },
            filters = getFilters();

        if (haveFilters()) {
          angular.extend(f, filters);
        }

        if (typeof me.category === 'string') {
          f.category = me.category;
        }

        return f;
      }
      /**
       * Execute a new query with the current query parameters.
       * @returns {$q}
       */


      function refresh() {
        lastQueryPayload = buildQueryPayload();
        var query = queryFn(lastQueryPayload);
        me.$resolved = query.$resolved;
        return me.$promise = query.$promise.then(function (rows) {
          me.$resolved = query.$resolved;
          me.rows = rows;
          me.limit = rows.limit || rows.length;
          me.total = rows.total;
          me.page = rows.page || 1;
          me.pages = rows.pages || 1;
          me.from = me.limit * (me.page - 1) + 1;
          me.to = me.limit * me.page > me.total ? me.total : me.limit * me.page;
          lastQueryPayload = buildQueryPayload();
          return rows;
        }, function (result) {
          me.$resolved = query.$resolved;
          me.rows = [];
          return $q.reject(result.data || result);
        }).then(onSuccess, onFailure);
      }
      /**
       * Check if filters are defined to limit the results.
       * @return {boolean}
       */


      function haveFilters() {
        var filters = getFilters();
        return angular.isObject(filters) && Object.keys(filters).length > 0;
      }
      /**
       * Return an object with the filters after validate then.
       * Take just the filters which doesn't have empty values.
       * @return {Object}
       */


      function getFilters() {
        return lodash.pickBy(me.filters, function (value) {
          if (angular.isString(value)) {
            return !!value;
          }

          return true;
        });
      }
      /**
       * Enable or disable the watcher for the filters object.
       *
       * @param {boolean} [enable=false]
       */


      function autoRefresh(enable) {
        if (enable && !filtersWatcher) {
          //Continuously check for changes and execute a new search is detects one
          filtersWatcher = $rootScope.$watch(function () {
            var newPauload = buildQueryPayload();

            if (!angular.equals(lastQueryPayload, newPauload)) {
              refresh();
            }
          });
        } else if (!enable && filtersWatcher) {
          filtersWatcher();
          filtersWatcher = null;
        }
      }

      return me;
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name notifications
   * @module app
   * @description
   * Fetches notifications from backend
   */

  notifications.$inject = ["$uibModal", "$rootScope", "$q", "$cookies", "websocket", "toaster"];
  module.service('notifications', notifications);
  /*@ngInject*/

  function notifications($uibModal, $rootScope, $q, $cookies, websocket, toaster) {
    var NOTIF_GET_ACTION = 'message.get';
    var HEADER_NOTIF_NEW_EVENT = 'headerNotificationFetched';
    var FOOTER_NOTIF_NEW_EVENT = 'footerNotificationFetched';
    var NOTIF_CLOSE_EVENT = 'notificationClosed';
    var LAST_SHOWN_NOTIF_COOKIE = 'lsnc';
    var shownNotifId = null;
    /**
     * Dispatches new notification event
     *
     * @param {object} notification
     * @return undefined
     */

    var dispatchNotification = function dispatchNotification(notification) {
      var eventName = notification.message_type == 'header' ? HEADER_NOTIF_NEW_EVENT : FOOTER_NOTIF_NEW_EVENT;
      $rootScope.$emit(eventName, notification);
    };
    /**
     * Checks if notification should be displayed
     *
     * @param {number} id
     * @return {boolean}
     */


    var shouldNotifBeDisplayed = function shouldNotifBeDisplayed(id) {
      var lastShownIdCookie = $cookies.get(LAST_SHOWN_NOTIF_COOKIE);

      if (!lastShownIdCookie || lastShownIdCookie != id) {
        return true;
      }

      return false;
    };
    /**
     * Saves fact that notification has been shown
     *
     * @param {number} id
     * @return undefined
     */


    var saveNotifShown = function saveNotifShown() {
      $cookies.put(LAST_SHOWN_NOTIF_COOKIE, shownNotifId);
    };
    /**
     * Checks if the notification needs to be displayed and dispatches proper event.
     *
     * @param {object} notif Notification in format returned from backend:
     *   - {number} entity_id - Unique ID of the notification
     *   - {string} message_link - Link to be redirected to
     *   - {string} message_content - Content of the notification
     *
     * @return undefined
     */


    var validateAndDispatch = function validateAndDispatch(notif) {
      if (Object.keys(notif).length > 0 && (notif.message_type == 'footer' || shouldNotifBeDisplayed(notif.entity_id))) {
        $rootScope.$on(NOTIF_CLOSE_EVENT, saveNotifShown);
        shownNotifId = notif.entity_id;
        dispatchNotification(notif);
      }
    };
    /**
     * Fetches the notification from backend and emits event in case it's new
     *
     * @param {string} messageType Message type
     */


    var fetch = function fetch(messageType) {
      websocket.emit(NOTIF_GET_ACTION, messageType, validateAndDispatch);
    };

    return {
      fetch: fetch
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name gtmDataLayer
   * @module app
   * @description
   * Manages GTM dataLayer
   */

  gtmDataLayer.$inject = ["$window"];
  module.service('gtmDataLayer', gtmDataLayer);
  /*@ngInject*/

  function gtmDataLayer($window) {
    /**
     * Pushes data to GTM dataLayer object.
     *
     * @param {Object} data Data to push
     */
    var push = function push(data) {
      if (typeof $window.dataLayer === 'undefined') {
        return;
      }

      try {
        $window.dataLayer.push(data);
      } catch (err) {// ignore errors
      }
    };

    return {
      push: push
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:fileDownload
   * @description Service to handle file downloads.
   */

  module.service('fileDownload', ['FileSaver', function (FileSaver) {
    /**
     * Get file name returned in Content-Disposition header of response.
     *
     * @param {object} response Response fetched from magento
     * @returns {string|null} The file name
     */
    var getFileNameFromResponse = function getFileNameFromResponse(response) {
      var contentDisposition = response.headers('Content-Disposition');

      if (contentDisposition && contentDisposition.length) {
        var filenameRegex = /filename="(.+?)"/;
        var matches = filenameRegex.exec(contentDisposition);
        return matches[1];
      }

      return null;
    };
    /**
     * Download file basing on response from API.
     *
     * @param [response] Response fetched from magento
     * @param [alternativeName] Alternative file name
     * @returns {undefined}
     */


    var downloadFile = function downloadFile(response, alternativeName) {
      var fileName = getFileNameFromResponse(response);

      if (!fileName) {
        if (typeof alternativeName !== 'undefined') {
          fileName = alternativeName;
        } else {
          fileName = 'download';
        }
      }

      FileSaver.saveAs(response.data, fileName);
    };

    return {
      downloadFile: downloadFile
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name convertToOfferModal
   * @module app
   * @description
   * Service to show a modal window for converting cart to offer and offer to cart
   */

  convertToModal.$inject = ["$uibModal", "$rootScope", "$q"];
  module.service('convertToModal', convertToModal);
  /*@ngInject*/

  function convertToModal($uibModal, $rootScope, $q) {
    /**
     * @name show
     * @description
     * Show the modal importer.
     * @return {Promise}
     */
    var show = function show(oldName, remove, origin) {
      return $q(function (resolve, reject) {
        var scope = $rootScope.$new(true);
        scope.translation = {
          'title': origin + '.CONVERT.MODAL_TITLE',
          'newName': origin + '.CONVERT.NEW_NAME',
          'remove': origin + '.CONVERT.REMOVE_SELECTION',
          'confirm': origin + '.CONVERT.CONFIRM'
        };
        /**
         * Initial data for converting modal
         * @type {{name: *, remove: boolean}}
         */

        scope.convertData = {
          name: oldName,
          remove: remove
        };
        /**
         * Create modal instance
         */

        scope.modalInstance = $uibModal.open({
          size: 'sm',
          windowClass: 'center-modal-child',
          //Template to encapsulate the component
          template: '<div class="modal-body convert-modal" ><form name="$parent.convertForm" novalidate ng-submit="convert()">' + '<h3 translate>{{translation.title}}</h3>' + '<div class="form-group" show-input-errors><label translate>{{translation.newName}}</label>' + '<input type="text" ng-model="$parent.convertData.name" name="newName" class="form-control" required/>' + '<span class="c-error" ng-show="$parent.convertForm.newName.$error.required" translate>ERRORS.REQUIRED</span>' + '</div>' + '<div class="form-group">' + '<input type="checkbox" id="confirmRemove" name="confirmRemove" ng-model="$parent.convertData.remove"/>' + '<label for="confirmRemove" translate>{{translation.remove}}</label>' + '</div>' + '<div class="import-actions"><button class="btn btn-primary" type="submit" translate>{{translation.confirm}}</button></div>' + '<div class="close-button">' + '<button type="button" class="close" ng-click="$dismiss()" ng-attr-title="{{\'GLOBAL.CLOSE\'|translate}}" ng-attr-aria-label="{{\'GLOBAL.CLOSE\'|translate}}">' + '</button>' + '</div>' + '</form></div>',
          scope: scope
        });
        /**
         * Reject promise when closed with no confirmation
         */

        scope.modalInstance.closed.then(function () {
          reject();
        });
        /**
         * Resolve promise with new offer data
         */

        scope.convert = function () {
          if (scope.convertForm.$invalid) {
            return;
          }

          scope.modalInstance.close();
          resolve(scope.convertData);
        };
      });
    };

    var failedItems = null;
    return {
      show: show,
      failedItems: failedItems
    };
  }
})(angular.module('app'));
"use strict";

/**
 * Show a spinner in the screen.
 * Based in {@link http://tobiasahlin.com/spinkit/} of @tobiasahlin.
 */
(function (module) {
  module.component('spinner', {
    template: '<div class="spinnerWrapper">' + '<div class="rect1"></div> ' + '<div class="rect2"></div> ' + '<div class="rect3"></div> ' + '<div class="rect4"></div> ' + '<div class="rect5"></div> ' + '</div> ' + '<p>{{vm.label}}</p>',
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      label: '@'
    }
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgInputButton
   * @description
   * Input field of the editor component to update the name of the model.
   */

  /*@ngInject*/

  module.directive('sgInputButton', ["$timeout", function ($timeout) {
    return {
      templateUrl: 'app/global/directives/sgInputButton.html',
      link: function link(scope, element, attrs, ngModel) {
        var input = element.find('input'),
            btn = element.find('button');

        function onPress() {
          scope.onRequestSave({
            name: input.val()
          });
        }

        ngModel.$render = function () {
          input.val(ngModel.$viewValue);
        };

        input.on('blur keyup change', function () {
          ngModel.$setViewValue(input.val());
        });
        btn.on('click', onPress);
        scope.onPress = onPress;

        if (angular.isDefined(attrs.autofocus)) {
          $timeout(function () {
            input.focus();
          }, 0);
        }
      },
      require: 'ngModel',
      scope: {
        /**
         * Label of the input field
         * @type string
         */
        fieldLabel: '@label',

        /**
         * Placeholder of the input field
         * @type string
         */
        placeholder: '@',

        /**
         * Disabled the input field.
         * @type boolean
         */
        disabled: '<',

        /**
         * Disabled the button.
         * @type boolean
         */
        btnDisabled: '<',

        /**
         * Function to execute when the user press over the button.
         */
        onRequestSave: '&',

        /**
         * Indicate if the input field should take focus automatically after browser finish page loading.
         * @boolean
         */
        autofocus: '<'
      }
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:ngTab
   * @description
   * Implementing the ng-tab directive.
   *
   * This directive execute an expression when the user press the TAB button.
   * This directive work exactly the same as ng-click.
   */

  module.directive('ngTab', function () {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        element.bind('keydown keypress', function (event) {
          if (event.which === 9) {
            scope.$apply(function () {
              scope.$eval(attrs.ngTab, {
                'event': event
              });
            });
            event.preventDefault();
          }
        });
      }
    };
  });
})(angular.module('app'));
"use strict";

/**
 * Implementing the ng-enter directive.
 *
 * This directive execute an expression when the user press the Enter button.
 * This directive work exactly the same as ng-click.
 */
angular.module('app').directive('ngEnter', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.bind('keydown keypress', function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter, {
              'event': event
            });
          });
          event.preventDefault();
        }
      });
    }
  };
});
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc directive
   * @name datepickerModel
   * @module app
   * @description
   * Automatically convert date written in the view value of a input field to a date in the ISO format.
   */

  module.directive('datepickerModel', ["moment", "$translate", function (moment, $translate) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, el, attr, ngModel) {
        if (!ngModel) {
          attr.dateFormat = 'dd.MM.yyyy';
          return;
        } else {
          el.prop('autocomplete', 'off');
          el.prop('placeholder', $translate.instant('GLOBAL.DATE_FORMAT_CODE'));
        }

        ngModel.$render = function () {
          el.val(formatDateAsLocale(ngModel.$viewValue || ''));
        };

        ngModel.$parsers.push(function (value) {
          return parseLocaleDate(value);
        });
        ngModel.$formatters.push(function (value) {
          return angular.isDate(value) ? moment(value).format('YYYY-MM-DD') : value;
        }); //Never left a invalid value in the input field

        el.on('blur', function () {
          if (ngModel.$invalid) {
            ngModel.$rollbackViewValue();
          }
        });
        /**
         * Convert a string local date with format into a YYYY-MM-DD format.
         * @param {string} date
         * @returns {string|undefined} Return undefined if the date is not valid
         */

        function parseLocaleDate(date) {
          if (date && angular.isString(date)) {
            var d = moment(date, 'L', true);

            if (d.isValid()) {
              return d.format('YYYY-MM-DD'); //ISO format
            }
          }

          return undefined;
        }
        /**
         * Convert a string date with format YYYY-MM-DD into a local format.
         * @param {string} date
         * @returns {string|undefined} Return undefined if the date is not valid
         */


        function formatDateAsLocale(date) {
          if (date && angular.isString(date)) {
            var d = moment(date, 'YYYY-MM-DD', true); //ISO format

            if (d.isValid()) {
              return d.format('L');
            }
          }

          return undefined;
        }
      }
    };
  }]);
})(angular.module('app'), angular);
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @module app
   * @name furnitureOffersNewCtrl
   * @description
   * Controller for create new issue.
   */

  module.controller('furnitureOffersNewCtrl', ["$scope", "addressesResource", "lodash", "issuesResource", "issueAttachmentsModal", "websocket", "$q", "$http", "orbaSession", "usersMeResource", "$location", "toaster", "$state", "$translate", "$rootScope", function furnitureOffersNewCtrl($scope, addressesResource, lodash, issuesResource, issueAttachmentsModal, websocket, $q, $http, orbaSession, usersMeResource, $location, toaster, $state, $translate, $rootScope) {
    $scope.isSubmit = false;
    $scope.editId = -1;
    usersMeResource.get().$promise.then(function (data) {
      $scope.info = {
        user: data
      };
    });
    $scope.edited = {
      deliveryName: false,
      deliveryStreet: false,
      deliveryBuilding: false,
      deliveryCity: false,
      deliveryPostcode: false,
      deliveryPerson: false,
      deliveryPhone: false,
      offerType: false,
      logo: false,
      name: false,
      phone: false,
      contactPerson: false,
      email: false,
      spin: false,
      orderNumber: false,
      productDescription: false,
      productDimensions: false,
      productUniq: false,
      productAmount: false
    };
    $scope.dropFileAvailable = true;
    $scope.currentPreset = '';
    $scope.addressData = {};
    $scope.addNew = false;
    $scope.validCodes = '';
    $scope.lastItemId = 1;
    $scope.fileSizeLimit = 70 * 1024 * 1024; //70 MB

    $scope.addOrEdit = false;
    $scope.showAddressPart = false;
    $scope.editIssue = false;
    $scope.attachments = [];
    $scope.attachment = null;
    $scope.items = [];
    $scope.item = {};
    $scope.offerName = '';
    $scope.issuePromise = '';
    $scope.offerData = {
      offerType: '',
      logo: 'logo-stalgast'
    };
    $scope.formData = {
      deliveryName: '',
      deliveryStreet: '',
      deliveryBuilding: '',
      deliveryCity: '',
      deliveryPostcode: '',
      contactPerson: '',
      contactPhone: '',
      contactEmail: ''
    };
    $scope.todaysDate = new Date();
    $scope.todaysDate.setDate($scope.todaysDate.getDate() - 1);
    $scope.todaysDate = $scope.todaysDate.toISOString().split('T')[0];
    $scope.hasErrorFields = false;
    $scope.addresses = addressesResource.query();
    /**
     * Messages dictionary, which are used for display them to a user
     */

    var messages = {
      issueSuccess: 'ISSUE.ISSUE_ADD_SUCCESS',
      issueError: 'ISSUE.ISSUE_ADD_FAILURE',
      formError: 'ISSUE.FILL_FORM',
      noItemsError: 'ISSUE.FILL_ITEMS',
      productSuccess: 'ISSUE.PRODUCT_ADD_SUCCESS',
      productError: 'ISSUE.PRODUCT_ADD_FAILURE',
      productDeleteSuccess: 'ISSUE.PRODUCT_DELETE_SUCCESS',
      productDeleteError: 'ISSUE.PRODUCT_DELETE_FAILURE',
      issueCheckSuccess: 'ISSUE.CHECK_SUCCESS',
      issueCreateSuccess: 'ISSUE.CREATE_SUCCESS',
      filesError: 'ISSUE.FILE_UPLOAD_ERROR'
    };
    /**
     * Initialize the controller.
     */

    function init() {
      orbaSession.userDataResolved.then(function () {
        if ($scope.formData.contact_person === '') {
          $scope.formData.contact_person = orbaSession.info.user.user.firstname + ' ' + orbaSession.info.user.user.lastname;
        }

        if ($scope.formData.contact_phone === '') {
          $scope.formData.contact_phone = orbaSession.info.user.user.phone;
        }

        if ($scope.formData.contact_email === '') {
          $scope.formData.contact_email = orbaSession.info.user.user.email;
        }

        $scope.formData.account_number = orbaSession.info.session.sgRAxId;

        if ($scope.formData.contact_notification === '') {
          $scope.formData.contact_notification = 'Email';
        }
      })["catch"](function (err) {
        toaster.error(err.data);
      });
    }

    ;
    /**
     * Add error class and change value to true of in required object for given name of filed
     * Error flag is equal true
     * @param fieldName
     */

    $scope.addErrorClass = function (fieldName) {
      $scope.hasErrorFields = true;
      angular.element(document.querySelector('#furnitureOffer_name')).addClass('error-field');
      $scope.required['name'] = true;
    };

    $scope.fieldChange = function (name) {
      $scope.edited[name] = true;
    };
    /**
     * Actually change visibility -- used internally, not w/ event
     */


    $scope.addNewVisibility = function (bool, item, rowNode) {
      $scope.errors = null;

      if (item) {
        $scope.itemRowNode = rowNode;
        rowNode.classList.add('item-editing');
        $scope.itemEdit = item;
      } else if (!bool) {
        if ($scope.itemRowNode) {
          $scope.itemRowNode.classList.remove('item-editing');
        }

        $scope.itemEdit = null;
      }

      $scope.addNew = bool;
    };
    /**
     * Change visibility of add new product form -- from event
     */


    $scope.addNewVisibilityEvent = function (bool, item, $event) {
      var rowNode = null;

      if (item) {
        rowNode = $event.currentTarget.parentNode.parentNode;
      }

      $scope.addNewVisibility(bool, item, rowNode);
    };
    /**
     * Apply a address preset to the current issue.
     * @param {addressesResource} address
     * @param {setPhonePerson} should it set phone & person or leave the default values
     */


    $scope.usePreset = function (address, setPhonePerson) {
      if (address instanceof addressesResource) {
        var picked = lodash.pick(address, ['company', 'street', 'building', 'postcode', 'city', 'telephone', 'fullname']);
        var object = {
          'deliveryName': picked.company,
          'deliveryStreet': picked.street,
          'deliveryBuilding': picked.building,
          'deliveryPostcode': picked.postcode,
          'deliveryCity': picked.city,
          'contactPhone': picked.telephone,
          'contactPerson': picked.fullname
        };

        if (!setPhonePerson) {
          delete object.contact_person;
          delete object.contact_phone;
        }

        Object.assign($scope.formData, object);
      } else {
        Object.assign($scope.formData, {
          deliveryName: '',
          deliveryStreet: '',
          deliveryBuilding: '',
          deliveryPostcode: '',
          deliveryCity: ''
        });
      }
    };
    /**
     * Return valid postcodes starting from given params
     * @param {string} code
     * @return {*[]}
     */


    $scope.findPostCodes = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            $scope.validCodes = response;
            resolve(response);
          }
        });
      });
    };
    /**
     * Checks if currently given postcode is valid
     * @param {string} postcode
     * @return {*}
     */


    $scope.validatePostcode = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (Array.isArray(response) && response.indexOf(postcode) < 0) {
            reject(false);
          } else {
            resolve(true);
          }
        });
      });
    };
    /**
     * Return valid cities based on postcode, starting from given param
     * @param {string} city
     * @return {*[]}
     */


    $scope.findCities = function (city) {
      return $q(function (resolve, reject) {
        var postcode = $scope.formData.deliveryPostcode;

        if (!postcode) {
          reject([]);
        }

        websocket.emit('account.getValidCities', {
          postcode: postcode,
          city: city
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject([]);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Return valid streets based on postcode and city, starting from given param
     * @param {string} city
     * @return {*[]}
     */


    $scope.findStreets = function (street) {
      return $q(function (resolve, reject) {
        var postcode = $scope.formData.deliveryPostcode;
        var city = $scope.formData.deliveryCity;

        if (!postcode || !city) {
          reject([]);
        }

        websocket.emit('account.getValidStreets', {
          postcode: postcode,
          city: city,
          street: street
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Set errors using data from http request.
     *
     * Useful when `catch`ing from a promise.
     *
     * @param {object} response - Response from a http request.
     */


    $scope.setErrors = function (response) {
      $scope.errors = response.data;
    };

    $scope.deleteFile = function (file) {
      $scope.attachments = $scope.attachments.filter(function (f) {
        return f !== file;
      });
    };

    $scope.getFileExtension = function (filename) {
      return filename.substring(filename.lastIndexOf('.') + 1, filename.length) || filename;
    };

    $scope.addProduct = function () {
      if (!$scope.validateProduct()) {
        toaster.error("Prosimy o poprawienie danych produktu");
        return;
      }

      if ($scope.editId >= 0) {
        $scope.items[$scope.editId] = $scope.item;
        $scope.item = {};
        $scope.addOrEdit = false;
        $scope.editId = -1;
        return;
      }

      $scope.item.id = $scope.items === undefined ? 0 : $scope.items.length + 1;
      $scope.items.push($scope.item);
      $scope.item = {};
      $scope.addOrEdit = false;
    };

    $scope.showProductEdit = function () {
      $scope.resetProductEdit();
      $scope.item = {};

      if ($scope.offerData.offerType === 'eval-attach' || $scope.offerData.offerType === 'order-attach') {
        if ($scope.items.length > 0) {
          toaster.error("Wybrany typ zgłoszenia może mieć dodany tylko jeden produkt");
          return;
        }

        $scope.item.description = 'Meble wg listy z załącznika';
      }

      $scope.addOrEdit = true;
    };

    $scope.edit = function (index) {
      $scope.resetProductEdit();
      $scope.editId = index - 1;
      $scope.addOrEdit = true;
      $scope.item = Object.assign({}, $scope.items[index - 1]);
    };

    $scope.resetProductEdit = function () {
      $scope.edited['productDescription'] = false;
      $scope.edited['productDimensions'] = false;
      $scope.edited['productUniq'] = false;
      $scope.edited['productAmount'] = false;
      $scope.edited['productComments'] = false;
    };

    $scope.cancelEdit = function () {
      $scope.addOrEdit = false;
      $scope.resetProductEdit();
    };

    $scope.deleteProduct = function (index) {
      $scope.items.splice(index, 1);
      var i = 1;
      $scope.items.forEach(function (el) {
        el.id = i++;
      });
    };

    $scope.validate = function () {
      if ($scope.addOrEdit === true) {
        toaster.error("Wysłanie formularza nie jest możliwe podczas edycji/dodawania produktu");
        return false;
      }

      if (!($scope.validateField('name') && $scope.validateField('phone') && $scope.validateField('email') && $scope.validateField('offerType') && $scope.validateField('orderNumber') && $scope.validateField('comments') && $scope.validateField('contactPerson') && $scope.validateField('logo'))) {
        toaster.error('Prosimy uzupełnić dane');
        return false;
      }

      if ($scope.offerData.offerType === 'order' || $scope.offerData.offerType === 'order-attach') {
        if (!($scope.validateField('deliveryName') && $scope.validateField('deliveryBuilding') && $scope.validateField('deliveryCity') && $scope.validateField('deliveryPostcode') && $scope.validateField('deliveryStreet') && $scope.validateField('deliveryPhone') && $scope.validateField('deliveryPerson'))) {
          toaster.error('Prosimy uzupełnić dane wysyłki');
          return false;
        }
      }

      if (!$scope.checkAttachments()) {
        return false;
      }

      if ($scope.items.length === 0) {
        toaster.error("Wymagany jest conajmniej 1 dodany produkt");
        return false;
      }

      return true;
    };

    $scope.checkAttachments = function () {
      var result = true;

      if (($scope.offerData.offerType === 'eval-attach' || $scope.offerData.offerType === 'order-attach') && $scope.attachments.length === 0) {
        toaster.error("Wymagany jest conajmniej 1 załącznik");
        result = false;
      }

      if (!$scope.checkFileSizes()) {
        toaster.error("Zbyt duże załączniki, dopuszczalna wielkość to maksymalnie 70MB");
        result = false;
      }

      return result;
    };

    $scope.dropFileError = function () {
      if ($scope.furnitureRegistration.file.$error.pattern === true) {
        toaster.error('Niepoprawne rozszerzenie pliku');
      }
    };

    $scope.validateProduct = function () {
      $scope.edited['productDescription'] = true;
      $scope.edited['productDimensions'] = true;
      $scope.edited['productUniq'] = true;
      $scope.edited['productAmount'] = true;
      $scope.edited['productComments'] = true;
      return $scope.validateField('productDescription') && $scope.validateField('productDimensions') && $scope.validateField('productUniq') && $scope.validateField('productAmount') && $scope.validateField('productComments');
    };

    $scope.validateEmail = function (email) {
      var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      return !!email.match(validRegex);
    };

    $scope.validateField = function (field) {
      switch (field) {
        case "name":
          return !$scope.edited.name ? true : $scope.offerName !== undefined ? $scope.offerName.length > 2 && $scope.offerName.length <= 50 : false;

        case "phone":
          return !$scope.edited.phone ? true : $scope.offerData.phone !== undefined ? $scope.offerData.phone.length === 9 && /^\d+$/.test($scope.offerData.phone) : false;

        case "email":
          return !$scope.edited.email ? true : $scope.offerData.email !== undefined ? $scope.offerData.email.length > 5 && $scope.offerData.email.length < 50 && $scope.validateEmail($scope.offerData.email) : false;

        case "comments":
          return $scope.offerData.comments !== undefined ? $scope.offerData.comments.length < 200 : true;

        case "offerType":
          return !$scope.edited.offerType ? true : $scope.offerData.offerType !== undefined && $scope.offerData.offerType.length > 1;

        case "orderNumber":
          return !$scope.edited.orderNumber ? true : $scope.offerData.connectToOrder ? $scope.offerData.orderNumber !== undefined ? $scope.offerData.orderNumber.length > 7 && $scope.offerData.orderNumber.length <= 20 : false : true;

        case "deliveryName":
          return !$scope.edited.deliveryName ? true : $scope.formData.deliveryName !== undefined ? $scope.formData.deliveryName.length > 2 && $scope.formData.deliveryName.length <= 50 : false;

        case "deliveryBuilding":
          return !$scope.edited.deliveryBuilding ? true : $scope.formData.deliveryBuilding !== undefined ? $scope.formData.deliveryBuilding.length > 0 && $scope.formData.deliveryBuilding.length <= 15 : false;

        case "deliveryCity":
          return !$scope.edited.deliveryCity ? true : $scope.formData.deliveryCity !== undefined ? $scope.formData.deliveryCity.length > 2 && $scope.formData.deliveryCity.length <= 20 : false;

        case "deliveryPerson":
          return !$scope.edited.deliveryPerson ? true : $scope.formData.contactPerson !== undefined ? $scope.formData.contactPerson.length > 1 && $scope.formData.contactPerson.length <= 25 : false;

        case "deliveryPhone":
          return !$scope.edited.deliveryPhone ? true : $scope.formData.phone !== undefined ? $scope.formData.phone.length > 0 && $scope.formData.phone.length <= 9 && /^\d+$/.test($scope.formData.phone) : false;

        case "deliveryPostcode":
          return !$scope.edited.deliveryPostcode ? true : $scope.formData.deliveryPostcode !== undefined ? $scope.formData.deliveryPostcode.length > 2 && $scope.formData.deliveryPostcode.length <= 8 : false;

        case "deliveryStreet":
          return !$scope.edited.deliveryStreet ? true : $scope.formData.deliveryStreet !== undefined ? $scope.formData.deliveryStreet.length > 2 && $scope.formData.deliveryStreet.length <= 50 : false;

        case "productDescription":
          return !$scope.edited.productDescription ? true : $scope.item.description !== undefined ? $scope.item.description.length > 5 && $scope.item.description.length < 200 : false;

        case "productDimensions":
          return !$scope.edited.productDimensions ? true : $scope.offerData.offerType === 'eval-attach' || $scope.offerData.offerType === 'order-attach' ? true : $scope.item.dimensions !== undefined ? $scope.item.dimensions.length > 0 && $scope.item.dimensions.length <= 20 : false;

        case "productUniq":
          return !$scope.edited.productUniq ? true : $scope.offerData.offerType === 'eval' || $scope.offerData.offerType === 'order' ? true : $scope.item.uniq !== undefined ? $scope.item.uniq > 0 && $scope.item.uniq <= 9999 : false;

        case "productAmount":
          return !$scope.edited.productAmount ? true : $scope.item.amount !== undefined ? $scope.item.amount > 0 && $scope.item.amount <= 9999 : false;

        case "productComments":
          return $scope.item.comments !== undefined ? $scope.item.comments.length < 200 : true;

        case "contactPerson":
          return !$scope.edited.contactPerson ? true : $scope.offerData.contactPerson !== undefined ? $scope.offerData.contactPerson.length > 0 && $scope.offerData.contactPerson.length < 50 : false;

        case "expectedDate":
          return $scope.offerData.expectedDate !== undefined ? $scope.offerData.expectedDate.length < 20 : true;

        case "logo":
          return !$scope.edited.logo ? true : $scope.offerData.logo !== undefined && $scope.offerData.logo.length > 1;
      }

      return false;
    };

    $scope.offerTypeControl = function () {
      if ($scope.items !== undefined && $scope.items.length > 0 || $scope.addOrEdit) {
        toaster.info('By zmienić typ zgłoszenia prosimy o usunięcie produktów oraz/lub zakończenie dodawania/edycji produktu');
      }
    };

    $scope.showOfferTypeMsg = function () {
      if ($scope.items.length > 0 || $scope.addOrEdit) {
        toaster.info('By zmienić typ zgłoszenia prosimy o usunięcie produktów oraz/lub zakończenie dodawania/edycji produktu');
      }
    };

    $scope.sendData = function () {
      var formData = new FormData();
      $scope.attachments.forEach(function (element, key) {
        formData.append('file' + key, element);
      });
      var uuid = $scope.uuidv4();
      toaster.info('Rozpoczęto wysyłanie formularza.');
      var data = {
        name: $scope.offerName,
        content: {
          formData: $scope.offerData,
          deliveryData: $scope.offerData.offerType === 'order' || $scope.offerData.offerType === 'order-attach' ? $scope.formData : '',
          products: $scope.items,
          user: {
            userName: $scope.info.user.user.username,
            userId: $scope.info.user.reseller.distributor_id
          }
        },
        report_id: uuid
      };

      if ($scope.attachments.length > 0) {
        $scope.furnitureFormPromise = $http.post('rest/registration/file/' + uuid, formData, {
          headers: {
            'Content-Type': undefined
          },
          transformRequest: []
        }).then(function (response) {
          data.attachmentsSent = true;
          $scope.furnitureFormPromise = $http.post('rest/registration/', data).then(function (mainResponse) {
            $scope.spin = false;
            toaster.success("Pomyślnie wysłano zgłoszenie");
            $state.go('home');
          }, function (response) {
            $scope.spin = false;
            toaster.error('Wystąpił problem, prosimy spróbować ponownie później');
          });
        }, function (response) {
          $scope.spin = false;
          toaster.error('Wystąpił problem, prosimy spróbować ponownie później');
        });
      } else {
        data.attachmentsSent = false;
        $scope.furnitureFormPromise = $http.post('rest/registration/', data).then(function (mainResponse) {
          $scope.spin = false;
          toaster.success("Pomyślnie wysłano zgłoszenie");
          $state.go('home');
        }, function (response) {
          $scope.spin = false;
          toaster.error('Wystąpił problem, prosimy spróbować ponownie później');
        });
      }
    };

    $scope.submitForm = function () {
      $scope.spin = true;

      for (var _i = 0, _Object$entries = Object.entries($scope.edited); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        $scope.edited[key] = true;
      }

      if ($scope.validate()) {
        $scope.sendData();
      } else {
        $scope.spin = false;
      }
    };

    $scope.checkFileSizes = function () {
      var size = 0;
      $scope.attachments.forEach(function (element) {
        size += element.size;
      });
      return size < $scope.fileSizeLimit;
    };
    /**
     * Function for generating unique string
     * @returns string
     */


    $scope.uuidv4 = function () {
      return $scope.formatDate(new Date()).replace(' ', '');
    };

    $scope.padTo2Digits = function (num) {
      return num.toString().padStart(2, '0');
    };

    $scope.formatDate = function (date) {
      return [date.getFullYear(), $scope.padTo2Digits(date.getMonth() + 1), $scope.padTo2Digits(date.getDate())].join('') + ' ' + [$scope.padTo2Digits(date.getHours()), $scope.padTo2Digits(date.getMinutes()), $scope.padTo2Digits(date.getSeconds()), date.getMilliseconds()].join('');
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('complaintsResource', ["$resource", "$http", "complaintConfig", "moment", "resourceQueryPaginator", "$rootScope", "$filter", function ($resource, $http, complaintConfig, moment, resourceQueryPaginator, $rootScope, $filter) {
    var paginator = resourceQueryPaginator();
    /**
     * Available complaint types
     * @type {Object}
     */

    $rootScope.complaintTypes = {
      'Complaint': 'COMPLAINT.COMPLAINT',
      'PaidRepair': 'COMPLAINT.PAIDREPAIR',
      'BackSent': 'COMPLAINT.BACKSENT',
      'Service': 'COMPLAINT.SERVICE'
    };
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */

    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.receive_date = item.receive_date === null ? '' : item.receive_date;
      item.finished_date = item.finished_date === null ? '' : item.finished_date;
      item.invoice_date = item.invoice_date === null ? '' : item.invoice_date;

      if (item.items) {
        item.items.forEach(function (obj) {
          obj.created_date = obj.created_date === null ? '' : obj.created_date;
        });
      }

      return item;
    };
    /**
     * Process a response for a request of a single row.
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformSingle = function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.complaint || data) : data;
    };
    /**
     * Process a response for a request of multiple rows.
     * Sorting dictionary arrays from response.
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformMultiple = function transformMultiple(data) {
      data.dictionary.complaint_type = data.dictionary.complaint_type.map(function (item) {
        return {
          value: item,
          translated: $filter('translate')($rootScope.complaintTypes[item])
        };
      }).sort(function (obj1, obj2) {
        var value;

        if (obj1.translated === obj2.translated) {
          value = 0;
        } else {
          value = obj1.translated > obj2.translated ? 1 : -1;
        }

        return value;
      });
      data.dictionary.current_task.sort(function (value1, value2) {
        var value;

        if (value1 === value2) {
          value = 0;
        } else {
          value = value1 > value2 ? 1 : -1;
        }

        return value;
      });
      data.dictionary.cost_for.sort(function (value1, value2) {
        var value;

        if (value1 === value2) {
          value = 0;
        } else {
          value = value1 > value2 ? 1 : -1;
        }

        return value;
      });
      $rootScope.dictionary = data.dictionary;
      return angular.isObject(data) ? (data.complaints || data).map(transformItem) : data;
    };

    var resource = $resource(complaintConfig.restful.complaints, {
      id: '@id'
    }, {
      //Collection of items
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo($http.defaults.transformResponse.concat(transformMultiple))
      },
      //Single item
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      }
    }); // Apply pagination to resource query

    paginator.applyToResource(resource, 'query');
    return resource;
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for Orders list
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('complaintListCtrl', ["$scope", "complaintsResource", "paginationManager", "complaintConfig", function complaintListCtrl($scope, complaintsResource, paginationManager, complaintConfig) {
    init();
    /**
     * Initialize the controller.
     */

    function init() {
      /**
       * Retrieve orders from api
       */
      $scope.paginator = paginationManager($scope, 'complaint', complaintsResource.query);
      $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : complaintConfig.list.pageSize;
      $scope.paginator.page = 1;
      $scope.paginator.autoRefresh(true);
    }
    /**
     * Set filters payload
     * @return {{}}
     */


    var setFilterPayload = function setFilterPayload() {
      var filterPayload = {};
      angular.forEach($scope.filter, function (value, key) {
        if (value) {
          filterPayload[key] = value;
        }
      });
      return filterPayload;
    };
    /**
     * Reload complaints with given filters
     */


    $scope.filterComplaint = function () {
      $scope.paginator.filters = setFilterPayload();
    };
    /**
     * Clear filters and refresh list
     */


    $scope.clearFilters = function () {
      $scope.filter = {};
      $scope.filterComplaint();
    };
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for order details
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('complaintItemCtrl', ["$scope", "$state", "$stateParams", "toaster", "complaintsResource", function complaintItemCtrl($scope, $state, $stateParams, toaster, complaintsResource) {
    /**
     * Error message by default if the server returns an error and don't detail the cause.
     * @type {string}
     */
    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * Returns to the complaints list router state.
     */

    $scope.goBack = function () {
      $state.go('complaints.list');
    };
    /**
     * Retrieve complaint info
     */


    if ($stateParams.id) {
      $scope.complaint = complaintsResource.get({
        id: $stateParams.id
      });
      $scope.complaint.$promise["catch"](function (response) {
        toaster.error(response.data || $scope.defaultErrorMsg);
        $scope.goBack();
      });
    } else {
      $scope.goBack();
    }
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name importXMLModalLauncher
   * @module app
   * @description
   * Service to show a modal window for import items from xml
   */

  importXMLModalLauncher.$inject = ["$uibModal", "$rootScope", "$window", "cartsResource", "toaster"];
  module.service('importXMLModalLauncher', importXMLModalLauncher);
  /*@ngInject*/

  function importXMLModalLauncher($uibModal, $rootScope, $window, cartsResource, toaster) {
    /**
     * @name mapDlvMode
     * @description
     * Maps delivery mode fetched from XML to internal format
     * @return string
     */
    var mapDlvMode = function mapDlvMode(modeFromXml, codAmount) {
      switch (modeFromXml) {
        case 'WL':
          return 'pickup';

        case 'PRZEW':
          if (parseFloat(codAmount) > 0) {
            return 'courier_cod';
          }

          return 'courier';

        default:
          return '';
      }
    };
    /**
     * @name parseCartJsonToBackendFormat
     * @description
     * Parses imported JSON to backend format.
     * @return object
     */


    var parseCartJsonToBackendFormat = function parseCartJsonToBackendFormat(plain) {
      var header = plain["Stalgast-Order"]["Order-Header"];
      var contact = plain["Stalgast-Order"]["Order-Parties"].Contact;
      var delivery = plain["Stalgast-Order"]["Order-Parties"].DeliveryPoint;

      var getVal = function getVal(sectionName, prop) {
        var section = null,
            sectionNameXml = '';

        switch (sectionName) {
          case 'header':
            section = header;
            sectionNameXml = 'Order-Header';
            break;

          case 'contact':
            section = contact;
            sectionNameXml = 'Order-Parties.Contact';
            break;

          case 'delivery':
            section = delivery;
            sectionNameXml = 'Order-Parties.DeliveryPoint';
            break;
        }

        if (!section) {
          throw {
            entry: 'Stalgast-Order.' + sectionNameXml
          };
        } else if (!section[prop]) {
          if (prop == 'CashOnDelivery') {
            return 0;
          } else {
            throw {
              entry: 'Stalgast-Order.' + sectionNameXml + '.' + prop
            };
          }
        }

        return section[prop].value;
      };

      try {
        var phone = getVal('contact', 'Phone').replace(/\s/g, '');
        var re = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{3})$/;

        if (!re.test(phone)) {
          throw new Error('Numer telefonu jest nieprawidłowy, przykładowe poprawne numery: 123456789, 123-456-789');
        }

        var parsed = {
          "name": getVal('header', 'BasketName'),
          "fullname": getVal('contact', 'FirstName') + " " + getVal('contact', 'LastName'),
          "label": getVal('delivery', 'NameAlias'),
          "company": getVal('delivery', 'Name'),
          "street": getVal('delivery', 'Street'),
          "building": getVal('delivery', 'BuildNum'),
          "city": getVal('delivery', 'CityName'),
          "postcode": getVal('delivery', 'PostalCode'),
          "telephone": phone,
          "sg_reference": getVal('header', 'Remarks'),
          "sg_delivery_method": mapDlvMode(getVal('header', 'DlvMode'), getVal('header', 'CashOnDelivery')),
          "sg_service_request": getVal('header', 'CustomerRef'),
          "sg_cod_amount": getVal('header', 'CashOnDelivery')
        };
      } catch (entryInObject) {
        toaster.error('CART.XMLMODAL.NO_ENTRY', entryInObject);
        throw entryInObject;
      }

      return parsed;
    };
    /**
     * @name parseItemsJsonToBackendFormat
     * @description
     * Parses imported JSON to backend format.
     * @return array
     */


    var parseItemsJsonToBackendFormat = function parseItemsJsonToBackendFormat(plain) {
      var lines = plain["Stalgast-Order"]["Order-Lines"].Line; // lines can be single object or array of objects; let's unify it

      var linesArr = Array.isArray(lines) ? lines : [lines];
      var parsed = linesArr.map(function (line) {
        return {
          sku: line.ItemCode.value,
          qty: Number(line.Quantity.value)
        };
      });
      return parsed;
    };
    /**
     * @name parseMetaJsonToBackendFormat
     * @description
     * Parses imported JSON to backend format.
     * @return object
     */


    var parseSummaryJsonToBackendFormat = function parseSummaryJsonToBackendFormat(plain) {
      var summary = plain["Stalgast-Order"]["Order-Summary"];
      return {
        totalLines: Number(summary.TotalLines.value),
        totalQuantity: Number(summary.TotalQuantity.value)
      };
    };
    /**
     * @name show
     * @description
     * Show the modal importer.
     * @return {Promise}
     */


    var show = function show(block) {
      var scope = $rootScope.$new(true);
      scope.file = {
        loaded: false
      };
      scope.itemsFailed = '';
      scope.error = '';
      scope.loading = false;
      scope.uniqid = null;
      /**
       * Create modal instance
       */

      scope.modalInstance = $uibModal.open({
        size: 'md',
        windowClass: 'center-modal-child',
        //Template to encapsulate the component
        template: '<div class="modal-body xml-modal" >' + '<h3 translate>CART.XMLMODAL.TITLE</h3>' + '<p translate>CART.XMLMODAL.CONTENT</p>' + '<div ng-if="$parent.itemsFailed">' + '<div uib-alert type="danger">' + '<span>{{ "CART.XMLMODAL.INVALID_MSG" | translate }}: {{ itemsFailed }}</span>' + '</div>' + '<div class="import-actions"><button class="btn btn-primary" ng-click="closeModalAndRedirect()" translate>' + 'CART.XMLMODAL.CONTINUE' + '</button></div>' + '</div>' + '<div ng-if="$parent.error">' + '<div uib-alert type="danger">' + '<span translate>CART.XMLMODAL.FAIL_MSG</span>' + '</div>' + '<div uib-alert type="danger">' + '<span>{{ "CART.XMLMODAL.ERROR_MSG" | translate }}: {{ error }}</span>' + '</div>' + '</div>' + '<div ng-show="!$parent.itemsFailed && !$parent.loading">' + '<ng-orba-xml-import callback="loadFile" result="$parent.result"></ng-orba-xml-import>' + '<div class="import-actions"><button class="btn btn-primary" ng-click="importFile()" translate>CART.XMLMODAL.IMPORT</button></div>' + '</div>' + '<div ng-if="$parent.loading" translate>CART.XMLMODAL.WORKING</div>' + '<div class="close-button">' + '<button type="button" class="close" ng-click="$dismiss()" ng-attr-title="{{\'GLOBAL.CLOSE\'|translate}}" ng-attr-aria-label="{{\'GLOBAL.CLOSE\'|translate}}">' + '</button>' + '</div>' + '</div>',
        scope: scope
      });

      scope.closeModalAndRedirect = function () {
        scope.modalInstance.dismiss();
        $window.location.href = "/cart/update/" + scope.uniqid;
      };

      scope.loadFile = function () {
        scope.file.loaded = true;
      };

      scope.handleError = function (err) {
        scope.loading = false;
        toaster.error('CART.XMLMODAL.FAIL_MSG');

        if (err) {
          scope.error = err.data ? err.data : err.message ? err.message : err.entry ? err.entry : err;
        }
      };

      scope.importFile = function () {
        scope.error = '';

        if (!scope.file.loaded) {
          toaster.error('CART.XMLMODAL.NO_FILE');
          scope.modalInstance.dismiss();
          return false;
        }

        scope.loading = true;
        var items, summary; // Parse items & summary & validate meta

        try {
          items = parseItemsJsonToBackendFormat(scope.result);
          summary = parseSummaryJsonToBackendFormat(scope.result);
        } catch (err) {
          scope.handleError(err);
          return;
        }

        var totalQuantity = items.reduce(function (acc, curr) {
          acc += curr.qty;
          return acc;
        }, 0);

        if (summary.totalLines != items.length || summary.totalQuantity != totalQuantity) {
          toaster.error('CART.XMLMODAL.INVALID_SUMMARY');
          scope.modalInstance.dismiss();
          return false;
        }

        try {
          // Create cart
          var parsedJson = parseCartJsonToBackendFormat(scope.result);
        } catch (err) {
          scope.handleError(err);
          return;
        }

        cartsResource.createFromJson(parsedJson).then(function (resp) {
          // Create cart items
          var cart = resp;
          var payload = {
            cart_id: cart.uniqid,
            append: true,
            items: items
          };
          scope.uniqid = cart.uniqid;
          cartsResource.createItemsFromJson(payload).then(function (resp) {
            var data = resp.data;
            toaster.success('CART.CSVMODAL.CONFIRM_MSG');
            scope.loading = false;

            if (data && data.cart && data.cart.items_omitted && data.cart.items_omitted.length) {}

            if (data && data.cart && data.cart.items_failed && data.cart.items_failed.length || data && data.cart && data.cart.items_omitted && data.cart.items_omitted.length) {
              scope.itemsFailed = data.cart.items_failed.join(', ');
              scope.itemsFailed += scope.itemsFailed.length === 0 ? data.cart.items_omitted.join(', ') : ", " + data.cart.items_omitted.join(', ');
            } else {
              scope.closeModalAndRedirect();
            }
          }, function (err) {
            scope.handleError(err);
            return false;
          });
        })["catch"](function (err) {
          scope.handleError(err);
          return false;
        });
      };
    };

    return {
      show: show
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name importCSVModalLauncher
   * @module app
   * @description
   * Service to show a modal window for import items from csv
   */

  importCSVModalLauncher.$inject = ["$uibModal", "$rootScope", "cartActive", "toaster"];
  module.service('importCSVModalLauncher', importCSVModalLauncher);
  /*@ngInject*/

  function importCSVModalLauncher($uibModal, $rootScope, cartActive, toaster) {
    /**
     * @name show
     * @description
     * Show the modal importer.
     * @return {Promise}
     */
    var show = function show(block) {
      var scope = $rootScope.$new(true);
      var qtyField = 'Ilość (szt)';
      var skuField = 'Kod katalogowy';
      scope.file = {
        loaded: false
      };
      /**
       * Create modal instance
       */

      scope.modalInstance = $uibModal.open({
        size: 'md',
        windowClass: 'center-modal-child',
        //Template to encapsulate the component
        template: '<div class="modal-body csv-modal" >' + '<h3>' + block.title + '</h3>' + '<p>' + block.content + '</p>' + '<ng-orba-csv-import content="content" header="true" callback="loadFile" separator="\';\'" result="$parent.result" accept="\'.csv\'"></ng-orba-csv-import>' + '<div class="import-actions"><button class="btn btn-primary" ng-click="importFile()" translate>CART.CSVMODAL.IMPORT</button></div>' + '<div class="close-button">' + '<button type="button" class="close" ng-click="$dismiss()" ng-attr-title="{{\'GLOBAL.CLOSE\'|translate}}" ng-attr-aria-label="{{\'GLOBAL.CLOSE\'|translate}}">' + '</button>' + '</div>' + '</div>',
        scope: scope
      });
      /**
       * Function executed when file is uploaded
       */

      scope.loadFile = function () {
        scope.file.loaded = true;
      };
      /**
       * Import file data to cart
       */


      scope.importFile = function () {
        if (!scope.file.loaded) {
          toaster.error('CART.CSVMODAL.NO_FILE');
          return false;
        }

        var items = [];
        angular.forEach(scope.result, function (item) {
          if (item.hasOwnProperty(0) && item.hasOwnProperty(1) && item[0] !== '') {
            items.push({
              sku: item[0],
              qty: parseInt(item[1], 10) || 1
            });
          }
        });
        var loading = cartActive.addProducts(items).then(function (response) {
          if (response.hasOwnProperty('items_failed') && response.items_failed.length > 0) {
            toaster.warning('CART.CSVMODAL.PARTIAL_CONFIRM_MSG');
          } else {
            toaster.success('CART.CSVMODAL.CONFIRM_MSG');
          }
        }, function () {
          toaster.error('CART.CSVMODAL.FAIL_MSG');
        });
        scope.modalInstance.dismiss();
        $rootScope.$emit('cartImport', loading);
      };
    };

    return {
      show: show
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name cartActive
   * @description
   * Store and manage the current active cart.
   * In any given moment a specific cart can be marked as active so all widgets to add or remove products to the
   * active cart will use this service to do it.
   * @author daniel.zegarra@orba.co
   */

  /*@ngInject*/

  module.provider('cartActive', function cartActiveProvider() {
    var provider = this,
        currentCart = null;
    /**
     * Remember the last cart selected even if the user restart the application.
     * @type {boolean}
     */

    provider.rememberSelection = false;
    /**
     * Here comes the magic.
     * @param {$rootScope} $rootScope
     * @param {$sessionStorage} $sessionStorage
     * @param {cartsResource} cartsResource
     */

    /*@ngInject*/

    provider.$get = function cartActive($rootScope, $sessionStorage, orbaSession, toaster, cartsResource) {
      var me = this;
      /**
       * Remember the last shopping cart selected after browser reload.
       */

      me.enableRemember = function () {
        provider.rememberSelection = true;
      };
      /**
       * Don't remember the last shopping cart selected after browser reload.
       */


      me.disableRemember = function () {
        provider.rememberSelection = false;
      };
      /**
       * Tries to load the cart stored in session data.
       */


      me.loadRememberedCart = function () {
        var cartStored = getRememberedCart(); //This will never work if there's no session active

        if (provider.rememberSelection && cartStored && orbaSession.getUserId() == cartStored.userId) {
          cartsResource.get({
            id: cartStored.cartId
          }, function (cartModel) {
            me.set(cartModel);
          }, function (response) {
            rememberCart(null);
            toaster.error(response.data);
          });
        }
      };
      /**
       * Check if there is a cart currently active.
       *
       * @return {boolean}
       */


      me.has = function () {
        return angular.isObject(currentCart);
      };
      /**
       * Returns the currently active cart or NULL is no cart is currently active.
       *
       * @return {object|null}
       */


      me.get = function () {
        return currentCart || null;
      };
      /**
       * Defines the current active cart.
       *
       * @param {object|null} [newCart=null] New cart model or null to de-activate the current activated cart
       * @returns {boolean} TRUE if the new cart has been activated or de-activated
       */


      me.set = function (newCart) {
        if (currentCart === newCart) {
          return false;
        }

        if (angular.isObject(currentCart) && angular.isObject(newCart) && newCart instanceof cartsResource) {
          if (currentCart.getId() === newCart.getId()) {
            /*
             * If the IDs are the same the current cart model is also replaced by the new model object but this
             * function returns FALSE because doesn't want to give the impression that the cart has been
             * change.
             * This replacement allows the cart to maintain the reference to the same model object when
             * the same object is been update by the cart editor component.
             */
            currentCart = newCart;

            if (provider.rememberSelection) {
              rememberCart(currentCart);
            }

            return false;
          }
        }

        currentCart = newCart || null;

        if (provider.rememberSelection) {
          rememberCart(currentCart);
        }

        return true;
      };
      /**
       * Add a new product to the current cart.
       *
       * @param {string} sku
       * @param {number} qty
       * @return {Promise}
       */


      me.addProduct = function (sku, qty) {
        return currentCart.$addItemOrIncreaseQty({
          sku: sku,
          qty: qty
        }).then(function () {
          currentCart.refreshAvailability();
        });
      };
      /**
       * Add multiple products to the current cart.
       *
       * @param {object} items
       * @return {Promise}
       */


      me.addProducts = function (items) {
        return currentCart.$addItemOrIncreaseMultiple(items).then(function (response) {
          currentCart.refreshAvailability();
          return response;
        });
      };
      /**
       * Returns stored shopping cart data.
       * @return {object|null} Returns NULL if there's no cart saved
       */


      function getRememberedCart() {
        if ($sessionStorage.cartActive && angular.isObject($sessionStorage.cartActive)) {
          return $sessionStorage.cartActive;
        }

        return null;
      }
      /**
       * Store the cart given to rememberSelection.
       * @param {cartsResource} cart
       */


      function rememberCart(cart) {
        var cartId = cart instanceof cartsResource ? cart.getId() : null;

        if (cartId) {
          $sessionStorage.cartActive = {
            userId: orbaSession.getUserId(),
            cartId: cartId
          };
        } else {
          delete $sessionStorage.cartActive;
        }
      } //Deactivate cart when user logout


      $rootScope.$on('onLogout', function () {
        me.set(null);
      }); //Deactivate the current cart if is the same as the cart which just has been converted in a order

      $rootScope.$on('onOrderPlaced', function (evt, data) {
        if (me.has() && data.cart instanceof cartsResource && me.get().getId() == data.cart.getId()) {
          me.set(null);
        }
      });
      return me;
    };

    provider.$get.$inject = ["$rootScope", "$sessionStorage", "orbaSession", "toaster", "cartsResource"];
  });
})(angular.module('app'));
"use strict";

(function (module, angular, Big) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:cartsResource
   * @description
   * This service use the backend API to manage carts and its items.
   *
   * The cart items actions were implemented here because all the cart items HTTP requests returns a complete snapshot
   * of the cart (an its items). Managing the items in the same service ensure the update of the complete cart
   * properties every time a item of the cart change.
   *
   * It use response transformations to rectify the data returned by the server.
   * Check the {@link https://docs.angularjs.org/api/ngResource/service/$resource $resource docs} for
   * more information.
   */

  cartsResource.$inject = ["$resource", "$http", "$q", "moment", "lodash", "cartConfig", "offerConfig", "collectionUtils", "resourceQueryPaginator", "websocket", "cartItemModel", "$filter"];
  module.factory('cartsResource', cartsResource);
  /*@ngInject*/

  function cartsResource($resource, $http, $q, moment, lodash, cartConfig, offerConfig, collectionUtils, resourceQueryPaginator, websocket, cartItemModel, $filter) {
    var resource,
        idField = 'uniqid',
        paginator = resourceQueryPaginator();
    var transformStack = {
      forMulti: appendTransform($http.defaults.transformResponse, transformForMulti),
      forSingle: appendTransform($http.defaults.transformResponse, transformForSingle)
    };
    /**
     * Returns an object with the type properties of the model corrected.
     * @param {object} srcItem
     * @returns {object} Returns an object with the properties types corrected
     */

    var formatItem = function formatItem(srcItem) {
      var item = angular.copy(srcItem);
      item.entity_id = parseInt(item.entity_id, 10);
      item.items_count = parseInt(item.items_count, 10);
      item.items_qty = parseInt(item.items_qty, 10) || 0;
      item.customer_id = parseInt(item.customer_id, 10);
      item.grand_total = parseFloat(item.grand_total);
      item.subtotal = parseFloat(item.subtotal);
      item.created_at = moment(item.created_at).toDate();
      item.updated_at = moment(item.updated_at).toDate();

      if (item.hasOwnProperty('items') && angular.isArray(item.items)) {
        item.items = item.items.map(function (subitem) {
          return new cartItemModel(subitem);
        });
      }

      return item;
    };
    /**
     * Utility function to a new transform function to the existing transform stack.
     * @param {function|function[]} defaults
     * @param {function} transformFn
     * @returns {function[]}
     */


    function appendTransform(defaults, transformFn) {
      defaults = angular.isArray(defaults) ? defaults : [defaults];
      return defaults.concat(transformFn);
    }
    /**
     * Transform the response of a single element.
     * @param {object} data
     * @returns {object}
     */


    function transformForSingle(data) {
      if (angular.isObject(data)) {
        return formatItem(data.cart || data);
      }

      return data;
    }
    /**
     * Transform the response of a array of several elements.
     * @param {object} data
     * @returns {object}
     */


    function transformForMulti(data) {
      if (angular.isObject(data)) {
        return (data.carts || data).map(formatItem);
      }

      return data;
    }
    /**
     * Update, stealthily, the properties and items of the cart.
     * This function should be called inside the execution context of the resource instance.
     * @param {object} response HTTP response with the entire cart data
     */


    function updateCart(response) {
      var updatedCart = response.data,
          oldCart = this; // We need to delete items_failed and items_added because angular.merge joins old and new values,
      // but in fact new values has to replace old

      delete oldCart.items_failed;
      delete oldCart.items_added; //We need to separate the updates

      var updatedHeader = lodash.omit(updatedCart, 'items'),
          updatedItems = lodash.pick(updatedCart, 'items'); //Updating header

      angular.merge(oldCart, updatedHeader); //Updating items

      if (!oldCart.hasOwnProperty('items') || !angular.isArray(oldCart.items)) {
        oldCart.items = [];
      }

      collectionUtils.updateCollection(updatedItems.items, oldCart.items, 'item_id', true);
      return oldCart;
    }
    /**
     * Resource for cart management.
     * Note: This instance will be returned by this service.
     */


    resource = $resource(cartConfig.restful.carts, {
      id: '@' + idField
    }, {
      //List of carts
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo(transformStack.forMulti)
      },
      //Cart creation (empty, without items)
      'save': {
        method: 'POST',
        isArray: false,
        transformResponse: transformStack.forSingle
      },
      //Cart update (just cart, no items)
      'update': {
        method: 'PUT',
        isArray: false,
        transformResponse: transformStack.forSingle
      },
      //Obtain cart (with items)
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: transformStack.forSingle
      }
    }); //Applying the pagination support to the "query" method

    paginator.applyToResource(resource, 'query');
    /**
     * @ngdoc method
     * @name createFromOffer
     * @description
     * Order the backend to create a new cart based on a specific offer.
     * @param {number} offerId ID of the offer
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */

    resource.createFromOffer = function (offer, success, failure) {
      var url = offerConfig.restful.offers.replace('/:id', '/toCart'),
          payload = {
        offerId: offer.id
      };

      if (typeof offer.newName !== 'undefined') {
        payload.name = offer.newName;
      }

      return $http.post(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(function (response) {
        return new resource(response.data);
      }).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name createFromJson
     * @description
     * Create new cart from JSON.
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.createFromJson = function (payload, success, failure) {
      var url = cartConfig.restful.carts.replace('/:id', '');
      return $http.post(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(function (response) {
        return new resource(response.data);
      }).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name createItemsFromJson
     * @description
     * Create new cart items from JSON.
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.createItemsFromJson = function (payload, success, failure) {
      var me = this,
          url = cartConfig.restful.cartItems.replace('/:id', '');
      return $http.post(url, payload).then(success, failure);
    };
    /*
     * ADDING ACTIONS FOR MANAGE CART ITEMS
     */

    /**
     * @ngdoc method
     * @name $addItem
     * @methodOf app.service:cartsResource
     * @description
     * The properties of the cart are updated automatically if the backend respond for this call is successful
     * @param {object} item
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.prototype.$addItem = function (item, success, failure) {
      var me = this,
          url = cartConfig.restful.cartItems.replace('/:id', ''),
          payload = {
        cart_id: me[idField],
        items: {}
      };
      payload.items = [{
        sku: item.sku,
        qty: item.qty
      }];
      return $http.post(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateCart)).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name $addItemOrIncreaseQty
     * @methodOf app.service:cartsResource
     * @description
     * The properties of the cart are updated automatically if the backend respond for this call is successful
     * @param {object} item
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.prototype.$addItemOrIncreaseQty = function (item, success, failure) {
      var me = this,
          url = cartConfig.restful.cartItems.replace('/:id', ''),
          payload = {
        cart_id: me[idField],
        append: true,
        items: {}
      };
      payload.items = [{
        sku: item.sku,
        qty: item.qty
      }];
      return $http.post(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateCart)).then(success, failure);
    };
    /**
     * FIXME: comment
     * @param item
     * @param success
     * @param failure
     * @return {*}
     */


    resource.prototype.$addItemOrIncreaseMultiple = function (items, success, failure) {
      var me = this,
          url = cartConfig.restful.cartItems.replace('/:id', ''),
          payload = {
        cart_id: me[idField],
        append: true,
        items: items
      };
      return $http.post(url, payload, {
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateCart)).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name $updateItem
     * @methodOf app.service:cartsResource
     * @description
     * The properties of the cart are updated automatically if the backend respond for this call is successful
     * @param {object} item
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.prototype.$updateItem = function (item, success, failure) {
      var me = this,
          url = cartConfig.restful.cartItems.replace(':id', me[idField]);
      return $http.put(url, item, {
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateCart)).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name $removeItem
     * @methodOf app.service:cartsResource
     * @description
     * The properties of the cart are updated automatically if the backend respond for this call is successful
     * @param {object|object[]} item_or_items
     * @param {function} [success]
     * @param {function} [failure]
     * @returns {Promise} Future object
     */


    resource.prototype.$removeItem = function (item_or_items, success, failure) {
      var me = this,
          items = !angular.isArray(item_or_items) ? [item_or_items] : item_or_items,
          url = cartConfig.restful.cartItems.replace(':id', me[idField]);
      var payload = {
        sku: items.map(function (item) {
          return item.sku;
        })
      };
      return $http["delete"](url, {
        data: payload,
        transformResponse: transformStack.forSingle
      }).then(angular.bind(me, updateCart)).then(success, failure);
    };
    /**
     * @ngdoc method
     * @name isPhantom
     * @methodOf app.service:cartsResource
     * @description
     * Returns TRUE if the element doesn't have an ID yet.
     * @returns {boolean}
     */


    resource.prototype.isPhantom = function () {
      return !this.hasOwnProperty(idField);
    };
    /**
     * Check if the current cart can be converted into an offer.
     * @return {boolean}
     */


    resource.prototype.canConvertToOffer = function () {
      if (this && !this.isPhantom()) {
        if (angular.isArray(this.items) && this.items.length > 0) {
          return true;
        }
      }

      return false;
    };
    /**
     * Send api request to update stocks
     * @return {boolean}
     */


    resource.prototype.requestUpdateStocks = function () {
      var me = this;
      $resource(cartConfig.restful.stocks, {
        id: '@id'
      }).save({
        id: me[idField]
      });
      return $q(function (resolve, reject) {
        websocket.emit('cart.listenForUpdates', {
          cartId: me[idField]
        });
        websocket.once('cart.updated', function (cartId) {
          resolve(cartId);
        });
      });
    };
    /**
     * Obtain the availability status of a bunch of products and quantities (cart items).
     * @param {object[]} cartItems
     * @returns {$q}
     */


    resource.getAvailability = function (cartItems) {
      return $q(function (resolve, reject) {
        websocket.emit('cart.getAvailabilityOfItems', cartItems, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Obtain and update the availability status of the current cart's items.
     * @returns {$q} Promise returning the same current model instance
     */


    resource.prototype.refreshAvailability = function () {
      console.log('refreshAvailability');
      console.log(this);
      var model = this,
          items = (model.items || []).map(function (item) {
        return {
          sku: item.sku,
          qty: item.qty
        };
      });
      console.log(items);
      console.log(items.length);

      if (items.length) {
        return resource.getAvailability(items).then(function (availabilityReport) {
          var report = availabilityReport.map(function (item) {
            console.log(item);
            return {
              sku: item.sku,
              available: item.available,
              qtyIncrements: item.qtyIncrements,
              stock: item.stock,
              warehouse: item.warehouse,
              related: item.related,
              dlvDate: item.dlvDate
            };
          });
          collectionUtils.updateCollection(report, model.items, 'sku', true);
          return model;
        });
      } else {
        return $q.resolve(model);
      }
    };
    /**
     * Returns the ID of the current model.
     * @return {number}
     */


    resource.prototype.getId = function () {
      return this[idField];
    };
    /**
     * Returns the net amount of the all available products.
     * @return {number}
     */


    resource.prototype.calAvailableNetAmount = function () {
      var sum = lodash.reduce(this.items, function (prevValue, item) {
        return prevValue.plus(item.calAvailableNetAmount());
      }, new Big(0));
      return parseFloat(sum.toFixed(2));
    };
    /**
     * Returns the gross amount of the all available products.
     * @return {number}
     */


    resource.prototype.calAvailableGrossAmount = function () {
      var sum = lodash.reduce(this.items, function (prevValue, item) {
        return prevValue.plus(item.calAvailableGrossAmount());
      }, new Big(0));
      return parseFloat(sum.toFixed(2));
    };
    /**
     * Format currency according to current locale.
     *
     * @param {float} value
     * @returns {string}
     */


    resource.prototype.formatCurrency = function (value) {
      return $filter('currency')(value);
    };

    return resource;
  }
})(angular.module('app'), angular, Big);
"use strict";

(function (module) {
  'use strict';

  module.factory('cartItemModel', ["moment", "lodash", "cartConfig", function (moment, lodash, cartConfig) {
    return function (initialData) {
      var me = this,

      /**
       * Decimal precision to use when calculate the net and gross amounts of available products.
       * @type {number}
       */
      amountsPrecision = cartConfig.decimalPrecision || 4;

      if (initialData) {
        var promotion_price;

        if (initialData.promotion_price === undefined || initialData.promotion_price === true || typeof initialData.promotion_price === "boolean" || initialData.promotion_price === null) {
          promotion_price = 0;
        } else {
          promotion_price = initialData.promotion_price;
        }

        initialData.cart_id = parseInt(initialData.cart_id, 10);
        initialData.item_id = parseInt(initialData.item_id, 10);
        initialData.qty = parseInt(initialData.qty, 10);
        initialData.price = parseFloat(initialData.price);
        initialData.discount = parseFloat(initialData.discount);
        initialData.promotion_price = parseFloat(promotion_price);
        initialData.reseller_price = parseFloat(initialData.reseller_price);
        initialData.row_total_excl_tax = parseFloat(initialData.row_total_excl_tax);
        initialData.row_total_incl_tax = parseFloat(initialData.row_total_incl_tax);
        initialData.product_id = parseInt(initialData.product_id, 10);
        initialData.created_at = moment(initialData.created_at).toDate();
        initialData.updated_at = moment(initialData.updated_at).toDate();
        Object.assign(me, initialData);
      }
      /**
       * Calculate and returns the gross amount of one product.
       * @returns {number}
       */


      me.calUnitGrossAmount = function () {
        if (me.itemExists() && me.qty >= 0) {
          return parseFloat(new Big(me.row_total_incl_tax || 0).div(me.qty).toFixed(amountsPrecision));
        }

        return 0;
      };
      /**
       * Calculate and returns the net amount of the quantity of available units.
       * @returns {number}
       */


      me.calAvailableNetAmount = function () {
        var unitAmount = me.reseller_price;
        var stockVisible = me.calculateVisibleStock();
        console.log('calAvailableGrossAmount');
        console.log(unitAmount);
        console.log(stockVisible);

        if (stockVisible && stockVisible > 0) {
          return parseFloat(new Big(unitAmount).times(stockVisible).toFixed(amountsPrecision));
        }

        return 0;
      };
      /**
       * Calculate and returns the gross amount of the quantity of available units.
       * @returns {number}
       */


      me.calAvailableGrossAmount = function () {
        var unitAmount = me.calUnitGrossAmount();
        var stockVisible = me.calculateVisibleStock();
        console.log('calAvailableNetAmount');
        console.log(unitAmount);
        console.log(stockVisible);

        if (stockVisible && stockVisible > 0) {
          return parseFloat(new Big(unitAmount).times(stockVisible).toFixed(amountsPrecision));
        }

        return 0;
      };
      /**
       * Return the stock quantity that should be visible to the user.
       * @returns {number|null} It will return NULL if there's no enough data to calculate a value
       */


      me.calculateVisibleStock = function () {
        var qty = parseInt(me.qty, 10);

        if (isNaN(qty)) {
          qty = 0;
        }

        if (me.hasOwnProperty('sku') && me.hasOwnProperty('stock')) {
          return lodash.min([qty, me.stock]);
        }

        return 0;
      };
      /**
       * Ask if the item belong to the cart (has already an ID).
       * @returns {boolean}
       */


      me.itemExists = function () {
        return me.hasOwnProperty('item_id') && me.item_id > 0;
      };
      /**
       * Ask if the current item is in sale.
       * @returns {boolean}
       */


      me.itemIsInSale = function () {
        if (angular.isNumber(me.promotion_price) && me.promotion_price > 0) {
          return me.promotion_price !== me.price;
        }

        return false;
      }; //Never copy this functions to another object. This functions are just mine!


      Object.defineProperties(me, {
        "calAvailableNetAmount": {
          enumerable: false
        },
        "calUnitGrossAmount": {
          enumerable: false
        },
        "calAvailableGrossAmount": {
          enumerable: false
        },
        "calculateVisibleStock": {
          enumerable: false
        },
        "itemExists": {
          enumerable: false
        },
        "itemIsInSale": {
          enumerable: false
        }
      });
    };
  }]);
})(angular.module('app'));
'use strict';

var xmlImport = angular.module('ngOrbaXmlImport', ['xml2js']);
xmlImport.directive('ngOrbaXmlImport', ['$filter', function ($filter) {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope: {
      callback: '=?',
      result: '=?'
    },
    template: '<div>' + '<div><div class="label">Header</div><input type="checkbox" ng-model="header"></div>' + '<div><input ng-model="scope.result" class="btn cta gray" type="file" accept=".xml"/></div>' + '</div>',
    link: function link(scope, element) {
      var xmlToJSON = function xmlToJSON(textXml) {
        var xml = $filter('text2xml')(textXml),
            json = $filter('xml2js')(xml);
        return json;
      };

      element.on('change', function (onChangeEvent) {
        if (!onChangeEvent.target.files.length) {
          return;
        }

        var reader = new FileReader();

        reader.onload = function (onLoadEvent) {
          scope.result = xmlToJSON(onLoadEvent.target.result);
          scope.$apply();

          if (typeof scope.callback === 'function') {
            scope.callback();
          }
        };

        reader.readAsText(onChangeEvent.target.files[0]);
      });
    }
  };
}]);
'use strict';

var csvImport = angular.module('ngOrbaCsvImport', []);
csvImport.directive('ngOrbaCsvImport', function () {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    scope: {
      content: '=?',
      header: '=?',
      headerVisible: '=?',
      separator: '=?',
      separatorVisible: '=?',
      result: '=?',
      encoding: '=?',
      encodingVisible: '=?',
      accept: '=?',
      acceptSize: '=?',
      acceptSizeExceedCallback: '=?',
      callback: '=?'
    },
    template: '<div>' + '<div ng-show="headerVisible"><div class="label">Header</div><input type="checkbox" ng-model="header"></div>' + '<div ng-show="encoding && encodingVisible"><div class="label">Encoding</div><span>{{encoding}}</span></div>' + '<div ng-show="separator && separatorVisible">' + '<div class="label">Seperator</div>' + '<span><input class="separator-input" type="text" ng-change="changeSeparator" ng-model="separator"><span>' + '</div>' + '<div><input class="btn cta gray" type="file" multiple accept="{{accept}}"/></div>' + '</div>',
    link: function link(scope, element) {
      scope.separatorVisible = scope.separatorVisible || false;
      scope.headerVisible = scope.headerVisible || false;
      scope.acceptSize = scope.acceptSize || Number.POSITIVE_INFINITY;
      angular.element(element[0].querySelector('.separator-input')).on('keyup', function (e) {
        if (scope.content != null) {
          var content = {
            csv: scope.content,
            header: scope.header,
            separator: e.target.value,
            encoding: scope.encoding
          };
          scope.result = csvToJSON(content);
          scope.$apply();

          if (typeof scope.callback === 'function') {
            scope.callback(e);
          }
        }
      });
      element.on('change', function (onChangeEvent) {
        if (!onChangeEvent.target.files.length) {
          return;
        }

        if (onChangeEvent.target.files[0].size > scope.acceptSize) {
          if (typeof scope.acceptSizeExceedCallback === 'function') {
            scope.acceptSizeExceedCallback(onChangeEvent.target.files[0]);
          }

          return;
        }

        scope.filename = onChangeEvent.target.files[0].name;
        var reader = new FileReader();

        reader.onload = function (onLoadEvent) {
          scope.$apply(function () {
            var content = {
              csv: onLoadEvent.target.result.replace(/\r\n|\r/g, '\n'),
              header: scope.header,
              separator: scope.separator
            };
            scope.content = content.csv;
            scope.result = csvToJSON(content);
            scope.result.filename = scope.filename;
            scope.$$postDigest(function () {
              if (typeof scope.callback === 'function') {
                scope.callback(onChangeEvent);
              }
            });
          });
        };

        if (onChangeEvent.target.type === "file" && (onChangeEvent.target.files != null || onChangeEvent.srcElement.files != null)) {
          reader.readAsText((onChangeEvent.srcElement || onChangeEvent.target).files[0], scope.encoding);
        } else {
          if (scope.content != null) {
            var content = {
              csv: scope.content,
              header: !scope.header,
              separator: scope.separator
            };
            scope.result = csvToJSON(content);
            scope.$$postDigest(function () {
              if (typeof scope.callback === 'function') {
                scope.callback(onChangeEvent);
              }
            });
          }
        }
      });

      var csvToJSON = function csvToJSON(content) {
        var lines = content.csv.split(new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));
        var result = [];
        var start = 0;
        var columnCount = lines[0].split(content.separator).length;
        var headers = [];

        if (content.header) {
          headers = lines[0].split(content.separator);
          headers = headers.map(function (item) {
            return cleanCsvValue(item);
          });
          start = 1;
        }

        for (var i = start; i < lines.length; i++) {
          var obj = {};
          var currentline = lines[i].split(new RegExp(content.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)'));

          if (currentline.length === columnCount) {
            for (var k = 0; k < currentline.length; k++) {
              obj[k] = cleanCsvValue(currentline[k]);
            }

            result.push(obj);
          }
        }

        return result;
      };

      var cleanCsvValue = function cleanCsvValue(value) {
        return value.replace(/^\s*|\s*$/g, "") // remove leading & trailing space
        .replace(/^"|"$/g, "") // remove " on the beginning and end
        .replace(/""/g, '"'); // replace "" with "
      };
    }
  };
});
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('cartListCtrl', ["$translate", "$scope", "$state", "cartsResource", "sessionAccess", "cartConfig", "paginationManager", "lodash", "cartActive", "importXMLModalLauncher", function cartListCtrl($translate, $scope, $state, cartsResource, sessionAccess, cartConfig, paginationManager, lodash, cartActive, importXMLModalLauncher) {
    var vm = this;
    $scope.filters = {};
    vm.waitMsg = $translate.instant('GLOBAL.LOADING_DATA');
    vm.errorMsg = '';
    vm.createCart = createCart;
    vm.openImportModal = openImportModal;
    vm.openCart = openCart;
    vm.deleteCart = deleteCart;
    vm.updateResults = updateResults;
    init();
    /**
     * Initialize the controller.
     */

    function init() {
      //Obtaining the list of offers
      $scope.paginator = paginationManager($scope, 'cart', cartsResource.query, clearErrorMsg, showErrorMsg);
      $scope.paginator.limit = $scope.paginator.limit ? $scope.paginator.limit : cartConfig.list.pageSize;
      $scope.paginator.page = 1;
      $scope.paginator.autoRefresh(true); //Sharing the access permissions with the template

      vm.access = sessionAccess.areActionsAllowed(['carts.add']);
    }
    /**
     * This function is called by the table's directive with parameters to refresh the results.
     * @param {object} tableState
     */


    function updateResults(tableState) {
      var filters = {}; //Pagination

      var pagination = tableState.pagination;
      $scope.paginator.page = pagination.start / $scope.paginator.limit + 1; //Filters

      if (tableState.search.predicateObject) {
        filters = lodash.mapValues(tableState.search.predicateObject, function (value, key) {
          return $scope.filters.hasOwnProperty(key) ? $scope.filters[key] : value;
        });
        filters = lodash.mapKeys(filters, function (value, key) {
          return 'filter[' + key + ']';
        });

        if (filters['filter[created_at]']) {
          filters['filter[created_at][from]'] = filters['filter[created_at][to]'] = filters['filter[created_at]'];
          delete filters['filter[created_at]'];
        }

        if (filters['filter[updated_at]']) {
          filters['filter[updated_at][from]'] = filters['filter[updated_at][to]'] = filters['filter[updated_at]'];
          delete filters['filter[updated_at]'];
        }
      }

      $scope.paginator.filters = filters; //Refreshing results

      $scope.paginator.refresh().then(function () {
        //Update the total count of elements
        pagination.numberOfPages = $scope.paginator.pages;
      });
    }
    /**
     * Clear the error message.
     */


    function clearErrorMsg() {
      vm.errorMsg = '';
    }
    /**
     * Show an error.
     * @param {string} [err='GLOBAL.LIST_NOT_AVAILABLE']
     */


    function showErrorMsg(err) {
      vm.errorMsg = err || 'GLOBAL.LIST_NOT_AVAILABLE';
    }
    /**
     * Move to the router state for create a new cart.
     */


    function createCart() {
      $state.go('cart.new');
    }
    /**
     * Active the cart given and show its content to the user.
     * @param {object} cartModel
     */


    function openCart(cartModel) {
      $state.go('cart.update', {
        id: cartModel.uniqid
      });
    }
    /**
     * Import cart from XML
     */


    function openImportModal() {
      //TODO Valid title/content + i18n
      importXMLModalLauncher.show({
        title: "Import XML",
        content: ""
      });
    }
    /**
     * Order the backend to delete the given cart.
     * @param {object} cartModel
     */


    function deleteCart(cartModel) {
      var removedCartId = cartModel.getId();
      cartModel.$remove(function () {
        $scope.paginator.refresh();

        if (cartActive.get() && cartActive.get().getId() === removedCartId) {
          cartActive.set(null);
        }
      });
    }
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for update a new cart.
 */
(function (module) {
  'use strict';

  cartUpdateCtrl.$inject = ["$state", "$stateParams", "$translate", "toaster", "currentOrder", "cartsResource", "offersResource", "cartActive", "sessionAccess", "convertToModal", "$rootScope"];
  module.controller('cartEditorCtrl', cartUpdateCtrl);
  /*@ngInject*/

  function cartUpdateCtrl($state, $stateParams, $translate, toaster, currentOrder, cartsResource, offersResource, cartActive, sessionAccess, convertToModal, $rootScope) {
    var vm = this;
    /**
     * Listen for cart import action
     */

    $rootScope.$on('cartImport', function (a, loading) {
      vm["import"] = loading;
    });

    if ($stateParams.hasOwnProperty('id')) {
      vm.model = cartsResource.get({
        id: $stateParams.id
      });
      vm.model.$promise["catch"](function () {
        toaster.error('CART.CART_NOT_AVAILABLE');

        if (cartActive.get() && cartActive.get().getId() === $stateParams.id) {
          cartActive.set(null);
        }

        vm.goBack();
      });
    } else {
      vm.model = new cartsResource();
    } //ACCESS KEYS


    vm.access = sessionAccess.areActionsAllowed(['carts.edit', 'quote.add', 'cartItems.add', 'cartItems.edit', 'cartItems.delete']);
    /**
     * Returns to the list.
     */

    vm.goBack = function () {
      $state.go('cart.list');
    };
    /**
     * Mark the given cart as active.
     * @param {object} cartModel
     */


    vm.activateCart = function (cartModel) {
      if (cartActive.set(cartModel)) {
        toaster.info('CART.ACTIVATION_NOTIF', {
          name: cartModel.name
        });
      }
    };
    /**
     * Redirect the user to the first step of creating a order process passing it the entire quote data.
     * @param {object} quote
     */


    vm.startOrderProcess = function (quote) {
      currentOrder.saveCart(vm.model);
      currentOrder.saveQuoteItems(quote.quote.items);
      currentOrder.setQuoteAndCatalogs(quote);
      $state.go('order.step1', {
        cartId: vm.model.uniqid
      });
    };
    /**
     * When a new cart is created this function update the current router state to the "Update cart" mode without
     * really exit the "Create cart" mode.
     * @param {object} cartModel
     */


    vm.changeToUpdateMode = function (cartModel) {
      $state.go('cart.update', {
        id: cartModel.uniqid
      }, {
        notify: false
      });
    };
    /**
     * Request the conversion of the current cart to an offer.
     */


    vm.convertToOffer = function () {
      if (vm.model.canConvertToOffer()) {
        convertToModal.show(vm.model.name, false, 'CART').then(function (data) {
          offersResource.createFromCart({
            id: vm.model.uniqid,
            newName: data.name
          }).then(function (offerModel) {
            if (offerModel.hasOwnProperty('items_failed') && offerModel.items_failed.length > 0) {
              convertToModal.failedItems = offerModel.items_failed;
              toaster.warning('CART.PARTIALLY_CONVERTED_TO_OFFER');
            }

            if (data.remove === true) {
              vm.model.$remove();
            }

            vm.openOffer(offerModel);
          }, toaster.error);
        });
      }
    };
    /**
     * Open de offer editor with the offer given.
     * @param {object} offerModel
     */


    vm.openOffer = function (offerModel) {
      $state.go('offer.update', {
        id: offerModel.uniqid
      });
    };
    /**
     * Returns a hint to show when the user cannot convert the the current cart into a offer.
     * @return {string}
     */


    vm.getConvertToOfferHint = function () {
      return vm.model && vm.model.canConvertToOffer() ? '' : $translate.instant('CART.CANT_BE_CONVERTED_TO_OFFER');
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgCartSummary
   * @description
   * Summary of the shopping cart.
   */

  module.component('sgCartSummary', {
    templateUrl: 'app/cart/components/cartSummary.html',
    controllerAs: 'vm',
    bindings: {
      /**
       * Cart model.
       */
      model: '<',
      quote: '<'
    }
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgCartEditor
   * @description
   * This component show a complete editor of a cart.
   *
   * It has 2 modes:
   *  - CREATE: If is instantiated without specify a cart ID it create a empty cart model and disable all the options
   *  until the cart were created.
   *  - UPDATE: If a cart ID or model object is specify then this component load or use the model given as reference.
   */

  sgCartItems2Controller.$inject = ["$q", "toaster", "ordersResource", "$state", "cartActive", "gtmDataLayer"];
  module.component('sgCartItems2', {
    templateUrl: 'app/cart/components/cartItems2.html',
    controller: sgCartItems2Controller,
    controllerAs: 'vm',
    bindings: {
      /**
       * @name model
       * @type {cartsResource} model
       */
      model: '=',
      updateStocks: '&',
      editable: '<',
      allowCreateQuote: '<',
      allowAddItems: '<',
      allowEditItems: '<',
      allowRemoveItems: '<',
      onLoad: '&?',
      onCreate: '&?',
      onUpdate: '&?',
      onQuoteCreated: '&?'
    }
  });
  /*@ngInject*/

  function sgCartItems2Controller($q, toaster, ordersResource, $state, cartActive, gtmDataLayer) {
    var vm = this;
    /**
     * Variable used to show loading while adding/removing products in cart
     */

    vm.promiseCartChanged = $q.resolve(0); //automatically resolved promises

    /**
     * Variable which contain the fatal error message received.
     * @fieldOf app.directive:sgCartEditor
     * @type {string}
     */

    vm.fatalErrorMsg = '';
    /**
     * Buffor for promises
     */

    vm.itemsWaiting = [];
    vm.maxOmittedSkus = 20;
    /**
     * Update stocks in cart
     */

    vm.updateStocks = function () {
      return vm.model.requestUpdateStocks().then(function () {
        toaster.success('CART.STOCKS_UPDATED');
        return vm.refreshItemsAvailability();
      });
    };
    /**
     * Messages catalog.
     * @name defaultMessages
     * @fieldOf app.directive:sgCartEditor
     * @type {object}
     */


    vm.defaultMessages = {
      unknownError: 'GLOBAL.UNKNOWN_ERROR',
      creationSuccess: 'CART.CREATION_SUCCESS_MSG',
      creationError: 'CART.CREATION_FAILURE_MSG',
      updateSuccess: 'CART.UPDATE_SUCCESS_MSG',
      updateError: 'CART.UPDATE_FAILURE_MSG',
      deleteSuccess: 'CART.DELETE_SUCCESS_MSG',
      deleteError: 'CART.DELETE_FAILURE_MSG'
    };
    /**
     * Notifications catalog.
     * @name notifs
     * @fieldOf app.directive:sgCartEditor
     * @type {object}
     */

    vm.notifs = {
      cart: {
        creation: {
          success: function success() {
            toaster.success(vm.defaultMessages.creationSuccess);
            return {
              model: vm.model
            };
          },
          failure: function failure(response) {
            toaster.error(response.data || vm.defaultMessages.creationError);
            return $q.reject(response);
          }
        },
        update: {
          success: function success() {
            toaster.success(vm.defaultMessages.updateSuccess);
            return {
              model: vm.model
            };
          },
          failure: function failure(response) {
            toaster.error(response.data || vm.defaultMessages.updateError);
            return $q.reject(response);
          }
        },
        quote: {
          failure: function failure(response) {
            toaster.error(response || vm.defaultMessages.unknownError);
            cartActive.set(null);
            $state.go('cart.list');
            return $q.reject(response);
          }
        }
      },
      items: {
        success: function success() {
          toaster.success(vm.defaultMessages.updateSuccess);
        },
        failure: function failure(response) {
          toaster.error(response.data || vm.defaultMessages.updateError);

          if (response.status === 404) {
            cartActive.set(null);
            $state.go('cart.list');
          }

          return $q.reject(response);
        }
      }
    };
    /**
     * @internal
     */

    vm.$onInit = function () {
      if (angular.isObject(vm.model) && vm.model.hasOwnProperty('$promise')) {
        //Disable this component if the model encounter a fatal error
        vm.model.$promise["catch"](function (response) {
          vm.model = null;
          vm.showFatalError(response.data);
        }); //Obtain the availability of the cart's items when the cart data is loaded

        if (vm.model.$resolved) {
          vm.onLoadCartModel();
        } else if (vm.model.$promise) {
          vm.model.$promise.then(vm.onLoadCartModel);
        }
      }
    };
    /**
     * Function called when the model data of the cart is available to work with.
     * @returns {object} cart model
     */


    vm.onLoadCartModel = function () {
      vm.refreshItemsAvailability();
      if (vm.onLoad) vm.onLoad({
        model: vm.model
      });
      gtmDataLayer.push({
        'cartName': vm.model.name
      });
      return vm.model;
    };
    /**
     * @ngdoc method
     * @name isCartLoaded
     * @methodOf app.directive:sgCartEditor
     * @returns {boolean}
     */


    vm.isCartLoaded = function () {
      if (angular.isObject(vm.model) && vm.model.hasOwnProperty('uniqid')) {
        return true;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name showFatalError
     * @methodOf app.directive:sgCartEditor
     * @description Show a serious error to the user.
     * @param {string} msg
     */


    vm.showFatalError = function (msg) {
      vm.fatalErrorMsg = msg || vm.defaultMessages.unknownError;
    };
    /**
     * @ngdoc method
     * @name showlError
     * @description Show an error as a notification.
     * @param {string} msg
     */


    vm.showError = function (msg) {
      toaster.error(msg || vm.defaultMessages.unknownError);
    };
    /**
     * @ngdoc method
     * @name changeName
     * @methodOf app.directive:sgCartEditor
     * @description Send to the backend any change made to the cart.
     * @name {string} name New name of the cart
     */


    vm.changeName = function (name) {
      vm.model.name = name;

      if (vm.model.isPhantom()) {
        vm.model.$save().then(vm.notifs.cart.creation.success, vm.notifs.cart.creation.failure).then(vm.onLoadCartModel).then(function (model) {
          if (vm.onCreate) vm.onCreate({
            model: model
          });
        });
      } else {
        vm.model.$update().then(vm.notifs.cart.update.success, vm.notifs.cart.update.failure).then(function (model) {
          if (vm.onUpdate) vm.onUpdate({
            model: model
          });
        });
      }
    };
    /**
     * Request create this cart in a quote.
     * @return {Promise}
     */


    vm.createQuote = function () {
      if (angular.isArray(vm.model.items) && vm.model.items.length > 0) {
        return ordersResource.createQuoteFromCart(vm.model.uniqid).then(function (quote) {
          if (angular.isFunction(vm.onQuoteCreated)) {
            vm.onQuoteCreated({
              quote: quote
            });
          }
        }, vm.notifs.cart.quote.failure);
      } else {
        vm.showError('CART.CART_IS_EMPTY');
      }
    };
    /**
     * Update the availability of the current cart items.
     */


    vm.refreshItemsAvailability = function () {
      vm.model.refreshAvailability();
    };
    /**
     * @ngdoc method
     * @name addCartItem
     * @methodOf app.directive:sgCartEditor
     * @description adds item to the itemsWaiting list to be added to cart
     * @param {object} item
     */


    vm.addCartItem = function (item) {
      vm.itemsWaiting.push(angular.copy(item)); //if status not pending

      if (vm.promiseCartChanged.$$state.status !== 0) {
        vm.startResolvingPromise(vm.itemsWaiting[0]);
      }
    };
    /**
     * @ngdoc method
     * @name startResolvingPromise
     * @methodOf app.directive:sgCartEditor
     * @description adds item to the cart
     * @param {object} item
     */


    vm.startResolvingPromise = function (item) {
      vm.promiseCartChanged = vm.model.$addItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability)["finally"](vm.refreshItemsWaiting);
    };
    /**
     * @ngdoc method
     * @name refreshItemsWaiting
     * @methodOf app.directive:sgCartEditor
     * @description resolving itemsWaiting list one by one
     * @param {object} item
     */


    vm.refreshItemsWaiting = function () {
      vm.itemsWaiting.shift(); // buffor must be used by usedSKU's as long as possible

      if (vm.itemsWaiting.length !== 0) {
        vm.startResolvingPromise(vm.itemsWaiting[0]);
      }
    };
    /**
     * @ngdoc method
     * @name updateCartItem
     * @methodOf app.directive:sgCartEditor
     * @description Request update an existing item of the cart.
     * @param {object} item
     */


    vm.updateCartItem = function (item) {
      vm.model.$updateItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability);
    };
    /**
     * @ngdoc method
     * @name removeCartItem
     * @methodOf app.directive:sgCartEditor
     * @description Request remove an item.
     * @param {object} item
     */


    vm.removeCartItem = function (item) {
      vm.promiseCartChanged = vm.model.$removeItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability);
    };
    /**
     * Clear array of failed import sku's
     */


    vm.clearFailed = function () {
      delete vm.model.items_failed;
    };
    /**
     * Clear array of disabled import sku's
     */


    vm.clearOmitted = function () {
      delete vm.model.items_omitted;
    };
    /**
     * Returns omitted skus as string for message
     * @returns {string}
     */


    vm.getOmittedItems = function () {
      return vm.model.items_omitted.length >= vm.maxOmittedSkus ? vm.model.items_omitted.slice(0, vm.maxOmittedSkus).join(', ') + "..." : vm.model.items_omitted.join(", ");
    };
  }
})(angular.module('app'));
"use strict";

(function (module, angular) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgCartItems
   * @description
   * Show the items of a cart.
   */

  /*@ngInject*/

  sgCartItems.$inject = ["$scope", "$timeout", "$translate", "lodash", "toaster", "$window", "$compile", "cardFileService"];
  module.directive('sgCartItems', function () {
    return {
      templateUrl: 'app/cart/components/cartItems.html',
      controller: sgCartItems,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        model: '=',
        allowAddItems: '<',
        allowEditItems: '<',
        allowRemoveItems: '<',
        selectable: '<?',
        selection: '=?',
        onRequestAdd: '&?',
        onRequestUpdate: '&',
        onRequestRemove: '&',
        onRequestRemoveMulti: '&',
        promiseCartChanged: '<',
        itemsWaiting: '<'
      },
      link: function link(scope, element) {
        scope.vm.getCreatorRow = function () {
          return element.find('tr.add-new-item');
        };
      }
    };
  });
  /*@noInject*/

  function sgCartItems($scope, $timeout, $translate, lodash, toaster, $window, $compile, cardFileService) {
    var vm = this;
    /**
     * List of used SKUs in the current cart.
     * @type {String[]}
     */

    vm.usedSKUs = [];
    /**
     * List of selected SKUs for batch operations.
     * @type {String[]}
     */

    vm.selectedSKUs = [];
    /**
     * Translated labels for passed to the template.
     * @type {Object}
     */

    vm.labels = $translate.instant(['GLOBAL.REMOVE_SELECTION', 'GLOBAL.ARE_YOU_SURE', 'GLOBAL.YES', 'GLOBAL.NO', 'GLOBAL.REMOVE_SELECTION', 'GLOBAL.DOWNLOAD_CARD_FOR_SELECTED', 'CART.ITEM_POSITION', 'CART.PRODUCT', 'CART.PRICE_OF_LIST', 'CART.PRICE_OF_LIST_HELPTEXT', 'CART.QUANTITY', 'CART.AVAILABILITY_HELPTEXT', 'CART.YOUR_DISCOUNT_HELPTEXT', 'CART.YOUR_PRICE', 'CART.BOTH_PRICES', 'CART.SKU', 'CART.AVAILABILITY', 'CART.YOUR_DISCOUNT']);
    /**
     * Stack of all the cart items selected for batch operations.
     * @type {Object[]}
     */

    vm.selection = angular.isArray(vm.selection) ? vm.selection : [];
    /**
     * Indicate if all the items are currently selected.
     * @type {boolean}
     */

    vm.areAllSelected = false;
    /**
     * Handle sticky header
     */

    var stickyHeaderTable = angular.element('[data-sticky-header]');

    if (stickyHeaderTable.length > 0) {
      var header = stickyHeaderTable.find('thead');
      var headerTr = header.find('tr');
      $compile(header.append(headerTr.clone().addClass('fixed')))($scope);
      var headerFixedTr = header.find('tr.fixed.table-header');
      var loaderFixedTr = header.find('tr.fixed.loader');
      angular.element($window).bind("scroll", function () {
        if (this.pageYOffset >= stickyHeaderTable.offset().top) {
          header.addClass('fixed');
          headerFixedTr.css({
            'width': headerTr.outerWidth(),
            'height': headerTr.outerHeight()
          });
          loaderFixedTr.css({
            'width': headerTr.outerWidth(),
            'top': headerTr.outerHeight(),
            'height': 0
          });
          vm.placement = 'bottom';
        } else {
          header.removeClass('fixed');
          vm.placement = 'top';
        }
      });
    }
    /**
     * Select or deselect all the items.
     * @param {boolean} select
     */


    vm.applyBatchSelection = function (select) {
      vm.model.items.forEach(function (item) {
        vm.updateSelection(item, select);
      });
    };
    /**
     * @ngdoc method
     * @name isCartLoaded
     * @methodOf app.directive:sgCartItems
     * @returns {boolean}
     */


    vm.isCartLoaded = function () {
      if (angular.isObject(vm.model)) {
        return !vm.model.isPhantom();
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name isProductInCart
     * @methodOf app.directive:sgCartItems
     * @param {string} sku
     * @returns {boolean}
     */


    vm.isProductInCart = function (sku) {
      return lodash.findIndex(vm.model.items, {
        sku: sku
      }) >= 0 || lodash.findIndex(vm.itemsWaiting, {
        sku: sku
      }) >= 0;
    };
    /**
     * @ngdoc method
     * @name requestAdd
     * @methodOf app.directive:sgCartItems
     * @description
     * This method order the creation of the new item only if the product isn't already in the current cart.
     * @param {object} item
     * @returns {boolean}
     */


    vm.requestAdd = function (item) {
      //Don't order creation if the product code is already in the list
      if (!vm.isProductInCart(item.sku)) {
        vm.onRequestAdd({
          item: item
        });
        vm.usedSKUs.push(item.sku);
      } else {
        toaster.error('CART.PRODUCT_ALREADY_IN_CART');
      }
    };
    /**
     * @ngdoc method
     * @name updateSelection
     * @methodOf app.directive:sgCartItems
     * @description
     * Update the array of selected items.
     * @returns {boolean}
     */


    vm.updateSelection = function (item, selected) {
      if (selected) {
        //Adding
        if (!vm.isSelected(item)) {
          vm.selection.push(item);
        }
      } else {
        //Removing
        lodash.remove(vm.selection, {
          sku: item.sku
        });
      }
    };
    /**
     * @ngdoc method
     * @name clearSelection
     * @methodOf app.directive:sgCartItems
     * @description
     * Un-select all the selected items.
     * @returns {boolean}
     */


    vm.clearSelection = function () {
      vm.selection = [];
    };
    /**
     * @ngdoc method
     * @name removeAllSelected
     * @methodOf app.directive:sgCartItems
     * @description
     * Send the order to remove all the selected items.
     * @returns {boolean}
     */


    vm.removeAllSelected = function () {
      vm.onRequestRemoveMulti({
        items: vm.selection
      });
    };
    /**
     * @ngdoc method
     * @name isSelected
     * @methodOf app.directive:sgCartItems
     * @description
     * Query if the given cart item is selected.
     * @returns {boolean}
     */


    vm.isSelected = function (item) {
      return vm.selectedSKUs.indexOf(item.sku) >= 0;
    };
    /**
     * @ngdoc method
     * @name pruneSelection
     * @methodOf app.directive:sgCartItems
     * @description
     * Remove from the selection array all the items which no longer are part of the cart.
     * @returns {boolean}
     */


    vm.pruneSelection = function () {
      lodash.remove(vm.selection, function (item) {
        return lodash.findIndex(vm.model.items, {
          sku: item.sku
        }) === -1;
      });
    };
    /**
     * @ngdoc method
     * @name downloadCardForSelected
     * @methodOf app.directive:sgCartItems
     * @description Download PDF card for selected items
     * @returns {boolean}
     */


    vm.downloadCardForSelected = function () {
      var skus = getSelectedSKUs();
      cardFileService.downloadCartCard(vm.model.entity_id, skus);
    };
    /**
     * @ngdoc method
     * @name getUsedSKUs
     * @methodOf app.directive:sgCartItems
     * @description
     * Returns a list with all the SKUs used actually in the cart. + added/removed in current session
     * @returns {string[]}
     */


    function getUsedSKUs() {
      var itemsWaiting = vm.itemsWaiting || [];

      if (angular.isObject(vm.model) && vm.model.hasOwnProperty('items') && angular.isArray(vm.model.items)) {
        return vm.model.items.map(function (item) {
          return item.sku;
        }).concat(itemsWaiting.map(function (item) {
          return item.sku;
        }));
      }

      return [];
    }
    /**
     * @ngdoc method
     * @name getSelectedSKUs
     * @methodOf app.directive:sgCartItems
     * @description
     * Returns a list with all the SKUs selected for batch operations.
     * @returns {string[]}
     */


    function getSelectedSKUs() {
      if (angular.isArray(vm.selection)) {
        return vm.selection.map(function (item) {
          return item.sku;
        });
      }

      return [];
    }
    /**
     * Function executed after a new item is detected.
     * It maintain visible the row to add new items always visible.
     */


    function afterAddNewItem() {
      if (vm.editable === true) {
        //$timeout used with delay 0 because this need to be executed in the next digest cycle
        $timeout(function () {
          var creatorItem = vm.getCreatorRow();

          if (!domUtils.itemIsVisible(creatorItem, 140)) {
            domUtils.scrollToItem(creatorItem, 140);
          }
        }, 0);
      }
    } //Prune the selection array every time a change is detected in the items list


    $scope.$watchCollection('vm.model.items', vm.pruneSelection); //Maintain the selectedSKUs variable updated

    $scope.$watchCollection('vm.selection', function () {
      vm.selectedSKUs = getSelectedSKUs(); //Check if all the element are currently selected

      vm.areAllSelected = angular.isArray(vm.model.items) && vm.model.items.length ? vm.model.items.length === vm.selection.length : false;
    }); //Maintain the "usedSKUs" variable updated

    $scope.$watchCollection('vm.model.items', function (newItems, oldItems) {
      vm.usedSKUs = getUsedSKUs(); //Detect when new items are added to the table

      if (angular.isArray(newItems) && angular.isArray(oldItems) && newItems.length > oldItems.length) {
        afterAddNewItem();
      }
    });
  }
})(angular.module('app'), angular);
"use strict";

(function (module, angular, Big) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgCartItem
   * @description Row to represent a item of a shopping cart.
   *
   * This a directive instead of a component because it add a CSS class to the main tag when the item is selected and
   * also because is used in a tr tag (inside a HTML table).
   */

  /*@ngInject*/

  sgCartItem.$inject = ["$scope", "$timeout", "$translate", "productsResource", "domUtils", "collectionUtils", "cartItemModel", "toaster", "lodash"];
  module.directive('sgCartItem', ["$timeout", function ($timeout) {
    return {
      restrict: 'AE',
      templateUrl: 'app/cart/components/cartItem.html',
      controller: sgCartItem,
      controllerAs: 'vm',
      bindToController: true,
      scope: {
        model: '<',
        editable: '<?',
        removable: '<?',

        /**
         * Position in the items cart's list.
         */
        position: '<',

        /**
         * Show a checkbox to select this item.
         */
        selectable: '<',
        isSelected: '<?',

        /**
         * Array with the SKUs that shouldn't be include in the product searches.
         */
        skuExcludeList: '<',
        onRequestCreate: '&?',
        onRequestUpdate: '&?',
        onRequestRemove: '&?',
        onSelectionChange: '&?',
        isProductInCart: '<'
      },
      link: function link(scope, element) {
        /**
         * Focus a specific input field.
         * @param {string} name Name of the field (input param "name")
         * @param {number} [delay] Delay (in ms) the focusing
         */
        scope.vm.focusField = function (name, delay) {
          if (isFinite(delay) && delay > 0) {
            $timeout(function () {
              scope.vm.focusField(name);
            }, delay);
          } //TODO This css selector is too complex to be handler by the jqlite of Angular 1.5. This will work while jQuery library were also used in this project.


          element.find('input[name=' + name + ']:not([readonly])').focus().select();
        }; //Making the element node available to the controller


        scope.vm.element = element;
      }
    };
  }]);
  /*@ngInject*/

  function sgCartItem($scope, $timeout, $translate, productsResource, domUtils, collectionUtils, cartItemModel, toaster, lodash) {
    var vm = this;
    vm.qtyValid = true;
    vm.qtyIncValid = true;
    vm.isSelected = false;
    var LOYALTY_ICON_URL = '/img/stalgast_profit.svg';
    var LOYALTY_ATTRIBUTE_CODE = 'loyalty_program';
    /**
     * Scope variable used to check if list of searched products is shown.
     * For more details about this variable see the doc of the function {@link findProduct()}.
     * @type {Promise}
     */

    vm.typeaheadPromise = null;
    /**
     * A copy of the cart's item model is used as work copy to easily detect when important properties of the
     * item has change.
     * This variable is maintain in sync in one direction (real model -> work-copy model) and the updated requests
     * are inform calling external binding functions.
     * @type cartItemModel
     */

    vm.workCopy = new cartItemModel();
    /**
     * Scope variable used by the template to create or destroy the button for remove confirmation.
     * For more details about this variable see the doc of the function {@link resetRemoveButton()}.
     * @type {boolean}
     */

    vm.removeButtonVisible = true;
    /**
     * Translated labels used by the template.
     * This approach is used to reduce the number of scope watchers in the template because this translations
     * are used several times in the same template.
     * @type {object}
     */

    vm.labels = $translate.instant(['GLOBAL.REMOVE', 'GLOBAL.ARE_YOU_SURE', 'GLOBAL.SURE?', 'CART.SKU_ABRV', 'GLOBAL.YES', 'GLOBAL.NO', 'CART.NOT_AVAILABLE_HELPTEXT', 'CART.NOT_AVAILABLE_ON_ORDER']);
    /**
     * Pixels reserved under the "Product code" input field to display the product's suggestions for adding a new
     * cart's item.
     * @type {number}
     */

    vm.suggestionPxHeightReserved = 140;
    /**
     * @ngdoc method
     * @name arePendingChanges
     * @methodOf app.directive:sgCartItem
     * @description Check is the item has pending unsaved changes.
     * @returns {boolean} TRUE/FALSE
     */

    vm.arePendingChanges = function () {
      if (vm.workCopy.sku === '' || vm.workCopy.qty < 1) {
        return false;
      }

      if (vm.model.sku !== vm.workCopy.sku) {
        return true;
      }

      return vm.model.qty !== vm.workCopy.qty;
    };
    /**
     * @returns {boolean}
     */


    vm.loyaltyProgramEnabled = function () {
      if (vm.model) {
        if (vm.model.loyalty_program !== undefined) {
          switch (vm.model.loyalty_program) {
            case 'Tak':
              return true;

            case 'Nie':
            default:
              return false;
          }
        }
      }

      return false;
    };

    vm.getLoyaltyIconUrl = function () {
      return LOYALTY_ICON_URL;
    };
    /**
     * @ngdoc method
     * @name saveChanges
     * @methodOf app.directive:sgCartItem
     * @description This function is called when the user finish to edit the model.
     * It call the external function callback ordering to apply the changes on the real model.
     */


    vm.saveChanges = function () {
      if (!vm.arePendingChanges()) {
        return;
      }

      if (!vm.qtyValid || !vm.qtyIncValid || !vm.workCopy.sku) {
        return;
      }

      if (vm.workCopy.itemExists()) {
        vm.onRequestUpdate({
          item: vm.workCopy
        });
      } else {
        if (!vm.isProductInCart(vm.workCopy.sku)) {
          // checking if list with products searched is shown
          if (vm.typeaheadPromise !== null && typeof vm.typeaheadPromise.$$state.value !== 'undefined' && vm.typeaheadPromise.$$state.value.length > 0) {
            vm.onRequestCreate({
              item: vm.workCopy
            });
            vm.resetWorkingCopy();
            vm.focusField('sku');
            vm.typeaheadPromise = null;
          }
        } else {
          toaster.error('CART.PRODUCT_ALREADY_IN_CART');
        }
      }
    };
    /**
     * @ngdoc method
     * @name updateItemIfExist
     * @methodOf app.directive:sgCartItem
     * @description
     * This function order the update of the cart item only if this already exists.
     * If the item isn't exist yet this function will do nothing.
     *
     * This function is useful when is called by a Input blur event because the changes in the input values
     * should be saved immediately when the item already exist but if not, the creation order should be sent
     * just after the user explicitly express that (pressing the key ENTER for example).
     */


    vm.updateItemIfExist = function () {
      if (vm.workCopy.itemExists()) {
        vm.saveChanges();
      }
    };
    /**
     * @ngdoc method
     * @name requestRemove
     * @methodOf app.directive:sgCartItem
     * @description This method is called when the user request the removing of this item from the cart.
     */


    vm.requestRemove = function () {
      vm.onRequestRemove({
        item: vm.workCopy
      });
      vm.resetRemoveButton();
    };
    /**
     * @ngdoc method
     * @name updateDefaultQty
     * @methodOf app.directive:sgCartItem
     * @description When sku selected set default qty, based on qtyIncrements
     */


    vm.updateDefaultQty = function (item) {
      vm.workCopy.qty = item.qtyIncrements;
      vm.workCopy.qtyIncrements = item.qtyIncrements;
    };
    /**
     * @ngdoc method
     * @name resetWorkingCopy
     * @methodOf app.directive:sgCartItem
     * @description Synchronize the properties of the working copy model and the real model.
     */


    vm.resetWorkingCopy = function () {
      if (!angular.equals(vm.workCopy, vm.model)) {
        collectionUtils.updateObject(vm.model, vm.workCopy, true);
      }
    };
    /**
     * @ngdoc method
     * @name increaseQty
     * @methodOf app.directive:sgCartItem
     * @description Increase qty by qtyIncrements value
     */


    vm.increaseQty = function () {
      if (vm.qtyIncValid) {
        vm.workCopy.qty += vm.workCopy.qtyIncrements;
      }

      if (!vm.workCopy.itemExists()) {
        return;
      }

      if (typeof vm.timer !== 'undefined') {
        clearInterval(vm.timer);
      }

      vm.timer = setInterval(function () {
        vm.saveChanges();
        clearInterval(vm.timer);
      }, 300);
    };
    /**
     * This function change the value of the scope variable "removeButtonVisible" used by the template for
     * create or destroy the html node element which contain the confirmation button.
     *
     * This hack is necessary because ngRepeat try reuse the rows when the data change (and that's a good thing)
     * but the component used to ask for inline confirmation before remove items, don't have support for reuse the
     * same instance.
     *
     * When this functions is call the button is destroyed and created again in the next digest cycle.
     */


    vm.resetRemoveButton = function () {
      vm.removeButtonVisible = false;
      $timeout(function () {
        vm.removeButtonVisible = true;
      }, 0);
    };
    /**
     * @ngdoc method
     * @name decreaseQty
     * @methodOf app.directive:sgCartItem
     * @description Decrease qty by qtyIncrements value
     */


    vm.decreaseQty = function () {
      if (vm.workCopy.qty > vm.workCopy.qtyIncrements && vm.qtyIncValid) {
        vm.workCopy.qty -= vm.workCopy.qtyIncrements;
      }

      if (!vm.workCopy.itemExists()) {
        return;
      }

      if (typeof vm.timer !== 'undefined') {
        clearInterval(vm.timer);
      }

      vm.timer = setInterval(function () {
        vm.saveChanges();
        clearInterval(vm.timer);
      }, 300);
    };
    /**
     * @ngdoc method
     * @name increaseAvaliable
     * @methodOf app.directive:sgCartItem
     * @description Check if increase available
     */


    vm.increaseAvaliable = function () {
      return vm.qtyIncValid;
    };
    /**
     * @ngdoc method
     * @name decreaseAvaliable
     * @methodOf app.directive:sgCartItem
     * @description Check if decrease available
     */


    vm.decreaseAvaliable = function () {
      if (angular.isUndefined(vm.workCopy.qtyIncrements)) {
        return true;
      }

      return vm.qtyIncValid && vm.workCopy.qty > vm.workCopy.qtyIncrements;
    };
    /**
     * @ngdoc method
     * @name findProduct
     * @methodOf app.directive:sgCartItem
     * @description Make a product search and returns the first 5 products matched.
     * @returns {Promise} Future
     */


    vm.findProduct = function (val) {
      //List of products to include and exclude
      var products = {
        include: [val + '*'],
        //Using Apache Lucene wildcards
        exclude: angular.isArray(vm.skuExcludeList) ? vm.skuExcludeList : [],
        checkOnly: true
      };
      vm.typeaheadPromise = productsResource.query(null, products, 1, 5).then(function (results) {
        return (results.rows || []).map(function (item) {
          return {
            sku: item.sku,
            label: item.sku + ' - ' + item.name,
            qtyIncrements: item.qtyIncrements
          };
        });
      });
      return vm.typeaheadPromise;
    };
    /**
     * Check if the quantity requested of this product is less or equal that the available stock.
     * Note: This function returns FALSE is no stock or quantity value is available.
     * @return {boolean}
     */


    vm.isQtyLessThanStock = function () {
      var stock = vm.workCopy.calculateVisibleStock();

      if (isFinite(stock) && isFinite(vm.workCopy.qty)) {
        if (stock >= vm.workCopy.qty && vm.workCopy.available == 'available') {
          return 'available';
        }

        if (stock < vm.workCopy.qty && vm.workCopy.available == 'unavailable') {
          return 'unavailable';
        }

        if (stock < vm.workCopy.qty && vm.workCopy.available == 'onorder') {
          return 'onorder';
        }
      }

      return vm.workCopy.available == 'available' ? 'available' : vm.workCopy.available == 'unavailable' ? 'unavailable' : vm.workCopy.available == 'onorder' ? 'onorder' : 'available';
    };
    /**
     * Function usually executed when the row gain focus.
     * It will try to create enough space under the item to show all the product suggestions.
     */


    vm.reserveSpaceForSuggestions = function () {
      if (!domUtils.itemIsVisible(vm.element, vm.suggestionPxHeightReserved)) {
        domUtils.scrollToItem(vm.element, vm.suggestionPxHeightReserved);
      }
    };
    /**
     * Validate qty increments
     * @param qty
     * @param qtyIncrements
     * @return {boolean}
     */


    function validateQtyIncrements(qty, qtyIncrements) {
      return qty % qtyIncrements === 0;
    }
    /**
     * validate qty
     * @param qty
     * @param qtyIncrements
     * @return {boolean}
     */


    function validateQty(qty) {
      return !isNaN(parseInt(qty));
    } //Update working copy each time the model changed


    $scope.$watchCollection('vm.model', vm.resetWorkingCopy); // check if given qty is valid

    $scope.$watch('vm.workCopy.qtyIncrements', function () {
      if (angular.isUndefined(vm.workCopy.qtyIncrements)) {
        vm.qtyIncValid = true;
      } else {
        vm.qtyIncValid = validateQtyIncrements(vm.workCopy.qty, vm.workCopy.qtyIncrements); //Updating the qty increment error

        vm.incrementErrorMsg = $translate.instant('CART.QTY_INCREMENT_ERROR', vm.workCopy);
      }
    }); // check if given qty is valid

    $scope.$watch('vm.workCopy.qty', function () {
      vm.qtyValid = validateQty(vm.workCopy.qty);

      if (!angular.isUndefined(vm.workCopy.qtyIncrements)) {
        vm.qtyIncValid = validateQtyIncrements(vm.workCopy.qty, vm.workCopy.qtyIncrements);
      }
    }); //Invoke an external function When the selection change

    $scope.$watch('vm.isSelected', function (newVal, oldVal) {
      if (vm.onSelectionChange && newVal !== oldVal) {
        vm.onSelectionChange({
          item: vm.model,
          selected: newVal
        });
      }
    }); //If the directive is created without a model, I use a empty object

    if (angular.isUndefined(vm.model)) {
      vm.model = new cartItemModel();
      Object.assign(vm.model, {
        sku: '',
        qty: 1,
        qtyIncrements: 1
      });
    }
  }
})(angular.module('app'), angular, Big);
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgCartEditor
   * @description
   * This component show a complete editor of a cart.
   *
   * It has 2 modes:
   *  - CREATE: If is instantiated without specify a cart ID it create a empty cart model and disable all the options
   *  until the cart were created.
   *  - UPDATE: If a cart ID or model object is specify then this component load or use the model given as reference.
   */

  sgCartEditorController.$inject = ["$q", "toaster", "ordersResource", "$state", "cartActive", "gtmDataLayer"];
  module.component('sgCartEditor', {
    templateUrl: 'app/cart/components/cartEditor.html',
    controller: sgCartEditorController,
    controllerAs: 'vm',
    bindings: {
      /**
       * @name model
       * @type {cartsResource} model
       */
      model: '=',
      updateStocks: '&',
      editable: '<',
      allowCreateQuote: '<',
      allowAddItems: '<',
      allowEditItems: '<',
      allowRemoveItems: '<',
      onLoad: '&?',
      onCreate: '&?',
      onUpdate: '&?',
      onQuoteCreated: '&?'
    }
  });
  /*@ngInject*/

  function sgCartEditorController($q, toaster, ordersResource, $state, cartActive, gtmDataLayer) {
    var vm = this;
    /**
     * Variable used to show loading while adding/removing products in cart
     */

    vm.promiseCartChanged = $q.resolve(0); //automatically resolved promises

    /**
     * Variable which contain the fatal error message received.
     * @fieldOf app.directive:sgCartEditor
     * @type {string}
     */

    vm.fatalErrorMsg = '';
    /**
     * Buffor for promises
     */

    vm.itemsWaiting = [];
    vm.maxOmittedSkus = 20;
    /**
     * Update stocks in cart
     */

    vm.updateStocks = function () {
      return vm.model.requestUpdateStocks().then(function () {
        toaster.success('CART.STOCKS_UPDATED');
        return vm.refreshItemsAvailability();
      });
    };
    /**
     * Messages catalog.
     * @name defaultMessages
     * @fieldOf app.directive:sgCartEditor
     * @type {object}
     */


    vm.defaultMessages = {
      unknownError: 'GLOBAL.UNKNOWN_ERROR',
      creationSuccess: 'CART.CREATION_SUCCESS_MSG',
      creationError: 'CART.CREATION_FAILURE_MSG',
      updateSuccess: 'CART.UPDATE_SUCCESS_MSG',
      updateError: 'CART.UPDATE_FAILURE_MSG',
      deleteSuccess: 'CART.DELETE_SUCCESS_MSG',
      deleteError: 'CART.DELETE_FAILURE_MSG'
    };
    /**
     * Notifications catalog.
     * @name notifs
     * @fieldOf app.directive:sgCartEditor
     * @type {object}
     */

    vm.notifs = {
      cart: {
        creation: {
          success: function success() {
            toaster.success(vm.defaultMessages.creationSuccess);
            return {
              model: vm.model
            };
          },
          failure: function failure(response) {
            toaster.error(response.data || vm.defaultMessages.creationError);
            return $q.reject(response);
          }
        },
        update: {
          success: function success() {
            toaster.success(vm.defaultMessages.updateSuccess);
            return {
              model: vm.model
            };
          },
          failure: function failure(response) {
            toaster.error(response.data || vm.defaultMessages.updateError);
            return $q.reject(response);
          }
        },
        quote: {
          failure: function failure(response) {
            toaster.error(response || vm.defaultMessages.unknownError);
            cartActive.set(null);
            $state.go('cart.list');
            return $q.reject(response);
          }
        }
      },
      items: {
        success: function success() {
          toaster.success(vm.defaultMessages.updateSuccess);
        },
        failure: function failure(response) {
          toaster.error(response.data || vm.defaultMessages.updateError);

          if (response.status === 404) {
            cartActive.set(null);
            $state.go('cart.list');
          }

          return $q.reject(response);
        }
      }
    };
    /**
     * @internal
     */

    vm.$onInit = function () {
      if (angular.isObject(vm.model) && vm.model.hasOwnProperty('$promise')) {
        //Disable this component if the model encounter a fatal error
        vm.model.$promise["catch"](function (response) {
          vm.model = null;
          vm.showFatalError(response.data);
        }); //Obtain the availability of the cart's items when the cart data is loaded

        if (vm.model.$resolved) {
          vm.onLoadCartModel();
        } else if (vm.model.$promise) {
          vm.model.$promise.then(vm.onLoadCartModel);
        }
      }
    };
    /**
     * Function called when the model data of the cart is available to work with.
     * @returns {object} cart model
     */


    vm.onLoadCartModel = function () {
      vm.refreshItemsAvailability();
      if (vm.onLoad) vm.onLoad({
        model: vm.model
      });
      gtmDataLayer.push({
        'cartName': vm.model.name
      });
      return vm.model;
    };
    /**
     * @ngdoc method
     * @name isCartLoaded
     * @methodOf app.directive:sgCartEditor
     * @returns {boolean}
     */


    vm.isCartLoaded = function () {
      if (angular.isObject(vm.model) && vm.model.hasOwnProperty('uniqid')) {
        return true;
      }

      return false;
    };
    /**
     * @ngdoc method
     * @name showFatalError
     * @methodOf app.directive:sgCartEditor
     * @description Show a serious error to the user.
     * @param {string} msg
     */


    vm.showFatalError = function (msg) {
      vm.fatalErrorMsg = msg || vm.defaultMessages.unknownError;
    };
    /**
     * @ngdoc method
     * @name showlError
     * @description Show an error as a notification.
     * @param {string} msg
     */


    vm.showError = function (msg) {
      toaster.error(msg || vm.defaultMessages.unknownError);
    };
    /**
     * @ngdoc method
     * @name changeName
     * @methodOf app.directive:sgCartEditor
     * @description Send to the backend any change made to the cart.
     * @name {string} name New name of the cart
     */


    vm.changeName = function (name) {
      vm.model.name = name;

      if (vm.model.isPhantom()) {
        vm.model.$save().then(vm.notifs.cart.creation.success, vm.notifs.cart.creation.failure).then(vm.onLoadCartModel).then(function (model) {
          if (vm.onCreate) vm.onCreate({
            model: model
          });
        });
      } else {
        vm.model.$update().then(vm.notifs.cart.update.success, vm.notifs.cart.update.failure).then(function (model) {
          if (vm.onUpdate) vm.onUpdate({
            model: model
          });
        });
      }
    };
    /**
     * Request create this cart in a quote.
     * @return {Promise}
     */


    vm.createQuote = function () {
      if (angular.isArray(vm.model.items) && vm.model.items.length > 0) {
        return ordersResource.createQuoteFromCart(vm.model.uniqid).then(function (quote) {
          if (angular.isFunction(vm.onQuoteCreated)) {
            vm.onQuoteCreated({
              quote: quote
            });
          }
        }, vm.notifs.cart.quote.failure);
      } else {
        vm.showError('CART.CART_IS_EMPTY');
      }
    };
    /**
     * Update the availability of the current cart items.
     */


    vm.refreshItemsAvailability = function () {
      vm.model.refreshAvailability();
    };
    /**
     * @ngdoc method
     * @name addCartItem
     * @methodOf app.directive:sgCartEditor
     * @description adds item to the itemsWaiting list to be added to cart
     * @param {object} item
     */


    vm.addCartItem = function (item) {
      vm.itemsWaiting.push(angular.copy(item)); //if status not pending

      if (vm.promiseCartChanged.$$state.status !== 0) {
        vm.startResolvingPromise(vm.itemsWaiting[0]);
      }
    };
    /**
     * @ngdoc method
     * @name startResolvingPromise
     * @methodOf app.directive:sgCartEditor
     * @description adds item to the cart
     * @param {object} item
     */


    vm.startResolvingPromise = function (item) {
      vm.promiseCartChanged = vm.model.$addItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability)["finally"](vm.refreshItemsWaiting);
    };
    /**
     * @ngdoc method
     * @name refreshItemsWaiting
     * @methodOf app.directive:sgCartEditor
     * @description resolving itemsWaiting list one by one
     * @param {object} item
     */


    vm.refreshItemsWaiting = function () {
      vm.itemsWaiting.shift(); // buffor must be used by usedSKU's as long as possible

      if (vm.itemsWaiting.length !== 0) {
        vm.startResolvingPromise(vm.itemsWaiting[0]);
      }
    };
    /**
     * @ngdoc method
     * @name updateCartItem
     * @methodOf app.directive:sgCartEditor
     * @description Request update an existing item of the cart.
     * @param {object} item
     */


    vm.updateCartItem = function (item) {
      vm.model.$updateItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability);
    };
    /**
     * @ngdoc method
     * @name removeCartItem
     * @methodOf app.directive:sgCartEditor
     * @description Request remove an item.
     * @param {object} item
     */


    vm.removeCartItem = function (item) {
      vm.promiseCartChanged = vm.model.$removeItem(item, vm.notifs.items.success, vm.notifs.items.failure).then(vm.refreshItemsAvailability);
    };
    /**
     * Clear array of failed import sku's
     */


    vm.clearFailed = function () {
      delete vm.model.items_failed;
    };
    /**
     * Clear array of disabled import sku's
     */


    vm.clearOmitted = function () {
      delete vm.model.items_omitted;
    };
    /**
     * Returns omitted skus as string for message
     * @returns {string}
     */


    vm.getOmittedItems = function () {
      return vm.model.items_omitted.length >= vm.maxOmittedSkus ? vm.model.items_omitted.slice(0, vm.maxOmittedSkus).join(', ') + "..." : vm.model.items_omitted.join(", ");
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgCartActionsBar
   * @description
   * Allow execute actions on a cart.
   */

  sgCartActionsBarController.$inject = ["$q", "$scope", "$translate", "toaster", "importCSVModalLauncher", "blocksResource"];
  module.component('sgCartActionsBar', {
    templateUrl: 'app/cart/components/cartActionsBar.html',
    controller: sgCartActionsBarController,
    controllerAs: 'vm',
    bindings: {
      model: '=',
      allowAddItems: '<',
      updateStocks: '&',
      onDelete: '&?'
    }
  });
  /*@ngInject*/

  function sgCartActionsBarController($q, $scope, $translate, toaster, importCSVModalLauncher, blocksResource) {
    var vm = this,
        importBlockId = 'csv_import_info';
    vm.defaultErrorMsg = $translate.instant('CART.DELETE_FAILURE_MSG');
    vm.deleteCart = deleteCart;
    vm.openImportModal = openImportModal;
    vm.cartHasItems = cartHasItems;
    /**
     * Configuration for the CSV export feature.
     * @type {{filename: string, fields: string[], headers: string[]}}
     */

    vm.csvConfig = {};
    /**
     * Function automatically called after the initialization of the component.
     */

    vm.$onInit = function () {
      vm.csvConfig = {
        filename: buildCsvFileName(),
        fields: ['sku', 'qty', 'name', 'price', 'promotion_price', 'stock', 'discount', 'discount_group', 'reseller_price', 'row_total_excl_tax'],
        headers: [$translate.instant('CART.SKU'), $translate.instant('CART.QUANTITY'), $translate.instant('CART.PRODUCT'), $translate.instant('CART.PRICE_OF_LIST'), $translate.instant('CART.PROMO_PRICE'), $translate.instant('CART.AVAILABILITY'), $translate.instant('CART.YOUR_DISCOUNT'), $translate.instant('CART.DISCOUNT_GROUP'), $translate.instant('CART.YOUR_PRICE'), $translate.instant('CART.BOTH_PRICES')],

        /**
         * Convert the cart items in a collection with values more easy to print as CSV.
         * @return {function}
         */
        getData: function getData() {
          return vm.model.items.map(function (item) {
            return {
              sku: item.sku,
              qty: item.qty,
              name: item.name,
              price: item.price,
              promotion_price: item.promotion_price ? item.promotion_price : '',
              stock: item.calculateVisibleStock(),
              discount: isFinite(item.discount) ? item.discount : 0,
              discount_group: item.discount_group,
              reseller_price: item.reseller_price,
              row_total_excl_tax: item.row_total_excl_tax
            };
          });
        }
      }; //Update filename of the csv export file when the name of cart also changes

      $scope.$watch('vm.model.name', function () {
        vm.csvConfig.filename = buildCsvFileName();
      });
    };
    /**
     * Generate and return a proposal for the name of the exported CSV file.
     * @return {string}
     */


    function buildCsvFileName() {
      var prefix = $translate.instant('CART.CART'),
          suffix = '.csv';
      return prefix + ' ' + vm.model.name + suffix;
    }
    /**
     * Order the backend to delete this cart.
     * @Return {Promise}
     */


    function deleteCart() {
      return vm.model.$delete().then(vm.onDelete)["catch"](function (response) {
        showError(response.data || vm.defaultErrorMsg);
        return $q.reject(response.data);
      });
    }
    /**
     * Check if the current cart has items.
     * @return {boolean}
     */


    function cartHasItems() {
      return !vm.model.isPhantom() && vm.model.items.length > 0;
    }
    /**
     * FIXME: COMMENT
     */


    function openImportModal() {
      blocksResource.get({
        id: importBlockId
      }).$promise.then(function (data) {
        importCSVModalLauncher.show(data[importBlockId]);
      });
    }
    /**
     * Show an error notification.
     * @param {string} msg
     */


    function showError(msg) {
      toaster.error(msg);
    }
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgAddToCart
   * @module app
   * @description
   * Show a component to quickly add a product to the currently active cart.
   */

  sgAddToCart.$inject = ["$state", "cartActive", "$scope", "$translate", "toaster"];
  module.component('sgAddToCart', {
    templateUrl: 'app/cart/components/addToCart.html',
    controller: sgAddToCart,
    controllerAs: 'vm',
    bindings: {
      productId: '<',
      qtyIncrements: '<',
      onProductAdd: '&',
      onGoToCartList: '&',

      /**
       * Default quantity value.
       * Default is 1.
       * @type number
       */
      defaultQty: '<?'
    }
  });
  /*@ngInject*/

  function sgAddToCart($state, cartActive, $scope, $translate, toaster) {
    var vm = this;
    vm.qtyValid = true;
    vm.qtyIncValid = true;
    vm.qty = vm.qtyIncrements;
    vm.incrementErrorMsg = $translate.instant('CART.QTY_INCREMENT_ERROR', vm);
    /**
     * Check if there a cart currently active.
     * @return {boolean}
     */

    vm.hasActiveCart = function () {
      return cartActive.has();
    };
    /**
     * Add to the active cart a specific quantity of the product.
     * @param {number} qty
     * @returns {Promise}
     */


    vm.addToCart = function (qty) {
      if (vm.hasActiveCart()) {
        return cartActive.addProduct(vm.productId, qty).then(function (result) {
          if (angular.isFunction(vm.onProductAdd)) vm.onProductAdd();
          return result;
        }, function (error) {
          toaster.error(error.data);
          cartActive.set(null);
        });
      }
    };
    /**
     * Go to the cart list router state.
     */


    vm.goToCartList = function () {
      $state.go('cart.list');
      if (angular.isFunction(vm.onGoToCartList)) vm.onGoToCartList();
    };
    /**
     * @ngdoc method
     * @name increaseQty
     * @methodOf app.directive:sgAddToCart
     * @description Increase qty by qtyIncrements value
     */


    vm.increaseQty = function () {
      if (vm.qtyIncValid) {
        vm.qty += vm.qtyIncrements;
      }
    };
    /**
     * @ngdoc method
     * @name decreaseQty
     * @methodOf app.directive:sgAddToCart
     * @description Decrease qty by qtyIncrements value
     */


    vm.decreaseQty = function () {
      if (vm.qty > vm.qtyIncrements && vm.qtyIncValid) {
        vm.qty -= vm.qtyIncrements;
      }
    };
    /**
     * @ngdoc method
     * @name increaseAvaliable
     * @methodOf app.directive:sgAddToCart
     * @description Check if increase available
     */


    vm.increaseAvaliable = function () {
      return vm.qtyIncValid;
    };
    /**
     * @ngdoc method
     * @name decreaseAvaliable
     * @methodOf app.directive:sgAddToCart
     * @description Check if decrease available
     */


    vm.decreaseAvaliable = function () {
      if (angular.isUndefined(vm.qtyIncrements)) {
        return true;
      }

      return vm.qtyIncValid && vm.qty > vm.qtyIncrements;
    };
    /**
     * Clear the quantity.
     */


    vm.clear = function () {
      vm.qty = isFinite(vm.defaultQty) && angular.isDefined(vm.defaultQty) ? vm.defaultQty : 1;
    }; //Clear qty on start


    vm.$onInit = vm.clear; // check if given qty is valid

    $scope.$watch('vm.qty', function () {
      vm.qtyValid = !isNaN(parseInt(vm.qty));

      if (!angular.isUndefined(vm.qtyIncrements)) {
        vm.qtyIncValid = vm.qty % vm.qtyIncrements === 0;
      }
    });
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name activeCartWidget
   * @module app
   * @author daniel.zegarra@orba.co
   * @description
   * Widget which show information about the current active cart.
   */

  activeCartWidget.$inject = ["cartActive", "$scope", "$state"];
  module.component('activeCartWidget', {
    templateUrl: 'app/cart/components/activeCartWidget.html',
    controller: activeCartWidget,
    controllerAs: 'vm'
  });
  /*@ngInject*/

  function activeCartWidget(cartActive, $scope, $state) {
    var vm = this; //Maintain update the cart model shared with the view

    $scope.$watch(function () {
      vm.cart = cartActive.get();
    });
    /**
     * Function executed after the user press over the component.
     * This functions decide which action to take.
     */

    vm.onPress = function () {
      if (cartActive.has()) {
        vm.openCart(cartActive.get());
      } else {
        vm.goToCartList();
      }
    };
    /**
     * Redirect to the list of carts.
     */


    vm.goToCartList = function () {
      $state.go('cart.list');
    };
    /**
     * Redirect to the router state with the cart details.
     */


    vm.openCart = function () {
      $state.go('cart.update', {
        id: vm.cart.uniqid
      });
    };
    /**
     * Check if the current component should allow user interaction.
     * @return {boolean}
     */


    vm.isUserInteractionAllowed = function () {
      if (vm.cart) {
        return !$state.is('cart.update', {
          id: vm.cart.uniqid
        });
      } else {
        return !$state.is('cart.list');
      }
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  "use strict";
  /**
   * @ngdoc service
   * @name agreementBlocks
   * @module app
   * @description
   * Service to show a modal window for edit a specific address.
   */

  agreementBlocks.$inject = ["orbaSession", "blocksResource"];
  module.service('agreementBlocks', agreementBlocks);
  /*@ngInject*/

  function agreementBlocks(orbaSession, blocksResource) {
    var vm = this;
    /**
     * Blocks returned from api
     * @type {object}
     */

    vm.agreementBlocks = null;
    /**
     * Constant values with block names
     */

    var WELCOME_TEXT = 'welcome';
    var RULES_LABEL_BLOCK_NAME = 'agreement_rules_label';
    var RULES_CONTENT_BLOCK_NAME = 'agreement_rules_content';
    var NOTIFICATIONS_LABEL_BLOCK_NAME = 'agreement_notifications_label';
    var NOTIFICATIONS_CONTENT_BLOCK_NAME = 'agreement_notifications_content';
    /**
     * Retrieve blocks from api
     * @private
     */

    var _getAgreementBlocks = function _getAgreementBlocks() {
      if (!vm.agreementBlocks || vm.agreementBlocks === null) {
        vm.agreementBlocks = blocksResource.query({
          id: [WELCOME_TEXT, RULES_LABEL_BLOCK_NAME, RULES_CONTENT_BLOCK_NAME, NOTIFICATIONS_LABEL_BLOCK_NAME, NOTIFICATIONS_CONTENT_BLOCK_NAME],
          client_id: orbaSession.getClientId()
        });
      }
    };
    /**
     * Get content from loaded block
     *
     * @private
     * @param {string} blockName
     * @returns {string}
     */


    var _getBlockContent = function _getBlockContent(blockName) {
      _getAgreementBlocks();

      var blockContent = '...';

      if (vm.agreementBlocks.hasOwnProperty(blockName)) {
        blockContent = vm.agreementBlocks[blockName].content;
      }

      return blockContent;
    };
    /**
     * Return welcome text from magento
     * @returns {string}
     */


    var getWelcomeText = function getWelcomeText() {
      return _getBlockContent(WELCOME_TEXT);
    };
    /**
     * Return agreement text from magento
     * @returns {string}
     */


    var getRulesLabel = function getRulesLabel() {
      return _getBlockContent(RULES_LABEL_BLOCK_NAME);
    };
    /**
     * Return agreement text from magento
     * @returns {string}
     */


    var getRulesContent = function getRulesContent() {
      return _getBlockContent(RULES_CONTENT_BLOCK_NAME);
    };
    /**
     * Return agreement text from magento
     * @returns {string}
     */


    var getNotificationsLabel = function getNotificationsLabel() {
      return _getBlockContent(NOTIFICATIONS_LABEL_BLOCK_NAME);
    };
    /**
     * Return agreement text from magento
     * @returns {string}
     */


    var getNotificationsContent = function getNotificationsContent() {
      return _getBlockContent(NOTIFICATIONS_CONTENT_BLOCK_NAME);
    };

    return {
      getWelcomeText: getWelcomeText,
      getRulesLabel: getRulesLabel,
      getRulesContent: getRulesContent,
      getNotificationsLabel: getNotificationsLabel,
      getNotificationsContent: getNotificationsContent
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('blocksResource', ["$resource", "$http", "blocksConfig", "$sce", function ($resource, $http, blocksConfig, $sce) {
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */
    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      angular.forEach(item, function (subitem) {
        subitem.content = $sce.trustAsHtml(subitem.content);
      });
      return item;
    };
    /**
     * Process a response for a request of a single row.
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformSingle = function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.blocks || data) : data;
    };
    /**
     * Process a response for a request of multiple rows.
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformMultiple = function transformMultiple(data) {
      if (angular.isObject(data)) {
        if (data.blocks) {
          [].map.call(data.blocks, transformItem);
          return data.blocks;
        }

        return data.map(transformItem);
      } else {
        return data;
      }
    };

    return $resource(blocksConfig.restful.blocks, {
      id: '@id'
    }, {
      //Collection of items
      'query': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformMultiple)
      },
      //Single item
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Creation
      'save': {
        method: 'POST',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Update
      'update': {
        method: 'PUT',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      }
    });
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for single block/infopage
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('blocksItemCtrl', ["$scope", "$state", "toaster", "blocksResource", function blocksItemCtrl($scope, $state, toaster, blocksResource) {
    /**
     * Block id
     * @type {string}
     */
    var blockId = $state.params.id;
    /**
     * Retrieve block content
     */

    $scope.blocks = blocksResource.get({
      id: blockId
    });
    $scope.blocks.$promise.then(function () {
      $scope.block = $scope.blocks[blockId];
      $state.current.ncyBreadcrumbLabel = $scope.block.title;
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  "use strict";
  /**
   * @ngdoc factory
   * @name sessionAccess
   * @module app
   * @description
   * Methods to check if the current user should have access to the resources or data given.
   */

  sessionAccess.$inject = ["orbaSession", "roleAccess", "lodash"];
  module.factory("sessionAccess", sessionAccess);
  /*@ngInject*/

  function sessionAccess(orbaSession, roleAccess, lodash) {
    /**
     * Returns the role code of the current user.
     * @return {String|null}
     */
    function getRole() {
      if (orbaSession.isLoggedIn()) {
        return orbaSession.getTokenPayload().sgrol;
      }

      return null;
    }
    /**
     * Check if the given action is allowed for the role given.
     * @param {string} action
     * @return {boolean}
     */


    function isActionAllowed(action) {
      var sep = lodash.split(action, '.'),
          userRoleId = getRole();
      return roleAccess.isActionAllowed(userRoleId, sep[0], sep[1]);
    }
    /**
     * Request the check of several access keys.
     *
     * @param {string[]} actions
     * @return {object} Object with results
     */


    function areActionsAllowed(actions) {
      var result = {};
      actions.forEach(function (action) {
        lodash.set(result, action, isActionAllowed(action));
      });
      return result;
    }

    return {
      isActionAllowed: isActionAllowed,
      areActionsAllowed: areActionsAllowed
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  "use strict";
  /**
   * @ngdoc factory
   * @name roleAccess
   * @module app
   * @description
   * Methods to check the accesses for a specific role.
   */

  module.provider("roleAccess", roleAccessProvider);
  /*@ngInject*/

  function roleAccessProvider() {
    var provider = this;
    /**
     * ID/Code of the role to use in case the role passed to check doesn't have roles defined.
     * @type {string|null}
     */

    provider["default"] = null;
    /**
     * Now comes the action.
     * @param {lodash} lodash
     * @param {roleAccessBlacklist} roleAccessBlacklist
     * @return {{isActionAllowed: isActionAllowed}}
     */

    /*@ngInject*/

    provider.$get = function (lodash, roleAccessBlacklist) {
      return {
        isActionAllowed: isActionAllowed,
        roleHasRules: roleHasRules
      };
      /**
       * Check if there is rules for the passed rol ID.
       * @param {number} roleId
       * @returns {boolean}
       */

      function roleHasRules(roleId) {
        var rules = getRules(roleId);
        return rules !== null;
      }
      /**
       * Returns the rules for a specific role.
       * @param {string|number} roleId
       * @param {string|number} [failSafeRoleId=undefined] Role ID to use in case there are no rules for the primary role passed.
       * @return {object|null}
       */


      function getRules(roleId, failSafeRoleId) {
        if (roleAccessBlacklist.hasOwnProperty(roleId)) {
          return roleAccessBlacklist[roleId];
        }

        if (angular.isDefined(failSafeRoleId) && failSafeRoleId !== null) {
          if (roleAccessBlacklist.hasOwnProperty(failSafeRoleId)) {
            return roleAccessBlacklist[failSafeRoleId];
          }
        }

        return null;
      }
      /**
       * Check if the given action is allowed for the role given.
       * @param {int} roleId
       * @param {string} resourceName
       * @param {string} actionName
       * @return {boolean}
       */


      function isActionAllowed(roleId, resourceName, actionName) {
        var actions,
            list = getRules(roleId, provider["default"]); // If there's no rules for the role given: allow

        if (list === null) {
          return true;
        }

        actions = lodash.get(list, 'rest_blacklist.' + resourceName, null); // If there are no restrictions for the resource: allow

        if (actions === null) {
          return true;
        } // Every action in this resource is disallowed


        if (actions === '*') {
          return false;
        } // Some actions are restricted - allow if action is NOT in the list


        actions = lodash.split(actions, ',');
        return actions.indexOf(actionName) === -1;
      }
    };

    provider.$get.$inject = ["lodash", "roleAccessBlacklist"];
  }
})(angular.module("app"));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgAccess
   * @module app
   * @description
   * Hide an element if the current user don't have access to the resource associated to it.
   * This directive don't watch changes in the access key because for know the access tree is hardcoded.
   */

  /*@ngInject*/

  module.directive('sgAccess', ["sessionAccess", function (sessionAccess) {
    return {
      restrict: 'A',
      link: function link(scope, el, attr) {
        var accessName = attr.sgAccess;

        if (sessionAccess.isActionAllowed(accessName)) {
          el.removeClass('no-access');
        } else {
          el.addClass('no-access');
        }
      }
    };
  }]);
})(angular.module('app'));
"use strict";

/**
 * @ngdoc controller
 * @name setAgreementsCtrl
 * @description
 */
(function (module, angular) {
  'use strict';
  /*@ngInject*/

  module.controller('setAgreementsCtrl', ["$state", "$scope", "orbaSession", "usersMeResource", "agreementBlocks", "toaster", function accountMyDataCtrl($state, $scope, orbaSession, usersMeResource, agreementBlocks, toaster) {
    var vm = this;
    vm.rulesToggle = false;
    vm.notificationsToggle = false;
    /**
     * State view to go after this process is finished.
     * TODO Debate if this should be hardcoded
     * @type {string}
     */

    $scope.afterFinishGoTo = 'account.myData';
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getRulesLabel = agreementBlocks.getRulesLabel;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getRulesContent = agreementBlocks.getRulesContent;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getNotificationsLabel = agreementBlocks.getNotificationsLabel;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getNotificationsContent = agreementBlocks.getNotificationsContent;
    $scope.usersMeResource = usersMeResource.get().$promise.then(function (data) {
      vm.info = {
        user: data
      };
    });
    /**
     * Update user mailer_allow param
     */

    $scope.saveAgreementsAttr = function () {
      var payload = {
        agreement_rules: vm.info.user.user.agreement_rules ? 1 : 0,
        agreement_notifications: vm.info.user.user.agreement_notifications ? 1 : 0
      };
      usersMeResource.update(payload).$promise.then(function () {
        toaster.success('ACCOUNT.DATA_SAVED');
        orbaSession.loadUserInfo();
        $state.go($scope.afterFinishGoTo, {}, {
          reload: true
        });
      }, function () {
        toaster.error('ACCOUNT.DATA_SAVE_ERROR');
      });
    };

    if (vm.info && vm.info.user.user.agreement_notifications) {
      $state.go($scope.afterFinishGoTo, {}, {
        reload: true
      });
    }
  }]);
})(angular.module('app'), angular);
"use strict";

/**
 * @ngdoc controller
 * @name recoverPasswordCtrl
 * @description
 * Controller to achieve the password recovery of an account.
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('recoverPasswordCtrl', ["$scope", "$http", "$state", "$translate", "orbaSession", "toaster", function ($scope, $http, $state, $translate, orbaSession, toaster) {
    /**
     * Variable which contain the last error message received.
     * @type {string}
     */
    $scope.lastErrorMsg = '';
    /**
     * Translation ID of the error message by default if the server doesn't provide one.
     * @type {string}
     */

    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * Name of the view to redirect after the server accept the request.
     * TODO The name of the state view of the login form is hardcoded
     * @type {string}
     */

    $scope.afterFinishGoTo = 'auth.login';
    /**
     * Suffix add to the default auth URL.
     * TODO The URL Suffix is hardcoded
     * @type {string}
     */

    $scope.hostUrlSuffix = '/users/recoveryPasswordRequest';
    /**
     * Default message when the server accept the request.
     * This message is shown only if the server doesn't return one.
     * @type {string}
     */

    $scope.defaultSuccessMsg = 'AUTH.RECOVERY_PASSWORD_PROCESS_START_CONFIRMATION';
    /**
     * Returns the payload the server requires.
     * TODO The structure of the payload is hardcoded
     * @returns {{client_id: string, login: string}}
     */

    $scope.buildRequestPayload = function () {
      return {
        client_id: orbaSession.getClientId(),
        username: $scope.login
      };
    };
    /**
     * Return the url to the send the request.
     * @returns {string}
     */


    $scope.getRequestUrl = function () {
      return orbaSession.getAuthHost() + $scope.hostUrlSuffix;
    };
    /**
     * Send the request to the server.
     */


    $scope.send = function () {
      var hostUrl = $scope.getRequestUrl(),
          payload = $scope.buildRequestPayload();
      $http.post(hostUrl, angular.toJson(payload)).then(function (response) {
        $scope.showConfirmation($scope.readResponseMessage(response.data, $scope.defaultSuccessMsg));
        $state.go($scope.afterFinishGoTo);
      }, function (response) {
        $scope.showError($scope.readResponseMessage(response.data));
      });
    };
    /**
     * Decode the string message sent by the server.
     * TODO This algorithm should be in a separate module
     * @param {object} response Response from the server
     * @param {string} [defaultMsg]
     * @returns {string}
     */


    $scope.readResponseMessage = function (response, defaultMsg) {
      var msg = '';
      if (angular.isString(response)) msg = response;

      if (angular.isObject(response)) {
        if (response.hasOwnProperty('message')) msg = response.message;
        if (response.hasOwnProperty('msg')) msg = response.msg;
      }

      return msg || defaultMsg;
    };
    /**
     * Show the confirmation process.
     */


    $scope.showConfirmation = function (msg) {
      $translate(msg).then(function (successMsg) {
        toaster.success(successMsg);
      }, function (translationId) {
        toaster.success(translationId);
      });
    };
    /**
     * Show an error in the screen.
     * @param {string} msg
     */


    $scope.showError = function (msg) {
      $scope.lastErrorMsg = msg ? msg : $scope.defaultErrorMsg;
    };
    /**
     * Hide a previous authentication error.
     */


    $scope.dismissError = function () {
      $scope.lastErrorMsg = '';
    };
  }]);
})(angular.module('app'));
"use strict";

/**
 * @ngdoc controller
 * @name newPasswordCtrl
 * @description
 * Controller to recover a forgotten password for an account using a temporal and unique token key.
 * @author  daniel.zegarra@orba.co`
 */
(function (module, angular) {
  'use strict';
  /*@ngInject*/

  module.controller('newPasswordCtrl', ["$scope", "orbaLoginEnforce", "$state", "$stateParams", "orbaSession", "toaster", function ($scope, orbaLoginEnforce, $state, $stateParams, orbaSession, toaster) {
    /**
     * Temporal code to set the new password.
     */
    $scope.token = $stateParams.token;
    /**
     * Translation ID of the error message by default if the server doesn't provide one.
     * @type {string}
     */

    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * State view to go after this process is finished.
     * TODO Debate if this should be hardcoded
     * @type {string}
     */

    $scope.afterFinishGoTo = 'account.myData';
    /**
     * Last error message returned by the server.
     * @type {string}
     */

    $scope.lastErrorMsg = '';
    /**
     * Error message by default if an error occurs and the cause is unknown.
     * @type {string}
     */

    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * Default message when the server accept the request.
     * This message is shown only if the server doesn't return one.
     * FIXME The default success message is hardcoded
     * @type {string}
     */

    $scope.defaultSuccessMsg = 'Your password has been set';
    /**
     * Send the request to set the user password and in case of success, the user is redirect to his dashboard.
     *
     * @param {string} password
     */

    $scope.sendPassword = function (password) {
      $scope.settingPasswordPromise = orbaSession.setPasswordAndThenLoginWithResponse($scope.token, password).then(function () {
        toaster.success($scope.defaultSuccessMsg);
        $state.go($scope.afterFinishGoTo);
      }, $scope.showError);
    };
    /**
     * Show an error in the screen.
     * @param {string} msg
     */


    $scope.showError = function (msg) {
      $scope.lastErrorMsg = msg ? msg : $scope.defaultErrorMsg;
    };
    /**
     * Clear the last error message.
     */


    $scope.dismissError = function () {
      $scope.lastErrorMsg = '';
    };

    if (!angular.isString($scope.token) || $scope.token.length === 0) {
      toaster.error('The token given is not valid');
      orbaLoginEnforce.showLoginForm();
    }
  }]);
})(angular.module('app'), angular);
"use strict";

(function (module) {
  /*@ngInject*/
  module.controller('loginCtrl', ["orbaSession", "$state", function (orbaSession, $state) {
    // if user already logged in, redirect to dashboard
    if (orbaSession.isLoggedIn() === true) {
      $state.go('home');
    }
  }]);
})(angular.module('app'));
"use strict";

/**
 * @ngdoc controller
 * @name newPasswordCtrl
 * @description
 * Controller to define the password for an user for the first time.
 */
(function (module, angular) {
  'use strict';
  /*@ngInject*/

  module.controller('activateAccountCtrl', ["$scope", "$state", "$stateParams", "orbaSession", "orbaLoginEnforce", "agreementBlocks", "toaster", function ($scope, $state, $stateParams, orbaSession, orbaLoginEnforce, agreementBlocks, toaster) {
    var vm = this;
    $scope.vm = vm;
    vm.rulesToggle = false;
    vm.notificationsToggle = false;
    orbaSession.logout();
    /**
     * Temporal code to set the user password for first time.
     */

    $scope.token = $stateParams.token;
    /**
     * @type {{password: string, agreement_rules: boolean, agreement_notifications: boolean}}
     */

    $scope.passwordModel = {
      "password": "",
      "agreement_rules": false,
      "agreement_notifications": false
    };
    /**
     * State view to go after this process is finished.
     * TODO Debate if this should be hardcoded
     * @type {string}
     */

    $scope.afterFinishGoTo = 'account.myData';
    /**
     * Translation ID of the error message by default if the server doesn't provide one.
     * @type {string}
     */

    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR'; //Initial status

    $scope.status = 'checkingToken';
    $scope.lastErrorMsg = '';
    $scope.userBasicData = {};
    /**
     * Send the request to set the user password for the first time and, in case of success, the user is redirect
     * to his dashboard.
     */

    $scope.sendCreatePassword = function () {
      var model = $scope.passwordModel;
      $scope.settingPasswordPromise = orbaSession.loginSettingPasswordWithToken($scope.token, model).then($scope.onSendPasswordSuccess, $scope.showError)["catch"]($scope.showError);
    };
    /**
     * Function to be called when the confirmation of the set of new password is received.
     */


    $scope.onSendPasswordSuccess = function () {
      //TODO The success message is hardcoded
      toaster.success('Your password has been set');
      var login = $scope.userBasicData.username;
      var password = $scope.passwordModel.password;
      return orbaSession.login(login, password).then(function () {
        $state.go($scope.afterFinishGoTo, {
          reload: true
        });
      })["catch"]($scope.showError);
    };
    /**
     * Show a error message.
     * @param {string} msg
     */


    $scope.showError = function (msg) {
      $scope.lastErrorMsg = msg ? msg : $scope.defaultErrorMsg;
    };
    /**
     * Clear the error message.
     */


    $scope.dismissError = function () {
      $scope.lastErrorMsg = '';
    };
    /**
     * Return welcome text from magento
     * @returns {string}
     */


    $scope.getWelcomeText = agreementBlocks.getWelcomeText;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getRulesLabel = agreementBlocks.getRulesLabel;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getRulesContent = agreementBlocks.getRulesContent;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getNotificationsLabel = agreementBlocks.getNotificationsLabel;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getNotificationsContent = agreementBlocks.getNotificationsContent;

    if (angular.isString($scope.token) && $scope.token.length > 0) {
      /*
       * Checking if the token given is valid and receive basic user info in the response.
       * The result is saved in the variable userBasicData in the scope.
       * Also, the status will change depending of the response.
       */
      orbaSession.checkAccountConfirmationTokenValidity($scope.token).then(function onSuccess(userBasicData) {
        $scope.userBasicData = userBasicData;
        $scope.status = 'tokenValid';
      }, function onFailure() {
        $scope.status = 'tokenInvalid';
      });
    } else {
      /*
       * In case no token is given the login form is shown.
       */
      toaster.error('The token given is not valid');
      orbaLoginEnforce.showLoginForm();
    }
  }]);
})(angular.module('app'), angular);
"use strict";

/**
 * @ngdoc directive
 * @name sgLoginForm
 * @restrict E
 * @description
 * Login form which start the login request.
 *
 * Note: This UI include a link to try recover a forgotten password.
 *
 * onError: will show a notification to the user.
 * onSuccess: will do nothing.
 *
 * @author daniel.zegarra@orba.co
 */
(function (module) {
  'use strict';

  module.component('sgLoginForm', {
    templateUrl: 'app/auth/components/form.html',

    /*@ngInject*/
    controller: ["$scope", "orbaSession", "$state", function ($scope, orbaSession, $state) {
      var scope = $scope;
      /**
       * Translation ID of the error message by default if the server doesn't provide one.
       * @type {string}
       */

      scope.defaultErrorMsg = 'GLOBAL.LOGIN_ERROR';
      scope.errorMsg = '';
      scope.sessionSvc = orbaSession;
      /**
       * Try to authenticate using the credentials currently in the model object.
       */

      scope.login = function () {
        scope.dismissError();

        if (scope.form.$valid === true) {
          scope.loginRequestPromise = orbaSession.login(scope.username, scope.password).then(function () {
            $state.go('home');
          })["catch"](showError);
          clearPassword();
        }
      };
      /**
       * Clear the form.
       */


      function clearAll() {
        scope.username = '';
        scope.password = '';
        scope.dismissError();
      }

      function clearPassword() {
        scope.password = '';
      }
      /**
       * Show an authentication error.
       * @param {string} msg
       */


      function showError(msg) {
        scope.errorMsg = msg ? msg : scope.defaultErrorMsg;
      }
      /**
       * Hide a previous authentication error.
       */


      scope.dismissError = function dismissError() {
        scope.errorMsg = '';
      };

      clearAll();
    }]
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('articlesResource', ["$resource", "$http", "articlesConfig", "moment", "resourceQueryPaginator", "$sce", function ($resource, $http, articlesConfig, moment, resourceQueryPaginator, $sce) {
    var paginator = resourceQueryPaginator();
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */

    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.created_at = moment(srcItem.created_at).toDate();
      item.content = $sce.trustAsHtml(srcItem.content);
      return item;
    };
    /**
     * Process a response for a request of a single row.
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformSingle = function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.article || data) : data;
    };
    /**
     * Process a response for a request of multiple rows.
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformMultiple = function transformMultiple(data) {
      return angular.isObject(data) ? (data.articles || data).map(transformItem) : data;
    };

    var resource = $resource(articlesConfig.restful.news, {
      id: '@id',
      category: '@category'
    }, {
      //Collection of items
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: paginator.addTransformTo($http.defaults.transformResponse.concat(transformMultiple))
      },
      //Single item
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      }
    }); // Apply pagination to resource query

    paginator.applyToResource(resource, 'query');
    return resource;
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for list of articles
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('articlesListCtrl', ["$scope", "$state", "toaster", "articlesResource", "articlesConfig", "paginationManager", function articlesListCtrl($scope, $state, toaster, articlesResource, articlesConfig, paginationManager) {
    $scope.category = $state.params.category;
    /**
     * Retrieve articles list
     */

    $scope.paginator = paginationManager($scope, 'articles', articlesResource.query);
    $scope.paginator.limit = articlesConfig.list.pageSize;
    $scope.paginator.page = 1;
    $scope.paginator.category = $scope.category;
    $scope.title = 'ARTICLES.' + $scope.category + '.SECTION';
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for single article
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('articlesItemCtrl', ["$scope", "$state", "toaster", "articlesResource", function articlesItemCtrl($scope, $state, toaster, articlesResource) {
    /**
     * Article id
     * @type {string}
     */
    var articleId = $state.params.id;
    $scope.category = $state.params.category;
    /**
     * Retrieve article content
     */

    $scope.item = articlesResource.get({
      id: articleId
    });
    $scope.item.$promise.then(function () {
      $state.current.ncyBreadcrumbLabel = $scope.item.title;
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name app.service:logoSelector
   * @description Show a modal component to update the logo of the current distributor.
   */

  resellerLogoUpdater.$inject = ["orbaSession", "$uibModal", "toaster"];
  module.factory('resellerLogoUpdater', resellerLogoUpdater);
  /*@ngInject*/

  function resellerLogoUpdater(orbaSession, $uibModal, toaster) {
    /**
     * Show the selector of the new logo.
     */
    var show = function show() {
      $uibModal.open({
        templateUrl: 'app/account/partials/logo/modalSelector.html',
        controller: 'resellerLogoUpdaterCtrl',
        controllerAs: 'vm'
      }).result.then(function (newLogoUrl) {
        updateSessionData(newLogoUrl);
        toaster.success('ACCOUNT.LOGO_HAS_BEEN_UPDATED');
      });
    };
    /**
     * Update the url of the logo in the session information data.
     * @param {string} newLogoUrl URL of the new logo image
     */


    var updateSessionData = function updateSessionData(newLogoUrl) {
      if (orbaSession.isLoggedIn()) {
        orbaSession.info.user.reseller.logo = newLogoUrl;
      }
    };

    return {
      show: show
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc service
   * @name addressEditorModalLauncher
   * @module app
   * @description
   * Service to show a modal window for edit a specific address.
   */

  addressEditorModalLauncher.$inject = ["$uibModal", "$rootScope"];
  module.service('addressEditorModalLauncher', addressEditorModalLauncher);
  /*@ngInject*/

  function addressEditorModalLauncher($uibModal, $rootScope) {
    /**
     * @name show
     * @description
     * Show the modal editor.
     * @param {addressesResource} model address model
     * @return {Promise}
     */
    var show = function show(model) {
      var scope = $rootScope.$new(true);
      scope.model = angular.copy(model);
      return $uibModal.open({
        size: 'sm',
        windowClass: 'center-modal-child',
        //Template to encapsulate the component
        template: '<div class="modal-body">' + '<h3 translate>ACCOUNT.EDIT_ADDRESS</h3>' + '<sg-account-address-form model="model" allow-set-as-default="false" on-saved="$close(model)" on-cancel="$dismiss()"></sg-account-address-form>' + '<div class="close-button">' + '<button type="button" class="close" ng-click="$dismiss()" ng-attr-title="{{\'GLOBAL.CLOSE\'|translate}}" ng-attr-aria-label="{{\'GLOBAL.CLOSE\'|translate}}">' + '</button>' + '</div>' + '</div>',
        scope: scope
      }).result;
    };

    return {
      show: show
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('usersResource', ["$resource", "$http", "accountConfig", "resetPassResource", function ($resource, $http, accountConfig, resetPassResource) {
    var idField = 'entity_id';
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */

    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.entity_id = parseInt(item.entity_id, 10);
      item.role = parseInt(item.role, 10);
      item.fullname = item.firstname + ' ' + item.lastname;

      if (item.mailer_allow === true || parseInt(item.mailer_allow, 10) === 1) {
        item.mailer_allow = true;
      } else {
        item.mailer_allow = false;
      }

      return item;
    };
    /**
     * Process a response for a request of a single row.
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformSingle = function transformSingle(data) {
      return angular.isObject(data) ? transformItem(data.user || data) : data;
    };
    /**
     * Process a response for a request of multiple rows.
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformMultiple = function transformMultiple(data) {
      return angular.isObject(data) ? (data.users || data).map(transformItem) : data;
    };
    /**
     * Remove user login from request
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformUpdate = function transformUpdate(srcItem) {
      var item = angular.copy(srcItem);
      delete item.username;
      return JSON.stringify(item);
    };

    var resource = $resource(accountConfig.restful.users, {
      id: '@entity_id'
    }, {
      //Collection of items
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: $http.defaults.transformResponse.concat(transformMultiple)
      },
      //Single item
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Creation
      'save': {
        method: 'POST',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Update
      'update': {
        method: 'PUT',
        isArray: false,
        transformRequest: transformUpdate,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      }
    });
    /**
     * @ngdoc method
     * @name isPhantom
     * @description
     * Returns TRUE if the element doesn't have an ID yet.
     * @returns {boolean}
     */

    resource.prototype.isPhantom = function () {
      return !(this.hasOwnProperty(idField) && angular.isNumber(this[idField]) && this[idField] > 0);
    };
    /**
     * Reset user's pass
     * @return {*}
     */


    resource.prototype.resetPass = function () {
      if (this.isPhantom()) {
        return $q.reject('User has no id');
      }

      var username = encodeURIComponent(this.username);
      return resetPassResource.post({
        login: username
      });
    };

    return resource;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('usersMeResource', ["$resource", "$http", "accountConfig", function ($resource, $http, accountConfig) {
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */
    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      return item;
    };

    var resource = $resource(accountConfig.restful.me, {}, {
      //Single item
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformItem)
      },
      //Creation
      'update': {
        method: 'PUT',
        isArray: false
      }
    });
    return resource;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('rolesResource', ["$resource", "$http", "lodash", "accountConfig", function ($resource, $http, lodash, accountConfig) {
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @param {*} key
     * @returns {object} Returns the item formatted
     */
    var transformItem = function transformItem(srcItem, key) {
      return {
        id: parseInt(key, 10),
        label: srcItem.label,
        description: srcItem.description
      };
    };

    return $resource(accountConfig.restful.roles, {}, {
      'query': {
        method: 'GET',
        isArray: true,

        /**
         * I make any transformation necessary to use this data in the app.
         * @param {object|object[]|string} data
         * @returns {object[]|string}
         */
        transformResponse: $http.defaults.transformResponse.concat(function (data) {
          return angular.isObject(data) ? lodash.map(data.roles || data, transformItem) : data;
        })
      }
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('resetPassResource', ["$resource", "$http", "accountConfig", "orbaSession", function ($resource, $http, accountConfig, orbaSession) {
    /**
     * transform reset pass
     * @param {object|string} data
     * @returns {object|string}
     */
    var transformResetPass = function transformResetPass(srcItem) {
      var item = {
        client_id: orbaSession.getClientId(),
        username: srcItem.login
      };
      return JSON.stringify(item);
    };

    return $resource(accountConfig.restful.resetPass, {}, {
      'post': {
        method: 'POST',
        transformRequest: transformResetPass
      }
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.factory('addressesResource', ["$resource", "$http", "jsUtils", "accountConfig", function ($resource, $http, jsUtils, accountConfig) {
    var idField = 'entity_id';
    var LABEL_MAXLENGTH = 35;
    /**
     * Set default label only on single item
     * @param {object} address
     */

    function fillDefaultLabel(address) {
      if ((!address.label || address.label.length <= 0) && !!address.company && address.company.length <= LABEL_MAXLENGTH) {
        address.label = address.company || '';
      }
    }
    /**
     * Correct the format of the properties of an model received from the server.
     *
     * @param {object} srcItem
     * @returns {object} Returns the item formatted
     */


    var transformItem = function transformItem(srcItem) {
      var item = angular.copy(srcItem);
      item.entity_id = parseInt(item.entity_id, 10);
      item.is_default_shipping = jsUtils.getBoolValue(item.is_default_shipping);
      fillDefaultLabel(item);
      return item;
    };
    /**
     * Process a response for a request of a single row.
     * @param {object|string} data
     * @returns {object|string}
     */


    var transformSingle = function transformSingle(data) {
      var item = angular.isObject(data) ? transformItem(data.address || data) : data;
      return item;
    };
    /**
     * Process a response for a request of multiple rows.
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformMultiple = function transformMultiple(data) {
      return angular.isObject(data) ? (data.addresses || data).map(transformItem) : data;
    };
    /**
     * Process a response for a request for default address
     * @param {object|object[]|string} data
     * @returns {object[]|string}
     */


    var transformDefault = function transformDefault(data) {
      return angular.isObject(data) ? transformItem(data.addresses[0] || data) : data;
    };

    var resource = $resource(accountConfig.restful.addresses, {
      id: '@entity_id'
    }, {
      //Collection of items
      'query': {
        method: 'GET',
        isArray: true,
        transformResponse: $http.defaults.transformResponse.concat(transformMultiple)
      },
      //Single item
      'get': {
        method: 'GET',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Default address
      'getdefault': {
        method: 'GET',
        isArray: false,
        params: {
          'filter[is_default_shipping]=1': '1'
        },
        transformResponse: $http.defaults.transformResponse.concat(transformDefault)
      },
      //Creation
      'save': {
        method: 'POST',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      },
      //Update
      'update': {
        method: 'PUT',
        isArray: false,
        transformResponse: $http.defaults.transformResponse.concat(transformSingle)
      }
    });
    /**
     * @ngdoc method
     * @name isPhantom
     * @description
     * Returns TRUE if the element doesn't have an ID yet.
     * @returns {boolean}
     */

    resource.prototype.isPhantom = function () {
      return !(this.hasOwnProperty(idField) && angular.isNumber(this[idField]) && this[idField] > 0);
    };

    resource.fillDefaultLabel = fillDefaultLabel;
    return resource;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.filter('resolveRoleName', ["rolesResource", function (rolesResource) {
    var roles = rolesResource.query();
    /**
     * Receive a role ID and returns its name.
     * @param {number} id
     * @returns {string}
     */

    var resolve = function resolve(id) {
      var name = 'Unknown';
      angular.forEach(roles, function (item) {
        if (item.id == id) {
          name = item.label;
        }
      });
      return name;
    };
    /**
     * Filter per se.
     * @param {number} id
     * @returns {string}
     */


    var filter = function filter(id) {
      if (roles.$resolved) {
        return resolve(id);
      } else {
        return '-';
      }
    };

    filter.$stateful = true;
    return filter;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgContactMozaic
   * @description Show information about a contact.
   */

  module.component('sgContactMozaic', {
    templateUrl: 'app/account/components/sgContactMozaic.html',
    controllerAs: 'vm',
    bindToController: true,
    bindings: {
      model: '<',
      title: '@'
    }
  });
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgAccountNavBar
   * @description Vertical navigation for with the item of the Account module.
   */

  sgAccountNavBarController.$inject = ["orbaSession"];
  module.component('sgAccountNavBar', {
    templateUrl: 'app/account/components/sgAccountNavBar.html',
    controller: sgAccountNavBarController,
    controllerAs: 'ctrl'
  });
  /*@ngInject*/

  function sgAccountNavBarController(orbaSession) {
    var vm = this;
    vm.session = orbaSession;
    /**
     * @ngdoc method
     * @name currentUserIsAdmin
     * @methodOf app.directive:sgAccountNavBar
     * @description Returns TRUE if the current user is an administrator
     * @returns {boolean} Returns TRUE/FALSE
     * TODO The admin rol ID is hardcoded
     */

    this.currentUserIsAdmin = function () {
      return parseInt(orbaSession.getTokenPayload().sgrol, 10) === 1;
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc component
   * @name sgAccountBalance
   * @module app
   * @description
   * Show the actual balance of the user account.
   */

  sgAccountBalance.$inject = ["$scope", "orbaSession"];
  module.component('sgAccountBalance', {
    templateUrl: 'app/account/components/sgAccountBalance.html',
    controller: sgAccountBalance,
    controllerAs: 'vm'
  });
  /*@ngInject*/

  function sgAccountBalance($scope, orbaSession) {
    var vm = this;
    vm.info = orbaSession.info;
    /**
     * @param {number}balance
     * @param {number}credit
     * @return {number}
     */

    function calcAmountAvailable(balance, credit) {
      return credit - balance;
    }

    $scope.$watchGroup(['vm.info.user.reseller.credit_level', 'vm.info.user.reseller.balance'], function (values) {
      if (isFinite(values[0]) && isFinite(values[1])) {
        vm.amountAvailable = calcAmountAvailable(values[1], values[0]);
      } else {
        vm.amountAvailable = null;
      }
    });
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgAccountAddressSelectionTable
   * @description
   * Show a table with addresses of the current account to select one of them.
   */

  sgAccountAddressSelectionTable.$inject = ["addressesResource", "addressEditorModalLauncher"];
  module.component('sgAccountAddressSelectionTable', {
    templateUrl: 'app/account/components/sgAccountAddressSelectionTable.html',
    controllerAs: 'vm',
    controller: sgAccountAddressSelectionTable,
    bindings: {
      /**
       * Function called when the user select a address.
       */
      onSelect: '&',

      /**
       * Function called when the list finish the first load of data (first page).
       * Useful when a parent component wants to know when the table finish its resize.
       */
      onLoaded: '&'
    }
  });
  /*@ngInject*/

  function sgAccountAddressSelectionTable(addressesResource, addressEditorModalLauncher) {
    var vm = this;

    vm.$onInit = function () {
      vm.rows = addressesResource.query();
      vm.rows.$promise.then(vm.onLoaded);
    };
    /**
     * Inform the external container that the user has selected one address.
     * @param {addressesResource} model
     */


    vm.select = function (model) {
      if (angular.isFunction(vm.onSelect)) vm.onSelect({
        model: model
      });
    };
    /**
     * Open the modal editor to update the properties of the given address.
     * @param {addressesResource} model
     */


    vm.edit = function (model) {
      addressEditorModalLauncher.show(model).then(function (newModel) {
        Object.assign(model, newModel);
      });
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name sgAddressForm
   * @description
   * Show a form for edit or create a new address model.
   */

  sgAccountAddressForm.$inject = ["websocket", "$q"];
  module.component('sgAccountAddressForm', {
    templateUrl: 'app/account/components/sgAccountAddressForm.html',
    controllerAs: 'vm',
    controller: sgAccountAddressForm,
    bindings: {
      /**
       * Address model.
       * @type addressesResource
       */
      model: '=',

      /**
       * Indicate if the address model given is the currently default address for this account.
       * @type boolean
       */
      currentlyDefault: '<',

      /**
       * Indicate if allow the component to set this address as default.
       * TRUE by default.
       * @type boolean
       */
      allowSetAsDefault: '<',

      /**
       * Function called when the address model has been created or updated.
       */
      onSaved: '&',

      /**
       * Function called when the user press on the CANCEL button.
       */
      onCancel: '&'
    }
  });
  /*@ngInject*/

  function sgAccountAddressForm(websocket, $q) {
    var vm = this;
    /**
     * Array of calid postcodes
     * @type {Array}
     */

    vm.validCodes = [];
    /**
     * Variable which contain the last error message received.
     * @type {string}
     */

    vm.lastErrorMsg = '';
    /**
     * Error message by default if the server returns an error and don't detail the cause.
     * @type {string}
     */

    vm.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * Variable to flag if custom errors should be shown
     * @type {boolean}
     */

    vm.showErrors = false;

    vm.$onInit = function () {
      if (angular.isUndefined(vm.allowSetAsDefault)) {
        vm.allowSetAsDefault = true;
      }
    };
    /**
     * Return valid postcodes starting from given params
     * @param {string} postcode
     * @return {*[]}
     */


    vm.findPostCodes = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject(response.error);
          } else {
            vm.validCodes = response;
            resolve(response);
          }
        });
      });
    };
    /**
     * Checks if currently given postcode is valid
     * @param {string} postcode
     * @return {*}
     */


    vm.validatePostcode = function (postcode) {
      return $q(function (resolve, reject) {
        websocket.emit('account.getValidPostcodes', {
          postcode: postcode
        }, function (response) {
          if (Array.isArray(response) && response.indexOf(postcode) < 0) {
            reject(false);
          } else {
            resolve(true);
          }
        });
      });
    };
    /**
     * Return valid cities based on postcode, starting from given param
     * @param {string} city
     * @return {*[]}
     */


    vm.findCities = function (city) {
      return $q(function (resolve, reject) {
        if (!vm.model.postcode) {
          reject([]);
        }

        websocket.emit('account.getValidCities', {
          postcode: vm.model.postcode,
          city: city
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject([]);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Return valid streets based on postcode and city, starting from given param
     * @param {string} street
     * @return {*[]}
     */


    vm.findStreets = function (street) {
      return $q(function (resolve, reject) {
        if (!vm.model.postcode || !vm.model.city) {
          reject([]);
        }

        websocket.emit('account.getValidStreets', {
          postcode: vm.model.postcode,
          city: vm.model.city,
          street: street
        }, function (response) {
          if (response.hasOwnProperty('error')) {
            reject([]);
          } else {
            resolve(response);
          }
        });
      });
    };
    /**
     * Submit form - if valid then save address
     */


    vm.submitForm = function () {
      vm.showErrors = true;

      if (vm.accountAddressForm.$invalid) {
        return;
      }

      vm.save();
    };
    /**
     * Send the creation/update request to the server.
     */


    vm.save = function () {
      vm.dismissError();
      vm.requestPromise = vm.model.isPhantom() ? vm.model.$save() : vm.model.$update();
      vm.requestPromise.then(function (model) {
        if (angular.isFunction(vm.onSaved)) vm.onSaved({
          model: model
        });
        return model;
      }, function (response) {
        vm.showError(response.data);
      });
    };
    /**
     * Show an error in the screen.
     * @param {string} msg
     */


    vm.showError = function (msg) {
      msg = msg ? msg : vm.defaultErrorMsg;
      vm.lastErrorMsg = msg;
    };
    /**
     * Hide a previous authentication error.
     */


    vm.dismissError = function () {
      vm.lastErrorMsg = '';
    };
    /**
     * Inform the external container that the user wants to cancel the creation/update.
     */


    vm.cancel = function () {
      if (angular.isFunction(vm.onCancel)) vm.onCancel();
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  "use strict";
  /**
   * @ngdoc service
   * @name disagreementModal
   * @module account
   * @description
   * Service to show a modal window to confirm agreement removal
   */

  disagreementModal.$inject = ["$uibModal", "$rootScope"];
  module.service("disagreementModal", disagreementModal);
  /*@ngInject*/

  function disagreementModal($uibModal, $rootScope) {
    /**
     * Show the modal.
     *
     * @param {callable} callback
     * @param {Array} callbackArgs
     */
    var show = function show(callback, callbackArgs) {
      var modalScope = $rootScope.$new(true);
      modalScope.callback = callback;
      modalScope.callbackArgs = callbackArgs || [];
      modalScope.modalInstance = $uibModal.open({
        size: "md",
        windowClass: "center-modal-child",
        //Template to encapsulate the product summary component
        templateUrl: "app/account/components/disagreementModal.html",
        scope: modalScope
      });
      /**
       * On confirm button pressed, run callback
       */

      modalScope.accept = function () {
        if (typeof modalScope.callback === "function") {
          modalScope.callback.apply(modalScope.callback, modalScope.callbackArgs);
        }

        modalScope.modalInstance.close();
      };
    };

    return {
      show: show
    };
  }
})(angular.module("app"));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name app.controller:logoSelectorController
   * @description Controller for component to update the logo of the current distributor.
   */

  resellerLogoUpdaterCtrl.$inject = ["Upload", "$uibModalInstance", "accountConfig"];
  module.controller('resellerLogoUpdaterCtrl', resellerLogoUpdaterCtrl);
  /*@ngInject*/

  function resellerLogoUpdaterCtrl(Upload, $uibModalInstance, accountConfig) {
    var vm = this;
    vm.config = {
      /**
       * URL to send the logo image.
       */
      urlToUpload: '',

      /**
       * Size of the final image.
       * @link https://github.com/CrackerakiUA/ngImgCropFullExtended/wiki/Options#result-image-size
       */
      sizeInPx: 'max',

      /**
       * Aspect ratio used to crop the image.
       */
      aspectRatio: null
    };
    vm.file = '';
    vm.cropFile = '';
    vm.errorMsg = ''; //Reading configuration parameters

    if (accountConfig.hasOwnProperty('logo') && angular.isObject(accountConfig.logo)) {
      angular.extend(vm.config, accountConfig.logo);
    }
    /**
     * Starts the upload of the file.
     * @param {string} imageData
     */


    vm.upload = function (imageData) {
      Upload.upload({
        url: vm.config.urlToUpload,
        data: {
          logo: Upload.dataUrltoBlob(imageData, 'logo.jpg')
        }
      }).then(function (response) {
        if (angular.isObject(response.data) && response.data.hasOwnProperty('url')) {
          $uibModalInstance.close(response.data.url);
        } else {
          vm.showError('GLOBAL.SUCCESS_RESPONSE_IN_UNEXPECTED_FORMAT');
        }
      }, function (resp) {
        vm.showError(resp.data);
      });
    };
    /**
     * Show an error in the screen.
     * @param {string} msg
     */


    vm.showError = function (msg) {
      vm.errorMsg = msg || 'GLOBAL.UNKNOWN_ERROR';
    };
    /**
     * Clear the last error message from the screen.
     */


    vm.dismissError = function () {
      vm.errorMsg = '';
    };
  }
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name app.controller:loyaltyProgramCtrl
   * @description
   * Controller to show the contacts of the actual distributor.
   */

  /*@ngInject*/

  module.controller('loyaltyProgramCtrl', ["orbaSession", "blocksResource", function (orbaSession, blocksResource) {
    var vm = this;
    /**
     * Contact block id
     * @type {string}
     */

    vm.blockId = 'loyalty_program';
    /**
     * Retrieve block content
     */

    vm.block = blocksResource.get({
      id: vm.blockId
    });
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for edit an existing client.
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('accountUpdateClientCtrl', ["$scope", "$state", "toaster", "usersResource", "rolesResource", function accountUpdateClientCtrl($scope, $state, toaster, usersResource, rolesResource) {
    /**
     * Default success message.
     * @type {string}
     */
    $scope.defaultSuccessMsg = 'The client account has been updated';
    /**
     * Variable which contain the last error message received.
     * @type {string}
     */

    $scope.lastErrorMsg = '';
    /**
     * Error message by default if the server returns an error and don't detail the cause.
     * FIXME The default error message is hardcoded
     * @type {string}
     */

    $scope.defaultErrorMsg = 'An unknown error has just happened';
    /**
     * Catalog of roles.
     * @type {object[]}
     */

    $scope.roles = rolesResource.query();
    /**
     * New user model data.
     * @type {{}}
     */

    $scope.model = {};
    /**
     * Send the creation request to the server.
     */

    $scope.send = function () {
      $scope.dismissError();
      $scope.requestPromise = usersResource.save($scope.model).$promise.then(function (response) {
        toaster.success($scope.readResponseMessage(response.data, $scope.defaultSuccessMsg));
        $scope.goBack();
      }, function (response) {
        $scope.showError($scope.readResponseMessage(response.data, $scope.defaultErrorMsg));
      });
    };
    /**
     * Decode the string message sent by the server.
     * TODO This algorithm should be in a separate module
     * @param {object} response Response from the server
     * @param {string} [defaultMsg=null]
     * @returns {string}
     */


    $scope.readResponseMessage = function (response, defaultMsg) {
      var msg = defaultMsg || '';
      if (angular.isString(response)) msg = response;

      if (angular.isObject(response)) {
        if (response.hasOwnProperty('message')) msg = response.message;
        if (response.hasOwnProperty('msg')) msg = response.msg;
      }

      return msg || defaultMsg;
    };
    /**
     * Show an error in the screen.
     * @param {string} msg
     */


    $scope.showError = function (msg) {
      msg = msg ? msg : $scope.defaultErrorMsg;
      $scope.lastErrorMsg = msg;
    };
    /**
     * Hide a previous authentication error.
     */


    $scope.dismissError = function () {
      $scope.lastErrorMsg = '';
    };
    /**
     * Returns to the client list.
     */


    $scope.goBack = function () {
      $state.go('account.client.list');
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name app.controller:accountMyDataCtrl
   * @description
   * Controller to show the information of the current account.
   */

  /*@ngInject*/

  module.controller('accountMyDataCtrl', ["$state", "$scope", "disagreementModal", "orbaSession", "usersMeResource", "agreementBlocks", "toaster", function accountMyDataCtrl($state, $scope, disagreementModal, orbaSession, usersMeResource, agreementBlocks, toaster) {
    var vm = this;
    $scope.vm = vm;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getRulesLabel = agreementBlocks.getRulesLabel;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getRulesContent = agreementBlocks.getRulesContent;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getNotificationsLabel = agreementBlocks.getNotificationsLabel;
    /**
     * Return agreement text from magento
     * @returns {string}
     */

    $scope.getNotificationsContent = agreementBlocks.getNotificationsContent;
    $scope.usersMeResource = usersMeResource.get().$promise.then(function (data) {
      vm.info = {
        user: data
      };
    });
    /**
     * Update user mailer_allow param and agreements
     */

    vm.saveMailerAttr = function () {
      var payload = {
        mailer_allow: vm.info.user.user.mailer_allow ? 1 : 0,
        agreement_rules: vm.info.user.user.agreement_rules ? 1 : 0,
        agreement_notifications: vm.info.user.user.agreement_notifications ? 1 : 0
      };

      if (payload.agreement_rules === 0) {
        disagreementModal.show(vm.sendUpdate, [payload, true]);
      } else {
        vm.sendUpdate(payload, false);
      }
    };
    /**
     * Actually send an update to flags
     *
     * @param {object} payload
     * @param {boolean} doLogout
     */


    vm.sendUpdate = function (payload, doLogout) {
      usersMeResource.update(payload).$promise.then(function () {
        if (doLogout) {
          orbaSession.logout();
          $state.go('auth.login');
        }

        toaster.success('ACCOUNT.DATA_SAVED');
      }, function () {
        toaster.error('ACCOUNT.DATA_SAVE_ERROR');
      });
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name app.controller:accountLogoCtrl
   * @description
   * Controller to show and upload the current logo of the distributor.
   */

  /*@ngInject*/

  module.controller('accountLogoCtrl', ["orbaSession", "sessionAccess", "resellerLogoUpdater", function accountLogoCtrl(orbaSession, sessionAccess, resellerLogoUpdater) {
    var vm = this;
    vm.info = orbaSession.info;
    /**
     * Check if the current distributor has a logo image defined.
     * @returns {boolean}
     */

    vm.hasLogo = function () {
      if (vm.info.user && vm.info.user.reseller) {
        return angular.isString(vm.info.user.reseller.logo) && vm.info.user.reseller.logo.length > 0;
      }

      return false;
    };
    /**
     * Ask if the current user has permission to change the logo.
     * @returns {boolean}
     */


    vm.hasUploadPermissions = function () {
      return sessionAccess.isActionAllowed('logo.edit');
    };
    /**
     * Show the wizard to update the distributor logo.
     */


    vm.changeLogo = function () {
      resellerLogoUpdater.show();
    };
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for the view of the employees of an account.
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('accountEmployeeListCtrl', ["$scope", "lodash", "usersResource", "rolesResource", "toaster", function accountEmployeeListCtrl($scope, lodash, usersResource, rolesResource, toaster) {
    $scope.rows = usersResource.query();
    $scope.roles = rolesResource.query();
    $scope.pageLength = 10;
    $scope.displayedPages = 7;
    /**
     * Remove from the list all the users without ID.
     */

    $scope.clean = function () {
      lodash.remove($scope.rows, function (row) {
        return !row.hasOwnProperty('entity_id');
      });
    };
    /**
     * Reset user pass
     * @param {object} user
     */


    $scope.resetPass = function (user) {
      user.resetPass().$promise.then(function () {
        toaster.success('ACCOUNT.PASSWORD_CHANGED');
      }, function () {
        toaster.error('ACCOUNT.PASSWORD_CHANGE_FAILED');
      });
    };
    /**
     * Delete a user.
     * @param {number} id
     */


    $scope["delete"] = function (id) {
      var pk = {
        entity_id: id
      };
      var user = lodash.find($scope.rows, pk);
      user.$remove(null, function () {
        $scope.clean();
      });
    };
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for create a new employee.
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('accountEmployeeFormCtrl', ["$scope", "$state", "toaster", "usersResource", "rolesResource", "orbaSession", "$stateParams", function accountEmployeeNewCtrl($scope, $state, toaster, usersResource, rolesResource, orbaSession, $stateParams) {
    /**
     * Default success message.
     * @type {string}
     */
    $scope.defaultSuccessMsg = 'ACCOUNT.EMPLOYEE_SAVED';
    /**
     * Variable which contain the last error message received.
     * @type {string}
     */

    $scope.lastErrorMsg = '';
    /**
     * Error message by default if the server returns an error and don't detail the cause.
     * FIXME The default error message is hardcoded
     * @type {string}
     */

    $scope.defaultErrorMsg = 'GLOBAL.UNKNOWN_ERROR';
    /**
     * Catalog of roles.
     * @type {object[]}
     */

    $scope.roles = rolesResource.query();
    /**
     * Employee model data.
     * @type {{}}
     */

    $scope.model = new usersResource();
    /**
     * Retrieve employee data if edit mode
     */

    if ($stateParams.id) {
      $scope.roles.$promise.then(function () {
        $scope.requestPromise = usersResource.get({
          id: $stateParams.id
        }).$promise.then(function (model) {
          $scope.model = model;
          return model;
        }, function () {
          toaster.error('ACCOUNT.EMPLOYEE_NOT_REACHABLE');
          $scope.goBack();
        });
      });
    }
    /**
     * Session information.
     * @type {{session: {}, user: {}}}
     */


    $scope.sessionInfo = orbaSession.info;
    /**
     * Send the creation request to the server.
     */

    $scope.send = function () {
      if ($scope.form.$invalid) {
        return;
      }

      $scope.dismissError();

      if ($scope.model.isPhantom()) {
        $scope.requestPromise = usersResource.save($scope.model);
      } else {
        $scope.requestPromise = usersResource.update($scope.model);
      }

      $scope.requestPromise.$promise.then(function (response) {
        toaster.success($scope.readResponseMessage(response.data, $scope.defaultSuccessMsg));
        $scope.goBack();
      }, function (response) {
        $scope.showError($scope.readResponseMessage(response.data, $scope.defaultErrorMsg));
      });
    };

    $scope.validateEmail = function (email) {
      if (email === undefined || email === '' || email === null) {
        return true;
      }

      if (String(email).match(/^[0-9a-zA-Z\_\.\-\+]+?\@[0-9a-zA-Z\_\.\-]+?\.[a-zA-Z]{2,6}$/) === null) {
        return false;
      }

      return true;
    };
    /**
     * Decode the string message sent by the server.
     * TODO This algorithm should be in a separate module
     * @param {object} response Response from the server
     * @param {string} [defaultMsg=null]
     * @returns {string}
     */


    $scope.readResponseMessage = function (response, defaultMsg) {
      var msg = '';

      if (angular.isString(response)) {
        msg = response;
      }

      if (angular.isObject(response)) {
        if (response.hasOwnProperty('message')) {
          msg = response.message;
        }

        if (response.hasOwnProperty('msg')) {
          msg = response.msg;
        }
      }

      return msg || defaultMsg;
    };
    /**
     * Show an error in the screen.
     * @param {string} msg
     */


    $scope.showError = function (msg) {
      msg = msg ? msg : $scope.defaultErrorMsg;
      $scope.lastErrorMsg = msg;
    };
    /**
     * Hide a previous authentication error.
     */


    $scope.dismissError = function () {
      $scope.lastErrorMsg = '';
    };
    /**
     * Returns to the client list.
     */


    $scope.goBack = function () {
      $state.go('account.employee.list');
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc controller
   * @name app.controller:accountContactCtrl
   * @description
   * Controller to show the contacts of the actual distributor.
   */

  /*@ngInject*/

  module.controller('accountContactCtrl', ["orbaSession", "blocksResource", function (orbaSession, blocksResource) {
    var vm = this;
    vm.info = orbaSession.info;
    /**
     * Contact block id
     * @type {string}
     */

    vm.contactBlockId = 'contact_details';
    /**
     * Retrieve block content
     */

    vm.contactBlock = blocksResource.get({
      id: vm.contactBlockId
    });
  }]);
})(angular.module('app'));
"use strict";

/**
 * Controller for My addresses list
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('accountAddressesListCtrl', ["$scope", "lodash", "addressesResource", function accountAddressesListCtrl($scope, lodash, addressesResource) {
    $scope.rows = addressesResource.query();
    $scope.pageLength = 10;
    $scope.displayedPages = 7;
    /**
     * Delete address.
     * @param {number} id
     */

    $scope["delete"] = function (id) {
      var pk = {
        entity_id: id
      };
      var address = lodash.find($scope.rows, pk);
      address.$remove(function () {
        lodash.remove($scope.rows, address);
      });
    };
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * Controller for create/edit address
   */

  accountAddressesFormCtrl.$inject = ["$state", "$stateParams", "toaster", "addressesResource"];
  module.controller('accountAddressesFormCtrl', accountAddressesFormCtrl);
  /*@ngInject*/

  function accountAddressesFormCtrl($state, $stateParams, toaster, addressesResource) {
    var vm = this;
    /**
     * New address model data.
     * @type {{}}
     */

    vm.model = new addressesResource();
    /**
     * Default success message.
     * @type {string}
     */

    vm.defaultSuccessMsg = 'ACCOUNT.ADDRESS_HAVE_BEEN_SAVED';
    /**
     * Indicate if the currently address is the default address of this account (in the backend).
     * @type {boolean}
     */

    vm.currentlyDefault = false;
    /*
     * Retrieve address data if edit mode
     */

    if ($stateParams.id) {
      vm.requestPromise = addressesResource.get({
        id: $stateParams.id
      }).$promise.then(function (model) {
        vm.model = model;
        vm.currentlyDefault = model.is_default_shipping;
        return model;
      }, function () {
        toaster.error('ACCOUNT.ADDRESS_NOT_REACHABLE');
        vm.goBack();
      });
    }
    /**
     * Inform the user of the success of the action and return to the address list.
     */


    vm.onSaved = function () {
      toaster.success(vm.defaultSuccessMsg);
      vm.goBack();
    };
    /**
     * Returns to the addresses list.
     */


    vm.goBack = function () {
      $state.go('account.addresses.list');
    };
  }
})(angular.module('app'));
"use strict";

/**
 * @ngdoc module
 * @name orba.sg.product
 * @description
 * Module to allow access to product information, catalog search, product info widgets, etc.
 */
(function (module) {
  'use strict';
  /*
   * Runtime configuration
   */

  module.run(["$rootScope", "productCatalog", "$location", "$window", function ($rootScope, productCatalog, $location, $window) {
    /*
     * Clear the last product search filters used when the user go out from the product catalog.
     */
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
      //When the route change from a state from product's module to a state of another module
      if (fromState.name.indexOf('product.') >= 0 && toState.name.indexOf('product.') === -1) {
        productCatalog.keywords = '';
      } // Try to run Google analytics, if error - ignore.


      try {
        var locationPath = $location.path();
        var search = $location.search();

        if (search.s !== undefined) {
          locationPath += '?s=' + encodeURIComponent(search.s);
        }

        $window.ga('set', 'page', locationPath);
        $window.ga('send', 'pageview');
      } catch (err) {// Ignore error.
      }
    });
  }]);
})(angular.module('app'));
"use strict";

/**
 * This script implement the polyfill for the Object.assign function globally available JS engines with ES6 support.
 * Script taken from {@link https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Object/assign#Polyfill}.
 */
if (!Object.assign) {
  Object.defineProperty(Object, 'assign', {
    enumerable: false,
    configurable: true,
    writable: true,
    value: function value(target, firstSource) {
      'use strict';

      if (target === undefined || target === null) {
        throw new TypeError('Cannot convert first argument to object');
      }

      var to = Object(target);

      for (var i = 1; i < arguments.length; i++) {
        var nextSource = arguments[i];

        if (nextSource === undefined || nextSource === null) {
          continue;
        }

        var keysArray = Object.keys(Object(nextSource));

        for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
          var nextKey = keysArray[nextIndex];
          var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

          if (desc !== undefined && desc.enumerable) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }

      return to;
    }
  });
}
"use strict";

(function (module) {
  'use strict';
  /**
   * @ngdoc directive
   * @name app.directive:sgHeader
   * @description
   * Header of the application.
   * @author daniel.zegarra@orba.co
   */

  module.component('sgHeader', {
    templateUrl: 'app/header/templates/simple.html',
    controllerAs: 'vm',

    /*@ngInject*/
    controller: ["$rootScope", "$scope", "orbaSession", "orbaLoginEnforce", "blocksResource", "productCategory", "navigationConfig", "notifications", "$http", "$sce", function ($rootScope, $scope, orbaSession, orbaLoginEnforce, blocksResource, productCategory, navigationConfig, notifications, $http, $sce) {
      var vm = this;
      vm.session = orbaSession;
      vm.extended = navigationConfig.extended;
      vm.notification = null;
      var NOTIF_CLOSE_EVENT = 'notificationClosed';
      var HEADER_NOTIF_NEW_EVENT = 'headerNotificationFetched';
      /**
       * Close global notification
       */

      vm.closeNotification = function () {
        vm.notification = null;
        $rootScope.$emit(NOTIF_CLOSE_EVENT);
      };
      /**
       * Set notification to the newly loaded one
       */


      $rootScope.$on(HEADER_NOTIF_NEW_EVENT, function (e, notif) {
        vm.notification = notif;
        $http({
          method: 'GET',
          url: '/rest/message/template/' + vm.notification.template
        }).then(function successCallback(response) {
          vm.notification.designData = response.data;
        });
      });

      vm.showNotification = function () {
        return vm.session.isLoggedIn() && !!vm.notification;
      };
      /**
       * Logout.
       */


      vm.logout = function () {
        orbaSession.logout();
        orbaLoginEnforce.showLoginForm();
        getServicePhoneBlock();
      };
      /**
       * Service phone static block id
       * @type {string}
       */


      vm.servicePhoneId = 'service_phone';
      /**
       * Service category
       */

      $scope.categories = [];
      /**
       * Get category form node
       */

      function getCategory() {
        productCategory.getCategory().then(function (categories) {
          $scope.categories = categories;
        });
      }
      /**
       * Listening event
       */


      $scope.$on('authenticated', function () {
        loadCategory();
      });
      /**
       * Load category if need
       */

      function loadCategory() {
        if ($scope.categories.length === 0) {
          getCategory();
        }
      }
      /**
       * Stop propagation event
       */


      $scope.stopPropagationAndLoadCategory = function ($event) {
        loadCategory();

        if (angular.element(document.querySelector('body')).hasClass('uib-dropdown-open')) {
          $event.stopPropagation();
        }
      };
      /**
       *  Calculate position subcategory tab
       *
       * div-subcategory-tab, div-subcategory-container-list, title-subcategory, div-recommended-container-list and recommended-in-subcategory  is only tag name, this is not a component
       * find() can search only by tag name
       */


      $scope.calculatePosition = function ($event) {
        var element = angular.element($event.currentTarget);

        if (element.attr('calculated') === undefined) {
          var parentOffset = element.offsetParent().offset().top;
          var containerCategories = element.offsetParent().offsetParent();
          var itemOffset = element.offset().top;
          var itemHeight = element.height();
          var containerListSubcategories = element.find("div-subcategory-container-list");
          var containerRecommendedSubcategories = element.find("div-recommended-container-list");
          var categoryTitle = element.find("title-subcategory");
          var recommendedTitle = element.find("recommended-in-subcategory");
          var tabHeight = element.find("div-subcategory-tab").height();
          /**
           * 15px from margin bottom and 2px from border
           */

          containerListSubcategories.css('max-height', containerCategories.height() - categoryTitle.outerHeight(true) - 17 + 'px');
          containerRecommendedSubcategories.css('max-height', containerCategories.height() - recommendedTitle.outerHeight(true) - 17 + 'px');

          if (itemOffset - parentOffset + itemHeight > tabHeight) {
            element.addClass('small-subcategory');
          }

          element.attr('calculated', true);
        }
      };
      /**
       *  Close menu
       */


      $scope.closeMenu = function () {
        angular.element(document.querySelector('body')).removeClass('uib-dropdown-open');
        angular.element(document.querySelector('li.products')).attr('aria-expanded', false);
        angular.element(document.querySelector('li.products a')).attr('aria-expanded', false);
      };

      vm.hexToRgb = function (hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16);
      };

      $scope.renderHtml = function (html_code) {
        return $sce.trustAsHtml(html_code);
      };
      /**
       * Retrieve block content
       */


      function getServicePhoneBlock() {
        if (!vm.servicePhone) {
          vm.servicePhone = blocksResource.get({
            id: vm.servicePhoneId,
            client_id: orbaSession.getClientId()
          });
        }
      }

      if (!orbaSession.isLoggedIn()) {
        getServicePhoneBlock();
      }
    }]
  });
})(angular.module('app'));
"use strict";

angular.module('app').component('sgFooter', {
  templateUrl: 'app/footer/templates/basic.html',
  controllerAs: 'vm',

  /*@ngInject*/
  controller: ["orbaSession", function (orbaSession) {
    var vm = this;
    vm.session = orbaSession;
  }]
});
"use strict";

(function (module) {
  /**
   * Apply the "has-error" bootstrap class to the control when is mark as invalid (by angular).
   *
   * @link http://blog.yodersolutions.com/bootstrap-form-validation-done-right-in-angularjs/
   */
  module.directive('showInputErrors', function () {
    return {
      restrict: 'A',
      require: '^form',
      link: function link(scope, el, attrs, formCtrl) {
        // find the text box element, which has the 'name' attribute
        var inputEl = el[0].querySelector('[name]');

        if (inputEl) {
          // convert the native text box element to an angular element
          var inputNgEl = angular.element(inputEl); // get the name on the text box so we know the property to check
          // on the form controller

          var inputName = inputNgEl.attr('name'); // only apply the has-error class after the user leaves the text box

          var dirty = inputNgEl.attr('is-dirty');
          inputNgEl.bind('blur', function () {
            if (dirty === 'true') {
              el.toggleClass('has-error', formCtrl[inputName].$invalid && formCtrl[inputName].$dirty);
            } else {
              el.toggleClass('has-error', formCtrl[inputName].$invalid);
            }
          });
        }
      }
    };
  });
})(angular.module('app'));
"use strict";

/**
 * Component to show the logo image of the seller.
 * 
 * @author daniel.zegarra@orba.co
 */
(function (module) {
  'use strict';

  module.component('sgLogo', {
    templateUrl: 'app/directives/logo.html',

    /*@ngInject*/
    controller: ["$scope", function ($scope) {
      //TODO Logo URL hardcoded
      $scope.url = '/img/stalgast_logotyp_rgb.svg';
    }]
  });
})(angular.module('app'));
'use strict';

(function () {
  angular.module('app').directive('sgDisableInputScroll', function () {
    function link(scope, element) {
      element.on('wheel', function (e) {
        e.preventDefault();
      });
    }

    return {
      link: link
    };
  });
})();
'use strict';

(function () {
  /**
   * Code from https://github.com/dzegarra/angular-confirmable
   */
  angular.module('app').directive('confirmable', ['$timeout', function ($timeout) {
    return {
      restrict: 'AE',
      transclude: true,
      scope: {
        'textBefore': '@?',
        'textAfter': '@?',
        'unconfirmedText': '@',
        'confirmingText': '@',
        'confirmedText': '@?',
        'resetDelay': '@?',
        'whenConfirmed': '&',
        'classes': '@?',
        'disabled': '=?'
      },
      template: '<span ng-click="handleClick($event)" ng-transclude></span>',
      link: function link(scope, el, attr) {
        if (!scope.unconfirmedText) {
          throw new Error('Confirmable: unconfirmedText attribute was not defined and is required.');
        }

        if (!scope.confirmingText) {
          throw new Error('Confirmable: confirmingText attribute was not defined and is required.');
        }

        if (!scope.whenConfirmed()) {
          throw new Error('Confirmable: whenConfirmed action (function) was not defined and is required.');
        }

        var textBefore = scope.textBefore || '';
        var textAfter = scope.textAfter || '';
        var UNCONFIRMED = 'unconfirmed';
        var CONFIRMING = 'confirming';
        var CONFIRMED = 'confirmed';
        /* milliseconds */

        var REVERT_CONFIRM_DELAY = scope.resetDelay || 3000;
        var STATES = [UNCONFIRMED, CONFIRMING];

        if (scope.confirmedText) {
          STATES.push(CONFIRMED);
        }

        var INITIAL_STATE = STATES[0];
        var END_STATE = STATES[STATES.length - 1];
        var timer = null;

        var _state;

        var cancelEvent = function cancelEvent($event) {
          /* this blur event is only required for Firefox / Chrome to prevent sticky hover CSS after a click */
          var targetButton = el.find('button');
          targetButton.triggerHandler('blur');
          $event.preventDefault();
          $event.stopPropagation();
          return false;
        }; // methods


        scope.resetToInitialState = function () {
          setState(INITIAL_STATE);
        };

        scope.handleClick = function ($event) {
          if (scope.disabled) {
            return cancelEvent($event);
          } // times out to current state if no activity


          setTimerToRevertToState(getState());

          if (isState(UNCONFIRMED)) {
            setState(CONFIRMING);
            return cancelEvent($event);
          } else if (isState(CONFIRMING)) {
            unbindTimer(); // don't toggle confirmed state if there is no text change required

            if (STATES.indexOf(CONFIRMED) > -1) {
              setState(CONFIRMED);
            }

            scope.whenConfirmed()($event);
          }
        };

        var isState = function isState(expectedState) {
          return getState() === expectedState;
        };

        var getState = function getState(expectedState) {
          return _state;
        };

        var setTimerToRevertToState = function setTimerToRevertToState(futureState) {
          unbindTimer();
          timer = $timeout(function () {
            setState(futureState);
          }, REVERT_CONFIRM_DELAY, true);
        };

        var unbindTimer = function unbindTimer() {
          if (timer) {
            $timeout.cancel(timer);
          }
        };

        var setState = function setState(state) {
          _state = state;
          el.attr('confirmable-state', state);
          var text = textBefore + scope[state + 'Text'] + textAfter;
          el.find('confirmable-outlet').html(text);
          return getState();
        };

        scope.$on('$destroy', function () {
          unbindTimer();
        }); // initialisation

        setState(INITIAL_STATE); // if you disable a button for any reason, upon re-enabling it, it will reset to the initial button state

        scope.$watch('disabled', function (newValue, oldValue) {
          var wasLoading = oldValue === true;
          var isLoadingNow = newValue === true;

          if (wasLoading && !isLoadingNow) {
            scope.resetToInitialState();
          }
        });
      }
    };
  }]);
})();
"use strict";

/**
 * Controller of the home section.
 *
 * @author daniel.zegarra@orba.co
 */
(function (module) {
  /*@ngInject*/
  module.controller('homeCtrl', ["$rootScope", "$scope", "orbaSession", "articlesResource", "sessionAccess", "notifications", function ($rootScope, $scope, orbaSession, articlesResource, sessionAccess, notifications) {
    var FOOTER_NOTIF_NEW_EVENT = 'footerNotificationFetched';
    /**
     * Update user data
     */

    orbaSession.loadUserInfo().then(function () {
      $scope.userData = orbaSession.info;
    });
    $scope.access = sessionAccess.areActionsAllowed(['payments.index']);
    /**
     * Retrieve news from api
     */

    articlesResource.query({
      limit: 3,
      category: 'news'
    }, function (response) {
      if (response.length > 0) {
        $scope.news = response;
      }
    });
    /**
     * Set notification to the newly loaded one
     */

    $rootScope.$on(FOOTER_NOTIF_NEW_EVENT, function (e, notif) {
      $scope.notification = notif;
    });

    $scope.showNotification = function () {
      return orbaSession.isLoggedIn() && !!$scope.notification;
    }; // fetch footer message


    notifications.fetch('footer');
  }]);
})(angular.module('app'));
"use strict";

/**
 * Main controller of the application.
 */
(function (module) {
  'use strict';
  /*@ngInject*/

  module.controller('appCtrl', ["$rootScope", "$scope", "attributesService", "notifications", "$location", "gtmDataLayer", function appCtrl($rootScope, $scope, attributesService, notifications, $location, gtmDataLayer) {
    /**
     * Event onUserInfo is emit in orbaSession module
     */
    $rootScope.$on('onUserInfo', function (event, userInfo) {
      gtmDataLayer.push({
        'userLogin': userInfo.user.username,
        'userEmail': userInfo.user.email,
        'userName': userInfo.user.firstname,
        'userSurname': userInfo.user.lastname,
        'distributorId': userInfo.reseller.distributor_id
      });
      attributesService.get();
      notifications.fetch('header');
    });
    notifications.fetch('header');
    $rootScope.$on('$stateChangeSuccess', function () {
      gtmDataLayer.push({
        'locationPath': $location.path(),
        'cartName': '',
        'offerName': ''
      });
    });
  }]);
})(angular.module('app'));
"use strict";

/**
 * Configuration of the websocket support.
 *
 * @author daniel.zegarra@orba.co
 */
(function (module) {
  'use strict';
  /*
   * Configuring services
   */

  /*@ngInject*/

  module.config(["websocketProvider", "deployConf", function (websocketProvider, deployConf) {
    websocketProvider.setHost(deployConf.websocket.url);
    websocketProvider.setUrlRoute(deployConf.websocket.path);
  }]);
  /*
   * Start the connection after the user login.
   */

  /*@ngInject*/

  module.run(["$rootScope", "orbaSession", "websocket", function ($rootScope, orbaSession, websocket) {
    $rootScope.$on('onLogin', function () {
      var token = orbaSession.getToken();
      websocket.connect(token).then(function () {
        $rootScope.$broadcast('authenticated');
      })["catch"](function () {
        orbaSession.logout();
      });
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict'; //Configuring services

  /*@ngInject*/

  module.config(["$translateProvider", function ($translateProvider) {
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    $translateProvider.preferredLanguage('pl');
    $translateProvider.fallbackLanguage('en'); // $translateProvider.useMissingTranslationHandlerLog(); should not be active on production

    $translateProvider.translations('en', {
      GLOBAL: {
        'DEFAULT': 'Default',
        'USERNAME': 'Username',
        'PASSWORD': 'Password',
        'NAME': 'Name',
        'LAST_NAME': 'Last name',
        'FULLNAME': 'Fullname',
        'ADDR_LABEL': 'Address short name for delivery/ address label (max. 35 characters)',
        'ADDR_LABEL_LIST': 'Address short name for delivery/ address label',
        'EMAIL': 'E-mail',
        'ROLE': 'Rol',
        'LOGIN': 'Login',
        'LOGOUT': 'Logout',
        'CLOSE': 'Close',
        'CANCEL': 'Cancel',
        'CREATE': 'Create',
        'EDIT': 'Edit',
        'DELETE': 'Delete',
        'SUBMIT': 'Submit',
        'SAVE': 'Save',
        'YES': 'Yes',
        'NO': 'No',
        'ADD': 'Add',
        'ARE_YOU_SURE': 'Are you sure?',
        'SURE?': 'Sure?',
        'SELECT': 'Select',
        'SELECT_ALL': 'Select all',
        'DESELECT_ALL': 'Deselect all',
        'REMOVE': 'Remove',
        'REMOVE_SELECTION': 'Remove selected',
        'CONTACT': 'B2B Support',
        'PRODUCT': 'Product',
        'AVAILABLE': 'Available',
        'FIELD_REQUIRED_VALIDATION_MSG': 'Please enter a value for this field.',
        'FIELD_ALPHANUMERIC_VALIDATION_MSG': 'Just alphanumeric characters are allowed.',
        'EMAIL_REQUIRED_VALIDATION_MSG': 'This field must be a valid email address.',
        'GO_TO_URL': 'Go to {{url}}',
        'SEE_PDF_CATALOG': 'Start guide',
        'UNKNOWN_ERROR': 'An unknown error has just happened',
        'SUCCESS_RESPONSE_IN_UNEXPECTED_FORMAT': 'The application can\'t confirm the transaction. Please refresh the page.',
        'CREATION': 'Creation',
        'CREATOR': 'Creator',
        'LAST_UPDATE': 'Last update',
        'ALL': 'All',
        'SEE': 'See',
        'IMPORT_PRODUCTS': 'Convert in offer',
        'EXPORT_PRODUCTS': 'Convert in offer',
        'PHONE': 'Phone',
        'INFORMATION_UNAVAILABLE': 'Information not available',
        'PHONE_ABBR': 'tel.',
        'COMPANY': 'Company',
        'STREET': 'Street',
        'BUILDING': 'Building',
        'POSTAL_CODE': 'Postal code',
        'CITY': 'City',
        'GO_BACK': 'Go back',
        'LOADING_DATA': 'Loading data',
        'NEXT': 'Next',
        'PREV': 'Previous',
        'PAGE_SIZE': 'Count on page',
        'NEXT_MONTH': 'Next month',
        'PREV_MONTH': 'Previous month',
        'LIST_NOT_AVAILABLE': 'The list isn\'t available',
        'RETURNS_AND_COMPLAINTS': 'Returns and complaints',
        'READ_MORE': 'Read more',
        'STATUS': 'Status',
        'CREATION_FROM': 'Creation date from',
        'CREATION_TO': 'Creation date to',
        'SEARCH': 'Search',
        'CLEAR_FILTERS': 'Clear filters',
        'FILTER': 'Filter',
        'LOGGED': 'Logged',
        'NEWS': 'News',
        'COMMENTS': 'Comments',
        'LIST': 'List',
        'NEW': 'New',
        'UPDATE': 'Update',
        'FROM': 'from',
        'TO': 'do',
        'UNKNOWN': 'unknown',
        'SETTLEMENT': 'Settlement',
        'SELECT_EXISTENT': 'Select existent',
        'DATE_FORMAT_CODE': 'DD.MM.YYYY',
        'CURRENCY': 'Currency',
        'SAVE_TO_FILE': 'Save to file',
        'SAVE_TO_FILE_CSV': 'Save to csv file',
        'SAVE_TO_FILE_XLS': 'Save to xls file',
        'SAVE_TO_FILE_PDF': 'Save to pdf file',
        'INSERT_SKU': 'Enter',
        'RECOMMENDED': 'Recommended',
        'CATEGORY': 'Category',
        'DAYS': 'days',
        'DAY': 'day',
        'USERNAME_INFO': '',
        'LOGIN_USERNAME_POPUP': '',
        'LOGIN_PASSWORD_POPUP': '',
        'LOGIN_REMEMBER_PASSWORD_POPUP': '',
        'SHOWN_RESULTS': 'Shown results',
        'OF': 'of',
        'RETURNS_AND_COMPLAINTS_LIST': 'Complaints/ returns/ orders',
        'SHOW': 'Show',
        'DOWNLOAD_CARD_FOR_SELECTED': 'Download PDF cart for selected items',
        'DIMENSIONS': '(width x depth x height)',
        'UNIQUE_ITEMS': 'The number of different products in terms of performance',
        'TOTAL_QUANTITIES': 'The sum of the quantities of all products'
      },
      FURNITURE_OFFERS: {
        'ALLOWED_FILE_EXTENSIONS': 'Możliwe rozszerzenia: dwg, dxf, pdf, xlsx, xls, doc, docx, odt, ods, png, jpg.',
        'FURNITURE_OFFERS_REGISTRATION': 'Zarejestruj ofertę mebli',
        'SUBMIT': 'Wyślij zgłoszenie',
        'NEW_OFFER_TITLE': 'Nowe zapytanie o ofertę meblową',
        'NEW_OFFER_SUBTITLE': 'Nazwa zapytania (wybrana przez ciebie)',
        'CONTACT_DATA': 'Dane kontaktowe',
        'CONTACT_PERSON': 'Osoba kontaktowa',
        'PHONE': 'Telefon',
        'EMAIL': 'Adres email',
        'OFFER_PARAMETERS': 'Parametry zgłoszenia',
        'OFFER_TYPE': 'Typ zgłoszenia',
        'EXPECTED_DATE': 'Oczekiwany termin dostawy',
        'CONNECT_TO_ORDER': 'Połącz z zamówieniem',
        'ORDER_NUMBER': 'Numer zamówienia sprzedaży',
        'COMMENTS': 'Uwagi',
        'DELIVERY_ADDRESS': 'Adres dostawy',
        'CHOOSE_ADDRESS': 'Wybierz adres (ze zdefiniowanych, lub dodaj nowy)',
        'COMPANY': 'Firma',
        'ZIP_CODE': 'Kod pocztowy',
        'CITY': 'Miasto',
        'STREET': 'Ulica',
        'BULDING': 'Budynek',
        'EVALUATION': 'Wycena',
        'EVALUATION_ATTACH': 'Wycena wg listy z załącznika',
        'ORDER': 'Zamówienie',
        'ORDER_ATTACH': 'Zamówienie wg listy z załącznika',
        'PRODUCT_DIMENSIONS': 'Wymiary',
        'PRODUCT_DESCRIPTION': 'Opis',
        'PRODUCT_COMMENTS': 'Uwagi',
        'PRODUCT_UNIQUE_AMOUNT': 'Ilość pozycji',
        'PRODUCT_AMOUNT': 'Ilość sztuk łącznie',
        'LOGO_STALGAST': 'Logo Stalgast',
        'LOGO_EMPTY': 'Bez logo',
        'LOGO_OWN': 'Logo własne',
        'LOGO_TITLE': 'Logo na meblach',
        'FURNITURE': 'Meble'
      },
      AUTH: {
        'NO_REMEMBER_PASSWORD': 'Nie pamiętasz hasła?',
        'LOGGED_STATUS': 'You are currently logged in.',
        'VALIDATING_TOKEN_MSG': 'Validating your token...',
        'TOKEN_INVALID_MSG': 'Your token is invalid.',
        'WELCOME': 'Welcome to the B2B system of Stalgast!',
        'ACTIVATION_INSTRUCTIONS': 'This are the instruction for {{user.firstname}}. We encourage you to read it before you start.',
        'INFORMATION_OF_YOUR_ACCOUNT': 'Your account information is as follows:',
        'CHANGE_PASSWORD': 'Change your password',
        'NEW_PASSWORD': 'New password',
        'TYPE_NEW_PASSWORD': 'Type your new password',
        'REPEAT_NEW_PASSWORD': 'Repeat your new password',
        'ACTIVATE_ACCOUNT': 'Activate account',
        'SET_NEW_PASSWORD': 'Set your new password',
        'SAVE_PASSWORD': 'Save password',
        'RECOVER_PASSWORD_INSTRUCTIONS': 'Please enter your email address below. You will receive a link in your inbox to reset your password.',
        'PASSWORD_MIN_LENGTH_VALIDATION_MSG': 'Your password need to have at least {{minlength}} characters',
        'PASSWORD_NOT_EQUAL_VALIDATION_MSG': 'Remember that you have to repeat the same password',
        'RECOVERY_PASSWORD_PROCESS_START_CONFIRMATION': 'If your e-mail address is correct, you will receive a link to set a new password.',
        'ROUTE_ACCESS_RESTRICTED': 'The access to this section is restricted',
        'YOU_ARE_USING_FAILSAFE_ROLE': 'Your account has problems with your permissions. Please inform Stalgast about this issue.'
      },
      ACCOUNT: {
        'MY_ACCOUNT': 'My account',
        'MY_DATA': 'My data',
        'MY_LOGO': 'My logo',
        'MY_ADDRESS': 'My address',
        'CURRENT_LOGO': 'Current logo',
        'EMPLOYEES': 'Employees',
        'EMPLOYEES_LIST': 'Employees\'s list',
        'NEW_EMPLOYEE': 'New employee',
        'THERE_IS_NO_EMPLOYEES': 'You have not employees.',
        'CHANGE_PASSWORD': 'Change password',
        'MY_DATA_WELCOME': 'Below you can see the data recorded in the Stalgast systems. <br>In the case you need made changes to these data, please contact your sales representative.',
        'B2B_ADMINISTRATOR': 'B2B Administrator',
        'B2B_USER': 'B2B Reseller (You)',
        'RECIPIENT': 'Recipient',
        'ACCOUNT_MANAGER': 'Account Manager',
        'DEFAULT_SHIPPING_ADDRESS': 'Default shipping address',
        'CREDIT_LIMIT': 'Limit of credit',
        'PAYMENTS_TERMS': 'Terms of payment',
        'METHOD_OF_INVOICE_DELIVERY': 'Method of invoice delivery',
        'DELIVERY_METHOD': 'Delivery method',
        'CARRIER': 'Carrier',
        'CHOOSE_ROLE': 'Select a role',
        'NAME_TOO_SHORT_VALIDATION_MSG': 'The name chosen is to short',
        'LASTNAME_TOO_SHORT_VALIDATION_MSG': 'The last name chosen is to short',
        'CONTACT': 'Contact',
        'STALGAST_CONTACT': 'Contact person in Stalgast',
        'REGIONAL_SALES_MANAGER': 'Regional Manager Sales',
        'SERVICE_COORDINATOR': 'Service Coordinator',
        'DEALER': 'Dealer',
        'B2B_STALGAST_HELP': 'B2B Stalgast Help',
        'PLEASE_SEND_YOUR_FEEDBACK_TO': 'Please send your comments or ideas of how to improve this system to:',
        'NO_LOGO_MSG': 'This distributor doen\'t have a logo yet.',
        'UPLOAD_LOGO': 'Upload logo',
        'CHANGE_LOGO': 'Change logo',
        'SELECT_NEW_LOGO': 'Select a new logo',
        'PRESS_HERE_TO_SELECT_FILE': 'Press here to select a file',
        'OR_DROP_FILE_HERE': 'or drop it here',
        'LOGO_HAS_BEEN_UPDATED': 'The distributor logo has been updated',
        'THERE_ARE_NO_ADDRESSES': 'There are no addresses matching given criteria',
        'NEW_ADDRESS': 'New address',
        'EDIT_ADDRESS': 'Edit address',
        'ADDRESS_HAVE_BEEN_SAVED': 'Address have been saved',
        'ADDRESS_NOT_REACHABLE': 'There was a problem retrieving the address. Please try again.',
        'EDIT_SETTINGS': 'Edit account settings',
        'SET_AS_DEFAULT_DELIVERY': 'Set as default delivery address',
        'DEFAULT_DELIVERY': 'Default delivery address',
        'CONTACT_IN_DELIVERY_PLACE': 'Contact in delivery\'s place',
        'FILL_ADDR_LABEL': 'Fill short name for delivery/ address label',
        'LOYALTY_PROGRAM': 'Loyalty program'
      },
      CART: {
        'CART': 'Cart',
        'CARTS': 'Carts',
        'SHOPPING_CARTS_LIST': 'Shopping carts',
        'SHOPPING_CARTS': 'Shopping carts',
        'NAME': 'Cart name',
        'PRODUCT_COUNT': 'Product count',
        'NEW': 'New cart',
        'CREATE_NEW': 'Create new cart',
        'THERE_IS_NO_CARTS': 'There is not carts.',
        'LIST_NOT_AVAILABLE': 'The cart list can\'t be obtain.',
        'CONVERT_IN_OFFER': 'Convert in offer',
        'RECALCULATE_AND_UPDATE_AVAILABILITY': 'Convert and update availability',
        'TYPE_NEW_NAME': 'Type cart\'s name',
        'CREATION_SUCCESS_MSG': 'The cart has been created',
        'CREATION_FAILURE_MSG': 'The cart couldn\'t be created',
        'UPDATE_SUCCESS_MSG': 'The cart has been updated',
        'UPDATE_FAILURE_MSG': 'The cart couldn\'t be updated',
        'DELETE_SUCCESS_MSG': 'The cart has been deleted',
        'DELETE_FAILURE_MSG': 'The cart couldn\'t be deleted',
        'PRODUCT_ALREADY_IN_CART': 'This product is already in your cart',
        'ITEM_POSITION': 'Pos.',
        'SKU': 'Nr.kat.',
        'PRODUCT': 'Product',
        'PRICE_OF_LIST': 'Price in catalog (net)',
        'QUANTITY': 'Quantity (unit)',
        'WAREHOUSE': 'Warehouse',
        'AVAILABILITY': 'Availability',
        'YOUR_DISCOUNT': 'Your discount',
        'DISCOUNT_GROUP': 'Discount group',
        'PROMO_PRICE': 'Promotion price',
        'YOUR_PRICE': 'Your price',
        'BOTH_PRICES': 'Prices (net)',
        'REMOVE': 'Remove',
        'REMOVE_IN_PROGRESS': 'Removing...',
        'AVAILABLE': 'Available',
        'NOT_AVAILABLE_HELPTEXT': 'Product in stock,\n' + 'ordered quantity\n' + 'requires confirmation.',
        'NOT_AVAILABLE_ON_ORDER': 'Product on order,\n' + 'ordered quantity\n' + 'requires confirmation.',
        'ALL': 'All',
        'NET_AMOUNT': 'Net amount',
        'GROSS_AMOUNT': 'Gross amount',
        'CHECKOUT': 'Checkout',
        'CART_IS_EMPTY': 'Cart is empty',
        'PRICE_OF_LIST_HELPTEXT': 'In the case of the promotion list price is crossed out, and below it is given the current catalog promotional price.',
        'AVAILABILITY_HELPTEXT': 'Availability shows how much of the ordered pieces from the "Number" is currently available.',
        'YOUR_DISCOUNT_HELPTEXT': 'The rebate is calculated in relation to the list price, or if the promotion is valid, then the current catalog promotional price, which is given under the crossed list price. After the dash is presented indication of the discount to which the product belongs.',
        'QTY_INCREMENT_ERROR': 'Quantity must be a multiple of {{qtyIncrements}}',
        'CURRENT_ACTIVE': 'Current active cart',
        'SELECT_CURRENT_ACTIVE': 'Select or create a new cart',
        'COUNT': 'Carts count',
        'CONVERT_TO_OFFER': 'Convert to offer',
        'CANT_BE_CONVERTED_TO_OFFER': 'Only carts with items can be converted in offers',
        'ADD_TO_CART': 'Add to cart',
        'SELECT_CART': 'Select cart',
        'DELIVERY_DATE': 'Planned delivery date:',
        'DELIVERY_ORDER': 'Products on request. Realization time',
        'ERROR_BANNED': 'The account has been blocked. Please contact your commercial Counsellor.'
      },
      OFFER: {
        'NEW': 'New offer',
        'CREATE_NEW': 'Create new offer',
        'COUNT': 'Offers count',
        'LIST': 'Offers list',
        'OFFERS': 'Offers',
        'NAME': 'Offer name',
        'BRAND': 'Brand',
        'OFFER_LIST': 'Offers list',
        'THERE_IS_NO_OFFERS': 'There is no offers',
        'THERE_IS_NO_MATCH_OFFERS': 'No offers match the current criteria',
        'PRODUCT_COUNT': 'Product count',
        'NET_AMOUNT': 'Net amount',
        'PRICE': 'Price',
        'CREATE': 'Start offer',
        'UPDATE': 'Save offer in my account',
        'REFER_DETAILS': 'Details of the person who make the proposal',
        'ADD_PRICES': 'Add prices',
        'ADD_DISCOUNTS': 'Add catalog prices and discounts',
        'ADD_IMAGES': 'Add images',
        'ADD_DESCRIPTIONS': 'Add descriptions',
        'HIDE_STALGAST_ITEMS': 'Hide Stalgast items',
        'ADD_CUSTOMER_LOGO': 'Add customer logo',
        'ADD_STALGAST_LOGO': 'Add Stalgast logo',
        'OPTIONS_TITLE': 'VISIBLE ITEMS IN OFFER <small>(Select what should be included in the offer sent to your customer)</small>',
        'FILE_TYPE': 'File format',
        'FILE_TYPE_PDF': 'PDF',
        'FILE_TYPE_XLSX': 'Excel',
        'PLANNED_DELIVERY_ADDRESS': 'Planned delivery address',
        'DISCOUNT_OFFER': 'Discount offer',
        'PRODUCTS_OUTSIDE_STALGAST': 'Products outside of the Stalgast offer',
        'APPLY_TO_THE_SELECTED_ROWS': 'Apply to the selected rows',
        'CREATION_SUCCESS_MSG': 'The offer has been created',
        'CREATION_FAILURE_MSG': 'The offer couldn\'t be created',
        'UPDATE_SUCCESS_MSG': 'The offer has been updated',
        'UPDATE_FAILURE_MSG': 'The offer couldn\'t be updated',
        'DELETE_SUCCESS_MSG': 'The offer has been deleted',
        'DELETE_FAILURE_MSG': 'The offer couldn\'t be deleted',
        'PRODUCT_ALREADY_IN_OFFER': 'This product is already in your offer',
        'PRODUCTS_OF_STALGAST': 'Products of Stalgast in teh offer',
        'CONVERT_TO_CART': 'Convert to cart',
        'CANT_BE_CONVERTED_TO_CART': 'Only offers with items can be converted in shopping carts',
        'DOWNLOAD_FILE': 'Update and download file',
        'ADD_EXTENDED_OFFERS': 'Add products outside the Stalgast offer',
        'SHOW_EXTENDED_OFFERS': 'Show products outside the Stalgast offer',
        'HIDE_EXTENDED_OFFERS': 'Hide products outside the Stalgast offer',
        'CURRENCY': '$',
        'IGNORE_PROMO_PRICE': 'Ignore promotional price',
        'PRICE_BELOW_PURCHASE_PRICE': 'Warning! Price is below the purchase price!',
        'OFFER_NOT_AVAILABLE': 'Cannot load offer, offer does not exist.'
      },
      PRODUCT: {
        'FILTERS': 'Filters',
        'PRODUCT_LIST': 'Product list',
        'LIST_PRICE': 'List price',
        'YOUR_PRICE': 'Your price',
        'PROMO_PRICE': 'Promotion price',
        'ADD_TO_CART': 'Add to cart',
        'ADD_SELECTION_TO_CART': 'Add selection to cart',
        'PROMOTION': 'Promotion -{{discount}}%',
        'CODE': 'Nr.kat.',
        'BRAND': 'Brand',
        'LINE': 'Line',
        'NET': 'net',
        'PRODUCT_AVAILABLE': 'Product available',
        'PRODUCT_UNAVAILABLE': 'Product unavailable',
        'PRODUCT_ON_ORDER': 'Product on order',
        'DO_NOT_HAVE_ATTRIBUTES': 'This product doesn\'t have attributes.',
        'PRODUCTS': 'Products',
        'VIEW_INFO_TOOLTIP': 'View product information',
        'ABBR': 'prd.',
        'QTY_INCREMENTS_INFO': '{{qty}} pcs in box (given price for 1 pc)',
        'SEE_ALL': 'see all',
        'CATEGORY-UP': 'Go to parent category',
        'CLEAR_FILTERS': 'Remove all filters',
        'CLEAR_FILTER': 'Remove filter',
        'DOWNLOAD_CARD': 'Download PDF product card',
        'GUARANTEE_PERIOD_MONTHS': 'guarantee periond [in months]: {{guaranteePeriod}}',
        'QUICK_INFO': 'Product quick information',
        'SELECT_PRODUCT_FIRST_MSG': 'You have to select a product first.',
        'PRODUCT_DOESNT_EXIST_MSG': 'Cannot load product, product does not exist.'
      },
      ORDER: {
        'HISTORY': 'Orders history',
        'LAST_ORDER': 'Last order',
        'COUNT': 'Orders count',
        'ORDERING': 'Ordering',
        'NAME_OF_ORDER': 'Order\'s name',
        'SERVICE_REQUEST': ' Service request',
        'REFERENCE': 'Reference',
        'NOTE': 'Note',
        'SHIPPING_DATE': 'Shipping date',
        'DELIVERY': 'Delivery',
        'DELIVERY_ADDRESS': 'Delivery address',
        'DELIVERY_METHOD': 'Delivery method',
        'PAYMENT_METHOD': 'Payment method',
        'CONTACT_IN_DELIVERY_PLACE': 'Contact in delivery\'s place',
        'ORDER_SUMMARY': 'Order\'s summary',
        'ORDER_NAME_HELPTEXT': 'The name is inherited from the name cart',
        'COMPLETE_ORDER': 'Complete order',
        'NO_QUOTE_WAS_FOUND': 'No quote information was found',
        'OFFER_NAME': 'Offer\'s name',
        'SERVICE_REQUEST_HELPTEXT': 'This information is printed on the invoice',
        'PAYMENT_AMOUNT': 'Payment amount',
        'Courier': 'Courier',
        'Courier cash on delivery': 'Courier cash on delivery',
        'courier_cod': 'Courier cash on delivery',
        'COURIER_COD_WITH_AMOUNT': 'Courier cash on delivery. <strong>COD amount {{cod_amount}}</strong>',
        'Self pickup': 'Self pickup',
        'Money transfer': 'Money transfer',
        'Cash on delivery': 'Cash on delivery',
        'cod': 'Cash on delivery',
        'COD_AMOUNT_LABEL': 'Cash on delivery amount in PLN (from {{min_cod_amount}} to {{max_cod_amount}})',
        'CONFIRMATION': {
          'TITLE': 'Confirmation',
          'HELLO': 'Dear User!',
          'THANKS': 'Thank you for submitting a subsequent order by the web-based B2B Stalgast.',
          'STATUS': 'The contract was forwarded to our accounting systems and storage and currently has a status of "Complex".',
          'STATUS_AFTER_BOOKED': 'After receiving confirmation of the booking of goods will change its status to "Reserved", which will be informed by e-mail.',
          'STATUS_LINK': 'Any information about this contract can be found here: Information on Contract <strong>No. {{code}}</strong> and are constantly updated.',
          'HISTORY_NOTE': 'NOTE: We remind you that the information about all the complex orders can be found in the "Order History", no matter what route were filed by both the B2B system, as well as by telephone, mail or fax.',
          'GOODBAY_LINE1': 'Sincerely,',
          'GOODBAY_LINE2': 'Team Stalgast'
        },
        'ORDER_ID': 'Order id',
        'LIST': 'Historia zamówień',
        'THERE_ARE_NO_ORDERS': 'There are no orders matching given criteria',
        'ORDERS': 'Orders',
        'SKU': 'Catalog number',
        'DELIVERY_STREET': 'Street',
        'DELIVERY_POSTCODE': 'Post code',
        'DELIVERY_CITY': 'City',
        'STATUSES': {
          'DELETE': 'Deleted',
          'CANCEL': 'Cancelled',
          'IN_PROGRESS': 'In progress',
          'COMPLETED': 'Completed',
          'INVALID': 'Invalid'
        },
        'STATUS': 'Order status',
        'B2B_ID': 'Order ID in B2B system',
        'ORDERED_ITEMS': 'Ordered items',
        'INFO': 'Order {{id}} info',
        'DETAILS': 'Order details',
        'QTY_ORDERED': 'Ordered',
        'QTY_RESERVED': 'Reservation',
        'QTY_SHIPPED': 'Shipped',
        'DELIVERY_DATE': 'Delivery date',
        'ADDRESS_CREATION_SUCCESS': 'The address has been added to your account',
        'ADDRESS_CREATION_FAILURE': 'Could not add the address to your account',
        'SAVE_ADDRESS': 'Add address to my account',
        'SHIPPING_LABEL_ID': 'Shipping label Id',
        'OFFER_DATE': 'Date of preparing the offer',
        'PDF_NOT_SHOW': '(Not visible on PDF and XLS)',
        'PDF_SHOW': '(Visible on PDF and XLS)',
        'NEW_ADDRESS': 'New address (clear fields)',
        'SET_DEFAULT_ADDRESS': 'Select default address'
      },
      FINANCES: {
        'SETTLEMENT': 'Settlment',
        'BALANCE': 'Balance',
        'OVERDUE': 'Overdue'
      },
      NEWS: {
        'THERE_ARE_NO_NEWS': 'There are no news',
        'NEWS': 'News',
        'NEWS_TITLE': 'Title',
        'SEE_ALL': 'See all news'
      },
      INVOICE: {
        'LIST': 'invoices',
        'INVOICE_NUMBER': 'Number',
        'ORDER': 'Order',
        'PAYER_ACCOUNT': 'Payer\' account',
        'NET_AMOUNT': 'Net amount',
        'TAX_AMOUNT': 'Tax amount',
        'GROSS_AMOUNT': 'Gross amount',
        'AMOUNT': 'Amount',
        'DUE_DATE': 'Due date',
        'PAYMENT_DATE': 'Payment date',
        'DOWNLOAD_PDF': 'Download PDF',
        'THERE_ARE_NO_RESULTS': 'There are no invoices matching given criteria'
      },
      PAYMENT: {
        'RECIPIENT_ID': 'Account',
        'RECIPIENT_NAME': 'Name',
        'ATTACHMENT': 'Attachment',
        'NAME': 'Name of transaction',
        'AMOUNT': 'Amount',
        'DEALER': 'Dealer',
        'PAYMENTS': 'Payments',
        'PAYMENT_DATE': 'Payment date',
        'THERE_ARE_NO_RESULTS': 'There are no result with this criteria'
      },
      ERRORS: {
        'POSTCODE': 'Invalid postal code',
        'REQUIRED': 'Field required',
        'CURRENT_DATE': 'Invalid date',
        'EMAIL': 'Invalid e-mail',
        'VALID_DATE': 'Enter valid date',
        'MAXSIZE': 'File too big',
        'COD_AMOUNT_RANGE': 'Kwota pobrania powinna wynosić od {{min_cod_amount}} do {{max_cod_amount}}'
      },
      SETTLE: {
        'TITLE': 'Open settlements',
        'HEADER': 'Detailed list of open settlements',
        'PAYMENT': 'Please transfer dues bank account',
        'SUBMIT': 'Amount to be settled',
        'DELAY': 'Days after the date',
        'AMOUNT': 'Amount to pay',
        'AMOUNT_SETTLE': 'Amount to settle',
        'ATTACHMENT_DATE': 'Date of the attachment',
        'DUE_DATE': 'Date of the due',
        'CASE_STATUS': 'Law status',
        'LAST_INVOICE': 'Date of last invoice',
        'LAST_PAYMENT': 'Date of last payment',
        'SETTLEMENT_EMAIL': 'Settlements/ returns/ compensations',
        'OVERDUE_PAYMENTS': 'Overdue payments',
        'PAYER_ACCOUNT': 'Payer account',
        'NAME': 'Transaction description',
        'DOCUMENT': 'Document',
        'EXPORT': 'Export to csv'
      },
      COMPLAINT: {
        'TITLE': 'List of complaints/ returns/ service orders',
        'ITEM_TITLE': 'Complaint/ Return/ service order',
        'COMPANY': 'Company (from return address)',
        'COMPANY_SHORT': 'Company',
        'NUMBER': 'Complaint number',
        'REQUEST_NUMBER': 'Request number',
        'ACCEPTANCE_DATE': 'Acceptance date',
        'FINISHED_DATE': 'Finished date',
        'PRODUCT_CODE': 'Product code',
        'REQUEST_TYPE': 'Request type',
        'COST_COVERED': 'Costs covered by',
        'COMPLAINT_PHASE': 'Complaint phase',
        'CHOOSE': 'Choose',
        'RETURN_ADDRESS': 'Address to send back/ intervention',
        'CONTACT': 'Contact',
        'ITEM_POSITION': 'Pos.',
        'WORK_TYPE': 'Work type',
        'CREATION_DATE': 'Creation date',
        'INFORMATIONS': 'Informations',
        'THERE_ARE_NO_ITEMS': 'No complaint/ service orders, were found',
        'EMPLOYEE': 'Sales representative',
        'QUANTITY': 'Quantity',
        'INVOICE': 'Invoice',
        'INVOICE_DATE': 'Invoice date',
        'COUNTRY': 'Country',
        'HISTORY': 'History of complaint/ return/ service order',
        'THERE_ARE_NO_HISTORY': 'This complaint/ service order has no history',
        'ALL': 'Show all',
        'COMPLAINT': 'Complaint',
        'PAIDREPAIR': 'Paid repair',
        'BACKSENT': 'Back sent',
        'SERVICE': 'Service',
        'EXCHANGE': 'Exchange',
        'SITECHECK': 'Site check',
        'INSPECTION': 'Inspection',
        'FROM': 'from',
        'TO': 'to',
        'DATE': 'Date',
        'ACTION': 'Action',
        'PROCESS': 'Process:'
      },
      ISSUE: {
        'ISSUES': 'Issues',
        'ISSUE': 'Issue',
        'TITLE': 'Issues and service requests',
        'TITLE_ITEM': ' Issue / service request',
        'TITLE_NEW': 'New issue / service request',
        'NEW_ISSUE': 'New Issue',
        'ISSUE_NAME': 'Issue name',
        'CHOOSE_ISSUE_NAME': 'Issue name (chosen by you)',
        'COMPANY': 'Company',
        'REQUEST_NUMBER': 'Issue number',
        'CREATION_DATE': 'Creation date',
        'FROM': 'from',
        'TO': 'to',
        'CREATED_BY': 'Created by',
        'ISSUE_PHASE': 'Issue phase',
        'THERE_ARE_NO_ITEMS': 'No issues and service requests were found',
        'PRODUCTS_QTY': 'Products quantity',
        'QTY': 'Quantity',
        'STREET': 'Street',
        'POSTAL_CODE': 'Postal code',
        'COUNTRY': 'Country',
        'CONTACT': 'Contact',
        'CONTACT_PERSON': 'Contact person',
        'PRODUCTS': 'Products',
        'ITEM_POSITION': 'Lp.',
        'COMPLAINT_NUMBER': 'Complaint number',
        'SKU': 'Catalog number',
        'PRODUCT_SKU': 'Product code',
        'NAME': 'Name',
        'WARRANTY': 'Warranty conditions',
        'WARRANTY_END_DATE': 'Warranty end date',
        'REQUEST_TYPE': 'Request type',
        'INVOICE': 'Invoice',
        'INVOICE_FULL_NUMBER': 'Invoice (full number)',
        'SERIAL_NUMBER': 'Serial number',
        'DEFECT_DESC': 'Defect description',
        'REQUEST': 'Request',
        'COMPLAINT': 'Complaint',
        'RETURN_ADDRESS': 'Address for referral / intervention',
        'CHOOSE_ADDRESS': 'Choose the address (from defined or add new one)',
        'SEND_NOTIFICATION': 'Send notifications',
        'NONE': 'None',
        'MAIL': 'E-mail',
        'ADD_PRODUCT': 'Add product',
        'CANCEL_ADD': 'Cancel adding',
        'SEND_ISSUE': 'Send issue',
        'NEXT_STEP': 'Next step',
        'ADD': 'Add',
        'STEP1': 'Step 1/2',
        'STEP2': 'Step 2/2',
        'INVOICE_NEED': 'This option requires invoice number',
        'DELETE_SUCCESS_MSG': 'Issue has been removed',
        'DELETE_FAILURE_MSG': 'Issue could not be removed',
        'ISSUE_ADD_SUCCESS': 'Issue has been successfully added',
        'ISSUE_ADD_FAILURE': 'Issue could not be added',
        'FILL_FORM': 'Fill all required form fields',
        'FILL_ITEMS': 'Issue must contain at least one item',
        'PRODUCT_ADD_SUCCESS': 'The product has been successfully added',
        'PRODUCT_ADD_FAILURE': 'The product could not be added',
        'PRODUCT_DELETE_SUCCESS': 'The product has been removed',
        'PRODUCT_DELETE_FAILURE': 'The product could not be removed',
        'DONT_HAVE_ANY_PRODUCTS': 'You have not added any products',
        'NEXT_STEP_FAILURE': 'Could not go to the next step',
        'REPAIR': 'Repair',
        'PARTS': 'Parts',
        'CORRECTION': 'Correction',
        'INSTALLATION': 'Montage',
        'TRAINING': 'Training',
        'EXCHANGE': 'Exchange',
        'SITECHECK': 'Site check',
        'INSPECTION': 'Inspection',
        'CANCELED': 'Canceled',
        'COMPLETED': 'Completed',
        'ERROR': 'Error',
        'IN_PROGRESS': 'In progress',
        'OK': 'Sent',
        'NEW': 'New',
        'RECEIVED': 'Received',
        'EDIT_PRODUCT': 'Edit product',
        'CANCEL_EDIT': 'Cancel edit',
        'SAVE_PRODUCT': 'Save product',
        'SAVE_ISSUE': 'Save issue',
        'EDIT': 'Edit',
        'CHECK': 'Check',
        'CHECK_SUCCESS': 'Issue is correct',
        'ISSUE_IS_LOCKED': 'Issue has been already sent',
        'PHONE_REQUIRED': 'must be filled before sending',
        'CREATE_SUCCESS': 'Issue successfully created',
        'SELECT_TYPE_FIRST': 'add an issue type firstly',
        'ATTACHMENTS': 'Attachments',
        'FILE_NAME': 'File name',
        'NO_ATTACHMENTS': 'No attachments for the product',
        'FILE_UPLOAD_ERROR': 'Error uploading file',
        'FILE_UPLOADED': 'Uploaded file',
        'FILE_UPLOADING': 'Uploading',
        'FILE_ERROR_TOO_BIG': 'File too big. Maximum file size is 100MB',
        'FILE_ERROR_TYPE': 'Wrong file type',
        'FILE_ERROR_UNKNOWN': 'Unknown upload error',
        'DOWNLOAD_ATTACHMENT': 'Download attachment'
      },
      NOTIFICATIONS: {
        'READ_MORE': 'Czytaj więcej'
      }
    });
    $translateProvider.translations('pl', {
      GLOBAL: {
        'DEFAULT': 'Domyślny',
        'USERNAME': 'Login',
        'PASSWORD': 'Hasło',
        'NAME': 'Imię',
        'LAST_NAME': 'Nazwisko',
        'FULLNAME': 'Imię i nazwisko',
        'ADDR_LABEL': 'Skrócona nazwa adresata dla kuriera/ nazwa adresu (do 35 znaków)',
        'ADDR_LABEL_LIST': 'Skrócona nazwa adresata dla kuriera/ nazwa adresu',
        'EMAIL': 'Adres e-mail',
        'ROLE': 'Uprawnienia',
        'LOGIN': 'Zaloguj się',
        'LOGOUT': 'Wyloguj',
        'CLOSE': 'Zamknij',
        'CANCEL': 'Anuluj',
        'CREATE': 'Utwórz',
        'EDIT': 'Edytuj',
        'DELETE': 'Usuń',
        'SUBMIT': 'Prześlij',
        'SAVE': 'Zapisz',
        'CONFIRM': 'Potwierdź',
        'YES': 'Tak',
        'NO': 'Nie',
        'ADD': 'Dodaj',
        'ARE_YOU_SURE': 'Czy jesteś pewien?',
        'SURE?': 'Jesteś pewien?',
        'SELECT': 'Wybierz',
        'SELECT_ALL': 'Zaznacz wszystko',
        'DESELECT_ALL': 'Odznacz wszystko',
        'REMOVE': 'Usuń',
        'REMOVE_SELECTION': 'Usuń zaznaczone',
        'CONTACT': 'Pomoc B2B',
        'PRODUCT': 'Produkt',
        'AVAILABLE': 'Dostępne',
        'FIELD_REQUIRED_VALIDATION_MSG': 'Pole wymagane',
        'FIELD_ALPHANUMERIC_VALIDATION_MSG': 'Dozwolone znaki: litery oraz cyfry',
        'EMAIL_REQUIRED_VALIDATION_MSG': 'Podaj prawidłowy adres e-mail.',
        'GO_TO_URL': 'Przejdź do {{url}}',
        'SEE_PDF_CATALOG': 'Poradnik na start',
        'UNKNOWN_ERROR': 'Wystąpił nieznany błąd',
        'SUCCESS_RESPONSE_IN_UNEXPECTED_FORMAT': 'Wystąpił błąd. Odśwież stronę i spróbuj ponownie.',
        'CREATION': 'Data utworzenia',
        'CREATOR': 'Utworzył',
        'LAST_UPDATE': 'Ostatnia modyfikacja',
        'ALL': 'Wszystko',
        'SEE': 'Zobacz',
        'IMPORT_PRODUCTS': 'Importuj produkty',
        'EXPORT_PRODUCTS': 'Eksportuj',
        'PHONE': 'Telefon',
        'INFORMATION_UNAVAILABLE': 'Informacje nie są dostępne',
        'PHONE_ABBR': 'tel.',
        'COMPANY': 'Firma',
        'STREET': 'Ulica',
        'BUILDING': 'Budynek',
        'POSTAL_CODE': 'Kod pocztowy',
        'CITY': 'Miasto',
        'GO_BACK': 'Powrót',
        'LOADING_DATA': 'Trwa wczytywanie danych',
        'NEXT': 'Następny',
        'PREV': 'Poprzedni',
        'NEXT_MONTH': 'Następny miesiąc',
        'PREV_MONTH': 'Poprzedni miesiąc',
        'RETURNS_AND_COMPLAINTS': 'Zwroty i reklamacje',
        'READ_MORE': 'Czytaj więcej',
        'STATUS': 'Status',
        'CREATION_FROM': 'Data utworzenia (od)',
        'CREATION_TO': 'Data utworzenia (do)',
        'SEARCH': 'Szukaj',
        'CLEAR_FILTERS': 'Wyczyść filtry',
        'FILTER': 'Filtruj',
        'PROMOTIONS': 'Okazje',
        'PRESS_MATERIALS': 'Mariały prasowe',
        'FORMS': 'Formularze',
        'MARKETING': 'Informacje handlowe',
        'CATALOGS_AND_LEAFLETS': 'Katalogi i ulotki',
        'TRAININGS': 'Szkolenia',
        'INSTRUCTIONS': 'Instrukcje',
        'SERVICE_REQUESTS_LIST': 'Lista zgłoszeń',
        'SERVICE_DOCUMENTS': 'Dokumenty do pobrania',
        'SERVICE_AND_COMPLAINTS': 'Serwis i reklamacje',
        'INFORMATIONS': 'AKTUALNOŚCI I PLIKI',
        'HOMEPAGE': 'Strona główna',
        'LOGGED': 'Zalogowany',
        'NEWS': 'Aktualności',
        'COMMENTS': 'Uwagi',
        'LIST': 'Lista',
        'NEW': 'Nowy',
        'UPDATE': 'Edytuj',
        'FROM': 'od',
        'TO': 'do',
        'UNKNOWN': 'nieznany',
        'SETTLEMENT': 'Rozliczenia',
        'SELECT_EXISTENT': 'Wybierz z zapisanych adresów',
        'DATE_FORMAT_CODE': 'dd.mm.rrrr',
        'SORT': {
          'ORDER': 'Sortuj wg',
          'nameASC': 'Nazwy rosnąco',
          'nameDESC': 'Nazwy malejąco',
          'priceASC': 'Ceny rosnąco',
          'priceDESC': 'Ceny malejąco',
          'skuASC': 'Kodu katalogowego rosnąco',
          'skuDESC': 'Kodu katalogowego malejąco',
          'scoreDESC': 'Trafności rosnąco'
        },
        'PAGE_SIZE': 'Elementów na stronie',
        'LOGIN_ERROR': ' Login i/lub hasło nieprawidłowe, lub konto zablokowane',
        'CURRENCY': 'Waluta',
        'SAVE_TO_FILE': 'Zapisz do pliku',
        'SAVE_TO_FILE_CSV': 'Zapisz do pliku csv',
        'SAVE_TO_FILE_XLS': 'Zapisz do pliku xls',
        'SAVE_TO_FILE_PDF': 'Zapisz do pliku pdf',
        'INSERT_SKU': 'Wpisz',
        'STEP': 'Krok',
        'TAX_ID': 'NIP',
        'CLIENT_ID': 'Nr klienta Stalgast',
        'RECOMMENDED': 'Polecamy',
        'CATEGORY-ONE': 'Kategoria',
        'CATEGORY-MANY': 'Kategorie',
        'CATALOG-PRICE': 'Cena katalogowa',
        'ACTIVE-FILTER': 'Aktywne filtry',
        'ACTIVE-FILTER-EMPTY': 'Brak aktywnych filtrów',
        'AVAILABLE-FILTERS': 'Dostępne filtry',
        'REMOVE-ALL-FILTERS': 'Wyczyść wszystkie filtry',
        'REMOVE-FILTER': 'Wyczyść filtr',
        'NO-ACTIVE-FILTERS': 'Brak aktywnych filtrów',
        'ALL_PRODUCTS': 'Wszystkie produkty',
        'DAYS': 'dni',
        'DAY': 'dzień',
        'REQUIRED_LEGEND': ' - pola wymagane',
        'USERNAME_INFO': '(np. 012345_janek)',
        'LOGIN_USERNAME_POPUP': 'Login ma postać xxxxxx_abc, gdzie „xxxxxx” to sześciocyfrowy numer klienta w Stalgast, a „abc” to fragment zdefiniowany przez administratora konta. \n Uwaga: Login administratora ma zawsze postać xxxxxx_admin.',
        'LOGIN_PASSWORD_POPUP': 'Jeśli ustawiłeś już kiedyś hasło i go nie pamiętasz - użyj linku „Nie pamiętasz hasła?” (poniżej).\n UWAGA: Po raz pierwszy hasło ustawia się wyłącznie klikając w otrzymany pocztą elektroniczną link do aktywacji konta.',
        'LOGIN_REMEMBER_PASSWORD_POPUP': 'Wciśnij, jeśli chcesz ustawić nowe hasło. \n Gdy pojawi się nowe okno należy podać swój login i kliknąć przycisk „Prześlij”. Na adres e-mail przypisany do konta otrzymasz link do zresetowania hasła.\n',
        'SHOWN_RESULTS': 'Pokazane wyniki',
        'OF': 'z',
        'RETURNS_AND_COMPLAINTS_LIST': 'Reklamacje/ zwroty/ zlecenia',
        'SHOW': 'Pokaż',
        'DOWNLOAD_CARD_FOR_SELECTED': 'Pobierz karty produktu w PDF dla zaznaczonych',
        'FILES_FOR_DOWNLOAD': 'Pliki XML, CSV, XLS',
        'DIMENSIONS': '(szer x gł x wys)',
        'UNIQUE_ITEMS': ' Ilość różnych pod względem wykonania produktów',
        'TOTAL_QUANTITIES': 'Suma ilości wszystkich produktów'
      },
      AUTH: {
        'NO_REMEMBER_PASSWORD': 'Nie pamiętasz hasła?',
        'LOGGED_STATUS': 'Aktualnie zalogowany.',
        'VALIDATING_TOKEN_MSG': 'Sprawdzanie poprawności tokenu ...',
        'TOKEN_INVALID_MSG': 'Token jest nieprawidłowy.',
        'WELCOME': 'Witamy na platformie B2B firmy Stalgast!',
        'ACTIVATION_INSTRUCTIONS': 'Instrukcja obsługi znajduje się {{user.firstname}}. Zachęcamy do zapoznania się z nią przed rozpoczęciem pracy.',
        'INFORMATION_OF_YOUR_ACCOUNT': 'Twoje dane na koncie systemu są następujące:',
        'ACTIVATION_GOODBYE': '<p>Te dane może edytować wyłącznie administrator konta.</p><p>Życzymy owocnych zakupów!</p> <p>Z poważaniem<br>Zespół Stalgast</p>',
        'CHANGE_PASSWORD': 'Utwórz hasło do systemu',
        'NEW_PASSWORD': 'Nowe hasło',
        'TYPE_NEW_PASSWORD': 'Wpisz nowe hasło',
        'REPEAT_NEW_PASSWORD': 'Powtórz nowe hasło',
        'ACTIVATE_ACCOUNT': 'Aktywuj konto',
        'SET_NEW_PASSWORD': 'Ustaw nowe hasło',
        'SAVE_PASSWORD': 'Zapisz hasło',
        'RECOVER_PASSWORD_INSTRUCTIONS': 'Wpisz swój login. Na adres e-mail przypisany do konta otrzymasz link do zresetowania hasła.',
        'PASSWORD_MIN_LENGTH_VALIDATION_MSG': 'Hasło musi mieć więcej niż {{minlength}} znaków',
        'PASSWORD_NOT_EQUAL_VALIDATION_MSG': 'Pamiętaj, że hasła muszą być takie same',
        'RECOVERY_PASSWORD_PROCESS_START_CONFIRMATION': 'Za chwilę otrzymasz link do ustawienia nowego hasła.<br/>Wiadomość zostanie wysłana na adres e-mail przypisany do konta.',
        'ROUTE_ACCESS_RESTRICTED': 'Nie masz uprawnień do wyświetlenia tej sekcji',
        'YOU_ARE_USING_FAILSAFE_ROLE': 'Wystąpił problem z uprawnieniami konta. Poinformuj pracownika Stalgast o problemie.',
        'RULES_AGREEMENT_REQUIRED': 'Akceptacja regulaminu jest wymagana do aktywacji konta.',
        'AGREEMENT_RULES': 'Akceptacja regulaminu B2B',
        'AGREEMENT_NOTIFICATIONS': 'Zgoda na przesyłanie informacji',
        'SEE_TERMS': 'Zobacz regulamin',
        'MORE': 'Pokaż więcej',
        'LESS': 'Zwiń tekst',
        'SET_AGREEMENT_WELCOME': 'Do dalszej pracy wymagana jest akceptacja regulaminu. Jeżeli masz pytania, skontaktuj się z administratorem systemu.'
      },
      ACCOUNT: {
        'MY_ACCOUNT': 'Moje konto',
        'MY_DATA': 'Moje dane',
        'MY_LOGO': 'Moje logo',
        'MY_ADDRESS': 'Moje adresy',
        'CURRENT_LOGO': 'Aktualnie ustawione logo',
        'EMPLOYEES_LIST': 'Lista pracowników',
        'NEW_EMPLOYEE': 'Dodaj pracownika',
        'THERE_IS_NO_EMPLOYEES': 'Brak pracowników spełniających podane kryteria.',
        'CHANGE_PASSWORD': 'Zmień hasło',
        'MY_DATA_WELCOME': 'Poniżej prezentujemy dane zarejestrowane w systemach handlowych Stalgast.<br>W sprawie zmian tych danych prosimy o kontakt z Państwa Opiekunem Handlowym.',
        'B2B_ADMINISTRATOR': 'Administrator B2B',
        'B2B_USER': 'Użytkownik B2B (Ty)',
        'RECIPIENT': 'Odbiorca',
        'ACCOUNT_MANAGER': 'Opiekun klienta',
        'DEFAULT_SHIPPING_ADDRESS': 'Domyślny adres dostawy',
        'CREDIT_LIMIT': 'Limit kredytu',
        'PAYMENTS_TERMS': 'Warunki płatności',
        'METHOD_OF_INVOICE_DELIVERY': 'Sposób doręczenia faktury',
        'DELIVERY_METHOD': 'Sposób dostawy',
        'CARRIER': 'Przewoźnik',
        'CHOOSE_ROLE': 'Wybierz',
        'NAME_TOO_SHORT_VALIDATION_MSG': 'Wprowadzone imię jest zbyt krótkie.',
        'LASTNAME_TOO_SHORT_VALIDATION_MSG': 'Wprowadzone nazwisko jest zbyt krótkie.',
        'CONTACT': 'Kontakt',
        'STALGAST_CONTACT': 'Osoba wskazana do kontaktu dla Stalgast',
        'REGIONAL_SALES_MANAGER': 'Kierownik Regionalny Sprzedaży (KRS)',
        'SERVICE_COORDINATOR': 'Koordynator serwisu',
        'DEALER': 'Handlowiec',
        'B2B_STALGAST_HELP': 'Pomoc B2B.Stalgast',
        'PLEASE_SEND_YOUR_FEEDBACK_TO': 'Uwagi i pomysły jak usprawnić system B2B Stalgast prosimy zgłaszać na adres:',
        'NO_LOGO_MSG': 'Nie ustawiono jeszcze logo dla dystrybutora.',
        'UPLOAD_LOGO': 'Prześlij logo',
        'CHANGE_LOGO': 'Zmień logo',
        'SELECT_NEW_LOGO': 'Wybierz nowe logo',
        'PRESS_HERE_TO_SELECT_FILE': 'kliknij tutaj, aby dodać z dysku.',
        'OR_DROP_FILE_HERE': 'Przeciągnij plik, lub ',
        'LOGO_HAS_BEEN_UPDATED': 'Logo dystrybutora zostało zaktualizowane',
        'THERE_ARE_NO_ADDRESSES': 'Brak adresów spełniających podane kryteria',
        'NEW_ADDRESS': 'Nowy adres',
        'EDIT_ADDRESS': 'Edytuj adres',
        'ADDRESS_HAVE_BEEN_SAVED': 'Adres został zapisany',
        'ADDRESS_NOT_REACHABLE': 'Wystąpił problem przy pobieraniu adresu. Spróbuj ponownie.',
        'EDIT_SETTINGS': 'Edytuj ustawienia konta',
        'SET_AS_DEFAULT_DELIVERY': 'Ustaw jako domyślny adres dostawy',
        'DEFAULT_DELIVERY': 'Domyślny adres dostawy',
        'CONTACT_IN_DELIVERY_PLACE': 'Kontakt w miejscu dostawy',
        'FILL_ADDR_LABEL': 'Wciśnij „Edytuj” i wprowadź skróconą nazwę adresata dla kuriera/ nazwę adresu',
        'EDIT_EMPLOYEE': 'Edytuj konto pracownika',
        'PASSWORD_CHANGED': 'Link do utworzenia nowego hasła został wysłany do użytkownika.',
        'PASSWORD_CHANGE_FAILED': 'Wystąpił błąd podczas resetowania hasła. Spróbuj ponownie.',
        'EMPLOYEE_SAVED': 'Pracownik zapisany',
        'ALLOW_SENDING_MAILS': 'Dostaje maile o zmianie statusu zamówienia',
        'ALLOW_ME_SENDING_MAILS': 'Chcę otrzymywać maile o zmianie statusu zamówienia',
        'DATA_SAVED': 'Dane zostały zapisane',
        'DATA_SAVE_ERROR': 'Wystąpił problem podczas zapisywania. Spróbuj ponownie',
        'REMOVE_RULES_AGREEMENT': 'Jeżeli nie akceptujesz regulaminu, potwierdź swój wybór poniższym przyciskiem.<br />Twoje ustawienia zostaną zmienione i nastąpi wylogowanie Cię z systemu.',
        'REMOVE_RULES_AGREEMENT_BUTTON': 'Potwierdzam, że nie akceptuję regulaminu i chcę zakończyć pracę w systemie',
        'ERROR_BANNED': 'Konto zostało zablokowane. Skontaktuj się z Doradcą Klienta.',
        'LOYALTY_PROGRAM': 'Program lojalnościowy'
      },
      CART: {
        'CART': 'Koszyk',
        'CARTS': 'Koszyki',
        'SHOPPING_CARTS_LIST': 'Lista koszyków',
        'SHOPPING_CARTS': 'Koszyki',
        'NAME': 'Nazwa koszyka',
        'PRODUCT_COUNT': 'Liczba produktów',
        'NEW': 'Nowy Koszyk',
        'CREATE_NEW': 'Utwórz nowy koszyk',
        'THERE_IS_NO_CARTS': 'Brak koszyków spełniających podane kryteria',
        'LIST_NOT_AVAILABLE': 'Wystąpił problem podczas pobierania listy koszyków. Spróbuj ponownie.',
        'CART_NOT_AVAILABLE': 'Wystąpił problem podczas pobierania danych koszyka. Spróbuj ponownie.',
        'CONVERT_IN_OFFER': 'Użyj jako oferta',
        'RECALCULATE_AND_UPDATE_AVAILABILITY': 'Przelicz i zaktualizuj dostępności',
        'TYPE_NEW_NAME': 'Nazwa koszyka',
        'CREATION_SUCCESS_MSG': 'Koszyk został stworzony',
        'CREATION_FAILURE_MSG': 'Wystąpił problem podczas tworzenia koszyka. Spróbuj ponownie.',
        'UPDATE_SUCCESS_MSG': 'Koszyk został zaktualizowany',
        'UPDATE_FAILURE_MSG': 'Wystąpił problem podczas aktualizacji koszyka. Spróbuj ponownie.',
        'DELETE_SUCCESS_MSG': 'Koszyk został usunięty',
        'DELETE_FAILURE_MSG': 'Koszyk nie może być usunięty',
        'PRODUCT_ALREADY_IN_CART': 'Ten produkt jest już w koszyku',
        'ITEM_POSITION': 'Lp.',
        'SKU': 'Kod katalogowy',
        'SKU_ABRV': 'Kod kat.',
        'PRODUCT': 'Produkt',
        'PRICE_OF_LIST': 'Cena katalogowa',
        'QUANTITY': 'Ilość (szt)',
        'WAREHOUSE': 'Magazyn',
        'AVAILABILITY': 'Dostępne',
        'YOUR_DISCOUNT': 'Twój rabat',
        'DISCOUNT_GROUP': 'Grupa rabatowa',
        'PROMO_PRICE': 'Cena promocyjna',
        'YOUR_PRICE': 'Twoja cena',
        'BOTH_PRICES': 'Razem',
        'REMOVE': 'Usuń',
        'REMOVE_IN_PROGRESS': 'Usuwanie...',
        'AVAILABLE': 'Dostępne',
        'NOT_AVAILABLE_HELPTEXT': 'Produkt magazynowany,\n' + 'zamawiana ilość\n' + 'wymaga potwierdzenia.',
        'NOT_AVAILABLE_ON_ORDER': 'Produkt na zamówienie,\n' + 'zamawiana ilość\n' + 'wymaga potwierdzenia.',
        'ALL': 'Wszystko',
        'NET_AMOUNT': 'Wartość netto',
        'GROSS_AMOUNT': 'Wartość brutto',
        'CHECKOUT': 'Realizuj zamówienie',
        'CART_IS_EMPTY': 'Koszyk jest pusty',
        'PRICE_OF_LIST_HELPTEXT': 'W przypadku promocji cena katalogowa jest przekreślona, a pod nią podawana jest aktualna katalogowa cena promocyjna.',
        'AVAILABILITY_HELPTEXT': 'Dostępność pokazuje ile z zamawianych sztuk z pozycji "Ilość" jest aktualnie dostępne.',
        'YOUR_DISCOUNT_HELPTEXT': 'Rabat obliczany jest względem ceny katalogowej lub jeśli obowiązuje promocja, to od aktualnej katalogowej ceny promocyjnej, która jest podana pod przekreśloną ceną katalogową. Po kresce prezentowane jest oznaczenie grupy rabatowej, do której należy produkt.',
        'QTY_INCREMENT_ERROR': 'Zamawiana ilość musi być wielokrotnością {{qtyIncrements}}',
        'CURRENT_ACTIVE': 'Aktywny koszyk',
        'SELECT_CURRENT_ACTIVE': 'Wybierz albo utwórz koszyk',
        'ACTIVATION_NOTIF': 'Koszyk <b>{{name}}</b> został wybrany',
        'COUNT': 'Liczba koszyków',
        'CONVERT_TO_OFFER': 'Utwórz nową ofertę z tego koszyka',
        'CANT_BE_CONVERTED_TO_OFFER': 'Tylko koszyk posiadający produkty może zostać przekształcony w ofertę.',
        'ADD_TO_CART': 'Dodaj do koszyka',
        'SELECT_CART': 'Wybierz koszyk',
        'IMPORT_XML': 'Importuj koszyk z pliku XML',
        'CSVMODAL': {
          'TITLE': 'Importuj produkty z pliku CSV',
          'CONTENT': 'Info - jaki plik wstawić',
          'IMPORT': 'Importuj',
          'NO_FILE': 'Nie wybrano pliku',
          'CONFIRM_MSG': 'Produkty z pliku zostały dodane do koszyka',
          'FAIL_MSG': 'Wystąpił problem podczas dodawania do koszyka.<br/>Sprawdź poprawność pliku i spróbuj ponownie.',
          'PARTIAL_CONFIRM_MSG': 'Dane z pliku zaimportowane częściowo.<br/>Poniżej znajdziesz szczegóły błędu.'
        },
        'XMLMODAL': {
          'TITLE': 'Importuj koszyk z pliku XML',
          'CONTENT': '',
          'IMPORT': 'Importuj',
          'CONTINUE': 'Dalej',
          'WORKING': 'Przetwarzanie',
          'INVALID_MSG': 'Podane kody katalogowe są nieprawidłowe i nie zostały dodane do koszyka',
          'ERROR_MSG': 'Błąd',
          'NO_FILE': 'Nie wybrano pliku',
          'CONFIRM_MSG': 'Koszyk utworzony',
          'FAIL_MSG': 'Wystąpił problem podczas dodawania do koszyka.<br/>Sprawdź poprawność pliku i spróbuj ponownie.',
          'INVALID_SUMMARY': 'Problem z walidacją pliku XML.<br/>Podsumowanie nie zgadza się z zawartością koszyka.',
          'NO_ENTRY': 'Brak wpisu: {{ entry }}.'
        },
        'CONVERT': {
          'NEW_NAME': 'Nazwa nowej oferty',
          'MODAL_TITLE': 'Utwórz nową ofertę z tego koszyka',
          'REMOVE_SELECTION': 'Usuń koszyk po stworzeniu oferty',
          'CONFIRM': 'Utwórz ofertę'
        },
        'SELECT_CART_BEFORE_ADD': 'Wybierz koszyk aby móc dodać',
        'FAILED_SKU': 'Podane kody katalogowe są nieprawidłowe',
        'OMITTED_SKU': 'Podane kody katalogowe są niedostępne',
        'STOCKS_UPDATED': 'Dostępności zaktualizowane',
        'PARTIALLY_CONVERTED_TO_OFFER': 'Niektóre z produktów nie mogły być dodane do oferty.',
        'DELIVERY_DATE': 'Planowana data dostawy:',
        'DELIVERY_ORDER': 'Towar na zamówienie. Czas realizacji około'
      },
      OFFER: {
        'NEW': 'Nowa oferta',
        'CREATE_NEW': 'Utwórz nową ofertę',
        'COUNT': 'Liczba ofert',
        'LIST': 'Lista ofert',
        'OFFER': 'Oferta',
        'OFFERS': 'Oferty',
        'NAME': 'Nazwa oferty',
        'BRAND': 'Marka',
        'SKU': 'Kod katalogowy',
        'SKU_ABRV': 'Kod kat.',
        'SERVICE_REQUEST': ' Zapotrzebowanie',
        'OFFER_LIST': 'Lista ofert',
        'THERE_IS_NO_OFFERS': 'Nie utworzono jeszcze żadnej oferty.',
        'THERE_IS_NO_MATCH_OFFERS': 'Brak ofert spełniających podane kryteria.',
        'PRODUCT_COUNT': 'Liczba produktów',
        'CREATE': 'Stwórz ofertę',
        'UPDATE': 'Zapisz',
        'ITEM_POSITION': 'Lp.',
        'PRODUCT': 'Produkt',
        'PRICE': 'Cena',
        'PRICE_OF_LIST': 'Cena katalogowa',
        'YOUR_PRICE': 'Twoja cena',
        'QUANTITY': 'Ilość (szt)',
        'AVAILABILITY': 'Dostępne',
        'YOUR_DISCOUNT': 'Twój rabat',
        'NET_AMOUNT': 'Wartość netto',
        'REFER_DETAILS': 'Dane osoby składającej ofertę',
        'ADD_PRICES': 'Załącz ceny',
        'ADD_DISCOUNTS': 'Pokaż ceny katalogowe i rabaty',
        'ADD_IMAGES': 'Dodaj zdjęcia',
        'ADD_DESCRIPTIONS': 'Dodaj opisy',
        'HIDE_STALGAST_ITEMS': 'Ukryj numery katalogowe',
        'ADD_CUSTOMER_LOGO': 'Dodaj logo (z Moje konto)',
        'ADD_STALGAST_LOGO': 'Dodaj logo Stalgast',
        'OPTIONS_TITLE': 'Pozycje widoczne na ofercie<br/><small>(zaznacz, co powinno się znaleźć w ofercie skierowanej do Twojego klienta)</small>',
        'FILE_TYPE': 'Typ pliku',
        'FILE_TYPE_PDF': 'PDF',
        'FILE_TYPE_XLSX': 'Excel',
        'PLANNED_DELIVERY_ADDRESS': 'Planowany adres dostawy',
        'DISCOUNT_OFFER': 'Rabat oferty',
        'APPLY_TO_THE_SELECTED_ROWS': 'Wstaw do zaznaczonych wierszy',
        'CREATION_SUCCESS_MSG': 'Oferta została utworzona',
        'CREATION_FAILURE_MSG': 'Wystąpił błąd podczas tworzenia oferty. Spróbuj ponownie.',
        'UPDATE_SUCCESS_MSG': 'Oferta została zaktualizowana',
        'UPDATE_FAILURE_MSG': 'Wystąpił błąd podczas aktualizowania oferty. Spróbuj ponownie',
        'DELETE_SUCCESS_MSG': 'Oferta usunięta',
        'DELETE_FAILURE_MSG': 'Oferta nie może być usunięta',
        'PRICE_OF_LIST_HELPTEXT': 'W przypadku promocji cena katalogowa jest przekreślona, a pod nią podawana jest aktualna katalogowa cena promocyjna.',
        'AVAILABILITY_HELPTEXT': 'Dostępność pokazuje ile z zamawianych sztuk z pozycji "Ilość" jest aktualnie dostępne.',
        'YOUR_DISCOUNT_HELPTEXT': 'Rabat obliczany jest względem ceny katalogowej lub jeśli obowiązuje promocja, to od aktualnej katalogowej ceny promocyjnej, która jest podana pod przekreśloną ceną katalogową. Po kresce prezentowane jest oznaczenie grupy rabatowej, do której należy produkt.',
        'PRODUCTS_OF_STALGAST': 'Produkty z oferty Stalgast',
        'PRODUCTS_OUTSIDE_STALGAST': 'Produkty spoza oferty Stalgast',
        'CONVERT_TO_CART': 'Utwórz nowy koszyk z tej oferty',
        'CANT_BE_CONVERTED_TO_CART': 'Tylko oferty, posiadające produkty, mogą zostać przekształcone w koszyk',
        'DOWNLOAD_FILE': 'Zapisz i pobierz plik',
        'CONVERT': {
          'NEW_NAME': 'Nazwa nowego koszyka',
          'MODAL_TITLE': 'Utwórz nowy koszyk z tej oferty',
          'REMOVE_SELECTION': 'Usuń ofertę po stworzeniu koszyka',
          'CONFIRM': 'Utwórz koszyk'
        },
        'NEXT_STEP': 'Następny krok',
        'PREVIOUS_STEP': 'Powrót do edycji produktów',
        'SEND_MAIL': 'Zapisz i wyślij do mnie e-mailem',
        'MAIL_SENT': 'Oferta zapisana. Za chwilę otrzymasz maila z ofertą.',
        'FAILED_SKU_CONVERT': 'Podane produkty nie mogą zostać dodane do oferty',
        'GENERATION_TOOLTIP': 'Ostrzeżenie: plik będzie generował się długo. Skorzystaj z funkcji „Zapisz i wyślij do mnie mailem”',
        'PRODUCT_ALREADY_IN_OFFER': 'Ten produkt jest już w ofercie',
        'ADD_EXTENDED_OFFERS': 'Dodaj produkty spoza oferty Stalgast',
        'SHOW_EXTENDED_OFFERS': 'Pokaż produkty spoza oferty Stalgast',
        'HIDE_EXTENDED_OFFERS': 'Ukryj produkty spoza oferty Stalgast',
        'CURRENCY': 'zł',
        'IGNORE_PROMO_PRICE': 'Nie uwzględniaj promocji',
        'PRICE_BELOW_PURCHASE_PRICE': 'Uwaga! Cena poniżej ceny zakupu!',
        'OFFER_NOT_AVAILABLE': 'Nie można pobrać danych. Wybrana oferta nie istnieje.'
      },
      PRODUCT: {
        'FILTERS': 'Filtry',
        'PRODUCT_LIST': 'Lista produktów',
        'LIST_PRICE': 'Cena katalogowa',
        'YOUR_PRICE': 'Twoja cena',
        'PROMO_PRICE': 'Cena promocyjna',
        'ADD_TO_CART': 'Dodaj do koszyka',
        'ADD_SELECTION_TO_CART': 'Dodaj zaznaczone do koszyka',
        'PROMOTION': 'Promocja -{{discount}}%',
        'CODE': 'Nr.kat.',
        'BRAND': 'Marka',
        'LINE': 'Linia',
        'NET': 'netto',
        'PRODUCT_AVAILABLE': 'Produkt dostępny',
        'PRODUCT_UNAVAILABLE': 'Produkt niedostępny',
        'PRODUCT_ON_ORDER': 'Produkt na zamówienie',
        'DO_NOT_HAVE_ATTRIBUTES': 'Ten produkt nie posiada cech.',
        'PRODUCTS': 'Produkty',
        'RECOMMENDED': 'Polecamy',
        'VIEW_INFO_TOOLTIP': 'Pokaż informacje o produkcie',
        'ABBR': 'szt.',
        'SEARCH_PHRASE': 'Wyniki wyszukiwania dla frazy: {{keywords}}',
        'THERE_ARE_NO_PRODUCTS': 'Nie znaleźliśmy poszukiwanego produktu. Sprawdź, czy znajduje się w naszej ofercie pozakatalogowej',
        'ATTRIBUTES': 'Parametry techniczne',
        'FILES_TO_DOWNLOAD': 'Pliki do pobrania',
        'DESCRIPTION': 'Opis produktu',
        'RELATED_TITLE': 'Produkty powiązane do:',
        'UPSELL': 'Produkty alternatywne',
        'RELATED': 'Produkty podobne',
        'CROSSELL': 'Produkty uzupełniające',
        'SHOW_RELATED': 'Pokaż produkty powiązane',
        'WARRANTY_DETAILS': 'Warunki gwarancji',
        'QTY_INCREMENTS_INFO': 'pakowane po {{qty}} szt. (podana cena za 1 szt.)',
        'SEE_ALL': 'Zobacz wszystkie',
        'CATEGORY-UP': 'Przejdź do kategorii wyżej',
        'CLEAR_FILTERS': 'Wyczyść filtry',
        'CLEAR_FILTER': 'Wyczyść filtr',
        'FILTER': 'Filtruj',
        'CATEGORY_NO_CHILDREN': 'Brak podkategorii',
        'SHOW_MORE': 'Pokaż więcej',
        'SHOW_LESS': 'Pokaż mniej',
        'DOWNLOAD_CARD': 'Pobierz kartę produktu w PDF',
        'GUARANTEE_PERIOD_MONTHS': 'okres gwarancji [miesiące]: {{guaranteePeriod}}',
        'QUICK_INFO': 'Szybka informacja o produkcie',
        'SELECT_PRODUCT_FIRST_MSG': 'Nie wybrano produktu do sprawdzenia dostępności.',
        'PRODUCT_DOESNT_EXIST_MSG': 'Nie można pobrać danych. Produkt o podanym kodzie katalogowym nie istnieje.',
        'RELATED_PRODUCTS': 'Części zamienne',
        'NON_CATALOG_PRODUCTS': 'Katalogi i cenniki produktów pozakatalogowych'
      },
      ORDER: {
        'HISTORY': 'Historia zamówień',
        'LAST_ORDER': 'Ostatnie zamówienie',
        'COUNT': 'Liczba zamówień',
        'ORDERING': 'Dane do zamówienia',
        'NAME_OF_ORDER': 'Nazwa zamówienia',
        'SERVICE_REQUEST': ' Zapotrzebowanie',
        'REFERENCE': 'Uwagi dla opiekuna handlowego',
        'NOTE': 'Notatka na ofercie',
        'SHIPPING_DATE': 'Data wysyłki',
        'COMPANY': 'Adresat dostawy',
        'DELIVERY': 'Dostawa',
        'DELIVERY_ADDRESS': 'Adres dostawy',
        'DELIVERY_METHOD': 'Sposób dostawy',
        'PAYMENT_METHOD': 'Sposób płatności',
        'CONTACT_IN_DELIVERY_PLACE': 'Kontakt w miejscu dostawy',
        'ORDER_SUMMARY': 'Podsumowanie zamówienia',
        'ORDER_NAME_HELPTEXT': 'Nazwa dziedziczona z nazwy koszyka',
        'COMPLETE_ORDER': 'Prześlij do realizacji',
        'NO_QUOTE_WAS_FOUND': 'Wystąpił problem podczas pobierania danych. Zostaniesz przekierowany do koszyka.',
        'OFFER_NAME': 'Nazwa oferty',
        'SERVICE_REQUEST_HELPTEXT': 'Ta informacja zostanie wydrukowana na fakturze',
        'PAYMENT_AMOUNT': 'Kwota pobrania',
        'Courier': 'Kurier',
        'courier': 'Kurier',
        'Courier cash on delivery': 'Kurier za pobraniem',
        'courier_cod': 'Kurier za pobraniem',
        'COURIER_COD_WITH_AMOUNT': 'Kurier za pobraniem. <strong>Kwota pobrania {{cod_amount}}</strong>',
        'Self pickup': 'Odbiór własny',
        'pickup': 'Odbiór własny',
        'Money transfer': 'Przelew',
        'transfer': 'Przelew',
        'Cash on delivery': 'Płatność przy odbiorze',
        'cod': 'Płatność przy odbiorze',
        'COD_AMOUNT_LABEL': 'Kwota pobrania w PLN (od {{min_cod_amount}} do {{max_cod_amount}})',
        'CONFIRMATION': {
          'TITLE': 'Potwierdzenie',
          'HELLO': 'Szanowny Użytkowniku!',
          'THANKS': 'Dziękujemy za złożenie kolejnego zamówienia przez internetowy system B2B Stalagst.',
          'STATUS': 'Zamówienie zostało przekazane do naszych systemów księgowo-magazynowych i aktualnie ma status "Utworzone".',
          'STATUS_AFTER_BOOKED': 'Po zaksięgowaniu potwierdzenia rezerwacji towarów zmieni się jego status na "W realizacji", o czym zostaniesz poinformowany mailem.',
          //FIXME: URL need to be changed
          'STATUS_LINK': 'Wszelkie informacje o tym zamówieniu znajdują się tutaj: <a href="/orders/{{code}}">Informacja o zamówieniu <strong>nr {{code}}</strong></a> i są na bieżąco aktualizowane.',
          //FIXME: URL need to be changed
          'HISTORY_NOTE': 'UWAGA: Przypominamy, że informacje o wszystkich złożonych zamówieniach można znaleźć w zakładce "Historia zamówień", bez względu na to, jaką drogą zostały złożone, zarówno przez system B2B, jak i telefonicznie, mailem lub faksem.',
          'GOODBAY_LINE1': 'Z poważaniem,',
          'GOODBAY_LINE2': 'Zespół Stalgast'
        },
        'ORDER_ID': 'Numer zamówienia',
        'LIST': 'Historia zamówień',
        'THERE_ARE_NO_ORDERS': 'Brak zamówień spełniających podane kryteria',
        'ORDERS': 'Zamówienia',
        'SKU': 'Numer katalogowy',
        'SKU_SHORT': 'Kod kat.',
        'PRICE': 'Cena',
        'DELIVERY_STREET': 'Ulica',
        'DELIVERY_POSTCODE': 'Kod pocztowy',
        'DELIVERY_CITY': 'Miasto',
        'STATUSES': {
          'CREATED': 'Utworzone',
          'DELETE': 'Usunięte',
          'CANCEL': 'Anulowane',
          'IN_PROGRESS': 'W realizacji',
          'COMPLETED': 'Dostarczone',
          'INVALID': 'Błąd',
          'ERROR': 'Błąd',
          'INVOICED': 'Zafakturowane'
        },
        'STATUS': 'Status zamówienia',
        'B2B_ID': 'Identyfikator zamówienia w systemie B2B',
        'ORDERED_ITEMS': 'Zamówione produkty',
        'INFO': 'Informacje o zamówieniu {{id}}',
        'DETAILS': 'Szczegóły zamówienia',
        'QTY_ORDERED': 'Zamówione',
        'QTY_RESERVED': 'Rezerwacja',
        'QTY_SHIPPED': 'Zrealizowane',
        'DELIVERY_DATE': 'Data dostawy',
        'ADDRESS_CREATION_SUCCESS': 'Adres został dodany do konta',
        'ADDRESS_CREATION_FAILURE': 'Nie można dodać adresu do swojego konta',
        'SAVE_ADDRESS': 'Dodaj do moich adresów',
        'SHIPPING_LABEL_ID': 'Nr listu przewozowego',
        'SHIPPING_LABELS': 'Listy przewozowe',
        'DATA_SAVED': 'Dane zapisane',
        'OFFER_DATE': 'Data przygotowania oferty',
        'PDF_NOT_SHOW': '(Niewidoczne na ofercie PDF i XLS)',
        'PDF_SHOW': '(Widoczne na ofercie PDF i XLS)',
        'NEW_ADDRESS': 'Nowy adres (wyczyść)',
        'SET_DEFAULT_ADDRESS': 'Użyj domyślnego adresu'
      },
      FINANCES: {
        'SETTLEMENT': 'Rozliczenia',
        'BALANCE': 'Saldo',
        'OVERDUE': 'Przeterminowane',
        'AVAILABLE_FOR_USE': 'Limit do wykorzystania'
      },
      ARTICLES: {
        'THERE_ARE_NO_ITEMS': 'Nie ma żadnych artykułów w tej kategorii.',
        'TITLE': 'Tytuł',
        'RETURN_TO_LIST': 'Powrót do listy',
        news: {
          'SECTION': 'Aktualności',
          'NEWS': 'Aktualności',
          'SEE_ALL': 'Zobacz wszystkie aktualności'
        },
        documents: {
          'SECTION': 'Dokumenty B2B',
          'SEE_ALL': 'Zobacz wszystkie instrukcje'
        }
      },
      INVOICE: {
        'LIST': 'Lista faktur',
        'INVOICE_NUMBER': 'Numer FV',
        'INVOICE_NUMBER_KSEF': 'Numer FV KSeF',
        'ORDER': 'Zamówienie',
        'ORDER_NO': 'Nr zamówienia',
        'PAYER_ACCOUNT': 'Konto płatnika',
        'NET_AMOUNT': 'Wartość netto',
        'TAX_AMOUNT': 'Wartość VAT',
        'GROSS_AMOUNT': 'Wartość brutto',
        'AMOUNT': 'Kwota faktury',
        'INVOICE_DATE': 'Data FV',
        'DUE_DATE': 'Data płatności faktury',
        'PAYMENT_DATE': 'Data płatności',
        'DOWNLOAD_PDF': 'Pobierz PDF',
        'THERE_ARE_NO_RESULTS': 'Brak faktur spełniających podane kryteria'
      },
      PAYMENT: {
        'RECIPIENT_ID': 'Konto odbiorcy',
        'RECIPIENT_NAME': 'Nazwa',
        'ATTACHMENT': 'Załącznik',
        'NAME': 'Tekst transakcji',
        'AMOUNT': 'Kwota',
        'DEALER': 'Sprzedawca',
        'PAYMENTS': 'Płatności',
        'PAYMENT_DATE': 'Data płatności',
        'THERE_ARE_NO_RESULTS': 'Brak transakcji spełniających podane kryteria'
      },
      SETTLE: {
        'TITLE': 'Rozliczenia otwarte',
        'HEADER': 'Szczegółowa lista transakcji otwartych',
        'PAYMENT': 'Należności prosimy przekazać na konto Stalgast sp. z o.o. nr:',
        'SUBMIT': 'Kwota do rozliczenia',
        'DELAY': 'Dni po terminie',
        'AMOUNT': 'Kwota do zapłaty',
        'AMOUNT_SETTLE': 'Kwota do rozliczenia',
        'ATTACHMENT_DATE': 'Data dokumentu',
        'DUE_DATE': 'Data należności',
        'CASE_STATUS': 'Status sprawy',
        'LAST_INVOICE': 'Data ostatniej faktury',
        'LAST_PAYMENT': 'Data ostatniej płatności',
        'SETTLEMENT_EMAIL': 'Rozliczenia/ zwroty/ kompensaty',
        'OVERDUE_PAYMENTS': 'Płatności przeterminowane',
        'PAYER_ACCOUNT': 'Konto płatnika',
        'NAME': 'Opis transakcji',
        'DOCUMENT': 'Dokument',
        'EXPORT': 'Eksport do csv'
      },
      COMPLAINT: {
        'TITLE': 'Lista reklamacji/ zwrotów/ zleceń serwisowych',
        'ITEM_TITLE': 'Reklamacja/ Zwrot/ zlecenie serwisowe',
        'COMPANY': 'Firma (z adresu do odesłania)',
        'COMPANY_SHORT': 'Firma',
        'NUMBER': 'Numer reklamacji',
        'REQUEST_NUMBER': 'Numer zgłoszenia',
        'ACCEPTANCE_DATE': 'Data przyjęcia',
        'FINISHED_DATE': 'Data zakończenia',
        'PRODUCT_CODE': 'Kod produktu',
        'REQUEST_TYPE': 'Typ zgłoszenia',
        'COST_COVERED': 'Koszty pokrywa',
        'COMPLAINT_PHASE': 'Faza reklamacji',
        'CHOOSE': 'Wybierz',
        'RETURN_ADDRESS': 'Adres do odesłania/ interwencji',
        'CONTACT': 'Kontakt',
        'ITEM_POSITION': 'Lp.',
        'WORK_TYPE': 'Typ zadania',
        'CREATION_DATE': 'Data utworzenia',
        'INFORMATIONS': 'Informacje',
        'THERE_ARE_NO_ITEMS': 'Nie znaleziono żadnych reklamacji/ zleceń serwisowych',
        'EMPLOYEE': 'Opiekun',
        'QUANTITY': 'Ilość',
        'INVOICE': 'Faktura',
        'INVOICE_DATE': 'Data faktury',
        'COUNTRY': 'Kraj',
        'HISTORY': 'Historia reklamacji/ zwrotu/ zlecenia serwisowego',
        'THERE_ARE_NO_HISTORY': 'Ta reklamacja/ zlecenie serwisowe nie ma historii',
        'ALL': 'Pokaż wszystkie',
        'COMPLAINT': 'Reklamacja',
        'PAIDREPAIR': 'Naprawa płatna',
        'BACKSENT': 'Zwrot',
        'SERVICE': 'Usługa serwisowa',
        'EXCHANGE': 'Wymiana',
        'SITECHECK': 'Wizja lokalna',
        'INSPECTION': 'Przegląd okresowy',
        'FROM': 'od',
        'TO': 'do',
        'DATE': 'Data',
        'ACTION': 'Czynność',
        'PROCESS': 'Przebieg:'
      },
      ISSUE: {
        'ISSUES': 'Zgłoszenia przez B2B',
        'ISSUE': 'Zgłoszenie',
        'TITLE': 'Zgłoszenia reklamacyjne i serwisowe (przez B2B)',
        'TITLE_ITEM': 'Zgłoszenie reklamacyjne/ serwisowe',
        'TITLE_NEW': 'Nowe zgłoszenie reklamacyjne/ serwisowe',
        'NEW_ISSUE': 'Nowe zgłoszenie',
        'ISSUE_NAME': 'Nazwa zgłoszenia',
        'CHOOSE_ISSUE_NAME': 'Nazwa zgłoszenia (wybrana przez ciebie)',
        'COMPANY': 'Firma',
        'REQUEST_NUMBER': 'Numer zgłoszenia',
        'CREATION_DATE': 'Data utworzenia',
        'FROM': 'od',
        'TO': 'do',
        'CREATED_BY': 'Utworzył',
        'ISSUE_PHASE': 'Faza zgłoszenia',
        'THERE_ARE_NO_ITEMS': 'Nie znaleziono żadnych zgłoszeń reklamacyjnych i serwisowych',
        'PRODUCTS_QTY': 'Liczba produktów',
        'QTY': 'Ilość (szt)',
        'STREET': 'Nazwa ulicy',
        'POSTAL_CODE': 'Kod pocztowy',
        'COUNTRY': 'Kraj',
        'CONTACT': 'Kontakt',
        'CONTACT_PERSON': 'Osoba kontaktowa',
        'PRODUCTS': 'Produkty',
        'ITEM_POSITION': 'Lp.',
        'COMPLAINT_NUMBER': 'Numer reklamacji',
        'SKU': 'Kod katalogowy',
        'PRODUCT_SKU': 'Kod produktu',
        'NAME': 'Nazwa',
        'WARRANTY': 'Warunki gwarancji',
        'WARRANTY_END_DATE': 'Data końca gwarancji',
        'REQUEST_TYPE': 'Typ zgłoszenia',
        'INVOICE': 'Faktura',
        'INVOICE_FULL_NUMBER': 'Faktura (pełny numer)',
        'SERIAL_NUMBER': 'Numer seryjny',
        'DEFECT_DESC': 'Opis błędu',
        'REQUEST': 'Żądanie',
        'COMPLAINT': 'Reklamacja',
        'RETURN_ADDRESS': 'Adres do odesłania/ interwencji',
        'CHOOSE_ADDRESS': 'Wybierz adres (ze zdefiniowanych, lub dodaj nowy)',
        'SEND_NOTIFICATION': 'Wysyłaj powiadomienia',
        'NONE': 'Brak',
        'MAIL': 'E-mail',
        'ADD_PRODUCT': 'Dodaj produkt',
        'CANCEL_ADD': 'Anuluj dodanie',
        'SEND_ISSUE': 'Wyślij zgłoszenie',
        'NEXT_STEP': 'Następny krok',
        'ADD': 'Dodaj',
        'STEP1': 'Krok 1/2',
        'STEP2': 'Krok 2/2',
        'INVOICE_NEED': 'Ta opcja wymaga podania faktury',
        'DELETE_SUCCESS_MSG': 'Zgłoszenie zostało usunięte',
        'DELETE_FAILURE_MSG': 'Zgłoszenie nie mogło zostać usunięte',
        'ISSUE_ADD_SUCCESS': 'Zgłoszenie zostało pomyślnie zapisane',
        'ISSUE_ADD_FAILURE': 'Zgłoszenie nie mogło zostać dodane',
        'FILL_FORM': 'Wypełnij wszystkie wymagane pola formularza',
        'FILL_ITEMS': 'Zgłoszenie nie zawiera żadnych produktów',
        'PRODUCT_ADD_SUCCESS': 'Produkt został pomyślnie dodany',
        'PRODUCT_ADD_FAILURE': 'Produkt nie mógł zostać dodany',
        'PRODUCT_DELETE_SUCCESS': 'Produkt został pomyślnie usunięty',
        'PRODUCT_DELETE_FAILURE': 'Produkt nie mógł zostać usunięty',
        'DONT_HAVE_ANY_PRODUCTS': 'Nie masz dodanych żadnych produktów',
        'NEXT_STEP_FAILURE': 'Nie można było przejść do następnego kroku',
        'REPAIR': 'Naprawa',
        'PARTS': 'Części',
        'CORRECTION': 'Korekta',
        'INSTALLATION': 'Montaż',
        'TRAINING': 'Szkolenie',
        'EXCHANGE': 'Wymiana',
        'SITECHECK': 'Wizja lokalna',
        'INSPECTION': 'Przegląd okresowy',
        'CANCELED': 'Anulowane',
        'COMPLETED': 'Zakończone',
        'ERROR': 'Błąd',
        'IN_PROGRESS': 'W trakcie',
        'OK': 'Wysłane',
        'NEW': 'Nowe',
        'RECEIVED': 'Odebrane',
        'EDIT_PRODUCT': 'Edycja produktu',
        'CANCEL_EDIT': 'Anuluj edycję',
        'SAVE_PRODUCT': 'Zapisz produkt',
        'SAVE_ISSUE': 'Zapisz zgłoszenie',
        'EDIT': 'Edytuj',
        'CHECK': 'Sprawdź poprawność',
        'CHECK_SUCCESS': 'Zgłoszenie jest poprawne',
        'ISSUE_IS_LOCKED': 'Zgłoszenie zostało już wysłane',
        'PHONE_REQUIRED': 'należy wypełnić przed wysłaniem',
        'CREATE_SUCCESS': 'Pomyślnie utworzono zgłoszenie',
        'SELECT_TYPE_FIRST': 'dodaj najpierw typ zgłoszenia',
        'ATTACHMENTS': 'Załączniki',
        'FILE_NAME': 'Nazwa pliku',
        'NO_ATTACHMENTS': 'Brak załączników do produktu',
        'FILE_UPLOAD_ERROR': 'Wystąpił błąd podczas zapisywania pliku',
        'FILE_UPLOADED': 'Zapisano plik',
        'FILE_UPLOADING': 'Zapisywanie',
        'FILE_ERROR_TOO_BIG': 'Plik zbyt duży. Maksymalna wielkość pliku nie może przekroczyć 70 MB',
        'FILES_ERROR_TOO_BIG_WARNING': 'Uwaga! Suma wielkości załączników nie może przekraczać 70M',
        'FILES_ERROR_TOO_BIG': 'Zgłoszenie nie może zostać wysłane. Proszę zmniejszyć wielkość załączników do 70M łącznie i wysłać zgłoszenie ponownie',
        'FILE_ERROR_TYPE': 'Nieobsługiwany typ pliku',
        'FILE_ERROR_UNKNOWN': 'Nieznany błąd zapisu',
        'DOWNLOAD_ATTACHMENT': 'Pobierz załącznik'
      },
      'Limited': 'Ograniczone',
      'Basic': 'Podstawowe',
      'Extended': 'Rozszerzone',
      '': '',
      'Customer with this username already exists': 'Użytkownik o podanym loginie już istnieje.',
      'Cannot create customer account, invalid user role.': 'Nieprawidłowe uprawnienia użytkownika.',
      'Cannot load cart, cart does not exist.': 'Nie można pobrać danych. Wybrany koszyk nie istnieje.',
      'Cannot place order, cart does not exist.': 'Nie można zrealizować zamówienia. Wybrany koszyk nie istnieje.',
      'Cannot update data, Company is required.': 'Nie można zapisać, nazwa firmy jest wymagana.',
      'Cannot update data, City is required.': 'Nie można zapisać, miasto jest wymagane.',
      'Cannot update data, Street is required.': 'Nie można zapisać, ulica jest wymagana.',
      'Cannot update data, Building number is required.': 'Nie można zapisać, numer budynku jest wymagany.',
      'Not Found': 'Żądany element nie istnieje w systemie.',
      'Forbidden': 'Brak dostępu.',
      'Conflict': 'Nie można dodać.',
      'Your password has been set': 'Hasło zostało zapisane.',
      ERRORS: {
        'POSTCODE': 'Nieprawidłowy kod pocztowy',
        'REQUIRED': 'Pole wymagane',
        'CURRENT_DATE': 'Nieprawidłowa data',
        'EMAIL': 'Nieprawidłowy adres e-mail',
        'VALID_DATE': 'Podaj prawidłową datę',
        'MAXSIZE': 'Plik zbyt duży'
      },
      NOTIFICATIONS: {
        'READ_MORE': 'Czytaj więcej'
      }
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*
   * This script decorate the toaster service and pass all the strings by the $translate service before show it
   * to the user.
   * If the translation ID is not found, it print the same string given.
   * TODO For now, its just translating the title of the notification.
   */

  /*@ngInject*/

  module.config(["$provide", function ($provide) {
    /*@ngInject*/
    $provide.decorator('toaster', ["$delegate", "$translate", function toasterDecorator($delegate, $translate) {
      function decorateFn(svc, method) {
        var org = svc[method];

        svc[method] = function (title, transValues) {
          var args = arguments; //Take the second argument as translations values

          transValues = angular.isObject(transValues) ? transValues : null;
          $translate(title, transValues).then( //If the translationID exist: show the translation
          function (titleTrans) {
            args[0] = titleTrans;
            org.apply($delegate, args);
          }, //If the translationID DON'T exist: show the translationID
          function (titleTransId) {
            args[0] = titleTransId;
            org.apply($delegate, args);
          });
        };
      }

      decorateFn($delegate, 'success');
      decorateFn($delegate, 'error');
      decorateFn($delegate, 'warning');
      decorateFn($delegate, 'info');
      return $delegate;
    }]);
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict'; //Configuring services

  /*@ngInject*/

  module.config(["orbaSessionProvider", "orbaSessionKeeperProvider", "orbaLoginEnforceProvider", "deployConf", function (orbaSessionProvider, orbaSessionKeeperProvider, orbaLoginEnforceProvider, deployConf) {
    //Session
    orbaSessionProvider.setAuthHost(deployConf.AuthHost);
    orbaSessionProvider.setClientId(deployConf.ClientId);
    orbaSessionProvider.setAuthPlugin(deployConf.AuthPlugin);
    orbaSessionProvider.obtainUserInfoAfterLogin(true); //Session memory

    orbaSessionKeeperProvider.enable(true);
    orbaSessionKeeperProvider.useLocalStorage(false); //Login enforcing

    orbaLoginEnforceProvider.loginFormViewState('auth.login');
    orbaLoginEnforceProvider.excludedViewStates([/^auth/i]);
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*
   * Initialization task that have to be executed in a specific order when the main module starts.
   */

  /*@ngInject*/

  module.run(["loginGhostMode", "cartActive", "orbaSessionKeeper", "orbaSession", function (loginGhostMode, cartActive, orbaSessionKeeper, orbaSession) {
    //Login in ghost model if a token is found
    loginGhostMode.run(); //Disable memory of active shopping cart in ghost sessions

    if (loginGhostMode.iAmGhost() && !loginGhostMode.rememberSession()) {
      cartActive.disableRemember();
    } //No session yet? No ghost session then. Maybe a save session in browser's memory?


    if (!orbaSession.isLoggedIn()) {
      //Try to restore a saved session (if no session is active yet)
      orbaSessionKeeper.restore(); //Try to load the saved cart

      cartActive.loadRememberedCart();
    }
  }]);
})(angular.module('app'));
"use strict";

/**
 * Router definitions.
 *
 * @author daniel.zegarra@orba.co
 */
(function (module) {
  'use strict'; //Registering routes

  /*@ngInject*/

  module.config(["$stateProvider", "$urlRouterProvider", "$locationProvider", "$breadcrumbProvider", "$urlMatcherFactoryProvider", function routesConfig($stateProvider, $urlRouterProvider, $locationProvider, $breadcrumbProvider, $urlMatcherFactoryProvider) {
    $locationProvider.html5Mode(true).hashPrefix('!');
    $urlRouterProvider.otherwise('/');
    $breadcrumbProvider.setOptions({
      includeAbstract: true,
      prefixStateName: 'home'
    });
    $stateProvider.state('home', {
      url: '/',
      templateUrl: 'app/home.html',
      controller: 'homeCtrl',
      ncyBreadcrumb: {
        label: 'GLOBAL.HOMEPAGE'
      }
    }) //AUTH ROUTES
    .state('auth', {
      url: '/auth',
      "abstract": true,
      templateUrl: 'app/auth/partials/index.html'
    }).state('auth.login', {
      url: '/login',
      templateUrl: 'app/auth/partials/login.html',
      controller: 'loginCtrl',
      ncyBreadcrumb: {
        label: 'GLOBAL.LOGIN'
      }
    }).state('auth.activateAccount', {
      url: '/activate-account/:token',
      templateUrl: 'app/auth/partials/activateAccount.html',
      controller: 'activateAccountCtrl',
      ncyBreadcrumb: {
        label: 'AUTH.ACTIVATE_ACCOUNT'
      }
    }).state('auth.recoverPassword', {
      url: '/recover-password',
      templateUrl: 'app/auth/partials/recoverPassword.html',
      controller: 'recoverPasswordCtrl',
      ncyBreadcrumb: {
        label: 'AUTH.CHANGE_PASSWORD'
      }
    }).state('auth.newPassword', {
      url: '/new-password/:token',
      templateUrl: 'app/auth/partials/newPassword.html',
      controller: 'newPasswordCtrl',
      ncyBreadcrumb: {
        label: 'AUTH.NEW_PASSWORD'
      }
    }).state('auth.setAgreements', {
      url: '/setAgreements',
      templateUrl: 'app/auth/partials/setAgreements.html',
      controller: 'setAgreementsCtrl',
      ncyBreadcrumb: {
        label: 'AUTH.SET_AGREEMENTS'
      }
    }) //ACCOUNT
    .state('account', {
      url: '/account',
      "abstract": true,
      templateUrl: 'app/account/partials/index.html',
      ncyBreadcrumb: {
        label: 'ACCOUNT.MY_ACCOUNT'
      }
    }) //MY DATA
    .state('account.myData', {
      url: '/my-data',
      templateUrl: 'app/account/partials/myData/index.html',
      ncyBreadcrumb: {
        label: 'ACCOUNT.MY_DATA'
      }
    }) //CONTACTS
    .state('account.contacts', {
      url: '/contacts',
      templateUrl: 'app/account/partials/contacts/index.html',
      ncyBreadcrumb: {
        label: 'ACCOUNT.CONTACT'
      }
    }) //DISTRIBUTOR LOGO
    .state('account.logo', {
      url: '/logo',
      templateUrl: 'app/account/partials/logo/index.html',
      ncyBreadcrumb: {
        label: 'ACCOUNT.MY_LOGO'
      }
    }) //ADDRESSES
    .state('account.addresses', {
      url: '/addresses',
      "abstract": true,
      template: '<ui-view/>',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('account.addresses.list', {
      url: '/list',
      templateUrl: 'app/account/partials/addresses/list.html',
      controller: 'accountAddressesListCtrl',
      ncyBreadcrumb: {
        label: 'ACCOUNT.MY_ADDRESS'
      }
    }).state('account.addresses.new', {
      url: '/new',
      templateUrl: 'app/account/partials/addresses/form.html',
      controller: 'accountAddressesFormCtrl',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: 'GLOBAL.NEW',
        parent: 'account.addresses.list'
      }
    }).state('account.addresses.update', {
      url: '/update/:id',
      templateUrl: 'app/account/partials/addresses/form.html',
      controller: 'accountAddressesFormCtrl',
      controllerAs: 'vm',
      resolve: {
        addressesResource: 'addressesResource',
        address: ["addressesResource", "$stateParams", "$state", "toaster", function (addressesResource, $stateParams, $state, toaster) {
          return addressesResource.get({
            id: $stateParams.id
          }).$promise["catch"](function () {
            toaster.error('ACCOUNT.ADDRESS_NOT_REACHABLE');
            $state.go('account.addresses.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: 'GLOBAL.UPDATE',
        parent: 'account.addresses.list'
      }
    }) //CLIENTS ROUTES
    .state('account.employee', {
      url: '/employee',
      "abstract": true,
      templateUrl: 'app/account/partials/client.html',
      template: '<ui-view/>',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('account.employee.list', {
      url: '/list',
      templateUrl: 'app/account/partials/employee/list.html',
      controller: 'accountEmployeeListCtrl',
      ncyBreadcrumb: {
        label: 'ACCOUNT.EMPLOYEES_LIST'
      },
      access: 'users.index'
    }).state('account.employee.new', {
      url: '/new',
      templateUrl: 'app/account/partials/employee/form.html',
      controller: 'accountEmployeeFormCtrl',
      ncyBreadcrumb: {
        label: 'GLOBAL.NEW',
        parent: 'account.employee.list'
      },
      access: 'users.add'
    }).state('account.employee.update', {
      url: '/update/:id',
      templateUrl: 'app/account/partials/employee/form.html',
      controller: 'accountEmployeeFormCtrl',
      ncyBreadcrumb: {
        label: 'GLOBAL.UPDATE',
        parent: 'account.employee.list'
      },
      access: 'users.edit'
    }).state('account.loyalty_program', {
      url: '/loyalty_program',
      templateUrl: 'app/account/partials/loyaltyProgram/index.html',
      controller: 'loyaltyProgramCtrl',
      ncyBreadcrumb: {
        skip: true
      }
    }) //CART ROUTES
    .state('cart', {
      url: '/cart',
      "abstract": true,
      templateUrl: 'app/cart/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('cart.list', {
      url: '/list',
      templateUrl: 'app/cart/partials/list.html',
      controller: 'cartListCtrl',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: 'CART.SHOPPING_CARTS_LIST'
      },
      access: 'carts.index'
    }).state('cart.new', {
      url: '/new',
      templateUrl: 'app/cart/partials/editor.html',
      ncyBreadcrumb: {
        label: 'GLOBAL.NEW',
        parent: 'cart.list'
      },
      access: 'carts.add'
    }).state('cart.update', {
      url: '/update/:id',
      templateUrl: 'app/cart/partials/editor.html',
      resolve: {
        cartsResource: 'cartsResource',
        cart: ["cartsResource", "$stateParams", "$state", "toaster", function (cartsResource, $stateParams, $state, toaster) {
          return cartsResource.get({
            id: $stateParams.id
          }).$promise["catch"](function () {
            toaster.error('CART.CART_NOT_AVAILABLE');
            $state.go('cart.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: 'GLOBAL.UPDATE',
        parent: 'cart.list'
      },
      access: 'carts.index'
    }) //FURNITURE OFFER ROUTES
    .state('furnitureoffer', {
      url: '/meble-niestandardowe',
      templateUrl: 'app/furnitureoffer/partials/form.html',
      controller: 'furnitureOffersNewCtrl',
      ncyBreadcrumb: {
        skip: true
      },
      access: 'furnitureoffer.index'
    }) //OFFER ROUTES
    .state('offer', {
      url: '/offer',
      "abstract": true,
      templateUrl: 'app/offer/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('offer.list', {
      url: '/list',
      templateUrl: 'app/offer/partials/list.html',
      controller: 'offerListCtrl',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: 'OFFER.LIST'
      },
      access: 'offers.index'
    }).state('offer.new', {
      url: '/new',
      templateUrl: 'app/offer/partials/editor.html',
      controller: 'offerEditorCtrl',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: 'GLOBAL.NEW',
        parent: 'offer.list'
      },
      access: 'offers.add'
    }).state('offer.update', {
      url: '/update/:id',
      templateUrl: 'app/offer/partials/editor.html',
      controller: 'offerEditorCtrl',
      controllerAs: 'vm',
      resolve: {
        offersResource: 'offersResource',
        offer: ["offersResource", "$stateParams", "$state", "toaster", function (offersResource, $stateParams, $state, toaster) {
          return offersResource.get({
            id: $stateParams.id
          }).$promise["catch"](function () {
            toaster.error('OFFER.OFFER_NOT_AVAILABLE');
            $state.go('offer.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: 'GLOBAL.UPDATE',
        parent: 'offer.list'
      },
      access: 'offers.index'
    }) //PRODUCT ROUTES
    .state('product', {
      url: '/product',
      "abstract": true,
      templateUrl: 'app/product/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('product.catalog', {
      url: '/catalog?s&p&sort&filter&{cid:int}',
      templateUrl: 'app/product/partials/catalog.html',
      params: {
        s: null,
        sort: "nameASC",
        cid: null,
        filter: null
      },
      controller: 'productCatalogCtrl',
      ncyBreadcrumb: {
        label: 'PRODUCT.PRODUCT_LIST'
      }
    }).state('product.quickInfo', {
      url: '/quick-info',
      templateUrl: 'app/product/partials/quickInfo.html',
      controller: 'quickInfoCtrl',
      controllerAs: 'vm',
      ncyBreadcrumb: {
        label: 'PRODUCT.QUICK_INFO'
      }
    }) //ORDER ROUTES
    .state('order', {
      url: '/order',
      "abstract": true,
      templateUrl: 'app/order/partials/index.html',
      ncyBreadcrumb: {
        label: 'CART.CHECKOUT'
      }
    }).state('order.step1', {
      url: '/step1/:cartId',
      templateUrl: 'app/order/partials/step1.html',
      ncyBreadcrumb: {
        label: 'ORDER.ORDERING'
      }
    }).state('order.step2', {
      url: '/step2/:cartId',
      templateUrl: 'app/order/partials/step2.html',
      ncyBreadcrumb: {
        label: 'ORDER.ORDER_SUMMARY'
      }
    }).state('order.step3', {
      url: '/step3/:code',
      templateUrl: 'app/order/partials/step3.html',
      ncyBreadcrumb: {
        label: 'ORDER.CONFIRMATION.TITLE'
      }
    }) // ORDERS ROUTES
    .state('orders', {
      url: '/orders',
      "abstract": true,
      templateUrl: 'app/order/partials/orders.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('orders.list', {
      url: '/list',
      templateUrl: 'app/order/partials/list.html',
      controller: 'orderListCtrl',
      ncyBreadcrumb: {
        label: 'ORDER.HISTORY'
      },
      access: 'orders.index'
    }).state('orders.item', {
      url: '/:id',
      templateUrl: 'app/order/partials/item.html',
      controller: 'orderItemCtrl',
      resolve: {
        ordersResource: 'ordersResource',
        order: ["ordersResource", "$stateParams", "$state", "toaster", function (ordersResource, $stateParams, $state, toaster) {
          return ordersResource.rest.get({
            id: $stateParams.id
          }).$promise["catch"](function (response) {
            toaster.error(response.data);
            $state.go('orders.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: "{{'ORDER.DETAILS' | translate}}",
        parent: 'orders.list'
      },
      access: 'order.index'
    }) // BLOCKS ROUTES
    .state('blocks', {
      url: '/page/:id',
      templateUrl: 'app/blocks/partials/item.html',
      controller: 'blocksItemCtrl',
      ncyBreadcrumb: {
        label: ' '
      }
    }) // ARTICLES ROUTES
    .state('news', {
      url: '/news',
      "abstract": true,
      templateUrl: 'app/articles/partials/index.html',
      params: {
        category: 'news'
      },
      ncyBreadcrumb: {
        skip: true
      }
    }).state('news.list', {
      url: '-list/',
      templateUrl: 'app/articles/partials/list.html',
      controller: 'articlesListCtrl',
      ncyBreadcrumb: {
        label: 'ARTICLES.news.SECTION'
      }
    }).state('news.item', {
      url: '/:id',
      templateUrl: 'app/articles/partials/item.html',
      controller: 'articlesItemCtrl',
      resolve: {
        articlesResource: 'articlesResource',
        news: ["articlesResource", "$stateParams", "$state", "toaster", function (articlesResource, $stateParams, $state, toaster) {
          return articlesResource.get({
            id: $stateParams.id
          }).$promise["catch"](function (response) {
            toaster.error(response.data);
            $state.go('news.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: ' ',
        parent: 'news.list'
      }
    }) // instructionB2B ROUTES
    .state('documentsB2B', {
      url: '/dokumenty-b2b',
      "abstract": true,
      templateUrl: 'app/articles/partials/index.html',
      params: {
        category: 'documents'
      },
      ncyBreadcrumb: {
        skip: true
      }
    }).state('documentsB2B.list', {
      url: '-lista/',
      templateUrl: 'app/articles/partials/list.html',
      controller: 'articlesListCtrl',
      ncyBreadcrumb: {
        label: 'ARTICLES.documents.SECTION'
      }
    }).state('documentsB2B.item', {
      url: '/:id',
      templateUrl: 'app/articles/partials/item.html',
      controller: 'articlesItemCtrl',
      resolve: {
        articlesResource: 'articlesResource',
        article: ["articlesResource", "$stateParams", "$state", "toaster", function (articlesResource, $stateParams, $state, toaster) {
          return articlesResource.get({
            id: $stateParams.id
          }).$promise["catch"](function (response) {
            toaster.error(response.data);
            $state.go('documentsB2B.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: ' ',
        parent: 'documentsB2B.list'
      }
    }) // INVOICES ROUTES
    .state('invoice', {
      url: '/invoice',
      "abstract": true,
      templateUrl: 'app/invoice/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('invoice.list', {
      url: '/list',
      templateUrl: 'app/invoice/partials/list.html',
      controller: 'invoiceListCtrl',
      ncyBreadcrumb: {
        label: 'INVOICE.LIST'
      },
      access: 'invoices.index'
    }).state('invoice.download', {
      url: '/download?id',
      controller: 'invoiceDownloadCtrl',
      ncyBreadcrumb: {
        label: 'INVOICE.LIST'
      }
    }) // PAYMENTS ROUTES
    .state('payment', {
      url: '/payment',
      "abstract": true,
      templateUrl: 'app/payment/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('payment.list', {
      url: '/list',
      templateUrl: 'app/payment/partials/list.html',
      ncyBreadcrumb: {
        label: 'FINANCES.SETTLEMENT'
      },
      access: 'payments.index'
    }) // SETTLEMENTS ROUTES
    .state('settlement', {
      url: '/settlement',
      "abstract": true,
      templateUrl: 'app/settlements/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('settlement.list', {
      url: '/list',
      templateUrl: 'app/settlements/partials/list.html',
      ncyBreadcrumb: {
        label: 'SETTLE.TITLE'
      },
      access: 'settlements.index'
    }) // COMPLAINTS ROUTES
    .state('complaints', {
      url: '/complaints',
      "abstract": true,
      templateUrl: 'app/complaints/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('complaints.list', {
      url: '-list',
      templateUrl: 'app/complaints/partials/list.html',
      controller: 'complaintListCtrl',
      ncyBreadcrumb: {
        label: 'COMPLAINT.TITLE'
      }
    }).state('complaints.item', {
      url: '/:id',
      templateUrl: 'app/complaints/partials/item.html',
      controller: 'complaintItemCtrl',
      resolve: {
        complaintsResource: 'complaintsResource',
        complaint: ["complaintsResource", "$stateParams", "$state", "toaster", function (complaintsResource, $stateParams, $state, toaster) {
          return complaintsResource.get({
            id: $stateParams.id
          }).$promise["catch"](function (response) {
            toaster.error(response.data);
            $state.go('complaints.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: ' ',
        parent: 'complaints.list'
      }
    }) // ISSUES ROUTES
    .state('issues', {
      url: '/issues',
      "abstract": true,
      templateUrl: 'app/issues/partials/index.html',
      ncyBreadcrumb: {
        skip: true
      }
    }).state('issues.list', {
      url: '-list',
      templateUrl: 'app/issues/partials/issuesList.html',
      controller: 'issuesListCtrl',
      ncyBreadcrumb: {
        label: 'ISSUE.ISSUES'
      }
    }) // We don't provide template for this route because we redirect user to edit page after new issues was created
    .state('issues.new', {
      url: '/new',
      controller: 'issuesNewCtrl',
      ncyBreadcrumb: {
        label: 'ISSUE.NEW_ISSUE',
        parent: 'issues.list'
      }
    }).state('issues.edit', {
      url: '/edit/:id',
      templateUrl: 'app/issues/partials/issuesNew.html',
      controller: 'issuesNewCtrl',
      resolve: {
        issuesResource: 'issuesResource',
        issue: ["issuesResource", "$stateParams", "$state", "toaster", function (issuesResource, $stateParams, $state, toaster) {
          return issuesResource.get({
            id: $stateParams.id
          }).$promise["catch"](function (response) {
            toaster.error(response && response.data || 'GLOBAL.UNKNOWN_ERROR');
            $state.go('issues.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: 'ISSUE.NEW_ISSUE',
        parent: 'issues.list'
      }
    }).state('issues.item', {
      url: '/:id',
      templateUrl: 'app/issues/partials/issuesItem.html',
      controller: 'issuesItemCtrl',
      resolve: {
        issuesResource: 'issuesResource',
        issue: ["issuesResource", "$stateParams", "$state", "toaster", function (issuesResource, $stateParams, $state, toaster) {
          return issuesResource.get({
            id: $stateParams.id
          }).$promise["catch"](function (response) {
            toaster.error(response && response.data || 'GLOBAL.UNKNOWN_ERROR');
            $state.go('issues.list');
          });
        }]
      },
      ncyBreadcrumb: {
        label: 'ISSUE.ISSUE',
        parent: 'issues.list'
      }
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /**
   * Deny the access to certain router states depending of the permissions of the role of the current user.
   * To use this script, define the "access" property with the resource.action in the router state definition.
   */

  /*@ngInject*/

  module.run(["$rootScope", "sessionAccess", "orbaSession", "toaster", "$state", function ($rootScope, sessionAccess, orbaSession, toaster, $state) {
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
      if (orbaSession.isLoggedIn() && angular.isDefined(toState.access) && angular.isString(toState.access)) {
        if (!sessionAccess.isActionAllowed(toState.access)) {
          event.preventDefault();
          toaster.error('AUTH.ROUTE_ACCESS_RESTRICTED'); //Send user to HOME is there's no previous router state

          if (fromState === null || angular.isObject(fromState) && fromState.name === '') {
            $state.go('home');
          }
        }
      }
    });
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*
   * Setting the failsafe's user role.
   */

  /*@ngInject*/

  module.config(["roleAccessProvider", "roleAccessBlacklist", function (roleAccessProvider, roleAccessBlacklist) {
    roleAccessProvider["default"] = roleAccessBlacklist["default"];
  }]);
  /*
   * Inform the user when he/she has a invalid role and is using the failsafe rules.
   */

  /*@ngInject*/

  module.run(["$rootScope", "roleAccess", "orbaSession", "toaster", function ($rootScope, roleAccess, orbaSession, toaster) {
    if (orbaSession.isLoggedIn()) {
      warnIfRoleIsFailSafe();
    } else {
      $rootScope.$on('onLogin', warnIfRoleIsFailSafe);
    }
    /**
     * Notify the user when is using the failsafe role.
     */


    function warnIfRoleIsFailSafe() {
      var sessionRoleId = orbaSession.getTokenPayload().sgrol;

      if (!roleAccess.roleHasRules(sessionRoleId)) {
        toaster.error('AUTH.YOU_ARE_USING_FAILSAFE_ROLE');
      }
    }
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.run(["moment", function (moment) {
    moment.locale('pl', {
      longDateFormat: {
        L: 'DD.MM.YYYY'
      }
    });
    moment.locale(['pl', 'en']);
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*
  * This script adds a function to the default HTTP response transformations stack to detect and auto-format all the
  * errors responses.
  * Notice that the transformResponse functions don't have access to the HTTP request configuration.
  */

  /*@ngInject*/

  module.config(["$provide", "$httpProvider", function ($provide, $httpProvider) {
    var defaultTransformResponse = $httpProvider.defaults.transformResponse;

    function errorTransform(data, headersFn, httpStatus) {
      var msg;

      if (angular.isObject(data)) {
        if (data.hasOwnProperty('data')) {
          data = data.data;
        }

        if (data.hasOwnProperty('message')) {
          msg = data.message;
        }

        if (data.hasOwnProperty('msg')) {
          msg = data.msg;
        }

        if (data.hasOwnProperty('errors')) {
          if (angular.isArray(data.errors) && data.errors.length > 0) {
            msg = data.errors.join('. ');
          } else if (angular.isString(data.errors) && data.errors.length > 0) {
            msg = data.errors;
          }
        }
      }

      return msg || data;
    }

    if (!angular.isArray(defaultTransformResponse)) {
      defaultTransformResponse = [defaultTransformResponse];
    }

    $httpProvider.defaults.transformResponse = defaultTransformResponse.concat(errorTransform);
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*@ngInject*/

  module.config(["cartActiveProvider", "cartConfig", function (cartActiveProvider, cartConfig) {
    cartActiveProvider.rememberSelection = cartConfig.rememberSelection;
  }]);
})(angular.module('app'));
"use strict";

(function (module) {
  'use strict';
  /*
   * Configuration of ncy-angular-breadcrumb.
   * Using a custom template to automatically translate the labels of the breadcrumb.
   */

  /*@ngInject*/

  module.config(["$breadcrumbProvider", function ($breadcrumbProvider) {
    $breadcrumbProvider.setOptions({
      template: '<ol class="breadcrumb">' + '<li ng-repeat="step in steps" ng-class="{active: $last}" ng-switch="$last || !!step.abstract">' + '<a ng-switch-when="false" href="{{step.ncyBreadcrumbLink}}" translate="{{step.ncyBreadcrumbLabel}}"></a>' + '<span ng-switch-when="true" translate="{{step.ncyBreadcrumbLabel}}"></span>' + '</li>' + '</ol>'
    });
  }]);
})(angular.module('app'));
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/home.html","<div class=\"dashboard\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <section class=\"row dashboard-panels\">\n            <div class=\"col-xs-6\">\n                <div class=\"row\">\n                    <div class=\"col-xs-6\" sg-access=\"carts.add\">\n                        <a class=\"dashboard-panel\" ui-sref=\"cart.new\">\n                            <h4 translate>CART.NEW</h4>\n                            <span translate>CART.CREATE_NEW</span>\n                        </a>\n                    </div>\n                    <div class=\"col-xs-6\" sg-access=\"offers.add\">\n                        <a class=\"dashboard-panel\" ui-sref=\"offer.new\">\n                            <h4 translate>OFFER.NEW</h4>\n                            <span translate>OFFER.CREATE_NEW</span>\n                        </a>\n                    </div>\n                    <div class=\"col-xs-6\" sg-access=\"carts.index\">\n                        <a class=\"dashboard-panel\" ui-sref=\"cart.list\">\n                            <h4 translate>CART.SHOPPING_CARTS_LIST</h4>\n                            <span>\n                                <span translate>CART.COUNT</span>:\n                                {{userData.user.carts.count}}\n                            </span>\n                        </a>\n                    </div>\n                    <div class=\"col-xs-6\" sg-access=\"offers.index\">\n                        <a class=\"dashboard-panel\" ui-sref=\"offer.list\">\n                            <h4 translate>OFFER.LIST</h4>\n                            <span>\n                            <span translate>OFFER.COUNT</span>:\n                            {{userData.user.offers.count}}\n                        </span>\n                        </a>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-3\">\n                <div class=\"clearfix\" sg-access=\"orders.index\">\n                    <a class=\"dashboard-panel\" ui-sref=\"orders.list\">\n                        <h4 translate>ORDER.HISTORY</h4>\n                        <span ng-if=\"userData.user.orders.last_date\">\n                            <span translate>ORDER.LAST_ORDER</span>:\n                            {{userData.user.orders.last_date | amDateFormat:\'DD.MM.YYYY\'}}\n                        </span>\n                        <span>\n                            <span translate>ORDER.COUNT</span>:\n                            {{userData.user.orders.count}}\n                        </span>\n                    </a>\n                </div>\n                <div class=\"clearfix\">\n                    <a class=\"dashboard-panel\" ui-sref=\"blocks({id:\'service_returns\'})\">\n                        <h4 translate>GLOBAL.RETURNS_AND_COMPLAINTS</h4>\n                    </a>\n                </div>\n            </div>\n            <div class=\"col-xs-3\">\n                <div class=\"clearfix\" sg-access=\"payments.index\">\n                    <a class=\"dashboard-panel\" ui-sref=\"payment.list\">\n                        <h4 translate>FINANCES.SETTLEMENT</h4>\n                        <span ng-if=\"userData.user.reseller.balance\">\n                            <span translate>FINANCES.BALANCE</span>:\n                            {{userData.user.reseller.balance | currency}}</span>\n                        <span ng-if=\"userData.user.reseller.arrear\">\n                            <span translate>FINANCES.OVERDUE</span>:\n                            {{userData.user.reseller.arrear | currency}}\n                        </span>\n                    </a>\n                </div>\n                <div class=\"clearfix\">\n                    <a class=\"dashboard-panel\" ui-sref=\"account.myData\">\n                        <h4 translate>ACCOUNT.MY_ACCOUNT</h4>\n                        <span translate>ACCOUNT.EDIT_SETTINGS</span>\n                    </a>\n                </div>\n            </div>\n        </section>\n        <section class=\"row home-news\" ng-if=\"news\">\n            <header class=\"col-xs-12\">\n                <a ui-sref=\"news.list\" class=\"see-all pull-right\" translate>ARTICLES.news.SEE_ALL</a>\n                <h2 translate>ARTICLES.news.NEWS</h2>\n            </header>\n            <article title=\"{{news.title}}\" class=\"col-xs-4\" ng-repeat=\"news in news track by $index\">\n                <a ui-sref=\"news.item({id: news.url_key})\">\n                    <div ng-if=\"news.thumbnail\" class=\"article-background\" style=\"background: url({{news.thumbnail}}) center center; background-size: cover\">\n                    </div>\n                    <div class=\"article-background default-bg\" style=\"background-image: url(/img/default_article_bg.jpeg); background-position: center center; background-size: cover\">\n                    </div>\n                </a>\n                <div class=\"default-container\">\n                    <h4>{{news.title}}</h4>\n                    <time>{{news.created_at | date : \"dd.MM.yyyy HH:mm\"}}</time>\n                    <p>{{news.lead}}</p>\n                    <p><a ui-sref=\"news.item({id: news.url_key})\" translate>GLOBAL.READ_MORE</a></p>\n                </div>\n            </article>\n        </section>\n        <section>\n            <div ng-if=\"showNotification()\" class=\"notification notification__footer\">\n                <div class=\"container\">\n                    <span>\n                        <span ng-bind-html=\"notification.message_content\"></span>\n                        <a href=\"{{notification.message_link}}\" ng-if=\"notification.message_link\">{{\'NOTIFICATIONS.READ_MORE\'|translate}}></a>\n                    </span>\n                </div>\n            </div>\n        </section>\n    </div>\n</div>");
$templateCache.put("app/directives/logo.html","<!--\n Logo of the seller company.\n-->\n<img ng-src=\"{{url}}\" class=\"logo\" alt=\"Logo. Press here to go to home\" height=\"50\">");
$templateCache.put("app/account/components/disagreementModal.html","<div class=\"modal-body no-padding\">\n    <div>\n        <div class=\"modal-body\">\n            <h3 translate>GLOBAL.ARE_YOU_SURE</h3>\n            <p translate>ACCOUNT.REMOVE_RULES_AGREEMENT</p>\n\n            <div class=\"import-actions\">\n                <button class=\"btn btn-primary\" ng-click=\"accept()\" translate>ACCOUNT.REMOVE_RULES_AGREEMENT_BUTTON\n                </button>\n            </div>\n\n            <div class=\"close-button\">\n                <button type=\"button\" class=\"close\" ng-click=\"$close()\" ng-attr-title=\"{{\'GLOBAL.CLOSE\'|translate}}\" ng-attr-aria-label=\"{{\'GLOBAL.CLOSE\'|translate}}\">\n                </button>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/account/components/sgAccountAddressForm.html","<form name=\"vm.accountAddressForm\" ng-submit=\"vm.submitForm()\" ng-class=\"{\'show-errors\': vm.showErrors}\" cg-busy=\"{promise:vm.requestPromise, message:\'\', minDuration:300}\">\n\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"new_address_label\" class=\"required\" translate>GLOBAL.ADDR_LABEL</label>\n        <input id=\"new_address_label\" ng-model=\"vm.model.label\" type=\"text\" name=\"label\" class=\"form-control\" maxlength=\"35\" required>\n    </div>\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"new_address_company\" class=\"required\" translate>ORDER.COMPANY</label>\n        <input id=\"new_address_company\" ng-model=\"vm.model.company\" type=\"text\" name=\"company\" class=\"form-control\" maxlength=\"255\" required>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-xs-6\" show-input-errors>\n            <label for=\"new_address_postcode\" class=\"required\" translate>GLOBAL.POSTAL_CODE</label>\n            <input id=\"new_address_postcode\" ng-model=\"vm.model.postcode\" type=\"text\" name=\"postcode\" uib-typeahead=\"postcode as postcode for postcode in vm.findPostCodes($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"0\" ui-validate=\"{postcode : \'vm.validatePostcode($value)\'}\" class=\"form-control\" required autocomplete=\"off\">\n            <span class=\"c-error\" ng-show=\"vm.accountAddressForm.postcode.$error.postcode\" translate>ERRORS.POSTCODE</span>\n        </div>\n        <div class=\"form-group col-xs-6\" show-input-errors>\n            <label for=\"new_address_city\" class=\"required\" translate>GLOBAL.CITY</label>\n            <input id=\"new_address_city\" ng-model=\"vm.model.city\" type=\"text\" name=\"city\" uib-typeahead=\"city as city for city in vm.findCities($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"1\" class=\"form-control\" maxlength=\"60\" required autocomplete=\"off\">\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-xs-9\" show-input-errors>\n            <label for=\"new_address_street\" class=\"required\" translate>GLOBAL.STREET</label>\n            <input id=\"new_address_street\" ng-model=\"vm.model.street\" type=\"text\" name=\"street\" uib-typeahead=\"street as street for street in vm.findStreets($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"1\" class=\"form-control\" maxlength=\"255\" required autocomplete=\"off\">\n        </div>\n        <div class=\"form-group col-xs-3\" show-input-errors>\n            <label for=\"new_address_building\" class=\"required\" translate>GLOBAL.BUILDING</label>\n            <input id=\"new_address_building\" ng-model=\"vm.model.building\" type=\"text\" name=\"building\" class=\"form-control\" maxlength=\"10\" required>\n        </div>\n    </div>\n\n    <h4 translate>ACCOUNT.CONTACT_IN_DELIVERY_PLACE</h4>\n\n    <div class=\"row\">\n        <div class=\"form-group col-xs-12\" show-input-errors>\n            <label for=\"new_address_fullname\" class=\"required\" translate>GLOBAL.FULLNAME</label>\n            <input id=\"new_address_fullname\" ng-model=\"vm.model.fullname\" type=\"text\" name=\"fullname\" class=\"form-control\" maxlength=\"255\" required>\n        </div>\n    </div>\n\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"new_address_telephone\" class=\"required\" translate>GLOBAL.PHONE</label>\n        <input id=\"new_address_telephone\" ng-model=\"vm.model.telephone\" type=\"text\" name=\"telephone\" class=\"form-control\" ui-mask=\"999-999-999\" required>\n    </div>\n\n    <!-- Checkbox visible when address is not the currently default -->\n    <div ng-if=\"vm.allowSetAsDefault\">\n        <div class=\"form-group\" ng-hide=\"vm.currentlyDefault\">\n            <input type=\"checkbox\" id=\"default_shipping\" ng-model=\"vm.model.is_default_shipping\">\n            <label for=\"default_shipping\" translate>ACCOUNT.SET_AS_DEFAULT_DELIVERY</label>\n        </div>\n        <div class=\"form-group\" ng-show=\"vm.currentlyDefault\" translate>ACCOUNT.DEFAULT_DELIVERY</div>\n    </div>\n\n    <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"vm.lastErrorMsg\">\n        <span translate=\"{{vm.lastErrorMsg}}\"></span>\n    </uib-alert>\n\n    <div class=\"form-group\">\n        <button type=\"submit\" class=\"btn btn-primary\" translate>GLOBAL.SAVE</button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.cancel()\" translate>GLOBAL.CANCEL</button>\n    </div>\n\n</form>");
$templateCache.put("app/account/components/sgAccountAddressSelectionTable.html","<table class=\"table\" st-table=\"vm.rowsFiltered\" st-safe-src=\"vm.rows\" cg-busy=\"{promise:vm.rows.$promise, message:\'\', minDuration:300}\">\n    <thead>\n    <tr>\n        <th st-sort=\"label\" translate>GLOBAL.ADDR_LABEL_LIST</th>\n        <th st-sort=\"street\" translate>GLOBAL.STREET</th>\n        <th st-sort=\"building\" translate>GLOBAL.BUILDING</th>\n        <th st-sort=\"postcode\" translate>GLOBAL.POSTAL_CODE</th>\n        <th st-sort=\"city\" translate>GLOBAL.CITY</th>\n        <th></th>\n    </tr>\n    <tr class=\"filters\">\n        <th>\n            <input st-search=\"label\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th>\n            <input st-search=\"street\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th class=\"column-building\">\n            <input st-search=\"building\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th class=\"column-postcode\">\n            <input st-search=\"postcode\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th class=\"column-city\">\n            <input st-search=\"city\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th></th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in vm.rowsFiltered\">\n        <td><span ng-if=\"row.label\">{{row.label}}</span><span ng-if=\"!row.label\">{{\'ACCOUNT.FILL_ADDR_LABEL\' | translate}}</span> <span class=\"defaultShipping\" ng-if=\"row.is_default_shipping\">{{\'GLOBAL.DEFAULT\' | translate}}</span></td>\n        <td>{{row.street}}</td>\n        <td>{{row.building}}</td>\n        <td>{{row.postcode}}</td>\n        <td>{{row.city}}</td>\n        <td class=\"actions text-right\">\n            <button type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"vm.edit(row)\" translate>GLOBAL.EDIT</button>\n            <button type=\"button\" class=\"btn btn-primary btn-sm\" ng-click=\"vm.select(row)\" translate>GLOBAL.SELECT</button>\n        </td>\n    </tr>\n    </tbody>\n    <tfoot>\n    <tr>\n        <td colspan=\"6\" class=\"text-center\">\n            <div st-pagination=\"\" st-items-by-page=\"pageLength\" st-displayed-pages=\"displayedPages\"></div>\n        </td>\n    </tr>\n    </tfoot>\n</table>\n\n<uib-alert type=\"info\" ng-show=\"vm.rows.$resolved && vm.rowsFiltered.length===0\">\n    <span translate>ACCOUNT.THERE_ARE_NO_ADDRESSES</span>\n</uib-alert>");
$templateCache.put("app/account/components/sgAccountBalance.html","<div class=\"row\" sg-access=\"payments.index\">\n    <div class=\"col-xs-5\">\n        <div class=\"row account-balance-item\">\n            <div class=\"col-xs-5 item-label\" translate>FINANCES.BALANCE</div>\n            <div class=\"col-xs-7 item-value\">{{vm.info.user.reseller.balance | currency}}</div>\n        </div>\n        <div class=\"row account-balance-item\">\n            <div class=\"col-xs-5 item-label\" translate>FINANCES.OVERDUE</div>\n            <div class=\"col-xs-7 item-value\">{{vm.info.user.reseller.arrear | currency}}</div>\n        </div>\n    </div>\n    <div class=\"col-xs-7\">\n        <div class=\"row account-balance-item\">\n            <div class=\"col-xs-7 item-label\" translate>ACCOUNT.CREDIT_LIMIT</div>\n            <div class=\"col-xs-5 item-value\">{{vm.info.user.reseller.credit_level | currency}}</div>\n        </div>\n        <div class=\"row account-balance-item\">\n            <div class=\"col-xs-7 item-label\" translate>FINANCES.AVAILABLE_FOR_USE</div>\n            <div class=\"col-xs-5 item-value\">{{vm.amountAvailable | currency}}</div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/account/components/sgAccountNavBar.html","<nav class=\"panel panel-default\">\n        <div class=\"panel-heading\">\n            <h3 class=\"panel-title\" translate>ACCOUNT.MY_ACCOUNT</h3>\n        </div>\n        <div class=\"panel-body\" role=\"navigation\">\n            <ul class=\"nav nav-pills nav-stacked account-nav\">\n                <li role=\"presentation\" ui-sref-active=\"active\">\n                    <a ui-sref=\"account.myData\" translate>ACCOUNT.MY_DATA</a>\n                </li>\n                <li role=\"presentation\" ui-sref-active=\"active\">\n                    <a ui-sref=\"account.logo\" translate>ACCOUNT.MY_LOGO</a>\n                </li>\n                <li role=\"presentation\" ui-sref-active=\"active\">\n                    <a ui-sref=\"account.addresses.list\" translate>ACCOUNT.MY_ADDRESS</a>\n                </li>\n                <li role=\"presentation\" ui-sref-active=\"active\" sg-access=\"users.index\">\n                    <a ui-sref=\"account.employee.list\" translate>ACCOUNT.EMPLOYEES_LIST</a>\n                </li>\n                <li role=\"presentation\" ui-sref-active=\"active\">\n                    <a ui-sref=\"account.contacts\" translate>ACCOUNT.CONTACT</a>\n                </li>\n                <li role=\"presentation\" ui-sref-active=\"active\">\n                    <a ui-sref=\"account.loyalty_program\" translate>ACCOUNT.LOYALTY_PROGRAM</a>\n                </li>\n            </ul>\n        </div>\n</nav>");
$templateCache.put("app/account/components/sgContactMozaic.html","<div class=\"col-xs-3\">\n    <div class=\"thumbnail\" ng-if=\"vm.model.image\">\n        <img class=\"media-object\" ng-src=\"{{vm.model.image}}\" alt=\"Contact\'s avatar\">\n    </div>\n</div>\n<div class=\"employee col-xs-9\">\n    <h5 class=\"media-heading\" ng-if=\"vm.title\">{{vm.title}}</h5>\n    <span class=\"contact-fullname\">{{vm.model.firstname}} {{vm.model.lastname}}</span>\n    <span class=\"contact-phone\" ng-if=\"vm.model.telephone\">\n        <abbr translate translate-attr-title=\"GLOBAL.PHONE\">GLOBAL.PHONE_ABBR</abbr> {{vm.model.telephone}}\n    </span>\n    <span class=\"contact-email\" ng-if=\"vm.model.email\">\n        <a ng-href=\"mailto:{{vm.model.email}}\">{{vm.model.email}}</a>\n    </span>\n</div>");
$templateCache.put("app/account/partials/index.html","<div class=\"account-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <div class=\"row\">\n\n            <sg-account-nav-bar class=\"col-sm-3\"></sg-account-nav-bar>\n\n            <div class=\"col-sm-9\">\n                <ui-view></ui-view>\n            </div>\n\n        </div>\n    </div>\n\n</div>");
$templateCache.put("app/articles/partials/index.html","<div class=\"articles-module\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/articles/partials/item.html","<div cg-busy=\"{promise:item.$promise,message:\'\'}\">\n<header>\n    <h1>{{item.title}}</h1>\n    <time>{{item.created_at | date : \"dd.MM.yyyy HH:mm\"}}</time>\n</header>\n<div class=\"content\" ng-bind-html=\"item.content\"></div>\n<div>\n    <a class=\"btn btn-default\" ui-sref=\"^.list\" translate>ARTICLES.RETURN_TO_LIST</a>\n</div>\n</div>");
$templateCache.put("app/articles/partials/list.html","<header class=\"page-header clearfix\">\n    <h1 class=\"pull-left\">{{title|translate}}</h1>\n</header>\n<table class=\"table\" cg-busy=\"{promise:paginator.rows.$promise,message:\'\',minDuration:300}\">\n    <thead>\n    <tr>\n        <th translate>ARTICLES.TITLE</th>\n        <th translate>GLOBAL.CREATION</th>\n        <th></th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in paginator.rows\">\n        <td>{{row.title}}</td>\n        <td>{{row.created_at | amDateFormat:\'DD.MM.YYYY HH:mm\'}}</td>\n        <td class=\"actions\">\n            <a class=\"btn btn-default btn-sm\" ui-sref=\"^.item({id: row.url_key})\" translate>GLOBAL.SEE</a>\n        </td>\n    </tr>\n    </tbody>\n</table>\n\n<div class=\"clearfix\" ng-show=\"paginator.pages > 1\">\n    <ul class=\"pull-right\" uib-pagination first-text=\"<<\" last-text=\">>\" previous-text=\"<\" next-text=\">\" items-per-page=\"paginator.limit\" total-items=\"paginator.total\" ng-model=\"paginator.page\" max-size=\"5\" force-ellipses=\"true\" boundary-links=\"true\"></ul>\n</div>\n<uib-alert type=\"info\" ng-show=\"paginator.rows.$resolved && paginator.rows.length===0\">{{\'ARTICLES.THERE_ARE_NO_ITEMS\' | translate}}</uib-alert>\n");
$templateCache.put("app/blocks/partials/item.html","<div class=\"blocks-module\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\" cg-busy=\"{promise:blocks.$promise,message:\'\'}\">\n                <header class=\"page-header clearfix\">\n                    <h1>{{block.title}}</h1>\n                </header>\n                <div class=\"content\" ng-bind-html=\"block.content\"></div>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/cart/components/activeCartWidget.html","<button class=\"main-container\" ng-click=\"vm.onPress()\" angular-ripple ng-disabled=\"!vm.isUserInteractionAllowed()\" sg-access=\"carts.index\">\n\n    <!-- Currently active cart info  -->\n    <div class=\"cart-active text-left with-cart-icon\" ng-show=\"vm.cart\" data-translate-attr=\"{title:\'CART.CURRENT_ACTIVE\'}\">\n        <div class=\"cart-name\">{{vm.cart.name}}</div>\n        <span class=\"cart-items-count\">{{vm.cart.items_qty}}</span>\n        <span translate>PRODUCT.ABBR</span>\n        <span class=\"cart-amount\">{{vm.cart.subtotal|currency}}</span>\n    </div>\n\n    <!-- Shown when no cart is currently active -->\n    <div class=\"no-cart-active text-muted with-cart-icon\" ng-hide=\"vm.cart\" translate>CART.SELECT_CURRENT_ACTIVE</div>\n\n</button>");
$templateCache.put("app/cart/components/addToCart.html","<form name=\"addToCartForm\" class=\"form-inline nowrap\" ng-submit=\"vm.addToCart(vm.qty)\" ng-if=\"vm.hasActiveCart()\">\n    <input type=\"number\" class=\"form-control text-center\" ng-model=\"vm.qty\" sg-disable-input-scroll name=\"qty\" uib-tooltip=\"{{vm.incrementErrorMsg}}\" tooltip-enable=\"vm.qtyValid && !vm.qtyIncValid\" tooltip-placement=\"left\" tooltip-is-open=\"vm.qtyValid && !vm.qtyIncValid\" ng-class=\"{\'invalid\': !vm.qtyValid || !vm.qtyIncValid}\" ng-min=\"1\" ng-step=\"vm.workCopy.qtyIncrements\">\n    <div class=\"btn-group-vertical\">\n        <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.increaseQty()\" ng-if=\"vm.qtyIncrements\" ng-disabled=\"!vm.increaseAvaliable()\">+</button>\n        <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.decreaseQty()\" ng-if=\"vm.qtyIncrements\" ng-disabled=\"!vm.decreaseAvaliable()\">-</button>\n    </div>\n\n    <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!vm.qtyValid || !vm.qtyIncValid\" translate>CART.ADD_TO_CART</button>\n</form>\n");
$templateCache.put("app/cart/components/cartActionsBar.html","<div role=\"toolbar\" class=\"row\" aria-label=\"Import and export list\">\n    <!-- Import and export -->\n    <div class=\"text-right col-xs-5\">\n        <button class=\"btn btn-link dark underline\" ng-show=\"vm.allowAddItems\" ng-disabled=\"vm.model.isPhantom()\" ng-click=\"vm.openImportModal()\" translate>GLOBAL.IMPORT_PRODUCTS</button>\n        </div>\n    <div class=\"text-center col-xs-2\">\n        <button type=\"button\" class=\"btn btn-link dark underline\" ng-disabled=\"!vm.cartHasItems()\" csv-header=\"vm.csvConfig.headers\" csv-column-order=\"vm.csvConfig.fields\" field-separator=\";\" ng-csv=\"vm.csvConfig.getData()\" filename=\"{{vm.csvConfig.filename}}\">\n            <span translate>GLOBAL.EXPORT_PRODUCTS</span>\n        </button>\n        </div>\n    <div class=\"col-xs-5 text-right\">\n        <button class=\"btn btn-default\" ng-disabled=\"!vm.model.canConvertToOffer()\" ng-click=\"vm.updateStocks()\" promise-btn>{{\'CART.RECALCULATE_AND_UPDATE_AVAILABILITY\'|translate}}</button>\n    </div>\n</div>");
$templateCache.put("app/cart/components/cartEditor.html","<div cg-busy=\"{promise:vm.model.$promise, message:\'\'}\">\n\n    <uib-alert type=\"danger\" ng-if=\"vm.fatalErrorMsg\">\n        <span translate=\"{{vm.fatalErrorMsg}}\"></span>\n    </uib-alert>\n\n    <header>\n        <div ng-switch=\"vm.editable || vm.model.isPhantom()\" class=\"name-container\">\n            <div ng-switch-when=\"false\">\n                <h4>{{vm.model.name}}</h4>\n            </div>\n            <div ng-switch-when=\"true\">\n                <sg-name-editor model=\"vm.model\" label=\"{{\'CART.NAME\'|translate}}\" placeholder=\"{{\'CART.TYPE_NEW_NAME\'|translate}}\" ng-show=\"vm.model.$resolved !== false\" on-request-change=\"vm.changeName(name)\"></sg-name-editor>\n            </div>\n        </div>\n\n        <sg-cart-actions-bar model=\"vm.model\" on-delete=\"vm.onDelete()\" allow-add-items=\"vm.allowAddItems\" update-stocks=\"vm.updateStocks()\" ng-if=\"!vm.model.isPhantom()\"></sg-cart-actions-bar>\n\n    </header>\n    <uib-alert type=\"danger\" close=\"vm.clearFailed()\" ng-show=\"vm.model.items_failed.length > 0\">\n        <span translate>CART.FAILED_SKU</span>:\n        <span class=\"failed-sku\" ng-repeat=\"sku in vm.model.items_failed track by $index\">{{sku}} {{$last ? \'\' : \', \'}}</span>\n    </uib-alert>\n    <uib-alert type=\"danger\" close=\"vm.clearOmitted()\" ng-if=\"vm.model.items_omitted.length > 0\">\n        <span translate>CART.OMITTED_SKU</span>:\n        <span class=\"failed-sku\">{{vm.getOmittedItems()}}</span>\n    </uib-alert>\n    <sg-cart-items model=\"vm.model\" selectable=\"true\" allow-add-items=\"vm.allowAddItems\" allow-edit-items=\"vm.allowEditItems\" allow-remove-items=\"vm.allowRemoveItems\" on-request-add=\"vm.addCartItem(item)\" on-request-update=\"vm.updateCartItem(item)\" on-request-remove=\"vm.removeCartItem(item)\" on-request-remove-multi=\"vm.removeCartItem(items)\" ng-if=\"!vm.model.isPhantom()\" promise-cart-changed=\"vm.promiseCartChanged\" items-waiting=\"vm.itemsWaiting\"></sg-cart-items>\n\n    <footer ng-if=\"!vm.model.isPhantom()\" class=\"clearfix\">\n        <div class=\"cart-summary\">\n            <sg-account-balance class=\"col-xs-6\"></sg-account-balance>\n            <sg-cart-summary model=\"vm.model\" class=\"col-xs-5 col-xs-offset-1\" ng-if=\"!vm.model.isPhantom()\"></sg-cart-summary>\n        </div>\n        <button type=\"button\" class=\"btn btn-primary btn-lg pull-right\" ng-show=\"vm.allowCreateQuote\" ng-disabled=\"vm.model.items.length==0\" ng-click=\"vm.createQuote()\" promise-btn>{{\'CART.CHECKOUT\'|translate}}</button>\n    </footer>\n\n</div>\n");
$templateCache.put("app/cart/components/cartItem.html","<!-- Position -->\n<td class=\"text-center\" ng-if=\"vm.workCopy.itemExists()\">\n    <span class=\"cart-item-position\">{{vm.position}}</span>\n</td>\n\n<!-- Selection control -->\n<td class=\"select-column\" ng-show=\"vm.selectable && vm.removable && vm.workCopy.itemExists()\">\n    <div ng-if=\"vm.workCopy.itemExists()\">\n        <input type=\"checkbox\" ng-attr-id=\"cartItem{{vm.model.item_id}}\" ng-model=\"vm.isSelected\">\n        <label ng-attr-for=\"cartItem{{vm.model.item_id}}\"></label>\n    </div>\n\n</td>\n<td ng-if=\"!vm.workCopy.itemExists()\" class=\"input-desc\" colspan=\"2\">\n    <strong translate>GLOBAL.INSERT_SKU</strong>\n</td>\n\n<!-- SKU -->\n<td ng-switch=\"vm.workCopy.itemExists()\">\n    <span ng-switch-when=\"true\" class=\"cart-item-sku\">{{vm.workCopy.sku}}</span>\n    <input ng-switch-when=\"false\" type=\"text\" class=\"form-control sku-input\" ng-model=\"vm.workCopy.sku\" name=\"sku\" ng-readonly=\"vm.workCopy.itemExists()\" maxlength=\"20\" size=\"6\" placeholder=\"{{vm.labels[\'CART.SKU_ABRV\']}}\" pattern=\"^[A-Za-z0-9]*$\" uib-typeahead=\"product.sku as product.label for product in vm.findProduct($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"2\" typeahead-select-on-blur=\"true\" typeahead-on-select=\"vm.updateDefaultQty($item)\" ng-enter=\"vm.saveChanges()\" ng-blur=\"vm.updateItemIfExist()\" ng-tab=\"vm.focusField(\'qty\', 10)\" ng-focus=\"vm.reserveSpaceForSuggestions()\" autocomplete=\"off\">\n</td>\n\n<!-- Product Name -->\n<td>\n    <span class=\"cart-item-name\">{{vm.workCopy.name}}</span>\n    <p ng-if=\"vm.workCopy.promotion_code_text\" class=\"promotion-info\">{{vm.workCopy.promotion_code_text}}</p>\n</td>\n<td class=\"icons\">\n    <product-info-button-launcher model=\"vm.workCopy\" allow-add-to-cart=\"false\" ng-show=\"vm.workCopy.itemExists()\"></product-info-button-launcher>\n    <product-related-button-launcher model=\"vm.workCopy\" user-limited=\"vm.userLimited\"></product-related-button-launcher>\n</td>\n\n<!-- Price -->\n<td class=\"text-center\">\n    <span ng-if=\"vm.workCopy.price >= vm.workCopy.promotion_price\" class=\"price cart-item-price\" ng-class=\"{\'price-deprecated\': vm.workCopy.itemIsInSale()}\">{{vm.workCopy.price | currency}}</span>\n    <span ng-show=\"vm.workCopy.itemIsInSale()\">{{vm.workCopy.promotion_price | currency}}</span>\n    <span class=\"attr\" ng-show=\"vm.loyaltyProgramEnabled()\">\n        <a href=\"/account/loyalty_program\">\n            <img ng-src=\"{{vm.getLoyaltyIconUrl()}}\" class=\"loyalty-icon\" alt=\"\">\n        </a>\n    </span>\n</td>\n\n<!-- Quantity -->\n<td>\n    <input type=\"number\" class=\"form-control text-center\" ng-readonly=\"!vm.editable\" ng-model=\"vm.workCopy.qty\" ng-model-options=\"{debounce: 100}\" name=\"qty\" sg-disable-input-scroll ng-class=\"{\'invalid\': !vm.qtyValid || !vm.qtyIncValid}\" uib-tooltip=\"{{vm.incrementErrorMsg}}\" tooltip-enable=\"vm.qtyValid && !vm.qtyIncValid\" tooltip-placement=\"left\" tooltip-is-open=\"vm.qtyValid && !vm.qtyIncValid\" ng-enter=\"vm.saveChanges()\" ng-tab=\"vm.focusField(\'sku\')\" ng-blur=\"vm.updateItemIfExist()\" ng-min=\"1\" ng-step=\"vm.workCopy.qtyIncrements\" size=\"3\">\n    <div class=\"btn-group-vertical\" ng-show=\"vm.editable\">\n        <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.increaseQty()\" ng-if=\"vm.workCopy.qtyIncrements\" ng-disabled=\"!vm.increaseAvaliable()\">+\n        </button>\n        <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.decreaseQty()\" ng-if=\"vm.workCopy.qtyIncrements\" ng-disabled=\"!vm.decreaseAvaliable()\">-\n        </button>\n    </div>\n</td>\n\n<!-- Availability -->\n<td class=\"cart-availability text-center\">\n    <span ng-if=\"vm.workCopy.itemExists()\" ng-class=\"vm.isQtyLessThanStock() == \'available\' ?\n           \'badge badge-success\' : vm.isQtyLessThanStock() == \'unavailable\' ?\n            \'badge badge-warning\' : vm.isQtyLessThanStock() == \'onorder\' ?\n             \'badge badge-onorder\' : \'badge badge-warning\'\" uib-tooltip=\"{{vm.isQtyLessThanStock() == \'available\' ?\n           \'\' : vm.isQtyLessThanStock() == \'unavailable\' ?\n            (vm.labels[\'CART.NOT_AVAILABLE_HELPTEXT\']) : vm.isQtyLessThanStock() == \'onorder\' ?\n             (vm.labels[\'CART.NOT_AVAILABLE_ON_ORDER\']) : (vm.labels[\'CART.NOT_AVAILABLE_HELPTEXT\'])}}\" data-placement=\"top\">{{vm.workCopy.calculateVisibleStock()}}</span>\n    <product-info-delivery model=\"vm.workCopy.dlvDate\"></product-info-delivery>\n</td>\n\n<!-- Discount percentage -->\n<td class=\"percentage-column text-center\">\n    <span ng-show=\"vm.workCopy.itemExists()\">{{(vm.workCopy.discount || 0) | number:2}}%</span>\n    <span ng-show=\"vm.workCopy.discount_group\" ng-class=\"{\'deprecated\': vm.workCopy.itemIsInSale()}\" class=\"discount-group\">({{vm.workCopy.discount_group}})</span>\n</td>\n\n<!-- Custom price -->\n<td class=\"text-right\">{{vm.workCopy.reseller_price | currency}}</td>\n\n<!-- Subtotal price amount -->\n<td class=\"text-right\">{{vm.workCopy.row_total_excl_tax | currency}}</td>\n\n<!-- Remove item from cart -->\n<td class=\"remove-column\" ng-if=\"vm.removable\">\n    <confirmable ng-if=\"vm.removeButtonVisible\" unconfirmed-text=\"{{::vm.labels[\'GLOBAL.REMOVE\']}}\" confirming-text=\"{{::vm.labels[\'GLOBAL.SURE?\']}}\" when-confirmed=\"vm.requestRemove\" ng-show=\"vm.workCopy.itemExists()\">\n        <button class=\"btn btn-danger\">\n            <confirmable-outlet></confirmable-outlet>\n        </button>\n    </confirmable>\n</td>\n");
$templateCache.put("app/cart/components/cartItems.html","<div rows=\"vm.model.items\" cg-busy=\"{promise:vm.model.$promise, message:\'\'}\">\n    <table class=\"table table-striped\" cg-busy=\"{promise:rows.$promise,message:\'\',minDuration:300}\" ng-show=\"vm.isCartLoaded()\" data-sticky-header>\n        <thead>\n        <tr class=\"table-header\">\n            <th class=\"id-column text-center\">{{::vm.labels[\'CART.ITEM_POSITION\']}}</th>\n            <th class=\"select-column\" ng-show=\"vm.selectable && vm.allowRemoveItems\">\n                <input id=\"cartItemsBatchSelectCheckbox\" type=\"checkbox\" ng-model=\"vm.areAllSelected\" ng-change=\"vm.applyBatchSelection(vm.areAllSelected)\">\n                <label for=\"cartItemsBatchSelectCheckbox\"></label>\n            </th>\n            <th class=\"sku-column\">{{::vm.labels[\'CART.SKU\']}}</th>\n            <th class=\"name-column\" colspan=\"2\">{{::vm.labels[\'CART.PRODUCT\']}}</th>\n            <th class=\"price-column text-center has-qi\">\n                <span uib-tooltip=\"{{::vm.labels[\'CART.PRICE_OF_LIST_HELPTEXT\']}}\" tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                    {{::vm.labels[\'CART.PRICE_OF_LIST\']}}\n                </span>\n            </th>\n            <th class=\"qty-column text-center\">{{::vm.labels[\'CART.QUANTITY\']}}</th>\n            <th class=\"availability-column text-center has-qi\">\n                <span uib-tooltip=\"{{::vm.labels[\'CART.AVAILABILITY_HELPTEXT\']}}\" tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                    {{::vm.labels[\'CART.AVAILABILITY\']}}\n                </span>\n            </th>\n            <th class=\"discount-column text-center has-qi\">\n                <span uib-tooltip=\"{{::vm.labels[\'CART.YOUR_DISCOUNT_HELPTEXT\']}}\" tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                    {{::vm.labels[\'CART.YOUR_DISCOUNT\']}}\n                </span>\n            </th>\n            <th class=\"price-column text-right\">{{::vm.labels[\'CART.YOUR_PRICE\']}}</th>\n            <th class=\"price-column text-right\">{{::vm.labels[\'CART.BOTH_PRICES\']}}</th>\n            <th class=\"remove-column\" ng-show=\"vm.allowRemoveItems\"></th>\n        </tr>\n        <tr class=\"loader\" cg-busy=\"{promise:vm.promiseCartChanged, message:\'\'}\">\n        </tr>\n        </thead>\n        <tbody>\n\n        <!-- Rows for each existing items in the cart -->\n        <tr sg-cart-item ng-repeat=\"item in vm.model.items track by $index\" model=\"item\" position=\"$index+1\" selectable=\"vm.selectable\" is-selected=\"vm.isSelected(item)\" editable=\"vm.allowEditItems\" removable=\"vm.allowRemoveItems\" on-request-update=\"vm.onRequestUpdate({item:item})\" on-request-remove=\"vm.onRequestRemove({item:item})\" on-selection-change=\"vm.updateSelection(item, selected)\"></tr>\n\n        <!-- Row to add a new item -->\n        <tr sg-cart-item class=\"add-new-item\" ng-show=\"vm.allowAddItems\" selectable=\"vm.selectable\" editable=\"true\" removable=\"vm.allowRemoveItems\" on-request-create=\"vm.requestAdd(item)\" sku-exclude-list=\"vm.usedSKUs\" is-product-in-cart=\"vm.isProductInCart\"></tr>\n        </tbody>\n    </table>\n\n    <!-- Remove all the selected items -->\n    <button class=\"btn btn-danger\" mwl-confirm ng-show=\"vm.selectable && vm.allowRemoveItems\" data-title=\"{{::vm.labels[\'GLOBAL.REMOVE_SELECTION\']}}\" message=\"{{::vm.labels[\'GLOBAL.ARE_YOU_SURE\']}}\" confirm-text=\"{{::vm.labels[\'GLOBAL.YES\']}}\" cancel-text=\"{{::vm.labels[\'GLOBAL.NO\']}}\" on-confirm=\"vm.removeAllSelected()\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" ng-disabled=\"vm.selection.length==0\">{{::vm.labels[\'GLOBAL.REMOVE_SELECTION\']}}</button>\n\n    <!-- Download a PDF cart of all the selected items -->\n    <button class=\"btn btn-default\" type=\"button\" ng-show=\"vm.selectable\" data-title=\"{{::vm.labels[\'GLOBAL.DOWNLOAD_CARD_FOR_SELECTED\']}}\" ng-click=\"vm.downloadCardForSelected()\" ng-disabled=\"vm.selection.length==0\">\n      {{ ::vm.labels[\'GLOBAL.DOWNLOAD_CARD_FOR_SELECTED\'] }}\n    </button>\n</div>\n");
$templateCache.put("app/cart/components/cartItems2.html","<div cg-busy=\"{promise:vm.model.$promise, message:\'\'}\">\n\n    <uib-alert type=\"danger\" ng-if=\"vm.fatalErrorMsg\">\n        <span translate=\"{{vm.fatalErrorMsg}}\"></span>\n    </uib-alert>\n\n    <uib-alert type=\"danger\" close=\"vm.clearFailed()\" ng-show=\"vm.model.items_failed.length > 0\">\n        <span translate>CART.FAILED_SKU</span>:\n        <span class=\"failed-sku\" ng-repeat=\"sku in vm.model.items_failed track by $index\">{{sku}} {{$last ? \'\' : \', \'}}</span>\n    </uib-alert>\n    <uib-alert type=\"danger\" close=\"vm.clearOmitted()\" ng-if=\"vm.model.items_omitted.length > 0\">\n        <span translate>CART.OMITTED_SKU</span>:\n        <span class=\"failed-sku\">{{vm.getOmittedItems()}}</span>\n    </uib-alert>\n    <sg-cart-items model=\"vm.model\" selectable=\"false\" allow-add-items=\"vm.allowAddItems\" allow-edit-items=\"vm.allowEditItems\" allow-remove-items=\"vm.allowRemoveItems\" on-request-add=\"vm.addCartItem(item)\" on-request-update=\"vm.updateCartItem(item)\" on-request-remove=\"vm.removeCartItem(item)\" on-request-remove-multi=\"vm.removeCartItem(items)\" ng-if=\"!vm.model.isPhantom()\" promise-cart-changed=\"vm.promiseCartChanged\" items-waiting=\"vm.itemsWaiting\"></sg-cart-items>\n</div>\n");
$templateCache.put("app/cart/components/cartSummary.html","<div class=\"row summary-labels\">\n    <div class=\"col-xs-4\"></div>\n    <div class=\"col-xs-4\" translate>CART.AVAILABLE</div>\n    <div class=\"col-xs-4\" translate>CART.ALL</div>\n</div>\n<div class=\"separator\"></div>\n<div class=\"row summary-net\">\n    <div class=\"col-xs-4\" translate>CART.NET_AMOUNT</div>\n    <div class=\"col-xs-4 price-value available price-highlight\">{{vm.model.calAvailableNetAmount() | currency}}</div>\n    <div class=\"col-xs-4 price-value all\">{{vm.model.subtotal | currency}}</div>\n</div>\n<div class=\"row summary-gross\">\n    <div class=\"col-xs-4\" translate>CART.GROSS_AMOUNT</div>\n    <div class=\"col-xs-4 price-value available price-highlight\">{{vm.model.calAvailableGrossAmount() | currency}}</div>\n    <div class=\"col-xs-4 price-value all\">{{vm.model.grand_total | currency}}</div>\n</div>\n<div class=\"row summary-shipping\" ng-if=\"vm.quote.sg_delivery_method\">\n    <div class=\"col-xs-4\" translate>ORDER.DELIVERY_METHOD</div>\n    <div class=\"col-xs-8 price-value available price-highlight\" ng-if=\"vm.quote.sg_delivery_method != \'courier_cod\'\">{{\'ORDER.\'+vm.quote.sg_delivery_method | translate}}</div>\n    <div class=\"col-xs-8 price-value available price-highlight\" ng-if=\"vm.quote.sg_delivery_method == \'courier_cod\' && vm.quote.sg_cod_amount >= 0\" translate translate-values=\"{cod_amount: vm.model.formatCurrency(vm.quote.sg_cod_amount)}\">ORDER.COURIER_COD_WITH_AMOUNT</div>\n</div>\n");
$templateCache.put("app/cart/partials/editor.html","<div ng-controller=\"cartEditorCtrl as vm\">\n\n    <header class=\"page-header\">\n        <h1 translate>CART.CART</h1>\n        <button type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.convertToOffer()\" ng-hide=\"vm.model.isPhantom()\" sg-access=\"carts.toOffer\" ng-disabled=\"!vm.model.canConvertToOffer()\" ng-attr-title=\"{{vm.getConvertToOfferHint()}}\" translate>CART.CONVERT_TO_OFFER</button>\n    </header>\n    <div cg-busy=\"{promise:vm.import, message:\'\'}\">\n        <sg-cart-editor model=\"vm.model\" editable=\"vm.access.carts.edit\" allow-create-quote=\"vm.access.quote.add\" allow-add-items=\"vm.access.cartItems.add\" allow-edit-items=\"vm.access.cartItems.edit\" allow-remove-items=\"vm.access.cartItems.delete\" on-load=\"vm.activateCart(model)\" on-cancel=\"vm.goBack()\" on-create=\"vm.changeToUpdateMode(model)\" on-delete=\"vm.goBack()\" on-quote-created=\"vm.startOrderProcess(quote)\"></sg-cart-editor>\n    </div>\n</div>");
$templateCache.put("app/cart/partials/index.html","<div class=\"cart-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>");
$templateCache.put("app/cart/partials/list.html","<header class=\"page-header clearfix\">\n    <h1 class=\"pull-left\" translate>CART.SHOPPING_CARTS_LIST</h1>\n    <div class=\"pull-right\">\n      <button class=\"btn btn-link dark\" ng-click=\"vm.openImportModal()\" sg-access=\"carts.add\" translate>CART.IMPORT_XML\n      </button>\n      <button class=\"btn btn-primary\" ng-click=\"vm.createCart()\" sg-access=\"carts.add\" translate>CART.NEW\n      </button>\n    </div>\n</header>\n\n<table class=\"table table-striped\" st-table=\"paginator.rows\" st-pipe=\"vm.updateResults\" cg-busy=\"{promise:paginator.$promise, message:\'\'}\">\n    <thead>\n    <tr>\n        <th translate>CART.NAME</th>\n        <th translate>GLOBAL.CREATION</th>\n        <th translate>GLOBAL.CREATOR</th>\n        <th translate>GLOBAL.LAST_UPDATE</th>\n        <th translate>CART.PRODUCT_COUNT</th>\n        <th translate>CART.NET_AMOUNT</th>\n        <th></th>\n    </tr>\n    <tr class=\"filters\">\n        <th>\n            <input st-search=\"name\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th>\n            <datepicker datepicker-model button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                <input id=\"filter_created_at\" datepicker datepicker-model ng-model=\"vm.filters.created_at\" st-search=\"created_at\" type=\"text\" name=\"filter_created_to\" class=\"form-control\">\n            </datepicker>\n        </th>\n        <th>\n            <input st-search=\"customer_name\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th>\n            <datepicker datepicker-model button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                <input id=\"filter_updated_at\" datepicker datepicker-model ng-model=\"vm.filters.updated_at\" st-search=\"updated_at\" type=\"text\" name=\"filter_updated_at\" class=\"form-control\" placeholder=\"{{\'GLOBAL.DATE_FORMAT_CODE\'|translate}}\">\n            </datepicker>\n        </th>\n        <th colspan=\"2\"></th>\n        <th class=\"limit-th\">\n            <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n            <div class=\"wrapSelect\">\n                <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n            </div>\n        </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in paginator.rows\">\n        <td>{{row.name}}</td>\n        <td>{{row.created_at | date}}</td>\n        <td>{{row.customer_fullname}}</td>\n        <td>{{row.updated_at | date}}</td>\n        <td>{{row.items_qty}}</td>\n        <td>{{row.subtotal | currency}}</td>\n        <td class=\"text-right no-wrap actions\">\n            <button class=\"btn btn-default btn-sm\" role=\"button\" ng-click=\"vm.openCart(row)\" translate>GLOBAL.SELECT\n            </button>\n            <button type=\"button\" class=\"btn btn-danger btn-sm\" mwl-confirm data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"vm.deleteCart(row)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" role=\"button\" sg-access=\"carts.delete\" translate>GLOBAL.DELETE\n            </button>\n        </td>\n    </tr>\n    </tbody>\n    <tfoot>\n    <tr>\n        <td colspan=\"7\" class=\"text-right\">\n            <sg-pagination paginator=\"paginator\"></sg-pagination>\n        </td>\n    </tr>\n    </tfoot>\n</table>\n\n<uib-alert type=\"info\" ng-show=\"paginator.$resolved && paginator.rows.length===0\">\n    <span translate>CART.THERE_IS_NO_CARTS</span>\n</uib-alert>\n\n<uib-alert type=\"danger\" ng-show=\"errorMsg\">\n    <span translate>{{errorMsg}}</span>\n</uib-alert>\n");
$templateCache.put("app/cart/partials/new.html","<header class=\"page-header\">\n    <h1 translate>CART.CART</h1>\n</header>\n\n<sg-cart-editor on-cancel=\"goBack()\" on-delete=\"goBack()\"></sg-cart-editor>\n");
$templateCache.put("app/auth/components/form.html","<!--\n Directive sgLoginForm\n Template of the form to auth in the system.\n-->\n<div class=\"panel panel-default\" cg-busy=\"{promise:loginRequestPromise,message:\'\',minDuration:300}\">\n    <form name=\"form\" novalidate ng-submit=\"login()\">\n\n        <div class=\"row\">\n            <div class=\"col-xs-8 col-xs-push-2\">\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"login_username\">\n                        <p class=\"login-inline-info\" translate>GLOBAL.USERNAME</p>\n                        <p class=\"login-inline-info\" translate>GLOBAL.USERNAME_INFO</p>\n                    </label>\n                    <input ng-model=\"username\" required autofocus type=\"text\" id=\"login_username\" name=\"username\" class=\"form-control\" is-dirty=\"true\" uib-tooltip=\"{{\'GLOBAL.LOGIN_USERNAME_POPUP\'|translate}}\" tooltip-popup-delay=\"500\" tooltip-placement=\"left\">\n                    <div ng-messages=\"form.username.$error\" role=\"alert\" class=\"help-block\">\n                        <div ng-message=\"required\" translate>GLOBAL.FIELD_REQUIRED_VALIDATION_MSG</div>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"login_password\" translate>GLOBAL.PASSWORD</label>\n                    <input ng-model=\"password\" required type=\"password\" id=\"login_password\" name=\"password\" class=\"form-control\" is-dirty=\"true\" uib-tooltip=\"{{\'GLOBAL.LOGIN_PASSWORD_POPUP\'|translate}}\" tooltip-popup-delay=\"500\" tooltip-placement=\"left\">\n                    <div ng-messages=\"form.password.$error\" role=\"alert\" class=\"help-block\">\n                        <div ng-message=\"required\" translate>GLOBAL.FIELD_REQUIRED_VALIDATION_MSG</div>\n                    </div>\n                </div>\n\n                <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"errorMsg\">{{errorMsg | translate}}</uib-alert>\n            </div>\n\n        </div>\n\n        <div class=\"row buttons\">\n            <div class=\"col-xs-8 col-xs-push-2\">\n                <div class=\"pull-left remember-password-link\" ng-hide=\"sessionSvc.isLoggedIn()\">\n                    <a ui-sref=\"auth.recoverPassword\" translate uib-tooltip=\"{{\'GLOBAL.LOGIN_REMEMBER_PASSWORD_POPUP\'|translate}}\" tooltip-popup-delay=\"500\" tooltip-placement=\"bottom\">\n                        AUTH.NO_REMEMBER_PASSWORD\n                    </a>\n                </div>\n                <button class=\"btn btn-primary btn-lg pull-right\" type=\"submit\" ng-hide=\"sessionSvc.isLoggedIn()\" ng-disabled=\"form.$invalid\" translate>GLOBAL.LOGIN\n                </button>\n            </div>\n        </div>\n\n    </form>\n</div>\n");
$templateCache.put("app/auth/partials/activateAccount.html","<div ng-switch=\"status\">\n\n    <div ng-switch-when=\"checkingToken\">\n        <header class=\"page-header\">\n            <h1 translate>AUTH.VALIDATING_TOKEN_MSG</h1>\n        </header>\n    </div>\n\n    <div ng-switch-when=\"tokenInvalid\">\n        <header class=\"page-header\">\n            <h1 translate>AUTH.TOKEN_INVALID_MSG</h1>\n        </header>\n    </div>\n\n    <div ng-switch-when=\"tokenValid\">\n        <header class=\"page-header\">\n            <h1 translate>AUTH.WELCOME</h1>\n        </header>\n\n        <div ng-bind-html=\"getWelcomeText()\"></div>\n\n        <p translate>AUTH.INFORMATION_OF_YOUR_ACCOUNT</p>\n\n        <div class=\"container\">\n            <div>\n                <label translate>GLOBAL.FULLNAME</label>\n                <span>{{userBasicData.firstname}} {{userBasicData.lastname}}</span>\n            </div>\n            <div>\n                <label translate>GLOBAL.USERNAME</label>\n                <span>{{userBasicData.username}}</span>\n            </div>\n            <div>\n                <label translate>GLOBAL.EMAIL</label>\n                <span>{{userBasicData.email}}</span>\n            </div>\n            <div>\n                <label translate>GLOBAL.ROLE</label>\n                <span>{{userBasicData.role}}</span>\n            </div>\n        </div>\n\n        <form name=\"form\" ng-submit=\"sendCreatePassword()\" cg-busy=\"{promise:settingPasswordPromise,message:\'\',minDuration:300}\">\n            <div class=\"row\">\n                <div class=\"well\">\n                    <div ng-include=\"\'app/auth/partials/createPasswordForm.html\'\"></div>\n                </div>\n            </div>\n        </form>\n    </div>\n\n</div>\n");
$templateCache.put("app/auth/partials/changePasswordForm.html","<div class=\"row\">\n    <div class=\"form-group col-sm-6\" show-input-errors>\n        <label for=\"login_new_pass\" translate>AUTH.NEW_PASSWORD</label>\n        <input id=\"login_new_pass\" class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"password\" autofocus required ng-minlength=\"7\" ng-maxlength=\"100\">\n        <div ng-messages=\"form.password.$error\" role=\"alert\">\n            <div ng-message=\"required\">\n                <span class=\"help-block\" translate>AUTH.TYPE_NEW_PASSWORD</span>\n            </div>\n            <div ng-message=\"minlength\">\n                <span class=\"help-block\" translate data-translate-value-minlength=\"7\">AUTH.PASSWORD_MIN_LENGTH_VALIDATION_MSG</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group col-sm-6\" show-input-errors>\n        <label for=\"login_new_pass_confirmation\" translate>AUTH.REPEAT_NEW_PASSWORD</label>\n        <input id=\"login_new_pass_confirmation\" class=\"form-control\" type=\"password\" name=\"password_check\" ng-model=\"password_check\" ng-disabled=\"form.password.$invalid\" ui-validate=\"\'$value==password\'\" ui-validate-watch=\"\'password\'\" required>\n        <div ng-messages=\"form.password_check.$error\" role=\"alert\">\n            <div ng-message=\"validator\">\n                <span class=\"help-block\" translate>AUTH.PASSWORD_NOT_EQUAL_VALIDATION_MSG</span>\n            </div>\n        </div>\n    </div>\n</div>\n<div class=\"form-group clearfix\">\n    <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"lastErrorMsg\">{{lastErrorMsg | translate}}</uib-alert>\n    <button class=\"btn btn-primary btn-lg pull-right\" type=\"submit\" ng-disabled=\"form.$invalid\" translate>GLOBAL.SUBMIT</button>\n</div>\n");
$templateCache.put("app/auth/partials/createPasswordForm.html","<div class=\"row\">\n    <h2 translate>AUTH.CHANGE_PASSWORD</h2>\n    <div class=\"form-group col-sm-6\" show-input-errors>\n        <label for=\"login_new_pass\" class=\"required\" translate>AUTH.NEW_PASSWORD</label>\n        <input id=\"login_new_pass\" class=\"form-control\" type=\"password\" name=\"password\" ng-model=\"passwordModel.password\" autofocus required ng-minlength=\"7\" ng-maxlength=\"100\">\n        <div ng-messages=\"form.password.$error\" role=\"alert\">\n            <div ng-message=\"required\">\n                <span class=\"help-block\" translate>AUTH.TYPE_NEW_PASSWORD</span>\n            </div>\n            <div ng-message=\"minlength\">\n                <span class=\"help-block\" translate data-translate-value-minlength=\"7\">AUTH.PASSWORD_MIN_LENGTH_VALIDATION_MSG</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group col-sm-6\" show-input-errors>\n        <label for=\"login_new_pass_confirmation\" class=\"required\" translate>AUTH.REPEAT_NEW_PASSWORD</label>\n        <input id=\"login_new_pass_confirmation\" class=\"form-control\" type=\"password\" name=\"password_check\" ng-model=\"password_check\" ng-disabled=\"form.password.$invalid\" ui-validate=\"\'$value==passwordModel.password\'\" ui-validate-watch=\"\'password\'\" required>\n        <div ng-messages=\"form.password_check.$error\" role=\"alert\">\n            <div ng-message=\"validator\">\n                <span class=\"help-block\" translate>AUTH.PASSWORD_NOT_EQUAL_VALIDATION_MSG</span>\n            </div>\n        </div>\n    </div>\n</div>\n\n<div class=\"row\">\n    <h3 class=\"label-required\" translate>AUTH.AGREEMENT_RULES</h3>\n    <div class=\"form-group\" show-input-errors ng-class=\"{\'has-error\' : form.agreement_rules.$invalid}\">\n        <input type=\"checkbox\" id=\"agreement_rules\" name=\"agreement_rules\" ng-model=\"passwordModel.agreement_rules\" ng-required=\"true\">\n        <label for=\"agreement_rules\" class=\"inline\" ng-bind-html=\"getRulesLabel()\"></label>\n        <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.rulesToggle=!vm.rulesToggle\" ng-hide=\"vm.rulesToggle\" translate>AUTH.SEE_TERMS</a>\n    </div>\n\n    <div ng-show=\"vm.rulesToggle\" class=\"agreement-readmore ng-hide\" ng-bind-html=\"getRulesContent()\"></div>\n</div>\n<div class=\"row\">\n    <h3 translate>AUTH.AGREEMENT_NOTIFICATIONS</h3>\n    <div class=\"form-group\">\n        <input type=\"checkbox\" id=\"agreement_notifications\" name=\"agreement_notifications\" ng-model=\"passwordModel.agreement_notifications\">\n        <label for=\"agreement_notifications\" class=\"inline\" ng-bind-html=\"getNotificationsLabel()\"></label>\n        <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.notificationsToggle=!vm.notificationsToggle\" ng-hide=\"vm.notificationsToggle\" translate>AUTH.MORE</a>\n    </div>\n\n    <div ng-show=\"vm.notificationsToggle\" class=\"agreement-readmore ng-hide\" ng-bind-html=\"getNotificationsContent()\"></div>\n</div>\n\n<div class=\"form-group clearfix\">\n    <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"lastErrorMsg\">{{lastErrorMsg | translate}}</uib-alert>\n    <div class=\"pull-right required-legend\" translate>GLOBAL.REQUIRED_LEGEND</div><br>\n    <button class=\"btn btn-primary btn-lg pull-right clear\" type=\"submit\" ng-disabled=\"form.$invalid\" translate>\n        GLOBAL.SUBMIT\n    </button>\n</div>");
$templateCache.put("app/auth/partials/index.html","<div class=\"container loginPage\">\n    <ui-view></ui-view>\n</div>");
$templateCache.put("app/auth/partials/login.html","<header class=\"page-header\">\n	<h1 translate>AUTH.WELCOME</h1>\n</header>\n\n<div class=\"row login-form-container\">\n\n    <sg-login-form class=\"col-xs-6\"></sg-login-form>\n\n    <div class=\"col-xs-6\">\n        <ul class=\"login-links\">\n            <li><a class=\"catalog\" href=\"/media/custom/upload/b2b.stalgast.com - wazne pytania i odpowiedzi - poradnik na start.pdf\" target=\"_blank\" translate>GLOBAL.SEE_PDF_CATALOG</a></li>\n            <li><a class=\"contact\" href=\"mailto:pomoc.b2b@stalgast.com\" target=\"_top\" translate>GLOBAL.CONTACT</a></li>\n            <li><a class=\"stalgast\" href=\"https://stalgast.com/\" target=\"_blank\" translate translate-values=\"{url:\'www.stalgast.com\'}\">GLOBAL.GO_TO_URL</a></li>\n        </ul>\n    </div>\n\n</div>\n");
$templateCache.put("app/auth/partials/newPassword.html","<header class=\"page-header\">\n    <h1 translate>AUTH.SET_NEW_PASSWORD</h1>\n</header>\n\n<div cg-busy=\"{promise:settingPasswordPromise,message:\'\',minDuration:300}\">\n    <form name=\"form\" ng-submit=\"sendPassword(password)\" ng-include=\"\'app/auth/partials/changePasswordForm.html\'\">\n    </form>\n</div>");
$templateCache.put("app/auth/partials/recoverPassword.html","<header class=\"page-header\">\n    <h1 translate>AUTH.NO_REMEMBER_PASSWORD</h1>\n</header>\n\n<p translate>AUTH.RECOVER_PASSWORD_INSTRUCTIONS</p>\n<div>\n    <form name=\"form\" ng-submit=\"send()\">\n        <div class=\"row recover-box\" show-input-errors>\n            <label class=\"col-xs-12 col-md-1 control-label recover-label\" for=\"login\" translate>GLOBAL.USERNAME</label>\n            <div class=\"col-xs-6 col-md-5\">\n                <input id=\"login\" class=\"form-control\" type=\"text\" name=\"login\" ng-model=\"login\" required>\n                <div ng-messages=\"form.login.$error\" role=\"alert\" class=\"help-block\">\n                    <div ng-message=\"required\" translate>GLOBAL.FIELD_REQUIRED_VALIDATION_MSG</div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"lastErrorMsg\">{{lastErrorMsg | translate}}</uib-alert>\n            </div>\n\n            <div class=\"col-xs-12\">\n                <button class=\"btn btn-primary btn-lg\" type=\"submit\" ng-disabled=\"form.$invalid\" translate>GLOBAL.SUBMIT</button>\n            </div>\n\n        </div>\n    </form>\n</div>\n");
$templateCache.put("app/auth/partials/setAgreements.html","<div ng-controller=\"setAgreementsCtrl as vm\" cg-busy=\"{promise:usersMeResource,message:\'\',minDuration:100}\">\n    <header class=\"page-header\">\n        <h1 translate>AUTH.WELCOME</h1>\n    </header>\n\n    <p translate>AUTH.SET_AGREEMENT_WELCOME</p>\n\n    <form name=\"form\" ng-submit=\"saveAgreementsAttr()\">\n        <div class=\"row\">\n            <h3 class=\"label-required\" translate>AUTH.AGREEMENT_RULES</h3>\n            <div class=\"form-group\" show-input-errors ng-class=\"{\'has-error\' : form.agreement_rules.$invalid}\">\n                <input type=\"checkbox\" id=\"agreement_rules\" name=\"agreement_rules\" class=\"agreement\" ng-model=\"vm.info.user.user.agreement_rules\" ng-required=\"true\">\n                <label for=\"agreement_rules\" class=\"inline\" ng-bind-html=\"getRulesLabel()\"></label>\n                <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.rulesToggle=!vm.rulesToggle\" ng-hide=\"vm.rulesToggle\" translate>AUTH.SEE_TERMS</a>\n            </div>\n\n            <div ng-show=\"vm.rulesToggle\" class=\"agreement-readmore ng-hide\" ng-bind-html=\"getRulesContent()\"></div>\n\n            <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.rulesToggle=!vm.rulesToggle\" ng-show=\"vm.rulesToggle\" translate>AUTH.LESS</a>\n        </div>\n        <div class=\"row\">\n            <h3 translate>AUTH.AGREEMENT_NOTIFICATIONS</h3>\n            <div class=\"form-group\">\n                <input type=\"checkbox\" id=\"agreement_notifications\" name=\"agreement_notifications\" class=\"agreement\" ng-model=\"vm.info.user.user.agreement_notifications\">\n                <label for=\"agreement_notifications\" class=\"inline\" ng-bind-html=\"getNotificationsLabel()\"></label>\n                <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.notificationsToggle=!vm.notificationsToggle\" ng-hide=\"vm.notificationsToggle\" translate>AUTH.MORE</a>\n            </div>\n\n            <div ng-show=\"vm.notificationsToggle\" class=\"agreement-readmore ng-hide\" ng-bind-html=\"getNotificationsContent()\"></div>\n\n            <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.notificationsToggle=!vm.notificationsToggle\" ng-show=\"vm.notificationsToggle\" translate>AUTH.LESS</a>\n        </div>\n        <div class=\"form-group clearfix\">\n            <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"lastErrorMsg\">{{lastErrorMsg | translate}}</uib-alert>\n            <div class=\"pull-right required-legend\" translate>GLOBAL.REQUIRED_LEGEND</div><br>\n            <button class=\"btn btn-primary btn-lg pull-right clear\" type=\"submit\" ng-disabled=\"form.$invalid\" translate>GLOBAL.SUBMIT</button>\n        </div>\n    </form>\n\n</div>\n");
$templateCache.put("app/footer/templates/basic.html","<footer class=\"container\">\n  © Stalgast <a ui-sref=\"account.contacts\" ng-if=\"vm.session.isLoggedIn()\" translate>GLOBAL.CONTACT</a>\n</footer>\n");
$templateCache.put("app/complaints/partials/index.html","<div class=\"complaint-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>");
$templateCache.put("app/complaints/partials/item.html","<div class=\"complaint-item\" cg-busy=\"{promise:complaint.$promise,message:\'\'}\">\n    <header>\n        <h1 translate>COMPLAINT.ITEM_TITLE</h1>\n    </header>\n\n    <div class=\"content\">\n        <div class=\"row\">\n            <table class=\"col-xs-6\">\n                <tbody>\n                    <tr>\n                        <td translate>COMPLAINT.NUMBER</td>\n                        <td>{{complaint.complaint_id}}</td>\n                    </tr>\n                    <tr>\n                        <td translate>COMPLAINT.REQUEST_TYPE</td>\n                        <td translate>{{complaintTypes[complaint.complaint_type]}}</td>\n                    </tr>\n                    <tr>\n                        <td translate>COMPLAINT.COMPLAINT_PHASE</td>\n                        <td translate>{{complaint.current_task}}</td>\n                    </tr>\n                    <tr ng-if=\"complaint.receive_date\">\n                        <td translate>COMPLAINT.ACCEPTANCE_DATE</td>\n                        <td>{{complaint.receive_date}}</td>\n                    </tr>\n                    <tr ng-if=\"complaint.finished_date\">\n                        <td translate>COMPLAINT.FINISHED_DATE</td>\n                        <td>{{complaint.finished_date}}</td>\n                    </tr>\n                    <tr>\n                        <td translate>COMPLAINT.EMPLOYEE</td>\n                        <td>{{complaint.employee_name}}</td>\n                    </tr>\n                </tbody>\n            </table>\n\n            <table class=\"col-xs-6\">\n                <tbody>\n                    <tr>\n                        <td translate>COMPLAINT.PRODUCT_CODE</td>\n                        <td>\n                            <span>{{complaint.sku}}</span>\n                            <span>{{complaint.item_name}}</span>\n                        </td>\n                    </tr>\n                    <tr>\n                        <td translate>COMPLAINT.QUANTITY</td>\n                        <td>{{complaint.item_qty}}</td>\n                    </tr>\n                    <!--<tr>-->\n                        <!--<td translate>COMPLAINT.COST_COVERED</td>-->\n                        <!--<td>{{complaint.cost_for}}</td>-->\n                    <!--</tr>-->\n                    <tr ng-if=\"complaint.invoice_id\">\n                        <td translate>COMPLAINT.INVOICE</td>\n                        <td>{{complaint.invoice_id}}</td>\n                    </tr>\n                    <tr ng-if=\"complaint.invoice_date\">\n                        <td translate>COMPLAINT.INVOICE_DATE</td>\n                        <td>{{complaint.invoice_date}}</td>\n                    </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-6\">\n                <h3 translate>COMPLAINT.RETURN_ADDRESS</h3>\n                <table>\n                    <tbody>\n                        <tr>\n                            <td translate>COMPLAINT.COMPANY_SHORT</td>\n                            <td>{{complaint.delivery_name}}</td>\n                        </tr>\n                        <tr>\n                            <td translate>GLOBAL.STREET</td>\n                            <td>{{complaint.delivery_street}} {{complaint.delivery_building}}</td>\n                        </tr>\n                        <tr>\n                            <td translate>GLOBAL.POSTAL_CODE</td>\n                            <td><span>{{complaint.delivery_postcode}}</span> <span>{{complaint.delivery_city}}</span></td>\n                        </tr>\n                        <tr>\n                            <td translate>COMPLAINT.COUNTRY</td>\n                            <td>{{complaint.delivery_country}}</td>\n                        </tr>\n                    </tbody>\n                </table>\n            </div>\n            <div class=\"contact col-xs-6\">\n                <h3 translate>COMPLAINT.CONTACT</h3>\n                <p>{{complaint.contact_person}}</p>\n                <p>\n                    <span>tel.</span>\n                    {{complaint.contact_phone}}\n                </p>\n                <span ng-if=\"complaint.contact_email\">email:</span>\n                <a class=\"contact_mail\" href=\"mailto:{{complaint.contact_email}}\">\n                    {{complaint.contact_email}}\n                </a>\n            </div>\n        </div>\n    </div>\n\n    <div>\n        <h3 translate>COMPLAINT.PROCESS</h3>\n        <table class=\"table\" ng-if=\"complaint.items.length>0\">\n            <thead>\n            <tr>\n                <th class=\"text-left\" translate>COMPLAINT.ITEM_POSITION</th>\n                <th class=\"text-left\" translate>COMPLAINT.ACTION</th>\n                <th class=\"text-left\" translate>COMPLAINT.INFORMATIONS</th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"item in complaint.items\">\n                <td class=\"text-left\">{{item.line_number}}</td>\n                <td class=\"text-left\">{{item.type}}</td>\n                <td class=\"text-left\">{{item.description}}</td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <uib-alert type=\"info\" ng-show=\"complaint.items.length===0\">{{\'COMPLAINT.THERE_ARE_NO_HISTORY\' | translate}}</uib-alert>\n\n    <div>\n        <a class=\"btn btn-default\" ui-sref=\"^.list\" translate>ARTICLES.RETURN_TO_LIST</a>\n    </div>\n</div>");
$templateCache.put("app/complaints/partials/list.html","<header class=\"page-header clearfix\">\n    <h1 translate>COMPLAINT.TITLE</h1>\n</header>\n\n<section class=\"filters\">\n    <form method=\"post\" name=\"complaint_filter\" ng-submit=\"filterComplaint()\">\n        <div class=\"form-group row\">\n            <div class=\"col-xs-2\">\n                <label for=\"filter_complaint_delivery_name\" translate>COMPLAINT.COMPANY_SHORT</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[delivery_name]\']\" id=\"filter_complaint_delivery_name\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_complaint_id\" translate>COMPLAINT.NUMBER</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[complaint_id]\']\" id=\"filter_complaint_id\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_complaint_application_id\" translate>COMPLAINT.REQUEST_NUMBER</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[application_id]\']\" id=\"filter_complaint_application_id\">\n            </div>\n            <div class=\"col-xs-2\">\n                <span translate>COMPLAINT.ACCEPTANCE_DATE</span>\n                <div class=\"date-container\">\n                    <label for=\"filter_complaint_receive_from\" translate>COMPLAINT.FROM</label>\n                    <datepicker datepicker-model date-max-limit=\"{{filter[\'filter[receive_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                        <input id=\"filter_complaint_receive_from\" datepicker datepicker-model ng-model=\"filter[\'filter[receive_date][from]\']\" type=\"text\" class=\"form-control\">\n                        <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                    </datepicker>\n                </div>\n                <div class=\"date-container\">\n                    <label for=\"filter_complaint_receive_to\" translate>COMPLAINT.TO</label>\n                    <datepicker datepicker-model date-min-limit=\"{{filter[\'filter[receive_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                        <input id=\"filter_complaint_receive_to\" datepicker datepicker-model ng-model=\"filter[\'filter[receive_date][to]\']\" type=\"text\" class=\"form-control\">\n                        <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                    </datepicker>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <span translate>COMPLAINT.FINISHED_DATE</span>\n                <div class=\"date-container\">\n                    <label for=\"filter_complaint_finished_from\" translate>COMPLAINT.FROM</label>\n                    <datepicker datepicker-model date-max-limit=\"{{filter[\'filter[finished_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                        <input id=\"filter_complaint_finished_from\" datepicker datepicker-model ng-model=\"filter[\'filter[finished_date][from]\']\" type=\"text\" class=\"form-control\">\n                        <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                    </datepicker>\n                </div>\n                <div class=\"date-container\">\n                    <label for=\"filter_complaint_finished_to\" translate>COMPLAINT.TO</label>\n                    <datepicker datepicker-model date-min-limit=\"{{filter[\'filter[finished_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                        <input id=\"filter_complaint_finished_to\" datepicker datepicker-model ng-model=\"filter[\'filter[finished_date][to]\']\" type=\"text\" class=\"form-control\">\n                        <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                    </datepicker>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_complaint_sku\" translate>COMPLAINT.PRODUCT_CODE</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[sku]\']\" id=\"filter_complaint_sku\">\n            </div>\n        </div>\n        <div class=\"form-group row\">\n            <div class=\"col-xs-2\">\n                <label for=\"filter_complaint_type\" translate>COMPLAINT.REQUEST_TYPE</label>\n                <div class=\"wrapSelect\">\n                    <select ng-model=\"filter[\'filter[complaint_type]\']\" class=\"form-control\" id=\"filter_complaint_type\">\n                        <option value=\"\" translate>COMPLAINT.ALL</option>\n                        <option ng-repeat=\"item in dictionary.complaint_type\" ng-attr-value=\"{{item.value}}\">\n                            {{item.translated}}\n                        </option>\n                    </select>\n                </div>\n            </div>\n            <!--Od Sabiny: \"Niestety Serwis uznał, że dane w polu Koszty pokrywa nie zawsze są poprawne.-->\n            <!--Muszę najpierw zapewnić poprawność tych danych a dopiero będziemy je mogli pokazywać w B2B.\"-->\n            <!--Dlatego wszystkie pola w module \'complaints\' związane z \'Koszty pokrywa\' są zakomentowane i gotowe do użycia w przyszłości-->\n\n            <!--<div class=\"col-xs-2\">-->\n                <!--<label for=\"filter_complaint_cost_for\" translate>COMPLAINT.COST_COVERED</label>-->\n                <!--<div class=\"wrapSelect\">-->\n                    <!--<select ng-model=\"filter[\'filter[cost_for]\']\" class=\"form-control\" id=\"filter_complaint_cost_for\">-->\n                        <!--<option value=\"\" translate>COMPLAINT.ALL</option>-->\n                        <!--<option ng-repeat=\"item in dictionary.cost_for\" ng-attr-value=\"{{item}}\">-->\n                            <!--{{item}}-->\n                        <!--</option>-->\n                    <!--</select>-->\n                <!--</div>-->\n            <!--</div>-->\n            <div class=\"col-xs-2\">\n                <label for=\"filter_complaint_current_task\" translate>COMPLAINT.COMPLAINT_PHASE</label>\n                <div class=\"wrapSelect\">\n                    <select ng-model=\"filter[\'filter[current_task]\']\" class=\"form-control\" id=\"filter_complaint_current_task\">\n                        <option value=\"\" translate>COMPLAINT.ALL</option>\n                        <option ng-repeat=\"item in dictionary.current_task\" ng-attr-value=\"{{item}}\">\n                            {{item}}\n                        </option>\n                    </select>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <button type=\"submit\" class=\"btn btn-primary\" translate>GLOBAL.SEARCH</button>\n                <button type=\"button\" ng-click=\"clearFilters()\" class=\"btn btn-default\" translate>GLOBAL.CLEAR_FILTERS\n                </button>\n            </div>\n        </div>\n    </form>\n</section>\n\n<table class=\"table\" st-table=\"rowsFiltered\" st-safe-src=\"rows\" ng-show=\"paginator.rows.length>0\" cg-busy=\"{promise: paginator.rows.$promise, message:\'\', minDuration: 300}\">\n    <thead>\n        <tr>\n            <th class=\"text-left\" translate>COMPLAINT.COMPANY</th>\n            <th class=\"text-left\" translate>COMPLAINT.NUMBER</th>\n            <th class=\"text-left\" translate>COMPLAINT.REQUEST_NUMBER</th>\n            <th class=\"text-left\" translate>COMPLAINT.ACCEPTANCE_DATE</th>\n            <th class=\"text-left\" translate>COMPLAINT.FINISHED_DATE</th>\n            <th class=\"text-left\" translate>COMPLAINT.PRODUCT_CODE</th>\n            <th class=\"text-left\" translate>COMPLAINT.REQUEST_TYPE</th>\n            <!--<th class=\"text-left\" translate>COMPLAINT.COST_COVERED</th>-->\n            <th class=\"text-left\" translate>COMPLAINT.COMPLAINT_PHASE</th>\n            <th class=\"limit-th\">\n                <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n                <div class=\"wrapSelect\">\n                    <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n                </div>\n            </th>\n        </tr>\n    </thead>\n    <tbody>\n        <tr ng-repeat=\"complaint in paginator.rows\">\n            <td class=\"text-left\">{{complaint.delivery_name}}</td>\n            <td class=\"text-left\">{{complaint.complaint_id}}</td>\n            <td class=\"text-left\">{{complaint.application_id}}</td>\n            <td class=\"text-left\">{{complaint.receive_date}}</td>\n            <td class=\"text-left\">{{complaint.finished_date}}</td>\n            <td class=\"text-left\">{{complaint.sku}}</td>\n            <td class=\"text-left\" translate>{{complaintTypes[complaint.complaint_type]}}</td>\n            <!--<td class=\"text-left\">{{complaint.cost_for}}</td>-->\n            <td class=\"text-left\">{{complaint.current_task}}</td>\n            <td class=\"actions\">\n                <a class=\"btn btn-default btn-sm\" ui-sref=\"complaints.item({id: complaint.complaint_id})\" translate>COMPLAINT.CHOOSE</a>\n            </td>\n        </tr>\n    </tbody>\n</table>\n\n<div class=\"clearfix\" ng-show=\"paginator.pages > 1\">\n    <ul class=\"pull-right\" uib-pagination first-text=\"<<\" last-text=\">>\" previous-text=\"<\" next-text=\">\" items-per-page=\"paginator.limit\" total-items=\"paginator.total\" ng-model=\"paginator.page\" max-size=\"5\" force-ellipses=\"true\" boundary-links=\"true\"></ul>\n</div>\n<uib-alert type=\"info\" ng-show=\"paginator.rows.length===0\">{{\'COMPLAINT.THERE_ARE_NO_ITEMS\' | translate}}</uib-alert>\n");
$templateCache.put("app/furnitureoffer/partials/form.html","<form name=\"furnitureRegistration\" ng-submit=\"isSubmit\" cg-busy=\"{promise: furnitureFormPromise ,message:\'\'}\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <header class=\"page-header\">\n                <div class=\"form-group col-xs-12\" ng-class=\"{ \'has-error\': !validateField(\'name\') }\">\n                    <h1 style=\"margin-bottom: 20px\"><span translate>FURNITURE_OFFERS.NEW_OFFER_TITLE</span></h1>\n                    <label class=\"ng-binding required\" for=\"furnitureOffer_name\" translate>ISSUE.CHOOSE_ISSUE_NAME</label>\n                    <div class=\"input-group\">\n                        <input type=\"text\" id=\"furnitureOffer_name\" class=\"form-control\" ng-model=\"offerName\" ng-change=\"fieldChange(\'name\')\" placeholder=\"{{\'ISSUE.ISSUE_NAME\'|translate}}\">\n                    </div>\n                    <span class=\"c-error ng-scope\">Pole wymagane</span>\n                    <span class=\"c-error ng-scope\">Pole powinno zawierać między 3 a 50 znaków</span>\n                </div>\n            </header>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-6\">\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\">\n                        <h1 style=\"margin-bottom: 20px\"><span translate>FURNITURE_OFFERS.CONTACT_DATA</span></h1>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\" ng-class=\"{ \'has-error\': !validateField(\'contactPerson\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_contactPerson\" translate>FURNITURE_OFFERS.CONTACT_PERSON</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_contactPerson\" class=\"form-control\" ng-model=\"offerData.contactPerson\" ng-change=\"fieldChange(\'contactPerson\')\">\n                            <span class=\"c-error ng-scope\">Pole powinno zawierać maksymalnie 25 znaków</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'phone\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_phone\" translate>FURNITURE_OFFERS.PHONE</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_phone\" class=\"form-control\" ng-model=\"offerData.phone\" ng-change=\"fieldChange(\'phone\')\">\n                            <span class=\"c-error ng-scope\">Pole wymagane</span>\n                            <span class=\"c-error ng-scope\">Pole powinno zawierać 9 znaków</span>\n                            <span class=\"c-error ng-scope\">Pole powinno składać się jedynie z liczb</span>\n                        </div>\n                    </div>\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'email\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_email\" translate>FURNITURE_OFFERS.EMAIL</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_email\" class=\"form-control\" ng-model=\"offerData.email\" ng-change=\"fieldChange(\'email\')\">\n                            <span class=\"c-error ng-scope\">Pole wymagane</span>\n                            <span class=\"c-error ng-scope\">Pole powinno zawierać między 6 a 50 znaków</span>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\">\n                        <h1 style=\"margin-bottom: 20px\"><span translate>FURNITURE_OFFERS.OFFER_PARAMETERS</span></h1>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'offerType\') }\" ng-click=\"showOfferTypeMsg()\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_offerType\" translate>FURNITURE_OFFERS.OFFER_TYPE</label>\n                        <select class=\"form-control\" id=\"furnitureOffer_offerType\" ng-model=\"offerData.offerType\" ng-click=\"offerTypeControl()\" ng-disabled=\"items.length > 0 || addOrEdit\" ng-change=\"fieldChange(\'offerType\')\">\n                            <option value=\"\" selected=\"selected\" translate></option>\n                            <option value=\"eval\" translate>FURNITURE_OFFERS.EVALUATION</option>\n                            <option value=\"eval-attach\" translate>FURNITURE_OFFERS.EVALUATION_ATTACH</option>\n                            <option value=\"order\" translate>FURNITURE_OFFERS.ORDER</option>\n                            <option value=\"order-attach\" translate>FURNITURE_OFFERS.ORDER_ATTACH</option>\n                        </select>\n                        <span class=\"c-error ng-scope\">Pole wymagane</span>\n                    </div>\n                    <div class=\"form-group col-xs-6\" ng-if=\"offerData.offerType == \'order\' || offerData.offerType == \'order-attach\'\">\n                        <label class=\"ng-binding\" for=\"furnitureOffer_expectedDate\" translate>FURNITURE_OFFERS.EXPECTED_DATE</label>\n                        <datepicker datepicker-model button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\" date-min-limit=\"{{todaysDate}}\">\n                            <input datepicker datepicker-model id=\"furnitureOffer_expectedDate\" class=\"form-control\" ng-model=\"offerData.expectedDate\">\n                        </datepicker>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'logo\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_logo\" translate>FURNITURE_OFFERS.LOGO_TITLE</label>\n                        <select class=\"form-control\" id=\"furnitureOffer_logo\" ng-model=\"offerData.logo\" ng-change=\"fieldChange(\'logo\')\">\n                            <option value=\"logo-stalgast\" selected=\"selected\" translate>FURNITURE_OFFERS.LOGO_STALGAST</option>\n                            <option value=\"logo-empty\" translate>FURNITURE_OFFERS.LOGO_EMPTY</option>\n                            <option value=\"logo-own\" translate>FURNITURE_OFFERS.LOGO_OWN</option>\n                        </select>\n                        <span class=\"c-error ng-scope\">Pole wymagane</span>\n                    </div>\n                </div>\n                <div class=\"row\" style=\"display: flex; align-items: center\" ng-if=\"offerData.offerType == \'order\' || offerData.offerType == \'order-attach\'\">\n                    <div class=\"form-group col-xs-6 form-check\" style=\"display: flex; justify-content: center\">\n                        <input type=\"checkbox\" id=\"furnitureOffer_connectToOrder\" class=\"form-check-input\" ng-model=\"offerData.connectToOrder\">\n                        <label class=\"form-check-label\" for=\"furnitureOffer_connectToOrder\" translate>FURNITURE_OFFERS.CONNECT_TO_ORDER</label>\n                    </div>\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'orderNumber\') }\">\n                        <label class=\"ng-binding\" for=\"furnitureOffer_orderNumber\" translate>FURNITURE_OFFERS.ORDER_NUMBER</label>\n                        <input type=\"text\" ng-model=\"offerData.orderNumber\" id=\"furnitureOffer_orderNumber\" class=\"form-control\" ng-disabled=\"!offerData.connectToOrder\" ng-change=\"fieldChange(\'orderNumber\')\">\n                        <span class=\"c-error ng-scope\">Pole wymagane</span>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać między 8 a 20 znaków</span>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\" ng-class=\"{ \'has-error\': !validateField(\'comments\') }\">\n                        <label class=\"ng-binding\" for=\"furnitureOffer_comments\" translate>FURNITURE_OFFERS.COMMENTS</label>\n                        <textarea id=\"furnitureOffer_comments\" ng-model=\"offerData.comments\" class=\"form-control\"></textarea>\n                        <span class=\"c-error ng-scope\">Pole może zawierać maksymalnie 200 znaków</span>\n                    </div>\n                </div>\n            </div>\n            <div class=\"col-xs-6\" ng-if=\"offerData.offerType == \'order\' || offerData.offerType == \'order-attach\'\">\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\">\n                        <h1 style=\"margin-bottom: 20px\"><span translate>FURNITURE_OFFERS.DELIVERY_ADDRESS</span></h1>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\">\n                        <label for=\"furnitureOffer_address\" translate>ISSUE.CHOOSE_ADDRESS</label>\n                        <div class=\"wrapSelect\">\n                            <select class=\"form-control\" id=\"furnitureOffer_address\" name=\"presets\" ng-model=\"currentPreset\" ng-change=\"usePreset(currentPreset)\" ng-options=\"address as address.company for address in addresses track by address.entity_id\">\n                                <option value=\"\" translate>ACCOUNT.NEW_ADDRESS</option>\n                            </select>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\" ng-class=\"{ \'has-error\': !validateField(\'deliveryName\') }\">\n                        <label class=\"required\" for=\"furnitureOffer_company_name\" translate>ISSUE.COMPANY</label>\n                        <input id=\"furnitureOffer_company_name\" ng-model=\"formData.deliveryName\" type=\"text\" name=\"company\" class=\"form-control\" ng-change=\"fieldChange(\'deliveryName\')\">\n                        <span class=\"c-error\" translate>Pole wymagane</span>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać pomiędzy 2 a 50 znaków</span>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'deliveryPostcode\') }\">\n                        <label class=\"required\" for=\"furnitureOffer_address_postalcode\" translate>GLOBAL.POSTAL_CODE</label>\n                        <input id=\"furnitureOffer_address_postalcode\" ng-model=\"formData.deliveryPostcode\" type=\"text\" name=\"postcode\" uib-typeahead=\"postcode as postcode for postcode in findPostCodes($viewValue)\" class=\"form-control\" autocomplete=\"off\" ng-change=\"fieldChange(\'deliveryPostcode\')\">\n                        <span class=\"c-error\" translate>Pole wymagane</span>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać pomiędzy 2 a 8 znaków</span>\n                    </div>\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'deliveryCity\') }\">\n                        <label class=\"required\" for=\"furnitureOffer_address_city\" translate>GLOBAL.CITY</label>\n                        <input id=\"furnitureOffer_address_city\" ng-model=\"formData.deliveryCity\" type=\"text\" name=\"city\" uib-typeahead=\"city as city for city in findCities($viewValue)\" autocomplete=\"off\" ng-change=\"fieldChange(\'deliveryCity\')\" class=\"form-control\">\n                        <span class=\"c-error\" translate>Pole wymagane</span>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać pomiędzy 2 a 20 znaków</span>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-9\" ng-class=\"{ \'has-error\': !validateField(\'deliveryStreet\') }\">\n                        <label class=\"required\" for=\"furnitureOffer_address_street\" translate>GLOBAL.STREET</label>\n                        <input id=\"furnitureOffer_address_street\" ng-model=\"formData.deliveryStreet\" type=\"text\" name=\"street\" uib-typeahead=\"street as street for street in findStreets($viewValue)\" autocomplete=\"off\" ng-change=\"fieldChange(\'deliveryStreet\')\" class=\"form-control\">\n                        <span class=\"c-error\" translate>Pole wymagane</span>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać pomiędzy 2 a 50 znaków</span>\n                    </div>\n                    <div class=\"form-group col-xs-3\" ng-class=\"{ \'has-error\': !validateField(\'deliveryBuilding\') }\">\n                        <label for=\"furnitureOffer_address_building\" class=\"required\" translate>GLOBAL.BUILDING</label>\n                        <input id=\"furnitureOffer_address_building\" ng-model=\"formData.deliveryBuilding\" type=\"text\" name=\"building\" class=\"form-control\" ng-change=\"fieldChange(\'deliveryBuilding\')\">\n                        <span class=\"c-error\" translate>Pole wymagane</span>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać pomiędzy 2 a 15 znaków</span>\n                    </div>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'deliveryPerson\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_address_contact_person\" translate>FURNITURE_OFFERS.CONTACT_PERSON</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_address_contact_person\" class=\"form-control\" ng-model=\"formData.contactPerson\" ng-change=\"fieldChange(\'deliveryPerson\')\">\n                        </div>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać pomiędzy 2 a 25 znaków</span>\n                    </div>\n                    <div class=\"form-group col-xs-6\" ng-class=\"{ \'has-error\': !validateField(\'deliveryPhone\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_address_phone\" translate>FURNITURE_OFFERS.PHONE</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_address_phone\" class=\"form-control\" ng-model=\"formData.phone\" ng-change=\"fieldChange(\'deliveryPhone\')\">\n                        </div>\n                        <span class=\"c-error ng-scope\">Pole powinno zawierać maksymalnie 9 znaków</span>\n                        <span class=\"c-error ng-scope\">Pole powinno składać się jedynie z liczb</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ng-if=\"attachments.length > 0\">\n                    <div class=\"container-fluid table-attachments\">\n                        <div class=\"row table-attachments__row table-attachments__row--header\">\n                            <div class=\"table-attachments__col table-attachments__col col-xs-12\">\n                                {{ \"ISSUE.FILE_NAME\" | translate }}\n                            </div>\n                        </div>\n\n                        <div ng-repeat=\"file in attachments\" class=\"row table-attachments__row\">\n                            <div class=\"text-left col-xs-8 table-attachments__col\">\n                                {{ file.name }}\n                            </div>\n                            <div class=\"text-right col-xs-4 table-attachments__col table-attachments__col--action\">\n                                <div class=\"table-attachments__status\" ng-if=\"file.uploading\">{{ \"ISSUE.FILE_UPLOADING\" | translate }}...</div>\n                                <div class=\"table-attachments__status table-attachments__status--success\" ng-if=\"file.success\">{{ \"ISSUE.FILE_UPLOADED\" | translate }}.</div>\n                                <div class=\"table-attachments__status table-attachments__status--error\" ng-if=\"file.error\">{{ getUploadErrorString(file.error) | translate }}.</div>\n\n                                <button type=\"button\" class=\"btn btn-danger btn-sm btn-product\" data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" mwl-confirm message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"deleteFile(file)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" role=\"button\" translate>\n                                    GLOBAL.DELETE\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <table class=\"attachment-table\">\n                    <tr>\n                        <th>\n                            <span translate>ISSUE.ATTACHMENTS</span>:\n                        </th>\n                    </tr>\n                    <tr>\n                        <td class=\"attachments\">\n                            <div ngf-select ngf-drop name=\"file\" class=\"drop-box ng-pristine ng-untouched ng-valid ng-empty attach-dropbox\" ng-class=\"{ \'error-field\': invalidFiles.length }\" ng-model=\"attachments\" ng-change=\"dropFileError()\" ngf-capture=\"capture\" ngf-multiple=\"true\" ngf-keep=\"\'distinct\'\" ngf-allow-dir=\"false\" ngf-pattern=\"\'.dwg,.dxf,.pdf,.xlsx,.xls,.doc,.docx,.odt,.ods,.png,.jpg\'\" ngf-drag-over-class=\"{accept:\'accept-file\', reject:\'error-field\', delay:100}\" ngf-model-invalid=\"invalidFiles\" ngf-validate=\"{pattern: \'.dwg,.dxf,.pdf,.xlsx,.xls,.doc,.docx,.odt,.ods,.png,.jpg\'}\" ngf-model-options=\"{allowInvalid: false}\" ngf-drop-available=\"dropFileAvailable\">\n                                <div class=\"msg\">\n                                    <span translate>ACCOUNT.OR_DROP_FILE_HERE</span>\n                                    <span translate>ACCOUNT.PRESS_HERE_TO_SELECT_FILE</span>\n                                    <p translate>FURNITURE_OFFERS.ALLOWED_FILE_EXTENSIONS</p>\n                                </div>\n                            </div>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n        <div class=\"row product-table\">\n            <div class=\"col-xs-12\">\n                <h1>Produkty</h1>\n                <div class=\"row text-center furniture-table-header\" style=\"margin-bottom: 10px\">\n                    <div class=\"col-xs-1\">\n                        <span><b>Lp.</b></span>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <span><b>Opis produktu</b></span>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <span><b>Wymiary [mm]</b></span>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <span><b>Ilość pozycji</b></span>\n                    </div>\n                    <div class=\"col-xs-1\">\n                        <span><b>Ilość sztuk łącznie</b></span>\n                    </div>\n                    <div class=\"col-xs-2\">\n                        <span><b>Uwagi</b></span>\n                    </div>\n                    <div class=\"col-xs-2\">\n                    </div>\n                </div>\n                <div ng-if=\"items.length == 0\"><h5 translate>ISSUE.DONT_HAVE_ANY_PRODUCTS</h5></div>\n                <div class=\"row text-center\" ng-if=\"items.length > 0\" ng-repeat=\"(key, item) in items\" style=\"margin-top: 10px\">\n                    <div class=\"col-xs-1\">{{ item.id }}</div>\n                    <div class=\"col-xs-2\">{{ item.description }}</div>\n                    <div class=\"col-xs-2\">{{ item.dimensions }}</div>\n                    <div class=\"col-xs-2\">{{ item.uniq }}</div>\n                    <div class=\"col-xs-1\">{{ item.amount }}</div>\n                    <div class=\"col-xs-2\">{{ item.comments }}</div>\n                    <div class=\"col-xs-2\" style=\"display: flex; justify-content: space-evenly\">\n                        <button class=\"btn btn-default btn-product\" type=\"button\" ng-click=\"edit(item.id)\" translate>\n                            ISSUE.EDIT\n                        </button>\n                        <button class=\"btn btn-danger btn-product\" type=\"button\" data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" mwl-confirm message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"deleteProduct($index)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" translate>\n                            GLOBAL.DELETE\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-10\"></div>\n            <div class=\"col-xs-2 align-right text-right\">\n                <button class=\"btn btn-default\" type=\"button\" ng-disabled=\"offerData.offerType == \'\'\" ng-if=\"!addOrEdit\" ng-click=\"showProductEdit()\" style=\"margin-top: 20px\" translate>\n                    ISSUE.ADD_PRODUCT\n                </button>\n            </div>\n        </div>\n        <div class=\"row\" ng-if=\"addOrEdit\">\n            <div class=\"col-xs-12\">\n                <h1>{{ editId == -1 ? \'Dodaj produkt\' : (\'Edycja produktu nr: \'+ (editId + 1)) }}</h1>\n                <div class=\"row text-center table-header-products\">\n                    <div class=\"col-xs-3 h-100 form-group\" ng-class=\"{ \'has-error\': !validateField(\'productDescription\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_product_description\" translate>FURNITURE_OFFERS.PRODUCT_DESCRIPTION</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_product_description\" class=\"form-control\" ng-model=\"item.description\" ng-change=\"fieldChange(\'productDescription\')\" ng-disabled=\"offerData.offerType === \'eval-attach\' ||\n                                   offerData.offerType === \'order-attach\'\" name=\"item.description\">\n                            <span class=\"c-error ng-scope\">\n                                Pole wymagane\n                            </span>\n                            <span class=\"c-error ng-scope\">\n                                Pole powinno zawierać między 6 a 200 znaków\n                            </span>\n                        </div>\n                    </div>\n                    <div class=\"col-xs-2 h-100 form-group\" ng-class=\"{ \'has-error\': !validateField(\'productDimensions\') }\">\n                        <label class=\"ng-binding\" for=\"furnitureOffer_product_dimensions\" ng-class=\"{ \'required\': offerData.offerType === \'eval\' || offerData.offerType === \'order\' }\">\n                            <span translate>FURNITURE_OFFERS.PRODUCT_DIMENSIONS</span> [mm]\n                        </label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_product_dimensions\" class=\"form-control\" ng-model=\"item.dimensions\" ng-change=\"fieldChange(\'productDimensions\')\" uib-tooltip=\"{{::\'GLOBAL.DIMENSIONS\'|translate}}\" tooltip-enable=\"true\" tooltip-placement=\"bottom\" ng-disabled=\"offerData.offerType === \'eval-attach\' || offerData.offerType === \'order-attach\'\">\n                        </div>\n                        <span class=\"c-error ng-scope\">\n                            Pole wymagane\n                        </span>\n                        <span class=\"c-error ng-scope\">\n                            Maks. ilość znaków 20\n                        </span>\n                    </div>\n                    <div class=\"col-xs-2 h-100 form-group\" ng-class=\"{ \'has-error\': !validateField(\'productUniq\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_product_uniq\" translate>FURNITURE_OFFERS.PRODUCT_UNIQUE_AMOUNT</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"number\" id=\"furnitureOffer_product_uniq\" class=\"form-control\" ng-change=\"fieldChange(\'productUniq\')\" uib-tooltip=\"{{::\'GLOBAL.UNIQUE_ITEMS\'|translate}}\" tooltip-enable=\"true\" tooltip-placement=\"bottom\" ng-model=\"item.uniq\" ng-disabled=\"offerData.offerType === \'eval\' || offerData.offerType === \'order\'\">\n                        </div>\n                        <span class=\"c-error ng-scope\">\n                            Pole wymagane\n                        </span>\n                        <span class=\"c-error ng-scope\" ng-show=\"item.uniq > 9999\">\n                            Pole powinno zawierać liczbę maksymalnie 4 cyfrową\n                        </span>\n                        <span class=\"c-error ng-scope\" ng-show=\"item.uniq <= 0\">\n                            Pole powinno zawierać liczbę dodatnią\n                        </span>\n                    </div>\n                    <div class=\"col-xs-2 h-100 form-group\" ng-class=\"{ \'has-error\': !validateField(\'productAmount\') }\">\n                        <label class=\"ng-binding required\" for=\"furnitureOffer_product_amount\" translate>FURNITURE_OFFERS.PRODUCT_AMOUNT</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"number\" id=\"furnitureOffer_product_amount\" class=\"form-control\" uib-tooltip=\"{{::\'GLOBAL.TOTAL_QUANTITIES\'|translate}}\" tooltip-enable=\"true\" tooltip-placement=\"bottom\" ng-model=\"item.amount\" ng-change=\"fieldChange(\'productAmount\')\">\n                        </div>\n                        <span class=\"c-error ng-scope\">\n                                Pole wymagane\n                        </span>\n                        <span class=\"c-error ng-scope\" ng-show=\"item.amount > 9999\">\n                            Pole powinno zawierać liczbę maksymalnie 4 cyfrową\n                        </span>\n                        <span class=\"c-error ng-scope\" ng-show=\"item.amount <= 0\">\n                            Pole powinno zawierać liczbę dodatnią\n                        </span>\n                    </div>\n                    <div class=\"col-xs-3 h-100 form-group\" ng-class=\"{ \'has-error\': !validateField(\'productComments\') }\">\n                        <label class=\"ng-binding\" for=\"furnitureOffer_product_comments\" translate>FURNITURE_OFFERS.PRODUCT_COMMENTS</label>\n                        <div class=\"input-group col-xs-12\">\n                            <input type=\"text\" id=\"furnitureOffer_product_comments\" class=\"form-control\" ng-model=\"item.comments\" name=\"item.comments\">\n                        </div>\n                        <span class=\"c-error ng-scope\">\n                            Maks. ilość znaków 200\n                        </span>\n                    </div>\n                </div>\n                <div class=\"align-right text-right\">\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"cancelEdit()\" style=\"margin-top: 20px\" translate>\n                        ISSUE.CANCEL_EDIT\n                    </button>\n                    <button class=\"btn btn-default\" type=\"button\" ng-click=\"addProduct()\" style=\"margin-top: 20px\" translate>\n                        ISSUE.ADD\n                    </button>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <footer class=\"text-right\">\n                <button type=\"submit\" class=\"btn btn-lg btn-primary\" style=\"margin-top: 20px\" ng-click=\"submitForm()\" ng-disabled=\"spin\" translate>\n                    FURNITURE_OFFERS.SUBMIT\n                </button>\n            </footer>\n        </div>\n    </div>\n</form>\n");
$templateCache.put("app/global/directives/sgInputButton.html","<div class=\"form-group\">\n    <label>{{fieldLabel}}</label>\n    <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" minlength=\"2\" maxlength=\"255\" ng-attr-placeholder=\"{{placeholder}}\" ng-disabled=\"disabled\" ng-enter=\"onPress()\">\n        <span class=\"input-group-btn\">\n            <button class=\"btn btn-default\" type=\"button\" ng-disabled=\"disabled || btnDisabled\" translate>GLOBAL.SAVE</button>\n        </span>\n    </div>\n</div>");
$templateCache.put("app/header/templates/simple.html","<header>\n    <div class=\"header1\" ng-if=\"vm.session.isLoggedIn()\">\n        <div class=\"container\">\n            <div class=\"row\">\n                <nav class=\"col-xs-12\">\n                    <ul class=\"nav navbar-nav navbar-right\">\n\n                        <li class=\"logged-user-name\"><a ui-sref=\"account.myData\">\n                            <span translate>GLOBAL.LOGGED</span>:\n                            {{vm.session.info.user.user.firstname}} {{vm.session.info.user.user.lastname}}\n                            ({{vm.session.info.user.reseller.name}})\n                        </a></li>\n\n                        <li class=\"dropdown\" uib-dropdown data-keyboard-nav>\n                            <a href=\"#\" class=\"dropdown-toggle arrow-after-down\" uib-dropdown-toggle role=\"button\">\n                                <span translate>ACCOUNT.MY_ACCOUNT</span>\n                            </a>\n                            <ul class=\"dropdown-menu\" role=\"menu\" uib-dropdown-menu>\n                                <li>\n                                    <a ui-sref-active=\"active\" ui-sref=\"account.myData\" translate>ACCOUNT.MY_DATA</a>\n                                </li>\n                                <li ng-if=\"vm.session.info.user.user.agreement_rules\">\n                                    <a ui-sref-active=\"active\" ui-sref=\"account.logo\" translate>ACCOUNT.MY_LOGO</a>\n                                </li>\n                                <li ng-if=\"vm.session.info.user.user.agreement_rules\">\n                                    <a ui-sref-active=\"active\" ui-sref=\"account.addresses.list\" translate>ACCOUNT.MY_ADDRESS</a>\n                                </li>\n                                <li sg-access=\"users.index\" ng-if=\"vm.session.info.user.user.agreement_rules\">\n                                    <a ui-sref-active=\"active\" ui-sref=\"account.employee.list\" translate>ACCOUNT.EMPLOYEES_LIST</a>\n                                </li>\n                                <li ng-if=\"vm.session.info.user.user.agreement_rules\">\n                                    <a ui-sref-active=\"active\" ui-sref=\"account.contacts\" translate>ACCOUNT.CONTACT</a>\n                                </li>\n                                <li role=\"presentation\" ui-sref-active=\"active\">\n                                    <a ui-sref-active=\"active\" ui-sref=\"account.loyalty_program\" translate>ACCOUNT.LOYALTY_PROGRAM</a>\n                                </li>\n                            </ul>\n                        </li>\n\n                        <li class=\"\"><a href=\"#\" ng-click=\"vm.logout()\" translate>GLOBAL.LOGOUT</a></li>\n\n                    </ul>\n                </nav>\n            </div>\n        </div>\n    </div>\n    <div ng-if=\"vm.showNotification()\" class=\"notification\" ng-style=\"vm.notification.hasOwnProperty(\'designData\') ?\n        { \'background-color\': \'#\' + vm.notification.designData.background, \'color\': \'#\' + vm.notification.designData.text } : {}\">\n        <div class=\"container notification-container\">\n            <span>\n                <span ng-bind-html=\"renderHtml(vm.notification.message_content)\"></span>\n                <a ng-style=\"vm.notification.hasOwnProperty(\'designData\') ?\n        { \'color\': \'#\' + vm.notification.designData.other } : {}\" href=\"{{ vm.notification.message_link }}\">{{ \'NOTIFICATIONS.READ_MORE\' | translate }} ></a>\n            </span>\n            <a href=\"#\" ng-click=\"vm.closeNotification()\" class=\"notification__close\" ng-style=\"vm.notification.hasOwnProperty(\'designData\') ?\n        { \'color\': \'#\' + vm.notification.designData.other } : {}\"></a>\n            <div class=\"notification-container-after\" ng-style=\"vm.notification.hasOwnProperty(\'designData\') ?\n        { \'background\':\n        \'linear-gradient(to right, rgba(\' + vm.hexToRgb(vm.notification.designData.background) + \', 0), rgba(\' + vm.hexToRgb(vm.notification.designData.background) + \', 1) 50%)\'\n        } : {}\">\n            </div>\n        </div>\n    </div>\n    <div class=\"container clearfix\">\n        <div class=\"row header2\">\n            <!-- Logo -->\n            <div class=\"navbar-header col-xs-3\">\n                <a ui-sref=\"home\">\n                    <sg-logo></sg-logo>\n                </a>\n\n            </div>\n            <div class=\"col-xs-6\" ng-if=\"vm.session.info.user.user.agreement_rules\">\n                <sg-product-search-box></sg-product-search-box>\n            </div>\n\n            <!-- NavBar -->\n            <div class=\"col-xs-3 text-right\" ng-if=\"vm.session.info.user.user.agreement_rules\">\n                <product-quick-info-button-launcher></product-quick-info-button-launcher>\n                <active-cart-widget></active-cart-widget>\n            </div>\n\n            <!-- Infolinia -->\n            <div class=\"col-xs-9 helpline\" ng-if=\"vm.session.info.user.user.agreement_rules\" ng-bind-html=\"vm.servicePhone[vm.servicePhoneId].content\">\n\n            </div>\n        </div>\n        <div class=\"row main-menu\" ng-if=\"vm.session.info.user.user.agreement_rules\">\n            <nav class=\"col-xs-12\">\n                <ul class=\"nav navbar-nav\" ng-switch=\"vm.extended\">\n                    <li ng-switch-default class=\"products\">\n                        <a class=\"dropdown-toggle\" ui-sref=\"product.catalog({p:1, s:null, sort:null, cid:null, filter:null})\">\n                            <span translate>PRODUCT.PRODUCTS</span>\n                        </a>\n                    </li>\n                    <li ng-switch-when=\"true\" class=\"dropdown products mega-dropdown\" ng-click=\"stopPropagationAndLoadCategory($event)\" uib-dropdown dropdown-append-to-body data-keyboard-nav>\n                        <a class=\"dropdown-toggle arrow-after-down\" uib-dropdown-toggle role=\"button\">\n                            <span translate>PRODUCT.PRODUCTS</span>\n                        </a>\n                        <div id=\"category-products-list\" class=\"category-products-list\">\n                            <ul class=\"dropdown-menu top-category\" role=\"menu\">\n                                <li><a ui-sref=\"product.catalog({p:1, s:null, sort:null, cid:null, filter:null})\" ng-click=\"closeMenu()\" class=\"title all-products\" translate=\"\">GLOBAL.ALL_PRODUCTS</a>\n                                </li>\n                                <li ng-repeat=\"category in categories track by $index\" class=\"top-category\" ng-mouseenter=\"calculatePosition($event)\">\n                                    <div class=\"title\" translate>{{category.name}}</div>\n                                    <div-subcategory-tab class=\"subcategory-tab\">\n                                        <div class=\"subcategory-body\">\n                                            <div class=\"row\">\n                                                <div ng-class=\"{\'col-xs-6\': category.recommended.length > 0, \'col-xs-12\': category.recommended.length == 0}\" class=\"no-float\">\n                                                    <div>\n                                                        <title-subcategory class=\"title-subcategory h2\">\n                                                            <span class=\"title\">{{category.name}}</span>\n                                                            <small class=\"button\">\n                                                                <nobr><a ui-sref=\"product.catalog({p:1, s:null, sort:null, cid:category.id, filter:null})\" ng-click=\"closeMenu()\" class=\"see-all\" translate>PRODUCT.SEE_ALL</a></nobr>\n                                                            </small>\n                                                        </title-subcategory>\n                                                        <div-subcategory-container-list class=\"subcategory-container-list\">\n                                                            <ul class=\"subcategory-list\" ng-class=\"{\'multi-column\': category.recommended.length == 0}\">\n                                                                <li ng-repeat=\"categoryChildren in category.children\">\n                                                                    <a ui-sref=\"product.catalog({p:1, s:null, sort:null, cid:categoryChildren.id, filter:null})\" ng-click=\"closeMenu()\">{{categoryChildren.name}}</a>\n                                                                </li>\n                                                            </ul>\n                                                        </div-subcategory-container-list>\n                                                    </div>\n                                                </div>\n                                                <div ng-if=\"category.recommended.length > 0\" class=\"col-xs-6 no-float border-left\">\n                                                    <div>\n                                                        <recommended-in-subcategory class=\"h2 recommended-in-subcategory\" translate>PRODUCT.RECOMMENDED</recommended-in-subcategory>\n                                                        <div-recommended-container-list class=\"div-recommended-container-list\">\n                                                            <ul class=\"subcategory-product-list\">\n                                                                <li ng-repeat=\"product in category.recommended track by $index\" class=\"col-xs-12\">\n                                                                    <div class=\"row\">\n                                                                        <div class=\"col-xs-4\">\n                                                                            <img class=\"img-responsive\" ng-src=\"{{product.pictureUrl}}\" src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAwIDEwMDAiPjxkZWZzPjxyYWRpYWxHcmFkaWVudCBpZD0icmFkaWFsLWdyYWRpZW50IiBjeD0iNTAwIiBjeT0iNTAwIiByPSI1MDAiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj48c3RvcCBvZmZzZXQ9IjAiIHN0b3AtY29sb3I9IiNkZmRmZGYiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiM5OTkiLz48L3JhZGlhbEdyYWRpZW50PjwvZGVmcz48cmVjdCBmaWxsPSJ1cmwoI3JhZGlhbC1ncmFkaWVudCkiIHdpZHRoPSIxMDAwIiBoZWlnaHQ9IjEwMDAiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNjAxIDQxNGwwIDBWNTg2bDAgMEgzOTlsMCAwVjQxNGwwIDBINjAxWm0wLTE0SDM5OUExNCAxNCAwIDAgMCAzODUgNDE0djE3M2ExNCAxNCAwIDAgMCAxNCAxNEg2MDFBMTQgMTQgMCAwIDAgNjE1IDU4NlY0MTRhMTQgMTQgMCAwIDAtMTQtMTRoMFpNNTcyIDQ1MGEyMiAyMiAwIDEgMS0yMi0yMkEyMiAyMiAwIDAgMSA1NzIgNDUwWk01ODYgNTcySDQxNFY1NDNsNTAtODYgNTggNzJoMTRsNTAtNDN2ODZaIi8+PC9zdmc+\">\n                                                                        </div>\n                                                                        <div class=\"col-xs-8\">\n                                                                            <div class=\"recommended-buttons\">\n                                                                                <product-info-delivery model=\"product.dlvDate\"></product-info-delivery>\n                                                                                <product-availability-icon model=\"product\" show-label=\"false\" show-tooltip=\"true\" tooltip-pos=\"right-top\"></product-availability-icon>\n                                                                                <product-info-button-launcher model=\"product\" allow-add-to-cart=\"true\"></product-info-button-launcher>\n                                                                            </div>\n                                                                            <div class=\"name\">{{product.name}}</div>\n                                                                            <div class=\"price\">{{product.price_reseller |\n                                                                                currency}} <span class=\"discount-group\" ng-class=\"{\'promo\': product.price_special}\" ng-if=\"product.itemGroupId\">({{product.itemGroupId}})</span>\n                                                                            </div>\n                                                                            <div class=\"button\">\n                                                                                <sg-add-to-cart product-id=\"product.sku\" qty-increments=\"product.qtyIncrements\" default-qty=\"product.qtyIncrements\" on-product-add=\"product.onProductAddToCart()\"></sg-add-to-cart>\n                                                                            </div>\n                                                                        </div>\n                                                                    </div>\n                                                                </li>\n                                                            </ul>\n                                                        </div-recommended-container-list>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div-subcategory-tab>\n                                </li>\n                            </ul>\n                        </div>\n                    </li>\n                    <li><a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'promotions\'})\" translate>GLOBAL.PROMOTIONS</a></li>\n                    <li><a ui-sref-active=\"active\" ui-sref=\"cart.list\" sg-access=\"carts.index\" translate>CART.SHOPPING_CARTS</a></li>\n                    <li><a ui-sref-active=\"active\" ui-sref=\"offer.list\" sg-access=\"offers.index\" translate>OFFER.OFFERS</a></li>\n                    <li><a ui-sref-active=\"active\" ui-sref=\"orders.list\" sg-access=\"orders.index\" translate>ORDER.ORDERS</a></li>\n                    <li>\n                        <a ui-sref-active=\"active\" ui-sref=\"furnitureoffer\" sg-access=\"furnitureoffer.index\" class=\"inline-elements\">\n                            <span translate>FURNITURE_OFFERS.FURNITURE</span>\n                            <img src=\"../../../img/NEW.svg\" class=\"furniture-new-icon\" alt=\"New\">\n                        </a>\n                    </li>\n                    <li class=\"dropdown\" uib-dropdown data-keyboard-nav sg-access=\"payments.index\">\n                        <a href=\"#\" class=\"dropdown-toggle arrow-after-down\" uib-dropdown-toggle role=\"button\">\n                            <span translate>GLOBAL.SETTLEMENT</span>\n                        </a>\n                        <ul class=\"dropdown-menu\" role=\"menu\" uib-dropdown-menu>\n                            <li><a ui-sref-active=\"active\" ui-sref=\"payment.list\" sg-access=\"payments.index\" translate>GLOBAL.SETTLEMENT</a></li>\n                            <li><a ui-sref-active=\"active\" ui-sref=\"settlement.list\" sg-access=\"settlements.index\" translate>SETTLE.TITLE</a></li>\n                            <li><a ui-sref-active=\"active\" ui-sref=\"invoice.list\" sg-access=\"invoices.index\" translate>INVOICE.LIST</a></li>\n                        </ul>\n                    </li>\n                    <li class=\"dropdown\" uib-dropdown data-keyboard-nav>\n                        <a href=\"#\" class=\"dropdown-toggle arrow-after-down\" uib-dropdown-toggle role=\"button\">\n                            <span translate>GLOBAL.SERVICE_AND_COMPLAINTS</span>\n                        </a>\n                        <ul class=\"dropdown-menu\" role=\"menu\" uib-dropdown-menu>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'service_documents\'})\" translate>GLOBAL.SERVICE_DOCUMENTS</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'service_returns\'})\" translate>GLOBAL.RETURNS_AND_COMPLAINTS</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"issues.list\" sg-access=\"issues.index\" translate=\"\">ISSUE.ISSUES</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"complaints.list\" sg-access=\"complaints.index\" translate>GLOBAL.RETURNS_AND_COMPLAINTS_LIST</a>\n                            </li>\n<!--                            <li>-->\n<!--                                <a ui-sref-active=\"active\" ui-sref=\"furnitureoffer\"-->\n<!--                                   translate>FURNITURE_OFFERS.FURNITURE_OFFERS_REGISTRATION</a>-->\n<!--                            </li>-->\n                        </ul>\n                    </li>\n                    <li class=\"dropdown\" uib-dropdown data-keyboard-nav>\n                        <a href=\"#\" class=\"dropdown-toggle arrow-after-down\" uib-dropdown-toggle role=\"button\">\n                            <span translate class=\"informations\">GLOBAL.INFORMATIONS</span>\n                        </a>\n                        <ul class=\"dropdown-menu\" role=\"menu\" uib-dropdown-menu>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"news.list\" translate>GLOBAL.NEWS</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'info_marketing\'})\" translate>GLOBAL.MARKETING</a>\n                            </li>\n\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'info_training\'})\" translate>GLOBAL.TRAININGS</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'info_catalog\'})\" translate>GLOBAL.CATALOGS_AND_LEAFLETS</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'info_instructions\'})\" translate>GLOBAL.FORMS</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"documentsB2B.list\" translate>ARTICLES.documents.SECTION</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"account.contacts\" translate>GLOBAL.CONTACT</a>\n                            </li>\n                            <li>\n                                <a ui-sref-active=\"active\" ui-sref=\"blocks({id:\'xml_csv_xls_files\'})\" translate>GLOBAL.FILES_FOR_DOWNLOAD</a>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n                <div class=\"nav-border\"></div>\n            </nav>\n        </div>\n    </div>\n</header>\n<div class=\"header-overlay\"></div>\n");
$templateCache.put("app/issues/components/sgIssuesNewProduct.html","<div class=\"product-component\">\n    <div class=\"step1\">\n        <div class=\"step-header\">\n            <span>\n                {{(vm.itemEdit ? \'ISSUE.EDIT_PRODUCT\' : \'ISSUE.ADD_PRODUCT\')|translate}}: {{vm.itemEdit.product_name}}\n            </span>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-3\">\n                <label class=\"ng-scope required\" for=\"issueNew_product_work_type\">{{\'ISSUE.REQUEST_TYPE\'|translate}}:</label>\n                <div class=\"wrapSelect\">\n                    <select class=\"form-control\" id=\"issueNew_product_work_type\" ng-model=\"vm.item.type\" ng-change=\"vm.validateField(\'type\')\">\n                        <option ng-repeat=\"(key, value) in vm.issueTypes\" ng-attr-value=\"{{key}}\" translate>\n                            {{value}}\n                        </option>\n                    </select>\n                </div>\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.type\" translate>ERRORS.REQUIRED</span>\n                <span ng-if=\"vm.item.type === \'Complaint\' || vm.item.type === \'BackSent\'\" translate>\n                    ISSUE.INVOICE_NEED\n                </span>\n            </div>\n            <div class=\"col-xs-2\">\n                <label class=\"ng-scope required\" for=\"issueNew_product_sku\">{{\'ISSUE.PRODUCT_SKU\'|translate}}:</label>\n                <input type=\"text\" class=\"form-control\" id=\"issueNew_product_sku\" ng-model=\"vm.item.sku\" name=\"sku\" maxlength=\"20\" size=\"6\" placeholder=\"{{\'OFFER.SKU_ABRV\'|translate}}\" pattern=\"^[A-Za-z0-9]*$\" uib-typeahead=\"product.sku as product.label for product in vm.findProduct($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"2\" typeahead-select-on-blur=\"true\" typeahead-on-select=\"vm.setDefinedProduct($item)\" ng-change=\"vm.setDefinedProduct(vm.item.sku); vm.validateField(\'sku\')\" ng-enter=\"\" autocomplete=\"off\">\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.sku\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"col-xs-4\">\n                <label class=\"ng-scope required\" for=\"issueNew_product_name\">{{\'ISSUE.NAME\'|translate}}:</label>\n                <input class=\"form-control\" id=\"issueNew_product_name\" ng-change=\"vm.validateField(\'product_name\')\" ng-model=\"vm.item.product_name\" ng-disabled=\"nameDisabled\">\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.product_name\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"col-xs-1\">\n                <label class=\"ng-scope required\" for=\"issueNew_product_quantity\">{{\'ISSUE.QTY\'|translate}}:</label>\n                <div class=\"input-number-container\">\n                    <input type=\"number\" class=\"form-control text-left\" id=\"issueNew_product_quantity\" ng-model=\"vm.item.count\" ng-change=\"vm.validateField(\'count\')\" ng-min=\"1\" ng-step=\"1\">\n                    <div class=\"btn-group-vertical\">\n                        <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.changeCount(1)\">+</button>\n                        <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.changeCount(-1)\" ng-disabled=\"!vm.item.count || vm.item.count <= 0\">-\n                        </button>\n                    </div>\n                </div>\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.count\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"col-xs-2\">\n                <label class=\"ng-scope\" for=\"issueNew_product_invoice\" ng-class=\"{required: vm.item.type === \'Complaint\' || vm.item.type === \'BackSent\'}\">{{\'ISSUE.INVOICE_FULL_NUMBER\'|translate}}:</label>\n                <input class=\"form-control\" id=\"issueNew_product_invoice\" ng-model=\"vm.item.invoice_id\" name=\"invoice_id\" ng-change=\"vm.validateField(\'invoice_id\')\">\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.invoice_id\" translate>ERRORS.REQUIRED</span>\n            </div>\n        </div>\n\n        <div class=\"row warranty\" ng-if=\"vm.item.warranty_terms || vm.item.warranty_end_date\">\n            <div class=\"col-xs-3\">\n                <span>{{\'ISSUE.WARRANTY\'|translate}}:</span>\n                <b>{{vm.item.warranty_terms || \'-\'}}</b>\n            </div>\n            <div class=\"col-xs-3\">\n                <span>{{\'ISSUE.WARRANTY_END_DATE\'|translate}}:</span>\n                <b>{{vm.item.warranty_end_date || \'-\'}}</b>\n            </div>\n        </div>\n\n        <div class=\"text-right\">\n        </div>\n    </div>\n\n    <div class=\"step2\">\n        <div class=\"row\">\n            <div class=\"col-xs-3\">\n                <label class=\"ng-scope\" for=\"issueNew_product_serial_number\">{{\'ISSUE.SERIAL_NUMBER\'|translate}}:</label>\n                <input class=\"form-control\" id=\"issueNew_product_serial_number\" ng-model=\"vm.item.serial_id\">\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.serial_id\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"col-xs-3\">\n                <label class=\"ng-scope required\" for=\"issueNew_product_request_type\">{{\'ISSUE.REQUEST\'|translate}}:</label>\n                <span class=\"input_detail\" ng-if=\"!vm.item.type\">({{\'ISSUE.SELECT_TYPE_FIRST\'|translate}})</span>\n                <div class=\"wrapSelect\">\n                    <select class=\"form-control\" id=\"issueNew_product_request_type\" ng-disabled=\"!vm.item.type\" ng-model=\"vm.item.request\" ng-change=\"vm.validateField(\'request\')\">\n                        <option ng-repeat=\"value in vm.filteredRequests\" ng-attr-value=\"{{value}}\" translate>\n                        {{vm.issueRequests[value]}}\n                        </option>\n                    </select>\n                </div>\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.request\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"col-xs-6\">\n                <label class=\"ng-scope required\" for=\"issueNew_product_description\">{{\'ISSUE.DEFECT_DESC\'|translate}}:</label>\n                <input id=\"issueNew_product_description\" class=\"form-control\" ng-change=\"vm.validateField(\'description\')\" ng-model=\"vm.item.description\" ng-enter=\"vm.addItem(vm.item)\">\n                <span class=\"c-error ng-scope\" ng-show=\"vm.required.description\" translate>ERRORS.REQUIRED</span>\n            </div>\n        </div>\n        <div></div>\n    </div>\n\n    <div class=\"step3\">\n        <div class=\"step-header\">\n            <span>\n                {{ \"ISSUE.ATTACHMENTS\" | translate }}:\n            </span>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n\n                <div class=\"container-fluid table-attachments\" ng-show=\"vm.item.attachments.length > 0\">\n                    <div class=\"row table-attachments__row table-attachments__row--header\">\n                        <div class=\"table-attachments__col table-attachments__col col-xs-12\">\n                            {{ \"ISSUE.FILE_NAME\" | translate }}\n                        </div>\n                    </div>\n\n                    <div ng-repeat=\"file in vm.item.attachments\" class=\"row table-attachments__row\">\n                        <div class=\"text-left col-xs-8 table-attachments__col\">\n                            {{ file.name }}\n                        </div>\n                        <div class=\"text-right col-xs-4 table-attachments__col table-attachments__col--action\">\n                            <div class=\"table-attachments__status\" ng-if=\"file.uploading\">{{ \"ISSUE.FILE_UPLOADING\" | translate }}...</div>\n                            <div class=\"table-attachments__status table-attachments__status--success\" ng-if=\"file.success\">{{ \"ISSUE.FILE_UPLOADED\" | translate }}.</div>\n                            <div class=\"table-attachments__status table-attachments__status--error\" ng-if=\"file.error\">{{ vm.getUploadErrorString(file.error) | translate }}.</div>\n\n                            <button type=\"button\" class=\"btn btn-danger btn-sm\" data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" mwl-confirm message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"vm.deleteFile(file)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" role=\"button\" translate>\n                                GLOBAL.DELETE\n                            </button>\n                        </div>\n                    </div>\n\n                </div>\n\n                <div ngf-select ngf-drop class=\"drop-box ng-pristine ng-untouched ng-valid ng-empty\" ng-class=\"{ \'error-field\': vm.invalidFiles.length }\" ng-model=\"vm.item.attachments\" ng-model-options=\"{allowInvalid: false}\" ngf-capture=\"capture\" ngf-multiple=\"true\" ngf-keep=\"\'distinct\'\" ngf-drag-over-class=\"{accept:\'accept-file\', reject:\'error-field\', delay:100}\" ngf-drop-available=\"vm.dropFileAvailable\">\n                    <div class=\"msg\">\n                        <span ng-show=\"vm.dropFileAvailable\" translate>ACCOUNT.OR_DROP_FILE_HERE</span>\n                        <span translate>ACCOUNT.PRESS_HERE_TO_SELECT_FILE</span>\n                    </div>\n                </div>\n\n            </div>\n        </div>\n\n        <div></div>\n    </div>\n\n    <div class=\"step4\">\n        <div class=\"text-right\">\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.visibility(false)\" translate>\n                {{vm.itemEdit ? \'ISSUE.CANCEL_EDIT\' : \'ISSUE.CANCEL_ADD\'}}\n            </button>\n            <button class=\"btn btn-default\" type=\"button\" ng-click=\"vm.addItem(vm.item)\" ng-disabled=\"vm.hasErrorFields\" translate>\n                {{vm.itemEdit ? \'ISSUE.SAVE_PRODUCT\' : \'ISSUE.ADD\'}}\n            </button>\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/issues/partials/index.html","<div class=\"issue-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>\n");
$templateCache.put("app/issues/partials/issueAttachmentsModal.html","<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-xs-12\">\n\n            <table class=\"table table-attachments\">\n                <thead>\n                    <tr>\n                        <th colspan=\"2\" class=\"text-left\" translate>ISSUE.FILE_NAME</th>\n                    </tr>\n                </thead>\n\n                <tbody>\n                    <tr ng-repeat=\"file in attachments\">\n                        <td class=\"text-left\">\n                            {{ file.name }}\n                        </td>\n                        <td class=\"text-right\">\n                            <button ng-click=\"downloadAttachment(file)\" type=\"button\" class=\"btn btn-default\" translate>\n                                ISSUE.DOWNLOAD_ATTACHMENT\n                            </button>\n                        </td>\n                    </tr>\n                </tbody>\n            </table>\n\n        </div>\n    </div>\n</div>\n");
$templateCache.put("app/issues/partials/issuesItem.html","<div class=\"issue-item\" cg-busy=\"{promise:issue.$promise,message:\'\'}\">\n    <header>\n        <h1 translate>ISSUE.TITLE_ITEM</h1>\n    </header>\n\n    <div class=\"content\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <table class=\"col-xs-2 bold\">\n                    <tbody>\n                    <tr>\n                        <td translate>ISSUE.ISSUE_NAME</td>\n                    </tr>\n                    <tr>\n                        <td translate>ISSUE.COMPANY</td>\n                    </tr>\n                    <tr>\n                        <td translate>ISSUE.ISSUE_PHASE</td>\n                    </tr>\n                    <tr>\n                        <td translate>ISSUE.CREATION_DATE</td>\n                    </tr>\n                    <tr>\n                        <td translate>ISSUE.CREATED_BY</td>\n                    </tr>\n                    </tbody>\n                </table>\n\n                <table class=\"col-xs-10\">\n                    <tbody>\n                    <tr>\n                        <td>{{issue.issue_id}}</td>\n                    </tr>\n                    <tr>\n                        <td>{{issue.delivery_name}}</td>\n                    </tr>\n                    <tr>\n                        <td>{{issueTasks[issue.current_task]?(issueTasks[issue.current_task]|translate):issue.current_task}}</td>\n                    </tr>\n                    <tr>\n                        <td>{{issue.create_date}}</td>\n                    </tr>\n                    <tr>\n                        <td>{{issue.customer_name}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-6\">\n                <h3 translate>ISSUE.RETURN_ADDRESS</h3>\n                <table class=\"col-xs-4 bold\">\n                    <tbody>\n                    <tr>\n                        <td translate>ISSUE.COMPANY</td>\n                    </tr>\n                    <tr>\n                        <td translate>ISSUE.STREET</td>\n                    </tr>\n                    <tr>\n                        <td translate>ISSUE.POSTAL_CODE</td>\n                    </tr>\n                    <tr>\n                        <td translate>ISSUE.COUNTRY</td>\n                    </tr>\n                    </tbody>\n                </table>\n\n                <table>\n                    <tbody>\n                    <tr>\n                        <td>{{issue.delivery_name}}</td>\n                    </tr>\n                    <tr>\n                        <td>{{issue.delivery_street}} {{issue.delivery_building}}</td>\n                    </tr>\n                    <tr>\n                        <td>{{issue.delivery_postcode}}, {{issue.delivery_city}}</td>\n                    </tr>\n                    <tr>\n                        <td>{{issue.delivery_country}}</td>\n                    </tr>\n                    </tbody>\n                </table>\n            </div>\n            <div class=\"contact col-xs-6\">\n                <h3 translate>ISSUE.CONTACT</h3>\n                <p>{{issue.contact_person}}</p>\n                <p>\n                    <span>tel.</span>\n                    {{issue.contact_phone}}\n                </p>\n                <span>email:</span>\n                <a class=\"contact_mail\" href=\"mailto:example@example.com\">\n                    {{issue.contact_email}}\n                </a>\n            </div>\n        </div>\n    </div>\n\n    <div>\n        <h3 translate>ISSUE.PRODUCTS</h3>\n        <table class=\"table\" ng-if=\"issue.items.length > 0\">\n            <thead>\n            <tr>\n                <th class=\"text-left\" translate>ISSUE.ITEM_POSITION</th>\n                <th class=\"text-left\" translate>ISSUE.COMPLAINT</th>\n                <th class=\"text-left\" translate>ISSUE.SKU</th>\n                <th class=\"text-left\" translate>ISSUE.NAME</th>\n                <th class=\"text-left\" translate>ISSUE.WARRANTY</th>\n                <th class=\"text-left\" translate>ISSUE.WARRANTY_END_DATE</th>\n                <th class=\"text-left\" translate>ISSUE.QTY</th>\n                <th class=\"text-left\" translate>ISSUE.REQUEST_TYPE</th>\n                <th class=\"text-left\" translate>ISSUE.INVOICE</th>\n                <th class=\"text-left\" translate>ISSUE.SERIAL_NUMBER</th>\n                <th class=\"text-left\" translate>ISSUE.DEFECT_DESC</th>\n                <th class=\"text-left\" translate>ISSUE.REQUEST</th>\n                <th class=\"text-left\" translate>ISSUE.ATTACHMENTS</th>\n                <th class=\"text-left\"></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"item in issue.items track by $index\">\n                <td class=\"text-left\">{{$index + 1}}</td>\n                <td class=\"text-left\">{{item.complaint_id}}<span ng-if=\"item.complaint_status\"><br>{{item.complaint_status}}</span></td>\n                <td class=\"text-left\">{{(item.sku!==null?item.sku:item.ext_item_code)}}</td>\n                <td class=\"text-left\">{{item.product_name}}</td>\n                <td class=\"text-left\">{{item.warranty_terms}}</td>\n                <td class=\"text-left\">{{item.warranty_end_date}}</td>\n                <td class=\"text-left\">{{item.count}}</td>\n                <td class=\"text-left\">{{issueTypes[item.type]|translate}}</td>\n                <td class=\"text-left\">{{item.invoice_id}}</td>\n                <td class=\"text-left\">{{item.serial_id}}</td>\n                <td class=\"text-left\">{{item.description}}</td>\n                <td class=\"text-left\">{{issueRequests[item.request]|translate}}</td>\n                <td class=\"text-left\">\n                  <button ng-click=\"showAttachmentsModal(item)\" class=\"btn btn-default btn-sm\" translate>\n                    GLOBAL.SHOW\n                  </button>\n                </td>\n                <td class=\"text-right no-wrap\">\n                    <a class=\"btn btn-default btn-sm\" ng-if=\"item.complaint_id\" ui-sref=\"complaints.item({ id: item.complaint_id })\" translate>ISSUE.COMPLAINT</a>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n\n    <uib-alert type=\"info\" ng-show=\"issue.items.length===0\">\n        {{\'ISSUE.THERE_ARE_NO_ITEMS\' | translate}}\n    </uib-alert>\n\n    <div>\n        <a class=\"btn btn-default\" ui-sref=\"^.list\" translate>ARTICLES.RETURN_TO_LIST</a>\n    </div>\n</div>\n");
$templateCache.put("app/issues/partials/issuesList.html","<div class=\"issue-list\" cg-busy=\"{promise:item.$promise,message:\'\'}\">\n    <header class=\"page-header clearfix\">\n        <h1 translate>ISSUE.TITLE</h1>\n        <a class=\"btn btn-primary pull-right\" ui-sref=\"issues.new\" translate>ISSUE.NEW_ISSUE</a>\n    </header>\n\n    <section class=\"filters\">\n        <form method=\"post\" name=\"offer_filter\" ng-submit=\"filterIssues()\">\n            <div class=\"form-group row\">\n                <div class=\"col-xs-2\">\n                    <label for=\"filter_issue_name\" translate>ISSUE.NAME</label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[issue_name]\']\" id=\"filter_issue_name\">\n                </div>\n                <div class=\"col-xs-2\">\n                    <label for=\"filter_issue_company\" translate>ISSUE.COMPANY</label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[delivery_name]\']\" id=\"filter_issue_company\">\n                </div>\n                <div class=\"col-xs-2\">\n                    <label for=\"filter_issue_application_id\" translate>ISSUE.REQUEST_NUMBER</label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[issue_id]\']\" id=\"filter_issue_application_id\">\n                </div>\n                <div class=\"col-xs-2\">\n                    <span translate>ISSUE.CREATION_DATE</span>\n                    <div class=\"date-container\">\n                        <label for=\"filter_issue_create_from\" translate>ISSUE.FROM</label>\n                        <datepicker datepicker-model date-max-limit=\"{{filter[\'filter[create_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input id=\"filter_issue_create_from\" datepicker datepicker-model ng-model=\"filter[\'filter[create_date][from]\']\" type=\"text\" class=\"form-control\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                    <div class=\"date-container\">\n                        <label for=\"filter_issue_create_to\" translate>ISSUE.TO</label>\n                        <datepicker datepicker-model date-min-limit=\"{{filter[\'filter[create_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input id=\"filter_issue_create_to\" datepicker datepicker-model ng-model=\"filter[\'filter[create_date][to]\']\" type=\"text\" class=\"form-control\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                </div>\n                <div class=\"col-xs-2\">\n                    <label for=\"filter_issue_created_by\" translate>ISSUE.CREATED_BY</label>\n                    <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[customer_name]\']\" id=\"filter_issue_created_by\">\n                </div>\n                <div class=\"col-xs-2\">\n                    <label for=\"filter_issue_current_task\" translate>ISSUE.ISSUE_PHASE</label>\n                    <div class=\"wrapSelect\">\n                        <select ng-model=\"filter[\'filter[current_task]\']\" class=\"form-control\" id=\"filter_issue_current_task\">\n                            <option value=\"\" translate>COMPLAINT.ALL</option>\n                            <option ng-repeat=\"value in dictionary.current_task\" ng-attr-value=\"{{value}}\" translate>\n                                {{issueTasks[value]||value}}\n                            </option>\n                        </select>\n                    </div>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-xs-12\">\n                    <button type=\"submit\" class=\"btn btn-primary\" translate>GLOBAL.SEARCH</button>\n                    <button type=\"button\" ng-click=\"clearFilters()\" class=\"btn btn-default\" translate>\n                        GLOBAL.CLEAR_FILTERS\n                    </button>\n                </div>\n            </div>\n        </form>\n    </section>\n\n    <table class=\"table\" st-table=\"rowsFiltered\" st-safe-src=\"rows\" cg-busy=\"{promise: paginator.rows.$promise, message:\'\', minDuration: 300}\" ng-show=\"paginator.rows.length > 0\">\n        <thead>\n        <tr>\n            <th class=\"text-left\" translate>ISSUE.ISSUE_NAME</th>\n            <th class=\"text-left\" translate>ISSUE.COMPANY</th>\n            <th class=\"text-left\" translate>ISSUE.REQUEST_NUMBER</th>\n            <th class=\"text-left\" translate>ISSUE.CREATION_DATE</th>\n            <th class=\"text-left\" translate>ISSUE.CREATED_BY</th>\n            <th class=\"text-left\" translate>ISSUE.PRODUCTS_QTY</th>\n            <th class=\"text-left\" translate>ISSUE.ISSUE_PHASE</th>\n            <th class=\"limit-th\">\n                <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n                <div class=\"wrapSelect\">\n                    <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n                </div>\n            </th>\n        </tr>\n        </thead>\n        <tbody>\n        <tr ng-repeat=\"issue in paginator.rows\">\n            <td class=\"text-left\">{{issue.issue_name}}</td>\n            <td class=\"text-left\">{{issue.delivery_name}}</td>\n            <td class=\"text-left\">{{issue.issue_id}}</td>\n            <td class=\"text-left\">{{issue.create_date}}</td>\n            <td class=\"text-left\">{{issue.customer_name}}</td>\n            <td class=\"text-left\">{{issue.item_count}}</td>\n            <td class=\"text-left\">{{issueTasks[issue.current_task]?(issueTasks[issue.current_task]|translate):issue.current_task}}</td>\n            <td class=\"text-right no-wrap\">\n                <a class=\"btn btn-default btn-sm\" ng-if=\"issue.issue_id\" ui-sref=\"issues.item({id: issue.uniqid})\" translate>GLOBAL.SELECT</a>\n                <a class=\"btn btn-default btn-sm\" ng-if=\"!issue.issue_id\" ui-sref=\"issues.edit({id: issue.uniqid})\" translate>GLOBAL.EDIT</a>\n                <button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"!issue.issue_id\" mwl-confirm data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"deleteIssue({id: issue.uniqid})\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" role=\"button\" sg-access=\"carts.delete\" translate>GLOBAL.DELETE\n                </button>\n            </td>\n        </tr>\n        </tbody>\n    </table>\n\n    <div class=\"clearfix\" ng-show=\"paginator.pages > 1\">\n        <ul class=\"pull-right\" uib-pagination first-text=\"<<\" last-text=\">>\" previous-text=\"<\" next-text=\">\" items-per-page=\"paginator.limit\" total-items=\"paginator.total\" ng-model=\"paginator.page\" max-size=\"5\" force-ellipses=\"true\" boundary-links=\"true\"></ul>\n    </div>\n\n    <uib-alert type=\"info\" ng-show=\"paginator.$resolved && paginator.rows.length===0\">{{\'ISSUE.THERE_ARE_NO_ITEMS\' | translate}}</uib-alert>\n</div>");
$templateCache.put("app/issues/partials/issuesNew.html","<div class=\"issue-new-report\">\n    <header class=\"page-header clearfix\">\n        <h1 translate>ISSUE.TITLE_NEW</h1>\n    </header>\n\n    <form name=\"issueForm\" cg-busy=\"{promise: issuePromise ,message:\'\'}\">\n        <div class=\"row\">\n            <div class=\"form-group col-xs-12\">\n                <label class=\"ng-binding\" for=\"issueNew_name\" translate>ISSUE.CHOOSE_ISSUE_NAME</label>\n                <div class=\"input-group\">\n                    <input type=\"text\" id=\"issueNew_name\" class=\"form-control\" ng-model=\"formData.issue_name\" minlength=\"2\" maxlength=\"255\" placeholder=\"{{\'ISSUE.ISSUE_NAME\'|translate}}\">\n                </div>\n            </div>\n\n            <div class=\"col-xs-5\">\n                <h3 translate>ISSUE.RETURN_ADDRESS</h3>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\">\n                        <label for=\"issueNew_address\" translate>ISSUE.CHOOSE_ADDRESS</label>\n                        <div class=\"wrapSelect\">\n                            <select class=\"form-control\" id=\"issueNew_address\" name=\"presets\" ng-model=\"currentPreset\" ng-change=\"usePreset(currentPreset)\" ng-options=\"address as address.company for address in addresses track by address.entity_id\">\n                                <option value=\"\" translate>ACCOUNT.NEW_ADDRESS</option>\n                            </select>\n                        </div>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\" show-input-errors>\n                        <label class=\"required\" for=\"issueNew_company_name\" translate>ISSUE.COMPANY</label>\n                        <input id=\"issueNew_company_name\" ng-model=\"formData.delivery_name\" type=\"text\" name=\"company\" class=\"form-control\" required>\n                        <span class=\"c-error\" ng-show=\"issueForm.company.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" show-input-errors>\n                        <label class=\"required\" for=\"issueNew_address_postalcode\" translate>GLOBAL.POSTAL_CODE</label>\n                        <input id=\"issueNew_address_postalcode\" ng-model=\"formData.delivery_postcode\" type=\"text\" name=\"postcode\" uib-typeahead=\"postcode as postcode for postcode in findPostCodes($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"0\" class=\"form-control\" autocomplete=\"off\" required>\n                        <span class=\"c-error\" ng-show=\"issueForm.postcode.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                    <div class=\"form-group col-xs-6\" show-input-errors>\n                        <label class=\"required\" for=\"issueNew_address_city\" translate>GLOBAL.CITY</label>\n                        <input id=\"issueNew_address_city\" ng-model=\"formData.delivery_city\" type=\"text\" name=\"city\" uib-typeahead=\"city as city for city in findCities($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"1\" autocomplete=\"off\" class=\"form-control\" maxlength=\"140\" required>\n                        <span class=\"c-error\" ng-show=\"issueForm.city.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-9\" show-input-errors>\n                        <label class=\"required\" for=\"issueNew_address_street\" translate>GLOBAL.STREET</label>\n                        <input id=\"issueNew_address_street\" ng-model=\"formData.delivery_street\" type=\"text\" name=\"street\" uib-typeahead=\"street as street for street in findStreets($viewValue)\" typeahead-wait-ms=\"250\" typeahead-min-length=\"1\" autocomplete=\"off\" class=\"form-control\" maxlength=\"255\" required>\n                        <span class=\"c-error\" ng-show=\"issueForm.street.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                    <div class=\"form-group col-xs-3\" show-input-errors>\n                        <label for=\"issueNew_address_building\" class=\"required\" translate>GLOBAL.BUILDING</label>\n                        <input id=\"issueNew_address_building\" ng-model=\"formData.delivery_building\" type=\"text\" name=\"building\" class=\"form-control\" required>\n                        <span class=\"c-error\" ng-show=\"issueForm.building.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"col-xs-push-1 col-xs-6\">\n                <h3 translate>ISSUE.CONTACT</h3>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\">\n                        <label class=\"\" for=\"issueNew_contact_fullname\" translate>ISSUE.CONTACT_PERSON</label>\n                        <input type=\"text\" id=\"issueNew_contact_fullname\" class=\"form-control\" ng-model=\"formData.contact_person\" name=\"firstname\" maxlength=\"50\">\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" show-input-errors>\n                        <label class=\"required\" for=\"issueNew_contact_phone\" translate>GLOBAL.PHONE</label>\n                        <input type=\"tel\" id=\"issueNew_contact_phone\" class=\"form-control\" name=\"phone\" ui-mask=\"999-999-999\" ng-model=\"formData.contact_phone\" required>\n                        <span class=\"c-error\" ng-show=\"issueForm.phone.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n\n                    <div class=\"form-group col-xs-6\" show-input-errors>\n                        <label class=\"required\" for=\"issueNew_contact_email\" translate>GLOBAL.EMAIL</label>\n                        <input type=\"email\" id=\"issueNew_contact_email\" class=\"form-control\" name=\"email\" ng-model=\"formData.contact_email\" required>\n                        <span class=\"c-error\" ng-show=\"issueForm.email.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-12\" show-input-errors>\n                        <label for=\"issueNew_contact_notification\" translate>ISSUE.SEND_NOTIFICATION</label>\n                        <div class=\"wrapSelect\">\n                            <select class=\"form-control\" id=\"issueNew_contact_notification\" name=\"notification\" ng-model=\"formData.contact_notification\">\n                                <option value=\"None\" translate>ISSUE.NONE</option>\n                                <option value=\"Email\" translate>ISSUE.MAIL</option>\n                            </select>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row error_container\">\n            <div class=\"container\">\n                <uib-alert class=\"col-xs-10\" type=\"danger\" ng-if=\"errors\">\n                    <span ng-bind-html=\"errors\"></span>\n                </uib-alert>\n            </div>\n        </div>\n\n        <div class=\"content\">\n            <h3 translate>ISSUE.PRODUCTS</h3>\n            <table class=\"table\">\n                <thead>\n                <tr>\n                    <th>Lp.</th>\n                    <th class=\"text-left\" translate>ISSUE.REQUEST_TYPE</th>\n                    <th class=\"text-left\" translate>ISSUE.PRODUCT_SKU</th>\n                    <th class=\"text-left\" translate>ISSUE.NAME</th>\n                    <th class=\"text-left\" translate>ISSUE.QTY</th>\n                    <th class=\"text-left\" translate>ISSUE.INVOICE</th>\n                    <th class=\"text-left\" translate>ISSUE.WARRANTY</th>\n                    <th class=\"text-left\" translate>ISSUE.WARRANTY_END_DATE</th>\n                    <th class=\"text-left\" translate>ISSUE.SERIAL_NUMBER</th>\n                    <th class=\"text-left\" translate>ISSUE.REQUEST</th>\n                    <th class=\"text-left\" translate>ISSUE.DEFECT_DESC</th>\n                    <th class=\"text-left\" translate>ISSUE.ATTACHMENTS</th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-if=\"formData.items.length === 0\">\n                    <td colspan=\"12\" translate=\"\">ISSUE.DONT_HAVE_ANY_PRODUCTS</td>\n                </tr>\n                <tr ng-repeat=\"item in formData.items track by $index\" id=\"{{ item.uniqid }}\">\n                    <td>{{$index + 1}}</td>\n                    <td class=\"text-left\">{{issueTypes[item.type]|translate}}</td>\n                    <td class=\"text-left\">{{item.sku || item.ext_item_code}}</td>\n                    <td class=\"text-left\">{{item.product_name}}</td>\n                    <td class=\"text-left\">{{item.count}}</td>\n                    <td class=\"text-left\">{{item.invoice_id}}</td>\n                    <td class=\"text-left\">{{item.warranty_terms}}</td>\n                    <td class=\"text-left\">{{item.warranty_end_date}}</td>\n                    <td class=\"text-left\">{{item.serial_id}}</td>\n                    <td class=\"text-left\">{{issueRequests[item.request]|translate}}</td>\n                    <td class=\"text-left\">{{item.description}}</td>\n                    <td class=\"text-left\">\n                        <button ng-if=\"item.attachments.length\" type=\"button\" ng-click=\"showAttachmentsModal(item)\" class=\"btn btn-default btn-sm\">\n                            {{ \"GLOBAL.SHOW\" | translate }} ({{ item.attachments.length }})\n                        </button>\n                        <span ng-if=\"!item.attachments.length\">\n                            {{ \"ISSUE.NO_ATTACHMENTS\" | translate }}\n                        </span>\n                    </td>\n                    <td class=\"text-right\">\n                        <button type=\"button\" class=\"btn btn-default\" ng-click=\"addNewVisibilityEvent(true, item, $event)\" ng-disabled=\"addNew\" translate>\n                            ISSUE.EDIT\n                        </button>\n                        <button type=\"button\" class=\"btn btn-danger btn-sm\" mwl-confirm data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"removeProduct(item)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" role=\"button\" ng-disabled=\"addNew\" translate>GLOBAL.DELETE\n                        </button>\n                    </td>\n                </tr>\n                </tbody>\n            </table>\n        </div>\n\n        <div class=\"text-right\" ng-if=\"!addNew\">\n            <button class=\"btn btn-default add-product\" type=\"button\" ng-click=\"addNewVisibility(true)\" translate>\n                {{\'ISSUE.ADD_PRODUCT\'}}\n            </button>\n        </div>\n\n        <div cg-busy=\"{promise: productPromise ,message:\'\'}\">\n            <sg-issues-new-product ng-if=\"addNew\" visibility=\"addNewVisibility\" item-edit=\"itemEdit\" submit=\"addNewProduct\" validate=\"validateProduct\"></sg-issues-new-product>\n        </div>\n        <div class=\"pull-right\">\n            <button type=\"button\" class=\"btn btn-default pull-left check\" ng-disabled=\"addNew\" ng-click=\"validateIssue()\" promise-btn=\"issuePromise\">{{\'ISSUE.CHECK\' | translate}}\n            </button>\n            <button class=\"btn btn-primary pull-right\" ng-disabled=\"addNew || (issueForm.$invalid && issueForm.$dirty)\" ng-click=\"submitIssue()\" promise-btn=\"issuePromise\">{{\'ISSUE.SEND_ISSUE\' | translate}}\n            </button>\n        </div>\n    </form>\n\n    <div>\n        <a class=\"btn btn-default\" ui-sref=\"^.list\" translate>ARTICLES.RETURN_TO_LIST</a>\n    </div>\n</div>\n");
$templateCache.put("app/ngIdle/templates/locked.html","<div class=\"modal-header\">\n    <h3>Your session is lock</h3>\n</div>\n<div class=\"modal-body\">\n    <p>\n        You were idle too long. Use your password for unlock me.\n    </p>\n</div>");
$templateCache.put("app/ngIdle/templates/warning.html","<div class=\"modal-header\">\n    <h3>You\'re Idle</h3>\n</div>\n<div idle-countdown=\"countdown\" ng-init=\"countdown=10\" class=\"modal-body\">\n    <p>\n        For security reasons your session will be block in {{countdown}} seconds.\n        You can\'t unblock it in any moment with your password.\n    </p>\n    <uib-progressbar max=\"10\" value=\"countdown\" animate=\"true\" class=\"progress-striped active\"></uib-progressbar>\n</div>");
$templateCache.put("app/invoice/components/sgInvoicesList.html","<table class=\"table table-striped\" ng-show=\"paginator.total && !vm.errorMsg\" cg-busy=\"{promise: paginator.$promise, message: vm.waitMsg}\">\n    <thead>\n    <tr>\n        <th translate>INVOICE.INVOICE_NUMBER</th>\n        <th translate>INVOICE.INVOICE_NUMBER_KSEF</th>\n        <th translate>INVOICE.ORDER</th>\n        <th translate>INVOICE.PAYER_ACCOUNT</th>\n        <th translate>INVOICE.NET_AMOUNT</th>\n        <th translate>INVOICE.TAX_AMOUNT</th>\n        <th translate>INVOICE.GROSS_AMOUNT</th>\n        <th translate>INVOICE.INVOICE_DATE</th>\n        <th translate>INVOICE.DUE_DATE</th>\n        <th class=\"limit-th\">\n            <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n            <div class=\"wrapSelect\">\n                <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n            </div>\n        </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"invoice in paginator.rows\">\n        <td>{{invoice.invoice_number}}</td>\n        <td>{{invoice.submission_uuid}}</td>\n        <td>{{invoice.order_numbers}}</td>\n        <td>{{invoice.distributor_id}}</td>\n        <td>{{invoice.net_total | currency}}</td>\n        <td>{{invoice.tax_total | currency}}</td>\n        <td>{{invoice.grand_total | currency}}</td>\n        <td>{{invoice.invoice_date | date}}</td>\n        <td>{{invoice.due_date | date}}</td>\n        <td class=\"actions text-right\">\n            <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"invoice.file\" ng-click=\"vm.downloadPdf(invoice)\" translate>INVOICE.DOWNLOAD_PDF</button>\n        </td>\n    </tr>\n    </tbody>\n</table>\n\n<div class=\"clearfix\">\n    <!-- Button to export results to CSV -->\n    <span ng-show=\"paginator.$resolved && paginator.rows.length>0\">\n        <button type=\"button\" class=\"btn btn-default pull-left export-to-csv-btn\" csv-header=\"vm.csvConfig.headers\" csv-column-order=\"vm.csvConfig.fields\" ng-csv=\"vm.csvConfig.getData()\" filename=\"{{vm.csvConfig.filename}}\">\n            <span translate>GLOBAL.SAVE_TO_FILE_CSV</span>\n        </button>\n\n        <button type=\"button\" ng-click=\"vm.downloadFile(\'pdf\')\" uib-tooltip=\"{{\'OFFER.GENERATION_TOOLTIP\'|translate}}\" class=\"btn btn-default pull-left export-to-csv-btn\" promise-btn>\n            <span translate>GLOBAL.SAVE_TO_FILE_PDF</span>\n        </button>\n\n        <button type=\"button\" ng-click=\"vm.downloadFile(\'xls\')\" uib-tooltip=\"{{\'OFFER.GENERATION_TOOLTIP\'|translate}}\" class=\"btn btn-default pull-left export-to-csv-btn\" promise-btn>\n            <span translate>GLOBAL.SAVE_TO_FILE_XLS</span>\n        </button>\n        \n    </span>\n    <!-- Pagination bar -->\n    <sg-pagination paginator=\"paginator\"></sg-pagination>\n</div>\n\n<uib-alert type=\"info\" ng-show=\"paginator.$resolved && paginator.rows.length===0\">\n    <span translate>INVOICE.THERE_ARE_NO_RESULTS</span>\n</uib-alert>");
$templateCache.put("app/invoice/components/sgInvoicesListFilters.html","<form class=\"row\" ng-submit=\"vm.applyChanges()\">\n\n    <div class=\"form-group col-xs-2\">\n        <label for=\"invoiceListFilterNumber\" translate>INVOICE.INVOICE_NUMBER</label>\n        <input type=\"text\" class=\"form-control\" id=\"invoiceListFilterNumber\" ng-model=\"vm.filters[\'filter[invoice_number]\']\">\n    </div>\n    <div class=\"form-group col-xs-2\">\n        <label for=\"invoiceListFilterOrders\" translate>INVOICE.ORDER_NO</label>\n        <input type=\"text\" class=\"form-control\" id=\"invoiceListFilterOrders\" ng-model=\"vm.filters[\'filter[order_numbers]\']\">\n    </div>\n    <div class=\"form-group col-xs-2\">\n        <label for=\"invoiceListFilterSku\" translate>GLOBAL.PRODUCT</label>\n        <input type=\"text\" class=\"form-control\" id=\"invoiceListFilterSku\" ng-model=\"vm.filters[\'filter[sku]\']\">\n    </div>\n    <div class=\"form-group col-xs-2\">\n        <label translate>INVOICE.INVOICE_DATE</label>\n        <div class=\"form-horizontal range-inputs-container\">\n            <div class=\"form-group has-feedback\">\n                <label for=\"invoiceListFilterDateFrom\" class=\"col-xs-2 control-label\" translate>GLOBAL.FROM</label>\n                <datepicker datepicker-model class=\"col-xs-10\" date-max-limit=\"{{vm.filters[\'filter[invoice_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                    <input datepicker-model type=\"text\" class=\"form-control\" id=\"invoiceListFilterDateFrom\" ng-model=\"vm.filters[\'filter[invoice_date][from]\']\">\n                    <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                </datepicker>\n            </div>\n            <div class=\"form-group has-feedback\">\n                <label for=\"invoiceListFilterDateTo\" class=\"col-xs-2 control-label\" translate>GLOBAL.TO</label>\n                <datepicker datepicker-model class=\"col-xs-10\" date-min-limit=\"{{vm.filters[\'filter[invoice_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                    <input datepicker-model type=\"text\" class=\"form-control\" id=\"invoiceListFilterDateTo\" ng-model=\"vm.filters[\'filter[invoice_date][to]\']\">\n                    <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                </datepicker>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group col-xs-2\">\n        <label translate>INVOICE.DUE_DATE</label>\n        <div class=\"form-horizontal range-inputs-container\">\n            <div class=\"form-group has-feedback\">\n                <label for=\"invoiceListFilterDueFrom\" class=\"col-xs-2 control-label\" translate>GLOBAL.FROM</label>\n                <datepicker datepicker-model class=\"col-xs-10\" date-max-limit=\"{{vm.filters[\'filter[due_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                    <input datepicker-model type=\"text\" class=\"form-control\" id=\"invoiceListFilterDueFrom\" ng-model=\"vm.filters[\'filter[due_date][from]\']\">\n                    <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                </datepicker>\n            </div>\n            <div class=\"form-group has-feedback\">\n                <label for=\"invoiceListFilterDueTo\" class=\"col-xs-2 control-label\" translate>GLOBAL.TO</label>\n                <datepicker datepicker-model class=\"col-xs-10\" date-min-limit=\"{{vm.filters[\'filter[due_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                    <input datepicker-model type=\"text\" class=\"form-control\" id=\"invoiceListFilterDueTo\" ng-model=\"vm.filters[\'filter[due_date][to]\']\">\n                    <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                </datepicker>\n            </div>\n        </div>\n    </div>\n    <div class=\"form-group col-xs-2\">\n        <label translate>INVOICE.AMOUNT</label>\n        <div class=\"form-horizontal range-inputs-container\">\n            <div class=\"form-group\">\n                <label for=\"invoiceListFilterAmountFrom\" class=\"col-xs-2 control-label\" translate>GLOBAL.FROM</label>\n                <div class=\"col-xs-10\">\n                    <input type=\"number\" class=\"form-control\" id=\"invoiceListFilterAmountFrom\" step=\"0.01\" ng-model=\"vm.filters[\'filter[net_total][from]\']\" sg-disable-input-scroll>\n                </div>\n            </div>\n            <div class=\"form-group\">\n                <label for=\"invoiceListFilterAmountTo\" class=\"col-xs-2 control-label\" translate>GLOBAL.TO</label>\n                <div class=\"col-xs-10\">\n                    <input type=\"number\" class=\"form-control\" id=\"invoiceListFilterAmountTo\" step=\"0.01\" ng-model=\"vm.filters[\'filter[net_total][to]\']\" sg-disable-input-scroll>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"col-xs-3\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!vm.pendingChanges()\" translate>GLOBAL.SEARCH</button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clearFilters()\" translate>GLOBAL.CLEAR_FILTERS</button>\n    </div>\n\n</form>\n");
$templateCache.put("app/invoice/partials/index.html","<div class=\"invoice-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>\n");
$templateCache.put("app/invoice/partials/list.html","<header class=\"page-header clearfix\">\n    <h1 translate>INVOICE.LIST</h1>\n</header>\n\n<div class=\"well well-sm\">\n    <sg-invoices-list-filters filters=\"filters\"></sg-invoices-list-filters>\n</div>\n\n<sg-invoices-list filters=\"filters\"></sg-invoices-list>");
$templateCache.put("app/offer/components/offerAddressForm.html","<ng-form name=\"offerAddressForm\">\n    <div class=\"row\">\n        <div class=\"form-group col-xs-6\" show-input-errors>\n            <label for=\"offerEditor_address_presets\" translate>GLOBAL.SELECT</label>\n            <div class=\"wrapSelect\">\n                <select class=\"form-control\" id=\"offerEditor_address_presets\" ng-disabled=\"!vm.editable\" name=\"presets\" ng-model=\"vm.currentPreset\" ng-change=\"vm.usePreset(vm.currentPreset)\" ng-options=\"address as address.label for address in vm.addresses track by address.entity_id\">\n                    <option value=\"\" selected=\"selected\" translate>ACCOUNT.NEW_ADDRESS</option>\n                </select>\n            </div>\n        </div>\n        <div class=\"form-group col-xs-6 clearfix form-group-datepicker\">\n            <label for=\"offerEditor_address_shipping_date\" class=\"\" translate>ORDER.SHIPPING_DATE</label>\n            <datepicker datepicker-model date-min-limit=\"{{vm.today.toDateString()}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                <input datepicker-model id=\"offerEditor_address_shipping_date\" ng-model=\"vm.model.sg_shipping_date\" type=\"text\" name=\"sg_shipping_date\" class=\"form-control\" ui-validate=\"{currDate : \'vm.validateShippingDate($value)\'}\" ng-blur=\"vm.focusField(\'offerEditor_address_name\')\" ng-disabled=\"!vm.editable\">\n            </datepicker>\n\n\n            <span class=\"c-error\" ng-show=\"offerAddressForm.sg_shipping_date.$error.parse\" translate>ERRORS.CURRENT_DATE</span>\n            <span class=\"c-error\" ng-show=\"offerAddressForm.sg_shipping_date.$error.currDate\" translate>ERRORS.CURRENT_DATE</span>\n            <span class=\"c-error\" ng-show=\"offerAddressForm.sg_shipping_date.$error.required\" translate>ERRORS.REQUIRED</span>\n        </div>\n    </div>\n\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"offerEditor_address_name\" class=\"required\" translate>ORDER.COMPANY</label>\n        <input id=\"offerEditor_address_name\" ng-model=\"vm.model.company\" type=\"text\" name=\"name\" class=\"form-control\" maxlength=\"140\" ng-disabled=\"!vm.editable\" required>\n        <span class=\"c-error\" ng-show=\"offerAddressForm.name.$error.required\" translate>ERRORS.REQUIRED</span>\n    </div>\n\n    <div class=\"row\">\n        <div class=\"form-group col-xs-6\" show-input-errors>\n            <label for=\"offerEditor_address_postcode\" class=\"\" translate>GLOBAL.POSTAL_CODE</label>\n            <input id=\"offerEditor_address_postcode\" ng-model=\"vm.model.postcode\" type=\"text\" name=\"postcode\" uib-typeahead=\"postcode as postcode for postcode in vm.findPostCodes($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"0\" class=\"form-control\" autocomplete=\"off\" ng-disabled=\"!vm.editable\">\n            <span class=\"c-error\" ng-show=\"offerAddressForm.postcode.$error.postcode\" translate>ERRORS.POSTCODE</span>\n        </div>\n        <div class=\"form-group col-xs-6\" show-input-errors>\n            <label for=\"offerEditor_address_city\" class=\"\" translate>GLOBAL.CITY</label>\n            <input id=\"offerEditor_address_city\" ng-model=\"vm.model.city\" type=\"text\" name=\"city\" uib-typeahead=\"city as city for city in vm.findCities($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"1\" autocomplete=\"off\" class=\"form-control\" maxlength=\"140\" ng-disabled=\"!vm.editable\">\n            <span class=\"c-error\" ng-show=\"offerAddressForm.city.$error.required\" translate>ERRORS.REQUIRED</span>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"form-group col-xs-9\" show-input-errors>\n            <label for=\"offerEditor_address_street\" class=\"\" translate>GLOBAL.STREET</label>\n            <input id=\"offerEditor_address_street\" ng-model=\"vm.model.street\" type=\"text\" name=\"street\" uib-typeahead=\"street as street for street in vm.findStreets($viewValue)\" typeahead-wait-ms=\"250\" typeahead-min-length=\"1\" autocomplete=\"off\" class=\"form-control\" maxlength=\"255\" ng-disabled=\"!vm.editable\">\n            <span class=\"c-error\" ng-show=\"offerAddressForm.street.$error.required\" translate>ERRORS.REQUIRED</span>\n        </div>\n        <div class=\"form-group col-xs-3\" show-input-errors>\n            <label for=\"offerEditor_address_building\" class=\"\" translate>GLOBAL.BUILDING</label>\n            <input id=\"offerEditor_address_building\" ng-model=\"vm.model.building\" type=\"text\" name=\"building\" class=\"form-control\" maxlength=\"20\" ng-disabled=\"!vm.editable\">\n        </div>\n    </div>\n\n\n    <h4 translate>ACCOUNT.CONTACT_IN_DELIVERY_PLACE</h4>\n\n    <div class=\"row\">\n        <div class=\"form-group col-xs-12\" show-input-errors>\n            <label class=\"\" for=\"offerEditor_address_fullname\" translate>GLOBAL.FULLNAME</label>\n            <input type=\"text\" id=\"offerEditor_address_fullname\" class=\"form-control\" ng-model=\"vm.model.fullname\" name=\"fullname\" maxlength=\"255\" ng-disabled=\"!vm.editable\">\n            <span class=\"c-error\" ng-show=\"offerAddressForm.fullname.$error.required\" translate>ERRORS.REQUIRED</span>\n        </div>\n    </div>\n\n    <div class=\"form-group\" show-input-errors>\n        <label class=\"\" for=\"offerEditor_address_phone\" translate>GLOBAL.PHONE</label>\n        <input type=\"text\" id=\"offerEditor_address_phone\" class=\"form-control\" ng-model=\"vm.model.telephone\" name=\"phone\" ui-mask=\"999-999-999\" ng-disabled=\"!vm.editable\">\n        <span class=\"c-error\" ng-show=\"offerAddressForm.phone.$error.required\" translate>ERRORS.REQUIRED</span>\n    </div>\n\n</ng-form>\n\n");
$templateCache.put("app/offer/components/offerAttrsForm.html","<ng-form name=\"offerAttrsForm\">\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"offerEditor_date\" translate>ORDER.OFFER_DATE</label>\n        <input type=\"text\" id=\"offerEditor_date\" class=\"form-control\" ng-model=\"vm.model.offerdate\" name=\"offerDate\" maxlength=\"30\" ng-disabled=\"!vm.editable\" ui-mask=\"9999-99-99\" model-view-value=\"{{true}}\" ng-pattern=\"/2[0-9]{3}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])/\">\n        <span class=\"c-error\" ng-show=\"vm.model.offerdate !== null && vm.model.offerdate !== \'\' && offerAttrsForm.offerDate.$error.pattern\" translate>ERRORS.VALID_DATE</span>\n    </div>\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"offerEditor_request\" translate>ORDER.SERVICE_REQUEST</label>\n        <span translate>ORDER.PDF_NOT_SHOW</span>\n        <input type=\"text\" id=\"offerEditor_request\" class=\"form-control\" ng-model=\"vm.model.sg_service_request\" name=\"request\" maxlength=\"30\" ng-disabled=\"!vm.editable\">\n    </div>\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"offerEditor_warning\" translate>GLOBAL.COMMENTS</label>\n        <span translate>ORDER.PDF_NOT_SHOW</span>\n        <textarea id=\"offerEditor_warning\" class=\"form-control\" ng-model=\"vm.model.sg_reference\" name=\"warning\" maxlength=\"400\" ng-disabled=\"!vm.editable\"></textarea>\n    </div>\n    <div class=\"form-group\" show-input-errors>\n        <label for=\"offerEditor_note\" translate>ORDER.NOTE</label>\n        <span translate>ORDER.PDF_SHOW</span>\n        <textarea id=\"offerEditor_note\" class=\"form-control\" ng-model=\"vm.model.sg_note\" name=\"note\" maxlength=\"255\" ng-disabled=\"!vm.editable\"></textarea>\n    </div>\n</ng-form>");
$templateCache.put("app/offer/components/offerEditor.html","<form ng-submit=\"vm.saveChanges()\" name=\"vm.offerForm\" promise-btn ng-class=\"{\'show-errors\': vm.offerForm.$submitted}\" novalidate cg-busy=\"{promise:vm.model.$promise, message:\'\'}\">\n\n    <uib-alert type=\"danger\" ng-if=\"vm.fatalErrorMsg\">\n        <span translate=\"{{vm.fatalErrorMsg}}\"></span>\n    </uib-alert>\n\n    <div class=\"row\" ng-show=\"vm.step === 1\">\n        <div ng-switch=\"vm.editable || vm.model.isPhantom()\">\n            <!-- READ ONLY -->\n            <div ng-switch-when=\"false\" class=\"col-xs-3\">\n                <h4>{{vm.model.name}}</h4>\n            </div>\n            <!-- WRITABLE -->\n            <div ng-switch-when=\"true\">\n                <sg-name-editor class=\"col-xs-3\" model=\"vm.model\" label=\"{{\'OFFER.NAME\'|translate}}\" placeholder=\"{{\'OFFER.NAME\'|translate}}\" ng-show=\"vm.model.$resolved !== false\" on-request-change=\"vm.changeName(name)\"></sg-name-editor>\n            </div>\n        </div>\n    </div>\n    <uib-alert type=\"danger\" close=\"vm.clearFailed()\" ng-show=\"vm.itemsFailed.length > 0\">\n        <span translate>OFFER.FAILED_SKU_CONVERT</span>:\n        <span class=\"failed-sku\" ng-repeat=\"sku in vm.itemsFailed track by $index\">{{sku}}</span>\n    </uib-alert>\n    <div ng-if=\"!vm.model.isPhantom()\">\n        <div ng-show=\"vm.step === 1\">\n            <div class=\"offer-header\">\n                <h3 class=\"section-name\" translate>OFFER.PRODUCTS_OF_STALGAST</h3>\n                <div>\n                    <input id=\"ignorePromoPrice\" type=\"checkbox\" ng-model=\"vm.model.ignore_promo_price\" ng-click=\"vm.changePromoPrice()\">\n                    <label for=\"ignorePromoPrice\" translate=\"\">OFFER.IGNORE_PROMO_PRICE</label>\n                </div>\n            </div>\n            <sg-offer-items model=\"vm.model\" selectable=\"true\" allow-add-items=\"vm.allowAddItems\" allow-edit-items=\"vm.allowEditItems\" allow-remove-items=\"vm.allowRemoveItems\" on-request-add=\"vm.addItem(item)\" on-request-update=\"vm.updateItem(item)\" on-request-remove=\"vm.removeItem(item)\" on-request-remove-multi=\"vm.removeItem(items)\" promise-offer-changed=\"vm.promiseOfferChanged\" form-step=\"vm.step\" items-waiting=\"vm.itemsWaiting\"></sg-offer-items>\n\n        </div>\n\n        <div class=\"row\" ng-show=\"vm.step === 1\">\n            <sg-cart-summary model=\"vm.model\" class=\"col-xs-6 col-xs-push-6\"></sg-cart-summary>\n        </div>\n        <div class=\"text-right\" ng-show=\"vm.step === 1\">\n            <button type=\"button\" class=\"btn btn-lg btn-primary\" ng-disabled=\"!vm.model.hasItems()\" ng-click=\"vm.goToStep(2)\" translate>OFFER.NEXT_STEP</button>\n        </div>\n        <div class=\"row\" cg-busy=\"{promise:vm.downloadFilePromise, message:\'\'}\" ng-show=\"vm.step === 2\">\n            <div class=\"col-xs-5\">\n\n                <h3 translate>OFFER.PLANNED_DELIVERY_ADDRESS</h3>\n                <sg-offer-address-form model=\"vm.model\" editable=\"vm.editable\"></sg-offer-address-form>\n            </div>\n            <div class=\"col-xs-push-1 col-xs-6\">\n                <h3 translate>OFFER.REFER_DETAILS</h3>\n                <sg-offer-refer-form model=\"vm.model\" editable=\"vm.editable\"></sg-offer-refer-form>\n                <sg-offer-attrs-form model=\"vm.model\" editable=\"vm.editable\"></sg-offer-attrs-form>\n            </div>\n            <div class=\"col-xs-12\">\n                <div class=\"well offer-options\">\n                    <sg-offer-options-form model=\"vm.model\" editable=\"vm.editable\" export-file-types=\"vm.exportFileTypes\" export-file-type=\"vm.exportFileType\"></sg-offer-options-form>\n                </div>\n            </div>\n        </div>\n\n        <footer class=\"text-right\" ng-show=\"vm.step === 2\">\n            <button type=\"button\" class=\"btn btn-link pull-left\" ng-click=\"vm.goToStep(1)\" translate>\n                OFFER.PREVIOUS_STEP\n            </button>\n            <button type=\"submit\" class=\"btn btn-lg btn-primary\" ng-show=\"vm.editable\" translate>OFFER.UPDATE</button>\n            <button type=\"button\" ng-click=\"vm.downloadFile()\" uib-tooltip=\"{{\'OFFER.GENERATION_TOOLTIP\'|translate}}\" tooltip-enable=\"vm.generationTooltipEnabled()\" class=\"btn btn-lg btn-default\" promise-btn>\n                <span translate>OFFER.DOWNLOAD_FILE</span>\n            </button>\n            <button type=\"button\" ng-click=\"vm.sendByEmail()\" class=\"btn btn-lg btn-default\" promise-btn>\n                <span translate>OFFER.SEND_MAIL</span>\n            </button>\n\n        </footer>\n    </div>\n\n</form>\n");
$templateCache.put("app/offer/components/offerItem.html","<!-- Position -->\n<td class=\"text-center\" ng-show=\"vm.itemExists()\">\n    <span class=\"offer-item-position\">{{vm.position}}</span>\n</td>\n\n<!-- Selection control -->\n<td ng-show=\"vm.selectable && vm.removable && vm.itemExists()\">\n    <div ng-show=\"vm.itemExists()\">\n        <input type=\"checkbox\" ng-attr-id=\"offerItem{{vm.model.item_id}}\" ng-model=\"vm.isSelected\">\n        <label ng-attr-for=\"offerItem{{vm.model.item_id}}\"></label>\n    </div>\n</td>\n<td ng-show=\"!vm.itemExists()\" class=\"input-desc text-right\" colspan=\"2\">\n    <strong translate>GLOBAL.INSERT_SKU</strong>\n</td>\n<!-- SKU -->\n<td>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.workCopy.sku\" name=\"sku\" ng-readonly=\"vm.itemExists()\" maxlength=\"20\" size=\"6\" placeholder=\"{{\'OFFER.SKU_ABRV\'|translate}}\" pattern=\"^[A-Za-z0-9]*$\" uib-typeahead=\"product.sku as product.label for product in vm.findProduct($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"2\" typeahead-select-on-blur=\"true\" typeahead-on-select=\"vm.updateDefaultQty($item)\" ng-enter=\"vm.saveChanges()\" ng-blur=\"vm.updateItemIfExist()\" ng-tab=\"vm.focusField(\'qty\', 10)\" ng-focus=\"vm.onFocus()\" autocomplete=\"off\">\n</td>\n\n<!-- Product Name -->\n<td>\n    <span class=\"offer-item-name\">{{vm.workCopy.name}}</span>\n    <p ng-if=\"vm.workCopy.promotion_code_text\" class=\"promotion-info\">{{vm.workCopy.promotion_code_text}}</p>\n</td>\n<td class=\"icon\">\n    <product-info-button-launcher model=\"vm.workCopy\" allow-add-to-cart=\"true\" ng-show=\"vm.itemExists()\"></product-info-button-launcher>\n</td>\n\n<!-- Product Brand -->\n<td>\n    <span class=\"offer-item-brand\">{{vm.workCopy.brand}}</span>\n</td>\n\n<!-- Catalog price -->\n<td class=\"text-right\">\n    <span class=\"price offer-item-price\" ng-class=\"{\'price-deprecated\': vm.itemIsInSale()}\">{{vm.workCopy.price | currency}}</span>\n    <span ng-show=\"vm.itemIsInSale()\">{{vm.workCopy.promotion_price | currency}}</span>\n</td>\n\n<!-- Custom price -->\n<td class=\"text-right\" sg-access=\"resellerPrices\">\n    {{vm.workCopy.reseller_price | currency}}\n</td>\n\n<!-- Quantity -->\n<td>\n    <div class=\"input-number-container\">\n        <input type=\"number\" class=\"form-control text-center\" ng-readonly=\"!vm.editable\" ng-model=\"vm.workCopy.qty\" name=\"qty\" ng-class=\"{\'invalid\': !vm.qtyValid || !vm.qtyIncValid}\" uib-tooltip=\"{{vm.incrementErrorMsg}}\" tooltip-enable=\"vm.qtyValid && !vm.qtyIncValid\" tooltip-placement=\"left\" tooltip-is-open=\"vm.qtyValid && !vm.qtyIncValid\" sg-disable-input-scroll ng-enter=\"vm.saveChanges()\" ng-tab=\"vm.focusField(\'discount\')\" ng-blur=\"vm.updateItemIfExist()\" ng-min=\"1\" ng-step=\"vm.workCopy.qtyIncrements\" size=\"3\">\n        <div class=\"btn-group-vertical\" ng-show=\"vm.editable\">\n            <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.increaseQty()\" ng-if=\"vm.workCopy.qtyIncrements\" ng-disabled=\"!vm.increaseAvaliable()\">+</button>\n            <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.decreaseQty()\" ng-if=\"vm.workCopy.qtyIncrements\" ng-disabled=\"!vm.decreaseAvaliable()\">-</button>\n        </div>\n    </div>\n</td>\n\n<!-- Availability -->\n<td class=\"text-center\">\n    <span ng-class=\"vm.isQtyLessThanStock() ? \'badge badge-success\' : \'badge badge-warning\'\" uib-tooltip=\"{{vm.isQtyLessThanStock()?\'\':(vm.labels[\'CART.NOT_AVAILABLE_HELPTEXT\'])}}\" data-placement=\"top\">{{vm.workCopy.stockVisible}}</span>\n    <product-info-delivery model=\"vm.workCopy.dlvDate\"></product-info-delivery>\n</td>\n\n<!-- Discount percentage -->\n<td class=\"percentage-column text-center\" ng-switch=\"vm.editable\">\n    <div ng-switch-when=\"false\">{{vm.workCopy.discount}}%</div>\n    <div ng-switch-when=\"true\" class=\"no-wrap flex-item\">\n        <div class=\"input-number-container\">\n            <div class=\"input-group\">\n                <input type=\"number\" name=\"discount\" class=\"form-control text-center\" sg-disable-input-scroll ng-model=\"vm.workCopy.discount\" maxlength=\"4\" step=\"0.01\" min=\"0\" max=\"99.9\" ng-enter=\"vm.saveChanges()\" ng-tab=\"vm.focusField(\'sku\')\" ng-blur=\"vm.updateItemIfExist()\">\n                <span class=\"input-group-addon\">%</span>\n            </div>\n\n        </div>\n        <span uib-tooltip=\"{{::\'OFFER.PRICE_BELOW_PURCHASE_PRICE\'|translate}}\" translate tooltip-placement=\"left\" tooltip-animation=\"false\" ng-show=\"vm.warningPromoPrice\" class=\"warning-price\">\n                !\n        </span>\n    </div>\n</td>\n\n<!-- Subtotal price amount -->\n<td class=\"text-right\">\n    <span>{{vm.workCopy.row_total_excl_tax | currency}}</span>\n</td>\n\n<!-- Remove item from offer -->\n<td class=\"remove-column\" ng-if=\"vm.removable\">\n    <confirmable ng-if=\"vm.removeButtonVisible\" unconfirmed-text=\"{{::vm.labels[\'GLOBAL.REMOVE\']}}\" confirming-text=\"{{::vm.labels[\'GLOBAL.SURE?\']}}\" when-confirmed=\"vm.requestRemove\" ng-show=\"vm.itemExists()\">\n        <button type=\"button\" class=\"btn btn-danger\"><confirmable-outlet></confirmable-outlet></button>\n    </confirmable>\n</td>\n");
$templateCache.put("app/offer/components/offerItemExtended.html","<!-- Position -->\n<td class=\"text-center\" ng-show=\"vm.itemExists()\">\n    <span class=\"offer-item-position\">{{vm.position}}</span>\n</td>\n\n<!-- Selection control -->\n<td ng-show=\"vm.selectable && vm.removable && vm.itemExists()\">\n    <div ng-show=\"vm.itemExists()\">\n        <input type=\"checkbox\" ng-attr-id=\"offerItem{{vm.model.item_id}}\" ng-model=\"vm.isSelectedExtended\">\n        <label ng-attr-for=\"offerItem{{vm.model.item_id}}\"></label>\n    </div>\n</td>\n<td ng-show=\"!vm.itemExists()\" class=\"input-desc text-right\" colspan=\"2\">\n    <strong translate>GLOBAL.INSERT_SKU</strong>\n</td>\n<!-- SKU -->\n<td>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.workCopy.sku\" name=\"sku\" maxlength=\"20\" size=\"6\" placeholder=\"{{\'OFFER.SKU_ABRV\'|translate}}\" ng-enter=\"vm.saveChanges()\" ng-tab=\"vm.focusField(\'name\', 10)\" ng-focus=\"vm.onFocus()\" autocomplete=\"off\">\n</td>\n\n<!-- Product Name -->\n<td>\n    <div>\n        <input type=\"text\" class=\"form-control\" ng-model=\"vm.workCopy.name\" name=\"name\" maxlength=\"400\" size=\"6\" placeholder=\"{{\'OFFER.PRODUCT\'|translate}} *\" ng-enter=\"vm.saveChanges()\" ng-blur=\"vm.updateItemIfExist()\" ng-tab=\"vm.focusField(\'brand\', 10)\" ng-focus=\"vm.onFocus()\" ng-change=\"vm.isEmpty(\'name\')\" ng-click=\"vm.isEmpty(\'name\')\" autocomplete=\"off\">\n        <span class=\"required_name\" translate>ERRORS.REQUIRED</span>\n    </div>\n</td>\n\n<!-- Product Brand -->\n<td>\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.workCopy.brand\" name=\"brand\" maxlength=\"40\" size=\"6\" placeholder=\"{{\'OFFER.BRAND\'|translate}}\" ng-enter=\"vm.saveChanges()\" ng-blur=\"vm.updateItemIfExist()\" ng-tab=\"vm.focusField(\'price\', 10)\" ng-focus=\"vm.onFocus()\" autocomplete=\"off\">\n</td>\n\n<!-- Catalog price -->\n<td>\n    <div>\n        <input type=\"text\" class=\"form-control text-center\" ng-model=\"vm.workCopy.price\" name=\"price\" maxlength=\"50\" size=\"6\" placeholder=\"{{\'OFFER.PRICE\'|translate}} *\" pattern=\"^[0-9.,]*$\" ng-enter=\"vm.saveChanges()\" ng-blur=\"vm.updateItemIfExist()\" ng-tab=\"vm.focusField(\'qty\', 10)\" ng-focus=\"vm.onFocus()\" ng-change=\"vm.isEmpty(\'price\')\" ng-click=\"vm.isEmpty(\'price\')\" step=\"0.01\" min=\"0.01\" max=\"9999999999999999999999.99\" autocomplete=\"off\">\n        <span class=\"required_price\" translate>ERRORS.REQUIRED</span>\n    </div>\n</td>\n\n<!-- Quantity -->\n<td>\n    <div class=\"input-number-container\">\n        <input type=\"number\" class=\"form-control text-center\" ng-model=\"vm.workCopy.qty\" name=\"qty\" sg-disable-input-scroll ng-enter=\"vm.saveChanges()\" ng-tab=\"vm.focusField(\'discount\')\" ng-min=\"1\" ng-step=\"1\" size=\"3\">\n        <div class=\"btn-group-vertical\">\n            <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.increaseQty()\">+</button>\n            <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.decreaseQty()\" ng-disabled=\"!vm.decreaseAvaliable()\">-</button>\n        </div>\n    </div>\n</td>\n\n<!-- Discount percentage -->\n<td class=\"percentage-column text-center\" ng-switch=\"vm.editable\">\n    <div ng-switch-when=\"false\">{{vm.workCopy.discount}}%</div>\n    <div ng-switch-when=\"true\" class=\"no-wrap\">\n        <div class=\"input-number-container\">\n            <div class=\"input-group\">\n                <input type=\"number\" name=\"discount\" class=\"form-control text-center\" sg-disable-input-scroll ng-model=\"vm.workCopy.discount\" maxlength=\"4\" step=\"0.01\" min=\"0\" max=\"99.9\" ng-enter=\"vm.saveChanges()\" ng-tab=\"vm.focusField(\'sku\')\" ng-blur=\"vm.updateItemIfExist()\">\n                <span class=\"input-group-addon\">%</span>\n            </div>\n        </div>\n    </div>\n</td>\n\n<!-- Subtotal price amount -->\n<td class=\"text-right\">{{vm.workCopy.row_total_excl_tax | currency}}</td>\n\n<!-- Remove item from offer -->\n<td class=\"remove-column\" ng-if=\"vm.removable\">\n    <confirmable ng-if=\"vm.removeButtonVisible\" unconfirmed-text=\"{{::vm.labels[\'GLOBAL.REMOVE\']}}\" confirming-text=\"{{::vm.labels[\'GLOBAL.SURE?\']}}\" when-confirmed=\"vm.requestRemove\" ng-show=\"vm.itemExists()\">\n        <button type=\"button\" class=\"btn btn-danger\"><confirmable-outlet></confirmable-outlet></button>\n    </confirmable>\n</td>\n");
$templateCache.put("app/offer/components/offerItems.html","<div rows=\"vm.model.items\">\n\n    <table class=\"table table-striped\" cg-busy=\"{promise:vm.model.items.$promise, message:\'\', minDuration:300}\">\n        <thead>\n        <tr class=\"table-header\">\n            <th class=\"id-column text-center\" translate>OFFER.ITEM_POSITION</th>\n            <th class=\"select-column\" ng-show=\"vm.selectable && vm.allowRemoveItems\">\n                <input id=\"offerItemsBatchSelectCheckbox\" type=\"checkbox\" ng-model=\"vm.areAllSelected\" ng-change=\"vm.applyBatchSelection(vm.areAllSelected)\">\n                <label for=\"offerItemsBatchSelectCheckbox\"></label>\n            </th>\n            <th class=\"sku-column\" translate>OFFER.SKU</th>\n            <th class=\"name-column\" colspan=\"2\" translate>OFFER.PRODUCT</th>\n            <th class=\"brand-column\" translate>OFFER.BRAND</th>\n            <th class=\"price-column text-right has-qi\">\n                <span uib-tooltip=\"{{::\'OFFER.PRICE_OF_LIST_HELPTEXT\'|translate}}\" translate tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                    OFFER.PRICE_OF_LIST\n                </span>\n            </th>\n            <th class=\"price-column text-right\" sg-access=\"resellerPrices\" translate>OFFER.YOUR_PRICE</th>\n            <th class=\"qty-column text-center\" translate>OFFER.QUANTITY</th>\n            <th class=\"availability-column text-center has-qi\">\n                <span uib-tooltip=\"{{::\'OFFER.AVAILABILITY_HELPTEXT\'|translate}}\" translate tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                    OFFER.AVAILABILITY\n                </span>\n            </th>\n            <th class=\"discount-column text-left\" translate>OFFER.DISCOUNT_OFFER</th>\n            <th class=\"price-column text-right\" translate>OFFER.NET_AMOUNT</th>\n            <th class=\"remove-column\" ng-show=\"vm.allowRemoveItems\"></th>\n        </tr>\n        <tr class=\"loader\" cg-busy=\"{promise:vm.promiseOfferChanged, message:\'\'}\">\n        </tr>\n        </thead>\n\n        <tbody>\n        <!-- Rows for each existing items in the offer -->\n        <tr sg-offer-item ng-repeat=\"item in vm.model.items track by $index\" model=\"item\" position=\"$index+1\" selectable=\"vm.selectable\" is-selected=\"vm.isSelected(item)\" editable=\"vm.allowEditItems\" removable=\"vm.allowRemoveItems\" on-request-update=\"vm.onRequestUpdate({item:item})\" on-request-remove=\"vm.onRequestRemove({item:item})\" on-selection-change=\"vm.updateSelection(item, selected)\"></tr>\n\n        <!-- Row to add a new item -->\n        <tr sg-offer-item class=\"add-new-item\" ng-show=\"vm.allowAddItems\" selectable=\"vm.selectable\" removable=\"vm.allowRemoveItems\" editable=\"true\" on-request-create=\"vm.requestAdd(item)\" sku-exclude-list=\"vm.usedSKUs\" is-product-in-offer=\"vm.isProductInOffer\"></tr>\n        </tbody>\n\n    </table>\n\n    <div class=\"show-extended\">\n        <a class=\"arrow-after-up\" href=\"#\" ng-show=\"showExtended\" ng-click=\"showExtended = false\">\n            <span translate class=\"ng-scope\">OFFER.HIDE_EXTENDED_OFFERS</span>\n        </a>\n        <a class=\"arrow-after-down\" href=\"#\" ng-show=\"!showExtended\" ng-click=\"showExtended = true\">\n            <span translate class=\"ng-scope\" ng-if=\"vm.model.items_extended.length === 0\">OFFER.ADD_EXTENDED_OFFERS</span>\n            <span translate class=\"ng-scope\" ng-if=\"vm.model.items_extended.length > 0\">OFFER.SHOW_EXTENDED_OFFERS</span>\n        </a>\n    </div>\n\n    <div ng-show=\"showExtended\">\n        <h3 class=\"section-name\" translate>OFFER.PRODUCTS_OUTSIDE_STALGAST</h3>\n        <table class=\"table table-striped\" cg-busy=\"{promise:vm.model.items.$promise, message:\'\', minDuration:300}\">\n            <thead>\n            <tr class=\"table-header\">\n                <th class=\"id-column text-center\" translate>OFFER.ITEM_POSITION</th>\n                <th class=\"select-column\" ng-show=\"vm.selectable && vm.allowRemoveItems\">\n                    <input id=\"offerItemsBatchSelectCheckboxExtended\" type=\"checkbox\" ng-model=\"vm.areAllSelectedExtended\" ng-change=\"vm.applyBatchSelectionExtended(vm.areAllSelectedExtended)\">\n                    <label for=\"offerItemsBatchSelectCheckboxExtended\"></label>\n                </th>\n                <th class=\"sku-column\" translate>OFFER.SKU</th>\n                <th class=\"name-column\">{{\'OFFER.PRODUCT\' | translate}} *</th>\n                <th class=\"brand-column\" translate>OFFER.BRAND</th>\n                <th class=\"price-column text-right\">\n                    {{\'OFFER.PRICE\'|translate}} ({{\'OFFER.CURRENCY\'|translate}}) *\n                </th>\n                <th class=\"qty-column text-center\" translate>OFFER.QUANTITY</th>\n                <th class=\"discount-column text-left\" translate>OFFER.DISCOUNT_OFFER</th>\n                <th class=\"price-column text-right\" translate>OFFER.NET_AMOUNT</th>\n                <th class=\"remove-column\" ng-show=\"vm.allowRemoveItems\"></th>\n            </tr>\n            <tr class=\"loader\" cg-busy=\"{promise:vm.promiseOfferChanged, message:\'\'}\">\n            </tr>\n            </thead>\n\n            <tbody>\n            <!-- Rows for each existing items in the offer -->\n            <tr sg-offer-item-extended ng-repeat=\"item in vm.model.items_extended track by $index\" model=\"item\" position=\"$index+1\" selectable=\"vm.selectable\" is-selected-extended=\"vm.isSelectedExtended(item)\" editable=\"vm.allowEditItems\" removable=\"vm.allowRemoveItems\" on-request-update=\"vm.onRequestUpdate({item:item})\" on-request-remove=\"vm.onRequestRemove({item:item})\" form-step=\"vm.formStep\" on-selection-change=\"vm.updateSelectionExtended(item, selected)\"></tr>\n\n            <!-- Row to add a new item -->\n            <tr sg-offer-item-extended class=\"add-new-item\" ng-show=\"vm.allowAddItems\" selectable=\"vm.selectable\" removable=\"vm.allowRemoveItems\" editable=\"true\" on-request-create=\"vm.requestAdd(item)\" sku-exclude-list=\"vm.usedSKUs\" is-product-in-offer=\"vm.isProductInOffer\"></tr>\n            </tbody>\n\n        </table>\n    </div>\n\n\n    <div class=\"row\">\n        <div class=\"col-xs-2\">\n            <!-- Button to remove all the selected items -->\n            <button type=\"button\" class=\"btn btn-danger\" mwl-confirm ng-show=\"vm.selectable && vm.allowRemoveItems\" data-title=\"{{::vm.labels[\'GLOBAL.REMOVE_SELECTION\']}}\" message=\"{{::vm.labels[\'GLOBAL.ARE_YOU_SURE\']}}\" confirm-text=\"{{::vm.labels[\'GLOBAL.YES\']}}\" cancel-text=\"{{::vm.labels[\'GLOBAL.NO\']}}\" on-confirm=\"vm.removeAllSelected()\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" ng-disabled=\"vm.selection.length==0 && vm.selectionExtended.length==0\">{{::vm.labels[\'GLOBAL.REMOVE_SELECTION\']}}</button>\n        </div>\n        <div class=\"col-xs-5\">\n            <!-- Widget to apply a specific discount to the selected offer items -->\n            <div class=\"batch-discount\">\n                <ng-form name=\"offerItemsDiscountBatch\" class=\"form-inline\" ng-show=\"vm.allowEditItems\">\n                    <div class=\"form-group\">\n                        <label for=\"offerItems_discountBatchInput\" translate>OFFER.DISCOUNT_OFFER</label>\n                        <div class=\"input-group input-group--short\">\n                            <input type=\"number\" id=\"offerItems_discountBatchInput\" name=\"discountBatch\" sg-disable-input-scroll class=\"form-control text-center\" ng-model=\"vm.batchDiscount\" maxlength=\"4\" step=\"0.1\" min=\"0\" max=\"99.9\" ng-disabled=\"vm.selection.length==0 && vm.selectionExtended.length==0\" ng-enter=\"vm.applyBatchDiscount()\">\n                            <span class=\"input-group-addon\">%</span>\n                        </div>\n                    </div>\n                    <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.applyBatchDiscount()\" ng-disabled=\"(vm.selection.length==0 && vm.selectionExtended.length==0) || vm.batchDiscount==null || !(vm.batchDiscount>=0 && vm.batchDiscount<=100)\" translate>OFFER.APPLY_TO_THE_SELECTED_ROWS</button>\n                </ng-form>\n            </div>\n        </div>\n        <div class=\"col-xs-5\">\n          <!-- Download a PDF cart of all the selected items -->\n          <button class=\"btn btn-default\" type=\"button\" ng-show=\"vm.selectable\" data-title=\"{{::vm.labels[\'GLOBAL.DOWNLOAD_CARD_FOR_SELECTED\']}}\" ng-click=\"vm.downloadCardForSelected()\" ng-disabled=\"vm.selection.length==0\">\n            {{ ::vm.labels[\'GLOBAL.DOWNLOAD_CARD_FOR_SELECTED\'] }}\n          </button>\n        </div>\n    </div>\n\n</div>\n");
$templateCache.put("app/offer/components/offerListFilters.html","<form class=\"row\" ng-submit=\"vm.applyChanges()\">\n\n    <div class=\"form-group\">\n        <label for=\"offerListFilterName\" translate>OFFER.NAME</label>\n        <input type=\"text\" class=\"form-control\" id=\"offerListFilterName\" ng-model=\"vm.filters[\'filter[name]\']\">\n    </div>\n    <div class=\"form-group\">\n        <label for=\"offerListFilterSku\" translate>OFFER.SKU</label>\n        <input type=\"text\" class=\"form-control\" id=\"offerListFilterSku\" ng-model=\"vm.filters[\'filter[sku]\']\">\n    </div>\n    <div class=\"form-group\">\n        <label for=\"offerListFilterRefer\" translate>OFFER.SERVICE_REQUEST</label>\n        <input type=\"text\" class=\"form-control\" id=\"offerListFilterRefer\" ng-model=\"vm.filters[\'filter[sg_service_request]\']\">\n    </div>\n    <div class=\"form-group\">\n        <label for=\"offerListFilterCreation\" translate>GLOBAL.CREATION</label>\n        <datepicker datepicker-model button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n            <input type=\"text\" class=\"form-control\" id=\"offerListFilterCreation\" datepicker datepicker-model ng-model=\"vm.filters[\'filter[created_at][from]\']\" placeholder=\"{{\'GLOBAL.DATE_FORMAT_CODE\'|translate}}\">\n        </datepicker>\n    </div>\n    <div class=\"form-group\">\n        <label for=\"offerListFilterCreator\" translate>GLOBAL.CREATOR</label>\n        <input type=\"text\" class=\"form-control\" id=\"offerListFilterCreator\" ng-model=\"vm.filters[\'filter[author_lastname]\']\">\n    </div>\n\n    <div class=\"col-xs-3\">\n        <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!vm.pendingChanges()\" translate>GLOBAL.SEARCH</button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clearFilters()\" translate>GLOBAL.CLEAR_FILTERS</button>\n    </div>\n\n</form>");
$templateCache.put("app/offer/components/offerOptionsForm.html","<div>\n    <h4 translate>OFFER.OPTIONS_TITLE</h4>\n    <div class=\"pull-right\">\n        <button type=\"button\" class=\"btn btn-link\" ng-click=\"vm.selectAll()\" ng-show=\"vm.editable\" translate>GLOBAL.SELECT_ALL</button>\n        <button type=\"button\" class=\"btn btn-link\" ng-click=\"vm.clearSelection()\" ng-show=\"vm.editable\" translate>GLOBAL.DESELECT_ALL</button>\n    </div>\n</div>\n<div class=\"form-inline\">\n    <div class=\"form-group\" ng-repeat=\"opt in vm.opts\">\n        <input type=\"checkbox\" ng-attr-id=\"offerOption_{{opt}}\" ng-model=\"vm.model[opt]\" ng-disabled=\"!vm.editable\">\n        <label ng-attr-for=\"offerOption_{{opt}}\" translate=\"OFFER.{{opt|uppercase}}\"></label>\n    </div>\n</div>\n<div class=\"form-inline\" ng-if=\"vm.exportFileTypes.length\">\n    <div>\n        <h4 translate>OFFER.FILE_TYPE</h4>\n    </div>\n    <div class=\"form-group\" ng-repeat=\"fileType in vm.exportFileTypes\">\n        <input type=\"radio\" name=\"exportFileType\" ng-model=\"vm.exportFileType\" ng-attr-id=\"fileType_{{fileType}}\" ng-value=\"fileType\" ng-disabled=\"!vm.editable\">\n        <label ng-attr-for=\"fileType_{{fileType}}\" translate=\"OFFER.FILE_TYPE_{{fileType|uppercase}}\"></label>\n    </div>\n</div>");
$templateCache.put("app/offer/components/offerReferForm.html","<ng-form name=\"offerReferForm\" class=\"offer-refer\">\n    <div class=\"row\">\n        <div class=\"col-xs-6\">\n            <div class=\"form-group\" show-input-errors>\n                <label class=\"required\" for=\"offerEditor_refer_firstname\" translate>GLOBAL.NAME</label>\n                <input type=\"text\" id=\"offerEditor_refer_firstname\" class=\"form-control\" ng-model=\"vm.model.author_firstname\" name=\"refFirstname\" maxlength=\"255\" ng-disabled=\"!vm.editable\" required>\n                <span class=\"c-error\" ng-show=\"offerReferForm.refFirstname.$error.required\" translate>ERRORS.REQUIRED</span>\n            </div>\n        </div>\n        <div class=\"col-xs-6\">\n            <div class=\"form-group\" show-input-errors>\n                <label class=\"required\" for=\"offerEditor_refer_lastname\" translate>GLOBAL.LAST_NAME</label>\n                <input type=\"text\" id=\"offerEditor_refer_lastname\" class=\"form-control\" ng-model=\"vm.model.author_lastname\" name=\"refLastname\" maxlength=\"255\" ng-disabled=\"!vm.editable\" required>\n                <span class=\"c-error\" ng-show=\"offerReferForm.refLastname.$error.required\" translate>ERRORS.REQUIRED</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-6\">\n            <div class=\"form-group\" show-input-errors>\n                <label class=\"required\" for=\"offerEditor_refer_email\" translate>GLOBAL.EMAIL</label>\n                <input type=\"email\" id=\"offerEditor_refer_email\" class=\"form-control\" ng-model=\"vm.model.author_email\" name=\"refEmail\" ng-disabled=\"!vm.editable\" required>\n                <span class=\"c-error\" ng-show=\"offerReferForm.refEmail.$error.required\" translate>ERRORS.REQUIRED</span>\n            </div>\n        </div>\n        <div class=\"col-xs-6\">\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"offerEditor_refer_phone\" translate>GLOBAL.PHONE</label>\n                <input type=\"text\" id=\"offerEditor_refer_phone\" class=\"form-control\" ng-model=\"vm.model.author_telephone\" name=\"refTelephone\" ui-mask=\"999-999-999\" ng-disabled=\"!vm.editable\">\n            </div>\n        </div>\n    </div>\n</ng-form>");
$templateCache.put("app/offer/partials/editor.html","<header class=\"page-header\">\n    <h1><span translate>OFFER.OFFER</span><small><span translate>GLOBAL.STEP</span> {{vm.step}}</small></h1>\n    <button type=\"button\" class=\"btn btn-default pull-right\" ng-click=\"vm.convertToCart()\" ng-hide=\"vm.model.isPhantom()\" sg-access=\"offers.toCart\" ng-disabled=\"!vm.model.hasItems()\" ng-attr-title=\"{{vm.getConvertToCartHint()}}\" translate>OFFER.CONVERT_TO_CART</button>\n</header>\n\n<sg-offer-editor model=\"vm.model\" editable=\"vm.access.offers.edit\" step=\"vm.step\" items-failed=\"vm.itemsFailed\" allow-add-items=\"vm.access.offers.edit && vm.access.offerItems.add\" allow-edit-items=\"vm.access.offers.edit && vm.access.offerItems.edit\" allow-remove-items=\"vm.access.offers.edit && vm.access.offerItems.delete\" on-create=\"vm.changeToUpdateMode(model)\"></sg-offer-editor>");
$templateCache.put("app/offer/partials/index.html","<div class=\"offer-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>");
$templateCache.put("app/offer/partials/list.html","<!--Header-->\n<header class=\"page-header clearfix\">\n    <h1 class=\"pull-left\" translate>OFFER.OFFER_LIST</h1>\n    <button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.startNewOffer()\" sg-access=\"offers.add\" translate>OFFER.NEW</button>\n</header>\n\n<!--Filters section-->\n<div class=\"well well-sm\" ng-hide=\"!paginator.haveFilters() && paginator.total==0\">\n    <sg-offer-list-filters filters=\"paginator.filters\"></sg-offer-list-filters>\n</div>\n\n<!--Results table-->\n<table class=\"table table-striped\" ng-show=\"paginator.total && !vm.errorMsg\" cg-busy=\"{promise: paginator.$promise, message: \'\'}\">\n    <thead>\n    <tr>\n        <th translate>OFFER.NAME</th>\n        <th translate>GLOBAL.CREATION</th>\n        <th translate>GLOBAL.CREATOR</th>\n        <th translate>GLOBAL.LAST_UPDATE</th>\n        <th translate>OFFER.PRODUCT_COUNT</th>\n        <th translate>OFFER.NET_AMOUNT</th>\n        <th class=\"limit-th\">\n            <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n            <div class=\"wrapSelect\">\n                <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n            </div>\n        </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in paginator.rows\">\n        <td>{{row.name}}</td>\n        <td>{{row.created_at | date}}</td>\n        <td>{{row.customer_fullname}}</td>\n        <td>{{row.updated_at | date}}</td>\n        <td>{{row.items_qty}}</td>\n        <td>{{row.subtotal | currency }}</td>\n        <td class=\"text-right nowrap actions\">\n            <button type=\"button\" class=\"btn btn-default btn-sm\" role=\"button\" ng-click=\"vm.openOffer(row)\" translate>GLOBAL.SEE</button>\n            <button type=\"button\" class=\"btn btn-danger btn-sm\" mwl-confirm data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"vm.deleteOffer(row)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" role=\"button\" sg-access=\"offers.delete\" translate>GLOBAL.DELETE</button>\n        </td>\n    </tr>\n    </tbody>\n</table>\n\n<!--Message when there\'s no results-->\n<uib-alert type=\"info\" ng-show=\"paginator.$resolved && paginator.total===0 && !vm.errorMsg\">\n    <span translate=\"{{paginator.haveFilters()?\'OFFER.THERE_IS_NO_MATCH_OFFERS\':\'OFFER.THERE_IS_NO_OFFERS\'}}\"></span>\n</uib-alert>\n\n<!--Error message-->\n<uib-alert type=\"danger\" ng-show=\"vm.errorMsg\">\n    <span translate=\"{{vm.errorMsg}}\"></span>\n</uib-alert>\n\n<!--Pagination bar-->\n<div class=\"clearfix\">\n    <sg-pagination paginator=\"paginator\"></sg-pagination>\n</div>");
$templateCache.put("app/order/components/sgOrderSummary.html","<div class=\"row summary-labels\">\n    <div class=\"col-xs-6\"></div>\n    <div class=\"col-xs-6\" translate>CART.ALL</div>\n</div>\n<div class=\"separator\"></div>\n<div class=\"row summary-net\">\n    <div class=\"col-xs-6\" translate>CART.NET_AMOUNT</div>\n    <div class=\"col-xs-6 price-value all\">{{vm.model.subtotal | currency}}</div>\n</div>\n<div class=\"row summary-gross\">\n    <div class=\"col-xs-6\" translate>CART.GROSS_AMOUNT</div>\n    <div class=\"col-xs-6 price-value all\">{{vm.model.grand_total | currency}}</div>\n</div>\n");
$templateCache.put("app/order/components/sgQuoteDetails.html","<div class=\"row\">\n\n    <div class=\"col-xs-6\">\n        <div class=\"form-group\">\n            <label translate>ORDER.NAME_OF_ORDER</label>\n            <p class=\"form-control-static\">{{vm.model.sg_order_name}}</p>\n        </div>\n        <div class=\"form-group\" ng-if=\"vm.model.sg_service_request\">\n            <label translate>ORDER.SERVICE_REQUEST</label>\n            <p class=\"form-control-static\">{{vm.model.sg_service_request}}</p>\n        </div>\n        <div class=\"form-group word-break\" ng-if=\"vm.model.sg_reference\">\n            <label translate>ORDER.REFERENCE</label>\n            <p class=\"form-control-static\">{{vm.model.sg_reference}}</p>\n        </div>\n    </div>\n\n    <div class=\"col-xs-6\">\n        <div class=\"form-group\">\n            <label translate>ORDER.SHIPPING_DATE</label>\n            <p class=\"form-control-static\">{{vm.model.sg_shipping_date}}</p>\n        </div>\n        <div class=\"form-group\">\n            <label translate>ORDER.DELIVERY_ADDRESS</label>\n            <p class=\"form-control-static\">\n                {{vm.model.shipping_address.label}}<br>\n                {{vm.model.shipping_address.company}}<br>\n                {{vm.model.shipping_address.street}}<br>\n                {{vm.model.shipping_address.postcode}} {{vm.model.shipping_address.city}}\n            </p>\n        </div>\n        <div class=\"form-group\">\n            <label translate>ORDER.CONTACT_IN_DELIVERY_PLACE</label>\n            <p class=\"form-control-static\">{{vm.model.shipping_address.fullname}}</p>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/order/partials/index.html","<div class=\"order-module\">\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n</div>\n");
$templateCache.put("app/order/partials/item.html","<header class=\"page-header clearfix\">\n    <h1 translate translate-values=\"{id: order.order_ax_id}\">ORDER.INFO</h1>\n</header>\n\n<div cg-busy=\"{promise:order.$promise,message:\'\',minDuration:300}\">\n    <div class=\"row details\">\n        <div class=\"col-xs-3\">\n            <div class=\"form-group\" ng-if=\"order.sg_order_name\">\n                <label translate>ORDER.NAME_OF_ORDER</label>\n                <p class=\"form-control-static\">{{order.sg_order_name}}</p>\n            </div>\n            <div class=\"form-group\" ng-if=\"order.sg_service_request\">\n                <label translate>ORDER.SERVICE_REQUEST</label>\n                <p class=\"form-control-static\">{{order.sg_service_request}}</p>\n            </div>\n            <div class=\"form-group word-break\" ng-if=\"order.sg_reference\">\n                <label translate>ORDER.REFERENCE</label>\n                <p class=\"form-control-static\">{{order.sg_reference}}</p>\n            </div>\n        </div>\n        <div class=\"col-xs-3\">\n            <div class=\"form-group\" ng-if=\"order.sg_expected_delivery_date\">\n                <label translate>ORDER.SHIPPING_DATE</label>\n                <p class=\"form-control-static\">{{order.sg_expected_delivery_date | amDateFormat : \"DD.MM.YYYY\"}}</p>\n            </div>\n            <div class=\"form-group\" ng-if=\"order.shipping_address\">\n                <label translate>ORDER.DELIVERY_ADDRESS</label>\n                <p class=\"form-control-static\">\n                    {{order.shipping_address.label}}<br>\n                    {{order.shipping_address.company}}<br>\n                    {{order.shipping_address.street}} {{order.shipping_address.building}}<br>\n                    {{order.shipping_address.postcode}} {{order.shipping_address.city}}\n                </p>\n            </div>\n            <div class=\"form-group\" ng-if=\"order.shipping_address.firstname || order.shipping_address.lastname\">\n                <label translate>ORDER.CONTACT_IN_DELIVERY_PLACE</label>\n                <p class=\"form-control-static\">\n                    {{order.shipping_address.fullname}}<br>\n                    {{order.shipping_address.telephone}}\n                </p>\n            </div>\n            <div class=\"form-group\" ng-if=\"order.sg_delivery_method\">\n                <label translate>ORDER.DELIVERY_METHOD</label>\n                <p class=\"form-control-static\">{{order.sg_delivery_method}}</p>\n            </div>\n        </div>\n        <div class=\"col-xs-3\">\n            <div class=\"form-group\" ng-if=\"order.customer_fullname\">\n                <label translate>GLOBAL.CREATOR</label>\n                <p class=\"form-control-static\">{{order.customer_fullname}}</p>\n            </div>\n            <div class=\"form-group\" ng-if=\"order.sg_payment_method\">\n                <label translate>ORDER.PAYMENT_METHOD</label>\n                <p class=\"form-control-static\">{{order.sg_payment_method}}</p>\n            </div>\n            <div class=\"form-group\" ng-if=\"order.sg_cod_amount\">\n                <label translate>ORDER.PAYMENT_AMOUNT</label>\n                <p class=\"form-control-static\">{{order.sg_cod_amount | currency}}</p>\n            </div>\n        </div>\n        <div class=\"col-xs-3\">\n            <div class=\"form-group\" ng-if=\"order.sg_status\">\n                <label translate>ORDER.STATUS</label>\n                <p class=\"form-control-static\">{{orderStatuses[order.sg_status] | translate}}</p>\n            </div>\n            <div class=\"form-group\" ng-if=\"order.increment_id\">\n                <label translate>ORDER.B2B_ID</label>\n                <p class=\"form-control-static\">{{order.increment_id}}</p>\n            </div>\n        </div>\n    </div>\n    <div class=\"orderInvoices\" ng-if=\"order.invoices\">\n        <h4 translate>INVOICE.LIST</h4>\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th class=\"text-center\" translate>CART.ITEM_POSITION</th>\n                <th translate>INVOICE.INVOICE_NUMBER</th>\n                <th translate>INVOICE.INVOICE_NUMBER_KSEF</th>\n                <th translate>INVOICE.PAYER_ACCOUNT</th>\n                <th translate>INVOICE.NET_AMOUNT</th>\n                <th translate>INVOICE.TAX_AMOUNT</th>\n                <th translate>INVOICE.GROSS_AMOUNT</th>\n                <th translate>INVOICE.INVOICE_DATE</th>\n                <th translate>INVOICE.DUE_DATE</th>\n                <th></th>\n            </tr>\n            </thead>\n            <tbody>\n            <tr ng-repeat=\"invoice in order.invoices\">\n                <td class=\"text-center\">{{$index+1}}</td>\n                <td>{{invoice.invoice_number}}</td>\n                <td>{{invoice.submission_uuid}}</td>\n                <td>{{invoice.distributor_id}}</td>\n                <td>{{invoice.net_total | currency}}</td>\n                <td>{{invoice.tax_total | currency}}</td>\n                <td>{{invoice.grand_total | currency}}</td>\n                <td>{{invoice.invoice_date | date}}</td>\n                <td>{{invoice.due_date | date}}</td>\n                <td class=\"text-right\">\n                    <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"invoice.file\" ng-click=\"downloadPdf(invoice)\" translate>INVOICE.DOWNLOAD_PDF</button>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n\n\n    </div>\n    <div class=\"orderShipments\" ng-if=\"order.shipments\">\n        <h4 translate>ORDER.SHIPPING_LABELS</h4>\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th class=\"text-center\" translate>CART.ITEM_POSITION</th>\n                <th translate>ORDER.SHIPPING_DATE</th>\n                <th translate>ACCOUNT.CARRIER</th>\n                <th translate>ORDER.SHIPPING_LABEL_ID</th>\n                <th translate>ORDER.PAYMENT_AMOUNT</th>\n            </tr>\n            </thead>\n            <tbody>\n\n            <tr ng-repeat=\"shipment in order.shipments track by $index\">\n                <td class=\"text-center\">{{$index+1}}</td>\n                <td>{{shipment.date | date}}</td>\n                <td>{{shipment.ax_courier_id}}</td>\n                <td>{{shipment.courier_shipment_id}}</td>\n                <td>{{shipment.cash_on_delivery | currency}}</td>\n            </tr>\n\n            </tbody>\n        </table>\n    </div>\n    <div class=\"orderedItems\" ng-if=\"order.items\">\n        <h4 translate>ORDER.ORDERED_ITEMS</h4>\n        <table class=\"table table-striped\">\n            <thead>\n            <tr>\n                <th class=\"text-center\" translate>CART.ITEM_POSITION</th>\n                <th translate>ORDER.SKU_SHORT</th>\n                <th colspan=\"2\" translate>CART.PRODUCT</th>\n                <th translate>ORDER.QTY_ORDERED</th>\n                <th translate>ORDER.QTY_RESERVED</th>\n                <th translate>ORDER.QTY_SHIPPED</th>\n                <th translate>ORDER.PRICE</th>\n                <th translate>CART.YOUR_DISCOUNT</th>\n                <th translate>CART.YOUR_PRICE</th>\n                <th translate>CART.BOTH_PRICES</th>\n                <th translate>ORDER.DELIVERY_DATE</th>\n            </tr>\n            </thead>\n            <tbody>\n\n            <tr ng-repeat=\"item in order.items track by $index\">\n                <td class=\"text-center\">{{$index+1}}</td>\n                <td>{{item.sku}}</td>\n                <td>{{item.name}}</td>\n                <td>\n                    <product-info-button-launcher model=\"item\" allow-add-to-cart=\"true\"></product-info-button-launcher>\n                </td>\n                <td>{{item.qty_ordered}}</td>\n                <td>{{item.sg_quantity_reserved}}</td>\n                <td>{{item.qty_shipped}}</td>\n                <td>{{item.sg_price | currency}}</td>\n                <td>\n                  <span>{{item.sg_discount | number:2}} %</span>\n                  <span ng-show=\"item.sg_discount_group\" class=\"discount-group\">\n                    ({{ item.sg_discount_group }})\n                  </span>\n                </td>\n                <td>{{item.price | currency}}</td>\n                <td>{{item.row_total | currency}}</td>\n                <td>{{item.sg_delivered_data | amDateFormat : \"DD.MM.YYYY\"}}</td>\n            </tr>\n\n            </tbody>\n        </table>\n\n        <sg-order-summary class=\"col-xs-4 col-xs-offset-8\" model=\"order\"></sg-order-summary>\n\n    </div>\n</div>\n");
$templateCache.put("app/order/partials/list.html","<header class=\"page-header clearfix\">\n    <h1 class=\"pull-left\" translate>ORDER.LIST</h1>\n</header>\n<section class=\"filters\">\n    <form method=\"post\" ng-submit=\"filterOrders()\">\n        <div class=\"form-group row\">\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_id\" translate>ORDER.ORDER_ID</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[increment_id]\']\" id=\"filter_order_id\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_sku\" translate>ORDER.SKU</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[sku]\']\" id=\"filter_order_sku\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_sr\" translate>ORDER.SERVICE_REQUEST</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[sg_service_request]\']\" id=\"filter_order_sr\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_creation_from\" translate>GLOBAL.CREATION_FROM</label>\n                <datepicker datepicker-model date-max-limit=\"{{filter[\'filter[sg_order_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                    <input id=\"filter_order_creation_from\" datepicker datepicker-model ng-model=\"filter[\'filter[sg_order_date][from]\']\" type=\"text\" name=\"filter_order_creation_from\" class=\"form-control\">\n                </datepicker>\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_creation_to\" translate>GLOBAL.CREATION_TO</label>\n                <datepicker datepicker-model date-min-limit=\"{{filter[\'filter[sg_order_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                    <input id=\"filter_order_creation_to\" datepicker datepicker-model ng-model=\"filter[\'filter[sg_order_date][to]\']\" type=\"text\" name=\"filter_order_creation_to\" class=\"form-control\">\n                </datepicker>\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_creator\" translate>GLOBAL.CREATOR</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[customer_name]\']\" id=\"filter_order_creator\">\n            </div>\n        </div>\n        <div class=\"form-group row\">\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_status\" translate>GLOBAL.STATUS</label>\n                <div class=\"wrapSelect\">\n                    <select ng-model=\"filter[\'filter[sg_status]\']\" class=\"form-control\" id=\"filter_order_status\">\n                        <option></option>\n                        <option ng-repeat=\"(key, value) in orderStatuses\" ng-attr-value=\"{{key}}\">\n                            {{value | translate}}\n                        </option>\n                    </select>\n                </div>\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_company\" translate>ORDER.COMPANY</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[company]\']\" id=\"filter_order_company\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_street\" translate>ORDER.DELIVERY_STREET</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[street]\']\" id=\"filter_order_street\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_postcode\" translate>ORDER.DELIVERY_POSTCODE</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[postcode]\']\" id=\"filter_order_postcode\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_order_city\" translate>ORDER.DELIVERY_CITY</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[city]\']\" id=\"filter_order_city\">\n            </div>\n            <div class=\"col-xs-2\">\n                <label for=\"filter_shipping_label_id\" translate>ORDER.SHIPPING_LABEL_ID</label>\n                <input type=\"text\" class=\"form-control\" ng-model=\"filter[\'filter[shipping_label_id]\']\" id=\"filter_shipping_label_id\">\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <button type=\"submit\" class=\"btn btn-primary\" translate>GLOBAL.SEARCH</button>\n                <button type=\"button\" ng-click=\"clearFilters()\" class=\"btn btn-default\" translate>GLOBAL.CLEAR_FILTERS\n                </button>\n            </div>\n        </div>\n    </form>\n</section>\n<table class=\"table\" st-table=\"rowsFiltered\" st-safe-src=\"rows\" ng-show=\"paginator.rows.length>0\" cg-busy=\"{promise:paginator.rows.$promise,message:\'\',minDuration:300}\">\n    <thead>\n    <tr>\n        <th translate>ORDER.ORDER_ID</th>\n        <th translate>GLOBAL.CREATION</th>\n        <th translate>ORDER.SERVICE_REQUEST</th>\n        <th translate>GLOBAL.CREATOR</th>\n        <th translate>CART.NET_AMOUNT</th>\n        <th translate>GLOBAL.STATUS</th>\n        <th class=\"limit-th\">\n            <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n            <div class=\"wrapSelect\">\n                <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n            </div>\n        </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in paginator.rows\">\n        <td>{{row.order_ax_id}}</td>\n        <td>{{row.sg_order_date | date : \"dd.MM.yyyy\"}}</td>\n        <td>{{row.sg_service_request}}</td>\n        <td>{{row.customer_fullname}}</td>\n        <td>{{row.subtotal | currency}}</td>\n        <td>{{orderStatuses[row.sg_status] | translate}}</td>\n        <td class=\"actions\">\n            <a class=\"btn btn-default btn-sm\" ui-sref=\"orders.item({id: row.increment_id})\" translate>GLOBAL.SEE</a>\n        </td>\n    </tr>\n    </tbody>\n</table>\n<div class=\"clearfix\">\n    <sg-pagination paginator=\"paginator\"></sg-pagination>\n</div>\n<uib-alert type=\"info\" ng-show=\"paginator.$resolved && paginator.rows.length===0\">\n    {{\'ORDER.THERE_ARE_NO_ORDERS\' | translate}}\n</uib-alert>\n");
$templateCache.put("app/order/partials/orders.html","<div class=\"orders-module\">\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <ui-view></ui-view>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/order/partials/step1.html","<div ng-controller=\"orderStep1Ctrl as vm\" class=\"order-step-1\">\n    <header class=\"page-header clearfix\">\n        <h1 translate>ORDER.ORDERING</h1>\n    </header>\n\n    <form ng-submit=\"vm.submitAll()\" name=\"vm.quoteForm\" ng-class=\"{\'show-errors\': vm.showErrors}\" promise-btn novalidate>\n\n        <div class=\"row\" cg-busy=\"{promise:vm.updateQuoteRequestPromise,message:\'\'}\">\n\n            <div class=\"col-xs-4\">\n                <h4>&nbsp;</h4>\n                <div class=\"form-group\">\n                    <label>\n                        <span translate>ORDER.NAME_OF_ORDER</span>\n                        <div class=\"question-icon\" uib-tooltip=\"{{\'ORDER.ORDER_NAME_HELPTEXT\' | translate}}\"></div>\n                    </label>\n                    <p class=\"form-control-static\"><strong>{{vm.model.sg_order_name}}</strong></p>\n                </div>\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"order_step1_sg_service_request\">\n                        <span translate>ORDER.SERVICE_REQUEST</span>\n                        <div class=\"question-icon\" uib-tooltip=\"{{\'ORDER.SERVICE_REQUEST_HELPTEXT\' | translate}}\"></div>\n                    </label>\n                    <input id=\"order_step1_sg_service_request\" ng-model=\"vm.model.sg_service_request\" type=\"text\" name=\"sg_service_request\" class=\"form-control\" maxlength=\"30\" autofocus>\n                </div>\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"order_step1_sg_reference\" translate>ORDER.REFERENCE</label>\n                    <textarea id=\"order_step1_sg_reference\" ng-model=\"vm.model.sg_reference\" maxlength=\"400\" name=\"sg_reference\" class=\"form-control\">\n                    </textarea>\n                </div>\n            </div>\n\n            <div class=\"col-xs-4\">\n                <h4 translate>ORDER.DELIVERY</h4>\n                <div class=\"row shipment-date-container\">\n                    <div class=\"col-xs-12 address-source-options\">\n                        <a ng-click=\"vm.setDefaultAddress()\" translate>ORDER.SET_DEFAULT_ADDRESS</a><br>\n                        <a ng-click=\"vm.clearShipmentAddress()\" translate>ORDER.NEW_ADDRESS</a><br>\n                        <a ng-click=\"vm.selectShipmentAddress()\" translate>GLOBAL.SELECT_EXISTENT</a>\n                    </div>\n                </div>\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"order_step1_label\" class=\"required\" translate>GLOBAL.ADDR_LABEL</label>\n                    <input id=\"order_step1_label\" ng-model=\"vm.model.label\" type=\"text\" name=\"label\" class=\"form-control\" maxlength=\"35\" required>\n                    <span class=\"c-error\" ng-show=\"vm.quoteForm.label.$error.required\" translate>ERRORS.REQUIRED</span>\n                </div>\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"order_step1_company\" class=\"required\" translate>GLOBAL.COMPANY</label>\n                    <input id=\"order_step1_company\" ng-model=\"vm.model.company\" type=\"text\" name=\"company\" class=\"form-control\" maxlength=\"140\" required>\n                    <span class=\"c-error\" ng-show=\"vm.quoteForm.company.$error.required\" translate>ERRORS.REQUIRED</span>\n                </div>\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-6\" show-input-errors>\n                        <label for=\"order_step1_postcode\" class=\"required\" translate>GLOBAL.POSTAL_CODE</label>\n                        <input id=\"order_step1_postcode\" ng-model=\"vm.model.postcode\" type=\"text\" name=\"postcode\" uib-typeahead=\"postcode as postcode for postcode in vm.findPostCodes($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"0\" ui-validate=\"{postcode : \'vm.validatePostcode($value)\'}\" class=\"form-control\" required autocomplete=\"off\">\n                        <span class=\"c-error\" ng-show=\"vm.quoteForm.postcode.$error.postcode\" translate>ERRORS.POSTCODE</span>\n                    </div>\n                    <div class=\"form-group col-xs-6\" show-input-errors>\n                        <label for=\"order_step1_city\" class=\"required\" translate>GLOBAL.CITY</label>\n                        <input id=\"order_step1_city\" ng-model=\"vm.model.city\" type=\"text\" name=\"city\" uib-typeahead=\"city as city for city in vm.findCities($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"1\" class=\"form-control\" maxlength=\"140\" required autocomplete=\"off\">\n                        <span class=\"c-error\" ng-show=\"vm.quoteForm.city.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                </div>\n\n                <div class=\"row\">\n                    <div class=\"form-group col-xs-9\" show-input-errors>\n                        <label for=\"order_step1_street\" class=\"required\" translate>GLOBAL.STREET</label>\n                        <input id=\"order_step1_street\" ng-model=\"vm.model.street\" type=\"text\" name=\"street\" uib-typeahead=\"street as street for street in vm.findStreets($viewValue)\" typeahead-wait-ms=\"250\" typeahead-min-length=\"1\" class=\"form-control\" maxlength=\"255\" required autocomplete=\"off\">\n                        <span class=\"c-error\" ng-show=\"vm.quoteForm.street.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                    <div class=\"form-group col-xs-3\" show-input-errors>\n                        <label for=\"order_step1_building\" class=\"required\" translate>GLOBAL.BUILDING</label>\n                        <input id=\"order_step1_building\" ng-model=\"vm.model.building\" type=\"text\" name=\"building\" class=\"form-control\" maxlength=\"20\" required>\n                        <span class=\"c-error\" ng-show=\"vm.quoteForm.building.$error.required\" translate>ERRORS.REQUIRED</span>\n                    </div>\n                </div>\n\n                <div class=\"form-group\" ng-if=\"vm.saveAddressAvailable\">\n                    <input type=\"checkbox\" id=\"checkoutStep1SaveAddressCheckbox\" ng-model=\"vm.saveAddress\">\n                    <label for=\"checkoutStep1SaveAddressCheckbox\" translate>ORDER.SAVE_ADDRESS</label>\n                </div>\n            </div>\n\n            <div class=\"col-xs-4\">\n                <h4 translate>ORDER.CONTACT_IN_DELIVERY_PLACE</h4>\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"order_step1_fullname\" class=\"required\" translate>GLOBAL.FULLNAME</label>\n                    <input id=\"order_step1_fullname\" ng-model=\"vm.model.fullname\" type=\"text\" name=\"fullname\" class=\"form-control\" maxlength=\"35\" required>\n                    <span class=\"c-error\" ng-show=\"vm.quoteForm.fullname.$error.required\" translate>ERRORS.REQUIRED</span>\n                </div>\n                <div class=\"form-group\" show-input-errors>\n                    <label for=\"order_step1_telephone\" class=\"required\" translate>GLOBAL.PHONE</label>\n                    <input id=\"order_step1_telephone\" ng-model=\"vm.model.telephone\" type=\"text\" name=\"telephone\" class=\"form-control\" ui-mask=\"999-999-999\" required>\n                    <span class=\"c-error\" ng-show=\"vm.quoteForm.telephone.$error.required\" translate>ERRORS.REQUIRED</span>\n                </div>\n\n                <h4 translate>ORDER.DELIVERY_METHOD</h4>\n                <div class=\"form-group\">\n                    <div class=\"radio\" ng-class=\"{\'overflow-hidden\':item.code == \'courier_cod\'}\" ng-repeat=\"item in vm.shippingMethods\">\n                        <div ng-class=\"{\'col-xs-6 no-padding\':item.code == \'courier_cod\'}\">\n                            <input ng-model=\"vm.model.sg_delivery_method\" type=\"radio\" name=\"sg_delivery_method\" ng-attr-id=\"order_step1_sg_delivery_method_{{item.code}}\" ng-value=\"item.code\" required>\n                            <label ng-attr-for=\"order_step1_sg_delivery_method_{{item.code}}\">{{\'ORDER.\'+item.label |\n                                translate}}</label>\n                        </div>\n                        <div ng-if=\"item.code == \'courier_cod\'\" ng-show=\"vm.model.sg_delivery_method == \'courier_cod\'\" class=\"sg-cod-amount col-xs-6\">\n                            <label for=\"sg_cod_amount\" class=\"required\" translate translate-values=\"{min_cod_amount: vm.formatCurrency(vm.shippingMethodsConfig.courier_cod.cod_min_amount), max_cod_amount: vm.formatCurrency(vm.shippingMethodsConfig.courier_cod.cod_max_amount)}\">ORDER.COD_AMOUNT_LABEL</label>\n                            <input id=\"sg_cod_amount\" ng-model=\"vm.model.sg_cod_amount\" type=\"number\" name=\"sg_cod_amount\" class=\"form-control\" maxlength=\"12\" size=\"6\" min=\"{{vm.getCodMinCoditionValue()}}\" max=\"{{vm.getCodMaxCoditionValue()}}\" ng-required=\"vm.quoteForm.sg_delivery_method.$modelValue == \'courier_cod\'\">\n                            <span class=\"c-error\" ng-show=\"vm.quoteForm.sg_cod_amount.$error.required\" translate>ERRORS.REQUIRED</span>\n                            <span class=\"c-error\" ng-show=\"vm.quoteForm.sg_cod_amount.$error.min || vm.quoteForm.sg_cod_amount.$error.max\" translate translate-values=\"{min_cod_amount: vm.formatCurrency(vm.shippingMethodsConfig.courier_cod.cod_min_amount), max_cod_amount: vm.formatCurrency(vm.shippingMethodsConfig.courier_cod.cod_max_amount)}\">ERRORS.COD_AMOUNT_RANGE</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n\n        <footer class=\"row\">\n            <div class=\"col-xs-6\">\n                <button class=\"btn btn-link\" ng-click=\"vm.goToCart()\" type=\"button\">\n                    <span class=\"glyphicon glyphicon-chevron-left\"></span>\n                    <span translate>GLOBAL.GO_BACK</span>\n                </button>\n            </div>\n            <div class=\"col-xs-6\">\n                <button class=\"btn btn-primary btn-lg pull-right\" type=\"submit\">{{\'ORDER.ORDER_SUMMARY\' | translate}}</button>\n                <button class=\"btn btn-link pull-right\" ng-click=\"vm.saveQuote()\" type=\"button\">{{\'GLOBAL.SAVE\' | translate}}</button>\n            </div>\n        </footer>\n\n    </form>\n\n    <!-- Selector of existing address -->\n    <sg-account-address-selection-table on-select=\"vm.setShipmentAddress(model)\" on-loaded=\"vm.scrollToBottom()\" ng-if=\"vm.addressSelectionTableVisible\">\n    </sg-account-address-selection-table>\n\n</div>\n");
$templateCache.put("app/order/partials/step2.html","<div ng-controller=\"orderStep2Ctrl as vm\">\n\n    <header>\n        <div class=\"page-header clearfix\">\n            <h1 translate>ORDER.ORDER_SUMMARY</h1>\n        </div>\n        <div class=\"row\">\n            <div class=\"col-xs-6\">\n                <sg-quote-details model=\"vm.quote\"></sg-quote-details>\n            </div>\n            <div class=\"col-xs-5 col-xs-offset-1 order-amounts\" ng-show=\"vm.stocksUpdated\">\n                <sg-cart-summary model=\"vm.model\" quote=\"vm.quote\"></sg-cart-summary>\n                <button class=\"btn btn-primary btn-lg pull-right complete-order\" ng-click=\"vm.confirmOrder()\" promise-btn=\"vm.confirmOrderPromise\">\n                    {{\'ORDER.COMPLETE_ORDER\' | translate}}\n                </button>\n            </div>\n        </div>\n    </header>\n\n    <div>\n        <spinner data-label=\"{{\'GLOBAL.LOADING_DATA\' | translate}}\" ng-if=\"!vm.stocksUpdated\"></spinner>\n\n        <div class=\"row\" cg-busy=\"{promise:vm.import, message:\'\'}\">\n            <sg-cart-items2 model=\"vm.model\" editable=\"vm.access.carts.edit\" allow-create-quote=\"vm.access.quote.add\" allow-add-items=\"vm.access.cartItems.add\" allow-edit-items=\"vm.access.cartItems.edit\" allow-remove-items=\"vm.access.cartItems.delete\" on-load=\"vm.activateCart(model)\" on-cancel=\"vm.goBack()\" on-create=\"vm.changeToUpdateMode(model)\" on-delete=\"vm.goBack()\" on-quote-created=\"vm.startOrderProcess(quote)\"></sg-cart-items2>\n        </div>\n    </div>\n\n    <footer class=\"clearfix\" ng-show=\"vm.stocksUpdated\">\n        <div class=\"row\" cg-busy=\"{promise:vm.import, message:\'\'}\">\n            <sg-cart-summary class=\"col-xs-5 col-xs-offset-7\" model=\"vm.model\" quote=\"vm.quote\"></sg-cart-summary>\n        </div>\n        <button class=\"btn btn-primary btn-lg pull-right complete-order\" ng-click=\"vm.confirmOrder()\" promise-btn=\"vm.confirmOrderPromise\">\n            {{\'ORDER.COMPLETE_ORDER\' | translate}}\n        </button>\n    </footer>\n\n</div>");
$templateCache.put("app/order/partials/step3.html","<div ng-controller=\"orderStep3Ctrl as vm\">\n\n    <header class=\"page-header clearfix\">\n        <h1 translate>ORDER.CONFIRMATION.TITLE</h1>\n    </header>\n\n    <p translate>ORDER.CONFIRMATION.HELLO</p>\n\n    <p>\n        <span translate>ORDER.CONFIRMATION.THANKS</span><br>\n        <span translate>ORDER.CONFIRMATION.STATUS</span><br>\n        <span translate>ORDER.CONFIRMATION.STATUS_AFTER_BOOKED</span><br>\n    </p>\n\n    <p translate>ORDER.CONFIRMATION.HISTORY_NOTE</p>\n\n    <p>\n        <span translate>ORDER.CONFIRMATION.GOODBAY_LINE1</span><br>\n        <span translate>ORDER.CONFIRMATION.GOODBAY_LINE2</span>\n    </p>\n\n</div>");
$templateCache.put("app/payment/components/sgPaymentListHeader.html","<div class=\"row\">\n    <div class=\"col-xs-3\">\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>PAYMENT.RECIPIENT_ID</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.distributor_id}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>PAYMENT.RECIPIENT_NAME</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.name}}</span>\n        </div>\n    </div>\n    <div class=\"col-xs-3\">\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>FINANCES.BALANCE</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.balance | currency}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>FINANCES.OVERDUE</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.arrear | currency}}</span>\n        </div>\n    </div>\n    <div class=\"col-xs-3\">\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>ACCOUNT.CREDIT_LIMIT</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.credit_level | currency}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>ACCOUNT.PAYMENTS_TERMS</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.payment_terms}}</span>\n        </div>\n    </div>\n    <div class=\"col-xs-3\" ng-if=\"vm.info.user.reseller.dealer\">\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>ACCOUNT.ACCOUNT_MANAGER</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.dealer.firstname}} {{vm.info.user.reseller.dealer.lastname}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>GLOBAL.EMAIL</span>\n            <span class=\"block-value\">\n                <a ng-href=\"mailto:{{vm.info.user.reseller.dealer.email}}\">{{vm.info.user.reseller.dealer.email}}</a>\n            </span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span class=\"block-label\" translate>GLOBAL.PHONE</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.dealer.telephone}}</span>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/payment/components/sgPaymentsList.html","<table class=\"table table-striped\" ng-show=\"paginator.total && !vm.errorMsg\" cg-busy=\"{promise: paginator.$promise, message: \'\'}\">\n    <thead>\n    <tr>\n        <th translate>PAYMENT.ATTACHMENT</th>\n        <th translate>PAYMENT.NAME</th>\n        <th class=\"text-right\" translate>PAYMENT.AMOUNT</th>\n        <th class=\"text-right\" translate>PAYMENT.PAYMENT_DATE</th>\n        <th class=\"limit-th\">\n            <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n            <div class=\"wrapSelect\">\n                <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n            </div>\n        </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"payment in paginator.rows\">\n        <td>{{payment.attachment}}</td>\n        <td>{{payment.name}}</td>\n        <td class=\"text-right\">{{payment.amount | number:2}} {{payment.currency}}</td>\n        <td class=\"text-right\">{{payment.payment_date | date}}</td>\n        <td></td>\n    </tr>\n    </tbody>\n</table>\n\n<div class=\"clearfix\">\n    <!-- Button to export results to CSV -->\n    <span ng-show=\"paginator.$resolved && paginator.rows.length>0\">\n        <button type=\"button\" class=\"btn btn-default pull-left export-to-csv-btn\" csv-header=\"vm.csvConfig.headers\" csv-column-order=\"vm.csvConfig.fields\" ng-csv=\"vm.csvConfig.getData()\" filename=\"{{vm.csvConfig.filename}}\">\n            <span translate>GLOBAL.SAVE_TO_FILE</span>\n        </button>\n\n        <!-- Button to export results to XLS -->\n        <button type=\"button\" class=\"btn btn-default pull-left export-to-csv-btn\" csv-header=\"vm.xlsConfig.headers\" csv-column-order=\"vm.xlsConfig.fields\" ng-csv=\"vm.xlsConfig.getData()\" filename=\"{{vm.xlsConfig.filename}}\">\n            <span translate>GLOBAL.SAVE_TO_FILE_XLS</span>\n        </button>\n\n    </span>\n    <sg-pagination paginator=\"paginator\"></sg-pagination>\n</div>\n\n<uib-alert type=\"info\" ng-show=\"paginator.$resolved && paginator.rows.length===0\">\n    <span translate>PAYMENT.THERE_ARE_NO_RESULTS</span>\n</uib-alert>");
$templateCache.put("app/payment/components/sgPaymentsListFilters.html","<form name=\"paymentListFilters\" ng-submit=\"vm.applyChanges()\">\n\n    <div class=\"row\">\n        <div class=\"form-group col-xs-2\">\n            <label for=\"paymentListFilterNumber\" translate>PAYMENT.ATTACHMENT</label>\n            <input type=\"text\" class=\"form-control\" id=\"paymentListFilterNumber\" ng-model=\"vm.filters[\'filter[attachment]\']\">\n        </div>\n        <div class=\"form-group col-xs-2\">\n            <label for=\"paymentListFilterOrders\" translate>PAYMENT.NAME</label>\n            <input type=\"text\" class=\"form-control\" id=\"paymentListFilterOrders\" ng-model=\"vm.filters[\'filter[name]\']\">\n        </div>\n        <div class=\"form-group col-xs-4\">\n            <label translate>PAYMENT.PAYMENT_DATE</label>\n            <div class=\"row range-inputs-container\">\n                <div class=\"form-group has-feedback col-xs-6\">\n                    <div class=\"row\">\n                        <label for=\"paymentListFilterDueFrom\" class=\"control-label col-xs-2\" translate>GLOBAL.FROM</label>\n                        <datepicker datepicker-model class=\"col-xs-10\" date-max-limit=\"{{vm.filters[\'filter[payment_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input datepicker-model type=\"text\" class=\"form-control\" id=\"paymentListFilterDueFrom\" ng-model=\"vm.filters[\'filter[payment_date][from]\']\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                </div>\n                <div class=\"form-group has-feedback col-xs-6\">\n                    <div class=\"row\">\n                        <label for=\"paymentListFilterDueTo\" class=\"control-label col-xs-2\" translate>GLOBAL.TO</label>\n                        <datepicker datepicker-model class=\"col-xs-10\" date-min-limit=\"{{vm.filters[\'filter[payment_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input datepicker-model type=\"text\" class=\"form-control\" id=\"paymentListFilterDueTo\" ng-model=\"vm.filters[\'filter[payment_date][to]\']\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group col-xs-4\">\n            <label translate>PAYMENT.AMOUNT</label>\n            <div class=\"row range-inputs-container\">\n                <div class=\"form-group col-xs-6\">\n                    <div class=\"row\">\n                        <label for=\"paymentListFilterAmountFrom\" class=\"col-xs-2 control-label\" translate>GLOBAL.FROM</label>\n                        <div class=\"col-xs-10\">\n                            <input type=\"number\" class=\"form-control\" id=\"paymentListFilterAmountFrom\" step=\"0.01\" sg-disable-input-scroll ng-model=\"vm.filters[\'filter[amount][from]\']\">\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group col-xs-6\">\n                    <div class=\"row\">\n                        <label for=\"paymentListFilterAmountTo\" class=\"col-xs-2 control-label\" translate>GLOBAL.TO</label>\n                        <div class=\"col-xs-10\">\n                            <input type=\"number\" class=\"form-control\" id=\"paymentListFilterAmountTo\" step=\"0.01\" sg-disable-input-scroll ng-model=\"vm.filters[\'filter[amount][to]\']\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div>\n        <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!vm.pendingChanges()\" translate>GLOBAL.SEARCH</button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clearFilters()\" translate>GLOBAL.CLEAR_FILTERS</button>\n    </div>\n\n</form>\n");
$templateCache.put("app/payment/partials/index.html","<div class=\"payment-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>\n");
$templateCache.put("app/payment/partials/list.html","<header class=\"page-header clearfix\">\n    <h1 translate>FINANCES.SETTLEMENT</h1>\n</header>\n\n<h4 translate>FINANCES.BALANCE</h4>\n\n<sg-payment-list-header></sg-payment-list-header>\n\n<h4 translate>PAYMENT.PAYMENTS</h4>\n\n<div class=\"well well-sm\">\n    <sg-payments-list-filters filters=\"filters\"></sg-payments-list-filters>\n</div>\n\n<sg-payments-list filters=\"filters\"></sg-payments-list>");
$templateCache.put("app/product/components/productAvailabilityIcon.html","<div ng-switch=\"vm.getStatus()\">\n    <div ng-switch-when=\"available\">\n        <div class=\"icon-container\" tooltip-placement=\"{{vm.tooltipPos}}\" tooltip-enable=\"vm.showTooltip\" uib-tooltip=\"{{\'PRODUCT.PRODUCT_AVAILABLE\' | translate}}\">\n            <svg height=\"10\" width=\"10\">\n                <circle cx=\"5\" cy=\"5\" r=\"5\" class=\"available\"></circle>\n            </svg>\n        </div>\n        <span ng-if=\"vm.showLabel\" translate>PRODUCT.PRODUCT_AVAILABLE</span>\n    </div>\n    <div ng-switch-when=\"unavailable\">\n        <div class=\"icon-container\" tooltip-placement=\"{{vm.tooltipPos}}\" tooltip-enable=\"vm.showTooltip\" uib-tooltip=\"{{\'PRODUCT.PRODUCT_UNAVAILABLE\' | translate}}\">\n            <svg height=\"10\" width=\"10\">\n                <circle cx=\"5\" cy=\"5\" r=\"5\" class=\"unavailable\"></circle>\n            </svg>\n        </div>\n        <span ng-if=\"vm.showLabel\" translate>PRODUCT.PRODUCT_UNAVAILABLE</span>\n    </div>\n    <div ng-switch-when=\"onorder\">\n        <div class=\"icon-container\" tooltip-placement=\"{{vm.tooltipPos}}\" tooltip-enable=\"vm.showTooltip\" uib-tooltip=\"{{\'PRODUCT.PRODUCT_ON_ORDER\' | translate}}\">\n            <svg height=\"10\" width=\"10\">\n                <circle cx=\"5\" cy=\"5\" r=\"5\" class=\"onorder\"></circle>\n            </svg>\n        </div>\n        <span ng-if=\"vm.showLabel\" translate>PRODUCT.PRODUCT_ON_ORDER</span>\n    </div>\n    <div ng-switch-default>\n        <div class=\"icon-container\" tooltip-placement=\"{{vm.tooltipPos}}\" tooltip-enable=\"vm.showTooltip\" uib-tooltip=\"{{\'PRODUCT.PRODUCT_UNAVAILABLE\' | translate}}\">\n            <svg height=\"10\" width=\"10\">\n                <circle cx=\"5\" cy=\"5\" r=\"5\"></circle>\n            </svg>\n        </div>\n        <span ng-if=\"vm.showLabel\" translate>GLOBAL.INFORMATION_UNAVAILABLE</span>\n    </div>\n</div>");
$templateCache.put("app/product/components/productFilterActive.html","<div class=\"filter-box\" ng-if=\"vm.selectedAnyFilter()\">\n    <div class=\"filter-header\">\n        <span translate>GLOBAL.ACTIVE-FILTER</span>\n    </div>\n    <div ng-if=\"vm.model\">\n        <div class=\"filter-body\">\n\n            <div class=\"container-list\" ng-if=\"!vm.showTags()\">\n                <ul class=\"list-unstyled\">\n                    <li ng-repeat=\"filter in vm._activeFilter track by $index\">\n                        <div class=\"form-group\">\n                            <input type=\"checkbox\" value=\"{{filter.code}}\" id=\"{{filter.code + \'_\' + $index}}\" ng-model=\"filter.selected\">\n                            <label for=\"{{filter.code + \'_\' + $index}}\">{{filter.label}}</label>\n                        </div>\n                    </li>\n                </ul>\n            </div>\n\n            <div class=\"container-tags\" ng-if=\"vm.showTags()\">\n                <div class=\"tag\" ng-repeat=\"item in vm._activeItemsFilters track by $index\" uib-tooltip=\"{{item.filterName}}\" tooltip-placement=\"top\"><span>{{item.label}}</span><span class=\"delete\" ng-click=\"vm.removeTags(item)\"><span class=\"glyphicon glyphicon-remove\"></span></span></div>\n            </div>\n\n            <div ng-hide=\"vm.selectedAnyFilter()\" class=\"no-active-filters\" translate>\n                GLOBAL.ACTIVE-FILTER-EMPTY\n            </div>\n\n        </div>\n        <div class=\"filter-footer\" ng-show=\"vm.selectedAnyFilter()\">\n            <div class=\"row\">\n                <div class=\"col-xs-8\">\n                    <div>\n                        <button class=\"apply-filter btn btn-link btn-small\" ng-click=\"vm.clearFilter()\" translate>PRODUCT.CLEAR_FILTERS\n                        </button>\n                    </div>\n                </div>\n                <div class=\"col-xs-4 text-right\" ng-if=\"!vm.showTags()\">\n                    <button class=\"apply-filter btn btn-primary btn-small\" ng-click=\"vm.applyFilter()\" translate>PRODUCT.FILTER\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/product/components/productFilterCategory.html","<div class=\"filter-box\">\n    <div class=\"filter-header\">\n        <div class=\"filter-title\" ng-show=\"vm.model.isRoot === true\">\n            <span translate>GLOBAL.CATEGORY-MANY</span>\n        </div>\n        <div class=\"filter-title\" ng-show=\"vm.model.isRoot === false\">\n            <div class=\"filter-buttons\">\n                <a class=\"filter-button\" ng-click=\"vm.goTo(vm.model.parent_id)\" uib-tooltip=\"{{\'PRODUCT.CATEGORY-UP\'|translate}}\" tooltip-placement=\"right-top\">\n                    <span class=\"glyphicon glyphicon-arrow-up\"></span>\n                </a>\n            </div>\n            <span translate>GLOBAL.CATEGORY-ONE</span>: {{vm.model.name}}\n        </div>\n    </div>\n    <div class=\"filter-body\">\n        <div class=\"container-menu\" ng-class=\"{\'show-all\':vm.model.isRoot}\">\n            <ul class=\"category-list\" ng-show=\"vm.model.children.length > 0\">\n                <li ng-repeat=\"children in vm.model.children track by $index\">\n                    <a ng-click=\"vm.goTo(children.id)\">{{children.name}}</a>\n                </li>\n            </ul>\n        </div>\n\n        <div ng-show=\"vm.model.children.length === 0\" class=\"no-children\" translate>PRODUCT.CATEGORY_NO_CHILDREN</div>\n\n    </div>\n</div>");
$templateCache.put("app/product/components/productFilterContainer.html","<div class=\"product-filter-container\">\n\n    <product-filter-active model=\"vm.model\" parent-apply-filter=\"vm.applyFilter()\" filters=\"vm.filters()\"></product-filter-active>\n\n    <ng-repeat ng-if=\"vm.showFilters()\" ng-repeat=\"filter in vm.model track by $index\" ng-switch=\"filter.code\">\n        <product-filter-price ng-switch-when=\"price_decimal\" model=\"filter\" ng-if=\"filter.matches || filter.selected\" filters=\"vm.applyFilter()\"></product-filter-price>\n        <product-filter-default ng-switch-default model=\"filter\" ng-if=\"filter.matches || filter.selected\" filters=\"vm.applyFilter()\"></product-filter-default>\n    </ng-repeat>\n\n    <div class=\"filter-buttons row\" ng-show=\"vm.filterButtons()\">\n        <div class=\"col-xs-12\">\n            <div class=\"line\"></div>\n            <div class=\"buttons\">\n                <button class=\"clear-filter btn btn-default btn-small\" ng-click=\"vm.removeAllFilter()\" translate>PRODUCT.CLEAR_FILTERS</button>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/product/components/productFilterDefault.html","<div class=\"filter-box\">\n    <div class=\"filter-header\" ng-class=\"{\'arrow-after-up\': vm.model.open, \'arrow-after-down\': !vm.model.open}\" ng-click=\"vm.model.open = !vm.model.open\">\n        <span>{{vm.model.label}}</span>\n    </div>\n    <div ng-show=\"vm.model.open == true\">\n        <div class=\"filter-body\">\n\n            <div class=\"container-list\">\n                <ul class=\"list-unstyled\" ng-class=\"{\n                \'show-all-items\': vm.showAllItems,\n                \'show-5-items\': !vm.model.selected\n            }\">\n                    <li class=\"item\" ng-repeat=\"filterItem in (vm.model.values | limitTo:vm.limitTo) track by $index\" ng-class=\"{\n                    matches: filterItem.matches,\n                    \'no-matches\': !filterItem.matches && !filterItem.selected,\n                    selected: filterItem.selected,\n                    \'origin-selected\': filterItem.originSelected\n                }\">\n                        <div class=\"form-group\">\n                            <input type=\"checkbox\" value=\"{{filterItem.name}}\" id=\"{{vm.model.code + \'_\' + $index}}\" ng-model=\"filterItem.selected\">\n                            <label for=\"{{vm.model.code + \'_\' + $index}}\">\n                                {{filterItem.label}}<span> ({{filterItem.count}})</span>\n                                <span class=\"delete\" ng-click=\"vm.removeItem(filterItem)\" ng-show=\"filterItem.selected && filterItem.originSelected\"><span class=\"glyphicon glyphicon-remove\"></span></span>\n                            </label>\n                        </div>\n                    </li>\n\n                </ul>\n            </div>\n\n\n            <ul class=\"list-unstyled show-more-and-less\" ng-if=\"!vm.model.selected\">\n                <li ng-show=\"!vm.showAllItems && vm.haveMoreItems\">\n                        <span class=\"more\" ng-click=\"vm.clickMoreItems()\" translate>PRODUCT.SHOW_MORE</span>\n                </li>\n                <li ng-show=\"vm.showAllItems && vm.haveMoreItems\">\n                        <span class=\"less\" ng-click=\"vm.clickLessItems()\" translate>PRODUCT.SHOW_LESS</span>\n                </li>\n            </ul>\n\n        </div>\n        <div class=\"filter-footer\">\n            <div class=\"row\">\n                <div class=\"col-xs-8\">\n                    <button class=\"apply-filter btn btn-link btn-small\" ng-click=\"vm.clearFilter()\" ng-show=\"vm.model.selected\" translate>PRODUCT.CLEAR_FILTER\n                    </button>\n                </div>\n                <div class=\"col-xs-4 text-right\">\n                    <button class=\"apply-filter btn btn-primary btn-small\" ng-click=\"vm.applyFilter()\" translate>PRODUCT.FILTER\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/product/components/productFilterPrice.html","<div class=\"filter-box\">\n    <div class=\"filter-header\" ng-class=\"{\'arrow-after-down\': !vm.model.open, \'arrow-after-up\': vm.model.open}\" ng-click=\"vm.model.open = !vm.model.open\">\n        <span translate>GLOBAL.CATALOG-PRICE</span>\n    </div>\n    <div ng-show=\"vm.model.open == true\">\n        <div class=\"filter-body\">\n\n            <div class=\"filter-price\">\n                <div class=\"text-capitalize price_form_to\" translate>GLOBAL.FROM</div>\n                <div class=\"price_form_to_input\">\n                    <input type=\"text\" min=\"0\" class=\"form-control\" ng-model=\"vm.valueFrom\" ng-class=\"{\'invalid\': !vm.validNumberFrom}\" ng-enter=\"vm.applyFilter()\">\n                </div>\n                <div class=\"text-capitalize price_form_to\" translate>GLOBAL.TO</div>\n                <div class=\"price_form_to_input\">\n                    <input type=\"text\" class=\"form-control\" min=\"0\" ng-model=\"vm.valueTo\" ng-class=\"{\'invalid\': !vm.validTo || !vm.validNumberTo}\" ng-enter=\"vm.applyFilter()\" uib-tooltip=\"Kwota musi być większa od minimalnej szukanej kwoty\" tooltip-enable=\"!vm.validTo\" tooltip-placement=\"left\" tooltip-is-open=\"!vm.validTo\">\n                </div>\n            </div>\n\n        </div>\n        <div class=\"filter-footer\">\n            <div class=\"row\">\n                <div class=\"col-xs-8\">\n                    <!-- ng-show don\'t correct work when added animation for btn-default -->\n                    <div>\n                        <button class=\"apply-filter btn btn-default btn-small\" ng-click=\"vm.clearFilter()\" ng-show=\"vm.model.selected\" translate>PRODUCT.CLEAR_FILTER\n                        </button>\n                    </div>\n                </div>\n                <div class=\"col-xs-4 text-right\">\n                    <button class=\"apply-filter btn btn-primary btn-small\" ng-click=\"vm.applyFilter()\" ng-disabled=\"!vm.valid\" translate>PRODUCT.FILTER\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/product/components/productInfoButtonLauncher.html","<button type=\"button\" class=\"btn btn-link btn-info-small\" ng-disabled=\"!vm.haveModel()\" ng-click=\"vm.showModal()\" uib-tooltip=\"{{vm.label}}\" tooltip-enable=\"vm.label\" tooltip-popup-delay=\"{{vm.tooltipDelay}}\" tooltip-placement=\"{{vm.tooltipPos}}\"></button>");
$templateCache.put("app/product/components/productInfoDelivery.html","<button type=\"button\" class=\"btn btn-link btn-info-small\" ng-if=\"vm.haveModel()\" uib-tooltip=\"{{vm.label()}}\"></button>");
$templateCache.put("app/product/components/productInfoSummary.html","<!-- Promotion percentage -->\n<div class=\"discount-corner\" ng-show=\"vm.model.promo_code_text || vm.hasPromoPrice()\">\n    {{vm.model.promo_code_text}}\n    <span ng-show=\"vm.hasPromoPrice()\">-{{vm.getPromoDiscount()}}%</span>\n</div>\n\n<div class=\"row container-product\" cg-busy=\"{promise:vm.fetchingDataPromise,message:(\'GLOBAL.LOADING_DATA\' | translate)}\">\n\n    <!-- Picture -->\n    <div ng-class=\"[\'product-picture\', {\'col-xs-4\': vm.model.productPicturesUrls !== null}]\">\n        <span ng-click=\"changeImage(-1)\" ng-class=\"[\'arrow-gallery arrow-left glyphicon glyphicon-menu-left\',\n               {\'no-display\': vm.model.productPicturesUrls.length <= 1 || vm.model.productPicturesUrls === null}]\">\n        </span>\n        <img ng-src=\"{{vm.model.productPicturesUrls[currentIndex]}}\" fallback-src ng-attr-alt=\"vm.model.brand_name\">\n        <span ng-click=\"changeImage(1)\" ng-class=\"[\'arrow-gallery arrow-right glyphicon glyphicon-menu-right\',\n               {\'no-display\': vm.model.productPicturesUrls.length <= 1 || vm.model.productPicturesUrls === null}]\">\n        </span>\n    </div>\n\n    <!-- Product information -->\n    <div ng-class=\"[\'product-info\', {\'col-xs-8\': vm.model.pictureUrl !== null, \'col-xs-12\': vm.model.pictureUrl === null}]\">\n\n\n        <!-- Product title -->\n\n        <div class=\"page-header\">\n            <h3>{{vm.model.name}}</h3>\n        </div>\n        <div>\n            <span class=\"attr\" ng-if=\"vm.model.sku\">\n                <span class=\"attrName\" translate>PRODUCT.CODE</span>\n                {{vm.model.sku}}\n            </span>\n            <span class=\"attr\" ng-show=\"vm.hasBrand()\"><span class=\"attrName\" translate>PRODUCT.BRAND</span> {{vm.getBrandName()}}</span>\n            <span class=\"attr\" ng-show=\"vm.hasLine()\"><span class=\"attrName\" translate>PRODUCT.LINE</span> {{vm.getLineName()}}</span>\n        </div>\n        <div>\n            <uib-tabset active=\"active\">\n                <uib-tab heading=\"{{\'PRODUCT.DESCRIPTION\'|translate}}\" ng-click=\"vm.checkImage(\'desc\')\" index=\"\'desc\'\" ng-if=\"vm.model.description || vm.model.guaranteePeriod\">\n                    <div ng-bind-html=\"vm.model.description\"></div>\n                    <ul ng-if=\"vm.model.qtyIncrements > 1\">\n                        <li translate translate-values=\"{qty: vm.model.qtyIncrements}\">PRODUCT.QTY_INCREMENTS_INFO</li>\n                    </ul>\n                    <ul ng-if=\"vm.model.guaranteePeriod\">\n                        <li translate translate-values=\"{guaranteePeriod: vm.model.guaranteePeriod}\">PRODUCT.GUARANTEE_PERIOD_MONTHS</li>\n                    </ul>\n                </uib-tab>\n                <uib-tab heading=\"{{\'PRODUCT.ATTRIBUTES\'|translate}}\" ng-click=\"vm.checkImage(\'attr\')\" index=\"\'attr\'\" ng-if=\"vm.hasAttributes()\">\n                    <div class=\"product-properties\">\n                        <table class=\"product-fields\" ng-show=\"vm.hasAttributes()\">\n                            <!-- Product\'s custom attributes sort by its inhered position -->\n                            <tr ng-repeat=\"productProperty in (vm.model.customFields | sortProductAttributes)\" ng-if=\"productProperty.code !== vm.customAttrNameForLine\">\n                                <td class=\"product-property-label\">{{productProperty.label}}\n                                </td>\n                                <td class=\"product-property-value\">{{productProperty.value}}</td>\n                            </tr>\n                        </table>\n                        <p class=\"text-muted\" ng-hide=\"vm.hasAttributes()\" translate>PRODUCT.DO_NOT_HAVE_ATTRIBUTES</p>\n                    </div>\n                </uib-tab>\n                <uib-tab heading=\"{{\'PRODUCT.FILES_TO_DOWNLOAD\'|translate}}\" ng-click=\"vm.checkImage(\'attachments\')\" index=\"\'attachments\'\" ng-if=\"vm.model.attachments.length > 0\">\n                    <ul>\n                        <li ng-repeat=\"item in vm.model.attachments track by $index\">\n                            <a ng-href=\"/media/{{item.link}}\" target=\"_blank\">\n                                <span ng-if=\"item.type !== \'warranty\'\">{{item.title}}</span>\n                                <span ng-if=\"item.type === \'warranty\'\" translate>PRODUCT.WARRANTY_DETAILS</span>\n                            </a>\n                        </li>\n                        <li>\n                          <a href ng-click=\"vm.downloadCard()\" translate>PRODUCT.DOWNLOAD_CARD</a>\n                        </li>\n                    </ul>\n                </uib-tab>\n                <uib-tab heading=\"{{\'PRODUCT.RELATED_PRODUCTS\'|translate}}\" ng-click=\"vm.checkImage(\'related\')\" index=\"\'related\'\" ng-if=\"vm.getUpsellProducts().length > 0\">\n                    <div class=\"product-items\">\n                        <table class=\"table table-striped\">\n                            <thead>\n                            <tr>\n                                <th translate>GLOBAL.PRODUCT</th>\n                                <th translate>GLOBAL.AVAILABLE</th>\n                                <th translate>PRODUCT.LIST_PRICE</th>\n                                <th ng-if=\"!userLimited\" class=\"no-wrap\" translate>PRODUCT.YOUR_PRICE</th>\n                                <th ng-if=\"vm.allowAddToCart\"></th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <tr ng-repeat=\"item in vm.getUpsellProducts()\" allow-add-to-cart=\"true\" product-page-related-item data=\"item\"></tr>\n                            </tbody>\n                        </table>\n                    </div>\n                </uib-tab>\n            </uib-tabset>\n        </div>\n    </div>\n\n</div>\n");
$templateCache.put("app/product/components/productItem.html","<!-- Name of the product -->\n<td>\n    <h4>{{vm.row.name}}</h4>\n    <div class=\"attributes\">\n        <nobr class=\"attr\" ng-if=\"vm.row.sku\"><span class=\"attrName\" translate>PRODUCT.CODE</span> {{vm.row.sku}}</nobr>\n        <nobr class=\"attr\" ng-show=\"vm.hasBrand()\"><span class=\"attrName\" translate>PRODUCT.BRAND</span> {{vm.getBrandName()}}</nobr>\n        <nobr class=\"attr\" ng-show=\"vm.hasLine()\"><span class=\"attrName\" translate>PRODUCT.LINE</span> {{vm.getLineName()}}</nobr>\n    </div>\n</td>\n\n<!-- Modal launcher button -->\n<td class=\"icons\">\n    <product-info-button-launcher model=\"vm.row\" allow-add-to-cart=\"true\"></product-info-button-launcher>\n    <product-related-button-launcher model=\"vm.row\" user-limited=\"vm.userLimited\"></product-related-button-launcher>\n</td>\n\n<!-- Availability -->\n<td class=\"text-center\">\n    <product-availability-icon model=\"vm.row\" show-label=\"false\" show-tooltip=\"true\"></product-availability-icon>\n    <product-info-delivery model=\"vm.row.dlvDate\"></product-info-delivery>\n</td>\n\n<!-- List price -->\n<td class=\"text-center\">\n    <div class=\"catalog-price\" ng-class=\"{\'deprecated\': vm.row.price_special}\" ng-show=\"vm.row.price_special !== vm.row.price_catalog\">\n        {{vm.row.price_catalog | currency}}\n    </div>\n    <div class=\"promo-price\" ng-if=\"vm.row.price_special\">\n        {{vm.row.price_special | currency}}\n    </div>\n    <span class=\"attr\" ng-show=\"vm.loyaltyProgramEnabled()\">\n        <a href=\"/account/loyalty_program\">\n            <img ng-src=\"{{vm.getLoyaltyIconUrl()}}\" class=\"loyalty-icon\" alt=\"\">\n        </a>\n    </span>\n</td>\n\n<!-- Reseller price -->\n<td ng-if=\"!vm.userLimited\">\n    <div class=\"reseller-price\">\n        {{vm.row.price_reseller | currency}}\n    </div>\n    <div class=\"reseller-discount\">\n        <span ng-if=\"vm.row.price_discount\">{{vm.row.price_discount | number:2}}%</span>\n        <span class=\"discount-group\" ng-class=\"{\'deprecated\': vm.row.price_special && vm.row.price_special !== vm.row.price_catalog, \'promo\': vm.row.price_special}\" ng-if=\"vm.row.itemGroupId\">({{vm.row.itemGroupId}})</span>\n    </div>\n</td>\n\n<td>\n    <sg-add-to-cart product-id=\"vm.row.sku\" qty-increments=\"vm.row.qtyIncrements\" default-qty=\"vm.row.qtyIncrements\" on-product-add=\"vm.onProductAddToCart()\"></sg-add-to-cart>\n</td>");
$templateCache.put("app/product/components/productQuickInfoButtonLauncher.html","<button type=\"button\" class=\"btn-quick-info\" ui-sref-active=\"active\" ui-sref=\"product.quickInfo\" ng-click=\"vm.onPress()\" uib-tooltip=\"{{vm.label}}\" tooltip-enable=\"vm.label\"></button>");
$templateCache.put("app/product/components/productQuickInfoEditor.html","<div>\n    <header>\n        <div role=\"toolbar\" class=\"col-xs-12 toolbar\">\n            <div class=\"row text-right\">\n                <button class=\"btn btn-default\" ng-disabled=\"!vm.isItemChosen()\" ng-click=\"vm.updateStocks()\" promise-btn>{{\'CART.RECALCULATE_AND_UPDATE_AVAILABILITY\'|translate}}</button>\n            </div>\n        </div>\n    </header>\n    <sg-product-quick-info-items model=\"vm.model\" is-item-chosen=\"vm.isItemChosen()\" set-or-update-chosen-item=\"vm.setOrUpdateChosenItem\" get-chosen-item=\"vm.getChosenItem()\" remove-chosen-item=\"vm.removeChosenItem()\" update-chosen-item-qty=\"vm.updateChosenItemQty\" user-limited=\"vm.userLimited\"></sg-product-quick-info-items>\n</div>\n");
$templateCache.put("app/product/components/productQuickInfoItem.html","<!-- Position -->\n<td class=\"text-center\">\n    <span ng-show=\"vm.isProduct\" class=\"offer-item-position\">{{vm.position}}</span>\n    <strong ng-show=\"!vm.isProduct\" translate>GLOBAL.INSERT_SKU</strong>\n</td>\n\n<!-- Product SKU -->\n<td class=\"input-desc text-right\">\n    <input type=\"text\" class=\"form-control\" ng-model=\"vm.workCopy.sku\" name=\"sku\" ng-readonly=\"vm.isProduct\" maxlength=\"20\" size=\"6\" placeholder=\"{{\'CART.SKU_ABRV\'|translate}}\" pattern=\"^[A-Za-z0-9]*$\" uib-typeahead=\"product.sku as product.label for product in vm.findProduct($viewValue)\" typeahead-wait-ms=\"200\" typeahead-min-length=\"2\" typeahead-select-on-blur=\"true\" typeahead-on-select=\"vm.updateDefaultQty($item)\" ng-enter=\"vm.setOrUpdateChosenProduct()\" ng-tab=\"vm.focusField(\'qty\', 10)\" ng-focus=\"vm.onFocus()\" autocomplete=\"off\">\n</td>\n\n<!-- Product Name -->\n<td>\n    <span class=\"offer-item-name\">{{vm.workCopy.name}}</span>\n    <p ng-if=\"vm.workCopy.promotion_code_text\" class=\"promotion-info\">{{vm.workCopy.promotion_code_text}}</p>\n</td>\n<td class=\"icons\">\n    <product-info-button-launcher model=\"vm.workCopy\" allow-add-to-cart=\"true\" ng-show=\"vm.isProduct && vm.itemExists()\"></product-info-button-launcher>\n    <product-related-button-launcher model=\"vm.workCopy\" user-limited=\"vm.userLimited\" ng-show=\"vm.isProduct && vm.itemExists()\"></product-related-button-launcher>\n</td>\n\n<!-- Catalog price -->\n<td class=\"text-right\">\n    <div class=\"catalog-price\" ng-class=\"{\'deprecated\': vm.workCopy.price_special}\" ng-show=\"vm.workCopy.price_special !== vm.workCopy.price_catalog\">\n        {{vm.workCopy.price_catalog | currency}}\n    </div>\n    <div class=\"promo-price\" ng-if=\"vm.workCopy.price_special\">\n        {{vm.workCopy.price_special | currency}}\n    </div>\n</td>\n\n<!-- Quantity -->\n<td>\n    <div class=\"input-number-container\">\n        <input type=\"number\" class=\"form-control text-center\" ng-model=\"vm.workCopy.qty\" name=\"qty\" ng-class=\"{\'invalid\': !vm.qtyValid || !vm.qtyIncValid}\" uib-tooltip=\"{{vm.incrementErrorMsg}}\" tooltip-enable=\"vm.qtyValid && !vm.qtyIncValid\" tooltip-placement=\"left\" tooltip-is-open=\"vm.qtyValid && !vm.qtyIncValid\" sg-disable-input-scroll ng-enter=\"vm.setOrUpdateChosenProduct()\" ng-blur=\"vm.updateItemIfExist()\" ng-min=\"1\" ng-step=\"vm.workCopy.qtyIncrements\" size=\"3\">\n        <div class=\"btn-group-vertical\">\n            <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.increaseQty()\" ng-if=\"vm.workCopy.qtyIncrements\" ng-disabled=\"!vm.increaseAvaliable()\">+</button>\n            <button type=\"button\" class=\"btn btn-default btn-qty\" ng-click=\"vm.decreaseQty()\" ng-if=\"vm.workCopy.qtyIncrements\" ng-disabled=\"!vm.decreaseAvaliable()\">-</button>\n        </div>\n    </div>\n</td>\n\n<!-- Availability -->\n<td class=\"text-center\" ng-switch=\"vm.isProduct\">\n    <span ng-switch-when=\"true\" ng-class=\"vm.isQtyLessThanStock() ? \'badge badge-success\' : \'badge badge-warning\'\" uib-tooltip=\"{{vm.isQtyLessThanStock()?\'\':(vm.labels[\'CART.NOT_AVAILABLE_HELPTEXT\'])}}\" data-placement=\"top\">{{vm.workCopy.stockVisible}}</span>\n    <product-info-delivery model=\"vm.workCopy.dlvDate\"></product-info-delivery>\n</td>\n\n<!-- Discount percentage -->\n<td class=\"percentage-column text-center\" ng-switch=\"vm.isProduct && !vm.userLimited\">\n    <span ng-switch-when=\"true\">{{vm.workCopy.price_discount | number:2}}%</span>\n</td>\n\n<!-- Custom price -->\n<td class=\"text-right\" ng-switch=\"vm.isProduct && !vm.userLimited\">\n    <div ng-switch-when=\"true\" class=\"reseller-price\">\n        {{vm.workCopy.price_reseller | currency}}\n    </div>\n    <div ng-switch-when=\"true\" class=\"reseller-discount\">\n        <span class=\"discount-group\" ng-class=\"{\'promo\': vm.workCopy.price_special}\" ng-if=\"vm.workCopy.itemGroupId\">({{vm.workCopy.itemGroupId}})</span>\n    </div>\n</td>");
$templateCache.put("app/product/components/productQuickInfoItems.html","<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <table class=\"table table-striped\">\n            <thead>\n                <tr class=\"table-header\">\n                    <th class=\"id-column text-center\" translate>OFFER.ITEM_POSITION</th>\n                    <th class=\"sku-column\" translate>CART.SKU</th>\n                    <th class=\"name-column\" colspan=\"2\" translate>CART.PRODUCT</th>\n                    <th class=\"price-column text-right has-qi\">\n                        <span uib-tooltip=\"{{::\'CART.PRICE_OF_LIST_HELPTEXT\'|translate}}\" translate tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                            CART.PRICE_OF_LIST\n                        </span>\n                    </th>\n                    <th class=\"qty-column text-center\" translate>CART.QUANTITY</th>\n                    <th class=\"availability-column text-center has-qi\">\n                        <span uib-tooltip=\"{{::\'CART.AVAILABILITY_HELPTEXT\'|translate}}\" translate tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                            CART.AVAILABILITY\n                        </span>\n                    </th>\n                    <th class=\"discount-column text-center has-qi\">\n                        <span uib-tooltip=\"{{::\'CART.YOUR_DISCOUNT_HELPTEXT\'|translate}}\" translate tooltip-placement=\"{{vm.placement}}\" tooltip-animation=\"false\">\n                            CART.YOUR_DISCOUNT\n                        </span>\n                    </th>\n                    <th class=\"price-column text-right\" translate>CART.YOUR_PRICE</th>\n                </tr>\n            </thead>\n\n            <tbody>\n            <!-- Row to show chosen product -->\n            <tr sg-product-quick-info-item ng-show=\"vm.isItemChosen()\" model=\"vm.getChosenItem()\" position=\"1\" is-item-chosen=\"vm.isItemChosen()\" set-or-update-chosen-item=\"vm.setOrUpdateChosenItem\" remove-chosen-item=\"vm.removeChosenItem()\" update-chosen-item-qty=\"vm.updateChosenItemQty\" is-product=\"true\" user-limited=\"vm.userLimited\"></tr>\n\n                <!-- Row to add a new item -->\n                <tr sg-product-quick-info-item class=\"add-new-item\" is-item-chosen=\"vm.isItemChosen()\" set-or-update-chosen-item=\"vm.setOrUpdateChosenItem\" get-chosen-item=\"vm.getChosenItem()\" is-product=\"false\"></tr>\n            </tbody>\n        </table>\n    </div>\n</div>\n");
$templateCache.put("app/product/components/productRelatedButtonLauncher.html","<button type=\"button\" class=\"btn btn-link btn-info-small\" ng-if=\"vm.model.related\" ng-click=\"vm.showModal()\" uib-tooltip=\"{{\'PRODUCT.SHOW_RELATED\'|translate}}\" tooltip-popup-delay=\"500\" tooltip-placement=\"bottom\"></button>");
$templateCache.put("app/product/components/productRelatedItem.html","<!-- Name of the product -->\n<td>\n    <h4>{{vm.row.name}}</h4>\n    <div class=\"attributes\">\n        <span class=\"attr\" ng-if=\"vm.row.sku\"><span class=\"attrName\" translate>PRODUCT.CODE</span> {{vm.row.sku}}</span>\n    </div>\n</td>\n\n<!-- Availability -->\n<td class=\"text-center\">\n    <product-availability-icon class=\"no-border\" model=\"vm.row\" show-label=\"false\" show-tooltip=\"true\"></product-availability-icon>\n</td>\n\n<!-- List price -->\n<td>\n    <div class=\"catalog-price\" ng-class=\"{\'deprecated\': vm.row.price_special}\" ng-show=\"vm.row.price_special !== vm.row.price_catalog\">\n        {{vm.row.price_catalog | currency}}\n    </div>\n    <div class=\"promo-price\" ng-if=\"vm.row.price_special\">\n        {{vm.row.price_special | currency}}\n    </div>\n</td>\n\n<!-- Reseller price -->\n<td ng-if=\"!vm.userLimited\">\n    <div class=\"reseller-price\">\n        {{vm.row.price_reseller | currency}}\n    </div>\n    <div class=\"reseller-discount\">\n        <span ng-if=\"vm.row.price_discount\">{{vm.row.price_discount | number:2}}%</span>\n        <span class=\"discount-group\" ng-class=\"{\'promo\': vm.row.price_special}\" ng-if=\"vm.row.itemGroupId\">({{vm.row.itemGroupId}})</span>\n    </div>\n</td>\n\n<td ng-if=\"vm.allowAddToCart\">\n    <sg-add-to-cart product-id=\"vm.row.sku\" qty-increments=\"vm.row.qtyIncrements\" default-qty=\"vm.row.qtyIncrements\" on-product-add=\"vm.onProductAddToCart()\"></sg-add-to-cart>\n</td>");
$templateCache.put("app/product/components/productRelatedModal.html","<div class=\"modal-body no-padding\">\n    <div class=\"product-module\">\n        <div class=\"clearfix\">\n            <div class=\"page-header pull-left\">\n                <h3 translate>PRODUCT.RELATED_TITLE</h3>\n            </div>\n            <div class=\"pull-left product-name-attr\">\n                <h3>{{model.name}}</h3>\n                <div>\n                    <span class=\"attr\" ng-if=\"model.sku\">\n                        <span class=\"attrName\" translate>PRODUCT.CODE</span>\n                        {{model.sku}}\n                    </span>\n                    <span class=\"attr\" ng-show=\"model.hasBrand()\"><span class=\"attrName\" translate>PRODUCT.BRAND</span> {{model.getBrandName()}}</span>\n                    <span class=\"attr\" ng-show=\"model.hasLine()\"><span class=\"attrName\" translate>PRODUCT.LINE</span> {{model.getLineName()}}</span>\n                </div>\n            </div>\n        </div>\n        <uib-tabset active=\"active\">\n\n            <uib-tab heading=\"{{\'PRODUCT.CROSSELL\'|translate}}\" index=\"crossell\" ng-if=\"model.crossell\">\n                <div class=\"product-items\">\n                    <table class=\"table table-striped\">\n                        <thead>\n                        <tr>\n                            <th translate>GLOBAL.PRODUCT</th>\n                            <th translate>GLOBAL.AVAILABLE</th>\n                            <th translate>PRODUCT.LIST_PRICE</th>\n                            <th ng-if=\"!userLimited\" class=\"no-wrap\" translate>PRODUCT.YOUR_PRICE</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat=\"item in model.crossell\" user-limited=\"userLimited\" allow-add-to-cart=\"true\" product-related-item data=\"item\"></tr>\n                        </tbody>\n                    </table>\n                </div>\n            </uib-tab>\n            \n            <uib-tab heading=\"{{\'PRODUCT.RELATED\'|translate}}\" index=\"\'related\'\" ng-if=\"model.related\">\n                <div class=\"product-items\">\n                    <table class=\"table table-striped\">\n                        <thead>\n                        <tr>\n                            <th translate>GLOBAL.PRODUCT</th>\n                            <th translate>GLOBAL.AVAILABLE</th>\n                            <th translate>PRODUCT.LIST_PRICE</th>\n                            <th ng-if=\"!userLimited\" class=\"no-wrap\" translate>PRODUCT.YOUR_PRICE</th>\n                            <th></th>\n                        </tr>\n                        </thead>\n                        <tbody>\n                        <tr ng-repeat=\"item in model.related\" user-limited=\"userLimited\" allow-add-to-cart=\"false\" product-related-item data=\"item\"></tr>\n                        </tbody>\n                    </table>\n                </div>\n            </uib-tab>\n\n        </uib-tabset>\n\n        <div class=\"close-button\">\n            <button type=\"button\" class=\"close\" ng-click=\"$close()\" ng-attr-title=\"{{\'GLOBAL.CLOSE\'|translate}}\" ng-attr-aria-label=\"{{\'GLOBAL.CLOSE\'|translate}}\">\n            </button>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/product/components/productSearchBox.html","<form ng-submit=\"vm.search()\" class=\"search-box\">\n    <input type=\"text\" class=\"form-control\" placeholder=\"{{\'GLOBAL.SEARCH\'|translate}}\" ng-model=\"vm.keywords\" role=\"search\" maxlength=\"100\">\n    <button type=\"submit\" class=\"btn btn-default\">\n        <span class=\"glyphicon glyphicon-search\"></span>\n    </button>\n</form>");
$templateCache.put("app/product/partials/catalog.html","<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <ol class=\"breadcrumb\">\n            <li><a ui-sref=\"home({})\" translate>GLOBAL.HOMEPAGE</a></li>\n            <li><a ui-sref=\"product.catalog({p:1, s:null, sort:null, cid:null, filter:null})\" translate>PRODUCT.PRODUCT_LIST</a>\n            </li>\n            <li ng-repeat=\"cat in category.parentsPath track by $index\" ng-click=\"updateCategory(cat.id)\">\n                <span class=\"link\">{{cat.name}}</span></li>\n            <li class=\"active\" ng-if=\"category.name\">{{category.name}}</li>\n        </ol>\n    </div>\n</div>\n\n<div cg-busy=\"{promise:searchProductsPromise,message:\'\'}\">\n\n    <header>\n        <div class=\"row\">\n            <div class=\"col-xs-6\">\n                <h1 class=\"pull-left\">\n                    <span translate ng-if=\"!keywords\">PRODUCT.PRODUCT_LIST</span>\n                    <span ng-if=\"keywords\" translate translate-values=\"{keywords: keywords}\">PRODUCT.SEARCH_PHRASE</span>\n                </h1>\n            </div>\n            <div class=\"col-xs-6\">\n                <ul class=\"pull-right\" uib-pagination ng-show=\"rows\" total-items=\"totalResults\" ng-model=\"currentPage\" items-per-page=\"rowsPerPage\" boundary-links=\"true\" boundary-link-numbers=\"false\" max-size=\"paginatorLimitSize\" first-text=\"<<\" last-text=\">>\" previous-text=\"<\" next-text=\">\"></ul>\n            </div>\n        </div>\n\n        <div class=\"row\">\n            <div class=\"col-xs-3\"></div>\n            <div class=\"col-xs-2 products-counter\"><span translate>PRODUCT.PRODUCTS</span> {{ numberOfRows }}</div>\n            <div class=\"col-xs-2 sort-label\" ng-show=\"rows\" translate>GLOBAL.PAGE_SIZE</div>\n            <div class=\"col-xs-1\">\n                <div class=\"wrapSelect\" ng-show=\"rows\">\n                    <select class=\"form-control\" ng-model=\"rowsPerPage\" ng-options=\"value for value in limitValues\">\n                    </select>\n                </div>\n            </div>\n            <div class=\"col-xs-1 sort-label\" ng-show=\"rows\" translate>GLOBAL.SORT.ORDER</div>\n            <div class=\"col-xs-3\">\n                <div class=\"wrapSelect\" ng-show=\"rows\">\n                    <select class=\"form-control\" ng-model=\"sort\" ng-options=\"sortOption.code as sortOption.label | translate for sortOption in sortCatalog\">\n                    </select>\n                </div>\n            </div>\n        </div>\n    </header>\n\n    <div class=\"row\">\n        <div class=\"col-xs-3\">\n\n            <product-filter-category model=\"category\" category=\"updateCategory(arg)\" ng-if=\"showCategory\"></product-filter-category>\n\n            <product-filter-container model=\"facet\" rows-in-result=\"rows\" filters=\"updateFilter(arg)\" ng-if=\"showFilter\"></product-filter-container>\n\n        </div>\n        <div class=\"col-xs-9\">\n            <table class=\"table table-striped\" ng-show=\"rows && rows.length > 0\">\n                <thead>\n                <tr>\n                    <th colspan=\"2\" translate>GLOBAL.PRODUCT</th>\n                    <th translate>GLOBAL.AVAILABLE</th>\n                    <th translate class=\"text-center\">PRODUCT.LIST_PRICE</th>\n                    <th ng-if=\"!userLimited\" class=\"no-wrap\" translate>PRODUCT.YOUR_PRICE</th>\n                    <th></th>\n                </tr>\n                </thead>\n                <tbody>\n                <tr ng-repeat=\"row in rows\" user-limited=\"userLimited\" product-item data=\"row\"></tr>\n                </tbody>\n            </table>\n\n            <uib-alert type=\"info\" ng-show=\"!rows || rows.length == 0\">\n                {{\'PRODUCT.THERE_ARE_NO_PRODUCTS\' | translate}}\n                <a href=\"https://stalgast.com/katalogi-cenniki/pozakatalogowe\"><u>{{\'PRODUCT.NON_CATALOG_PRODUCTS\' | translate}}</u></a>\n            </uib-alert>\n\n            <uib-alert type=\"danger\" ng-show=\"lastErrorMsg\">{{lastErrorMsg | translate}}</uib-alert>\n\n            <ul class=\"pull-right\" uib-pagination ng-show=\"rows\" total-items=\"totalResults\" ng-model=\"currentPage\" items-per-page=\"rowsPerPage\" boundary-links=\"true\" boundary-link-numbers=\"false\" max-size=\"paginatorLimitSize\" first-text=\"<<\" last-text=\">>\" previous-text=\"<\" next-text=\">\"></ul>\n\n        </div>\n    </div>\n\n    <footer>\n        <div class=\"row\">\n            <div class=\"col-xs-3\">\n                <!-- TODO Uncomment when will be active\n                <button class=\"btn btn-primary\" translate>PRODUCT.ADD_SELECTION_TO_CART</button>\n                -->\n            </div>\n        </div>\n    </footer>\n\n</div>\n");
$templateCache.put("app/product/partials/index.html","<div class=\"product-module\">\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>\n");
$templateCache.put("app/product/partials/quickInfo.html","<div class=\"row\">\n    <div class=\"col-xs-12\">\n        <div ncy-breadcrumb></div>\n    </div>\n</div>\n\n<div ng-controller=\"quickInfoCtrl as vm\">\n    <header class=\"page-header\">\n        <h1><span translate>PRODUCT.QUICK_INFO</span></h1>\n    </header>\n\n    <sg-product-quick-info-editor model=\"vm.model\" user-limited=\"userLimited\"></sg-product-quick-info-editor>\n</div>");
$templateCache.put("app/settlements/components/sgSettleList.html","<table class=\"table table-striped\" ng-show=\"!vm.errorMsg\" cg-busy=\"{promise: paginator.$promise, message: \'\'}\">\n    <thead>\n    <tr>\n        <th class=\"text-right\" translate>PAYMENT.RECIPIENT_ID</th>\n        <th class=\"text-right\" translate>SETTLE.ATTACHMENT_DATE</th>\n        <th class=\"text-right\" translate>SETTLE.DUE_DATE</th>\n        <th class=\"text-right\" translate>SETTLE.DOCUMENT</th>\n        <th class=\"text-right\" translate>SETTLE.NAME</th>\n        <th class=\"text-right\" translate>GLOBAL.CURRENCY</th>\n        <th class=\"text-right\" translate>SETTLE.AMOUNT</th>\n        <th class=\"text-right\" translate>SETTLE.AMOUNT_SETTLE</th>\n        <th class=\"text-right\" translate>SETTLE.DELAY</th>\n        <th class=\"text-right\" translate>SETTLE.CASE_STATUS</th>\n        <th class=\"limit-th\">\n            <label for=\"paginator_limit\" translate>GLOBAL.PAGE_SIZE</label>\n            <div class=\"wrapSelect\">\n                <select ng-model=\"paginator.limit\" ng-options=\"value for value in limitValues\" class=\"form-control\" id=\"paginator_limit\">\n            </div>\n        </th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"settle in paginator.rows\">\n        <td class=\"text-right\">{{settle.order_account}}</td>\n        <td class=\"text-right\">{{settle.attachment_date | date}}</td>\n        <td class=\"text-right\">{{settle.due_date | date}}</td>\n        <td class=\"text-right\">{{settle.attachment}}</td>\n        <td class=\"text-right\">{{settle.name}}</td>\n        <td class=\"text-right\">{{settle.currency}}</td>\n        <td class=\"text-right\">{{settle.amount_to_pay | number:2}}</td>\n        <td class=\"text-right\">{{settle.amount_to_settle | number:2}}</td>\n        <td class=\"text-right\">{{settle.days_delay}}</td>\n        <td class=\"text-right\">{{settle.case_status}}</td>\n        <td></td>\n    </tr>\n    </tbody>\n</table>\n\n<div class=\"clearfix\">\n    <!-- Button to export results to CSV -->\n    <span ng-show=\"paginator.$resolved && paginator.rows.length>0\">\n        <button type=\"button\" class=\"btn btn-default pull-left export-to-csv-btn\" ng-click=\"vm.getCSV()\">\n            <span translate>SETTLE.EXPORT</span>\n        </button>\n    </span>\n    <!-- Pagination bar -->\n    <sg-pagination paginator=\"paginator\"></sg-pagination>\n</div>\n\n<uib-alert type=\"info\" ng-show=\"paginator.$resolved && paginator.rows.length===0\">\n    <span translate>PAYMENT.THERE_ARE_NO_RESULTS</span>\n</uib-alert>");
$templateCache.put("app/settlements/components/sgSettleListFilters.html","<form name=\"settleListFilters\" ng-submit=\"vm.applyChanges()\">\n\n    <div class=\"row\">\n        <div class=\"form-group col-xs-2\">\n            <label for=\"settleListFilterNumber\" translate>SETTLE.DOCUMENT</label>\n            <input type=\"text\" class=\"form-control\" id=\"settleListFilterNumber\" ng-model=\"vm.filters[\'filter[attachment]\']\">\n        </div>\n        <div class=\"form-group col-xs-2\">\n            <label for=\"settleListFilterOrders\" translate>SETTLE.NAME</label>\n            <input type=\"text\" class=\"form-control\" id=\"settleListFilterOrders\" ng-model=\"vm.filters[\'filter[name]\']\">\n        </div>\n        <div class=\"form-group col-xs-2\">\n            <label translate>SETTLE.ATTACHMENT_DATE</label>\n            <div class=\"row range-inputs-container\">\n                <div class=\"form-group has-feedback\">\n                    <div class=\"row\">\n                        <label for=\"settleListFilterAttachmentFrom\" class=\"control-label col-xs-1\" translate>GLOBAL.FROM</label>\n                        <datepicker datepicker-model class=\"col-xs-10\" date-max-limit=\"{{vm.filters[\'filter[attachment_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input datepicker-model type=\"text\" class=\"form-control\" id=\"settleListFilterAttachmentFrom\" ng-model=\"vm.filters[\'filter[attachment_date][from]\']\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                </div>\n                <div class=\"form-group has-feedback\">\n                    <div class=\"row\">\n                        <label for=\"settleListFilterAttachmentTo\" class=\"control-label col-xs-1\" translate>GLOBAL.TO</label>\n                        <datepicker datepicker-model class=\"col-xs-10\" date-min-limit=\"{{vm.filters[\'filter[attachment_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input datepicker-model type=\"text\" class=\"form-control\" id=\"settleListFilterAttachmentTo\" ng-model=\"vm.filters[\'filter[attachment_date][to]\']\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group col-xs-2\">\n            <label translate>SETTLE.DUE_DATE</label>\n            <div class=\"row range-inputs-container\">\n                <div class=\"form-group has-feedback\">\n                    <div class=\"row\">\n                        <label for=\"settleListFilterDueFrom\" class=\"control-label col-xs-1\" translate>GLOBAL.FROM</label>\n                        <datepicker datepicker-model class=\"col-xs-10\" date-max-limit=\"{{vm.filters[\'filter[due_date][to]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input datepicker-model type=\"text\" class=\"form-control\" id=\"settleListFilterDueFrom\" ng-model=\"vm.filters[\'filter[due_date][from]\']\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                </div>\n                <div class=\"form-group has-feedback\">\n                    <div class=\"row\">\n                        <label for=\"settleListFilterDueTo\" class=\"control-label col-xs-1\" translate>GLOBAL.TO</label>\n                        <datepicker datepicker-model class=\"col-xs-10\" date-min-limit=\"{{vm.filters[\'filter[due_date][from]\'] | amDateFormat}}\" button-prev-title=\"{{::\'GLOBAL.PREV_MONTH\'|translate}}\" button-next-title=\"{{::\'GLOBAL.NEXT_MONTH\'|translate}}\">\n                            <input datepicker-model type=\"text\" class=\"form-control\" id=\"settleListFilterDueTo\" ng-model=\"vm.filters[\'filter[due_date][to]\']\">\n                            <span class=\"glyphicon glyphicon-calendar form-control-feedback\" aria-hidden=\"true\"></span>\n                        </datepicker>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class=\"form-group col-xs-2\">\n            <label translate>SETTLE.AMOUNT</label>\n            <div class=\"row range-inputs-container\">\n                <div class=\"form-group\">\n                    <div class=\"row\">\n                        <label for=\"settleListFilterAmountFrom\" class=\"col-xs-1 control-label\" translate>GLOBAL.FROM</label>\n                        <div class=\"col-xs-10\">\n                            <input type=\"number\" class=\"form-control\" id=\"settleListFilterAmountFrom\" step=\"0.01\" sg-disable-input-scroll ng-model=\"vm.filters[\'filter[amount_to_pay][from]\']\">\n                        </div>\n                    </div>\n                </div>\n                <div class=\"form-group\">\n                    <div class=\"row\">\n                        <label for=\"settleListFilterAmountTo\" class=\"col-xs-1 control-label\" translate>GLOBAL.TO</label>\n                        <div class=\"col-xs-10\">\n                            <input type=\"number\" class=\"form-control\" id=\"settleListFilterAmountTo\" step=\"0.01\" sg-disable-input-scroll ng-model=\"vm.filters[\'filter[amount_to_pay][to]\']\">\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div>\n        <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"!vm.pendingChanges()\" translate>GLOBAL.SEARCH</button>\n        <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.clearFilters()\" translate>GLOBAL.CLEAR_FILTERS</button>\n    </div>\n\n</form>\n");
$templateCache.put("app/settlements/components/sgSettleListHeader.html","<div class=\"row\">\n    <div class=\"col-xs-3\">\n        <div class=\"payment-header-block\">\n            <span translate>SETTLE.PAYER_ACCOUNT</span>\n            <span class=\"block-value\">{{$root.settleData.distributor_id}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span translate>SETTLE.LAST_INVOICE</span>\n            <span class=\"block-value\">{{$root.settleData.last_invoice | date}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span translate>SETTLE.LAST_PAYMENT</span>\n            <span class=\"block-value\">{{$root.settleData.last_payment | date}}</span>\n        </div>\n    </div>\n    <div class=\"col-xs-3\">\n        <div class=\"payment-header-block\">\n            <span translate>FINANCES.BALANCE</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.balance | currency}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span translate>SETTLE.AMOUNT</span>\n            <span class=\"block-value\">{{$root.settleData.amount_to_pay | currency}}</span>\n        </div>\n    </div>\n    <div class=\"col-xs-3\">\n        <div class=\"payment-header-block\">\n            <span translate>ACCOUNT.CREDIT_LIMIT</span>\n            <span class=\"block-value\">{{vm.info.user.reseller.credit_level | currency}}</span>\n        </div>\n        <div class=\"payment-header-block\">\n            <span translate>SETTLE.SUBMIT</span>\n            <span class=\"block-value\">{{$root.settleData.amount_to_settle | currency}}</span>\n        </div>\n    </div>\n    <div class=\"col-xs-3\">\n        <div ng-bind-html=\"vm.conatctInfo.settlement_info.content\"></div>\n    </div>\n</div>");
$templateCache.put("app/settlements/partials/index.html","<div class=\"payment-module\">\n\n    <div class=\"container\">\n        <div class=\"row\">\n            <div class=\"col-xs-12\">\n                <div ncy-breadcrumb></div>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"container\">\n        <ui-view></ui-view>\n    </div>\n\n</div>\n");
$templateCache.put("app/settlements/partials/list.html","<header class=\"page-header clearfix\">\n    <h1 translate>SETTLE.TITLE</h1>\n</header>\n\n<h4 translate>SETTLE.HEADER</h4>\n\n<sg-settle-list-header></sg-settle-list-header>\n\n<div class=\"well well-sm\">\n    <sg-settle-list-filters filters=\"filters\"></sg-settle-list-filters>\n</div>\n\n<div class=\"bank_account\">\n    <span translate>SETTLE.PAYMENT</span>\n    <div>\n        <span>{{$root.settleData.bank_name}}:</span>\n        <span>{{$root.settleData.bank_account_num}}</span>\n    </div>\n</div>\n\n<sg-settle-list filters=\"filters\"></sg-settle-list>");
$templateCache.put("app/account/partials/addresses/form.html","<header class=\"page-header\">\n    <h1 ng-show=\"vm.model.isPhantom()\" translate>ACCOUNT.NEW_ADDRESS</h1>\n    <h1 ng-hide=\"vm.model.isPhantom()\" translate>ACCOUNT.EDIT_ADDRESS</h1>\n</header>\n\n<div class=\"row\">\n    <div class=\"col-sm-7 col-lg-6\">\n        <sg-account-address-form model=\"vm.model\" currently-default=\"vm.currentlyDefault\" on-saved=\"vm.onSaved()\" on-cancel=\"vm.goBack()\">\n        </sg-account-address-form>\n    </div>\n</div>");
$templateCache.put("app/account/partials/addresses/list.html","<header class=\"page-header clearfix\">\n    <h1 class=\"pull-left\" translate>ACCOUNT.MY_ADDRESS</h1>\n    <a ui-sref=\"account.addresses.new\" class=\"btn btn-primary pull-right\" translate>ACCOUNT.NEW_ADDRESS</a>\n</header>\n\n<table class=\"table\" st-table=\"rowsFiltered\" st-safe-src=\"rows\" cg-busy=\"{promise:rows.$promise,message:\'\',minDuration:300}\">\n    <thead>\n    <tr>\n        <th st-sort=\"label\" translate>GLOBAL.ADDR_LABEL_LIST</th>\n        <th st-sort=\"street\" translate>GLOBAL.STREET</th>\n        <th st-sort=\"building\" translate>GLOBAL.BUILDING</th>\n        <th st-sort=\"postcode\" translate>GLOBAL.POSTAL_CODE</th>\n        <th st-sort=\"city\" translate>GLOBAL.CITY</th>\n        <th></th>\n    </tr>\n    <tr class=\"filters\">\n        <th>\n            <input st-search=\"label\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th>\n            <input st-search=\"street\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th class=\"column-building\">\n            <input st-search=\"building\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th class=\"column-postcode\">\n            <input st-search=\"postcode\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th class=\"column-city\">\n            <input st-search=\"city\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th></th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in rowsFiltered\">\n        <td><span ng-if=\"row.label\">{{row.label}}</span><span ng-if=\"!row.label\">{{\'ACCOUNT.FILL_ADDR_LABEL\' | translate}}</span> <span class=\"defaultShipping\" ng-if=\"row.is_default_shipping\">{{\'GLOBAL.DEFAULT\' | translate}}</span></td>\n        <td>{{row.street}}</td>\n        <td>{{row.building}}</td>\n        <td>{{row.postcode}}</td>\n        <td>{{row.city}}</td>\n        <td class=\"actions\">\n            <a class=\"btn btn-default btn-sm\" ui-sref=\"account.addresses.update({id: row.entity_id})\" translate>GLOBAL.EDIT</a>\n            <a class=\"btn btn-danger btn-sm\" ng-if=\"!row.is_default_shipping\" mwl-confirm data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"delete(row.entity_id)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" role=\"button\" translate>GLOBAL.DELETE</a>\n        </td>\n    </tr>\n    </tbody>\n    <tfoot>\n    <tr>\n        <td colspan=\"6\" class=\"text-center\">\n            <div st-template=\"app/account/partials/addresses/pagination.html\" st-pagination=\"\" st-items-by-page=\"pageLength\" st-displayed-pages=\"displayedPages\"></div>\n        </td>\n    </tr>\n    </tfoot>\n</table>\n\n<uib-alert type=\"info\" ng-show=\"rows.$resolved && rowsFiltered.length===0\">{{\'ACCOUNT.THERE_ARE_NO_ADDRESSES\' | translate}}</uib-alert>\n");
$templateCache.put("app/account/partials/addresses/pagination.html","<nav ng-if=\"numPages && pages.length >= 2\">\n    <ul class=\"pull-right pagination\">\n        <li><a href=\"\" ng-hide=\"currentPage==1\" ng-click=\"selectPage(1)\">&lt;&lt;</a></li>\n        <li><a href=\"\" ng-hide=\"currentPage==1\" ng-click=\"selectPage(currentPage-1)\">&lt;</a></li>\n        <li ng-repeat=\"page in pages\" ng-class=\"{active: page==currentPage}\"><a href=\"\" ng-click=\"selectPage(page)\">{{page}}</a></li>\n        <li><a href=\"\" ng-hide=\"currentPage==numPages\" ng-click=\"selectPage(currentPage+1)\">&gt;</a></li>\n        <li><a href=\"\" ng-hide=\"currentPage==numPages\" class=\"fa fa-angle-double-right\" ng-click=\"selectPage(numPages)\">&gt;&gt;</a></li>\n    </ul>\n</nav>");
$templateCache.put("app/account/partials/contacts/index.html","<header class=\"page-header\">\n    <h1 translate>ACCOUNT.CONTACT</h1>\n</header>\n\n<div class=\"row\" ng-controller=\"accountContactCtrl as vm\">\n\n    <div class=\"col-xs-8\" ng-if=\"vm.info.user.reseller.dealer || vm.info.user.reseller.commercial_counsellor || vm.info.user.reseller.service\">\n        <sg-contact-mozaic ng-if=\"vm.info.user.reseller.dealer\" data-title=\"{{\'ACCOUNT.ACCOUNT_MANAGER\' | translate}}\" model=\"vm.info.user.reseller.dealer\" class=\"row\"></sg-contact-mozaic>\n        <sg-contact-mozaic ng-if=\"vm.info.user.reseller.commercial_counsellor\" data-title=\"{{\'ACCOUNT.REGIONAL_SALES_MANAGER\' | translate}}\" model=\"vm.info.user.reseller.commercial_counsellor\" class=\"row\"></sg-contact-mozaic>\n        <sg-contact-mozaic ng-if=\"vm.info.user.reseller.service\" data-title=\"{{\'ACCOUNT.SERVICE_COORDINATOR\' | translate}}\" model=\"vm.info.user.reseller.service\" class=\"row\"></sg-contact-mozaic>\n    </div>\n\n    <div class=\"col-md-4\" ng-if=\"vm.contactBlock\" ng-bind-html=\"vm.contactBlock[vm.contactBlockId].content\">\n    </div>\n\n</div>");
$templateCache.put("app/account/partials/employee/form.html","<header class=\"page-header\">\n    <h1 translate ng-if=\"model.isPhantom()\">ACCOUNT.NEW_EMPLOYEE</h1>\n    <h1 translate ng-if=\"!model.isPhantom()\">ACCOUNT.EDIT_EMPLOYEE</h1>\n</header>\n\n<div class=\"row\">\n    <div class=\"col-xs-5\">\n        <form name=\"form\" ng-submit=\"send(form)\" method=\"post\" cg-busy=\"{promise:requestPromise,message:\'\',minDuration:300}\" ng-class=\"{\'show-errors\': form.$submitted}\" novalidate>\n\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewFirstname\" class=\"required\" translate>GLOBAL.NAME</label>\n                <input type=\"text\" class=\"form-control\" id=\"accountClientNewFirstname\" required autofocus name=\"firstname\" ng-model=\"model.firstname\" minlength=\"2\" maxlength=\"255\" pattern=\"[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ \\w\\-]+\">\n                <span class=\"c-error\" ng-show=\"form.firstname.$error.required\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewLastname\" class=\"required\" translate>GLOBAL.LAST_NAME</label>\n                <input type=\"text\" class=\"form-control\" id=\"accountClientNewLastname\" required name=\"lastname\" ng-model=\"model.lastname\" minlength=\"2\" maxlength=\"255\" pattern=\"[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ \\w\\-]+\">\n                <span class=\"c-error\" ng-show=\"form.lastname.$error.required\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewUsername\" ng-class=\"{\'required\': model.isPhantom()}\" translate>GLOBAL.USERNAME</label>\n                <div class=\"input-group\" ng-show=\"model.isPhantom()\">\n                    <div class=\"input-group-addon\">{{sessionInfo.user.reseller.distributor_id}}_</div>\n                    <input type=\"text\" class=\"form-control\" id=\"accountClientNewUsername\" required pattern=\"[\\w\\-]+\" name=\"username\" ng-model=\"model.username\" minlength=\"2\" maxlength=\"40\" pattern=\"[\\w\\-_]+\">\n                </div>\n                <p class=\"help-block text-info\" ng-if=\"model.isPhantom()\" translate>GLOBAL.FIELD_ALPHANUMERIC_VALIDATION_MSG</p>\n                <p ng-if=\"!model.isPhantom()\"><strong>{{model.username}}</strong></p>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewEmail\" class=\"required\" translate>GLOBAL.EMAIL</label>\n                <input type=\"email\" class=\"form-control\" id=\"accountClientNewEmail\" required name=\"email\" ng-model=\"model.email\" ui-validate=\"{validEmail : \'validateEmail($value)\'}\" maxlength=\"255\">\n                <span class=\"c-error no-transition\" ng-if=\"form.email.$error.required\" translate>ERRORS.REQUIRED</span>\n                <span class=\"c-error no-transition\" ng-if=\"form.email.$error.validEmail\" translate>ERRORS.EMAIL</span>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewPhone\" translate>GLOBAL.PHONE</label>\n                <input type=\"phone\" class=\"form-control\" id=\"accountClientNewPhone\" name=\"phone\" ng-model=\"model.phone\" maxlength=\"11\" ui-mask=\"999-999-999\">\n                <p class=\"help-block text-info\" translate>GLOBAL.FIELD_ALPHANUMERIC_VALIDATION_MSG</p>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewRole\" class=\"required\" translate>GLOBAL.ROLE</label>\n                <div class=\"wrapSelect\">\n                    <select class=\"form-control\" id=\"accountClientNewRole\" required name=\"role\" ng-model=\"model.role\">\n                        <option value=\"\" disabled=\"disabled\" translate>ACCOUNT.CHOOSE_ROLE</option>\n                        <option ng-repeat=\"rol in roles track by rol.id\" ng-attr-value=\"{{rol.id}}\" ng-selected=\"rol.id == model.role\" translate>{{rol.label}}</option>\n                    </select>\n                </div>\n                <span class=\"c-error\" ng-show=\"form.role.$error.required\" translate>ERRORS.REQUIRED</span>\n            </div>\n            <div class=\"form-group\">\n                <input type=\"checkbox\" id=\"mailer_allow\" name=\"mailer_allow\" ng-model=\"model.mailer_allow\">\n                <label for=\"mailer_allow\" translate>ACCOUNT.ALLOW_SENDING_MAILS</label>\n            </div>\n            <div>\n                <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"lastErrorMsg\">{{lastErrorMsg | translate}}</uib-alert>\n            </div>\n\n            <div class=\"form-group\">\n                <button type=\"submit\" class=\"btn btn-primary\" translate>GLOBAL.SAVE</button>\n                <button type=\"buttom\" class=\"btn btn-default\" ng-click=\"goBack()\" translate>GLOBAL.CANCEL</button>\n            </div>\n\n        </form>\n    </div>\n    <div class=\"col-xs-5 col-xs-push-1 roles\">\n        <h2 translate>GLOBAL.ROLE</h2>\n        <div ng-repeat=\"role in roles\" class=\"role\">\n            <h3>{{role.label}}</h3>\n            <p>{{role.description}}</p>\n        </div>\n    </div>\n</div>");
$templateCache.put("app/account/partials/employee/list.html","<header class=\"page-header clearfix\">\n    <h1 class=\"pull-left\" translate>ACCOUNT.EMPLOYEES_LIST</h1>\n    <a ui-sref=\"account.employee.new\" class=\"btn btn-primary pull-right\" sg-access=\"users.add\" translate>ACCOUNT.NEW_EMPLOYEE</a>\n</header>\n\n<table class=\"table\" st-table=\"rowsFiltered\" st-safe-src=\"rows\" ng-show=\"rows.length>0\" cg-busy=\"{promise:rows.$promise,message:\'\',minDuration:300}\">\n    <thead>\n    <tr>\n        <th st-sort=\"fullname\" translate>GLOBAL.FULLNAME</th>\n        <th st-sort=\"username\" translate>GLOBAL.USERNAME</th>\n        <th st-sort=\"email\" translate>GLOBAL.EMAIL</th>\n        <th st-sort=\"role\" translate>GLOBAL.ROLE</th>\n        <th></th>\n    </tr>\n    <tr class=\"filters\">\n        <th>\n            <input st-search=\"fullname\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th>\n            <input st-search=\"username\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th>\n            <input st-search=\"email\" placeholder=\"{{\'GLOBAL.FILTER\' | translate}}\" class=\"input-sm form-control\" type=\"search\">\n        </th>\n        <th>\n            <div class=\"wrapSelect\">\n                <select st-search=\"role\" ng-model=\"rolFilter\" class=\"input-sm form-control\" st-input-event=\"change\">\n                    <option value=\"\" translate>GLOBAL.ALL</option>\n                    <option ng-repeat=\"rol in roles track by rol.id\" ng-attr-value=\"{{rol.id}}\" ng-selected=\"rol.id == rolFilter\" translate>{{rol.label}}</option>\n                </select>\n            </div>\n        </th>\n        <th></th>\n    </tr>\n    </thead>\n    <tbody>\n    <tr ng-repeat=\"row in rowsFiltered\">\n        <td>{{row.fullname}}</td>\n        <td>{{row.username}}</td>\n        <td>{{row.email}}</td>\n        <td>{{row.role | resolveRoleName | translate}}</td>\n        <td class=\"actions\">\n            <a class=\"btn btn-default btn-sm\" role=\"button\" ui-sref=\"account.employee.update({id: row.entity_id})\" sg-access=\"users.edit\" translate>GLOBAL.EDIT</a>\n            <a class=\"btn btn-default btn-sm\" role=\"button\" mwl-confirm data-title=\"{{\'ACCOUNT.CHANGE_PASSWORD\'|translate}}\" message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"resetPass(row)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" translate>ACCOUNT.CHANGE_PASSWORD</a>\n            <a class=\"btn btn-danger btn-sm\" role=\"button\" sg-access=\"users.delete\" mwl-confirm data-title=\"{{\'GLOBAL.DELETE\'|translate}}\" message=\"{{\'GLOBAL.ARE_YOU_SURE\'|translate}}\" confirm-text=\"{{\'GLOBAL.YES\'|translate}}\" cancel-text=\"{{\'GLOBAL.NO\'|translate}}\" on-confirm=\"delete(row.entity_id)\" confirm-button-type=\"danger\" cancel-button-type=\"default\" focus-button=\"cancel\" placement=\"bottom\" translate>GLOBAL.DELETE</a>\n        </td>\n    </tr>\n    </tbody>\n    <tfoot>\n    <tr>\n        <td colspan=\"5\" class=\"text-center\">\n            <div st-pagination=\"\" st-items-by-page=\"pageLength\" st-displayed-pages=\"displayedPages\"></div>\n        </td>\n    </tr>\n    </tfoot>\n</table>\n\n<uib-alert type=\"info\" ng-show=\"rows.$resolved && rowsFiltered.length===0\">{{\'ACCOUNT.THERE_IS_NO_EMPLOYEES\' | translate}}</uib-alert>\n");
$templateCache.put("app/account/partials/employee/update.html","<header class=\"page-header\">\n    <h1 translate>ACCOUNT.EDIT_EMPLOYEE</h1>\n</header>\n\n<div class=\"row\">\n    <div class=\"col-sm-7 col-lg-6\">\n        <form name=\"form\" ng-submit=\"send(form)\" cg-busy=\"{promise:requestPromise,message:\'\',minDuration:300}\">\n\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewFirstname\" class=\"required\" translate>GLOBAL.NAME</label>\n                <input type=\"text\" class=\"form-control\" id=\"accountClientNewFirstname\" required autofocus name=\"firstname\" ng-model=\"model.firstname\" minlength=\"2\" maxlength=\"255\" pattern=\"[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ \\w\\-]+\">\n                <div ng-messages=\"form.firstname.$error\">\n                    <div ng-message=\"minlength\" class=\"help-block\" translate>ACCOUNT.NAME_TOO_SHORT_VALIDATION_MSG</div>\n                    <div ng-message=\"pattern\" class=\"help-block\" translate>GLOBAL.FIELD_ALPHANUMERIC_VALIDATION_MSG</div>\n                </div>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewLastname\" class=\"required\" translate>GLOBAL.LAST_NAME</label>\n                <input type=\"text\" class=\"form-control\" id=\"accountClientNewLastname\" required name=\"lastname\" ng-model=\"model.lastname\" minlength=\"2\" maxlength=\"255\" pattern=\"[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ \\w\\-]+\">\n                <div ng-messages=\"form.lastname.$error\">\n                    <div ng-message=\"minlength\" class=\"help-block\" translate>ACCOUNT.LASTNAME_TOO_SHORT_VALIDATION_MSG</div>\n                    <div ng-message=\"pattern\" class=\"help-block\" translate>GLOBAL.FIELD_ALPHANUMERIC_VALIDATION_MSG</div>\n                </div>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewEmail\" class=\"required\" translate>GLOBAL.EMAIL</label>\n                <input type=\"email\" class=\"form-control\" id=\"accountClientNewEmail\" required name=\"email\" ng-model=\"model.email\" maxlength=\"255\" pattern=\"^[0-9a-zA-Z\\_\\.\\-\\+]+?@[0-9a-zA-Z\\_\\.\\-]+?\\.[a-zA-Z]{2,6}$\">\n                <div ng-messages=\"form.email.$error\">\n                    <div ng-message=\"email\" class=\"help-block\" translate>GLOBAL.EMAIL_REQUIRED_VALIDATION_MSG</div>\n                    <div ng-message=\"pattern\" class=\"help-block\" translate>GLOBAL.EMAIL_REQUIRED_VALIDATION_MSG</div>\n                </div>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewPhone\" class=\"required\" translate>GLOBAL.PHONE</label>\n                <input type=\"phone\" class=\"form-control\" id=\"accountClientNewPhone\" name=\"phone\" ng-model=\"model.phone\" maxlength=\"11\" ui-mask=\"999-999-999\">\n                <div ng-messages=\"form.phone.$error\">\n                    <div ng-message=\"phone\" class=\"help-block\" translate>GLOBAL.PHONE_REQUIRED_VALIDATION_MSG</div>\n                    <div ng-message=\"pattern\" class=\"help-block\" translate>GLOBAL.PHONE_REQUIRED_VALIDATION_MSG</div>\n                </div>\n            </div>\n            <div class=\"form-group\" show-input-errors>\n                <label for=\"accountClientNewRole\" class=\"required\" translate>GLOBAL.ROLE</label>\n                <div class=\"wrapSelect\">\n                    <select class=\"form-control\" id=\"accountClientNewRole\" required name=\"role\" ng-model=\"model.role\">\n                        <option value=\"\" disabled=\"disabled\" selected=\"selected\" translate>ACCOUNT.CHOOSE_ROLE</option>\n                        <option ng-repeat=\"rol in roles track by rol.id\" ng-attr-value=\"{{rol.id}}\" translate>{{rol.label}}</option>\n                    </select>\n                </div>\n            </div>\n\n            <div>\n                <uib-alert type=\"danger\" close=\"dismissError()\" ng-show=\"lastErrorMsg\">{{lastErrorMsg | translate}}</uib-alert>\n            </div>\n\n            <div class=\"form-group\">\n                <button type=\"submit\" class=\"btn btn-primary\" translate>GLOBAL.CREATE</button>\n                <button type=\"buttom\" class=\"btn btn-default\" ng-click=\"goBack()\" translate>GLOBAL.CANCEL</button>\n            </div>\n\n        </form>\n    </div>\n</div>");
$templateCache.put("app/account/partials/logo/index.html","<header class=\"page-header\">\n    <h1 translate>ACCOUNT.MY_LOGO</h1>\n</header>\n\n<div ng-controller=\"accountLogoCtrl as vm\">\n\n    <!-- Container of the current logo -->\n    <div class=\"thumbnail account-logo-container\" ng-show=\"vm.hasLogo()\">\n\n        <!-- Active zone over the logo to detect click events -->\n        <div class=\"show-logo-selector-overlay\" ng-show=\"vm.hasUploadPermissions()\" ng-click=\"vm.changeLogo()\">\n            <span class=\"glyphicon glyphicon-pencil\" translate translate-attr-title=\"ACCOUNT.CHANGE_LOGO\"></span>\n        </div>\n\n        <!-- Current logo preview -->\n        <img ng-src=\"{{vm.info.user.reseller.logo}}\" translate translate-attr-alt=\"ACCOUNT.CURRENT_LOGO\">\n\n    </div>\n\n    <!-- Is no logo is found, this message is shown -->\n    <div ng-hide=\"vm.hasLogo()\">\n        <p translate>ACCOUNT.NO_LOGO_MSG</p>\n        <button class=\"btn btn-primary\" ng-show=\"vm.hasUploadPermissions()\" ng-click=\"vm.changeLogo()\" translate>ACCOUNT.UPLOAD_LOGO</button>\n    </div>\n    <div ng-show=\"vm.hasLogo()\" class=\"text-center\">\n        <button class=\"btn btn-primary\" ng-show=\"vm.hasUploadPermissions()\" ng-click=\"vm.changeLogo()\" translate>ACCOUNT.CHANGE_LOGO</button>\n    </div>\n\n</div>");
$templateCache.put("app/account/partials/logo/modalSelector.html","<div class=\"sg-logo-selector\">\n\n    <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"$dismiss()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h3 class=\"modal-title\" translate>ACCOUNT.SELECT_NEW_LOGO</h3>\n    </div>\n\n    <div class=\"modal-body\">\n\n        <div class=\"image-container\">\n            <div ngf-select ngf-drop class=\"drop-box ng-pristine ng-untouched ng-valid ng-empty\" ng-hide=\"!!vm.file\" ng-model=\"vm.file\" ng-model-options=\"{allowInvalid: false}\" ngf-model-invalid=\"invalidFiles\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" ngf-capture=\"capture\" ngf-drag-over-class=\"{pattern:\'image/*\', accept:\'accept-file\', reject:\'reject-file\', delay:100}\" ngf-validate=\"{size: {min: 10, max: \'5MB\'}}\" ngf-drop-available=\"vm.dropFileAvailable\">\n                <div class=\"msg\">\n                    <span ng-show=\"vm.dropFileAvailable\" translate>ACCOUNT.OR_DROP_FILE_HERE</span>\n                    <span translate>ACCOUNT.PRESS_HERE_TO_SELECT_FILE</span>\n                </div>\n            </div>\n            <img-crop ng-show=\"!!vm.file\" image=\"vm.file | ngfDataUrl\" area-type=\"rectangle\" aspect-ratio=\"vm.config.aspectRatio\" init-max-area=\"true\" result-image-format=\"\'image/jpeg\'\" result-image-size=\"vm.config.sizeInPx\" result-image=\"vm.cropFile\">\n            </img-crop>\n        </div>\n\n        <button class=\"btn btn-primary btn-block\" ng-click=\"vm.upload(vm.cropFile)\" ng-disabled=\"!vm.file\" translate>ACCOUNT.UPLOAD_LOGO</button>\n\n        <uib-alert type=\"danger\" close=\"vm.dismissError()\" ng-show=\"vm.errorMsg\">{{vm.errorMsg | translate}}</uib-alert>\n\n    </div>\n\n</div>");
$templateCache.put("app/account/partials/loyaltyProgram/index.html","<div class=\"row\" ng-controller=\"loyaltyProgramCtrl as vm\">\n    <div class=\"col-12\" ng-bind-html=\"vm.block[vm.blockId].content\">\n    </div>\n</div>");
$templateCache.put("app/account/partials/myData/agreementFields.html","<div class=\"row\">\n    <div class=\"form-group\">\n        <input type=\"checkbox\" id=\"agreement_rules\" name=\"agreement_rules\" ng-model=\"vm.info.user.user.agreement_rules\">\n        <label for=\"agreement_rules\" class=\"inline\" ng-bind-html=\"getRulesLabel()\"></label>\n        <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.rulesToggle=!vm.rulesToggle\" ng-hide=\"vm.rulesToggle\" translate>AUTH.SEE_TERMS</a>\n    </div>\n\n    <div ng-show=\"vm.rulesToggle\" class=\"agreement-readmore ng-hide\" ng-bind-html=\"getRulesContent()\"></div>\n\n    <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.rulesToggle=!vm.rulesToggle\" ng-show=\"vm.rulesToggle\" translate>AUTH.LESS</a>\n\n</div>\n<div class=\"row\">\n    <div class=\"form-group\">\n        <input type=\"checkbox\" id=\"agreement_notifications\" name=\"agreement_notifications\" ng-model=\"vm.info.user.user.agreement_notifications\">\n        <label for=\"agreement_notifications\" class=\"inline\" ng-bind-html=\"getNotificationsLabel()\"></label>\n        <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.notificationsToggle=!vm.notificationsToggle\" ng-hide=\"vm.notificationsToggle\" translate>AUTH.MORE</a>\n    </div>\n\n    <div ng-show=\"vm.notificationsToggle\" class=\"agreement-readmore ng-hide\" ng-bind-html=\"getNotificationsContent()\"></div>\n\n    <a href=\"#\" class=\"agreement-readmore\" ng-click=\"vm.notificationsToggle=!vm.notificationsToggle\" ng-show=\"vm.notificationsToggle\" translate>AUTH.LESS</a>\n</div>");
$templateCache.put("app/account/partials/myData/index.html","<header class=\"page-header\">\n    <h1 translate>ACCOUNT.MY_DATA</h1>\n</header>\n\n<p translate>ACCOUNT.MY_DATA_WELCOME</p>\n\n<div class=\"row\" ng-controller=\"accountMyDataCtrl as vm\" cg-busy=\"{promise:usersMeResource,message:\'\',minDuration:300}\">\n\n    <div class=\"col-lg-5\">\n\n        <div class=\"info-block\">\n            <h5 translate>ACCOUNT.B2B_ADMINISTRATOR</h5>\n            <ul>\n                <li>{{vm.info.user.admin.firstname}} {{vm.info.user.admin.lastname}}</li>\n                <li ng-if=\"vm.info.user.admin.email\"><a ng-href=\"mailto:{{vm.info.user.admin.email}}\">{{vm.info.user.admin.email}}</a>\n                </li>\n                <li ng-if=\"vm.info.user.admin.phone\"><span translate>GLOBAL.PHONE_ABBR</span>: {{vm.info.user.admin.phone}}</li>\n            </ul>\n        </div>\n\n        <div class=\"info-block\">\n            <h5 translate>ACCOUNT.B2B_USER</h5>\n            <ul>\n                <li>{{vm.info.user.user.firstname}} {{vm.info.user.user.lastname}}</li>\n                <li ng-if=\"vm.info.user.user.email\"><a ng-href=\"mailto:{{vm.info.user.user.email}}\">{{vm.info.user.user.email}}</a>\n                </li>\n                <li ng-if=\"vm.info.user.user.phone\"><span translate>GLOBAL.PHONE_ABBR</span>: {{vm.info.user.user.phone}}</li>\n                <li><span translate>GLOBAL.ROLE</span>: {{vm.info.user.user.role}}</li>\n            </ul>\n        </div>\n\n        <div class=\"info-block\">\n            <h5 translate>ACCOUNT.RECIPIENT</h5>\n            <ul class=\"recipient\">\n                <li>{{vm.info.user.reseller.name}}</li>\n                <li>{{vm.info.user.reseller.street}} {{vm.info.user.reseller.build_num}},\n                    {{vm.info.user.reseller.postal_code}} {{vm.info.user.reseller.city}}\n                </li>\n                <li>\n                    <span ng-if=\"vm.info.user.reseller.county\">{{vm.info.user.reseller.county}}</span>\n                    <span ng-if=\"vm.info.user.reseller.province\">{{vm.info.user.reseller.province}}</span>\n                </li>\n                <li ng-if=\"vm.info.user.reseller.tax_id\"><span translate>GLOBAL.TAX_ID</span>:\n                    {{vm.info.user.reseller.tax_id}}\n                </li>\n                <li ng-if=\"vm.info.user.reseller.distributor_id\"><span translate>GLOBAL.CLIENT_ID</span>:\n                    {{vm.info.user.reseller.distributor_id}}\n                </li>\n            </ul>\n            <ul>\n                <li ng-if=\"vm.info.user.reseller.telephone\">tel.: {{vm.info.user.reseller.telephone}}</li>\n                <li ng-if=\"vm.info.user.reseller.telephone_mobile\">mobile: {{vm.info.user.reseller.telephone_mobile}}\n                </li>\n                <li ng-if=\"vm.info.user.reseller.fax\">fax: {{vm.info.user.reseller.fax}}</li>\n            </ul>\n        </div>\n\n        <div class=\"info-block\" ng-if=\"vm.info.user.reseller.contact_id\">\n            <h5 translate>ACCOUNT.STALGAST_CONTACT</h5>\n            <ul>\n                <li>{{vm.info.user.reseller.contact_id}}</li>\n            </ul>\n        </div>\n\n        <div class=\"info-block\" ng-if=\"vm.info.user.reseller.commercial_counsellor_id\">\n            <h5 translate>ACCOUNT.ACCOUNT_MANAGER</h5>\n            <ul>\n                <li>{{vm.info.user.reseller.commercial_counsellor_id}}</li>\n            </ul>\n        </div>\n\n    </div>\n\n    <div class=\"col-lg-3\">\n\n    </div>\n\n    <div class=\"col-xs-4\">\n\n        <div class=\"info-block\" ng-if=\"vm.info.user.reseller.credit_level\">\n            <h5 translate>ACCOUNT.CREDIT_LIMIT</h5>\n            <p>{{vm.info.user.reseller.credit_level | number:2}} {{vm.info.user.reseller.currency}}</p>\n        </div>\n\n        <div class=\"info-block\" ng-if=\"vm.info.user.reseller.payment_terms\">\n            <h5 translate>ACCOUNT.PAYMENTS_TERMS</h5>\n            <p>{{vm.info.user.reseller.payment_terms}}</p>\n        </div>\n\n        <div class=\"info-block\" ng-if=\"vm.info.user.reseller.delivery_method\">\n            <h5 translate>ACCOUNT.DELIVERY_METHOD</h5>\n            <p>{{vm.info.user.reseller.delivery_method}}</p>\n        </div>\n\n        <div class=\"info-block\" ng-if=\"vm.info.user.reseller.carrier\">\n            <h5 translate>ACCOUNT.CARRIER</h5>\n            <p>{{vm.info.user.reseller.carrier}}</p>\n        </div>\n\n    </div>\n    <form class=\"col-xs-12\" ng-submit=\"vm.saveMailerAttr()\">\n        <div class=\"row\">\n            <div class=\"form-group mailer-allow\">\n                <input type=\"checkbox\" id=\"mailer_allow\" name=\"mailer_allow\" ng-model=\"vm.info.user.user.mailer_allow\">\n                <label for=\"mailer_allow\" translate>ACCOUNT.ALLOW_ME_SENDING_MAILS</label>\n            </div>\n        </div>\n        <div ng-include=\"\'app/account/partials/myData/agreementFields.html\'\"></div>\n        <div class=\"form-group\">\n            <button type=\"submit\" class=\"btn btn-primary\" translate>GLOBAL.SAVE</button>\n        </div>\n    </form>\n\n</div>");
$templateCache.put("app/global/components/editor/sgNameEditor.html","<sg-input-button ng-model=\"vm.newName\" on-request-save=\"vm.save()\" label=\"{{vm.label}}\" placeholder=\"{{vm.placeholder}}\" btn-disabled=\"!vm.isSaveAllowed()\" autofocus></sg-input-button>");
$templateCache.put("app/global/components/pagination/sgPagination.html","<span class=\"paginator-summary\" ng-if=\"vm.paginator.total > 0\">\n    {{\'GLOBAL.SHOWN_RESULTS\'|translate}}: {{vm.paginator.from}}-{{vm.paginator.to}} {{\'GLOBAL.OF\'|translate}} {{vm.paginator.total}}\n</span>\n<ul class=\"pull-right\" uib-pagination ng-show=\"vm.paginator.total > vm.paginator.limit\" first-text=\"<<\" last-text=\">>\" previous-text=\"<\" next-text=\">\" items-per-page=\"vm.paginator.limit\" total-items=\"vm.paginator.total\" ng-model=\"vm.paginator.page\" max-size=\"5\" force-ellipses=\"true\" boundary-links=\"true\"></ul>");}]);
"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function e(t, n, r) {
  function s(o, u) {
    if (!n[o]) {
      if (!t[o]) {
        var a = typeof require == "function" && require;
        if (!u && a) return a(o, !0);
        if (i) return i(o, !0);
        var f = new Error("Cannot find module '" + o + "'");
        throw f.code = "MODULE_NOT_FOUND", f;
      }

      var l = n[o] = {
        exports: {}
      };
      t[o][0].call(l.exports, function (e) {
        var n = t[o][1][e];
        return s(n ? n : e);
      }, l, l.exports, e, t, n, r);
    }

    return n[o].exports;
  }

  var i = typeof require == "function" && require;

  for (var o = 0; o < r.length; o++) {
    s(r[o]);
  }

  return s;
})({
  1: [function (_dereq_, module, exports) {
    (function (global) {
      "use strict";

      _dereq_(327);

      _dereq_(328);

      _dereq_(2);

      if (global._babelPolyfill) {
        throw new Error("only one instance of babel-polyfill is allowed");
      }

      global._babelPolyfill = true;
      var DEFINE_PROPERTY = "defineProperty";

      function define(O, key, value) {
        O[key] || Object[DEFINE_PROPERTY](O, key, {
          writable: true,
          configurable: true,
          value: value
        });
      }

      define(String.prototype, "padLeft", "".padStart);
      define(String.prototype, "padRight", "".padEnd);
      "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
        [][key] && define(Array, key, Function.call.bind([][key]));
      });
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  }, {
    "2": 2,
    "327": 327,
    "328": 328
  }],
  2: [function (_dereq_, module, exports) {
    _dereq_(130);

    module.exports = _dereq_(23).RegExp.escape;
  }, {
    "130": 130,
    "23": 23
  }],
  3: [function (_dereq_, module, exports) {
    module.exports = function (it) {
      if (typeof it != 'function') throw TypeError(it + ' is not a function!');
      return it;
    };
  }, {}],
  4: [function (_dereq_, module, exports) {
    var cof = _dereq_(18);

    module.exports = function (it, msg) {
      if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
      return +it;
    };
  }, {
    "18": 18
  }],
  5: [function (_dereq_, module, exports) {
    // 22.1.3.31 Array.prototype[@@unscopables]
    var UNSCOPABLES = _dereq_(128)('unscopables');

    var ArrayProto = Array.prototype;
    if (ArrayProto[UNSCOPABLES] == undefined) _dereq_(42)(ArrayProto, UNSCOPABLES, {});

    module.exports = function (key) {
      ArrayProto[UNSCOPABLES][key] = true;
    };
  }, {
    "128": 128,
    "42": 42
  }],
  6: [function (_dereq_, module, exports) {
    module.exports = function (it, Constructor, name, forbiddenField) {
      if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
        throw TypeError(name + ': incorrect invocation!');
      }

      return it;
    };
  }, {}],
  7: [function (_dereq_, module, exports) {
    var isObject = _dereq_(51);

    module.exports = function (it) {
      if (!isObject(it)) throw TypeError(it + ' is not an object!');
      return it;
    };
  }, {
    "51": 51
  }],
  8: [function (_dereq_, module, exports) {
    // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
    'use strict';

    var toObject = _dereq_(119);

    var toAbsoluteIndex = _dereq_(114);

    var toLength = _dereq_(118);

    module.exports = [].copyWithin || function copyWithin(target
    /* = 0 */
    , start
    /* = 0, end = @length */
    ) {
      var O = toObject(this);
      var len = toLength(O.length);
      var to = toAbsoluteIndex(target, len);
      var from = toAbsoluteIndex(start, len);
      var end = arguments.length > 2 ? arguments[2] : undefined;
      var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
      var inc = 1;

      if (from < to && to < from + count) {
        inc = -1;
        from += count - 1;
        to += count - 1;
      }

      while (count-- > 0) {
        if (from in O) O[to] = O[from];else delete O[to];
        to += inc;
        from += inc;
      }

      return O;
    };
  }, {
    "114": 114,
    "118": 118,
    "119": 119
  }],
  9: [function (_dereq_, module, exports) {
    // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
    'use strict';

    var toObject = _dereq_(119);

    var toAbsoluteIndex = _dereq_(114);

    var toLength = _dereq_(118);

    module.exports = function fill(value
    /* , start = 0, end = @length */
    ) {
      var O = toObject(this);
      var length = toLength(O.length);
      var aLen = arguments.length;
      var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
      var end = aLen > 2 ? arguments[2] : undefined;
      var endPos = end === undefined ? length : toAbsoluteIndex(end, length);

      while (endPos > index) {
        O[index++] = value;
      }

      return O;
    };
  }, {
    "114": 114,
    "118": 118,
    "119": 119
  }],
  10: [function (_dereq_, module, exports) {
    var forOf = _dereq_(39);

    module.exports = function (iter, ITERATOR) {
      var result = [];
      forOf(iter, false, result.push, result, ITERATOR);
      return result;
    };
  }, {
    "39": 39
  }],
  11: [function (_dereq_, module, exports) {
    // false -> Array#indexOf
    // true  -> Array#includes
    var toIObject = _dereq_(117);

    var toLength = _dereq_(118);

    var toAbsoluteIndex = _dereq_(114);

    module.exports = function (IS_INCLUDES) {
      return function ($this, el, fromIndex) {
        var O = toIObject($this);
        var length = toLength(O.length);
        var index = toAbsoluteIndex(fromIndex, length);
        var value; // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare

        if (IS_INCLUDES && el != el) while (length > index) {
          value = O[index++]; // eslint-disable-next-line no-self-compare

          if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
        } else for (; length > index; index++) {
          if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
          }
        }
        return !IS_INCLUDES && -1;
      };
    };
  }, {
    "114": 114,
    "117": 117,
    "118": 118
  }],
  12: [function (_dereq_, module, exports) {
    // 0 -> Array#forEach
    // 1 -> Array#map
    // 2 -> Array#filter
    // 3 -> Array#some
    // 4 -> Array#every
    // 5 -> Array#find
    // 6 -> Array#findIndex
    var ctx = _dereq_(25);

    var IObject = _dereq_(47);

    var toObject = _dereq_(119);

    var toLength = _dereq_(118);

    var asc = _dereq_(15);

    module.exports = function (TYPE, $create) {
      var IS_MAP = TYPE == 1;
      var IS_FILTER = TYPE == 2;
      var IS_SOME = TYPE == 3;
      var IS_EVERY = TYPE == 4;
      var IS_FIND_INDEX = TYPE == 6;
      var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
      var create = $create || asc;
      return function ($this, callbackfn, that) {
        var O = toObject($this);
        var self = IObject(O);
        var f = ctx(callbackfn, that, 3);
        var length = toLength(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;

        for (; length > index; index++) {
          if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);

            if (TYPE) {
              if (IS_MAP) result[index] = res; // map
              else if (res) switch (TYPE) {
                  case 3:
                    return true;
                  // some

                  case 5:
                    return val;
                  // find

                  case 6:
                    return index;
                  // findIndex

                  case 2:
                    result.push(val);
                  // filter
                } else if (IS_EVERY) return false; // every
            }
          }
        }

        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
      };
    };
  }, {
    "118": 118,
    "119": 119,
    "15": 15,
    "25": 25,
    "47": 47
  }],
  13: [function (_dereq_, module, exports) {
    var aFunction = _dereq_(3);

    var toObject = _dereq_(119);

    var IObject = _dereq_(47);

    var toLength = _dereq_(118);

    module.exports = function (that, callbackfn, aLen, memo, isRight) {
      aFunction(callbackfn);
      var O = toObject(that);
      var self = IObject(O);
      var length = toLength(O.length);
      var index = isRight ? length - 1 : 0;
      var i = isRight ? -1 : 1;
      if (aLen < 2) for (;;) {
        if (index in self) {
          memo = self[index];
          index += i;
          break;
        }

        index += i;

        if (isRight ? index < 0 : length <= index) {
          throw TypeError('Reduce of empty array with no initial value');
        }
      }

      for (; isRight ? index >= 0 : length > index; index += i) {
        if (index in self) {
          memo = callbackfn(memo, self[index], index, O);
        }
      }

      return memo;
    };
  }, {
    "118": 118,
    "119": 119,
    "3": 3,
    "47": 47
  }],
  14: [function (_dereq_, module, exports) {
    var isObject = _dereq_(51);

    var isArray = _dereq_(49);

    var SPECIES = _dereq_(128)('species');

    module.exports = function (original) {
      var C;

      if (isArray(original)) {
        C = original.constructor; // cross-realm fallback

        if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;

        if (isObject(C)) {
          C = C[SPECIES];
          if (C === null) C = undefined;
        }
      }

      return C === undefined ? Array : C;
    };
  }, {
    "128": 128,
    "49": 49,
    "51": 51
  }],
  15: [function (_dereq_, module, exports) {
    // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
    var speciesConstructor = _dereq_(14);

    module.exports = function (original, length) {
      return new (speciesConstructor(original))(length);
    };
  }, {
    "14": 14
  }],
  16: [function (_dereq_, module, exports) {
    'use strict';

    var aFunction = _dereq_(3);

    var isObject = _dereq_(51);

    var invoke = _dereq_(46);

    var arraySlice = [].slice;
    var factories = {};

    var construct = function construct(F, len, args) {
      if (!(len in factories)) {
        for (var n = [], i = 0; i < len; i++) {
          n[i] = 'a[' + i + ']';
        } // eslint-disable-next-line no-new-func


        factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
      }

      return factories[len](F, args);
    };

    module.exports = Function.bind || function bind(that
    /* , ...args */
    ) {
      var fn = aFunction(this);
      var partArgs = arraySlice.call(arguments, 1);

      var bound = function bound()
      /* args... */
      {
        var args = partArgs.concat(arraySlice.call(arguments));
        return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
      };

      if (isObject(fn.prototype)) bound.prototype = fn.prototype;
      return bound;
    };
  }, {
    "3": 3,
    "46": 46,
    "51": 51
  }],
  17: [function (_dereq_, module, exports) {
    // getting tag from 19.1.3.6 Object.prototype.toString()
    var cof = _dereq_(18);

    var TAG = _dereq_(128)('toStringTag'); // ES3 wrong here


    var ARG = cof(function () {
      return arguments;
    }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

    var tryGet = function tryGet(it, key) {
      try {
        return it[key];
      } catch (e) {
        /* empty */
      }
    };

    module.exports = function (it) {
      var O, T, B;
      return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
      : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
      : ARG ? cof(O) // ES3 arguments fallback
      : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
    };
  }, {
    "128": 128,
    "18": 18
  }],
  18: [function (_dereq_, module, exports) {
    var toString = {}.toString;

    module.exports = function (it) {
      return toString.call(it).slice(8, -1);
    };
  }, {}],
  19: [function (_dereq_, module, exports) {
    'use strict';

    var dP = _dereq_(72).f;

    var create = _dereq_(71);

    var redefineAll = _dereq_(93);

    var ctx = _dereq_(25);

    var anInstance = _dereq_(6);

    var forOf = _dereq_(39);

    var $iterDefine = _dereq_(55);

    var step = _dereq_(57);

    var setSpecies = _dereq_(100);

    var DESCRIPTORS = _dereq_(29);

    var fastKey = _dereq_(66).fastKey;

    var validate = _dereq_(125);

    var SIZE = DESCRIPTORS ? '_s' : 'size';

    var getEntry = function getEntry(that, key) {
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return that._i[index]; // frozen object case

      for (entry = that._f; entry; entry = entry.n) {
        if (entry.k == key) return entry;
      }
    };

    module.exports = {
      getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function (that, iterable) {
          anInstance(that, C, NAME, '_i');
          that._t = NAME; // collection type

          that._i = create(null); // index

          that._f = undefined; // first entry

          that._l = undefined; // last entry

          that[SIZE] = 0; // size

          if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        });
        redefineAll(C.prototype, {
          // 23.1.3.1 Map.prototype.clear()
          // 23.2.3.2 Set.prototype.clear()
          clear: function clear() {
            for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
              entry.r = true;
              if (entry.p) entry.p = entry.p.n = undefined;
              delete data[entry.i];
            }

            that._f = that._l = undefined;
            that[SIZE] = 0;
          },
          // 23.1.3.3 Map.prototype.delete(key)
          // 23.2.3.4 Set.prototype.delete(value)
          'delete': function _delete(key) {
            var that = validate(this, NAME);
            var entry = getEntry(that, key);

            if (entry) {
              var next = entry.n;
              var prev = entry.p;
              delete that._i[entry.i];
              entry.r = true;
              if (prev) prev.n = next;
              if (next) next.p = prev;
              if (that._f == entry) that._f = next;
              if (that._l == entry) that._l = prev;
              that[SIZE]--;
            }

            return !!entry;
          },
          // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
          // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
          forEach: function forEach(callbackfn
          /* , that = undefined */
          ) {
            validate(this, NAME);
            var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
            var entry;

            while (entry = entry ? entry.n : this._f) {
              f(entry.v, entry.k, this); // revert to the last existing entry

              while (entry && entry.r) {
                entry = entry.p;
              }
            }
          },
          // 23.1.3.7 Map.prototype.has(key)
          // 23.2.3.7 Set.prototype.has(value)
          has: function has(key) {
            return !!getEntry(validate(this, NAME), key);
          }
        });
        if (DESCRIPTORS) dP(C.prototype, 'size', {
          get: function get() {
            return validate(this, NAME)[SIZE];
          }
        });
        return C;
      },
      def: function def(that, key, value) {
        var entry = getEntry(that, key);
        var prev, index; // change existing entry

        if (entry) {
          entry.v = value; // create new entry
        } else {
          that._l = entry = {
            i: index = fastKey(key, true),
            // <- index
            k: key,
            // <- key
            v: value,
            // <- value
            p: prev = that._l,
            // <- previous entry
            n: undefined,
            // <- next entry
            r: false // <- removed

          };
          if (!that._f) that._f = entry;
          if (prev) prev.n = entry;
          that[SIZE]++; // add to index

          if (index !== 'F') that._i[index] = entry;
        }

        return that;
      },
      getEntry: getEntry,
      setStrong: function setStrong(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $iterDefine(C, NAME, function (iterated, kind) {
          this._t = validate(iterated, NAME); // target

          this._k = kind; // kind

          this._l = undefined; // previous
        }, function () {
          var that = this;
          var kind = that._k;
          var entry = that._l; // revert to the last existing entry

          while (entry && entry.r) {
            entry = entry.p;
          } // get next entry


          if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
            // or finish the iteration
            that._t = undefined;
            return step(1);
          } // return step by kind


          if (kind == 'keys') return step(0, entry.k);
          if (kind == 'values') return step(0, entry.v);
          return step(0, [entry.k, entry.v]);
        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2

        setSpecies(NAME);
      }
    };
  }, {
    "100": 100,
    "125": 125,
    "25": 25,
    "29": 29,
    "39": 39,
    "55": 55,
    "57": 57,
    "6": 6,
    "66": 66,
    "71": 71,
    "72": 72,
    "93": 93
  }],
  20: [function (_dereq_, module, exports) {
    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
    var classof = _dereq_(17);

    var from = _dereq_(10);

    module.exports = function (NAME) {
      return function toJSON() {
        if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
        return from(this);
      };
    };
  }, {
    "10": 10,
    "17": 17
  }],
  21: [function (_dereq_, module, exports) {
    'use strict';

    var redefineAll = _dereq_(93);

    var getWeak = _dereq_(66).getWeak;

    var anObject = _dereq_(7);

    var isObject = _dereq_(51);

    var anInstance = _dereq_(6);

    var forOf = _dereq_(39);

    var createArrayMethod = _dereq_(12);

    var $has = _dereq_(41);

    var validate = _dereq_(125);

    var arrayFind = createArrayMethod(5);
    var arrayFindIndex = createArrayMethod(6);
    var id = 0; // fallback for uncaught frozen keys

    var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
      return that._l || (that._l = new UncaughtFrozenStore());
    };

    var UncaughtFrozenStore = function UncaughtFrozenStore() {
      this.a = [];
    };

    var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
      return arrayFind(store.a, function (it) {
        return it[0] === key;
      });
    };

    UncaughtFrozenStore.prototype = {
      get: function get(key) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) return entry[1];
      },
      has: function has(key) {
        return !!findUncaughtFrozen(this, key);
      },
      set: function set(key, value) {
        var entry = findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;else this.a.push([key, value]);
      },
      'delete': function _delete(key) {
        var index = arrayFindIndex(this.a, function (it) {
          return it[0] === key;
        });
        if (~index) this.a.splice(index, 1);
        return !!~index;
      }
    };
    module.exports = {
      getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function (that, iterable) {
          anInstance(that, C, NAME, '_i');
          that._t = NAME; // collection type

          that._i = id++; // collection id

          that._l = undefined; // leak store for uncaught frozen objects

          if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        });
        redefineAll(C.prototype, {
          // 23.3.3.2 WeakMap.prototype.delete(key)
          // 23.4.3.3 WeakSet.prototype.delete(value)
          'delete': function _delete(key) {
            if (!isObject(key)) return false;
            var data = getWeak(key);
            if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
            return data && $has(data, this._i) && delete data[this._i];
          },
          // 23.3.3.4 WeakMap.prototype.has(key)
          // 23.4.3.4 WeakSet.prototype.has(value)
          has: function has(key) {
            if (!isObject(key)) return false;
            var data = getWeak(key);
            if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
            return data && $has(data, this._i);
          }
        });
        return C;
      },
      def: function def(that, key, value) {
        var data = getWeak(anObject(key), true);
        if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
        return that;
      },
      ufstore: uncaughtFrozenStore
    };
  }, {
    "12": 12,
    "125": 125,
    "39": 39,
    "41": 41,
    "51": 51,
    "6": 6,
    "66": 66,
    "7": 7,
    "93": 93
  }],
  22: [function (_dereq_, module, exports) {
    'use strict';

    var global = _dereq_(40);

    var $export = _dereq_(33);

    var redefine = _dereq_(94);

    var redefineAll = _dereq_(93);

    var meta = _dereq_(66);

    var forOf = _dereq_(39);

    var anInstance = _dereq_(6);

    var isObject = _dereq_(51);

    var fails = _dereq_(35);

    var $iterDetect = _dereq_(56);

    var setToStringTag = _dereq_(101);

    var inheritIfRequired = _dereq_(45);

    module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
      var Base = global[NAME];
      var C = Base;
      var ADDER = IS_MAP ? 'set' : 'add';
      var proto = C && C.prototype;
      var O = {};

      var fixMethod = function fixMethod(KEY) {
        var fn = proto[KEY];
        redefine(proto, KEY, KEY == 'delete' ? function (a) {
          return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'has' ? function has(a) {
          return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'get' ? function get(a) {
          return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
        } : KEY == 'add' ? function add(a) {
          fn.call(this, a === 0 ? 0 : a);
          return this;
        } : function set(a, b) {
          fn.call(this, a === 0 ? 0 : a, b);
          return this;
        });
      };

      if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
        new C().entries().next();
      }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        redefineAll(C.prototype, methods);
        meta.NEED = true;
      } else {
        var instance = new C(); // early implementations not supports chaining

        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false

        var THROWS_ON_PRIMITIVES = fails(function () {
          instance.has(1);
        }); // most early implementations doesn't supports iterables, most modern - not close it correctly

        var ACCEPT_ITERABLES = $iterDetect(function (iter) {
          new C(iter);
        }); // eslint-disable-line no-new
        // for early implementations -0 and +0 not the same

        var BUGGY_ZERO = !IS_WEAK && fails(function () {
          // V8 ~ Chromium 42- fails only with 5+ elements
          var $instance = new C();
          var index = 5;

          while (index--) {
            $instance[ADDER](index, index);
          }

          return !$instance.has(-0);
        });

        if (!ACCEPT_ITERABLES) {
          C = wrapper(function (target, iterable) {
            anInstance(target, C, NAME);
            var that = inheritIfRequired(new Base(), target, C);
            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
            return that;
          });
          C.prototype = proto;
          proto.constructor = C;
        }

        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
          fixMethod('delete');
          fixMethod('has');
          IS_MAP && fixMethod('get');
        }

        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

        if (IS_WEAK && proto.clear) delete proto.clear;
      }

      setToStringTag(C, NAME);
      O[NAME] = C;
      $export($export.G + $export.W + $export.F * (C != Base), O);
      if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
      return C;
    };
  }, {
    "101": 101,
    "33": 33,
    "35": 35,
    "39": 39,
    "40": 40,
    "45": 45,
    "51": 51,
    "56": 56,
    "6": 6,
    "66": 66,
    "93": 93,
    "94": 94
  }],
  23: [function (_dereq_, module, exports) {
    var core = module.exports = {
      version: '2.5.0'
    };
    if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
  }, {}],
  24: [function (_dereq_, module, exports) {
    'use strict';

    var $defineProperty = _dereq_(72);

    var createDesc = _dereq_(92);

    module.exports = function (object, index, value) {
      if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
    };
  }, {
    "72": 72,
    "92": 92
  }],
  25: [function (_dereq_, module, exports) {
    // optional / simple context binding
    var aFunction = _dereq_(3);

    module.exports = function (fn, that, length) {
      aFunction(fn);
      if (that === undefined) return fn;

      switch (length) {
        case 1:
          return function (a) {
            return fn.call(that, a);
          };

        case 2:
          return function (a, b) {
            return fn.call(that, a, b);
          };

        case 3:
          return function (a, b, c) {
            return fn.call(that, a, b, c);
          };
      }

      return function ()
      /* ...args */
      {
        return fn.apply(that, arguments);
      };
    };
  }, {
    "3": 3
  }],
  26: [function (_dereq_, module, exports) {
    'use strict'; // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()

    var fails = _dereq_(35);

    var getTime = Date.prototype.getTime;
    var $toISOString = Date.prototype.toISOString;

    var lz = function lz(num) {
      return num > 9 ? num : '0' + num;
    }; // PhantomJS / old WebKit has a broken implementations


    module.exports = fails(function () {
      return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
    }) || !fails(function () {
      $toISOString.call(new Date(NaN));
    }) ? function toISOString() {
      if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
      var d = this;
      var y = d.getUTCFullYear();
      var m = d.getUTCMilliseconds();
      var s = y < 0 ? '-' : y > 9999 ? '+' : '';
      return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
    } : $toISOString;
  }, {
    "35": 35
  }],
  27: [function (_dereq_, module, exports) {
    'use strict';

    var anObject = _dereq_(7);

    var toPrimitive = _dereq_(120);

    var NUMBER = 'number';

    module.exports = function (hint) {
      if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
      return toPrimitive(anObject(this), hint != NUMBER);
    };
  }, {
    "120": 120,
    "7": 7
  }],
  28: [function (_dereq_, module, exports) {
    // 7.2.1 RequireObjectCoercible(argument)
    module.exports = function (it) {
      if (it == undefined) throw TypeError("Can't call method on  " + it);
      return it;
    };
  }, {}],
  29: [function (_dereq_, module, exports) {
    // Thank's IE8 for his funny defineProperty
    module.exports = !_dereq_(35)(function () {
      return Object.defineProperty({}, 'a', {
        get: function get() {
          return 7;
        }
      }).a != 7;
    });
  }, {
    "35": 35
  }],
  30: [function (_dereq_, module, exports) {
    var isObject = _dereq_(51);

    var document = _dereq_(40).document; // typeof document.createElement is 'object' in old IE


    var is = isObject(document) && isObject(document.createElement);

    module.exports = function (it) {
      return is ? document.createElement(it) : {};
    };
  }, {
    "40": 40,
    "51": 51
  }],
  31: [function (_dereq_, module, exports) {
    // IE 8- don't enum bug keys
    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
  }, {}],
  32: [function (_dereq_, module, exports) {
    // all enumerable object keys, includes symbols
    var getKeys = _dereq_(81);

    var gOPS = _dereq_(78);

    var pIE = _dereq_(82);

    module.exports = function (it) {
      var result = getKeys(it);
      var getSymbols = gOPS.f;

      if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = pIE.f;
        var i = 0;
        var key;

        while (symbols.length > i) {
          if (isEnum.call(it, key = symbols[i++])) result.push(key);
        }
      }

      return result;
    };
  }, {
    "78": 78,
    "81": 81,
    "82": 82
  }],
  33: [function (_dereq_, module, exports) {
    var global = _dereq_(40);

    var core = _dereq_(23);

    var hide = _dereq_(42);

    var redefine = _dereq_(94);

    var ctx = _dereq_(25);

    var PROTOTYPE = 'prototype';

    var $export = function $export(type, name, source) {
      var IS_FORCED = type & $export.F;
      var IS_GLOBAL = type & $export.G;
      var IS_STATIC = type & $export.S;
      var IS_PROTO = type & $export.P;
      var IS_BIND = type & $export.B;
      var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
      var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
      var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
      var key, own, out, exp;
      if (IS_GLOBAL) source = name;

      for (key in source) {
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

        out = (own ? target : source)[key]; // bind timers to global for call from export context

        exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

        if (target) redefine(target, key, out, type & $export.U); // export

        if (exports[key] != out) hide(exports, key, exp);
        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
      }
    };

    global.core = core; // type bitmap

    $export.F = 1; // forced

    $export.G = 2; // global

    $export.S = 4; // static

    $export.P = 8; // proto

    $export.B = 16; // bind

    $export.W = 32; // wrap

    $export.U = 64; // safe

    $export.R = 128; // real proto method for `library`

    module.exports = $export;
  }, {
    "23": 23,
    "25": 25,
    "40": 40,
    "42": 42,
    "94": 94
  }],
  34: [function (_dereq_, module, exports) {
    var MATCH = _dereq_(128)('match');

    module.exports = function (KEY) {
      var re = /./;

      try {
        '/./'[KEY](re);
      } catch (e) {
        try {
          re[MATCH] = false;
          return !'/./'[KEY](re);
        } catch (f) {
          /* empty */
        }
      }

      return true;
    };
  }, {
    "128": 128
  }],
  35: [function (_dereq_, module, exports) {
    module.exports = function (exec) {
      try {
        return !!exec();
      } catch (e) {
        return true;
      }
    };
  }, {}],
  36: [function (_dereq_, module, exports) {
    'use strict';

    var hide = _dereq_(42);

    var redefine = _dereq_(94);

    var fails = _dereq_(35);

    var defined = _dereq_(28);

    var wks = _dereq_(128);

    module.exports = function (KEY, length, exec) {
      var SYMBOL = wks(KEY);
      var fns = exec(defined, SYMBOL, ''[KEY]);
      var strfn = fns[0];
      var rxfn = fns[1];

      if (fails(function () {
        var O = {};

        O[SYMBOL] = function () {
          return 7;
        };

        return ''[KEY](O) != 7;
      })) {
        redefine(String.prototype, KEY, strfn);
        hide(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
        // 21.2.5.11 RegExp.prototype[@@split](string, limit)
        ? function (string, arg) {
          return rxfn.call(string, this, arg);
        } // 21.2.5.6 RegExp.prototype[@@match](string)
        // 21.2.5.9 RegExp.prototype[@@search](string)
        : function (string) {
          return rxfn.call(string, this);
        });
      }
    };
  }, {
    "128": 128,
    "28": 28,
    "35": 35,
    "42": 42,
    "94": 94
  }],
  37: [function (_dereq_, module, exports) {
    'use strict'; // 21.2.5.3 get RegExp.prototype.flags

    var anObject = _dereq_(7);

    module.exports = function () {
      var that = anObject(this);
      var result = '';
      if (that.global) result += 'g';
      if (that.ignoreCase) result += 'i';
      if (that.multiline) result += 'm';
      if (that.unicode) result += 'u';
      if (that.sticky) result += 'y';
      return result;
    };
  }, {
    "7": 7
  }],
  38: [function (_dereq_, module, exports) {
    'use strict'; // https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray

    var isArray = _dereq_(49);

    var isObject = _dereq_(51);

    var toLength = _dereq_(118);

    var ctx = _dereq_(25);

    var IS_CONCAT_SPREADABLE = _dereq_(128)('isConcatSpreadable');

    function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
      var targetIndex = start;
      var sourceIndex = 0;
      var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
      var element, spreadable;

      while (sourceIndex < sourceLen) {
        if (sourceIndex in source) {
          element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
          spreadable = false;

          if (isObject(element)) {
            spreadable = element[IS_CONCAT_SPREADABLE];
            spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
          }

          if (spreadable && depth > 0) {
            targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
          } else {
            if (targetIndex >= 0x1fffffffffffff) throw TypeError();
            target[targetIndex] = element;
          }

          targetIndex++;
        }

        sourceIndex++;
      }

      return targetIndex;
    }

    module.exports = flattenIntoArray;
  }, {
    "118": 118,
    "128": 128,
    "25": 25,
    "49": 49,
    "51": 51
  }],
  39: [function (_dereq_, module, exports) {
    var ctx = _dereq_(25);

    var call = _dereq_(53);

    var isArrayIter = _dereq_(48);

    var anObject = _dereq_(7);

    var toLength = _dereq_(118);

    var getIterFn = _dereq_(129);

    var BREAK = {};
    var RETURN = {};

    var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
      var iterFn = ITERATOR ? function () {
        return iterable;
      } : getIterFn(iterable);
      var f = ctx(fn, that, entries ? 2 : 1);
      var index = 0;
      var length, step, iterator, result;
      if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

      if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
        result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === BREAK || result === RETURN) return result;
      } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
        result = call(iterator, f, step.value, entries);
        if (result === BREAK || result === RETURN) return result;
      }
    };

    exports.BREAK = BREAK;
    exports.RETURN = RETURN;
  }, {
    "118": 118,
    "129": 129,
    "25": 25,
    "48": 48,
    "53": 53,
    "7": 7
  }],
  40: [function (_dereq_, module, exports) {
    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
    var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
    : Function('return this')();
    if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
  }, {}],
  41: [function (_dereq_, module, exports) {
    var hasOwnProperty = {}.hasOwnProperty;

    module.exports = function (it, key) {
      return hasOwnProperty.call(it, key);
    };
  }, {}],
  42: [function (_dereq_, module, exports) {
    var dP = _dereq_(72);

    var createDesc = _dereq_(92);

    module.exports = _dereq_(29) ? function (object, key, value) {
      return dP.f(object, key, createDesc(1, value));
    } : function (object, key, value) {
      object[key] = value;
      return object;
    };
  }, {
    "29": 29,
    "72": 72,
    "92": 92
  }],
  43: [function (_dereq_, module, exports) {
    var document = _dereq_(40).document;

    module.exports = document && document.documentElement;
  }, {
    "40": 40
  }],
  44: [function (_dereq_, module, exports) {
    module.exports = !_dereq_(29) && !_dereq_(35)(function () {
      return Object.defineProperty(_dereq_(30)('div'), 'a', {
        get: function get() {
          return 7;
        }
      }).a != 7;
    });
  }, {
    "29": 29,
    "30": 30,
    "35": 35
  }],
  45: [function (_dereq_, module, exports) {
    var isObject = _dereq_(51);

    var setPrototypeOf = _dereq_(99).set;

    module.exports = function (that, target, C) {
      var S = target.constructor;
      var P;

      if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
        setPrototypeOf(that, P);
      }

      return that;
    };
  }, {
    "51": 51,
    "99": 99
  }],
  46: [function (_dereq_, module, exports) {
    // fast apply, http://jsperf.lnkit.com/fast-apply/5
    module.exports = function (fn, args, that) {
      var un = that === undefined;

      switch (args.length) {
        case 0:
          return un ? fn() : fn.call(that);

        case 1:
          return un ? fn(args[0]) : fn.call(that, args[0]);

        case 2:
          return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

        case 3:
          return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

        case 4:
          return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
      }

      return fn.apply(that, args);
    };
  }, {}],
  47: [function (_dereq_, module, exports) {
    // fallback for non-array-like ES3 and non-enumerable old V8 strings
    var cof = _dereq_(18); // eslint-disable-next-line no-prototype-builtins


    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
      return cof(it) == 'String' ? it.split('') : Object(it);
    };
  }, {
    "18": 18
  }],
  48: [function (_dereq_, module, exports) {
    // check on default Array iterator
    var Iterators = _dereq_(58);

    var ITERATOR = _dereq_(128)('iterator');

    var ArrayProto = Array.prototype;

    module.exports = function (it) {
      return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
    };
  }, {
    "128": 128,
    "58": 58
  }],
  49: [function (_dereq_, module, exports) {
    // 7.2.2 IsArray(argument)
    var cof = _dereq_(18);

    module.exports = Array.isArray || function isArray(arg) {
      return cof(arg) == 'Array';
    };
  }, {
    "18": 18
  }],
  50: [function (_dereq_, module, exports) {
    // 20.1.2.3 Number.isInteger(number)
    var isObject = _dereq_(51);

    var floor = Math.floor;

    module.exports = function isInteger(it) {
      return !isObject(it) && isFinite(it) && floor(it) === it;
    };
  }, {
    "51": 51
  }],
  51: [function (_dereq_, module, exports) {
    module.exports = function (it) {
      return _typeof(it) === 'object' ? it !== null : typeof it === 'function';
    };
  }, {}],
  52: [function (_dereq_, module, exports) {
    // 7.2.8 IsRegExp(argument)
    var isObject = _dereq_(51);

    var cof = _dereq_(18);

    var MATCH = _dereq_(128)('match');

    module.exports = function (it) {
      var isRegExp;
      return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
    };
  }, {
    "128": 128,
    "18": 18,
    "51": 51
  }],
  53: [function (_dereq_, module, exports) {
    // call something on iterator step with safe closing on error
    var anObject = _dereq_(7);

    module.exports = function (iterator, fn, value, entries) {
      try {
        return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
      } catch (e) {
        var ret = iterator['return'];
        if (ret !== undefined) anObject(ret.call(iterator));
        throw e;
      }
    };
  }, {
    "7": 7
  }],
  54: [function (_dereq_, module, exports) {
    'use strict';

    var create = _dereq_(71);

    var descriptor = _dereq_(92);

    var setToStringTag = _dereq_(101);

    var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

    _dereq_(42)(IteratorPrototype, _dereq_(128)('iterator'), function () {
      return this;
    });

    module.exports = function (Constructor, NAME, next) {
      Constructor.prototype = create(IteratorPrototype, {
        next: descriptor(1, next)
      });
      setToStringTag(Constructor, NAME + ' Iterator');
    };
  }, {
    "101": 101,
    "128": 128,
    "42": 42,
    "71": 71,
    "92": 92
  }],
  55: [function (_dereq_, module, exports) {
    'use strict';

    var LIBRARY = _dereq_(60);

    var $export = _dereq_(33);

    var redefine = _dereq_(94);

    var hide = _dereq_(42);

    var has = _dereq_(41);

    var Iterators = _dereq_(58);

    var $iterCreate = _dereq_(54);

    var setToStringTag = _dereq_(101);

    var getPrototypeOf = _dereq_(79);

    var ITERATOR = _dereq_(128)('iterator');

    var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

    var FF_ITERATOR = '@@iterator';
    var KEYS = 'keys';
    var VALUES = 'values';

    var returnThis = function returnThis() {
      return this;
    };

    module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
      $iterCreate(Constructor, NAME, next);

      var getMethod = function getMethod(kind) {
        if (!BUGGY && kind in proto) return proto[kind];

        switch (kind) {
          case KEYS:
            return function keys() {
              return new Constructor(this, kind);
            };

          case VALUES:
            return function values() {
              return new Constructor(this, kind);
            };
        }

        return function entries() {
          return new Constructor(this, kind);
        };
      };

      var TAG = NAME + ' Iterator';
      var DEF_VALUES = DEFAULT == VALUES;
      var VALUES_BUG = false;
      var proto = Base.prototype;
      var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
      var $default = $native || getMethod(DEFAULT);
      var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
      var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
      var methods, key, IteratorPrototype; // Fix native

      if ($anyNative) {
        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
          // Set @@toStringTag to native iterators
          setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

          if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
        }
      } // fix Array#{values, @@iterator}.name in V8 / FF


      if (DEF_VALUES && $native && $native.name !== VALUES) {
        VALUES_BUG = true;

        $default = function values() {
          return $native.call(this);
        };
      } // Define iterator


      if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
        hide(proto, ITERATOR, $default);
      } // Plug for library


      Iterators[NAME] = $default;
      Iterators[TAG] = returnThis;

      if (DEFAULT) {
        methods = {
          values: DEF_VALUES ? $default : getMethod(VALUES),
          keys: IS_SET ? $default : getMethod(KEYS),
          entries: $entries
        };
        if (FORCED) for (key in methods) {
          if (!(key in proto)) redefine(proto, key, methods[key]);
        } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
      }

      return methods;
    };
  }, {
    "101": 101,
    "128": 128,
    "33": 33,
    "41": 41,
    "42": 42,
    "54": 54,
    "58": 58,
    "60": 60,
    "79": 79,
    "94": 94
  }],
  56: [function (_dereq_, module, exports) {
    var ITERATOR = _dereq_(128)('iterator');

    var SAFE_CLOSING = false;

    try {
      var riter = [7][ITERATOR]();

      riter['return'] = function () {
        SAFE_CLOSING = true;
      }; // eslint-disable-next-line no-throw-literal


      Array.from(riter, function () {
        throw 2;
      });
    } catch (e) {
      /* empty */
    }

    module.exports = function (exec, skipClosing) {
      if (!skipClosing && !SAFE_CLOSING) return false;
      var safe = false;

      try {
        var arr = [7];
        var iter = arr[ITERATOR]();

        iter.next = function () {
          return {
            done: safe = true
          };
        };

        arr[ITERATOR] = function () {
          return iter;
        };

        exec(arr);
      } catch (e) {
        /* empty */
      }

      return safe;
    };
  }, {
    "128": 128
  }],
  57: [function (_dereq_, module, exports) {
    module.exports = function (done, value) {
      return {
        value: value,
        done: !!done
      };
    };
  }, {}],
  58: [function (_dereq_, module, exports) {
    module.exports = {};
  }, {}],
  59: [function (_dereq_, module, exports) {
    var getKeys = _dereq_(81);

    var toIObject = _dereq_(117);

    module.exports = function (object, el) {
      var O = toIObject(object);
      var keys = getKeys(O);
      var length = keys.length;
      var index = 0;
      var key;

      while (length > index) {
        if (O[key = keys[index++]] === el) return key;
      }
    };
  }, {
    "117": 117,
    "81": 81
  }],
  60: [function (_dereq_, module, exports) {
    module.exports = false;
  }, {}],
  61: [function (_dereq_, module, exports) {
    // 20.2.2.14 Math.expm1(x)
    var $expm1 = Math.expm1;
    module.exports = !$expm1 // Old FF bug
    || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168 // Tor Browser bug
    || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
      return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
    } : $expm1;
  }, {}],
  62: [function (_dereq_, module, exports) {
    // 20.2.2.16 Math.fround(x)
    var sign = _dereq_(65);

    var pow = Math.pow;
    var EPSILON = pow(2, -52);
    var EPSILON32 = pow(2, -23);
    var MAX32 = pow(2, 127) * (2 - EPSILON32);
    var MIN32 = pow(2, -126);

    var roundTiesToEven = function roundTiesToEven(n) {
      return n + 1 / EPSILON - 1 / EPSILON;
    };

    module.exports = Math.fround || function fround(x) {
      var $abs = Math.abs(x);
      var $sign = sign(x);
      var a, result;
      if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
      a = (1 + EPSILON32 / EPSILON) * $abs;
      result = a - (a - $abs); // eslint-disable-next-line no-self-compare

      if (result > MAX32 || result != result) return $sign * Infinity;
      return $sign * result;
    };
  }, {
    "65": 65
  }],
  63: [function (_dereq_, module, exports) {
    // 20.2.2.20 Math.log1p(x)
    module.exports = Math.log1p || function log1p(x) {
      return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
    };
  }, {}],
  64: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
      if (arguments.length === 0 // eslint-disable-next-line no-self-compare
      || x != x // eslint-disable-next-line no-self-compare
      || inLow != inLow // eslint-disable-next-line no-self-compare
      || inHigh != inHigh // eslint-disable-next-line no-self-compare
      || outLow != outLow // eslint-disable-next-line no-self-compare
      || outHigh != outHigh) return NaN;
      if (x === Infinity || x === -Infinity) return x;
      return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
    };
  }, {}],
  65: [function (_dereq_, module, exports) {
    // 20.2.2.28 Math.sign(x)
    module.exports = Math.sign || function sign(x) {
      // eslint-disable-next-line no-self-compare
      return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
    };
  }, {}],
  66: [function (_dereq_, module, exports) {
    var META = _dereq_(124)('meta');

    var isObject = _dereq_(51);

    var has = _dereq_(41);

    var setDesc = _dereq_(72).f;

    var id = 0;

    var isExtensible = Object.isExtensible || function () {
      return true;
    };

    var FREEZE = !_dereq_(35)(function () {
      return isExtensible(Object.preventExtensions({}));
    });

    var setMeta = function setMeta(it) {
      setDesc(it, META, {
        value: {
          i: 'O' + ++id,
          // object ID
          w: {} // weak collections IDs

        }
      });
    };

    var fastKey = function fastKey(it, create) {
      // return primitive with prefix
      if (!isObject(it)) return _typeof(it) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

      if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return 'F'; // not necessary to add metadata

        if (!create) return 'E'; // add missing metadata

        setMeta(it); // return object ID
      }

      return it[META].i;
    };

    var getWeak = function getWeak(it, create) {
      if (!has(it, META)) {
        // can't set metadata to uncaught frozen object
        if (!isExtensible(it)) return true; // not necessary to add metadata

        if (!create) return false; // add missing metadata

        setMeta(it); // return hash weak collections IDs
      }

      return it[META].w;
    }; // add metadata on freeze-family methods calling


    var onFreeze = function onFreeze(it) {
      if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
      return it;
    };

    var meta = module.exports = {
      KEY: META,
      NEED: false,
      fastKey: fastKey,
      getWeak: getWeak,
      onFreeze: onFreeze
    };
  }, {
    "124": 124,
    "35": 35,
    "41": 41,
    "51": 51,
    "72": 72
  }],
  67: [function (_dereq_, module, exports) {
    var Map = _dereq_(160);

    var $export = _dereq_(33);

    var shared = _dereq_(103)('metadata');

    var store = shared.store || (shared.store = new (_dereq_(266))());

    var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
      var targetMetadata = store.get(target);

      if (!targetMetadata) {
        if (!create) return undefined;
        store.set(target, targetMetadata = new Map());
      }

      var keyMetadata = targetMetadata.get(targetKey);

      if (!keyMetadata) {
        if (!create) return undefined;
        targetMetadata.set(targetKey, keyMetadata = new Map());
      }

      return keyMetadata;
    };

    var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
      var metadataMap = getOrCreateMetadataMap(O, P, false);
      return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
    };

    var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
      var metadataMap = getOrCreateMetadataMap(O, P, false);
      return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
    };

    var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
      getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
    };

    var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
      var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
      var keys = [];
      if (metadataMap) metadataMap.forEach(function (_, key) {
        keys.push(key);
      });
      return keys;
    };

    var toMetaKey = function toMetaKey(it) {
      return it === undefined || _typeof(it) == 'symbol' ? it : String(it);
    };

    var exp = function exp(O) {
      $export($export.S, 'Reflect', O);
    };

    module.exports = {
      store: store,
      map: getOrCreateMetadataMap,
      has: ordinaryHasOwnMetadata,
      get: ordinaryGetOwnMetadata,
      set: ordinaryDefineOwnMetadata,
      keys: ordinaryOwnMetadataKeys,
      key: toMetaKey,
      exp: exp
    };
  }, {
    "103": 103,
    "160": 160,
    "266": 266,
    "33": 33
  }],
  68: [function (_dereq_, module, exports) {
    var global = _dereq_(40);

    var macrotask = _dereq_(113).set;

    var Observer = global.MutationObserver || global.WebKitMutationObserver;
    var process = global.process;
    var Promise = global.Promise;
    var isNode = _dereq_(18)(process) == 'process';

    module.exports = function () {
      var head, last, notify;

      var flush = function flush() {
        var parent, fn;
        if (isNode && (parent = process.domain)) parent.exit();

        while (head) {
          fn = head.fn;
          head = head.next;

          try {
            fn();
          } catch (e) {
            if (head) notify();else last = undefined;
            throw e;
          }
        }

        last = undefined;
        if (parent) parent.enter();
      }; // Node.js


      if (isNode) {
        notify = function notify() {
          process.nextTick(flush);
        }; // browsers with MutationObserver

      } else if (Observer) {
        var toggle = true;
        var node = document.createTextNode('');
        new Observer(flush).observe(node, {
          characterData: true
        }); // eslint-disable-line no-new

        notify = function notify() {
          node.data = toggle = !toggle;
        }; // environments with maybe non-completely correct, but existent Promise

      } else if (Promise && Promise.resolve) {
        var promise = Promise.resolve();

        notify = function notify() {
          promise.then(flush);
        }; // for other environments - macrotask based on:
        // - setImmediate
        // - MessageChannel
        // - window.postMessag
        // - onreadystatechange
        // - setTimeout

      } else {
        notify = function notify() {
          // strange IE + webpack dev server bug - use .call(global)
          macrotask.call(global, flush);
        };
      }

      return function (fn) {
        var task = {
          fn: fn,
          next: undefined
        };
        if (last) last.next = task;

        if (!head) {
          head = task;
          notify();
        }

        last = task;
      };
    };
  }, {
    "113": 113,
    "18": 18,
    "40": 40
  }],
  69: [function (_dereq_, module, exports) {
    'use strict'; // 25.4.1.5 NewPromiseCapability(C)

    var aFunction = _dereq_(3);

    function PromiseCapability(C) {
      var resolve, reject;
      this.promise = new C(function ($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
        resolve = $$resolve;
        reject = $$reject;
      });
      this.resolve = aFunction(resolve);
      this.reject = aFunction(reject);
    }

    module.exports.f = function (C) {
      return new PromiseCapability(C);
    };
  }, {
    "3": 3
  }],
  70: [function (_dereq_, module, exports) {
    'use strict'; // 19.1.2.1 Object.assign(target, source, ...)

    var getKeys = _dereq_(81);

    var gOPS = _dereq_(78);

    var pIE = _dereq_(82);

    var toObject = _dereq_(119);

    var IObject = _dereq_(47);

    var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

    module.exports = !$assign || _dereq_(35)(function () {
      var A = {};
      var B = {}; // eslint-disable-next-line no-undef

      var S = Symbol();
      var K = 'abcdefghijklmnopqrst';
      A[S] = 7;
      K.split('').forEach(function (k) {
        B[k] = k;
      });
      return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
    }) ? function assign(target, source) {
      // eslint-disable-line no-unused-vars
      var T = toObject(target);
      var aLen = arguments.length;
      var index = 1;
      var getSymbols = gOPS.f;
      var isEnum = pIE.f;

      while (aLen > index) {
        var S = IObject(arguments[index++]);
        var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
        var length = keys.length;
        var j = 0;
        var key;

        while (length > j) {
          if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
        }
      }

      return T;
    } : $assign;
  }, {
    "119": 119,
    "35": 35,
    "47": 47,
    "78": 78,
    "81": 81,
    "82": 82
  }],
  71: [function (_dereq_, module, exports) {
    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
    var anObject = _dereq_(7);

    var dPs = _dereq_(73);

    var enumBugKeys = _dereq_(31);

    var IE_PROTO = _dereq_(102)('IE_PROTO');

    var Empty = function Empty() {
      /* empty */
    };

    var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

    var _createDict = function createDict() {
      // Thrash, waste and sodomy: IE GC bug
      var iframe = _dereq_(30)('iframe');

      var i = enumBugKeys.length;
      var lt = '<';
      var gt = '>';
      var iframeDocument;
      iframe.style.display = 'none';

      _dereq_(43).appendChild(iframe);

      iframe.src = 'javascript:'; // eslint-disable-line no-script-url
      // createDict = iframe.contentWindow.Object;
      // html.removeChild(iframe);

      iframeDocument = iframe.contentWindow.document;
      iframeDocument.open();
      iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
      iframeDocument.close();
      _createDict = iframeDocument.F;

      while (i--) {
        delete _createDict[PROTOTYPE][enumBugKeys[i]];
      }

      return _createDict();
    };

    module.exports = Object.create || function create(O, Properties) {
      var result;

      if (O !== null) {
        Empty[PROTOTYPE] = anObject(O);
        result = new Empty();
        Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

        result[IE_PROTO] = O;
      } else result = _createDict();

      return Properties === undefined ? result : dPs(result, Properties);
    };
  }, {
    "102": 102,
    "30": 30,
    "31": 31,
    "43": 43,
    "7": 7,
    "73": 73
  }],
  72: [function (_dereq_, module, exports) {
    var anObject = _dereq_(7);

    var IE8_DOM_DEFINE = _dereq_(44);

    var toPrimitive = _dereq_(120);

    var dP = Object.defineProperty;
    exports.f = _dereq_(29) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
      anObject(O);
      P = toPrimitive(P, true);
      anObject(Attributes);
      if (IE8_DOM_DEFINE) try {
        return dP(O, P, Attributes);
      } catch (e) {
        /* empty */
      }
      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
      if ('value' in Attributes) O[P] = Attributes.value;
      return O;
    };
  }, {
    "120": 120,
    "29": 29,
    "44": 44,
    "7": 7
  }],
  73: [function (_dereq_, module, exports) {
    var dP = _dereq_(72);

    var anObject = _dereq_(7);

    var getKeys = _dereq_(81);

    module.exports = _dereq_(29) ? Object.defineProperties : function defineProperties(O, Properties) {
      anObject(O);
      var keys = getKeys(Properties);
      var length = keys.length;
      var i = 0;
      var P;

      while (length > i) {
        dP.f(O, P = keys[i++], Properties[P]);
      }

      return O;
    };
  }, {
    "29": 29,
    "7": 7,
    "72": 72,
    "81": 81
  }],
  74: [function (_dereq_, module, exports) {
    'use strict'; // Forced replacement prototype accessors methods

    module.exports = _dereq_(60) || !_dereq_(35)(function () {
      var K = Math.random(); // In FF throws only define methods
      // eslint-disable-next-line no-undef, no-useless-call

      __defineSetter__.call(null, K, function () {
        /* empty */
      });

      delete _dereq_(40)[K];
    });
  }, {
    "35": 35,
    "40": 40,
    "60": 60
  }],
  75: [function (_dereq_, module, exports) {
    var pIE = _dereq_(82);

    var createDesc = _dereq_(92);

    var toIObject = _dereq_(117);

    var toPrimitive = _dereq_(120);

    var has = _dereq_(41);

    var IE8_DOM_DEFINE = _dereq_(44);

    var gOPD = Object.getOwnPropertyDescriptor;
    exports.f = _dereq_(29) ? gOPD : function getOwnPropertyDescriptor(O, P) {
      O = toIObject(O);
      P = toPrimitive(P, true);
      if (IE8_DOM_DEFINE) try {
        return gOPD(O, P);
      } catch (e) {
        /* empty */
      }
      if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
    };
  }, {
    "117": 117,
    "120": 120,
    "29": 29,
    "41": 41,
    "44": 44,
    "82": 82,
    "92": 92
  }],
  76: [function (_dereq_, module, exports) {
    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
    var toIObject = _dereq_(117);

    var gOPN = _dereq_(77).f;

    var toString = {}.toString;
    var windowNames = (typeof window === "undefined" ? "undefined" : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

    var getWindowNames = function getWindowNames(it) {
      try {
        return gOPN(it);
      } catch (e) {
        return windowNames.slice();
      }
    };

    module.exports.f = function getOwnPropertyNames(it) {
      return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
    };
  }, {
    "117": 117,
    "77": 77
  }],
  77: [function (_dereq_, module, exports) {
    // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
    var $keys = _dereq_(80);

    var hiddenKeys = _dereq_(31).concat('length', 'prototype');

    exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
      return $keys(O, hiddenKeys);
    };
  }, {
    "31": 31,
    "80": 80
  }],
  78: [function (_dereq_, module, exports) {
    exports.f = Object.getOwnPropertySymbols;
  }, {}],
  79: [function (_dereq_, module, exports) {
    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
    var has = _dereq_(41);

    var toObject = _dereq_(119);

    var IE_PROTO = _dereq_(102)('IE_PROTO');

    var ObjectProto = Object.prototype;

    module.exports = Object.getPrototypeOf || function (O) {
      O = toObject(O);
      if (has(O, IE_PROTO)) return O[IE_PROTO];

      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
        return O.constructor.prototype;
      }

      return O instanceof Object ? ObjectProto : null;
    };
  }, {
    "102": 102,
    "119": 119,
    "41": 41
  }],
  80: [function (_dereq_, module, exports) {
    var has = _dereq_(41);

    var toIObject = _dereq_(117);

    var arrayIndexOf = _dereq_(11)(false);

    var IE_PROTO = _dereq_(102)('IE_PROTO');

    module.exports = function (object, names) {
      var O = toIObject(object);
      var i = 0;
      var result = [];
      var key;

      for (key in O) {
        if (key != IE_PROTO) has(O, key) && result.push(key);
      } // Don't enum bug & hidden keys


      while (names.length > i) {
        if (has(O, key = names[i++])) {
          ~arrayIndexOf(result, key) || result.push(key);
        }
      }

      return result;
    };
  }, {
    "102": 102,
    "11": 11,
    "117": 117,
    "41": 41
  }],
  81: [function (_dereq_, module, exports) {
    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
    var $keys = _dereq_(80);

    var enumBugKeys = _dereq_(31);

    module.exports = Object.keys || function keys(O) {
      return $keys(O, enumBugKeys);
    };
  }, {
    "31": 31,
    "80": 80
  }],
  82: [function (_dereq_, module, exports) {
    exports.f = {}.propertyIsEnumerable;
  }, {}],
  83: [function (_dereq_, module, exports) {
    // most Object methods by ES6 should accept primitives
    var $export = _dereq_(33);

    var core = _dereq_(23);

    var fails = _dereq_(35);

    module.exports = function (KEY, exec) {
      var fn = (core.Object || {})[KEY] || Object[KEY];
      var exp = {};
      exp[KEY] = exec(fn);
      $export($export.S + $export.F * fails(function () {
        fn(1);
      }), 'Object', exp);
    };
  }, {
    "23": 23,
    "33": 33,
    "35": 35
  }],
  84: [function (_dereq_, module, exports) {
    var getKeys = _dereq_(81);

    var toIObject = _dereq_(117);

    var isEnum = _dereq_(82).f;

    module.exports = function (isEntries) {
      return function (it) {
        var O = toIObject(it);
        var keys = getKeys(O);
        var length = keys.length;
        var i = 0;
        var result = [];
        var key;

        while (length > i) {
          if (isEnum.call(O, key = keys[i++])) {
            result.push(isEntries ? [key, O[key]] : O[key]);
          }
        }

        return result;
      };
    };
  }, {
    "117": 117,
    "81": 81,
    "82": 82
  }],
  85: [function (_dereq_, module, exports) {
    // all object keys, includes non-enumerable and symbols
    var gOPN = _dereq_(77);

    var gOPS = _dereq_(78);

    var anObject = _dereq_(7);

    var Reflect = _dereq_(40).Reflect;

    module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
      var keys = gOPN.f(anObject(it));
      var getSymbols = gOPS.f;
      return getSymbols ? keys.concat(getSymbols(it)) : keys;
    };
  }, {
    "40": 40,
    "7": 7,
    "77": 77,
    "78": 78
  }],
  86: [function (_dereq_, module, exports) {
    var $parseFloat = _dereq_(40).parseFloat;

    var $trim = _dereq_(111).trim;

    module.exports = 1 / $parseFloat(_dereq_(112) + '-0') !== -Infinity ? function parseFloat(str) {
      var string = $trim(String(str), 3);
      var result = $parseFloat(string);
      return result === 0 && string.charAt(0) == '-' ? -0 : result;
    } : $parseFloat;
  }, {
    "111": 111,
    "112": 112,
    "40": 40
  }],
  87: [function (_dereq_, module, exports) {
    var $parseInt = _dereq_(40).parseInt;

    var $trim = _dereq_(111).trim;

    var ws = _dereq_(112);

    var hex = /^[-+]?0[xX]/;
    module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
      var string = $trim(String(str), 3);
      return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
    } : $parseInt;
  }, {
    "111": 111,
    "112": 112,
    "40": 40
  }],
  88: [function (_dereq_, module, exports) {
    'use strict';

    var path = _dereq_(89);

    var invoke = _dereq_(46);

    var aFunction = _dereq_(3);

    module.exports = function ()
    /* ...pargs */
    {
      var fn = aFunction(this);
      var length = arguments.length;
      var pargs = Array(length);
      var i = 0;
      var _ = path._;
      var holder = false;

      while (length > i) {
        if ((pargs[i] = arguments[i++]) === _) holder = true;
      }

      return function ()
      /* ...args */
      {
        var that = this;
        var aLen = arguments.length;
        var j = 0;
        var k = 0;
        var args;
        if (!holder && !aLen) return invoke(fn, pargs, that);
        args = pargs.slice();
        if (holder) for (; length > j; j++) {
          if (args[j] === _) args[j] = arguments[k++];
        }

        while (aLen > k) {
          args.push(arguments[k++]);
        }

        return invoke(fn, args, that);
      };
    };
  }, {
    "3": 3,
    "46": 46,
    "89": 89
  }],
  89: [function (_dereq_, module, exports) {
    module.exports = _dereq_(40);
  }, {
    "40": 40
  }],
  90: [function (_dereq_, module, exports) {
    module.exports = function (exec) {
      try {
        return {
          e: false,
          v: exec()
        };
      } catch (e) {
        return {
          e: true,
          v: e
        };
      }
    };
  }, {}],
  91: [function (_dereq_, module, exports) {
    var newPromiseCapability = _dereq_(69);

    module.exports = function (C, x) {
      var promiseCapability = newPromiseCapability.f(C);
      var resolve = promiseCapability.resolve;
      resolve(x);
      return promiseCapability.promise;
    };
  }, {
    "69": 69
  }],
  92: [function (_dereq_, module, exports) {
    module.exports = function (bitmap, value) {
      return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
      };
    };
  }, {}],
  93: [function (_dereq_, module, exports) {
    var redefine = _dereq_(94);

    module.exports = function (target, src, safe) {
      for (var key in src) {
        redefine(target, key, src[key], safe);
      }

      return target;
    };
  }, {
    "94": 94
  }],
  94: [function (_dereq_, module, exports) {
    var global = _dereq_(40);

    var hide = _dereq_(42);

    var has = _dereq_(41);

    var SRC = _dereq_(124)('src');

    var TO_STRING = 'toString';
    var $toString = Function[TO_STRING];
    var TPL = ('' + $toString).split(TO_STRING);

    _dereq_(23).inspectSource = function (it) {
      return $toString.call(it);
    };

    (module.exports = function (O, key, val, safe) {
      var isFunction = typeof val == 'function';
      if (isFunction) has(val, 'name') || hide(val, 'name', key);
      if (O[key] === val) return;
      if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

      if (O === global) {
        O[key] = val;
      } else if (!safe) {
        delete O[key];
        hide(O, key, val);
      } else if (O[key]) {
        O[key] = val;
      } else {
        hide(O, key, val);
      } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

    })(Function.prototype, TO_STRING, function toString() {
      return typeof this == 'function' && this[SRC] || $toString.call(this);
    });
  }, {
    "124": 124,
    "23": 23,
    "40": 40,
    "41": 41,
    "42": 42
  }],
  95: [function (_dereq_, module, exports) {
    module.exports = function (regExp, replace) {
      var replacer = replace === Object(replace) ? function (part) {
        return replace[part];
      } : replace;
      return function (it) {
        return String(it).replace(regExp, replacer);
      };
    };
  }, {}],
  96: [function (_dereq_, module, exports) {
    // 7.2.9 SameValue(x, y)
    module.exports = Object.is || function is(x, y) {
      // eslint-disable-next-line no-self-compare
      return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
    };
  }, {}],
  97: [function (_dereq_, module, exports) {
    'use strict'; // https://tc39.github.io/proposal-setmap-offrom/

    var $export = _dereq_(33);

    var aFunction = _dereq_(3);

    var ctx = _dereq_(25);

    var forOf = _dereq_(39);

    module.exports = function (COLLECTION) {
      $export($export.S, COLLECTION, {
        from: function from(source
        /* , mapFn, thisArg */
        ) {
          var mapFn = arguments[1];
          var mapping, A, n, cb;
          aFunction(this);
          mapping = mapFn !== undefined;
          if (mapping) aFunction(mapFn);
          if (source == undefined) return new this();
          A = [];

          if (mapping) {
            n = 0;
            cb = ctx(mapFn, arguments[2], 2);
            forOf(source, false, function (nextItem) {
              A.push(cb(nextItem, n++));
            });
          } else {
            forOf(source, false, A.push, A);
          }

          return new this(A);
        }
      });
    };
  }, {
    "25": 25,
    "3": 3,
    "33": 33,
    "39": 39
  }],
  98: [function (_dereq_, module, exports) {
    'use strict'; // https://tc39.github.io/proposal-setmap-offrom/

    var $export = _dereq_(33);

    module.exports = function (COLLECTION) {
      $export($export.S, COLLECTION, {
        of: function of() {
          var length = arguments.length;
          var A = Array(length);

          while (length--) {
            A[length] = arguments[length];
          }

          return new this(A);
        }
      });
    };
  }, {
    "33": 33
  }],
  99: [function (_dereq_, module, exports) {
    // Works with __proto__ only. Old v8 can't work with null proto objects.

    /* eslint-disable no-proto */
    var isObject = _dereq_(51);

    var anObject = _dereq_(7);

    var check = function check(O, proto) {
      anObject(O);
      if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
    };

    module.exports = {
      set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
      function (test, buggy, set) {
        try {
          set = _dereq_(25)(Function.call, _dereq_(75).f(Object.prototype, '__proto__').set, 2);
          set(test, []);
          buggy = !(test instanceof Array);
        } catch (e) {
          buggy = true;
        }

        return function setPrototypeOf(O, proto) {
          check(O, proto);
          if (buggy) O.__proto__ = proto;else set(O, proto);
          return O;
        };
      }({}, false) : undefined),
      check: check
    };
  }, {
    "25": 25,
    "51": 51,
    "7": 7,
    "75": 75
  }],
  100: [function (_dereq_, module, exports) {
    'use strict';

    var global = _dereq_(40);

    var dP = _dereq_(72);

    var DESCRIPTORS = _dereq_(29);

    var SPECIES = _dereq_(128)('species');

    module.exports = function (KEY) {
      var C = global[KEY];
      if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
        configurable: true,
        get: function get() {
          return this;
        }
      });
    };
  }, {
    "128": 128,
    "29": 29,
    "40": 40,
    "72": 72
  }],
  101: [function (_dereq_, module, exports) {
    var def = _dereq_(72).f;

    var has = _dereq_(41);

    var TAG = _dereq_(128)('toStringTag');

    module.exports = function (it, tag, stat) {
      if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
        configurable: true,
        value: tag
      });
    };
  }, {
    "128": 128,
    "41": 41,
    "72": 72
  }],
  102: [function (_dereq_, module, exports) {
    var shared = _dereq_(103)('keys');

    var uid = _dereq_(124);

    module.exports = function (key) {
      return shared[key] || (shared[key] = uid(key));
    };
  }, {
    "103": 103,
    "124": 124
  }],
  103: [function (_dereq_, module, exports) {
    var global = _dereq_(40);

    var SHARED = '__core-js_shared__';
    var store = global[SHARED] || (global[SHARED] = {});

    module.exports = function (key) {
      return store[key] || (store[key] = {});
    };
  }, {
    "40": 40
  }],
  104: [function (_dereq_, module, exports) {
    // 7.3.20 SpeciesConstructor(O, defaultConstructor)
    var anObject = _dereq_(7);

    var aFunction = _dereq_(3);

    var SPECIES = _dereq_(128)('species');

    module.exports = function (O, D) {
      var C = anObject(O).constructor;
      var S;
      return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
    };
  }, {
    "128": 128,
    "3": 3,
    "7": 7
  }],
  105: [function (_dereq_, module, exports) {
    'use strict';

    var fails = _dereq_(35);

    module.exports = function (method, arg) {
      return !!method && fails(function () {
        // eslint-disable-next-line no-useless-call
        arg ? method.call(null, function () {
          /* empty */
        }, 1) : method.call(null);
      });
    };
  }, {
    "35": 35
  }],
  106: [function (_dereq_, module, exports) {
    var toInteger = _dereq_(116);

    var defined = _dereq_(28); // true  -> String#at
    // false -> String#codePointAt


    module.exports = function (TO_STRING) {
      return function (that, pos) {
        var s = String(defined(that));
        var i = toInteger(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
      };
    };
  }, {
    "116": 116,
    "28": 28
  }],
  107: [function (_dereq_, module, exports) {
    // helper for String#{startsWith, endsWith, includes}
    var isRegExp = _dereq_(52);

    var defined = _dereq_(28);

    module.exports = function (that, searchString, NAME) {
      if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
      return String(defined(that));
    };
  }, {
    "28": 28,
    "52": 52
  }],
  108: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var fails = _dereq_(35);

    var defined = _dereq_(28);

    var quot = /"/g; // B.2.3.2.1 CreateHTML(string, tag, attribute, value)

    var createHTML = function createHTML(string, tag, attribute, value) {
      var S = String(defined(string));
      var p1 = '<' + tag;
      if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
      return p1 + '>' + S + '</' + tag + '>';
    };

    module.exports = function (NAME, exec) {
      var O = {};
      O[NAME] = exec(createHTML);
      $export($export.P + $export.F * fails(function () {
        var test = ''[NAME]('"');
        return test !== test.toLowerCase() || test.split('"').length > 3;
      }), 'String', O);
    };
  }, {
    "28": 28,
    "33": 33,
    "35": 35
  }],
  109: [function (_dereq_, module, exports) {
    // https://github.com/tc39/proposal-string-pad-start-end
    var toLength = _dereq_(118);

    var repeat = _dereq_(110);

    var defined = _dereq_(28);

    module.exports = function (that, maxLength, fillString, left) {
      var S = String(defined(that));
      var stringLength = S.length;
      var fillStr = fillString === undefined ? ' ' : String(fillString);
      var intMaxLength = toLength(maxLength);
      if (intMaxLength <= stringLength || fillStr == '') return S;
      var fillLen = intMaxLength - stringLength;
      var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
      if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
      return left ? stringFiller + S : S + stringFiller;
    };
  }, {
    "110": 110,
    "118": 118,
    "28": 28
  }],
  110: [function (_dereq_, module, exports) {
    'use strict';

    var toInteger = _dereq_(116);

    var defined = _dereq_(28);

    module.exports = function repeat(count) {
      var str = String(defined(this));
      var res = '';
      var n = toInteger(count);
      if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");

      for (; n > 0; (n >>>= 1) && (str += str)) {
        if (n & 1) res += str;
      }

      return res;
    };
  }, {
    "116": 116,
    "28": 28
  }],
  111: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var defined = _dereq_(28);

    var fails = _dereq_(35);

    var spaces = _dereq_(112);

    var space = '[' + spaces + ']';
    var non = "\u200B\x85";
    var ltrim = RegExp('^' + space + space + '*');
    var rtrim = RegExp(space + space + '*$');

    var exporter = function exporter(KEY, exec, ALIAS) {
      var exp = {};
      var FORCE = fails(function () {
        return !!spaces[KEY]() || non[KEY]() != non;
      });
      var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
      if (ALIAS) exp[ALIAS] = fn;
      $export($export.P + $export.F * FORCE, 'String', exp);
    }; // 1 -> String#trimLeft
    // 2 -> String#trimRight
    // 3 -> String#trim


    var trim = exporter.trim = function (string, TYPE) {
      string = String(defined(string));
      if (TYPE & 1) string = string.replace(ltrim, '');
      if (TYPE & 2) string = string.replace(rtrim, '');
      return string;
    };

    module.exports = exporter;
  }, {
    "112": 112,
    "28": 28,
    "33": 33,
    "35": 35
  }],
  112: [function (_dereq_, module, exports) {
    module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, {}],
  113: [function (_dereq_, module, exports) {
    var ctx = _dereq_(25);

    var invoke = _dereq_(46);

    var html = _dereq_(43);

    var cel = _dereq_(30);

    var global = _dereq_(40);

    var process = global.process;
    var setTask = global.setImmediate;
    var clearTask = global.clearImmediate;
    var MessageChannel = global.MessageChannel;
    var Dispatch = global.Dispatch;
    var counter = 0;
    var queue = {};
    var ONREADYSTATECHANGE = 'onreadystatechange';
    var defer, channel, port;

    var run = function run() {
      var id = +this; // eslint-disable-next-line no-prototype-builtins

      if (queue.hasOwnProperty(id)) {
        var fn = queue[id];
        delete queue[id];
        fn();
      }
    };

    var listener = function listener(event) {
      run.call(event.data);
    }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


    if (!setTask || !clearTask) {
      setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;

        while (arguments.length > i) {
          args.push(arguments[i++]);
        }

        queue[++counter] = function () {
          // eslint-disable-next-line no-new-func
          invoke(typeof fn == 'function' ? fn : Function(fn), args);
        };

        defer(counter);
        return counter;
      };

      clearTask = function clearImmediate(id) {
        delete queue[id];
      }; // Node.js 0.8-


      if (_dereq_(18)(process) == 'process') {
        defer = function defer(id) {
          process.nextTick(ctx(run, id, 1));
        }; // Sphere (JS game engine) Dispatch API

      } else if (Dispatch && Dispatch.now) {
        defer = function defer(id) {
          Dispatch.now(ctx(run, id, 1));
        }; // Browsers with MessageChannel, includes WebWorkers

      } else if (MessageChannel) {
        channel = new MessageChannel();
        port = channel.port2;
        channel.port1.onmessage = listener;
        defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
      } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
        defer = function defer(id) {
          global.postMessage(id + '', '*');
        };

        global.addEventListener('message', listener, false); // IE8-
      } else if (ONREADYSTATECHANGE in cel('script')) {
        defer = function defer(id) {
          html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
            html.removeChild(this);
            run.call(id);
          };
        }; // Rest old browsers

      } else {
        defer = function defer(id) {
          setTimeout(ctx(run, id, 1), 0);
        };
      }
    }

    module.exports = {
      set: setTask,
      clear: clearTask
    };
  }, {
    "18": 18,
    "25": 25,
    "30": 30,
    "40": 40,
    "43": 43,
    "46": 46
  }],
  114: [function (_dereq_, module, exports) {
    var toInteger = _dereq_(116);

    var max = Math.max;
    var min = Math.min;

    module.exports = function (index, length) {
      index = toInteger(index);
      return index < 0 ? max(index + length, 0) : min(index, length);
    };
  }, {
    "116": 116
  }],
  115: [function (_dereq_, module, exports) {
    // https://tc39.github.io/ecma262/#sec-toindex
    var toInteger = _dereq_(116);

    var toLength = _dereq_(118);

    module.exports = function (it) {
      if (it === undefined) return 0;
      var number = toInteger(it);
      var length = toLength(number);
      if (number !== length) throw RangeError('Wrong length!');
      return length;
    };
  }, {
    "116": 116,
    "118": 118
  }],
  116: [function (_dereq_, module, exports) {
    // 7.1.4 ToInteger
    var ceil = Math.ceil;
    var floor = Math.floor;

    module.exports = function (it) {
      return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
    };
  }, {}],
  117: [function (_dereq_, module, exports) {
    // to indexed object, toObject with fallback for non-array-like ES3 strings
    var IObject = _dereq_(47);

    var defined = _dereq_(28);

    module.exports = function (it) {
      return IObject(defined(it));
    };
  }, {
    "28": 28,
    "47": 47
  }],
  118: [function (_dereq_, module, exports) {
    // 7.1.15 ToLength
    var toInteger = _dereq_(116);

    var min = Math.min;

    module.exports = function (it) {
      return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
    };
  }, {
    "116": 116
  }],
  119: [function (_dereq_, module, exports) {
    // 7.1.13 ToObject(argument)
    var defined = _dereq_(28);

    module.exports = function (it) {
      return Object(defined(it));
    };
  }, {
    "28": 28
  }],
  120: [function (_dereq_, module, exports) {
    // 7.1.1 ToPrimitive(input [, PreferredType])
    var isObject = _dereq_(51); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
    // and the second argument - flag - preferred type is a string


    module.exports = function (it, S) {
      if (!isObject(it)) return it;
      var fn, val;
      if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
      if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
      throw TypeError("Can't convert object to primitive value");
    };
  }, {
    "51": 51
  }],
  121: [function (_dereq_, module, exports) {
    'use strict';

    if (_dereq_(29)) {
      var LIBRARY = _dereq_(60);

      var global = _dereq_(40);

      var fails = _dereq_(35);

      var $export = _dereq_(33);

      var $typed = _dereq_(123);

      var $buffer = _dereq_(122);

      var ctx = _dereq_(25);

      var anInstance = _dereq_(6);

      var propertyDesc = _dereq_(92);

      var hide = _dereq_(42);

      var redefineAll = _dereq_(93);

      var toInteger = _dereq_(116);

      var toLength = _dereq_(118);

      var toIndex = _dereq_(115);

      var toAbsoluteIndex = _dereq_(114);

      var toPrimitive = _dereq_(120);

      var has = _dereq_(41);

      var classof = _dereq_(17);

      var isObject = _dereq_(51);

      var toObject = _dereq_(119);

      var isArrayIter = _dereq_(48);

      var create = _dereq_(71);

      var getPrototypeOf = _dereq_(79);

      var gOPN = _dereq_(77).f;

      var getIterFn = _dereq_(129);

      var uid = _dereq_(124);

      var wks = _dereq_(128);

      var createArrayMethod = _dereq_(12);

      var createArrayIncludes = _dereq_(11);

      var speciesConstructor = _dereq_(104);

      var ArrayIterators = _dereq_(141);

      var Iterators = _dereq_(58);

      var $iterDetect = _dereq_(56);

      var setSpecies = _dereq_(100);

      var arrayFill = _dereq_(9);

      var arrayCopyWithin = _dereq_(8);

      var $DP = _dereq_(72);

      var $GOPD = _dereq_(75);

      var dP = $DP.f;
      var gOPD = $GOPD.f;
      var RangeError = global.RangeError;
      var TypeError = global.TypeError;
      var Uint8Array = global.Uint8Array;
      var ARRAY_BUFFER = 'ArrayBuffer';
      var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
      var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
      var PROTOTYPE = 'prototype';
      var ArrayProto = Array[PROTOTYPE];
      var $ArrayBuffer = $buffer.ArrayBuffer;
      var $DataView = $buffer.DataView;
      var arrayForEach = createArrayMethod(0);
      var arrayFilter = createArrayMethod(2);
      var arraySome = createArrayMethod(3);
      var arrayEvery = createArrayMethod(4);
      var arrayFind = createArrayMethod(5);
      var arrayFindIndex = createArrayMethod(6);
      var arrayIncludes = createArrayIncludes(true);
      var arrayIndexOf = createArrayIncludes(false);
      var arrayValues = ArrayIterators.values;
      var arrayKeys = ArrayIterators.keys;
      var arrayEntries = ArrayIterators.entries;
      var arrayLastIndexOf = ArrayProto.lastIndexOf;
      var arrayReduce = ArrayProto.reduce;
      var arrayReduceRight = ArrayProto.reduceRight;
      var arrayJoin = ArrayProto.join;
      var arraySort = ArrayProto.sort;
      var arraySlice = ArrayProto.slice;
      var arrayToString = ArrayProto.toString;
      var arrayToLocaleString = ArrayProto.toLocaleString;
      var ITERATOR = wks('iterator');
      var TAG = wks('toStringTag');
      var TYPED_CONSTRUCTOR = uid('typed_constructor');
      var DEF_CONSTRUCTOR = uid('def_constructor');
      var ALL_CONSTRUCTORS = $typed.CONSTR;
      var TYPED_ARRAY = $typed.TYPED;
      var VIEW = $typed.VIEW;
      var WRONG_LENGTH = 'Wrong length!';
      var $map = createArrayMethod(1, function (O, length) {
        return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
      });
      var LITTLE_ENDIAN = fails(function () {
        // eslint-disable-next-line no-undef
        return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
      });
      var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
        new Uint8Array(1).set({});
      });

      var toOffset = function toOffset(it, BYTES) {
        var offset = toInteger(it);
        if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
        return offset;
      };

      var validate = function validate(it) {
        if (isObject(it) && TYPED_ARRAY in it) return it;
        throw TypeError(it + ' is not a typed array!');
      };

      var allocate = function allocate(C, length) {
        if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
          throw TypeError('It is not a typed array constructor!');
        }

        return new C(length);
      };

      var speciesFromList = function speciesFromList(O, list) {
        return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
      };

      var fromList = function fromList(C, list) {
        var index = 0;
        var length = list.length;
        var result = allocate(C, length);

        while (length > index) {
          result[index] = list[index++];
        }

        return result;
      };

      var addGetter = function addGetter(it, key, internal) {
        dP(it, key, {
          get: function get() {
            return this._d[internal];
          }
        });
      };

      var $from = function from(source
      /* , mapfn, thisArg */
      ) {
        var O = toObject(source);
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var iterFn = getIterFn(O);
        var i, length, values, result, step, iterator;

        if (iterFn != undefined && !isArrayIter(iterFn)) {
          for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
            values.push(step.value);
          }

          O = values;
        }

        if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);

        for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
          result[i] = mapping ? mapfn(O[i], i) : O[i];
        }

        return result;
      };

      var $of = function of()
      /* ...items */
      {
        var index = 0;
        var length = arguments.length;
        var result = allocate(this, length);

        while (length > index) {
          result[index] = arguments[index++];
        }

        return result;
      }; // iOS Safari 6.x fails here


      var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
        arrayToLocaleString.call(new Uint8Array(1));
      });

      var $toLocaleString = function toLocaleString() {
        return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
      };

      var proto = {
        copyWithin: function copyWithin(target, start
        /* , end */
        ) {
          return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
        },
        every: function every(callbackfn
        /* , thisArg */
        ) {
          return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        fill: function fill(value
        /* , start, end */
        ) {
          // eslint-disable-line no-unused-vars
          return arrayFill.apply(validate(this), arguments);
        },
        filter: function filter(callbackfn
        /* , thisArg */
        ) {
          return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
        },
        find: function find(predicate
        /* , thisArg */
        ) {
          return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        findIndex: function findIndex(predicate
        /* , thisArg */
        ) {
          return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
        },
        forEach: function forEach(callbackfn
        /* , thisArg */
        ) {
          arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        indexOf: function indexOf(searchElement
        /* , fromIndex */
        ) {
          return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        includes: function includes(searchElement
        /* , fromIndex */
        ) {
          return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
        },
        join: function join(separator) {
          // eslint-disable-line no-unused-vars
          return arrayJoin.apply(validate(this), arguments);
        },
        lastIndexOf: function lastIndexOf(searchElement
        /* , fromIndex */
        ) {
          // eslint-disable-line no-unused-vars
          return arrayLastIndexOf.apply(validate(this), arguments);
        },
        map: function map(mapfn
        /* , thisArg */
        ) {
          return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        reduce: function reduce(callbackfn
        /* , initialValue */
        ) {
          // eslint-disable-line no-unused-vars
          return arrayReduce.apply(validate(this), arguments);
        },
        reduceRight: function reduceRight(callbackfn
        /* , initialValue */
        ) {
          // eslint-disable-line no-unused-vars
          return arrayReduceRight.apply(validate(this), arguments);
        },
        reverse: function reverse() {
          var that = this;
          var length = validate(that).length;
          var middle = Math.floor(length / 2);
          var index = 0;
          var value;

          while (index < middle) {
            value = that[index];
            that[index++] = that[--length];
            that[length] = value;
          }

          return that;
        },
        some: function some(callbackfn
        /* , thisArg */
        ) {
          return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        },
        sort: function sort(comparefn) {
          return arraySort.call(validate(this), comparefn);
        },
        subarray: function subarray(begin, end) {
          var O = validate(this);
          var length = O.length;
          var $begin = toAbsoluteIndex(begin, length);
          return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin));
        }
      };

      var $slice = function slice(start, end) {
        return speciesFromList(this, arraySlice.call(validate(this), start, end));
      };

      var $set = function set(arrayLike
      /* , offset */
      ) {
        validate(this);
        var offset = toOffset(arguments[1], 1);
        var length = this.length;
        var src = toObject(arrayLike);
        var len = toLength(src.length);
        var index = 0;
        if (len + offset > length) throw RangeError(WRONG_LENGTH);

        while (index < len) {
          this[offset + index] = src[index++];
        }
      };

      var $iterators = {
        entries: function entries() {
          return arrayEntries.call(validate(this));
        },
        keys: function keys() {
          return arrayKeys.call(validate(this));
        },
        values: function values() {
          return arrayValues.call(validate(this));
        }
      };

      var isTAIndex = function isTAIndex(target, key) {
        return isObject(target) && target[TYPED_ARRAY] && _typeof(key) != 'symbol' && key in target && String(+key) == String(key);
      };

      var $getDesc = function getOwnPropertyDescriptor(target, key) {
        return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
      };

      var $setDesc = function defineProperty(target, key, desc) {
        if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set') // TODO: add validation descriptor w/o calling accessors
        && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
          target[key] = desc.value;
          return target;
        }

        return dP(target, key, desc);
      };

      if (!ALL_CONSTRUCTORS) {
        $GOPD.f = $getDesc;
        $DP.f = $setDesc;
      }

      $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
        getOwnPropertyDescriptor: $getDesc,
        defineProperty: $setDesc
      });

      if (fails(function () {
        arrayToString.call({});
      })) {
        arrayToString = arrayToLocaleString = function toString() {
          return arrayJoin.call(this);
        };
      }

      var $TypedArrayPrototype$ = redefineAll({}, proto);
      redefineAll($TypedArrayPrototype$, $iterators);
      hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
      redefineAll($TypedArrayPrototype$, {
        slice: $slice,
        set: $set,
        constructor: function constructor() {
          /* noop */
        },
        toString: arrayToString,
        toLocaleString: $toLocaleString
      });
      addGetter($TypedArrayPrototype$, 'buffer', 'b');
      addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
      addGetter($TypedArrayPrototype$, 'byteLength', 'l');
      addGetter($TypedArrayPrototype$, 'length', 'e');
      dP($TypedArrayPrototype$, TAG, {
        get: function get() {
          return this[TYPED_ARRAY];
        }
      }); // eslint-disable-next-line max-statements

      module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
        CLAMPED = !!CLAMPED;
        var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
        var GETTER = 'get' + KEY;
        var SETTER = 'set' + KEY;
        var TypedArray = global[NAME];
        var Base = TypedArray || {};
        var TAC = TypedArray && getPrototypeOf(TypedArray);
        var FORCED = !TypedArray || !$typed.ABV;
        var O = {};
        var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];

        var getter = function getter(that, index) {
          var data = that._d;
          return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
        };

        var setter = function setter(that, index, value) {
          var data = that._d;
          if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
          data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
        };

        var addElement = function addElement(that, index) {
          dP(that, index, {
            get: function get() {
              return getter(this, index);
            },
            set: function set(value) {
              return setter(this, index, value);
            },
            enumerable: true
          });
        };

        if (FORCED) {
          TypedArray = wrapper(function (that, data, $offset, $length) {
            anInstance(that, TypedArray, NAME, '_d');
            var index = 0;
            var offset = 0;
            var buffer, byteLength, length, klass;

            if (!isObject(data)) {
              length = toIndex(data);
              byteLength = length * BYTES;
              buffer = new $ArrayBuffer(byteLength);
            } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
              buffer = data;
              offset = toOffset($offset, BYTES);
              var $len = data.byteLength;

              if ($length === undefined) {
                if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                byteLength = $len - offset;
                if (byteLength < 0) throw RangeError(WRONG_LENGTH);
              } else {
                byteLength = toLength($length) * BYTES;
                if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
              }

              length = byteLength / BYTES;
            } else if (TYPED_ARRAY in data) {
              return fromList(TypedArray, data);
            } else {
              return $from.call(TypedArray, data);
            }

            hide(that, '_d', {
              b: buffer,
              o: offset,
              l: byteLength,
              e: length,
              v: new $DataView(buffer)
            });

            while (index < length) {
              addElement(that, index++);
            }
          });
          TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
          hide(TypedArrayPrototype, 'constructor', TypedArray);
        } else if (!fails(function () {
          TypedArray(1);
        }) || !fails(function () {
          new TypedArray(-1); // eslint-disable-line no-new
        }) || !$iterDetect(function (iter) {
          new TypedArray(); // eslint-disable-line no-new

          new TypedArray(null); // eslint-disable-line no-new

          new TypedArray(1.5); // eslint-disable-line no-new

          new TypedArray(iter); // eslint-disable-line no-new
        }, true)) {
          TypedArray = wrapper(function (that, data, $offset, $length) {
            anInstance(that, TypedArray, NAME);
            var klass; // `ws` module bug, temporarily remove validation length for Uint8Array
            // https://github.com/websockets/ws/pull/645

            if (!isObject(data)) return new Base(toIndex(data));

            if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
              return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
            }

            if (TYPED_ARRAY in data) return fromList(TypedArray, data);
            return $from.call(TypedArray, data);
          });
          arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
            if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
          });
          TypedArray[PROTOTYPE] = TypedArrayPrototype;
          if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
        }

        var $nativeIterator = TypedArrayPrototype[ITERATOR];
        var CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
        var $iterator = $iterators.values;
        hide(TypedArray, TYPED_CONSTRUCTOR, true);
        hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
        hide(TypedArrayPrototype, VIEW, true);
        hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

        if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
          dP(TypedArrayPrototype, TAG, {
            get: function get() {
              return NAME;
            }
          });
        }

        O[NAME] = TypedArray;
        $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
        $export($export.S, NAME, {
          BYTES_PER_ELEMENT: BYTES
        });
        $export($export.S + $export.F * fails(function () {
          Base.of.call(TypedArray, 1);
        }), NAME, {
          from: $from,
          of: $of
        });
        if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
        $export($export.P, NAME, proto);
        setSpecies(NAME);
        $export($export.P + $export.F * FORCED_SET, NAME, {
          set: $set
        });
        $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
        if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
        $export($export.P + $export.F * fails(function () {
          new TypedArray(1).slice();
        }), NAME, {
          slice: $slice
        });
        $export($export.P + $export.F * (fails(function () {
          return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
        }) || !fails(function () {
          TypedArrayPrototype.toLocaleString.call([1, 2]);
        })), NAME, {
          toLocaleString: $toLocaleString
        });
        Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
        if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
      };
    } else module.exports = function () {
      /* empty */
    };
  }, {
    "100": 100,
    "104": 104,
    "11": 11,
    "114": 114,
    "115": 115,
    "116": 116,
    "118": 118,
    "119": 119,
    "12": 12,
    "120": 120,
    "122": 122,
    "123": 123,
    "124": 124,
    "128": 128,
    "129": 129,
    "141": 141,
    "17": 17,
    "25": 25,
    "29": 29,
    "33": 33,
    "35": 35,
    "40": 40,
    "41": 41,
    "42": 42,
    "48": 48,
    "51": 51,
    "56": 56,
    "58": 58,
    "6": 6,
    "60": 60,
    "71": 71,
    "72": 72,
    "75": 75,
    "77": 77,
    "79": 79,
    "8": 8,
    "9": 9,
    "92": 92,
    "93": 93
  }],
  122: [function (_dereq_, module, exports) {
    'use strict';

    var global = _dereq_(40);

    var DESCRIPTORS = _dereq_(29);

    var LIBRARY = _dereq_(60);

    var $typed = _dereq_(123);

    var hide = _dereq_(42);

    var redefineAll = _dereq_(93);

    var fails = _dereq_(35);

    var anInstance = _dereq_(6);

    var toInteger = _dereq_(116);

    var toLength = _dereq_(118);

    var toIndex = _dereq_(115);

    var gOPN = _dereq_(77).f;

    var dP = _dereq_(72).f;

    var arrayFill = _dereq_(9);

    var setToStringTag = _dereq_(101);

    var ARRAY_BUFFER = 'ArrayBuffer';
    var DATA_VIEW = 'DataView';
    var PROTOTYPE = 'prototype';
    var WRONG_LENGTH = 'Wrong length!';
    var WRONG_INDEX = 'Wrong index!';
    var $ArrayBuffer = global[ARRAY_BUFFER];
    var $DataView = global[DATA_VIEW];
    var Math = global.Math;
    var RangeError = global.RangeError; // eslint-disable-next-line no-shadow-restricted-names

    var Infinity = global.Infinity;
    var BaseBuffer = $ArrayBuffer;
    var abs = Math.abs;
    var pow = Math.pow;
    var floor = Math.floor;
    var log = Math.log;
    var LN2 = Math.LN2;
    var BUFFER = 'buffer';
    var BYTE_LENGTH = 'byteLength';
    var BYTE_OFFSET = 'byteOffset';
    var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
    var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
    var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET; // IEEE754 conversions based on https://github.com/feross/ieee754

    function packIEEE754(value, mLen, nBytes) {
      var buffer = Array(nBytes);
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
      var i = 0;
      var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
      var e, m, c;
      value = abs(value); // eslint-disable-next-line no-self-compare

      if (value != value || value === Infinity) {
        // eslint-disable-next-line no-self-compare
        m = value != value ? 1 : 0;
        e = eMax;
      } else {
        e = floor(log(value) / LN2);

        if (value * (c = pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }

        if (e + eBias >= 1) {
          value += rt / c;
        } else {
          value += rt * pow(2, 1 - eBias);
        }

        if (value * c >= 2) {
          e++;
          c /= 2;
        }

        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value * c - 1) * pow(2, mLen);
          e = e + eBias;
        } else {
          m = value * pow(2, eBias - 1) * pow(2, mLen);
          e = 0;
        }
      }

      for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {
        ;
      }

      e = e << mLen | m;
      eLen += mLen;

      for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {
        ;
      }

      buffer[--i] |= s * 128;
      return buffer;
    }

    function unpackIEEE754(buffer, mLen, nBytes) {
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = eLen - 7;
      var i = nBytes - 1;
      var s = buffer[i--];
      var e = s & 127;
      var m;
      s >>= 7;

      for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {
        ;
      }

      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;

      for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {
        ;
      }

      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : s ? -Infinity : Infinity;
      } else {
        m = m + pow(2, mLen);
        e = e - eBias;
      }

      return (s ? -1 : 1) * m * pow(2, e - mLen);
    }

    function unpackI32(bytes) {
      return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
    }

    function packI8(it) {
      return [it & 0xff];
    }

    function packI16(it) {
      return [it & 0xff, it >> 8 & 0xff];
    }

    function packI32(it) {
      return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
    }

    function packF64(it) {
      return packIEEE754(it, 52, 8);
    }

    function packF32(it) {
      return packIEEE754(it, 23, 4);
    }

    function addGetter(C, key, internal) {
      dP(C[PROTOTYPE], key, {
        get: function get() {
          return this[internal];
        }
      });
    }

    function get(view, bytes, index, isLittleEndian) {
      var numIndex = +index;
      var intIndex = toIndex(numIndex);
      if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
      var store = view[$BUFFER]._b;
      var start = intIndex + view[$OFFSET];
      var pack = store.slice(start, start + bytes);
      return isLittleEndian ? pack : pack.reverse();
    }

    function set(view, bytes, index, conversion, value, isLittleEndian) {
      var numIndex = +index;
      var intIndex = toIndex(numIndex);
      if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
      var store = view[$BUFFER]._b;
      var start = intIndex + view[$OFFSET];
      var pack = conversion(+value);

      for (var i = 0; i < bytes; i++) {
        store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
      }
    }

    if (!$typed.ABV) {
      $ArrayBuffer = function ArrayBuffer(length) {
        anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
        var byteLength = toIndex(length);
        this._b = arrayFill.call(Array(byteLength), 0);
        this[$LENGTH] = byteLength;
      };

      $DataView = function DataView(buffer, byteOffset, byteLength) {
        anInstance(this, $DataView, DATA_VIEW);
        anInstance(buffer, $ArrayBuffer, DATA_VIEW);
        var bufferLength = buffer[$LENGTH];
        var offset = toInteger(byteOffset);
        if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
        byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
        if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
        this[$BUFFER] = buffer;
        this[$OFFSET] = offset;
        this[$LENGTH] = byteLength;
      };

      if (DESCRIPTORS) {
        addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
        addGetter($DataView, BUFFER, '_b');
        addGetter($DataView, BYTE_LENGTH, '_l');
        addGetter($DataView, BYTE_OFFSET, '_o');
      }

      redefineAll($DataView[PROTOTYPE], {
        getInt8: function getInt8(byteOffset) {
          return get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
          return get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset
        /* , littleEndian */
        ) {
          var bytes = get(this, 2, byteOffset, arguments[1]);
          return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset
        /* , littleEndian */
        ) {
          var bytes = get(this, 2, byteOffset, arguments[1]);
          return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset
        /* , littleEndian */
        ) {
          return unpackI32(get(this, 4, byteOffset, arguments[1]));
        },
        getUint32: function getUint32(byteOffset
        /* , littleEndian */
        ) {
          return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset
        /* , littleEndian */
        ) {
          return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
        },
        getFloat64: function getFloat64(byteOffset
        /* , littleEndian */
        ) {
          return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
        },
        setInt8: function setInt8(byteOffset, value) {
          set(this, 1, byteOffset, packI8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
          set(this, 1, byteOffset, packI8, value);
        },
        setInt16: function setInt16(byteOffset, value
        /* , littleEndian */
        ) {
          set(this, 2, byteOffset, packI16, value, arguments[2]);
        },
        setUint16: function setUint16(byteOffset, value
        /* , littleEndian */
        ) {
          set(this, 2, byteOffset, packI16, value, arguments[2]);
        },
        setInt32: function setInt32(byteOffset, value
        /* , littleEndian */
        ) {
          set(this, 4, byteOffset, packI32, value, arguments[2]);
        },
        setUint32: function setUint32(byteOffset, value
        /* , littleEndian */
        ) {
          set(this, 4, byteOffset, packI32, value, arguments[2]);
        },
        setFloat32: function setFloat32(byteOffset, value
        /* , littleEndian */
        ) {
          set(this, 4, byteOffset, packF32, value, arguments[2]);
        },
        setFloat64: function setFloat64(byteOffset, value
        /* , littleEndian */
        ) {
          set(this, 8, byteOffset, packF64, value, arguments[2]);
        }
      });
    } else {
      if (!fails(function () {
        $ArrayBuffer(1);
      }) || !fails(function () {
        new $ArrayBuffer(-1); // eslint-disable-line no-new
      }) || fails(function () {
        new $ArrayBuffer(); // eslint-disable-line no-new

        new $ArrayBuffer(1.5); // eslint-disable-line no-new

        new $ArrayBuffer(NaN); // eslint-disable-line no-new

        return $ArrayBuffer.name != ARRAY_BUFFER;
      })) {
        $ArrayBuffer = function ArrayBuffer(length) {
          anInstance(this, $ArrayBuffer);
          return new BaseBuffer(toIndex(length));
        };

        var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];

        for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
          if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
        }

        if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
      } // iOS Safari 7.x bug


      var view = new $DataView(new $ArrayBuffer(2));
      var $setInt8 = $DataView[PROTOTYPE].setInt8;
      view.setInt8(0, 2147483648);
      view.setInt8(1, 2147483649);
      if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
        setInt8: function setInt8(byteOffset, value) {
          $setInt8.call(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
          $setInt8.call(this, byteOffset, value << 24 >> 24);
        }
      }, true);
    }

    setToStringTag($ArrayBuffer, ARRAY_BUFFER);
    setToStringTag($DataView, DATA_VIEW);
    hide($DataView[PROTOTYPE], $typed.VIEW, true);
    exports[ARRAY_BUFFER] = $ArrayBuffer;
    exports[DATA_VIEW] = $DataView;
  }, {
    "101": 101,
    "115": 115,
    "116": 116,
    "118": 118,
    "123": 123,
    "29": 29,
    "35": 35,
    "40": 40,
    "42": 42,
    "6": 6,
    "60": 60,
    "72": 72,
    "77": 77,
    "9": 9,
    "93": 93
  }],
  123: [function (_dereq_, module, exports) {
    var global = _dereq_(40);

    var hide = _dereq_(42);

    var uid = _dereq_(124);

    var TYPED = uid('typed_array');
    var VIEW = uid('view');
    var ABV = !!(global.ArrayBuffer && global.DataView);
    var CONSTR = ABV;
    var i = 0;
    var l = 9;
    var Typed;
    var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');

    while (i < l) {
      if (Typed = global[TypedArrayConstructors[i++]]) {
        hide(Typed.prototype, TYPED, true);
        hide(Typed.prototype, VIEW, true);
      } else CONSTR = false;
    }

    module.exports = {
      ABV: ABV,
      CONSTR: CONSTR,
      TYPED: TYPED,
      VIEW: VIEW
    };
  }, {
    "124": 124,
    "40": 40,
    "42": 42
  }],
  124: [function (_dereq_, module, exports) {
    var id = 0;
    var px = Math.random();

    module.exports = function (key) {
      return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
    };
  }, {}],
  125: [function (_dereq_, module, exports) {
    var isObject = _dereq_(51);

    module.exports = function (it, TYPE) {
      if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
      return it;
    };
  }, {
    "51": 51
  }],
  126: [function (_dereq_, module, exports) {
    var global = _dereq_(40);

    var core = _dereq_(23);

    var LIBRARY = _dereq_(60);

    var wksExt = _dereq_(127);

    var defineProperty = _dereq_(72).f;

    module.exports = function (name) {
      var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
      if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
        value: wksExt.f(name)
      });
    };
  }, {
    "127": 127,
    "23": 23,
    "40": 40,
    "60": 60,
    "72": 72
  }],
  127: [function (_dereq_, module, exports) {
    exports.f = _dereq_(128);
  }, {
    "128": 128
  }],
  128: [function (_dereq_, module, exports) {
    var store = _dereq_(103)('wks');

    var uid = _dereq_(124);

    var _Symbol = _dereq_(40).Symbol;

    var USE_SYMBOL = typeof _Symbol == 'function';

    var $exports = module.exports = function (name) {
      return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
    };

    $exports.store = store;
  }, {
    "103": 103,
    "124": 124,
    "40": 40
  }],
  129: [function (_dereq_, module, exports) {
    var classof = _dereq_(17);

    var ITERATOR = _dereq_(128)('iterator');

    var Iterators = _dereq_(58);

    module.exports = _dereq_(23).getIteratorMethod = function (it) {
      if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
    };
  }, {
    "128": 128,
    "17": 17,
    "23": 23,
    "58": 58
  }],
  130: [function (_dereq_, module, exports) {
    // https://github.com/benjamingr/RexExp.escape
    var $export = _dereq_(33);

    var $re = _dereq_(95)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

    $export($export.S, 'RegExp', {
      escape: function escape(it) {
        return $re(it);
      }
    });
  }, {
    "33": 33,
    "95": 95
  }],
  131: [function (_dereq_, module, exports) {
    // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
    var $export = _dereq_(33);

    $export($export.P, 'Array', {
      copyWithin: _dereq_(8)
    });

    _dereq_(5)('copyWithin');
  }, {
    "33": 33,
    "5": 5,
    "8": 8
  }],
  132: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $every = _dereq_(12)(4);

    $export($export.P + $export.F * !_dereq_(105)([].every, true), 'Array', {
      // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
      every: function every(callbackfn
      /* , thisArg */
      ) {
        return $every(this, callbackfn, arguments[1]);
      }
    });
  }, {
    "105": 105,
    "12": 12,
    "33": 33
  }],
  133: [function (_dereq_, module, exports) {
    // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
    var $export = _dereq_(33);

    $export($export.P, 'Array', {
      fill: _dereq_(9)
    });

    _dereq_(5)('fill');
  }, {
    "33": 33,
    "5": 5,
    "9": 9
  }],
  134: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $filter = _dereq_(12)(2);

    $export($export.P + $export.F * !_dereq_(105)([].filter, true), 'Array', {
      // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
      filter: function filter(callbackfn
      /* , thisArg */
      ) {
        return $filter(this, callbackfn, arguments[1]);
      }
    });
  }, {
    "105": 105,
    "12": 12,
    "33": 33
  }],
  135: [function (_dereq_, module, exports) {
    'use strict'; // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

    var $export = _dereq_(33);

    var $find = _dereq_(12)(6);

    var KEY = 'findIndex';
    var forced = true; // Shouldn't skip holes

    if (KEY in []) Array(1)[KEY](function () {
      forced = false;
    });
    $export($export.P + $export.F * forced, 'Array', {
      findIndex: function findIndex(callbackfn
      /* , that = undefined */
      ) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    _dereq_(5)(KEY);
  }, {
    "12": 12,
    "33": 33,
    "5": 5
  }],
  136: [function (_dereq_, module, exports) {
    'use strict'; // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

    var $export = _dereq_(33);

    var $find = _dereq_(12)(5);

    var KEY = 'find';
    var forced = true; // Shouldn't skip holes

    if (KEY in []) Array(1)[KEY](function () {
      forced = false;
    });
    $export($export.P + $export.F * forced, 'Array', {
      find: function find(callbackfn
      /* , that = undefined */
      ) {
        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    _dereq_(5)(KEY);
  }, {
    "12": 12,
    "33": 33,
    "5": 5
  }],
  137: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $forEach = _dereq_(12)(0);

    var STRICT = _dereq_(105)([].forEach, true);

    $export($export.P + $export.F * !STRICT, 'Array', {
      // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
      forEach: function forEach(callbackfn
      /* , thisArg */
      ) {
        return $forEach(this, callbackfn, arguments[1]);
      }
    });
  }, {
    "105": 105,
    "12": 12,
    "33": 33
  }],
  138: [function (_dereq_, module, exports) {
    'use strict';

    var ctx = _dereq_(25);

    var $export = _dereq_(33);

    var toObject = _dereq_(119);

    var call = _dereq_(53);

    var isArrayIter = _dereq_(48);

    var toLength = _dereq_(118);

    var createProperty = _dereq_(24);

    var getIterFn = _dereq_(129);

    $export($export.S + $export.F * !_dereq_(56)(function (iter) {
      Array.from(iter);
    }), 'Array', {
      // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
      from: function from(arrayLike
      /* , mapfn = undefined, thisArg = undefined */
      ) {
        var O = toObject(arrayLike);
        var C = typeof this == 'function' ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = getIterFn(O);
        var length, result, step, iterator;
        if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

        if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
          for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
            createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
          }
        } else {
          length = toLength(O.length);

          for (result = new C(length); length > index; index++) {
            createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
          }
        }

        result.length = index;
        return result;
      }
    });
  }, {
    "118": 118,
    "119": 119,
    "129": 129,
    "24": 24,
    "25": 25,
    "33": 33,
    "48": 48,
    "53": 53,
    "56": 56
  }],
  139: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $indexOf = _dereq_(11)(false);

    var $native = [].indexOf;
    var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
    $export($export.P + $export.F * (NEGATIVE_ZERO || !_dereq_(105)($native)), 'Array', {
      // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
      indexOf: function indexOf(searchElement
      /* , fromIndex = 0 */
      ) {
        return NEGATIVE_ZERO // convert -0 to +0
        ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
      }
    });
  }, {
    "105": 105,
    "11": 11,
    "33": 33
  }],
  140: [function (_dereq_, module, exports) {
    // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
    var $export = _dereq_(33);

    $export($export.S, 'Array', {
      isArray: _dereq_(49)
    });
  }, {
    "33": 33,
    "49": 49
  }],
  141: [function (_dereq_, module, exports) {
    'use strict';

    var addToUnscopables = _dereq_(5);

    var step = _dereq_(57);

    var Iterators = _dereq_(58);

    var toIObject = _dereq_(117); // 22.1.3.4 Array.prototype.entries()
    // 22.1.3.13 Array.prototype.keys()
    // 22.1.3.29 Array.prototype.values()
    // 22.1.3.30 Array.prototype[@@iterator]()


    module.exports = _dereq_(55)(Array, 'Array', function (iterated, kind) {
      this._t = toIObject(iterated); // target

      this._i = 0; // next index

      this._k = kind; // kind
      // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var kind = this._k;
      var index = this._i++;

      if (!O || index >= O.length) {
        this._t = undefined;
        return step(1);
      }

      if (kind == 'keys') return step(0, index);
      if (kind == 'values') return step(0, O[index]);
      return step(0, [index, O[index]]);
    }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

    Iterators.Arguments = Iterators.Array;
    addToUnscopables('keys');
    addToUnscopables('values');
    addToUnscopables('entries');
  }, {
    "117": 117,
    "5": 5,
    "55": 55,
    "57": 57,
    "58": 58
  }],
  142: [function (_dereq_, module, exports) {
    'use strict'; // 22.1.3.13 Array.prototype.join(separator)

    var $export = _dereq_(33);

    var toIObject = _dereq_(117);

    var arrayJoin = [].join; // fallback for not array-like strings

    $export($export.P + $export.F * (_dereq_(47) != Object || !_dereq_(105)(arrayJoin)), 'Array', {
      join: function join(separator) {
        return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
      }
    });
  }, {
    "105": 105,
    "117": 117,
    "33": 33,
    "47": 47
  }],
  143: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var toIObject = _dereq_(117);

    var toInteger = _dereq_(116);

    var toLength = _dereq_(118);

    var $native = [].lastIndexOf;
    var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
    $export($export.P + $export.F * (NEGATIVE_ZERO || !_dereq_(105)($native)), 'Array', {
      // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
      lastIndexOf: function lastIndexOf(searchElement
      /* , fromIndex = @[*-1] */
      ) {
        // convert -0 to +0
        if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
        var O = toIObject(this);
        var length = toLength(O.length);
        var index = length - 1;
        if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
        if (index < 0) index = length + index;

        for (; index >= 0; index--) {
          if (index in O) if (O[index] === searchElement) return index || 0;
        }

        return -1;
      }
    });
  }, {
    "105": 105,
    "116": 116,
    "117": 117,
    "118": 118,
    "33": 33
  }],
  144: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $map = _dereq_(12)(1);

    $export($export.P + $export.F * !_dereq_(105)([].map, true), 'Array', {
      // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
      map: function map(callbackfn
      /* , thisArg */
      ) {
        return $map(this, callbackfn, arguments[1]);
      }
    });
  }, {
    "105": 105,
    "12": 12,
    "33": 33
  }],
  145: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var createProperty = _dereq_(24); // WebKit Array.of isn't generic


    $export($export.S + $export.F * _dereq_(35)(function () {
      function F() {
        /* empty */
      }

      return !(Array.of.call(F) instanceof F);
    }), 'Array', {
      // 22.1.2.3 Array.of( ...items)
      of: function of()
      /* ...args */
      {
        var index = 0;
        var aLen = arguments.length;
        var result = new (typeof this == 'function' ? this : Array)(aLen);

        while (aLen > index) {
          createProperty(result, index, arguments[index++]);
        }

        result.length = aLen;
        return result;
      }
    });
  }, {
    "24": 24,
    "33": 33,
    "35": 35
  }],
  146: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $reduce = _dereq_(13);

    $export($export.P + $export.F * !_dereq_(105)([].reduceRight, true), 'Array', {
      // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
      reduceRight: function reduceRight(callbackfn
      /* , initialValue */
      ) {
        return $reduce(this, callbackfn, arguments.length, arguments[1], true);
      }
    });
  }, {
    "105": 105,
    "13": 13,
    "33": 33
  }],
  147: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $reduce = _dereq_(13);

    $export($export.P + $export.F * !_dereq_(105)([].reduce, true), 'Array', {
      // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
      reduce: function reduce(callbackfn
      /* , initialValue */
      ) {
        return $reduce(this, callbackfn, arguments.length, arguments[1], false);
      }
    });
  }, {
    "105": 105,
    "13": 13,
    "33": 33
  }],
  148: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var html = _dereq_(43);

    var cof = _dereq_(18);

    var toAbsoluteIndex = _dereq_(114);

    var toLength = _dereq_(118);

    var arraySlice = [].slice; // fallback for not array-like ES3 strings and DOM objects

    $export($export.P + $export.F * _dereq_(35)(function () {
      if (html) arraySlice.call(html);
    }), 'Array', {
      slice: function slice(begin, end) {
        var len = toLength(this.length);
        var klass = cof(this);
        end = end === undefined ? len : end;
        if (klass == 'Array') return arraySlice.call(this, begin, end);
        var start = toAbsoluteIndex(begin, len);
        var upTo = toAbsoluteIndex(end, len);
        var size = toLength(upTo - start);
        var cloned = Array(size);
        var i = 0;

        for (; i < size; i++) {
          cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
        }

        return cloned;
      }
    });
  }, {
    "114": 114,
    "118": 118,
    "18": 18,
    "33": 33,
    "35": 35,
    "43": 43
  }],
  149: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $some = _dereq_(12)(3);

    $export($export.P + $export.F * !_dereq_(105)([].some, true), 'Array', {
      // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
      some: function some(callbackfn
      /* , thisArg */
      ) {
        return $some(this, callbackfn, arguments[1]);
      }
    });
  }, {
    "105": 105,
    "12": 12,
    "33": 33
  }],
  150: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var aFunction = _dereq_(3);

    var toObject = _dereq_(119);

    var fails = _dereq_(35);

    var $sort = [].sort;
    var test = [1, 2, 3];
    $export($export.P + $export.F * (fails(function () {
      // IE8-
      test.sort(undefined);
    }) || !fails(function () {
      // V8 bug
      test.sort(null); // Old WebKit
    }) || !_dereq_(105)($sort)), 'Array', {
      // 22.1.3.25 Array.prototype.sort(comparefn)
      sort: function sort(comparefn) {
        return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
      }
    });
  }, {
    "105": 105,
    "119": 119,
    "3": 3,
    "33": 33,
    "35": 35
  }],
  151: [function (_dereq_, module, exports) {
    _dereq_(100)('Array');
  }, {
    "100": 100
  }],
  152: [function (_dereq_, module, exports) {
    // 20.3.3.1 / 15.9.4.4 Date.now()
    var $export = _dereq_(33);

    $export($export.S, 'Date', {
      now: function now() {
        return new Date().getTime();
      }
    });
  }, {
    "33": 33
  }],
  153: [function (_dereq_, module, exports) {
    // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
    var $export = _dereq_(33);

    var toISOString = _dereq_(26); // PhantomJS / old WebKit has a broken implementations


    $export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
      toISOString: toISOString
    });
  }, {
    "26": 26,
    "33": 33
  }],
  154: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var toObject = _dereq_(119);

    var toPrimitive = _dereq_(120);

    $export($export.P + $export.F * _dereq_(35)(function () {
      return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({
        toISOString: function toISOString() {
          return 1;
        }
      }) !== 1;
    }), 'Date', {
      // eslint-disable-next-line no-unused-vars
      toJSON: function toJSON(key) {
        var O = toObject(this);
        var pv = toPrimitive(O);
        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
      }
    });
  }, {
    "119": 119,
    "120": 120,
    "33": 33,
    "35": 35
  }],
  155: [function (_dereq_, module, exports) {
    var TO_PRIMITIVE = _dereq_(128)('toPrimitive');

    var proto = Date.prototype;
    if (!(TO_PRIMITIVE in proto)) _dereq_(42)(proto, TO_PRIMITIVE, _dereq_(27));
  }, {
    "128": 128,
    "27": 27,
    "42": 42
  }],
  156: [function (_dereq_, module, exports) {
    var DateProto = Date.prototype;
    var INVALID_DATE = 'Invalid Date';
    var TO_STRING = 'toString';
    var $toString = DateProto[TO_STRING];
    var getTime = DateProto.getTime;

    if (new Date(NaN) + '' != INVALID_DATE) {
      _dereq_(94)(DateProto, TO_STRING, function toString() {
        var value = getTime.call(this); // eslint-disable-next-line no-self-compare

        return value === value ? $toString.call(this) : INVALID_DATE;
      });
    }
  }, {
    "94": 94
  }],
  157: [function (_dereq_, module, exports) {
    // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
    var $export = _dereq_(33);

    $export($export.P, 'Function', {
      bind: _dereq_(16)
    });
  }, {
    "16": 16,
    "33": 33
  }],
  158: [function (_dereq_, module, exports) {
    'use strict';

    var isObject = _dereq_(51);

    var getPrototypeOf = _dereq_(79);

    var HAS_INSTANCE = _dereq_(128)('hasInstance');

    var FunctionProto = Function.prototype; // 19.2.3.6 Function.prototype[@@hasInstance](V)

    if (!(HAS_INSTANCE in FunctionProto)) _dereq_(72).f(FunctionProto, HAS_INSTANCE, {
      value: function value(O) {
        if (typeof this != 'function' || !isObject(O)) return false;
        if (!isObject(this.prototype)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

        while (O = getPrototypeOf(O)) {
          if (this.prototype === O) return true;
        }

        return false;
      }
    });
  }, {
    "128": 128,
    "51": 51,
    "72": 72,
    "79": 79
  }],
  159: [function (_dereq_, module, exports) {
    var dP = _dereq_(72).f;

    var FProto = Function.prototype;
    var nameRE = /^\s*function ([^ (]*)/;
    var NAME = 'name'; // 19.2.4.2 name

    NAME in FProto || _dereq_(29) && dP(FProto, NAME, {
      configurable: true,
      get: function get() {
        try {
          return ('' + this).match(nameRE)[1];
        } catch (e) {
          return '';
        }
      }
    });
  }, {
    "29": 29,
    "72": 72
  }],
  160: [function (_dereq_, module, exports) {
    'use strict';

    var strong = _dereq_(19);

    var validate = _dereq_(125);

    var MAP = 'Map'; // 23.1 Map Objects

    module.exports = _dereq_(22)(MAP, function (get) {
      return function Map() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
      };
    }, {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = strong.getEntry(validate(this, MAP), key);
        return entry && entry.v;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
      }
    }, strong, true);
  }, {
    "125": 125,
    "19": 19,
    "22": 22
  }],
  161: [function (_dereq_, module, exports) {
    // 20.2.2.3 Math.acosh(x)
    var $export = _dereq_(33);

    var log1p = _dereq_(63);

    var sqrt = Math.sqrt;
    var $acosh = Math.acosh;
    $export($export.S + $export.F * !($acosh // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
    && Math.floor($acosh(Number.MAX_VALUE)) == 710 // Tor Browser bug: Math.acosh(Infinity) -> NaN
    && $acosh(Infinity) == Infinity), 'Math', {
      acosh: function acosh(x) {
        return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
      }
    });
  }, {
    "33": 33,
    "63": 63
  }],
  162: [function (_dereq_, module, exports) {
    // 20.2.2.5 Math.asinh(x)
    var $export = _dereq_(33);

    var $asinh = Math.asinh;

    function asinh(x) {
      return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
    } // Tor Browser bug: Math.asinh(0) -> -0


    $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', {
      asinh: asinh
    });
  }, {
    "33": 33
  }],
  163: [function (_dereq_, module, exports) {
    // 20.2.2.7 Math.atanh(x)
    var $export = _dereq_(33);

    var $atanh = Math.atanh; // Tor Browser bug: Math.atanh(-0) -> 0

    $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
      atanh: function atanh(x) {
        return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
      }
    });
  }, {
    "33": 33
  }],
  164: [function (_dereq_, module, exports) {
    // 20.2.2.9 Math.cbrt(x)
    var $export = _dereq_(33);

    var sign = _dereq_(65);

    $export($export.S, 'Math', {
      cbrt: function cbrt(x) {
        return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
      }
    });
  }, {
    "33": 33,
    "65": 65
  }],
  165: [function (_dereq_, module, exports) {
    // 20.2.2.11 Math.clz32(x)
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      clz32: function clz32(x) {
        return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
      }
    });
  }, {
    "33": 33
  }],
  166: [function (_dereq_, module, exports) {
    // 20.2.2.12 Math.cosh(x)
    var $export = _dereq_(33);

    var exp = Math.exp;
    $export($export.S, 'Math', {
      cosh: function cosh(x) {
        return (exp(x = +x) + exp(-x)) / 2;
      }
    });
  }, {
    "33": 33
  }],
  167: [function (_dereq_, module, exports) {
    // 20.2.2.14 Math.expm1(x)
    var $export = _dereq_(33);

    var $expm1 = _dereq_(61);

    $export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', {
      expm1: $expm1
    });
  }, {
    "33": 33,
    "61": 61
  }],
  168: [function (_dereq_, module, exports) {
    // 20.2.2.16 Math.fround(x)
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      fround: _dereq_(62)
    });
  }, {
    "33": 33,
    "62": 62
  }],
  169: [function (_dereq_, module, exports) {
    // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
    var $export = _dereq_(33);

    var abs = Math.abs;
    $export($export.S, 'Math', {
      hypot: function hypot(value1, value2) {
        // eslint-disable-line no-unused-vars
        var sum = 0;
        var i = 0;
        var aLen = arguments.length;
        var larg = 0;
        var arg, div;

        while (i < aLen) {
          arg = abs(arguments[i++]);

          if (larg < arg) {
            div = larg / arg;
            sum = sum * div * div + 1;
            larg = arg;
          } else if (arg > 0) {
            div = arg / larg;
            sum += div * div;
          } else sum += arg;
        }

        return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
      }
    });
  }, {
    "33": 33
  }],
  170: [function (_dereq_, module, exports) {
    // 20.2.2.18 Math.imul(x, y)
    var $export = _dereq_(33);

    var $imul = Math.imul; // some WebKit versions fails with big numbers, some has wrong arity

    $export($export.S + $export.F * _dereq_(35)(function () {
      return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
    }), 'Math', {
      imul: function imul(x, y) {
        var UINT16 = 0xffff;
        var xn = +x;
        var yn = +y;
        var xl = UINT16 & xn;
        var yl = UINT16 & yn;
        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
      }
    });
  }, {
    "33": 33,
    "35": 35
  }],
  171: [function (_dereq_, module, exports) {
    // 20.2.2.21 Math.log10(x)
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      log10: function log10(x) {
        return Math.log(x) * Math.LOG10E;
      }
    });
  }, {
    "33": 33
  }],
  172: [function (_dereq_, module, exports) {
    // 20.2.2.20 Math.log1p(x)
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      log1p: _dereq_(63)
    });
  }, {
    "33": 33,
    "63": 63
  }],
  173: [function (_dereq_, module, exports) {
    // 20.2.2.22 Math.log2(x)
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      log2: function log2(x) {
        return Math.log(x) / Math.LN2;
      }
    });
  }, {
    "33": 33
  }],
  174: [function (_dereq_, module, exports) {
    // 20.2.2.28 Math.sign(x)
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      sign: _dereq_(65)
    });
  }, {
    "33": 33,
    "65": 65
  }],
  175: [function (_dereq_, module, exports) {
    // 20.2.2.30 Math.sinh(x)
    var $export = _dereq_(33);

    var expm1 = _dereq_(61);

    var exp = Math.exp; // V8 near Chromium 38 has a problem with very small numbers

    $export($export.S + $export.F * _dereq_(35)(function () {
      return !Math.sinh(-2e-17) != -2e-17;
    }), 'Math', {
      sinh: function sinh(x) {
        return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
      }
    });
  }, {
    "33": 33,
    "35": 35,
    "61": 61
  }],
  176: [function (_dereq_, module, exports) {
    // 20.2.2.33 Math.tanh(x)
    var $export = _dereq_(33);

    var expm1 = _dereq_(61);

    var exp = Math.exp;
    $export($export.S, 'Math', {
      tanh: function tanh(x) {
        var a = expm1(x = +x);
        var b = expm1(-x);
        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
      }
    });
  }, {
    "33": 33,
    "61": 61
  }],
  177: [function (_dereq_, module, exports) {
    // 20.2.2.34 Math.trunc(x)
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      trunc: function trunc(it) {
        return (it > 0 ? Math.floor : Math.ceil)(it);
      }
    });
  }, {
    "33": 33
  }],
  178: [function (_dereq_, module, exports) {
    'use strict';

    var global = _dereq_(40);

    var has = _dereq_(41);

    var cof = _dereq_(18);

    var inheritIfRequired = _dereq_(45);

    var toPrimitive = _dereq_(120);

    var fails = _dereq_(35);

    var gOPN = _dereq_(77).f;

    var gOPD = _dereq_(75).f;

    var dP = _dereq_(72).f;

    var $trim = _dereq_(111).trim;

    var NUMBER = 'Number';
    var $Number = global[NUMBER];
    var Base = $Number;
    var proto = $Number.prototype; // Opera ~12 has broken Object#toString

    var BROKEN_COF = cof(_dereq_(71)(proto)) == NUMBER;
    var TRIM = 'trim' in String.prototype; // 7.1.3 ToNumber(argument)

    var toNumber = function toNumber(argument) {
      var it = toPrimitive(argument, false);

      if (typeof it == 'string' && it.length > 2) {
        it = TRIM ? it.trim() : $trim(it, 3);
        var first = it.charCodeAt(0);
        var third, radix, maxCode;

        if (first === 43 || first === 45) {
          third = it.charCodeAt(2);
          if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
        } else if (first === 48) {
          switch (it.charCodeAt(1)) {
            case 66:
            case 98:
              radix = 2;
              maxCode = 49;
              break;
            // fast equal /^0b[01]+$/i

            case 79:
            case 111:
              radix = 8;
              maxCode = 55;
              break;
            // fast equal /^0o[0-7]+$/i

            default:
              return +it;
          }

          for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
            code = digits.charCodeAt(i); // parseInt parses a string to a first unavailable symbol
            // but ToNumber should return NaN if a string contains unavailable symbols

            if (code < 48 || code > maxCode) return NaN;
          }

          return parseInt(digits, radix);
        }
      }

      return +it;
    };

    if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
      $Number = function Number(value) {
        var it = arguments.length < 1 ? 0 : value;
        var that = this;
        return that instanceof $Number // check on 1..constructor(foo) case
        && (BROKEN_COF ? fails(function () {
          proto.valueOf.call(that);
        }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
      };

      for (var keys = _dereq_(29) ? gOPN(Base) : ( // ES3:
      'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES6 (in case, if modules with ES6 Number statics required before):
      'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
        if (has(Base, key = keys[j]) && !has($Number, key)) {
          dP($Number, key, gOPD(Base, key));
        }
      }

      $Number.prototype = proto;
      proto.constructor = $Number;

      _dereq_(94)(global, NUMBER, $Number);
    }
  }, {
    "111": 111,
    "120": 120,
    "18": 18,
    "29": 29,
    "35": 35,
    "40": 40,
    "41": 41,
    "45": 45,
    "71": 71,
    "72": 72,
    "75": 75,
    "77": 77,
    "94": 94
  }],
  179: [function (_dereq_, module, exports) {
    // 20.1.2.1 Number.EPSILON
    var $export = _dereq_(33);

    $export($export.S, 'Number', {
      EPSILON: Math.pow(2, -52)
    });
  }, {
    "33": 33
  }],
  180: [function (_dereq_, module, exports) {
    // 20.1.2.2 Number.isFinite(number)
    var $export = _dereq_(33);

    var _isFinite = _dereq_(40).isFinite;

    $export($export.S, 'Number', {
      isFinite: function isFinite(it) {
        return typeof it == 'number' && _isFinite(it);
      }
    });
  }, {
    "33": 33,
    "40": 40
  }],
  181: [function (_dereq_, module, exports) {
    // 20.1.2.3 Number.isInteger(number)
    var $export = _dereq_(33);

    $export($export.S, 'Number', {
      isInteger: _dereq_(50)
    });
  }, {
    "33": 33,
    "50": 50
  }],
  182: [function (_dereq_, module, exports) {
    // 20.1.2.4 Number.isNaN(number)
    var $export = _dereq_(33);

    $export($export.S, 'Number', {
      isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare
        return number != number;
      }
    });
  }, {
    "33": 33
  }],
  183: [function (_dereq_, module, exports) {
    // 20.1.2.5 Number.isSafeInteger(number)
    var $export = _dereq_(33);

    var isInteger = _dereq_(50);

    var abs = Math.abs;
    $export($export.S, 'Number', {
      isSafeInteger: function isSafeInteger(number) {
        return isInteger(number) && abs(number) <= 0x1fffffffffffff;
      }
    });
  }, {
    "33": 33,
    "50": 50
  }],
  184: [function (_dereq_, module, exports) {
    // 20.1.2.6 Number.MAX_SAFE_INTEGER
    var $export = _dereq_(33);

    $export($export.S, 'Number', {
      MAX_SAFE_INTEGER: 0x1fffffffffffff
    });
  }, {
    "33": 33
  }],
  185: [function (_dereq_, module, exports) {
    // 20.1.2.10 Number.MIN_SAFE_INTEGER
    var $export = _dereq_(33);

    $export($export.S, 'Number', {
      MIN_SAFE_INTEGER: -0x1fffffffffffff
    });
  }, {
    "33": 33
  }],
  186: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var $parseFloat = _dereq_(86); // 20.1.2.12 Number.parseFloat(string)


    $export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', {
      parseFloat: $parseFloat
    });
  }, {
    "33": 33,
    "86": 86
  }],
  187: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var $parseInt = _dereq_(87); // 20.1.2.13 Number.parseInt(string, radix)


    $export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', {
      parseInt: $parseInt
    });
  }, {
    "33": 33,
    "87": 87
  }],
  188: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var toInteger = _dereq_(116);

    var aNumberValue = _dereq_(4);

    var repeat = _dereq_(110);

    var $toFixed = 1.0.toFixed;
    var floor = Math.floor;
    var data = [0, 0, 0, 0, 0, 0];
    var ERROR = 'Number.toFixed: incorrect invocation!';
    var ZERO = '0';

    var multiply = function multiply(n, c) {
      var i = -1;
      var c2 = c;

      while (++i < 6) {
        c2 += n * data[i];
        data[i] = c2 % 1e7;
        c2 = floor(c2 / 1e7);
      }
    };

    var divide = function divide(n) {
      var i = 6;
      var c = 0;

      while (--i >= 0) {
        c += data[i];
        data[i] = floor(c / n);
        c = c % n * 1e7;
      }
    };

    var numToString = function numToString() {
      var i = 6;
      var s = '';

      while (--i >= 0) {
        if (s !== '' || i === 0 || data[i] !== 0) {
          var t = String(data[i]);
          s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
        }
      }

      return s;
    };

    var pow = function pow(x, n, acc) {
      return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
    };

    var log = function log(x) {
      var n = 0;
      var x2 = x;

      while (x2 >= 4096) {
        n += 12;
        x2 /= 4096;
      }

      while (x2 >= 2) {
        n += 1;
        x2 /= 2;
      }

      return n;
    };

    $export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128.0.toFixed(0) !== '1000000000000000128') || !_dereq_(35)(function () {
      // V8 ~ Android 4.3-
      $toFixed.call({});
    })), 'Number', {
      toFixed: function toFixed(fractionDigits) {
        var x = aNumberValue(this, ERROR);
        var f = toInteger(fractionDigits);
        var s = '';
        var m = ZERO;
        var e, z, j, k;
        if (f < 0 || f > 20) throw RangeError(ERROR); // eslint-disable-next-line no-self-compare

        if (x != x) return 'NaN';
        if (x <= -1e21 || x >= 1e21) return String(x);

        if (x < 0) {
          s = '-';
          x = -x;
        }

        if (x > 1e-21) {
          e = log(x * pow(2, 69, 1)) - 69;
          z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
          z *= 0x10000000000000;
          e = 52 - e;

          if (e > 0) {
            multiply(0, z);
            j = f;

            while (j >= 7) {
              multiply(1e7, 0);
              j -= 7;
            }

            multiply(pow(10, j, 1), 0);
            j = e - 1;

            while (j >= 23) {
              divide(1 << 23);
              j -= 23;
            }

            divide(1 << j);
            multiply(1, 1);
            divide(2);
            m = numToString();
          } else {
            multiply(0, z);
            multiply(1 << -e, 0);
            m = numToString() + repeat.call(ZERO, f);
          }
        }

        if (f > 0) {
          k = m.length;
          m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
        } else {
          m = s + m;
        }

        return m;
      }
    });
  }, {
    "110": 110,
    "116": 116,
    "33": 33,
    "35": 35,
    "4": 4
  }],
  189: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $fails = _dereq_(35);

    var aNumberValue = _dereq_(4);

    var $toPrecision = 1.0.toPrecision;
    $export($export.P + $export.F * ($fails(function () {
      // IE7-
      return $toPrecision.call(1, undefined) !== '1';
    }) || !$fails(function () {
      // V8 ~ Android 4.3-
      $toPrecision.call({});
    })), 'Number', {
      toPrecision: function toPrecision(precision) {
        var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
        return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
      }
    });
  }, {
    "33": 33,
    "35": 35,
    "4": 4
  }],
  190: [function (_dereq_, module, exports) {
    // 19.1.3.1 Object.assign(target, source)
    var $export = _dereq_(33);

    $export($export.S + $export.F, 'Object', {
      assign: _dereq_(70)
    });
  }, {
    "33": 33,
    "70": 70
  }],
  191: [function (_dereq_, module, exports) {
    var $export = _dereq_(33); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


    $export($export.S, 'Object', {
      create: _dereq_(71)
    });
  }, {
    "33": 33,
    "71": 71
  }],
  192: [function (_dereq_, module, exports) {
    var $export = _dereq_(33); // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)


    $export($export.S + $export.F * !_dereq_(29), 'Object', {
      defineProperties: _dereq_(73)
    });
  }, {
    "29": 29,
    "33": 33,
    "73": 73
  }],
  193: [function (_dereq_, module, exports) {
    var $export = _dereq_(33); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


    $export($export.S + $export.F * !_dereq_(29), 'Object', {
      defineProperty: _dereq_(72).f
    });
  }, {
    "29": 29,
    "33": 33,
    "72": 72
  }],
  194: [function (_dereq_, module, exports) {
    // 19.1.2.5 Object.freeze(O)
    var isObject = _dereq_(51);

    var meta = _dereq_(66).onFreeze;

    _dereq_(83)('freeze', function ($freeze) {
      return function freeze(it) {
        return $freeze && isObject(it) ? $freeze(meta(it)) : it;
      };
    });
  }, {
    "51": 51,
    "66": 66,
    "83": 83
  }],
  195: [function (_dereq_, module, exports) {
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    var toIObject = _dereq_(117);

    var $getOwnPropertyDescriptor = _dereq_(75).f;

    _dereq_(83)('getOwnPropertyDescriptor', function () {
      return function getOwnPropertyDescriptor(it, key) {
        return $getOwnPropertyDescriptor(toIObject(it), key);
      };
    });
  }, {
    "117": 117,
    "75": 75,
    "83": 83
  }],
  196: [function (_dereq_, module, exports) {
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    _dereq_(83)('getOwnPropertyNames', function () {
      return _dereq_(76).f;
    });
  }, {
    "76": 76,
    "83": 83
  }],
  197: [function (_dereq_, module, exports) {
    // 19.1.2.9 Object.getPrototypeOf(O)
    var toObject = _dereq_(119);

    var $getPrototypeOf = _dereq_(79);

    _dereq_(83)('getPrototypeOf', function () {
      return function getPrototypeOf(it) {
        return $getPrototypeOf(toObject(it));
      };
    });
  }, {
    "119": 119,
    "79": 79,
    "83": 83
  }],
  198: [function (_dereq_, module, exports) {
    // 19.1.2.11 Object.isExtensible(O)
    var isObject = _dereq_(51);

    _dereq_(83)('isExtensible', function ($isExtensible) {
      return function isExtensible(it) {
        return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
      };
    });
  }, {
    "51": 51,
    "83": 83
  }],
  199: [function (_dereq_, module, exports) {
    // 19.1.2.12 Object.isFrozen(O)
    var isObject = _dereq_(51);

    _dereq_(83)('isFrozen', function ($isFrozen) {
      return function isFrozen(it) {
        return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
      };
    });
  }, {
    "51": 51,
    "83": 83
  }],
  200: [function (_dereq_, module, exports) {
    // 19.1.2.13 Object.isSealed(O)
    var isObject = _dereq_(51);

    _dereq_(83)('isSealed', function ($isSealed) {
      return function isSealed(it) {
        return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
      };
    });
  }, {
    "51": 51,
    "83": 83
  }],
  201: [function (_dereq_, module, exports) {
    // 19.1.3.10 Object.is(value1, value2)
    var $export = _dereq_(33);

    $export($export.S, 'Object', {
      is: _dereq_(96)
    });
  }, {
    "33": 33,
    "96": 96
  }],
  202: [function (_dereq_, module, exports) {
    // 19.1.2.14 Object.keys(O)
    var toObject = _dereq_(119);

    var $keys = _dereq_(81);

    _dereq_(83)('keys', function () {
      return function keys(it) {
        return $keys(toObject(it));
      };
    });
  }, {
    "119": 119,
    "81": 81,
    "83": 83
  }],
  203: [function (_dereq_, module, exports) {
    // 19.1.2.15 Object.preventExtensions(O)
    var isObject = _dereq_(51);

    var meta = _dereq_(66).onFreeze;

    _dereq_(83)('preventExtensions', function ($preventExtensions) {
      return function preventExtensions(it) {
        return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
      };
    });
  }, {
    "51": 51,
    "66": 66,
    "83": 83
  }],
  204: [function (_dereq_, module, exports) {
    // 19.1.2.17 Object.seal(O)
    var isObject = _dereq_(51);

    var meta = _dereq_(66).onFreeze;

    _dereq_(83)('seal', function ($seal) {
      return function seal(it) {
        return $seal && isObject(it) ? $seal(meta(it)) : it;
      };
    });
  }, {
    "51": 51,
    "66": 66,
    "83": 83
  }],
  205: [function (_dereq_, module, exports) {
    // 19.1.3.19 Object.setPrototypeOf(O, proto)
    var $export = _dereq_(33);

    $export($export.S, 'Object', {
      setPrototypeOf: _dereq_(99).set
    });
  }, {
    "33": 33,
    "99": 99
  }],
  206: [function (_dereq_, module, exports) {
    'use strict'; // 19.1.3.6 Object.prototype.toString()

    var classof = _dereq_(17);

    var test = {};
    test[_dereq_(128)('toStringTag')] = 'z';

    if (test + '' != '[object z]') {
      _dereq_(94)(Object.prototype, 'toString', function toString() {
        return '[object ' + classof(this) + ']';
      }, true);
    }
  }, {
    "128": 128,
    "17": 17,
    "94": 94
  }],
  207: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var $parseFloat = _dereq_(86); // 18.2.4 parseFloat(string)


    $export($export.G + $export.F * (parseFloat != $parseFloat), {
      parseFloat: $parseFloat
    });
  }, {
    "33": 33,
    "86": 86
  }],
  208: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var $parseInt = _dereq_(87); // 18.2.5 parseInt(string, radix)


    $export($export.G + $export.F * (parseInt != $parseInt), {
      parseInt: $parseInt
    });
  }, {
    "33": 33,
    "87": 87
  }],
  209: [function (_dereq_, module, exports) {
    'use strict';

    var LIBRARY = _dereq_(60);

    var global = _dereq_(40);

    var ctx = _dereq_(25);

    var classof = _dereq_(17);

    var $export = _dereq_(33);

    var isObject = _dereq_(51);

    var aFunction = _dereq_(3);

    var anInstance = _dereq_(6);

    var forOf = _dereq_(39);

    var speciesConstructor = _dereq_(104);

    var task = _dereq_(113).set;

    var microtask = _dereq_(68)();

    var newPromiseCapabilityModule = _dereq_(69);

    var perform = _dereq_(90);

    var promiseResolve = _dereq_(91);

    var PROMISE = 'Promise';
    var TypeError = global.TypeError;
    var process = global.process;
    var $Promise = global[PROMISE];
    var isNode = classof(process) == 'process';

    var empty = function empty() {
      /* empty */
    };

    var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
    var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
    var USE_NATIVE = !!function () {
      try {
        // correct subclassing with @@species support
        var promise = $Promise.resolve(1);

        var FakePromise = (promise.constructor = {})[_dereq_(128)('species')] = function (exec) {
          exec(empty, empty);
        }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


        return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
      } catch (e) {
        /* empty */
      }
    }(); // helpers

    var sameConstructor = LIBRARY ? function (a, b) {
      // with library wrapper special case
      return a === b || a === $Promise && b === Wrapper;
    } : function (a, b) {
      return a === b;
    };

    var isThenable = function isThenable(it) {
      var then;
      return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
    };

    var notify = function notify(promise, isReject) {
      if (promise._n) return;
      promise._n = true;
      var chain = promise._c;
      microtask(function () {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;

        var run = function run(reaction) {
          var handler = ok ? reaction.ok : reaction.fail;
          var resolve = reaction.resolve;
          var reject = reaction.reject;
          var domain = reaction.domain;
          var result, then;

          try {
            if (handler) {
              if (!ok) {
                if (promise._h == 2) onHandleUnhandled(promise);
                promise._h = 1;
              }

              if (handler === true) result = value;else {
                if (domain) domain.enter();
                result = handler(value);
                if (domain) domain.exit();
              }

              if (result === reaction.promise) {
                reject(TypeError('Promise-chain cycle'));
              } else if (then = isThenable(result)) {
                then.call(result, resolve, reject);
              } else resolve(result);
            } else reject(value);
          } catch (e) {
            reject(e);
          }
        };

        while (chain.length > i) {
          run(chain[i++]);
        } // variable length - can't use forEach


        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) onUnhandled(promise);
      });
    };

    var onUnhandled = function onUnhandled(promise) {
      task.call(global, function () {
        var value = promise._v;
        var unhandled = isUnhandled(promise);
        var result, handler, console;

        if (unhandled) {
          result = perform(function () {
            if (isNode) {
              process.emit('unhandledRejection', value, promise);
            } else if (handler = global.onunhandledrejection) {
              handler({
                promise: promise,
                reason: value
              });
            } else if ((console = global.console) && console.error) {
              console.error('Unhandled promise rejection', value);
            }
          }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

          promise._h = isNode || isUnhandled(promise) ? 2 : 1;
        }

        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
      });
    };

    var isUnhandled = function isUnhandled(promise) {
      if (promise._h == 1) return false;
      var chain = promise._a || promise._c;
      var i = 0;
      var reaction;

      while (chain.length > i) {
        reaction = chain[i++];
        if (reaction.fail || !isUnhandled(reaction.promise)) return false;
      }

      return true;
    };

    var onHandleUnhandled = function onHandleUnhandled(promise) {
      task.call(global, function () {
        var handler;

        if (isNode) {
          process.emit('rejectionHandled', promise);
        } else if (handler = global.onrejectionhandled) {
          handler({
            promise: promise,
            reason: promise._v
          });
        }
      });
    };

    var $reject = function $reject(value) {
      var promise = this;
      if (promise._d) return;
      promise._d = true;
      promise = promise._w || promise; // unwrap

      promise._v = value;
      promise._s = 2;
      if (!promise._a) promise._a = promise._c.slice();
      notify(promise, true);
    };

    var $resolve = function $resolve(value) {
      var promise = this;
      var then;
      if (promise._d) return;
      promise._d = true;
      promise = promise._w || promise; // unwrap

      try {
        if (promise === value) throw TypeError("Promise can't be resolved itself");

        if (then = isThenable(value)) {
          microtask(function () {
            var wrapper = {
              _w: promise,
              _d: false
            }; // wrap

            try {
              then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
            } catch (e) {
              $reject.call(wrapper, e);
            }
          });
        } else {
          promise._v = value;
          promise._s = 1;
          notify(promise, false);
        }
      } catch (e) {
        $reject.call({
          _w: promise,
          _d: false
        }, e); // wrap
      }
    }; // constructor polyfill


    if (!USE_NATIVE) {
      // 25.4.3.1 Promise(executor)
      $Promise = function Promise(executor) {
        anInstance(this, $Promise, PROMISE, '_h');
        aFunction(executor);
        Internal.call(this);

        try {
          executor(ctx($resolve, this, 1), ctx($reject, this, 1));
        } catch (err) {
          $reject.call(this, err);
        }
      }; // eslint-disable-next-line no-unused-vars


      Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions

        this._a = undefined; // <- checked in isUnhandled reactions

        this._s = 0; // <- state

        this._d = false; // <- done

        this._v = undefined; // <- value

        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

        this._n = false; // <- notify
      };

      Internal.prototype = _dereq_(93)($Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
          var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
          reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
          reaction.fail = typeof onRejected == 'function' && onRejected;
          reaction.domain = isNode ? process.domain : undefined;

          this._c.push(reaction);

          if (this._a) this._a.push(reaction);
          if (this._s) notify(this, false);
          return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        'catch': function _catch(onRejected) {
          return this.then(undefined, onRejected);
        }
      });

      OwnPromiseCapability = function OwnPromiseCapability() {
        var promise = new Internal();
        this.promise = promise;
        this.resolve = ctx($resolve, promise, 1);
        this.reject = ctx($reject, promise, 1);
      };

      newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
        return sameConstructor($Promise, C) ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
      };
    }

    $export($export.G + $export.W + $export.F * !USE_NATIVE, {
      Promise: $Promise
    });

    _dereq_(101)($Promise, PROMISE);

    _dereq_(100)(PROMISE);

    Wrapper = _dereq_(23)[PROMISE]; // statics

    $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
      // 25.4.4.5 Promise.reject(r)
      reject: function reject(r) {
        var capability = newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
      }
    });
    $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
      // 25.4.4.6 Promise.resolve(x)
      resolve: function resolve(x) {
        // instanceof instead of internal slot check because we should fix it without replacement native Promise core
        if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
        return promiseResolve(this, x);
      }
    });
    $export($export.S + $export.F * !(USE_NATIVE && _dereq_(56)(function (iter) {
      $Promise.all(iter)['catch'](empty);
    })), PROMISE, {
      // 25.4.4.1 Promise.all(iterable)
      all: function all(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = perform(function () {
          var values = [];
          var index = 0;
          var remaining = 1;
          forOf(iterable, false, function (promise) {
            var $index = index++;
            var alreadyCalled = false;
            values.push(undefined);
            remaining++;
            C.resolve(promise).then(function (value) {
              if (alreadyCalled) return;
              alreadyCalled = true;
              values[$index] = value;
              --remaining || resolve(values);
            }, reject);
          });
          --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
      },
      // 25.4.4.4 Promise.race(iterable)
      race: function race(iterable) {
        var C = this;
        var capability = newPromiseCapability(C);
        var reject = capability.reject;
        var result = perform(function () {
          forOf(iterable, false, function (promise) {
            C.resolve(promise).then(capability.resolve, reject);
          });
        });
        if (result.e) reject(result.v);
        return capability.promise;
      }
    });
  }, {
    "100": 100,
    "101": 101,
    "104": 104,
    "113": 113,
    "128": 128,
    "17": 17,
    "23": 23,
    "25": 25,
    "3": 3,
    "33": 33,
    "39": 39,
    "40": 40,
    "51": 51,
    "56": 56,
    "6": 6,
    "60": 60,
    "68": 68,
    "69": 69,
    "90": 90,
    "91": 91,
    "93": 93
  }],
  210: [function (_dereq_, module, exports) {
    // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
    var $export = _dereq_(33);

    var aFunction = _dereq_(3);

    var anObject = _dereq_(7);

    var rApply = (_dereq_(40).Reflect || {}).apply;
    var fApply = Function.apply; // MS Edge argumentsList argument is optional

    $export($export.S + $export.F * !_dereq_(35)(function () {
      rApply(function () {
        /* empty */
      });
    }), 'Reflect', {
      apply: function apply(target, thisArgument, argumentsList) {
        var T = aFunction(target);
        var L = anObject(argumentsList);
        return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
      }
    });
  }, {
    "3": 3,
    "33": 33,
    "35": 35,
    "40": 40,
    "7": 7
  }],
  211: [function (_dereq_, module, exports) {
    // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
    var $export = _dereq_(33);

    var create = _dereq_(71);

    var aFunction = _dereq_(3);

    var anObject = _dereq_(7);

    var isObject = _dereq_(51);

    var fails = _dereq_(35);

    var bind = _dereq_(16);

    var rConstruct = (_dereq_(40).Reflect || {}).construct; // MS Edge supports only 2 arguments and argumentsList argument is optional
    // FF Nightly sets third argument as `new.target`, but does not create `this` from it

    var NEW_TARGET_BUG = fails(function () {
      function F() {
        /* empty */
      }

      return !(rConstruct(function () {
        /* empty */
      }, [], F) instanceof F);
    });
    var ARGS_BUG = !fails(function () {
      rConstruct(function () {
        /* empty */
      });
    });
    $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
      construct: function construct(Target, args
      /* , newTarget */
      ) {
        aFunction(Target);
        anObject(args);
        var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
        if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);

        if (Target == newTarget) {
          // w/o altered newTarget, optimization for 0-4 arguments
          switch (args.length) {
            case 0:
              return new Target();

            case 1:
              return new Target(args[0]);

            case 2:
              return new Target(args[0], args[1]);

            case 3:
              return new Target(args[0], args[1], args[2]);

            case 4:
              return new Target(args[0], args[1], args[2], args[3]);
          } // w/o altered newTarget, lot of arguments case


          var $args = [null];
          $args.push.apply($args, args);
          return new (bind.apply(Target, $args))();
        } // with altered newTarget, not support built-in constructors


        var proto = newTarget.prototype;
        var instance = create(isObject(proto) ? proto : Object.prototype);
        var result = Function.apply.call(Target, instance, args);
        return isObject(result) ? result : instance;
      }
    });
  }, {
    "16": 16,
    "3": 3,
    "33": 33,
    "35": 35,
    "40": 40,
    "51": 51,
    "7": 7,
    "71": 71
  }],
  212: [function (_dereq_, module, exports) {
    // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
    var dP = _dereq_(72);

    var $export = _dereq_(33);

    var anObject = _dereq_(7);

    var toPrimitive = _dereq_(120); // MS Edge has broken Reflect.defineProperty - throwing instead of returning false


    $export($export.S + $export.F * _dereq_(35)(function () {
      // eslint-disable-next-line no-undef
      Reflect.defineProperty(dP.f({}, 1, {
        value: 1
      }), 1, {
        value: 2
      });
    }), 'Reflect', {
      defineProperty: function defineProperty(target, propertyKey, attributes) {
        anObject(target);
        propertyKey = toPrimitive(propertyKey, true);
        anObject(attributes);

        try {
          dP.f(target, propertyKey, attributes);
          return true;
        } catch (e) {
          return false;
        }
      }
    });
  }, {
    "120": 120,
    "33": 33,
    "35": 35,
    "7": 7,
    "72": 72
  }],
  213: [function (_dereq_, module, exports) {
    // 26.1.4 Reflect.deleteProperty(target, propertyKey)
    var $export = _dereq_(33);

    var gOPD = _dereq_(75).f;

    var anObject = _dereq_(7);

    $export($export.S, 'Reflect', {
      deleteProperty: function deleteProperty(target, propertyKey) {
        var desc = gOPD(anObject(target), propertyKey);
        return desc && !desc.configurable ? false : delete target[propertyKey];
      }
    });
  }, {
    "33": 33,
    "7": 7,
    "75": 75
  }],
  214: [function (_dereq_, module, exports) {
    'use strict'; // 26.1.5 Reflect.enumerate(target)

    var $export = _dereq_(33);

    var anObject = _dereq_(7);

    var Enumerate = function Enumerate(iterated) {
      this._t = anObject(iterated); // target

      this._i = 0; // next index

      var keys = this._k = []; // keys

      var key;

      for (key in iterated) {
        keys.push(key);
      }
    };

    _dereq_(54)(Enumerate, 'Object', function () {
      var that = this;
      var keys = that._k;
      var key;

      do {
        if (that._i >= keys.length) return {
          value: undefined,
          done: true
        };
      } while (!((key = keys[that._i++]) in that._t));

      return {
        value: key,
        done: false
      };
    });

    $export($export.S, 'Reflect', {
      enumerate: function enumerate(target) {
        return new Enumerate(target);
      }
    });
  }, {
    "33": 33,
    "54": 54,
    "7": 7
  }],
  215: [function (_dereq_, module, exports) {
    // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
    var gOPD = _dereq_(75);

    var $export = _dereq_(33);

    var anObject = _dereq_(7);

    $export($export.S, 'Reflect', {
      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
        return gOPD.f(anObject(target), propertyKey);
      }
    });
  }, {
    "33": 33,
    "7": 7,
    "75": 75
  }],
  216: [function (_dereq_, module, exports) {
    // 26.1.8 Reflect.getPrototypeOf(target)
    var $export = _dereq_(33);

    var getProto = _dereq_(79);

    var anObject = _dereq_(7);

    $export($export.S, 'Reflect', {
      getPrototypeOf: function getPrototypeOf(target) {
        return getProto(anObject(target));
      }
    });
  }, {
    "33": 33,
    "7": 7,
    "79": 79
  }],
  217: [function (_dereq_, module, exports) {
    // 26.1.6 Reflect.get(target, propertyKey [, receiver])
    var gOPD = _dereq_(75);

    var getPrototypeOf = _dereq_(79);

    var has = _dereq_(41);

    var $export = _dereq_(33);

    var isObject = _dereq_(51);

    var anObject = _dereq_(7);

    function get(target, propertyKey
    /* , receiver */
    ) {
      var receiver = arguments.length < 3 ? target : arguments[2];
      var desc, proto;
      if (anObject(target) === receiver) return target[propertyKey];
      if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
      if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
    }

    $export($export.S, 'Reflect', {
      get: get
    });
  }, {
    "33": 33,
    "41": 41,
    "51": 51,
    "7": 7,
    "75": 75,
    "79": 79
  }],
  218: [function (_dereq_, module, exports) {
    // 26.1.9 Reflect.has(target, propertyKey)
    var $export = _dereq_(33);

    $export($export.S, 'Reflect', {
      has: function has(target, propertyKey) {
        return propertyKey in target;
      }
    });
  }, {
    "33": 33
  }],
  219: [function (_dereq_, module, exports) {
    // 26.1.10 Reflect.isExtensible(target)
    var $export = _dereq_(33);

    var anObject = _dereq_(7);

    var $isExtensible = Object.isExtensible;
    $export($export.S, 'Reflect', {
      isExtensible: function isExtensible(target) {
        anObject(target);
        return $isExtensible ? $isExtensible(target) : true;
      }
    });
  }, {
    "33": 33,
    "7": 7
  }],
  220: [function (_dereq_, module, exports) {
    // 26.1.11 Reflect.ownKeys(target)
    var $export = _dereq_(33);

    $export($export.S, 'Reflect', {
      ownKeys: _dereq_(85)
    });
  }, {
    "33": 33,
    "85": 85
  }],
  221: [function (_dereq_, module, exports) {
    // 26.1.12 Reflect.preventExtensions(target)
    var $export = _dereq_(33);

    var anObject = _dereq_(7);

    var $preventExtensions = Object.preventExtensions;
    $export($export.S, 'Reflect', {
      preventExtensions: function preventExtensions(target) {
        anObject(target);

        try {
          if ($preventExtensions) $preventExtensions(target);
          return true;
        } catch (e) {
          return false;
        }
      }
    });
  }, {
    "33": 33,
    "7": 7
  }],
  222: [function (_dereq_, module, exports) {
    // 26.1.14 Reflect.setPrototypeOf(target, proto)
    var $export = _dereq_(33);

    var setProto = _dereq_(99);

    if (setProto) $export($export.S, 'Reflect', {
      setPrototypeOf: function setPrototypeOf(target, proto) {
        setProto.check(target, proto);

        try {
          setProto.set(target, proto);
          return true;
        } catch (e) {
          return false;
        }
      }
    });
  }, {
    "33": 33,
    "99": 99
  }],
  223: [function (_dereq_, module, exports) {
    // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
    var dP = _dereq_(72);

    var gOPD = _dereq_(75);

    var getPrototypeOf = _dereq_(79);

    var has = _dereq_(41);

    var $export = _dereq_(33);

    var createDesc = _dereq_(92);

    var anObject = _dereq_(7);

    var isObject = _dereq_(51);

    function set(target, propertyKey, V
    /* , receiver */
    ) {
      var receiver = arguments.length < 4 ? target : arguments[3];
      var ownDesc = gOPD.f(anObject(target), propertyKey);
      var existingDescriptor, proto;

      if (!ownDesc) {
        if (isObject(proto = getPrototypeOf(target))) {
          return set(proto, propertyKey, V, receiver);
        }

        ownDesc = createDesc(0);
      }

      if (has(ownDesc, 'value')) {
        if (ownDesc.writable === false || !isObject(receiver)) return false;
        existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
        existingDescriptor.value = V;
        dP.f(receiver, propertyKey, existingDescriptor);
        return true;
      }

      return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
    }

    $export($export.S, 'Reflect', {
      set: set
    });
  }, {
    "33": 33,
    "41": 41,
    "51": 51,
    "7": 7,
    "72": 72,
    "75": 75,
    "79": 79,
    "92": 92
  }],
  224: [function (_dereq_, module, exports) {
    var global = _dereq_(40);

    var inheritIfRequired = _dereq_(45);

    var dP = _dereq_(72).f;

    var gOPN = _dereq_(77).f;

    var isRegExp = _dereq_(52);

    var $flags = _dereq_(37);

    var $RegExp = global.RegExp;
    var Base = $RegExp;
    var proto = $RegExp.prototype;
    var re1 = /a/g;
    var re2 = /a/g; // "new" creates a new object, old webkit buggy here

    var CORRECT_NEW = new $RegExp(re1) !== re1;

    if (_dereq_(29) && (!CORRECT_NEW || _dereq_(35)(function () {
      re2[_dereq_(128)('match')] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

      return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
    }))) {
      $RegExp = function RegExp(p, f) {
        var tiRE = this instanceof $RegExp;
        var piRE = isRegExp(p);
        var fiU = f === undefined;
        return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
      };

      var proxy = function proxy(key) {
        key in $RegExp || dP($RegExp, key, {
          configurable: true,
          get: function get() {
            return Base[key];
          },
          set: function set(it) {
            Base[key] = it;
          }
        });
      };

      for (var keys = gOPN(Base), i = 0; keys.length > i;) {
        proxy(keys[i++]);
      }

      proto.constructor = $RegExp;
      $RegExp.prototype = proto;

      _dereq_(94)(global, 'RegExp', $RegExp);
    }

    _dereq_(100)('RegExp');
  }, {
    "100": 100,
    "128": 128,
    "29": 29,
    "35": 35,
    "37": 37,
    "40": 40,
    "45": 45,
    "52": 52,
    "72": 72,
    "77": 77,
    "94": 94
  }],
  225: [function (_dereq_, module, exports) {
    // 21.2.5.3 get RegExp.prototype.flags()
    if (_dereq_(29) && /./g.flags != 'g') _dereq_(72).f(RegExp.prototype, 'flags', {
      configurable: true,
      get: _dereq_(37)
    });
  }, {
    "29": 29,
    "37": 37,
    "72": 72
  }],
  226: [function (_dereq_, module, exports) {
    // @@match logic
    _dereq_(36)('match', 1, function (defined, MATCH, $match) {
      // 21.1.3.11 String.prototype.match(regexp)
      return [function match(regexp) {
        'use strict';

        var O = defined(this);
        var fn = regexp == undefined ? undefined : regexp[MATCH];
        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
      }, $match];
    });
  }, {
    "36": 36
  }],
  227: [function (_dereq_, module, exports) {
    // @@replace logic
    _dereq_(36)('replace', 2, function (defined, REPLACE, $replace) {
      // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
      return [function replace(searchValue, replaceValue) {
        'use strict';

        var O = defined(this);
        var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
        return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
      }, $replace];
    });
  }, {
    "36": 36
  }],
  228: [function (_dereq_, module, exports) {
    // @@search logic
    _dereq_(36)('search', 1, function (defined, SEARCH, $search) {
      // 21.1.3.15 String.prototype.search(regexp)
      return [function search(regexp) {
        'use strict';

        var O = defined(this);
        var fn = regexp == undefined ? undefined : regexp[SEARCH];
        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
      }, $search];
    });
  }, {
    "36": 36
  }],
  229: [function (_dereq_, module, exports) {
    // @@split logic
    _dereq_(36)('split', 2, function (defined, SPLIT, $split) {
      'use strict';

      var isRegExp = _dereq_(52);

      var _split = $split;
      var $push = [].push;
      var $SPLIT = 'split';
      var LENGTH = 'length';
      var LAST_INDEX = 'lastIndex';

      if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
        var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
        // based on es5-shim implementation, need to rework it

        $split = function $split(separator, limit) {
          var string = String(this);
          if (separator === undefined && limit === 0) return []; // If `separator` is not a regex, use native split

          if (!isRegExp(separator)) return _split.call(string, separator, limit);
          var output = [];
          var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
          var lastLastIndex = 0;
          var splitLimit = limit === undefined ? 4294967295 : limit >>> 0; // Make `global` and avoid `lastIndex` issues by working with a copy

          var separatorCopy = new RegExp(separator.source, flags + 'g');
          var separator2, match, lastIndex, lastLength, i; // Doesn't need flags gy, but they don't hurt

          if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);

          while (match = separatorCopy.exec(string)) {
            // `separatorCopy.lastIndex` is not reliable cross-browser
            lastIndex = match.index + match[0][LENGTH];

            if (lastIndex > lastLastIndex) {
              output.push(string.slice(lastLastIndex, match.index)); // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
              // eslint-disable-next-line no-loop-func

              if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
                for (i = 1; i < arguments[LENGTH] - 2; i++) {
                  if (arguments[i] === undefined) match[i] = undefined;
                }
              });
              if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
              lastLength = match[0][LENGTH];
              lastLastIndex = lastIndex;
              if (output[LENGTH] >= splitLimit) break;
            }

            if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
          }

          if (lastLastIndex === string[LENGTH]) {
            if (lastLength || !separatorCopy.test('')) output.push('');
          } else output.push(string.slice(lastLastIndex));

          return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
        }; // Chakra, V8

      } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
        $split = function $split(separator, limit) {
          return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
        };
      } // 21.1.3.17 String.prototype.split(separator, limit)


      return [function split(separator, limit) {
        var O = defined(this);
        var fn = separator == undefined ? undefined : separator[SPLIT];
        return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
      }, $split];
    });
  }, {
    "36": 36,
    "52": 52
  }],
  230: [function (_dereq_, module, exports) {
    'use strict';

    _dereq_(225);

    var anObject = _dereq_(7);

    var $flags = _dereq_(37);

    var DESCRIPTORS = _dereq_(29);

    var TO_STRING = 'toString';
    var $toString = /./[TO_STRING];

    var define = function define(fn) {
      _dereq_(94)(RegExp.prototype, TO_STRING, fn, true);
    }; // 21.2.5.14 RegExp.prototype.toString()


    if (_dereq_(35)(function () {
      return $toString.call({
        source: 'a',
        flags: 'b'
      }) != '/a/b';
    })) {
      define(function toString() {
        var R = anObject(this);
        return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
      }); // FF44- RegExp#toString has a wrong name
    } else if ($toString.name != TO_STRING) {
      define(function toString() {
        return $toString.call(this);
      });
    }
  }, {
    "225": 225,
    "29": 29,
    "35": 35,
    "37": 37,
    "7": 7,
    "94": 94
  }],
  231: [function (_dereq_, module, exports) {
    'use strict';

    var strong = _dereq_(19);

    var validate = _dereq_(125);

    var SET = 'Set'; // 23.2 Set Objects

    module.exports = _dereq_(22)(SET, function (get) {
      return function Set() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
      };
    }, {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
      }
    }, strong);
  }, {
    "125": 125,
    "19": 19,
    "22": 22
  }],
  232: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.2 String.prototype.anchor(name)

    _dereq_(108)('anchor', function (createHTML) {
      return function anchor(name) {
        return createHTML(this, 'a', 'name', name);
      };
    });
  }, {
    "108": 108
  }],
  233: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.3 String.prototype.big()

    _dereq_(108)('big', function (createHTML) {
      return function big() {
        return createHTML(this, 'big', '', '');
      };
    });
  }, {
    "108": 108
  }],
  234: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.4 String.prototype.blink()

    _dereq_(108)('blink', function (createHTML) {
      return function blink() {
        return createHTML(this, 'blink', '', '');
      };
    });
  }, {
    "108": 108
  }],
  235: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.5 String.prototype.bold()

    _dereq_(108)('bold', function (createHTML) {
      return function bold() {
        return createHTML(this, 'b', '', '');
      };
    });
  }, {
    "108": 108
  }],
  236: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $at = _dereq_(106)(false);

    $export($export.P, 'String', {
      // 21.1.3.3 String.prototype.codePointAt(pos)
      codePointAt: function codePointAt(pos) {
        return $at(this, pos);
      }
    });
  }, {
    "106": 106,
    "33": 33
  }],
  237: [function (_dereq_, module, exports) {
    // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
    'use strict';

    var $export = _dereq_(33);

    var toLength = _dereq_(118);

    var context = _dereq_(107);

    var ENDS_WITH = 'endsWith';
    var $endsWith = ''[ENDS_WITH];
    $export($export.P + $export.F * _dereq_(34)(ENDS_WITH), 'String', {
      endsWith: function endsWith(searchString
      /* , endPosition = @length */
      ) {
        var that = context(this, searchString, ENDS_WITH);
        var endPosition = arguments.length > 1 ? arguments[1] : undefined;
        var len = toLength(that.length);
        var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
        var search = String(searchString);
        return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
      }
    });
  }, {
    "107": 107,
    "118": 118,
    "33": 33,
    "34": 34
  }],
  238: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.6 String.prototype.fixed()

    _dereq_(108)('fixed', function (createHTML) {
      return function fixed() {
        return createHTML(this, 'tt', '', '');
      };
    });
  }, {
    "108": 108
  }],
  239: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.7 String.prototype.fontcolor(color)

    _dereq_(108)('fontcolor', function (createHTML) {
      return function fontcolor(color) {
        return createHTML(this, 'font', 'color', color);
      };
    });
  }, {
    "108": 108
  }],
  240: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.8 String.prototype.fontsize(size)

    _dereq_(108)('fontsize', function (createHTML) {
      return function fontsize(size) {
        return createHTML(this, 'font', 'size', size);
      };
    });
  }, {
    "108": 108
  }],
  241: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var toAbsoluteIndex = _dereq_(114);

    var fromCharCode = String.fromCharCode;
    var $fromCodePoint = String.fromCodePoint; // length should be 1, old FF problem

    $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
      // 21.1.2.2 String.fromCodePoint(...codePoints)
      fromCodePoint: function fromCodePoint(x) {
        // eslint-disable-line no-unused-vars
        var res = [];
        var aLen = arguments.length;
        var i = 0;
        var code;

        while (aLen > i) {
          code = +arguments[i++];
          if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
          res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
        }

        return res.join('');
      }
    });
  }, {
    "114": 114,
    "33": 33
  }],
  242: [function (_dereq_, module, exports) {
    // 21.1.3.7 String.prototype.includes(searchString, position = 0)
    'use strict';

    var $export = _dereq_(33);

    var context = _dereq_(107);

    var INCLUDES = 'includes';
    $export($export.P + $export.F * _dereq_(34)(INCLUDES), 'String', {
      includes: function includes(searchString
      /* , position = 0 */
      ) {
        return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
      }
    });
  }, {
    "107": 107,
    "33": 33,
    "34": 34
  }],
  243: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.9 String.prototype.italics()

    _dereq_(108)('italics', function (createHTML) {
      return function italics() {
        return createHTML(this, 'i', '', '');
      };
    });
  }, {
    "108": 108
  }],
  244: [function (_dereq_, module, exports) {
    'use strict';

    var $at = _dereq_(106)(true); // 21.1.3.27 String.prototype[@@iterator]()


    _dereq_(55)(String, 'String', function (iterated) {
      this._t = String(iterated); // target

      this._i = 0; // next index
      // 21.1.5.2.1 %StringIteratorPrototype%.next()
    }, function () {
      var O = this._t;
      var index = this._i;
      var point;
      if (index >= O.length) return {
        value: undefined,
        done: true
      };
      point = $at(O, index);
      this._i += point.length;
      return {
        value: point,
        done: false
      };
    });
  }, {
    "106": 106,
    "55": 55
  }],
  245: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.10 String.prototype.link(url)

    _dereq_(108)('link', function (createHTML) {
      return function link(url) {
        return createHTML(this, 'a', 'href', url);
      };
    });
  }, {
    "108": 108
  }],
  246: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var toIObject = _dereq_(117);

    var toLength = _dereq_(118);

    $export($export.S, 'String', {
      // 21.1.2.4 String.raw(callSite, ...substitutions)
      raw: function raw(callSite) {
        var tpl = toIObject(callSite.raw);
        var len = toLength(tpl.length);
        var aLen = arguments.length;
        var res = [];
        var i = 0;

        while (len > i) {
          res.push(String(tpl[i++]));
          if (i < aLen) res.push(String(arguments[i]));
        }

        return res.join('');
      }
    });
  }, {
    "117": 117,
    "118": 118,
    "33": 33
  }],
  247: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    $export($export.P, 'String', {
      // 21.1.3.13 String.prototype.repeat(count)
      repeat: _dereq_(110)
    });
  }, {
    "110": 110,
    "33": 33
  }],
  248: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.11 String.prototype.small()

    _dereq_(108)('small', function (createHTML) {
      return function small() {
        return createHTML(this, 'small', '', '');
      };
    });
  }, {
    "108": 108
  }],
  249: [function (_dereq_, module, exports) {
    // 21.1.3.18 String.prototype.startsWith(searchString [, position ])
    'use strict';

    var $export = _dereq_(33);

    var toLength = _dereq_(118);

    var context = _dereq_(107);

    var STARTS_WITH = 'startsWith';
    var $startsWith = ''[STARTS_WITH];
    $export($export.P + $export.F * _dereq_(34)(STARTS_WITH), 'String', {
      startsWith: function startsWith(searchString
      /* , position = 0 */
      ) {
        var that = context(this, searchString, STARTS_WITH);
        var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
        var search = String(searchString);
        return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
      }
    });
  }, {
    "107": 107,
    "118": 118,
    "33": 33,
    "34": 34
  }],
  250: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.12 String.prototype.strike()

    _dereq_(108)('strike', function (createHTML) {
      return function strike() {
        return createHTML(this, 'strike', '', '');
      };
    });
  }, {
    "108": 108
  }],
  251: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.13 String.prototype.sub()

    _dereq_(108)('sub', function (createHTML) {
      return function sub() {
        return createHTML(this, 'sub', '', '');
      };
    });
  }, {
    "108": 108
  }],
  252: [function (_dereq_, module, exports) {
    'use strict'; // B.2.3.14 String.prototype.sup()

    _dereq_(108)('sup', function (createHTML) {
      return function sup() {
        return createHTML(this, 'sup', '', '');
      };
    });
  }, {
    "108": 108
  }],
  253: [function (_dereq_, module, exports) {
    'use strict'; // 21.1.3.25 String.prototype.trim()

    _dereq_(111)('trim', function ($trim) {
      return function trim() {
        return $trim(this, 3);
      };
    });
  }, {
    "111": 111
  }],
  254: [function (_dereq_, module, exports) {
    'use strict'; // ECMAScript 6 symbols shim

    var global = _dereq_(40);

    var has = _dereq_(41);

    var DESCRIPTORS = _dereq_(29);

    var $export = _dereq_(33);

    var redefine = _dereq_(94);

    var META = _dereq_(66).KEY;

    var $fails = _dereq_(35);

    var shared = _dereq_(103);

    var setToStringTag = _dereq_(101);

    var uid = _dereq_(124);

    var wks = _dereq_(128);

    var wksExt = _dereq_(127);

    var wksDefine = _dereq_(126);

    var keyOf = _dereq_(59);

    var enumKeys = _dereq_(32);

    var isArray = _dereq_(49);

    var anObject = _dereq_(7);

    var toIObject = _dereq_(117);

    var toPrimitive = _dereq_(120);

    var createDesc = _dereq_(92);

    var _create = _dereq_(71);

    var gOPNExt = _dereq_(76);

    var $GOPD = _dereq_(75);

    var $DP = _dereq_(72);

    var $keys = _dereq_(81);

    var gOPD = $GOPD.f;
    var dP = $DP.f;
    var gOPN = gOPNExt.f;
    var $Symbol = global.Symbol;
    var $JSON = global.JSON;

    var _stringify = $JSON && $JSON.stringify;

    var PROTOTYPE = 'prototype';
    var HIDDEN = wks('_hidden');
    var TO_PRIMITIVE = wks('toPrimitive');
    var isEnum = {}.propertyIsEnumerable;
    var SymbolRegistry = shared('symbol-registry');
    var AllSymbols = shared('symbols');
    var OPSymbols = shared('op-symbols');
    var ObjectProto = Object[PROTOTYPE];
    var USE_NATIVE = typeof $Symbol == 'function';
    var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

    var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

    var setSymbolDesc = DESCRIPTORS && $fails(function () {
      return _create(dP({}, 'a', {
        get: function get() {
          return dP(this, 'a', {
            value: 7
          }).a;
        }
      })).a != 7;
    }) ? function (it, key, D) {
      var protoDesc = gOPD(ObjectProto, key);
      if (protoDesc) delete ObjectProto[key];
      dP(it, key, D);
      if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
    } : dP;

    var wrap = function wrap(tag) {
      var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

      sym._k = tag;
      return sym;
    };

    var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
      return _typeof(it) == 'symbol';
    } : function (it) {
      return it instanceof $Symbol;
    };

    var $defineProperty = function defineProperty(it, key, D) {
      if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
      anObject(it);
      key = toPrimitive(key, true);
      anObject(D);

      if (has(AllSymbols, key)) {
        if (!D.enumerable) {
          if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
          it[HIDDEN][key] = true;
        } else {
          if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
          D = _create(D, {
            enumerable: createDesc(0, false)
          });
        }

        return setSymbolDesc(it, key, D);
      }

      return dP(it, key, D);
    };

    var $defineProperties = function defineProperties(it, P) {
      anObject(it);
      var keys = enumKeys(P = toIObject(P));
      var i = 0;
      var l = keys.length;
      var key;

      while (l > i) {
        $defineProperty(it, key = keys[i++], P[key]);
      }

      return it;
    };

    var $create = function create(it, P) {
      return P === undefined ? _create(it) : $defineProperties(_create(it), P);
    };

    var $propertyIsEnumerable = function propertyIsEnumerable(key) {
      var E = isEnum.call(this, key = toPrimitive(key, true));
      if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
      return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
    };

    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
      it = toIObject(it);
      key = toPrimitive(key, true);
      if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
      var D = gOPD(it, key);
      if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
      return D;
    };

    var $getOwnPropertyNames = function getOwnPropertyNames(it) {
      var names = gOPN(toIObject(it));
      var result = [];
      var i = 0;
      var key;

      while (names.length > i) {
        if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
      }

      return result;
    };

    var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
      var IS_OP = it === ObjectProto;
      var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
      var result = [];
      var i = 0;
      var key;

      while (names.length > i) {
        if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
      }

      return result;
    }; // 19.4.1.1 Symbol([description])


    if (!USE_NATIVE) {
      $Symbol = function _Symbol2() {
        if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

        var $set = function $set(value) {
          if (this === ObjectProto) $set.call(OPSymbols, value);
          if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
          setSymbolDesc(this, tag, createDesc(1, value));
        };

        if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
          configurable: true,
          set: $set
        });
        return wrap(tag);
      };

      redefine($Symbol[PROTOTYPE], 'toString', function toString() {
        return this._k;
      });
      $GOPD.f = $getOwnPropertyDescriptor;
      $DP.f = $defineProperty;
      _dereq_(77).f = gOPNExt.f = $getOwnPropertyNames;
      _dereq_(82).f = $propertyIsEnumerable;
      _dereq_(78).f = $getOwnPropertySymbols;

      if (DESCRIPTORS && !_dereq_(60)) {
        redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
      }

      wksExt.f = function (name) {
        return wrap(wks(name));
      };
    }

    $export($export.G + $export.W + $export.F * !USE_NATIVE, {
      Symbol: $Symbol
    });

    for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
      wks(es6Symbols[j++]);
    }

    for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
      wksDefine(wellKnownSymbols[k++]);
    }

    $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
      // 19.4.2.1 Symbol.for(key)
      'for': function _for(key) {
        return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
      },
      // 19.4.2.5 Symbol.keyFor(sym)
      keyFor: function keyFor(key) {
        if (isSymbol(key)) return keyOf(SymbolRegistry, key);
        throw TypeError(key + ' is not a symbol!');
      },
      useSetter: function useSetter() {
        setter = true;
      },
      useSimple: function useSimple() {
        setter = false;
      }
    });
    $export($export.S + $export.F * !USE_NATIVE, 'Object', {
      // 19.1.2.2 Object.create(O [, Properties])
      create: $create,
      // 19.1.2.4 Object.defineProperty(O, P, Attributes)
      defineProperty: $defineProperty,
      // 19.1.2.3 Object.defineProperties(O, Properties)
      defineProperties: $defineProperties,
      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
      getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
      // 19.1.2.7 Object.getOwnPropertyNames(O)
      getOwnPropertyNames: $getOwnPropertyNames,
      // 19.1.2.8 Object.getOwnPropertySymbols(O)
      getOwnPropertySymbols: $getOwnPropertySymbols
    }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

    $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
      var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
      // WebKit converts symbol values to JSON as null
      // V8 throws on boxed symbols

      return _stringify([S]) != '[null]' || _stringify({
        a: S
      }) != '{}' || _stringify(Object(S)) != '{}';
    })), 'JSON', {
      stringify: function stringify(it) {
        if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

        var args = [it];
        var i = 1;
        var replacer, $replacer;

        while (arguments.length > i) {
          args.push(arguments[i++]);
        }

        replacer = args[1];
        if (typeof replacer == 'function') $replacer = replacer;
        if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
          if ($replacer) value = $replacer.call(this, key, value);
          if (!isSymbol(value)) return value;
        };
        args[1] = replacer;
        return _stringify.apply($JSON, args);
      }
    }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

    $Symbol[PROTOTYPE][TO_PRIMITIVE] || _dereq_(42)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

    setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

    setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

    setToStringTag(global.JSON, 'JSON', true);
  }, {
    "101": 101,
    "103": 103,
    "117": 117,
    "120": 120,
    "124": 124,
    "126": 126,
    "127": 127,
    "128": 128,
    "29": 29,
    "32": 32,
    "33": 33,
    "35": 35,
    "40": 40,
    "41": 41,
    "42": 42,
    "49": 49,
    "59": 59,
    "60": 60,
    "66": 66,
    "7": 7,
    "71": 71,
    "72": 72,
    "75": 75,
    "76": 76,
    "77": 77,
    "78": 78,
    "81": 81,
    "82": 82,
    "92": 92,
    "94": 94
  }],
  255: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var $typed = _dereq_(123);

    var buffer = _dereq_(122);

    var anObject = _dereq_(7);

    var toAbsoluteIndex = _dereq_(114);

    var toLength = _dereq_(118);

    var isObject = _dereq_(51);

    var ArrayBuffer = _dereq_(40).ArrayBuffer;

    var speciesConstructor = _dereq_(104);

    var $ArrayBuffer = buffer.ArrayBuffer;
    var $DataView = buffer.DataView;
    var $isView = $typed.ABV && ArrayBuffer.isView;
    var $slice = $ArrayBuffer.prototype.slice;
    var VIEW = $typed.VIEW;
    var ARRAY_BUFFER = 'ArrayBuffer';
    $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), {
      ArrayBuffer: $ArrayBuffer
    });
    $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
      // 24.1.3.1 ArrayBuffer.isView(arg)
      isView: function isView(it) {
        return $isView && $isView(it) || isObject(it) && VIEW in it;
      }
    });
    $export($export.P + $export.U + $export.F * _dereq_(35)(function () {
      return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
    }), ARRAY_BUFFER, {
      // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
      slice: function slice(start, end) {
        if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix

        var len = anObject(this).byteLength;
        var first = toAbsoluteIndex(start, len);

        var _final = toAbsoluteIndex(end === undefined ? len : end, len);

        var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(_final - first));
        var viewS = new $DataView(this);
        var viewT = new $DataView(result);
        var index = 0;

        while (first < _final) {
          viewT.setUint8(index++, viewS.getUint8(first++));
        }

        return result;
      }
    });

    _dereq_(100)(ARRAY_BUFFER);
  }, {
    "100": 100,
    "104": 104,
    "114": 114,
    "118": 118,
    "122": 122,
    "123": 123,
    "33": 33,
    "35": 35,
    "40": 40,
    "51": 51,
    "7": 7
  }],
  256: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    $export($export.G + $export.W + $export.F * !_dereq_(123).ABV, {
      DataView: _dereq_(122).DataView
    });
  }, {
    "122": 122,
    "123": 123,
    "33": 33
  }],
  257: [function (_dereq_, module, exports) {
    _dereq_(121)('Float32', 4, function (init) {
      return function Float32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  258: [function (_dereq_, module, exports) {
    _dereq_(121)('Float64', 8, function (init) {
      return function Float64Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  259: [function (_dereq_, module, exports) {
    _dereq_(121)('Int16', 2, function (init) {
      return function Int16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  260: [function (_dereq_, module, exports) {
    _dereq_(121)('Int32', 4, function (init) {
      return function Int32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  261: [function (_dereq_, module, exports) {
    _dereq_(121)('Int8', 1, function (init) {
      return function Int8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  262: [function (_dereq_, module, exports) {
    _dereq_(121)('Uint16', 2, function (init) {
      return function Uint16Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  263: [function (_dereq_, module, exports) {
    _dereq_(121)('Uint32', 4, function (init) {
      return function Uint32Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  264: [function (_dereq_, module, exports) {
    _dereq_(121)('Uint8', 1, function (init) {
      return function Uint8Array(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    });
  }, {
    "121": 121
  }],
  265: [function (_dereq_, module, exports) {
    _dereq_(121)('Uint8', 1, function (init) {
      return function Uint8ClampedArray(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
      };
    }, true);
  }, {
    "121": 121
  }],
  266: [function (_dereq_, module, exports) {
    'use strict';

    var each = _dereq_(12)(0);

    var redefine = _dereq_(94);

    var meta = _dereq_(66);

    var assign = _dereq_(70);

    var weak = _dereq_(21);

    var isObject = _dereq_(51);

    var fails = _dereq_(35);

    var validate = _dereq_(125);

    var WEAK_MAP = 'WeakMap';
    var getWeak = meta.getWeak;
    var isExtensible = Object.isExtensible;
    var uncaughtFrozenStore = weak.ufstore;
    var tmp = {};
    var InternalMap;

    var wrapper = function wrapper(get) {
      return function WeakMap() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
      };
    };

    var methods = {
      // 23.3.3.3 WeakMap.prototype.get(key)
      get: function get(key) {
        if (isObject(key)) {
          var data = getWeak(key);
          if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
          return data ? data[this._i] : undefined;
        }
      },
      // 23.3.3.5 WeakMap.prototype.set(key, value)
      set: function set(key, value) {
        return weak.def(validate(this, WEAK_MAP), key, value);
      }
    }; // 23.3 WeakMap Objects

    var $WeakMap = module.exports = _dereq_(22)(WEAK_MAP, wrapper, methods, weak, true, true); // IE11 WeakMap frozen keys fix


    if (fails(function () {
      return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7;
    })) {
      InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
      assign(InternalMap.prototype, methods);
      meta.NEED = true;
      each(['delete', 'has', 'get', 'set'], function (key) {
        var proto = $WeakMap.prototype;
        var method = proto[key];
        redefine(proto, key, function (a, b) {
          // store frozen objects on internal weakmap shim
          if (isObject(a) && !isExtensible(a)) {
            if (!this._f) this._f = new InternalMap();

            var result = this._f[key](a, b);

            return key == 'set' ? this : result; // store all the rest on native weakmap
          }

          return method.call(this, a, b);
        });
      });
    }
  }, {
    "12": 12,
    "125": 125,
    "21": 21,
    "22": 22,
    "35": 35,
    "51": 51,
    "66": 66,
    "70": 70,
    "94": 94
  }],
  267: [function (_dereq_, module, exports) {
    'use strict';

    var weak = _dereq_(21);

    var validate = _dereq_(125);

    var WEAK_SET = 'WeakSet'; // 23.4 WeakSet Objects

    _dereq_(22)(WEAK_SET, function (get) {
      return function WeakSet() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
      };
    }, {
      // 23.4.3.1 WeakSet.prototype.add(value)
      add: function add(value) {
        return weak.def(validate(this, WEAK_SET), value, true);
      }
    }, weak, false, true);
  }, {
    "125": 125,
    "21": 21,
    "22": 22
  }],
  268: [function (_dereq_, module, exports) {
    'use strict'; // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap

    var $export = _dereq_(33);

    var flattenIntoArray = _dereq_(38);

    var toObject = _dereq_(119);

    var toLength = _dereq_(118);

    var aFunction = _dereq_(3);

    var arraySpeciesCreate = _dereq_(15);

    $export($export.P, 'Array', {
      flatMap: function flatMap(callbackfn
      /* , thisArg */
      ) {
        var O = toObject(this);
        var sourceLen, A;
        aFunction(callbackfn);
        sourceLen = toLength(O.length);
        A = arraySpeciesCreate(O, 0);
        flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
        return A;
      }
    });

    _dereq_(5)('flatMap');
  }, {
    "118": 118,
    "119": 119,
    "15": 15,
    "3": 3,
    "33": 33,
    "38": 38,
    "5": 5
  }],
  269: [function (_dereq_, module, exports) {
    'use strict'; // https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten

    var $export = _dereq_(33);

    var flattenIntoArray = _dereq_(38);

    var toObject = _dereq_(119);

    var toLength = _dereq_(118);

    var toInteger = _dereq_(116);

    var arraySpeciesCreate = _dereq_(15);

    $export($export.P, 'Array', {
      flatten: function flatten()
      /* depthArg = 1 */
      {
        var depthArg = arguments[0];
        var O = toObject(this);
        var sourceLen = toLength(O.length);
        var A = arraySpeciesCreate(O, 0);
        flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
        return A;
      }
    });

    _dereq_(5)('flatten');
  }, {
    "116": 116,
    "118": 118,
    "119": 119,
    "15": 15,
    "33": 33,
    "38": 38,
    "5": 5
  }],
  270: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/tc39/Array.prototype.includes

    var $export = _dereq_(33);

    var $includes = _dereq_(11)(true);

    $export($export.P, 'Array', {
      includes: function includes(el
      /* , fromIndex = 0 */
      ) {
        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
      }
    });

    _dereq_(5)('includes');
  }, {
    "11": 11,
    "33": 33,
    "5": 5
  }],
  271: [function (_dereq_, module, exports) {
    // https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
    var $export = _dereq_(33);

    var microtask = _dereq_(68)();

    var process = _dereq_(40).process;

    var isNode = _dereq_(18)(process) == 'process';
    $export($export.G, {
      asap: function asap(fn) {
        var domain = isNode && process.domain;
        microtask(domain ? domain.bind(fn) : fn);
      }
    });
  }, {
    "18": 18,
    "33": 33,
    "40": 40,
    "68": 68
  }],
  272: [function (_dereq_, module, exports) {
    // https://github.com/ljharb/proposal-is-error
    var $export = _dereq_(33);

    var cof = _dereq_(18);

    $export($export.S, 'Error', {
      isError: function isError(it) {
        return cof(it) === 'Error';
      }
    });
  }, {
    "18": 18,
    "33": 33
  }],
  273: [function (_dereq_, module, exports) {
    // https://github.com/tc39/proposal-global
    var $export = _dereq_(33);

    $export($export.G, {
      global: _dereq_(40)
    });
  }, {
    "33": 33,
    "40": 40
  }],
  274: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
    _dereq_(97)('Map');
  }, {
    "97": 97
  }],
  275: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
    _dereq_(98)('Map');
  }, {
    "98": 98
  }],
  276: [function (_dereq_, module, exports) {
    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
    var $export = _dereq_(33);

    $export($export.P + $export.R, 'Map', {
      toJSON: _dereq_(20)('Map')
    });
  }, {
    "20": 20,
    "33": 33
  }],
  277: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      clamp: function clamp(x, lower, upper) {
        return Math.min(upper, Math.max(lower, x));
      }
    });
  }, {
    "33": 33
  }],
  278: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      DEG_PER_RAD: Math.PI / 180
    });
  }, {
    "33": 33
  }],
  279: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    var $export = _dereq_(33);

    var RAD_PER_DEG = 180 / Math.PI;
    $export($export.S, 'Math', {
      degrees: function degrees(radians) {
        return radians * RAD_PER_DEG;
      }
    });
  }, {
    "33": 33
  }],
  280: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    var $export = _dereq_(33);

    var scale = _dereq_(64);

    var fround = _dereq_(62);

    $export($export.S, 'Math', {
      fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
        return fround(scale(x, inLow, inHigh, outLow, outHigh));
      }
    });
  }, {
    "33": 33,
    "62": 62,
    "64": 64
  }],
  281: [function (_dereq_, module, exports) {
    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      iaddh: function iaddh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
      }
    });
  }, {
    "33": 33
  }],
  282: [function (_dereq_, module, exports) {
    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      imulh: function imulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >> 16;
        var v1 = $v >> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
      }
    });
  }, {
    "33": 33
  }],
  283: [function (_dereq_, module, exports) {
    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      isubh: function isubh(x0, x1, y0, y1) {
        var $x0 = x0 >>> 0;
        var $x1 = x1 >>> 0;
        var $y0 = y0 >>> 0;
        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
      }
    });
  }, {
    "33": 33
  }],
  284: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      RAD_PER_DEG: 180 / Math.PI
    });
  }, {
    "33": 33
  }],
  285: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    var $export = _dereq_(33);

    var DEG_PER_RAD = Math.PI / 180;
    $export($export.S, 'Math', {
      radians: function radians(degrees) {
        return degrees * DEG_PER_RAD;
      }
    });
  }, {
    "33": 33
  }],
  286: [function (_dereq_, module, exports) {
    // https://rwaldron.github.io/proposal-math-extensions/
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      scale: _dereq_(64)
    });
  }, {
    "33": 33,
    "64": 64
  }],
  287: [function (_dereq_, module, exports) {
    // http://jfbastien.github.io/papers/Math.signbit.html
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      signbit: function signbit(x) {
        // eslint-disable-next-line no-self-compare
        return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
      }
    });
  }, {
    "33": 33
  }],
  288: [function (_dereq_, module, exports) {
    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
    var $export = _dereq_(33);

    $export($export.S, 'Math', {
      umulh: function umulh(u, v) {
        var UINT16 = 0xffff;
        var $u = +u;
        var $v = +v;
        var u0 = $u & UINT16;
        var v0 = $v & UINT16;
        var u1 = $u >>> 16;
        var v1 = $v >>> 16;
        var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
      }
    });
  }, {
    "33": 33
  }],
  289: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var toObject = _dereq_(119);

    var aFunction = _dereq_(3);

    var $defineProperty = _dereq_(72); // B.2.2.2 Object.prototype.__defineGetter__(P, getter)


    _dereq_(29) && $export($export.P + _dereq_(74), 'Object', {
      __defineGetter__: function __defineGetter__(P, getter) {
        $defineProperty.f(toObject(this), P, {
          get: aFunction(getter),
          enumerable: true,
          configurable: true
        });
      }
    });
  }, {
    "119": 119,
    "29": 29,
    "3": 3,
    "33": 33,
    "72": 72,
    "74": 74
  }],
  290: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var toObject = _dereq_(119);

    var aFunction = _dereq_(3);

    var $defineProperty = _dereq_(72); // B.2.2.3 Object.prototype.__defineSetter__(P, setter)


    _dereq_(29) && $export($export.P + _dereq_(74), 'Object', {
      __defineSetter__: function __defineSetter__(P, setter) {
        $defineProperty.f(toObject(this), P, {
          set: aFunction(setter),
          enumerable: true,
          configurable: true
        });
      }
    });
  }, {
    "119": 119,
    "29": 29,
    "3": 3,
    "33": 33,
    "72": 72,
    "74": 74
  }],
  291: [function (_dereq_, module, exports) {
    // https://github.com/tc39/proposal-object-values-entries
    var $export = _dereq_(33);

    var $entries = _dereq_(84)(true);

    $export($export.S, 'Object', {
      entries: function entries(it) {
        return $entries(it);
      }
    });
  }, {
    "33": 33,
    "84": 84
  }],
  292: [function (_dereq_, module, exports) {
    // https://github.com/tc39/proposal-object-getownpropertydescriptors
    var $export = _dereq_(33);

    var ownKeys = _dereq_(85);

    var toIObject = _dereq_(117);

    var gOPD = _dereq_(75);

    var createProperty = _dereq_(24);

    $export($export.S, 'Object', {
      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
        var O = toIObject(object);
        var getDesc = gOPD.f;
        var keys = ownKeys(O);
        var result = {};
        var i = 0;
        var key, desc;

        while (keys.length > i) {
          desc = getDesc(O, key = keys[i++]);
          if (desc !== undefined) createProperty(result, key, desc);
        }

        return result;
      }
    });
  }, {
    "117": 117,
    "24": 24,
    "33": 33,
    "75": 75,
    "85": 85
  }],
  293: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var toObject = _dereq_(119);

    var toPrimitive = _dereq_(120);

    var getPrototypeOf = _dereq_(79);

    var getOwnPropertyDescriptor = _dereq_(75).f; // B.2.2.4 Object.prototype.__lookupGetter__(P)


    _dereq_(29) && $export($export.P + _dereq_(74), 'Object', {
      __lookupGetter__: function __lookupGetter__(P) {
        var O = toObject(this);
        var K = toPrimitive(P, true);
        var D;

        do {
          if (D = getOwnPropertyDescriptor(O, K)) return D.get;
        } while (O = getPrototypeOf(O));
      }
    });
  }, {
    "119": 119,
    "120": 120,
    "29": 29,
    "33": 33,
    "74": 74,
    "75": 75,
    "79": 79
  }],
  294: [function (_dereq_, module, exports) {
    'use strict';

    var $export = _dereq_(33);

    var toObject = _dereq_(119);

    var toPrimitive = _dereq_(120);

    var getPrototypeOf = _dereq_(79);

    var getOwnPropertyDescriptor = _dereq_(75).f; // B.2.2.5 Object.prototype.__lookupSetter__(P)


    _dereq_(29) && $export($export.P + _dereq_(74), 'Object', {
      __lookupSetter__: function __lookupSetter__(P) {
        var O = toObject(this);
        var K = toPrimitive(P, true);
        var D;

        do {
          if (D = getOwnPropertyDescriptor(O, K)) return D.set;
        } while (O = getPrototypeOf(O));
      }
    });
  }, {
    "119": 119,
    "120": 120,
    "29": 29,
    "33": 33,
    "74": 74,
    "75": 75,
    "79": 79
  }],
  295: [function (_dereq_, module, exports) {
    // https://github.com/tc39/proposal-object-values-entries
    var $export = _dereq_(33);

    var $values = _dereq_(84)(false);

    $export($export.S, 'Object', {
      values: function values(it) {
        return $values(it);
      }
    });
  }, {
    "33": 33,
    "84": 84
  }],
  296: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/zenparsing/es-observable

    var $export = _dereq_(33);

    var global = _dereq_(40);

    var core = _dereq_(23);

    var microtask = _dereq_(68)();

    var OBSERVABLE = _dereq_(128)('observable');

    var aFunction = _dereq_(3);

    var anObject = _dereq_(7);

    var anInstance = _dereq_(6);

    var redefineAll = _dereq_(93);

    var hide = _dereq_(42);

    var forOf = _dereq_(39);

    var RETURN = forOf.RETURN;

    var getMethod = function getMethod(fn) {
      return fn == null ? undefined : aFunction(fn);
    };

    var cleanupSubscription = function cleanupSubscription(subscription) {
      var cleanup = subscription._c;

      if (cleanup) {
        subscription._c = undefined;
        cleanup();
      }
    };

    var subscriptionClosed = function subscriptionClosed(subscription) {
      return subscription._o === undefined;
    };

    var closeSubscription = function closeSubscription(subscription) {
      if (!subscriptionClosed(subscription)) {
        subscription._o = undefined;
        cleanupSubscription(subscription);
      }
    };

    var Subscription = function Subscription(observer, subscriber) {
      anObject(observer);
      this._c = undefined;
      this._o = observer;
      observer = new SubscriptionObserver(this);

      try {
        var cleanup = subscriber(observer);
        var subscription = cleanup;

        if (cleanup != null) {
          if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
            subscription.unsubscribe();
          };else aFunction(cleanup);
          this._c = cleanup;
        }
      } catch (e) {
        observer.error(e);
        return;
      }

      if (subscriptionClosed(this)) cleanupSubscription(this);
    };

    Subscription.prototype = redefineAll({}, {
      unsubscribe: function unsubscribe() {
        closeSubscription(this);
      }
    });

    var SubscriptionObserver = function SubscriptionObserver(subscription) {
      this._s = subscription;
    };

    SubscriptionObserver.prototype = redefineAll({}, {
      next: function next(value) {
        var subscription = this._s;

        if (!subscriptionClosed(subscription)) {
          var observer = subscription._o;

          try {
            var m = getMethod(observer.next);
            if (m) return m.call(observer, value);
          } catch (e) {
            try {
              closeSubscription(subscription);
            } finally {
              throw e;
            }
          }
        }
      },
      error: function error(value) {
        var subscription = this._s;
        if (subscriptionClosed(subscription)) throw value;
        var observer = subscription._o;
        subscription._o = undefined;

        try {
          var m = getMethod(observer.error);
          if (!m) throw value;
          value = m.call(observer, value);
        } catch (e) {
          try {
            cleanupSubscription(subscription);
          } finally {
            throw e;
          }
        }

        cleanupSubscription(subscription);
        return value;
      },
      complete: function complete(value) {
        var subscription = this._s;

        if (!subscriptionClosed(subscription)) {
          var observer = subscription._o;
          subscription._o = undefined;

          try {
            var m = getMethod(observer.complete);
            value = m ? m.call(observer, value) : undefined;
          } catch (e) {
            try {
              cleanupSubscription(subscription);
            } finally {
              throw e;
            }
          }

          cleanupSubscription(subscription);
          return value;
        }
      }
    });

    var $Observable = function Observable(subscriber) {
      anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
    };

    redefineAll($Observable.prototype, {
      subscribe: function subscribe(observer) {
        return new Subscription(observer, this._f);
      },
      forEach: function forEach(fn) {
        var that = this;
        return new (core.Promise || global.Promise)(function (resolve, reject) {
          aFunction(fn);
          var subscription = that.subscribe({
            next: function next(value) {
              try {
                return fn(value);
              } catch (e) {
                reject(e);
                subscription.unsubscribe();
              }
            },
            error: reject,
            complete: resolve
          });
        });
      }
    });
    redefineAll($Observable, {
      from: function from(x) {
        var C = typeof this === 'function' ? this : $Observable;
        var method = getMethod(anObject(x)[OBSERVABLE]);

        if (method) {
          var observable = anObject(method.call(x));
          return observable.constructor === C ? observable : new C(function (observer) {
            return observable.subscribe(observer);
          });
        }

        return new C(function (observer) {
          var done = false;
          microtask(function () {
            if (!done) {
              try {
                if (forOf(x, false, function (it) {
                  observer.next(it);
                  if (done) return RETURN;
                }) === RETURN) return;
              } catch (e) {
                if (done) throw e;
                observer.error(e);
                return;
              }

              observer.complete();
            }
          });
          return function () {
            done = true;
          };
        });
      },
      of: function of() {
        for (var i = 0, l = arguments.length, items = Array(l); i < l;) {
          items[i] = arguments[i++];
        }

        return new (typeof this === 'function' ? this : $Observable)(function (observer) {
          var done = false;
          microtask(function () {
            if (!done) {
              for (var j = 0; j < items.length; ++j) {
                observer.next(items[j]);
                if (done) return;
              }

              observer.complete();
            }
          });
          return function () {
            done = true;
          };
        });
      }
    });
    hide($Observable.prototype, OBSERVABLE, function () {
      return this;
    });
    $export($export.G, {
      Observable: $Observable
    });

    _dereq_(100)('Observable');
  }, {
    "100": 100,
    "128": 128,
    "23": 23,
    "3": 3,
    "33": 33,
    "39": 39,
    "40": 40,
    "42": 42,
    "6": 6,
    "68": 68,
    "7": 7,
    "93": 93
  }],
  297: [function (_dereq_, module, exports) {
    // https://github.com/tc39/proposal-promise-finally
    'use strict';

    var $export = _dereq_(33);

    var core = _dereq_(23);

    var global = _dereq_(40);

    var speciesConstructor = _dereq_(104);

    var promiseResolve = _dereq_(91);

    $export($export.P + $export.R, 'Promise', {
      'finally': function _finally(onFinally) {
        var C = speciesConstructor(this, core.Promise || global.Promise);
        var isFunction = typeof onFinally == 'function';
        return this.then(isFunction ? function (x) {
          return promiseResolve(C, onFinally()).then(function () {
            return x;
          });
        } : onFinally, isFunction ? function (e) {
          return promiseResolve(C, onFinally()).then(function () {
            throw e;
          });
        } : onFinally);
      }
    });
  }, {
    "104": 104,
    "23": 23,
    "33": 33,
    "40": 40,
    "91": 91
  }],
  298: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/tc39/proposal-promise-try

    var $export = _dereq_(33);

    var newPromiseCapability = _dereq_(69);

    var perform = _dereq_(90);

    $export($export.S, 'Promise', {
      'try': function _try(callbackfn) {
        var promiseCapability = newPromiseCapability.f(this);
        var result = perform(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
      }
    });
  }, {
    "33": 33,
    "69": 69,
    "90": 90
  }],
  299: [function (_dereq_, module, exports) {
    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var toMetaKey = metadata.key;
    var ordinaryDefineOwnMetadata = metadata.set;
    metadata.exp({
      defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
        ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
      }
    });
  }, {
    "67": 67,
    "7": 7
  }],
  300: [function (_dereq_, module, exports) {
    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var toMetaKey = metadata.key;
    var getOrCreateMetadataMap = metadata.map;
    var store = metadata.store;
    metadata.exp({
      deleteMetadata: function deleteMetadata(metadataKey, target
      /* , targetKey */
      ) {
        var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
        var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
        if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
        if (metadataMap.size) return true;
        var targetMetadata = store.get(target);
        targetMetadata['delete'](targetKey);
        return !!targetMetadata.size || store['delete'](target);
      }
    });
  }, {
    "67": 67,
    "7": 7
  }],
  301: [function (_dereq_, module, exports) {
    var Set = _dereq_(231);

    var from = _dereq_(10);

    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var getPrototypeOf = _dereq_(79);

    var ordinaryOwnMetadataKeys = metadata.keys;
    var toMetaKey = metadata.key;

    var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
      var oKeys = ordinaryOwnMetadataKeys(O, P);
      var parent = getPrototypeOf(O);
      if (parent === null) return oKeys;
      var pKeys = ordinaryMetadataKeys(parent, P);
      return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
    };

    metadata.exp({
      getMetadataKeys: function getMetadataKeys(target
      /* , targetKey */
      ) {
        return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
      }
    });
  }, {
    "10": 10,
    "231": 231,
    "67": 67,
    "7": 7,
    "79": 79
  }],
  302: [function (_dereq_, module, exports) {
    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var getPrototypeOf = _dereq_(79);

    var ordinaryHasOwnMetadata = metadata.has;
    var ordinaryGetOwnMetadata = metadata.get;
    var toMetaKey = metadata.key;

    var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
      var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
      if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
      var parent = getPrototypeOf(O);
      return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
    };

    metadata.exp({
      getMetadata: function getMetadata(metadataKey, target
      /* , targetKey */
      ) {
        return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
      }
    });
  }, {
    "67": 67,
    "7": 7,
    "79": 79
  }],
  303: [function (_dereq_, module, exports) {
    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var ordinaryOwnMetadataKeys = metadata.keys;
    var toMetaKey = metadata.key;
    metadata.exp({
      getOwnMetadataKeys: function getOwnMetadataKeys(target
      /* , targetKey */
      ) {
        return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
      }
    });
  }, {
    "67": 67,
    "7": 7
  }],
  304: [function (_dereq_, module, exports) {
    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var ordinaryGetOwnMetadata = metadata.get;
    var toMetaKey = metadata.key;
    metadata.exp({
      getOwnMetadata: function getOwnMetadata(metadataKey, target
      /* , targetKey */
      ) {
        return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
      }
    });
  }, {
    "67": 67,
    "7": 7
  }],
  305: [function (_dereq_, module, exports) {
    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var getPrototypeOf = _dereq_(79);

    var ordinaryHasOwnMetadata = metadata.has;
    var toMetaKey = metadata.key;

    var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
      var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
      if (hasOwn) return true;
      var parent = getPrototypeOf(O);
      return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
    };

    metadata.exp({
      hasMetadata: function hasMetadata(metadataKey, target
      /* , targetKey */
      ) {
        return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
      }
    });
  }, {
    "67": 67,
    "7": 7,
    "79": 79
  }],
  306: [function (_dereq_, module, exports) {
    var metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var ordinaryHasOwnMetadata = metadata.has;
    var toMetaKey = metadata.key;
    metadata.exp({
      hasOwnMetadata: function hasOwnMetadata(metadataKey, target
      /* , targetKey */
      ) {
        return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
      }
    });
  }, {
    "67": 67,
    "7": 7
  }],
  307: [function (_dereq_, module, exports) {
    var $metadata = _dereq_(67);

    var anObject = _dereq_(7);

    var aFunction = _dereq_(3);

    var toMetaKey = $metadata.key;
    var ordinaryDefineOwnMetadata = $metadata.set;
    $metadata.exp({
      metadata: function metadata(metadataKey, metadataValue) {
        return function decorator(target, targetKey) {
          ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
        };
      }
    });
  }, {
    "3": 3,
    "67": 67,
    "7": 7
  }],
  308: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
    _dereq_(97)('Set');
  }, {
    "97": 97
  }],
  309: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
    _dereq_(98)('Set');
  }, {
    "98": 98
  }],
  310: [function (_dereq_, module, exports) {
    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
    var $export = _dereq_(33);

    $export($export.P + $export.R, 'Set', {
      toJSON: _dereq_(20)('Set')
    });
  }, {
    "20": 20,
    "33": 33
  }],
  311: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/mathiasbynens/String.prototype.at

    var $export = _dereq_(33);

    var $at = _dereq_(106)(true);

    $export($export.P, 'String', {
      at: function at(pos) {
        return $at(this, pos);
      }
    });
  }, {
    "106": 106,
    "33": 33
  }],
  312: [function (_dereq_, module, exports) {
    'use strict'; // https://tc39.github.io/String.prototype.matchAll/

    var $export = _dereq_(33);

    var defined = _dereq_(28);

    var toLength = _dereq_(118);

    var isRegExp = _dereq_(52);

    var getFlags = _dereq_(37);

    var RegExpProto = RegExp.prototype;

    var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
      this._r = regexp;
      this._s = string;
    };

    _dereq_(54)($RegExpStringIterator, 'RegExp String', function next() {
      var match = this._r.exec(this._s);

      return {
        value: match,
        done: match === null
      };
    });

    $export($export.P, 'String', {
      matchAll: function matchAll(regexp) {
        defined(this);
        if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
        var S = String(this);
        var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
        var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
        rx.lastIndex = toLength(regexp.lastIndex);
        return new $RegExpStringIterator(rx, S);
      }
    });
  }, {
    "118": 118,
    "28": 28,
    "33": 33,
    "37": 37,
    "52": 52,
    "54": 54
  }],
  313: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/tc39/proposal-string-pad-start-end

    var $export = _dereq_(33);

    var $pad = _dereq_(109);

    $export($export.P, 'String', {
      padEnd: function padEnd(maxLength
      /* , fillString = ' ' */
      ) {
        return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
      }
    });
  }, {
    "109": 109,
    "33": 33
  }],
  314: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/tc39/proposal-string-pad-start-end

    var $export = _dereq_(33);

    var $pad = _dereq_(109);

    $export($export.P, 'String', {
      padStart: function padStart(maxLength
      /* , fillString = ' ' */
      ) {
        return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
      }
    });
  }, {
    "109": 109,
    "33": 33
  }],
  315: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/sebmarkbage/ecmascript-string-left-right-trim

    _dereq_(111)('trimLeft', function ($trim) {
      return function trimLeft() {
        return $trim(this, 1);
      };
    }, 'trimStart');
  }, {
    "111": 111
  }],
  316: [function (_dereq_, module, exports) {
    'use strict'; // https://github.com/sebmarkbage/ecmascript-string-left-right-trim

    _dereq_(111)('trimRight', function ($trim) {
      return function trimRight() {
        return $trim(this, 2);
      };
    }, 'trimEnd');
  }, {
    "111": 111
  }],
  317: [function (_dereq_, module, exports) {
    _dereq_(126)('asyncIterator');
  }, {
    "126": 126
  }],
  318: [function (_dereq_, module, exports) {
    _dereq_(126)('observable');
  }, {
    "126": 126
  }],
  319: [function (_dereq_, module, exports) {
    // https://github.com/tc39/proposal-global
    var $export = _dereq_(33);

    $export($export.S, 'System', {
      global: _dereq_(40)
    });
  }, {
    "33": 33,
    "40": 40
  }],
  320: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
    _dereq_(97)('WeakMap');
  }, {
    "97": 97
  }],
  321: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
    _dereq_(98)('WeakMap');
  }, {
    "98": 98
  }],
  322: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
    _dereq_(97)('WeakSet');
  }, {
    "97": 97
  }],
  323: [function (_dereq_, module, exports) {
    // https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
    _dereq_(98)('WeakSet');
  }, {
    "98": 98
  }],
  324: [function (_dereq_, module, exports) {
    var $iterators = _dereq_(141);

    var getKeys = _dereq_(81);

    var redefine = _dereq_(94);

    var global = _dereq_(40);

    var hide = _dereq_(42);

    var Iterators = _dereq_(58);

    var wks = _dereq_(128);

    var ITERATOR = wks('iterator');
    var TO_STRING_TAG = wks('toStringTag');
    var ArrayValues = Iterators.Array;
    var DOMIterables = {
      CSSRuleList: true,
      // TODO: Not spec compliant, should be false.
      CSSStyleDeclaration: false,
      CSSValueList: false,
      ClientRectList: false,
      DOMRectList: false,
      DOMStringList: false,
      DOMTokenList: true,
      DataTransferItemList: false,
      FileList: false,
      HTMLAllCollection: false,
      HTMLCollection: false,
      HTMLFormElement: false,
      HTMLSelectElement: false,
      MediaList: true,
      // TODO: Not spec compliant, should be false.
      MimeTypeArray: false,
      NamedNodeMap: false,
      NodeList: true,
      PaintRequestList: false,
      Plugin: false,
      PluginArray: false,
      SVGLengthList: false,
      SVGNumberList: false,
      SVGPathSegList: false,
      SVGPointList: false,
      SVGStringList: false,
      SVGTransformList: false,
      SourceBufferList: false,
      StyleSheetList: true,
      // TODO: Not spec compliant, should be false.
      TextTrackCueList: false,
      TextTrackList: false,
      TouchList: false
    };

    for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
      var NAME = collections[i];
      var explicit = DOMIterables[NAME];
      var Collection = global[NAME];
      var proto = Collection && Collection.prototype;
      var key;

      if (proto) {
        if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
        if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
        Iterators[NAME] = ArrayValues;
        if (explicit) for (key in $iterators) {
          if (!proto[key]) redefine(proto, key, $iterators[key], true);
        }
      }
    }
  }, {
    "128": 128,
    "141": 141,
    "40": 40,
    "42": 42,
    "58": 58,
    "81": 81,
    "94": 94
  }],
  325: [function (_dereq_, module, exports) {
    var $export = _dereq_(33);

    var $task = _dereq_(113);

    $export($export.G + $export.B, {
      setImmediate: $task.set,
      clearImmediate: $task.clear
    });
  }, {
    "113": 113,
    "33": 33
  }],
  326: [function (_dereq_, module, exports) {
    // ie9- setTimeout & setInterval additional parameters fix
    var global = _dereq_(40);

    var $export = _dereq_(33);

    var invoke = _dereq_(46);

    var partial = _dereq_(88);

    var navigator = global.navigator;
    var MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check

    var wrap = function wrap(set) {
      return MSIE ? function (fn, time
      /* , ...args */
      ) {
        return set(invoke(partial, [].slice.call(arguments, 2), // eslint-disable-next-line no-new-func
        typeof fn == 'function' ? fn : Function(fn)), time);
      } : set;
    };

    $export($export.G + $export.B + $export.F * MSIE, {
      setTimeout: wrap(global.setTimeout),
      setInterval: wrap(global.setInterval)
    });
  }, {
    "33": 33,
    "40": 40,
    "46": 46,
    "88": 88
  }],
  327: [function (_dereq_, module, exports) {
    _dereq_(254);

    _dereq_(191);

    _dereq_(193);

    _dereq_(192);

    _dereq_(195);

    _dereq_(197);

    _dereq_(202);

    _dereq_(196);

    _dereq_(194);

    _dereq_(204);

    _dereq_(203);

    _dereq_(199);

    _dereq_(200);

    _dereq_(198);

    _dereq_(190);

    _dereq_(201);

    _dereq_(205);

    _dereq_(206);

    _dereq_(157);

    _dereq_(159);

    _dereq_(158);

    _dereq_(208);

    _dereq_(207);

    _dereq_(178);

    _dereq_(188);

    _dereq_(189);

    _dereq_(179);

    _dereq_(180);

    _dereq_(181);

    _dereq_(182);

    _dereq_(183);

    _dereq_(184);

    _dereq_(185);

    _dereq_(186);

    _dereq_(187);

    _dereq_(161);

    _dereq_(162);

    _dereq_(163);

    _dereq_(164);

    _dereq_(165);

    _dereq_(166);

    _dereq_(167);

    _dereq_(168);

    _dereq_(169);

    _dereq_(170);

    _dereq_(171);

    _dereq_(172);

    _dereq_(173);

    _dereq_(174);

    _dereq_(175);

    _dereq_(176);

    _dereq_(177);

    _dereq_(241);

    _dereq_(246);

    _dereq_(253);

    _dereq_(244);

    _dereq_(236);

    _dereq_(237);

    _dereq_(242);

    _dereq_(247);

    _dereq_(249);

    _dereq_(232);

    _dereq_(233);

    _dereq_(234);

    _dereq_(235);

    _dereq_(238);

    _dereq_(239);

    _dereq_(240);

    _dereq_(243);

    _dereq_(245);

    _dereq_(248);

    _dereq_(250);

    _dereq_(251);

    _dereq_(252);

    _dereq_(152);

    _dereq_(154);

    _dereq_(153);

    _dereq_(156);

    _dereq_(155);

    _dereq_(140);

    _dereq_(138);

    _dereq_(145);

    _dereq_(142);

    _dereq_(148);

    _dereq_(150);

    _dereq_(137);

    _dereq_(144);

    _dereq_(134);

    _dereq_(149);

    _dereq_(132);

    _dereq_(147);

    _dereq_(146);

    _dereq_(139);

    _dereq_(143);

    _dereq_(131);

    _dereq_(133);

    _dereq_(136);

    _dereq_(135);

    _dereq_(151);

    _dereq_(141);

    _dereq_(224);

    _dereq_(230);

    _dereq_(225);

    _dereq_(226);

    _dereq_(227);

    _dereq_(228);

    _dereq_(229);

    _dereq_(209);

    _dereq_(160);

    _dereq_(231);

    _dereq_(266);

    _dereq_(267);

    _dereq_(255);

    _dereq_(256);

    _dereq_(261);

    _dereq_(264);

    _dereq_(265);

    _dereq_(259);

    _dereq_(262);

    _dereq_(260);

    _dereq_(263);

    _dereq_(257);

    _dereq_(258);

    _dereq_(210);

    _dereq_(211);

    _dereq_(212);

    _dereq_(213);

    _dereq_(214);

    _dereq_(217);

    _dereq_(215);

    _dereq_(216);

    _dereq_(218);

    _dereq_(219);

    _dereq_(220);

    _dereq_(221);

    _dereq_(223);

    _dereq_(222);

    _dereq_(270);

    _dereq_(268);

    _dereq_(269);

    _dereq_(311);

    _dereq_(314);

    _dereq_(313);

    _dereq_(315);

    _dereq_(316);

    _dereq_(312);

    _dereq_(317);

    _dereq_(318);

    _dereq_(292);

    _dereq_(295);

    _dereq_(291);

    _dereq_(289);

    _dereq_(290);

    _dereq_(293);

    _dereq_(294);

    _dereq_(276);

    _dereq_(310);

    _dereq_(275);

    _dereq_(309);

    _dereq_(321);

    _dereq_(323);

    _dereq_(274);

    _dereq_(308);

    _dereq_(320);

    _dereq_(322);

    _dereq_(273);

    _dereq_(319);

    _dereq_(272);

    _dereq_(277);

    _dereq_(278);

    _dereq_(279);

    _dereq_(280);

    _dereq_(281);

    _dereq_(283);

    _dereq_(282);

    _dereq_(284);

    _dereq_(285);

    _dereq_(286);

    _dereq_(288);

    _dereq_(287);

    _dereq_(297);

    _dereq_(298);

    _dereq_(299);

    _dereq_(300);

    _dereq_(302);

    _dereq_(301);

    _dereq_(304);

    _dereq_(303);

    _dereq_(305);

    _dereq_(306);

    _dereq_(307);

    _dereq_(271);

    _dereq_(296);

    _dereq_(326);

    _dereq_(325);

    _dereq_(324);

    module.exports = _dereq_(23);
  }, {
    "131": 131,
    "132": 132,
    "133": 133,
    "134": 134,
    "135": 135,
    "136": 136,
    "137": 137,
    "138": 138,
    "139": 139,
    "140": 140,
    "141": 141,
    "142": 142,
    "143": 143,
    "144": 144,
    "145": 145,
    "146": 146,
    "147": 147,
    "148": 148,
    "149": 149,
    "150": 150,
    "151": 151,
    "152": 152,
    "153": 153,
    "154": 154,
    "155": 155,
    "156": 156,
    "157": 157,
    "158": 158,
    "159": 159,
    "160": 160,
    "161": 161,
    "162": 162,
    "163": 163,
    "164": 164,
    "165": 165,
    "166": 166,
    "167": 167,
    "168": 168,
    "169": 169,
    "170": 170,
    "171": 171,
    "172": 172,
    "173": 173,
    "174": 174,
    "175": 175,
    "176": 176,
    "177": 177,
    "178": 178,
    "179": 179,
    "180": 180,
    "181": 181,
    "182": 182,
    "183": 183,
    "184": 184,
    "185": 185,
    "186": 186,
    "187": 187,
    "188": 188,
    "189": 189,
    "190": 190,
    "191": 191,
    "192": 192,
    "193": 193,
    "194": 194,
    "195": 195,
    "196": 196,
    "197": 197,
    "198": 198,
    "199": 199,
    "200": 200,
    "201": 201,
    "202": 202,
    "203": 203,
    "204": 204,
    "205": 205,
    "206": 206,
    "207": 207,
    "208": 208,
    "209": 209,
    "210": 210,
    "211": 211,
    "212": 212,
    "213": 213,
    "214": 214,
    "215": 215,
    "216": 216,
    "217": 217,
    "218": 218,
    "219": 219,
    "220": 220,
    "221": 221,
    "222": 222,
    "223": 223,
    "224": 224,
    "225": 225,
    "226": 226,
    "227": 227,
    "228": 228,
    "229": 229,
    "23": 23,
    "230": 230,
    "231": 231,
    "232": 232,
    "233": 233,
    "234": 234,
    "235": 235,
    "236": 236,
    "237": 237,
    "238": 238,
    "239": 239,
    "240": 240,
    "241": 241,
    "242": 242,
    "243": 243,
    "244": 244,
    "245": 245,
    "246": 246,
    "247": 247,
    "248": 248,
    "249": 249,
    "250": 250,
    "251": 251,
    "252": 252,
    "253": 253,
    "254": 254,
    "255": 255,
    "256": 256,
    "257": 257,
    "258": 258,
    "259": 259,
    "260": 260,
    "261": 261,
    "262": 262,
    "263": 263,
    "264": 264,
    "265": 265,
    "266": 266,
    "267": 267,
    "268": 268,
    "269": 269,
    "270": 270,
    "271": 271,
    "272": 272,
    "273": 273,
    "274": 274,
    "275": 275,
    "276": 276,
    "277": 277,
    "278": 278,
    "279": 279,
    "280": 280,
    "281": 281,
    "282": 282,
    "283": 283,
    "284": 284,
    "285": 285,
    "286": 286,
    "287": 287,
    "288": 288,
    "289": 289,
    "290": 290,
    "291": 291,
    "292": 292,
    "293": 293,
    "294": 294,
    "295": 295,
    "296": 296,
    "297": 297,
    "298": 298,
    "299": 299,
    "300": 300,
    "301": 301,
    "302": 302,
    "303": 303,
    "304": 304,
    "305": 305,
    "306": 306,
    "307": 307,
    "308": 308,
    "309": 309,
    "310": 310,
    "311": 311,
    "312": 312,
    "313": 313,
    "314": 314,
    "315": 315,
    "316": 316,
    "317": 317,
    "318": 318,
    "319": 319,
    "320": 320,
    "321": 321,
    "322": 322,
    "323": 323,
    "324": 324,
    "325": 325,
    "326": 326
  }],
  328: [function (_dereq_, module, exports) {
    (function (global) {
      /**
       * Copyright (c) 2014, Facebook, Inc.
       * All rights reserved.
       *
       * This source code is licensed under the BSD-style license found in the
       * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
       * additional grant of patent rights can be found in the PATENTS file in
       * the same directory.
       */
      !function (global) {
        "use strict";

        var Op = Object.prototype;
        var hasOwn = Op.hasOwnProperty;
        var undefined; // More compressible than void 0.

        var $Symbol = typeof Symbol === "function" ? Symbol : {};
        var iteratorSymbol = $Symbol.iterator || "@@iterator";
        var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
        var inModule = _typeof(module) === "object";
        var runtime = global.regeneratorRuntime;

        if (runtime) {
          if (inModule) {
            // If regeneratorRuntime is defined globally and we're in a module,
            // make the exports object identical to regeneratorRuntime.
            module.exports = runtime;
          } // Don't bother evaluating the rest of this file if the runtime was
          // already defined globally.


          return;
        } // Define the runtime globally (as expected by generated code) as either
        // module.exports (if we're in a module) or a new, empty object.


        runtime = global.regeneratorRuntime = inModule ? module.exports : {};

        function wrap(innerFn, outerFn, self, tryLocsList) {
          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
          var generator = Object.create(protoGenerator.prototype);
          var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
          // .throw, and .return methods.

          generator._invoke = makeInvokeMethod(innerFn, self, context);
          return generator;
        }

        runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
        // record like context.tryEntries[i].completion. This interface could
        // have been (and was previously) designed to take a closure to be
        // invoked without arguments, but in all the cases we care about we
        // already have an existing method we want to call, so there's no need
        // to create a new function object. We can even get away with assuming
        // the method takes exactly one argument, since that happens to be true
        // in every case, so we don't have to touch the arguments object. The
        // only additional allocation required is the completion record, which
        // has a stable shape and so hopefully should be cheap to allocate.

        function tryCatch(fn, obj, arg) {
          try {
            return {
              type: "normal",
              arg: fn.call(obj, arg)
            };
          } catch (err) {
            return {
              type: "throw",
              arg: err
            };
          }
        }

        var GenStateSuspendedStart = "suspendedStart";
        var GenStateSuspendedYield = "suspendedYield";
        var GenStateExecuting = "executing";
        var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
        // breaking out of the dispatch switch statement.

        var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
        // .constructor.prototype properties for functions that return Generator
        // objects. For full spec compliance, you may wish to configure your
        // minifier not to mangle the names of these two functions.

        function Generator() {}

        function GeneratorFunction() {}

        function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
        // don't natively support it.


        var IteratorPrototype = {};

        IteratorPrototype[iteratorSymbol] = function () {
          return this;
        };

        var getProto = Object.getPrototypeOf;
        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
          // This environment has a native %IteratorPrototype%; use it instead
          // of the polyfill.
          IteratorPrototype = NativeIteratorPrototype;
        }

        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
        GeneratorFunctionPrototype.constructor = GeneratorFunction;
        GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
        // Iterator interface in terms of a single ._invoke method.

        function defineIteratorMethods(prototype) {
          ["next", "throw", "return"].forEach(function (method) {
            prototype[method] = function (arg) {
              return this._invoke(method, arg);
            };
          });
        }

        runtime.isGeneratorFunction = function (genFun) {
          var ctor = typeof genFun === "function" && genFun.constructor;
          return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
          // do is to check its .name property.
          (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
        };

        runtime.mark = function (genFun) {
          if (Object.setPrototypeOf) {
            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
          } else {
            genFun.__proto__ = GeneratorFunctionPrototype;

            if (!(toStringTagSymbol in genFun)) {
              genFun[toStringTagSymbol] = "GeneratorFunction";
            }
          }

          genFun.prototype = Object.create(Gp);
          return genFun;
        }; // Within the body of any async function, `await x` is transformed to
        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
        // `hasOwn.call(value, "__await")` to determine if the yielded value is
        // meant to be awaited.


        runtime.awrap = function (arg) {
          return {
            __await: arg
          };
        };

        function AsyncIterator(generator) {
          function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);

            if (record.type === "throw") {
              reject(record.arg);
            } else {
              var result = record.arg;
              var value = result.value;

              if (value && _typeof(value) === "object" && hasOwn.call(value, "__await")) {
                return Promise.resolve(value.__await).then(function (value) {
                  invoke("next", value, resolve, reject);
                }, function (err) {
                  invoke("throw", err, resolve, reject);
                });
              }

              return Promise.resolve(value).then(function (unwrapped) {
                // When a yielded Promise is resolved, its final value becomes
                // the .value of the Promise<{value,done}> result for the
                // current iteration. If the Promise is rejected, however, the
                // result for this iteration will be rejected with the same
                // reason. Note that rejections of yielded Promises are not
                // thrown back into the generator function, as is the case
                // when an awaited Promise is rejected. This difference in
                // behavior between yield and await is important, because it
                // allows the consumer to decide what to do with the yielded
                // rejection (swallow it and continue, manually .throw it back
                // into the generator, abandon iteration, whatever). With
                // await, by contrast, there is no opportunity to examine the
                // rejection reason outside the generator function, so the
                // only option is to throw it from the await expression, and
                // let the generator function handle the exception.
                result.value = unwrapped;
                resolve(result);
              }, reject);
            }
          }

          if (_typeof(global.process) === "object" && global.process.domain) {
            invoke = global.process.domain.bind(invoke);
          }

          var previousPromise;

          function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
              return new Promise(function (resolve, reject) {
                invoke(method, arg, resolve, reject);
              });
            }

            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
          } // Define the unified helper method that is used to implement .next,
          // .throw, and .return (see defineIteratorMethods).


          this._invoke = enqueue;
        }

        defineIteratorMethods(AsyncIterator.prototype);

        AsyncIterator.prototype[asyncIteratorSymbol] = function () {
          return this;
        };

        runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
        // AsyncIterator objects; they just return a Promise for the value of
        // the final result produced by the iterator.

        runtime.async = function (innerFn, outerFn, self, tryLocsList) {
          var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
          return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
          : iter.next().then(function (result) {
            return result.done ? result.value : iter.next();
          });
        };

        function makeInvokeMethod(innerFn, self, context) {
          var state = GenStateSuspendedStart;
          return function invoke(method, arg) {
            if (state === GenStateExecuting) {
              throw new Error("Generator is already running");
            }

            if (state === GenStateCompleted) {
              if (method === "throw") {
                throw arg;
              } // Be forgiving, per 25.3.3.3.3 of the spec:
              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


              return doneResult();
            }

            context.method = method;
            context.arg = arg;

            while (true) {
              var delegate = context.delegate;

              if (delegate) {
                var delegateResult = maybeInvokeDelegate(delegate, context);

                if (delegateResult) {
                  if (delegateResult === ContinueSentinel) continue;
                  return delegateResult;
                }
              }

              if (context.method === "next") {
                // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
              } else if (context.method === "throw") {
                if (state === GenStateSuspendedStart) {
                  state = GenStateCompleted;
                  throw context.arg;
                }

                context.dispatchException(context.arg);
              } else if (context.method === "return") {
                context.abrupt("return", context.arg);
              }

              state = GenStateExecuting;
              var record = tryCatch(innerFn, self, context);

              if (record.type === "normal") {
                // If an exception is thrown from innerFn, we leave state ===
                // GenStateExecuting and loop back for another invocation.
                state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                if (record.arg === ContinueSentinel) {
                  continue;
                }

                return {
                  value: record.arg,
                  done: context.done
                };
              } else if (record.type === "throw") {
                state = GenStateCompleted; // Dispatch the exception by looping back around to the
                // context.dispatchException(context.arg) call above.

                context.method = "throw";
                context.arg = record.arg;
              }
            }
          };
        } // Call delegate.iterator[context.method](context.arg) and handle the
        // result, either by returning a { value, done } result from the
        // delegate iterator, or by modifying context.method and context.arg,
        // setting context.delegate to null, and returning the ContinueSentinel.


        function maybeInvokeDelegate(delegate, context) {
          var method = delegate.iterator[context.method];

          if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;

            if (context.method === "throw") {
              if (delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);

                if (context.method === "throw") {
                  // If maybeInvokeDelegate(context) changed context.method from
                  // "return" to "throw", let that override the TypeError below.
                  return ContinueSentinel;
                }
              }

              context.method = "throw";
              context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }

            return ContinueSentinel;
          }

          var record = tryCatch(method, delegate.iterator, context.arg);

          if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
          }

          var info = record.arg;

          if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
          }

          if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

            context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.

            if (context.method !== "return") {
              context.method = "next";
              context.arg = undefined;
            }
          } else {
            // Re-yield the result returned by the delegate method.
            return info;
          } // The delegate iterator is finished, so forget it and continue with
          // the outer generator.


          context.delegate = null;
          return ContinueSentinel;
        } // Define Generator.prototype.{next,throw,return} in terms of the
        // unified ._invoke helper method.


        defineIteratorMethods(Gp);
        Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
        // @@iterator function is called on it. Some browsers' implementations of the
        // iterator prototype chain incorrectly implement this, causing the Generator
        // object to not be returned from this call. This ensures that doesn't happen.
        // See https://github.com/facebook/regenerator/issues/274 for more details.

        Gp[iteratorSymbol] = function () {
          return this;
        };

        Gp.toString = function () {
          return "[object Generator]";
        };

        function pushTryEntry(locs) {
          var entry = {
            tryLoc: locs[0]
          };

          if (1 in locs) {
            entry.catchLoc = locs[1];
          }

          if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
          }

          this.tryEntries.push(entry);
        }

        function resetTryEntry(entry) {
          var record = entry.completion || {};
          record.type = "normal";
          delete record.arg;
          entry.completion = record;
        }

        function Context(tryLocsList) {
          // The root entry object (effectively a try statement without a catch
          // or a finally block) gives us a place to store values thrown from
          // locations where there is no enclosing try statement.
          this.tryEntries = [{
            tryLoc: "root"
          }];
          tryLocsList.forEach(pushTryEntry, this);
          this.reset(true);
        }

        runtime.keys = function (object) {
          var keys = [];

          for (var key in object) {
            keys.push(key);
          }

          keys.reverse(); // Rather than returning an object with a next method, we keep
          // things simple and return the next function itself.

          return function next() {
            while (keys.length) {
              var key = keys.pop();

              if (key in object) {
                next.value = key;
                next.done = false;
                return next;
              }
            } // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.


            next.done = true;
            return next;
          };
        };

        function values(iterable) {
          if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];

            if (iteratorMethod) {
              return iteratorMethod.call(iterable);
            }

            if (typeof iterable.next === "function") {
              return iterable;
            }

            if (!isNaN(iterable.length)) {
              var i = -1,
                  next = function next() {
                while (++i < iterable.length) {
                  if (hasOwn.call(iterable, i)) {
                    next.value = iterable[i];
                    next.done = false;
                    return next;
                  }
                }

                next.value = undefined;
                next.done = true;
                return next;
              };

              return next.next = next;
            }
          } // Return an iterator with no values.


          return {
            next: doneResult
          };
        }

        runtime.values = values;

        function doneResult() {
          return {
            value: undefined,
            done: true
          };
        }

        Context.prototype = {
          constructor: Context,
          reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0; // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.

            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);

            if (!skipTempReset) {
              for (var name in this) {
                // Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                  this[name] = undefined;
                }
              }
            }
          },
          stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;

            if (rootRecord.type === "throw") {
              throw rootRecord.arg;
            }

            return this.rval;
          },
          dispatchException: function dispatchException(exception) {
            if (this.done) {
              throw exception;
            }

            var context = this;

            function handle(loc, caught) {
              record.type = "throw";
              record.arg = exception;
              context.next = loc;

              if (caught) {
                // If the dispatched exception was caught by a catch block,
                // then let that catch block handle the exception normally.
                context.method = "next";
                context.arg = undefined;
              }

              return !!caught;
            }

            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];
              var record = entry.completion;

              if (entry.tryLoc === "root") {
                // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
              }

              if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, "catchLoc");
                var hasFinally = hasOwn.call(entry, "finallyLoc");

                if (hasCatch && hasFinally) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  } else if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else if (hasCatch) {
                  if (this.prev < entry.catchLoc) {
                    return handle(entry.catchLoc, true);
                  }
                } else if (hasFinally) {
                  if (this.prev < entry.finallyLoc) {
                    return handle(entry.finallyLoc);
                  }
                } else {
                  throw new Error("try statement without catch or finally");
                }
              }
            }
          },
          abrupt: function abrupt(type, arg) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];

              if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
              }
            }

            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
              // Ignore the finally entry if control is not jumping to a
              // location outside the try/catch block.
              finallyEntry = null;
            }

            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;

            if (finallyEntry) {
              this.method = "next";
              this.next = finallyEntry.finallyLoc;
              return ContinueSentinel;
            }

            return this.complete(record);
          },
          complete: function complete(record, afterLoc) {
            if (record.type === "throw") {
              throw record.arg;
            }

            if (record.type === "break" || record.type === "continue") {
              this.next = record.arg;
            } else if (record.type === "return") {
              this.rval = this.arg = record.arg;
              this.method = "return";
              this.next = "end";
            } else if (record.type === "normal" && afterLoc) {
              this.next = afterLoc;
            }

            return ContinueSentinel;
          },
          finish: function finish(finallyLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];

              if (entry.finallyLoc === finallyLoc) {
                this.complete(entry.completion, entry.afterLoc);
                resetTryEntry(entry);
                return ContinueSentinel;
              }
            }
          },
          "catch": function _catch(tryLoc) {
            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
              var entry = this.tryEntries[i];

              if (entry.tryLoc === tryLoc) {
                var record = entry.completion;

                if (record.type === "throw") {
                  var thrown = record.arg;
                  resetTryEntry(entry);
                }

                return thrown;
              }
            } // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.


            throw new Error("illegal catch attempt");
          },
          delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
              iterator: values(iterable),
              resultName: resultName,
              nextLoc: nextLoc
            };

            if (this.method === "next") {
              // Deliberately forget the last sent value so that we don't
              // accidentally pass it on to the delegate.
              this.arg = undefined;
            }

            return ContinueSentinel;
          }
        };
      }( // Among the various tricks for obtaining a reference to the global
      // object, this seems to be the most reliable technique that does not
      // use indirect eval (which violates Content Security Policy).
      _typeof(global) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : this);
    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
  }, {}]
}, {}, [1]);
angular.module("app.config", [])
.constant("deployConf", {"AuthHost":"/rest","BackendHost":"/rest","ClientId":"a5c1014adf9a964d22c63531cc540e61","AuthPlugin":"authJwtPlugin","websocket":{"url":"//","path":null}})
.constant("ghostModeConfig", {"rememberSessions":true})
.constant("accountConfig", {"logo":{"urlToUpload":"/rest/reseller/uploadlogo","sizeInPx":"max","aspectRatio":null},"restful":{"users":"/rest/users/:id","roles":"/rest/users/roles","addresses":"/rest/addresses/:id","resetPass":"/rest/users/recoveryPasswordRequest","me":"/rest/users/me"}})
.constant("articlesConfig", {"restful":{"news":"/rest/articles/:category/:id"},"list":{"pageSize":10}})
.constant("cartConfig", {"decimalPrecision":4,"rememberSelection":true,"restful":{"carts":"/rest/carts/:id","cartItems":"/rest/cartItems/:id","stocks":"/rest/carts/restock/:id"},"list":{"pageSize":10}})
.constant("offerConfig", {"decimalPrecision":4,"list":{"pageSize":10},"tooltipLimit":100,"restful":{"offers":"/rest/offers/:id","offerItemsExtended":"/rest/offerItemsExtended/:id","mail":"/rest/offers/email/:id","offerItems":"/rest/offerItems/:id","editOffer":"/rest/offers/updateItems/:id","fileExportType":"/rest/offers/fileExportType"},"documentUrl":"/rest/offers/file/:id"})
.constant("productConfig", {"restful":{"productAttributes":"/rest/products/attributes","stocks":"/rest/products/restock/:sku"},"cardUrls":{"single":"/rest/products/pdf/:sku","cart":"/rest/cartItems/pdf","offer":"/rest/offerItems/pdf"},"customAttributes":{"line":"line_varchar","brand":"brand_m1_varchar"}})
.constant("blocksConfig", {"restful":{"blocks":"/rest/blocks/:id"}})
.constant("orderConfig", {"restful":{"quotes":"/rest/quote","orders":"/rest/orders/:id","stocks":"/rest/quote/restock"},"list":{"pageSize":10}})
.constant("invoiceConfig", {"restful":{"invoices":"/rest/invoices/:id","documentUrl":"/rest/invoices/file/:id"},"list":{"pageSize":10},"documentUrl":"/rest/invoices/file/:id","downloadFile":"/rest/invoices/downloadfile"})
.constant("paymentConfig", {"restful":{"payments":"/rest/payments/:id"},"list":{"pageSize":10}})
.constant("settleConfig", {"restful":{"settlements":"/rest/settlements/:id","csv":"/rest/settlements/csv"},"list":{"pageSize":10}})
.constant("complaintConfig", {"restful":{"complaints":"/rest/complaints/:id"},"list":{"pageSize":10}})
.constant("issuesConfig", {"restful":{"issues":"/rest/issues/:id","issuesCheck":"/rest/issues/check/:id","issuesAX":"/rest/issues/send/:id","itemAttachment":"/rest/attachments/:item_id","attachments":"/rest/attachments/:id","downloadAttachment":"/rest/attachments/download/:attach_id"},"list":{"pageSize":10}})
.constant("roleAccessBlacklist", {"1":{"label":"Admin","rest_blacklist":{}},"2":{"label":"Ograniczone","rest_blacklist":{"carts":"*","cartItems":"add,edit,delete","offers":"toCart","quote":"*","order":"*","orders":"*","invoices":"*","payments":"*","settlements":"*","users":"index,add,edit,delete","logo":"*","resellerPrices":"*"}},"3":{"label":"Podstawowe","rest_blacklist":{"users":"index,add,edit,delete","payments":"*","settlements":"*","invoices":"*","logo":"*"}},"4":{"label":"Rozszerzone","rest_blacklist":{"users":"add,edit,delete","logo":"*"}},"default":"2"})
.constant("navigationConfig", {"extended":false})
.constant("filterConfig", {"activeFilter":{"showTags":true},"showButtonsAfterAllFilters":false})
.constant("googleConfig", {"gtmId":"GTM-TLLQ4SZ","gaId":"UA-106067776-1"});
